var hg = Object.defineProperty;
var bg = (e, t, n) => t in e ? hg(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var an = (e, t, n) => bg(e, typeof t != "symbol" ? t + "" : t, n);
import { getCurrentInstance as ns, inject as Xn, ref as B, shallowRef as vg, computed as Ce, watch as lt, onMounted as Dt, onUnmounted as Ha, defineComponent as Je, h as Jd, createVNode as d, Text as yg, Fragment as He, toRefs as on, createElementBlock as H, openBlock as L, createElementVNode as y, normalizeStyle as Et, toDisplayString as U, readonly as _g, nextTick as mn, mergeProps as je, createCommentVNode as ue, renderSlot as It, mergeModels as Rn, useModel as Nn, unref as r, withCtx as _, resolveComponent as Tn, normalizeClass as Ge, toHandlers as Ii, createBlock as be, resolveDynamicComponent as Sa, reactive as tt, createTextVNode as vt, renderList as jt, toRaw as Wn, watchEffect as Ga, isRef as Wa, onBeforeUnmount as Ln, withModifiers as ka, withDirectives as Pt, vShow as ln, Teleport as Ur, resolveDirective as Gr, toRef as wg, normalizeProps as po, guardReactiveProps as Il, Transition as Ig, createSlots as Sg, withKeys as Eg, vModelRadio as lc, vModelCheckbox as Vo } from "vue";
import { useModals as Do, MUSwitch as Tg, useAssets as sa, MContainerRow as ke, MContainerColumn as ot, MContainerGrow as Ot, MContainerSplit as Bo, getAboutInfoModel as ic, MModal as Cg, MDialogCancelButton as Ng, MDialogFooter as Lg, MTabItem as Vl, MUButton as Ne, MContainer as we, MFSwitch as no, useReactiveModel as Og, MInputNumber as sc, useNavbar as Ao, ButtonEnum as _e, MDialogConfirmButtonRedesign as la, MDialogCancelButtonRedesign as ya, getSleeveOriginalName as qd, meshFormats as ki, textureFormats as Qd, TVersionTypes as ho, MPickList as Dg, MSlider as Vi, useServerApi as ia, MColorPicker as Ag, useSTLLibraryStore as dl, STLLibraryCache as Wr, useSTLLibraryApi as zr, MListComponent as kn, MenuType as hn, useUserSettingsStore as oa, ImageListItem as Rg, imgFormats as ep, MUErrorModal as tp, fileFormats as Mg, MIcon as Hr, useAuth as as, isUserWeblinkOperator as Pg, getIconSrc as xg, useResizeObserver as Yr, useGuiConfiguration as np, AppName as tl, success as lo, error as Vn, NavbarEventBus as nl, NavbarNamedEvents as al, MLoading as os, exception as jg, devLogger as Ye, useUtilStore as ap, getOemSerialNumber as $g, setWizardBackground as op, setPatientListBackground as lp, formatFileSizeBytes as Fg, MTogglePanel as kg, AppLanguageComponent as Vg, getNamespacedUuid as Bg } from "@xlabmedical/medic-web-framework";
import Ug from "primevue/slider/style";
import Gg from "primevue/radiobutton/style";
import da from "primevue/inputtext";
import Wg from "primevue/inputnumber/style";
import zg from "primevue/divider/style";
import { crosshairTypes as Hg, LayoutTemplate as Fe, useProjectContext as dn, ToolType as _n, ToolLayer as rn, volumeOptionsDefaultTemplates as Yg, takeVolumeTemplateScreenshot as Kg, VolumeShadingMode as Sl, TJSLambdaType as qt, DynamicGUIComponent as ls, DynamicPrevNext as is, ObjectType as Oe, dynamicRoundNumber as Ri, getProjectImplantDefaults as ip, convertColor as Wo, UniversalFilePicker as Zl, uploadObjectToContext as ss, useReactivity as Zg, takeStlScreenshot as Bi, mapColorFromVtk as sp, CustomUndoData as Bl, UndoEvent as Ul, ViewMode as Cn, Maxilla0Mandible as nn, takeImplantPartScreenshot as ea, mapColorToVtk as rc, ItemStatus as pt, getProjectPinDefaults as Xg, JawboneType as Xt, MTeethView as sr, ToothEditMode as Ea, HoverIconType as Mn, ViewPreset as uc, getMandibleTeethNames as rs, getMaxillaTeethNames as us, ImportTypeLabels as Jg, PresenterWindow3D as qg, ViewSTL3DPreview as Qg, viewports as rp, getTeethLibraryList as up, xml2json as eh, StlObject as th, TReconstructionDesign as ge, TCADObjectType as St, eOType as et, TReconstructionPreSelectedMode as ma, TReconstructionPreSelectedWorkflow as nh, TReconstructionWorkflow as Ue, loadTeethLibToWasm as Kr, CADTeethView as cc, CADTeethViewLegend as ah, ImportObjectsFromPlanner as cp, ActiveRecontstruction as oh, ReconstructionType as lh, takeViewScreenshot as zo, TMode as rr, getEmptyErpFile as ih, getEmptyImplantObj as sh, getEmptyPinObj as rh, WizardType as ye, makePath as Ui, statIfFile as Gi, createImageDataFromProject as uh, VolumeInterpolationType as ch, ToothMarker as dh, calculateOwnerNormal as ph, takeVtkActorScreenshotWithCamera as mh, useOverlayComponents as Zr, Observable as ao, ObjectList as Xr, AnchorPosition as Xl, ScalarBarWidget as dp, ScalarBar as tn, parseMenuItems as Jr, DocumentContext as cs, measurementToolModel as qr, MouseMode as xn, provideProjectContext as ds, setupVtkOverrides as ps, Set3DOrientationType as El, UploadPreviewGeneratorWasm as fh, UploadPreviewGenerator as gh, unlinkAllCadPartFiles as hh, unlinkTeethLibsFromWasm as bh } from "@xlabmedical/medic-web-engine";
import $n from "primevue/select";
import vh from "primevue/orderlist";
import { AppWizard as pp } from "@xlabmedical/web-cad-platform";
import { useDialog as Aa } from "primevue/usedialog";
import yh from "primevue/progressspinner/style";
import { useConfirm as ui } from "primevue/useconfirm";
import { mat4 as Wi, vec3 as mo } from "gl-matrix";
import Un from "primevue/dialog";
import _h from "primevue/inputtext/style";
import mp from "primevue/inputnumber";
import { defineStore as wh, storeToRefs as So } from "pinia";
import { useResizeObserver as Ih } from "@vueuse/core";
import Sh from "primevue/progressspinner";
import ci from "jszip";
import { ProjectFileType as Ta, ResponseStatusEnum as Ja } from "@xlabmedical/medic-api";
import Eh from "primevue/badge";
import fp from "primevue/ripple";
import Th from "primevue/button/style";
import Ch from "primevue/focustrap";
import Nh from "primevue/portal";
import Lh from "primevue/image/style";
import Oh from "primevue/iconfield";
import Dh from "primevue/inputicon";
import Ah from "primevue/virtualscroller";
import Rh from "primevue/listbox/style";
import js from "primevue/datepicker";
import dc from "primevue/colorpicker";
import Mh from "primevue/checkbox";
import qn from "primevue/floatlabel";
import Ph from "primevue/floatlabel/style";
import xh from "primevue/textarea";
import en from "primevue/radiobutton";
import jh from "primevue/toolbar/style";
import di from "primevue/progressbar";
import $h from "primevue/steps/style";
import { useRouter as ms, useRoute as pl } from "vue-router";
import { useToast as Fh } from "primevue/usetoast";
import kh from "primevue/divider";
/*!
  * shared v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function La(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const pc = {};
function Vh(e) {
  pc[e] || (pc[e] = !0, La(e));
}
const za = typeof window < "u";
let Kn, Eo;
if (process.env.NODE_ENV !== "production") {
  const e = za && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Kn = (t) => {
    e.mark(t);
  }, Eo = (t, n, a) => {
    e.measure(t, n, a), e.clearMarks(n), e.clearMarks(a);
  });
}
const Bh = /\{([0-9a-zA-Z]+)\}/g;
function fs(e, ...t) {
  return t.length === 1 && $t(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Bh, (n, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const Ya = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), Uh = (e, t, n) => Gh({ l: e, k: t, s: n }), Gh = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), yn = (e) => typeof e == "number" && isFinite(e), Wh = (e) => Qr(e) === "[object Date]", zi = (e) => Qr(e) === "[object RegExp]", gs = (e) => xt(e) && Object.keys(e).length === 0, wn = Object.assign, zh = Object.create, Wt = (e = null) => zh(e);
let mc;
const fo = () => mc || (mc = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : Wt());
function fc(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function gc(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Hh(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (a, o, l) => `${o}="${gc(l)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (a, o, l) => `${o}='${gc(l)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && La("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((a) => {
    e = e.replace(a, "$1javascript&#58;");
  }), e;
}
const Yh = Object.prototype.hasOwnProperty;
function fa(e, t) {
  return Yh.call(e, t);
}
const un = Array.isArray, Jt = (e) => typeof e == "function", nt = (e) => typeof e == "string", sn = (e) => typeof e == "boolean", $t = (e) => e !== null && typeof e == "object", Kh = (e) => $t(e) && Jt(e.then) && Jt(e.catch), gp = Object.prototype.toString, Qr = (e) => gp.call(e), xt = (e) => Qr(e) === "[object Object]", Zh = (e) => e == null ? "" : un(e) || xt(e) && e.toString === gp ? JSON.stringify(e, null, 2) : String(e);
function eu(e, t = "") {
  return e.reduce((n, a, o) => o === 0 ? n + a : n + t + a, "");
}
const hc = 2;
function Xh(e, t = 0, n = e.length) {
  const a = e.split(/\r?\n/);
  let o = 0;
  const l = [];
  for (let s = 0; s < a.length; s++)
    if (o += a[s].length + 1, o >= t) {
      for (let i = s - hc; i <= s + hc || n > o; i++) {
        if (i < 0 || i >= a.length)
          continue;
        const u = i + 1;
        l.push(`${u}${" ".repeat(3 - String(u).length)}|  ${a[i]}`);
        const c = a[i].length;
        if (i === s) {
          const p = t - (o - c) + 1, h = Math.max(1, n > o ? c - p : n - t);
          l.push("   |  " + " ".repeat(p) + "^".repeat(h));
        } else if (i > s) {
          if (n > o) {
            const p = Math.max(Math.min(n - o, c), 1);
            l.push("   |  " + "^".repeat(p));
          }
          o += c + 1;
        }
      }
      break;
    }
  return l.join(`
`);
}
function Jh() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, a) {
      const o = e.get(n);
      o && o.push(a) || e.set(n, [a]);
    },
    off(n, a) {
      const o = e.get(n);
      o && o.splice(o.indexOf(a) >>> 0, 1);
    },
    emit(n, a) {
      (e.get(n) || []).slice().map((o) => o(a)), (e.get("*") || []).slice().map((o) => o(n, a));
    }
  };
}
const Si = (e) => !$t(e) || un(e);
function Mi(e, t) {
  if (Si(e) || Si(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: a, des: o } = n.pop();
    Object.keys(a).forEach((l) => {
      l !== "__proto__" && ($t(a[l]) && !$t(o[l]) && (o[l] = Array.isArray(a[l]) ? [] : Wt()), Si(o[l]) || Si(a[l]) ? o[l] = a[l] : n.push({ src: a[l], des: o[l] }));
    });
  }
}
/*!
  * message-compiler v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function qh(e, t, n) {
  return { line: e, column: t, offset: n };
}
function ur(e, t, n) {
  return { start: e, end: t };
}
const gt = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Qh = 17, eb = {
  // tokenizer error messages
  [gt.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [gt.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [gt.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [gt.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [gt.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [gt.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [gt.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [gt.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [gt.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [gt.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [gt.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [gt.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [gt.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [gt.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [gt.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [gt.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function ml(e, t, n = {}) {
  const { domain: a, messages: o, args: l } = n, s = process.env.NODE_ENV !== "production" ? fs((o || eb)[e] || "", ...l || []) : e, i = new SyntaxError(String(s));
  return i.code = e, t && (i.location = t), i.domain = a, i;
}
function tb(e) {
  throw e;
}
const nb = /<\/?[\w\s="/.':;#-\/]+>/, ab = (e) => nb.test(e), _a = " ", ob = "\r", Dn = `
`, lb = "\u2028", ib = "\u2029";
function sb(e) {
  const t = e;
  let n = 0, a = 1, o = 1, l = 0;
  const s = (O) => t[O] === ob && t[O + 1] === Dn, i = (O) => t[O] === Dn, u = (O) => t[O] === ib, c = (O) => t[O] === lb, p = (O) => s(O) || i(O) || u(O) || c(O), h = () => n, g = () => a, b = () => o, E = () => l, m = (O) => s(O) || u(O) || c(O) ? Dn : t[O], I = () => m(n), S = () => m(n + l);
  function f() {
    return l = 0, p(n) && (a++, o = 0), s(n) && n++, n++, o++, t[n];
  }
  function v() {
    return s(n + l) && l++, l++, t[n + l];
  }
  function w() {
    n = 0, a = 1, o = 1, l = 0;
  }
  function A(O = 0) {
    l = O;
  }
  function T() {
    const O = n + l;
    for (; O !== n; )
      f();
    l = 0;
  }
  return {
    index: h,
    line: g,
    column: b,
    peekOffset: E,
    charAt: m,
    currentChar: I,
    currentPeek: S,
    next: f,
    peek: v,
    reset: w,
    resetPeek: A,
    skipToPeek: T
  };
}
const Pa = void 0, rb = ".", bc = "'", ub = "tokenizer";
function cb(e, t = {}) {
  const n = t.location !== !1, a = sb(e), o = () => a.index(), l = () => qh(a.line(), a.column(), a.index()), s = l(), i = o(), u = {
    currentType: 13,
    offset: i,
    startLoc: s,
    endLoc: s,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: s,
    lastEndLoc: s,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => u, { onError: p } = t;
  function h(P, F, me, ...de) {
    const We = c();
    if (F.column += me, F.offset += me, p) {
      const Q = n ? ur(We.startLoc, F) : null, ie = ml(P, Q, {
        domain: ub,
        args: de
      });
      p(ie);
    }
  }
  function g(P, F, me) {
    P.endLoc = l(), P.currentType = F;
    const de = { type: F };
    return n && (de.loc = ur(P.startLoc, P.endLoc)), me != null && (de.value = me), de;
  }
  const b = (P) => g(
    P,
    13
    /* TokenTypes.EOF */
  );
  function E(P, F) {
    return P.currentChar() === F ? (P.next(), F) : (h(gt.EXPECTED_TOKEN, l(), 0, F), "");
  }
  function m(P) {
    let F = "";
    for (; P.currentPeek() === _a || P.currentPeek() === Dn; )
      F += P.currentPeek(), P.peek();
    return F;
  }
  function I(P) {
    const F = m(P);
    return P.skipToPeek(), F;
  }
  function S(P) {
    if (P === Pa)
      return !1;
    const F = P.charCodeAt(0);
    return F >= 97 && F <= 122 || // a-z
    F >= 65 && F <= 90 || // A-Z
    F === 95;
  }
  function f(P) {
    if (P === Pa)
      return !1;
    const F = P.charCodeAt(0);
    return F >= 48 && F <= 57;
  }
  function v(P, F) {
    const { currentType: me } = F;
    if (me !== 2)
      return !1;
    m(P);
    const de = S(P.currentPeek());
    return P.resetPeek(), de;
  }
  function w(P, F) {
    const { currentType: me } = F;
    if (me !== 2)
      return !1;
    m(P);
    const de = P.currentPeek() === "-" ? P.peek() : P.currentPeek(), We = f(de);
    return P.resetPeek(), We;
  }
  function A(P, F) {
    const { currentType: me } = F;
    if (me !== 2)
      return !1;
    m(P);
    const de = P.currentPeek() === bc;
    return P.resetPeek(), de;
  }
  function T(P, F) {
    const { currentType: me } = F;
    if (me !== 7)
      return !1;
    m(P);
    const de = P.currentPeek() === ".";
    return P.resetPeek(), de;
  }
  function O(P, F) {
    const { currentType: me } = F;
    if (me !== 8)
      return !1;
    m(P);
    const de = S(P.currentPeek());
    return P.resetPeek(), de;
  }
  function C(P, F) {
    const { currentType: me } = F;
    if (!(me === 7 || me === 11))
      return !1;
    m(P);
    const de = P.currentPeek() === ":";
    return P.resetPeek(), de;
  }
  function k(P, F) {
    const { currentType: me } = F;
    if (me !== 9)
      return !1;
    const de = () => {
      const Q = P.currentPeek();
      return Q === "{" ? S(P.peek()) : Q === "@" || Q === "|" || Q === ":" || Q === "." || Q === _a || !Q ? !1 : Q === Dn ? (P.peek(), de()) : z(P, !1);
    }, We = de();
    return P.resetPeek(), We;
  }
  function M(P) {
    m(P);
    const F = P.currentPeek() === "|";
    return P.resetPeek(), F;
  }
  function z(P, F = !0) {
    const me = (We = !1, Q = "") => {
      const ie = P.currentPeek();
      return ie === "{" || ie === "@" || !ie ? We : ie === "|" ? !(Q === _a || Q === Dn) : ie === _a ? (P.peek(), me(!0, _a)) : ie === Dn ? (P.peek(), me(!0, Dn)) : !0;
    }, de = me();
    return F && P.resetPeek(), de;
  }
  function j(P, F) {
    const me = P.currentChar();
    return me === Pa ? Pa : F(me) ? (P.next(), me) : null;
  }
  function K(P) {
    const F = P.charCodeAt(0);
    return F >= 97 && F <= 122 || // a-z
    F >= 65 && F <= 90 || // A-Z
    F >= 48 && F <= 57 || // 0-9
    F === 95 || // _
    F === 36;
  }
  function x(P) {
    return j(P, K);
  }
  function N(P) {
    const F = P.charCodeAt(0);
    return F >= 97 && F <= 122 || // a-z
    F >= 65 && F <= 90 || // A-Z
    F >= 48 && F <= 57 || // 0-9
    F === 95 || // _
    F === 36 || // $
    F === 45;
  }
  function G(P) {
    return j(P, N);
  }
  function ce(P) {
    const F = P.charCodeAt(0);
    return F >= 48 && F <= 57;
  }
  function re(P) {
    return j(P, ce);
  }
  function Se(P) {
    const F = P.charCodeAt(0);
    return F >= 48 && F <= 57 || // 0-9
    F >= 65 && F <= 70 || // A-F
    F >= 97 && F <= 102;
  }
  function se(P) {
    return j(P, Se);
  }
  function Le(P) {
    let F = "", me = "";
    for (; F = re(P); )
      me += F;
    return me;
  }
  function Y(P) {
    let F = "";
    for (; ; ) {
      const me = P.currentChar();
      if (me === "{" || me === "}" || me === "@" || me === "|" || !me)
        break;
      if (me === _a || me === Dn)
        if (z(P))
          F += me, P.next();
        else {
          if (M(P))
            break;
          F += me, P.next();
        }
      else
        F += me, P.next();
    }
    return F;
  }
  function pe(P) {
    I(P);
    let F = "", me = "";
    for (; F = G(P); )
      me += F;
    const de = P.currentChar();
    if (de && de !== "}" && de !== Pa && de !== _a && de !== Dn && de !== "　") {
      const We = te(P);
      return h(gt.INVALID_TOKEN_IN_PLACEHOLDER, l(), 0, me + We), me + We;
    }
    return P.currentChar() === Pa && h(gt.UNTERMINATED_CLOSING_BRACE, l(), 0), me;
  }
  function fe(P) {
    I(P);
    let F = "";
    return P.currentChar() === "-" ? (P.next(), F += `-${Le(P)}`) : F += Le(P), P.currentChar() === Pa && h(gt.UNTERMINATED_CLOSING_BRACE, l(), 0), F;
  }
  function le(P) {
    return P !== bc && P !== Dn;
  }
  function Re(P) {
    I(P), E(P, "'");
    let F = "", me = "";
    for (; F = j(P, le); )
      F === "\\" ? me += q(P) : me += F;
    const de = P.currentChar();
    return de === Dn || de === Pa ? (h(gt.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, l(), 0), de === Dn && (P.next(), E(P, "'")), me) : (E(P, "'"), me);
  }
  function q(P) {
    const F = P.currentChar();
    switch (F) {
      case "\\":
      case "'":
        return P.next(), `\\${F}`;
      case "u":
        return he(P, F, 4);
      case "U":
        return he(P, F, 6);
      default:
        return h(gt.UNKNOWN_ESCAPE_SEQUENCE, l(), 0, F), "";
    }
  }
  function he(P, F, me) {
    E(P, F);
    let de = "";
    for (let We = 0; We < me; We++) {
      const Q = se(P);
      if (!Q) {
        h(gt.INVALID_UNICODE_ESCAPE_SEQUENCE, l(), 0, `\\${F}${de}${P.currentChar()}`);
        break;
      }
      de += Q;
    }
    return `\\${F}${de}`;
  }
  function ne(P) {
    return P !== "{" && P !== "}" && P !== _a && P !== Dn;
  }
  function te(P) {
    I(P);
    let F = "", me = "";
    for (; F = j(P, ne); )
      me += F;
    return me;
  }
  function Ie(P) {
    let F = "", me = "";
    for (; F = x(P); )
      me += F;
    return me;
  }
  function Ee(P) {
    const F = (me) => {
      const de = P.currentChar();
      return de === "{" || de === "@" || de === "|" || de === "(" || de === ")" || !de || de === _a ? me : (me += de, P.next(), F(me));
    };
    return F("");
  }
  function xe(P) {
    I(P);
    const F = E(
      P,
      "|"
      /* TokenChars.Pipe */
    );
    return I(P), F;
  }
  function Qe(P, F) {
    let me = null;
    switch (P.currentChar()) {
      case "{":
        return F.braceNest >= 1 && h(gt.NOT_ALLOW_NEST_PLACEHOLDER, l(), 0), P.next(), me = g(
          F,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), I(P), F.braceNest++, me;
      case "}":
        return F.braceNest > 0 && F.currentType === 2 && h(gt.EMPTY_PLACEHOLDER, l(), 0), P.next(), me = g(
          F,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), F.braceNest--, F.braceNest > 0 && I(P), F.inLinked && F.braceNest === 0 && (F.inLinked = !1), me;
      case "@":
        return F.braceNest > 0 && h(gt.UNTERMINATED_CLOSING_BRACE, l(), 0), me = Ke(P, F) || b(F), F.braceNest = 0, me;
      default: {
        let We = !0, Q = !0, ie = !0;
        if (M(P))
          return F.braceNest > 0 && h(gt.UNTERMINATED_CLOSING_BRACE, l(), 0), me = g(F, 1, xe(P)), F.braceNest = 0, F.inLinked = !1, me;
        if (F.braceNest > 0 && (F.currentType === 4 || F.currentType === 5 || F.currentType === 6))
          return h(gt.UNTERMINATED_CLOSING_BRACE, l(), 0), F.braceNest = 0, qe(P, F);
        if (We = v(P, F))
          return me = g(F, 4, pe(P)), I(P), me;
        if (Q = w(P, F))
          return me = g(F, 5, fe(P)), I(P), me;
        if (ie = A(P, F))
          return me = g(F, 6, Re(P)), I(P), me;
        if (!We && !Q && !ie)
          return me = g(F, 12, te(P)), h(gt.INVALID_TOKEN_IN_PLACEHOLDER, l(), 0, me.value), I(P), me;
        break;
      }
    }
    return me;
  }
  function Ke(P, F) {
    const { currentType: me } = F;
    let de = null;
    const We = P.currentChar();
    switch ((me === 7 || me === 8 || me === 11 || me === 9) && (We === Dn || We === _a) && h(gt.INVALID_LINKED_FORMAT, l(), 0), We) {
      case "@":
        return P.next(), de = g(
          F,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), F.inLinked = !0, de;
      case ".":
        return I(P), P.next(), g(
          F,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return I(P), P.next(), g(
          F,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return M(P) ? (de = g(F, 1, xe(P)), F.braceNest = 0, F.inLinked = !1, de) : T(P, F) || C(P, F) ? (I(P), Ke(P, F)) : O(P, F) ? (I(P), g(F, 11, Ie(P))) : k(P, F) ? (I(P), We === "{" ? Qe(P, F) || de : g(F, 10, Ee(P))) : (me === 7 && h(gt.INVALID_LINKED_FORMAT, l(), 0), F.braceNest = 0, F.inLinked = !1, qe(P, F));
    }
  }
  function qe(P, F) {
    let me = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (F.braceNest > 0)
      return Qe(P, F) || b(F);
    if (F.inLinked)
      return Ke(P, F) || b(F);
    switch (P.currentChar()) {
      case "{":
        return Qe(P, F) || b(F);
      case "}":
        return h(gt.UNBALANCED_CLOSING_BRACE, l(), 0), P.next(), g(
          F,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Ke(P, F) || b(F);
      default: {
        if (M(P))
          return me = g(F, 1, xe(P)), F.braceNest = 0, F.inLinked = !1, me;
        if (z(P))
          return g(F, 0, Y(P));
        break;
      }
    }
    return me;
  }
  function rt() {
    const { currentType: P, offset: F, startLoc: me, endLoc: de } = u;
    return u.lastType = P, u.lastOffset = F, u.lastStartLoc = me, u.lastEndLoc = de, u.offset = o(), u.startLoc = l(), a.currentChar() === Pa ? g(
      u,
      13
      /* TokenTypes.EOF */
    ) : qe(a, u);
  }
  return {
    nextToken: rt,
    currentOffset: o,
    currentPosition: l,
    context: c
  };
}
const db = "parser", pb = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function mb(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const a = parseInt(t || n, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function fb(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function a(S, f, v, w, ...A) {
    const T = S.currentPosition();
    if (T.offset += w, T.column += w, n) {
      const O = t ? ur(v, T) : null, C = ml(f, O, {
        domain: db,
        args: A
      });
      n(C);
    }
  }
  function o(S, f, v) {
    const w = { type: S };
    return t && (w.start = f, w.end = f, w.loc = { start: v, end: v }), w;
  }
  function l(S, f, v, w) {
    t && (S.end = f, S.loc && (S.loc.end = v));
  }
  function s(S, f) {
    const v = S.context(), w = o(3, v.offset, v.startLoc);
    return w.value = f, l(w, S.currentOffset(), S.currentPosition()), w;
  }
  function i(S, f) {
    const v = S.context(), { lastOffset: w, lastStartLoc: A } = v, T = o(5, w, A);
    return T.index = parseInt(f, 10), S.nextToken(), l(T, S.currentOffset(), S.currentPosition()), T;
  }
  function u(S, f) {
    const v = S.context(), { lastOffset: w, lastStartLoc: A } = v, T = o(4, w, A);
    return T.key = f, S.nextToken(), l(T, S.currentOffset(), S.currentPosition()), T;
  }
  function c(S, f) {
    const v = S.context(), { lastOffset: w, lastStartLoc: A } = v, T = o(9, w, A);
    return T.value = f.replace(pb, mb), S.nextToken(), l(T, S.currentOffset(), S.currentPosition()), T;
  }
  function p(S) {
    const f = S.nextToken(), v = S.context(), { lastOffset: w, lastStartLoc: A } = v, T = o(8, w, A);
    return f.type !== 11 ? (a(S, gt.UNEXPECTED_EMPTY_LINKED_MODIFIER, v.lastStartLoc, 0), T.value = "", l(T, w, A), {
      nextConsumeToken: f,
      node: T
    }) : (f.value == null && a(S, gt.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, wa(f)), T.value = f.value || "", l(T, S.currentOffset(), S.currentPosition()), {
      node: T
    });
  }
  function h(S, f) {
    const v = S.context(), w = o(7, v.offset, v.startLoc);
    return w.value = f, l(w, S.currentOffset(), S.currentPosition()), w;
  }
  function g(S) {
    const f = S.context(), v = o(6, f.offset, f.startLoc);
    let w = S.nextToken();
    if (w.type === 8) {
      const A = p(S);
      v.modifier = A.node, w = A.nextConsumeToken || S.nextToken();
    }
    switch (w.type !== 9 && a(S, gt.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, wa(w)), w = S.nextToken(), w.type === 2 && (w = S.nextToken()), w.type) {
      case 10:
        w.value == null && a(S, gt.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, wa(w)), v.key = h(S, w.value || "");
        break;
      case 4:
        w.value == null && a(S, gt.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, wa(w)), v.key = u(S, w.value || "");
        break;
      case 5:
        w.value == null && a(S, gt.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, wa(w)), v.key = i(S, w.value || "");
        break;
      case 6:
        w.value == null && a(S, gt.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, wa(w)), v.key = c(S, w.value || "");
        break;
      default: {
        a(S, gt.UNEXPECTED_EMPTY_LINKED_KEY, f.lastStartLoc, 0);
        const A = S.context(), T = o(7, A.offset, A.startLoc);
        return T.value = "", l(T, A.offset, A.startLoc), v.key = T, l(v, A.offset, A.startLoc), {
          nextConsumeToken: w,
          node: v
        };
      }
    }
    return l(v, S.currentOffset(), S.currentPosition()), {
      node: v
    };
  }
  function b(S) {
    const f = S.context(), v = f.currentType === 1 ? S.currentOffset() : f.offset, w = f.currentType === 1 ? f.endLoc : f.startLoc, A = o(2, v, w);
    A.items = [];
    let T = null;
    do {
      const k = T || S.nextToken();
      switch (T = null, k.type) {
        case 0:
          k.value == null && a(S, gt.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, wa(k)), A.items.push(s(S, k.value || ""));
          break;
        case 5:
          k.value == null && a(S, gt.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, wa(k)), A.items.push(i(S, k.value || ""));
          break;
        case 4:
          k.value == null && a(S, gt.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, wa(k)), A.items.push(u(S, k.value || ""));
          break;
        case 6:
          k.value == null && a(S, gt.UNEXPECTED_LEXICAL_ANALYSIS, f.lastStartLoc, 0, wa(k)), A.items.push(c(S, k.value || ""));
          break;
        case 7: {
          const M = g(S);
          A.items.push(M.node), T = M.nextConsumeToken || null;
          break;
        }
      }
    } while (f.currentType !== 13 && f.currentType !== 1);
    const O = f.currentType === 1 ? f.lastOffset : S.currentOffset(), C = f.currentType === 1 ? f.lastEndLoc : S.currentPosition();
    return l(A, O, C), A;
  }
  function E(S, f, v, w) {
    const A = S.context();
    let T = w.items.length === 0;
    const O = o(1, f, v);
    O.cases = [], O.cases.push(w);
    do {
      const C = b(S);
      T || (T = C.items.length === 0), O.cases.push(C);
    } while (A.currentType !== 13);
    return T && a(S, gt.MUST_HAVE_MESSAGES_IN_PLURAL, v, 0), l(O, S.currentOffset(), S.currentPosition()), O;
  }
  function m(S) {
    const f = S.context(), { offset: v, startLoc: w } = f, A = b(S);
    return f.currentType === 13 ? A : E(S, v, w, A);
  }
  function I(S) {
    const f = cb(S, wn({}, e)), v = f.context(), w = o(0, v.offset, v.startLoc);
    return t && w.loc && (w.loc.source = S), w.body = m(f), e.onCacheKey && (w.cacheKey = e.onCacheKey(S)), v.currentType !== 13 && a(f, gt.UNEXPECTED_LEXICAL_ANALYSIS, v.lastStartLoc, 0, S[v.offset] || ""), l(w, f.currentOffset(), f.currentPosition()), w;
  }
  return { parse: I };
}
function wa(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function gb(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (l) => (n.helpers.add(l), l) };
}
function vc(e, t) {
  for (let n = 0; n < e.length; n++)
    tu(e[n], t);
}
function tu(e, t) {
  switch (e.type) {
    case 1:
      vc(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      vc(e.items, t);
      break;
    case 6: {
      tu(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function hb(e, t = {}) {
  const n = gb(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && tu(e.body, n);
  const a = n.context();
  e.helpers = Array.from(a.helpers);
}
function bb(e) {
  const t = e.body;
  return t.type === 2 ? yc(t) : t.cases.forEach((n) => yc(n)), e;
}
function yc(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const a = e.items[n];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      t.push(a.value);
    }
    if (t.length === e.items.length) {
      e.static = eu(t);
      for (let n = 0; n < e.items.length; n++) {
        const a = e.items[n];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const vb = "minifier";
function Ho(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Ho(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let a = 0; a < n.length; a++)
        Ho(n[a]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let a = 0; a < n.length; a++)
        Ho(n[a]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Ho(t.key), t.k = t.key, delete t.key, t.modifier && (Ho(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw ml(gt.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: vb,
          args: [e.type]
        });
  }
  delete e.type;
}
const yb = "parser";
function _b(e, t) {
  const { filename: n, breakLineCode: a, needIndent: o } = t, l = t.location !== !1, s = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: a,
    needIndent: o,
    indentLevel: 0
  };
  l && e.loc && (s.source = e.loc.source);
  const i = () => s;
  function u(m, I) {
    s.code += m;
  }
  function c(m, I = !0) {
    const S = I ? a : "";
    u(o ? S + "  ".repeat(m) : S);
  }
  function p(m = !0) {
    const I = ++s.indentLevel;
    m && c(I);
  }
  function h(m = !0) {
    const I = --s.indentLevel;
    m && c(I);
  }
  function g() {
    c(s.indentLevel);
  }
  return {
    context: i,
    push: u,
    indent: p,
    deindent: h,
    newline: g,
    helper: (m) => `_${m}`,
    needIndent: () => s.needIndent
  };
}
function wb(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), ol(e, t.key), t.modifier ? (e.push(", "), ol(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Ib(e, t) {
  const { helper: n, needIndent: a } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(a());
  const o = t.items.length;
  for (let l = 0; l < o && (ol(e, t.items[l]), l !== o - 1); l++)
    e.push(", ");
  e.deindent(a()), e.push("])");
}
function Sb(e, t) {
  const { helper: n, needIndent: a } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(a());
    const o = t.cases.length;
    for (let l = 0; l < o && (ol(e, t.cases[l]), l !== o - 1); l++)
      e.push(", ");
    e.deindent(a()), e.push("])");
  }
}
function Eb(e, t) {
  t.body ? ol(e, t.body) : e.push("null");
}
function ol(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Eb(e, t);
      break;
    case 1:
      Sb(e, t);
      break;
    case 2:
      Ib(e, t);
      break;
    case 6:
      wb(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw ml(gt.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: yb,
          args: [t.type]
        });
  }
}
const Tb = (e, t = {}) => {
  const n = nt(t.mode) ? t.mode : "normal", a = nt(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const o = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, l = t.needIndent ? t.needIndent : n !== "arrow", s = e.helpers || [], i = _b(e, {
    filename: a,
    breakLineCode: o,
    needIndent: l
  });
  i.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(l), s.length > 0 && (i.push(`const { ${eu(s.map((p) => `${p}: _${p}`), ", ")} } = ctx`), i.newline()), i.push("return "), ol(i, e), i.deindent(l), i.push("}"), delete e.helpers;
  const { code: u, map: c } = i.context();
  return {
    ast: e,
    code: u,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Cb(e, t = {}) {
  const n = wn({}, t), a = !!n.jit, o = !!n.minify, l = n.optimize == null ? !0 : n.optimize, i = fb(n).parse(e);
  return a ? (l && bb(i), o && Ho(i), { ast: i, code: "" }) : (hb(i, n), Tb(i, n));
}
/*!
  * core-base v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Nb() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (fo().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (fo().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function ha(e) {
  return $t(e) && nu(e) === 0 && (fa(e, "b") || fa(e, "body"));
}
const hp = ["b", "body"];
function Lb(e) {
  return so(e, hp);
}
const bp = ["c", "cases"];
function Ob(e) {
  return so(e, bp, []);
}
const vp = ["s", "static"];
function Db(e) {
  return so(e, vp);
}
const yp = ["i", "items"];
function Ab(e) {
  return so(e, yp, []);
}
const _p = ["t", "type"];
function nu(e) {
  return so(e, _p);
}
const wp = ["v", "value"];
function Ei(e, t) {
  const n = so(e, wp);
  if (n != null)
    return n;
  throw Jl(t);
}
const Ip = ["m", "modifier"];
function Rb(e) {
  return so(e, Ip);
}
const Sp = ["k", "key"];
function Mb(e) {
  const t = so(e, Sp);
  if (t)
    return t;
  throw Jl(
    6
    /* NodeTypes.Linked */
  );
}
function so(e, t, n) {
  for (let a = 0; a < t.length; a++) {
    const o = t[a];
    if (fa(e, o) && e[o] != null)
      return e[o];
  }
  return n;
}
const Ep = [
  ...hp,
  ...bp,
  ...vp,
  ...yp,
  ...Sp,
  ...Ip,
  ...wp,
  ..._p
];
function Jl(e) {
  return new Error(`unhandled node type: ${e}`);
}
function $s(e) {
  return (n) => Pb(n, e);
}
function Pb(e, t) {
  const n = Lb(t);
  if (n == null)
    throw Jl(
      0
      /* NodeTypes.Resource */
    );
  if (nu(n) === 1) {
    const l = Ob(n);
    return e.plural(l.reduce((s, i) => [
      ...s,
      _c(e, i)
    ], []));
  } else
    return _c(e, n);
}
function _c(e, t) {
  const n = Db(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const a = Ab(t).reduce((o, l) => [...o, cr(e, l)], []);
    return e.normalize(a);
  }
}
function cr(e, t) {
  const n = nu(t);
  switch (n) {
    case 3:
      return Ei(t, n);
    case 9:
      return Ei(t, n);
    case 4: {
      const a = t;
      if (fa(a, "k") && a.k)
        return e.interpolate(e.named(a.k));
      if (fa(a, "key") && a.key)
        return e.interpolate(e.named(a.key));
      throw Jl(n);
    }
    case 5: {
      const a = t;
      if (fa(a, "i") && yn(a.i))
        return e.interpolate(e.list(a.i));
      if (fa(a, "index") && yn(a.index))
        return e.interpolate(e.list(a.index));
      throw Jl(n);
    }
    case 6: {
      const a = t, o = Rb(a), l = Mb(a);
      return e.linked(cr(e, l), o ? cr(e, o) : void 0, e.type);
    }
    case 7:
      return Ei(t, n);
    case 8:
      return Ei(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const xb = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function jb(e, t) {
  t && ab(e) && La(fs(xb, { source: e }));
}
const $b = (e) => e;
let Ti = Wt();
function Fb(e, t = {}) {
  let n = !1;
  const a = t.onError || tb;
  return t.onError = (o) => {
    n = !0, a(o);
  }, { ...Cb(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function kb(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && nt(e)) {
    const n = sn(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && jb(e, n);
    const o = (t.onCacheKey || $b)(e), l = Ti[o];
    if (l)
      return l;
    const { ast: s, detectError: i } = Fb(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), u = $s(s);
    return i ? u : Ti[o] = u;
  } else {
    if (process.env.NODE_ENV !== "production" && !ha(e))
      return La(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), (() => e);
    const n = e.cacheKey;
    if (n) {
      const a = Ti[n];
      return a || (Ti[n] = $s(e));
    } else
      return $s(e);
  }
}
let ql = null;
function Vb(e) {
  ql = e;
}
function Bb(e, t, n) {
  ql && ql.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Ub = /* @__PURE__ */ Gb("function:translate");
function Gb(e) {
  return (t) => ql && ql.emit(e, t);
}
const An = {
  INVALID_ARGUMENT: Qh,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, Wb = 24;
function Va(e) {
  return ml(e, null, process.env.NODE_ENV !== "production" ? { messages: zb } : void 0);
}
const zb = {
  [An.INVALID_ARGUMENT]: "Invalid arguments",
  [An.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [An.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [An.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [An.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [An.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [An.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function au(e, t) {
  return t.locale != null ? wc(t.locale) : wc(e.locale);
}
let Fs;
function wc(e) {
  if (nt(e))
    return e;
  if (Jt(e)) {
    if (e.resolvedOnce && Fs != null)
      return Fs;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Kh(t))
        throw Va(An.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Fs = t;
    } else
      throw Va(An.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Va(An.NOT_SUPPORT_LOCALE_TYPE);
}
function Hb(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...un(t) ? t : $t(t) ? Object.keys(t) : nt(t) ? [t] : [n]
  ])];
}
function Tp(e, t, n) {
  const a = nt(n) ? n : Hi, o = e;
  o.__localeChainCache || (o.__localeChainCache = /* @__PURE__ */ new Map());
  let l = o.__localeChainCache.get(a);
  if (!l) {
    l = [];
    let s = [n];
    for (; un(s); )
      s = Ic(l, s, t);
    const i = un(t) || !xt(t) ? t : t.default ? t.default : null;
    s = nt(i) ? [i] : i, un(s) && Ic(l, s, !1), o.__localeChainCache.set(a, l);
  }
  return l;
}
function Ic(e, t, n) {
  let a = !0;
  for (let o = 0; o < t.length && sn(a); o++) {
    const l = t[o];
    nt(l) && (a = Yb(e, t[o], n));
  }
  return a;
}
function Yb(e, t, n) {
  let a;
  const o = t.split("-");
  do {
    const l = o.join("-");
    a = Kb(e, l, n), o.splice(-1, 1);
  } while (o.length && a === !0);
  return a;
}
function Kb(e, t, n) {
  let a = !1;
  if (!e.includes(t) && (a = !0, t)) {
    a = t[t.length - 1] !== "!";
    const o = t.replace(/!/g, "");
    e.push(o), (un(n) || xt(n)) && n[o] && (a = n[o]);
  }
  return a;
}
const ro = [];
ro[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ro[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ro[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
ro[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
ro[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
ro[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
ro[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Zb = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Xb(e) {
  return Zb.test(e);
}
function Jb(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function qb(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return e;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function Qb(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Xb(t) ? Jb(t) : "*" + t;
}
function ev(e) {
  const t = [];
  let n = -1, a = 0, o = 0, l, s, i, u, c, p, h;
  const g = [];
  g[
    0
    /* Actions.APPEND */
  ] = () => {
    s === void 0 ? s = i : s += i;
  }, g[
    1
    /* Actions.PUSH */
  ] = () => {
    s !== void 0 && (t.push(s), s = void 0);
  }, g[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    g[
      0
      /* Actions.APPEND */
    ](), o++;
  }, g[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (o > 0)
      o--, a = 4, g[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (o = 0, s === void 0 || (s = Qb(s), s === !1))
        return !1;
      g[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function b() {
    const E = e[n + 1];
    if (a === 5 && E === "'" || a === 6 && E === '"')
      return n++, i = "\\" + E, g[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; a !== null; )
    if (n++, l = e[n], !(l === "\\" && b())) {
      if (u = qb(l), h = ro[a], c = h[u] || h.l || 8, c === 8 || (a = c[0], c[1] !== void 0 && (p = g[c[1]], p && (i = l, p() === !1))))
        return;
      if (a === 7)
        return t;
    }
}
const Sc = /* @__PURE__ */ new Map();
function tv(e, t) {
  return $t(e) ? e[t] : null;
}
function nv(e, t) {
  if (!$t(e))
    return null;
  let n = Sc.get(t);
  if (n || (n = ev(t), n && Sc.set(t, n)), !n)
    return null;
  const a = n.length;
  let o = e, l = 0;
  for (; l < a; ) {
    const s = n[l];
    if (Ep.includes(s) && ha(o))
      return null;
    const i = o[s];
    if (i === void 0 || Jt(o))
      return null;
    o = i, l++;
  }
  return o;
}
const Bn = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, av = 8, ov = {
  [Bn.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Bn.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Bn.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Bn.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Bn.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Bn.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Bn.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function To(e, ...t) {
  return fs(ov[e], ...t);
}
const lv = "11.1.12", hs = -1, Hi = "en-US", Yi = "", Ec = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function iv() {
  return {
    upper: (e, t) => t === "text" && nt(e) ? e.toUpperCase() : t === "vnode" && $t(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && nt(e) ? e.toLowerCase() : t === "vnode" && $t(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && nt(e) ? Ec(e) : t === "vnode" && $t(e) && "__v_isVNode" in e ? Ec(e.children) : e
  };
}
let Cp;
function sv(e) {
  Cp = e;
}
let Np;
function rv(e) {
  Np = e;
}
let Lp;
function uv(e) {
  Lp = e;
}
let Op = null;
const cv = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Op = e;
}, dv = /* @__NO_SIDE_EFFECTS__ */ () => Op;
let Dp = null;
const Tc = (e) => {
  Dp = e;
}, pv = () => Dp;
let Cc = 0;
function mv(e = {}) {
  const t = Jt(e.onWarn) ? e.onWarn : La, n = nt(e.version) ? e.version : lv, a = nt(e.locale) || Jt(e.locale) ? e.locale : Hi, o = Jt(a) ? Hi : a, l = un(e.fallbackLocale) || xt(e.fallbackLocale) || nt(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : o, s = xt(e.messages) ? e.messages : ks(o), i = xt(e.datetimeFormats) ? e.datetimeFormats : ks(o), u = xt(e.numberFormats) ? e.numberFormats : ks(o), c = wn(Wt(), e.modifiers, iv()), p = e.pluralRules || Wt(), h = Jt(e.missing) ? e.missing : null, g = sn(e.missingWarn) || zi(e.missingWarn) ? e.missingWarn : !0, b = sn(e.fallbackWarn) || zi(e.fallbackWarn) ? e.fallbackWarn : !0, E = !!e.fallbackFormat, m = !!e.unresolving, I = Jt(e.postTranslation) ? e.postTranslation : null, S = xt(e.processor) ? e.processor : null, f = sn(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, v = !!e.escapeParameter, w = Jt(e.messageCompiler) ? e.messageCompiler : Cp;
  process.env.NODE_ENV !== "production" && Jt(e.messageCompiler) && Vh(To(Bn.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const A = Jt(e.messageResolver) ? e.messageResolver : Np || tv, T = Jt(e.localeFallbacker) ? e.localeFallbacker : Lp || Hb, O = $t(e.fallbackContext) ? e.fallbackContext : void 0, C = e, k = $t(C.__datetimeFormatters) ? C.__datetimeFormatters : /* @__PURE__ */ new Map(), M = $t(C.__numberFormatters) ? C.__numberFormatters : /* @__PURE__ */ new Map(), z = $t(C.__meta) ? C.__meta : {};
  Cc++;
  const j = {
    version: n,
    cid: Cc,
    locale: a,
    fallbackLocale: l,
    messages: s,
    modifiers: c,
    pluralRules: p,
    missing: h,
    missingWarn: g,
    fallbackWarn: b,
    fallbackFormat: E,
    unresolving: m,
    postTranslation: I,
    processor: S,
    warnHtmlMessage: f,
    escapeParameter: v,
    messageCompiler: w,
    messageResolver: A,
    localeFallbacker: T,
    fallbackContext: O,
    onWarn: t,
    __meta: z
  };
  return j.datetimeFormats = i, j.numberFormats = u, j.__datetimeFormatters = k, j.__numberFormatters = M, process.env.NODE_ENV !== "production" && (j.__v_emitter = C.__v_emitter != null ? C.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Bb(j, n, z), j;
}
const ks = (e) => ({ [e]: Wt() });
function bs(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Ap(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function ou(e, t, n, a, o) {
  const { missing: l, onWarn: s } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: o,
      groupId: `${o}:${t}`
    });
  }
  if (l !== null) {
    const i = l(e, n, t, o);
    return nt(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && Ap(a, t) && s(To(Bn.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Tl(e, t, n) {
  const a = e;
  a.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Rp(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function fv(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let a = n + 1; a < t.length; a++)
    if (Rp(e, t[a]))
      return !0;
  return !1;
}
const Nc = typeof Intl < "u", Mp = {
  dateTimeFormat: Nc && typeof Intl.DateTimeFormat < "u",
  numberFormat: Nc && typeof Intl.NumberFormat < "u"
};
function Lc(e, ...t) {
  const { datetimeFormats: n, unresolving: a, fallbackLocale: o, onWarn: l, localeFallbacker: s } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !Mp.dateTimeFormat)
    return l(To(Bn.CANNOT_FORMAT_DATE)), Yi;
  const [u, c, p, h] = dr(...t), g = sn(p.missingWarn) ? p.missingWarn : e.missingWarn, b = sn(p.fallbackWarn) ? p.fallbackWarn : e.fallbackWarn, E = !!p.part, m = au(e, p), I = s(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    m
  );
  if (!nt(u) || u === "")
    return new Intl.DateTimeFormat(m, h).format(c);
  let S = {}, f, v = null, w = m, A = null;
  const T = "datetime format";
  for (let k = 0; k < I.length; k++) {
    if (f = A = I[k], process.env.NODE_ENV !== "production" && m !== f && bs(b, u) && l(To(Bn.FALLBACK_TO_DATE_FORMAT, {
      key: u,
      target: f
    })), process.env.NODE_ENV !== "production" && m !== f) {
      const M = e.__v_emitter;
      M && M.emit("fallback", {
        type: T,
        key: u,
        from: w,
        to: A,
        groupId: `${T}:${u}`
      });
    }
    if (S = n[f] || {}, v = S[u], xt(v))
      break;
    ou(e, u, f, g, T), w = A;
  }
  if (!xt(v) || !nt(f))
    return a ? hs : u;
  let O = `${f}__${u}`;
  gs(h) || (O = `${O}__${JSON.stringify(h)}`);
  let C = i.get(O);
  return C || (C = new Intl.DateTimeFormat(f, wn({}, v, h)), i.set(O, C)), E ? C.formatToParts(c) : C.format(c);
}
const Pp = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function dr(...e) {
  const [t, n, a, o] = e, l = Wt();
  let s = Wt(), i;
  if (nt(t)) {
    const u = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!u)
      throw Va(An.INVALID_ISO_DATE_ARGUMENT);
    const c = u[3] ? u[3].trim().startsWith("T") ? `${u[1].trim()}${u[3].trim()}` : `${u[1].trim()}T${u[3].trim()}` : u[1].trim();
    i = new Date(c);
    try {
      i.toISOString();
    } catch {
      throw Va(An.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (Wh(t)) {
    if (isNaN(t.getTime()))
      throw Va(An.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (yn(t))
    i = t;
  else
    throw Va(An.INVALID_ARGUMENT);
  return nt(n) ? l.key = n : xt(n) && Object.keys(n).forEach((u) => {
    Pp.includes(u) ? s[u] = n[u] : l[u] = n[u];
  }), nt(a) ? l.locale = a : xt(a) && (s = a), xt(o) && (s = o), [l.key || "", i, l, s];
}
function Oc(e, t, n) {
  const a = e;
  for (const o in n) {
    const l = `${t}__${o}`;
    a.__datetimeFormatters.has(l) && a.__datetimeFormatters.delete(l);
  }
}
function Dc(e, ...t) {
  const { numberFormats: n, unresolving: a, fallbackLocale: o, onWarn: l, localeFallbacker: s } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !Mp.numberFormat)
    return l(To(Bn.CANNOT_FORMAT_NUMBER)), Yi;
  const [u, c, p, h] = pr(...t), g = sn(p.missingWarn) ? p.missingWarn : e.missingWarn, b = sn(p.fallbackWarn) ? p.fallbackWarn : e.fallbackWarn, E = !!p.part, m = au(e, p), I = s(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    m
  );
  if (!nt(u) || u === "")
    return new Intl.NumberFormat(m, h).format(c);
  let S = {}, f, v = null, w = m, A = null;
  const T = "number format";
  for (let k = 0; k < I.length; k++) {
    if (f = A = I[k], process.env.NODE_ENV !== "production" && m !== f && bs(b, u) && l(To(Bn.FALLBACK_TO_NUMBER_FORMAT, {
      key: u,
      target: f
    })), process.env.NODE_ENV !== "production" && m !== f) {
      const M = e.__v_emitter;
      M && M.emit("fallback", {
        type: T,
        key: u,
        from: w,
        to: A,
        groupId: `${T}:${u}`
      });
    }
    if (S = n[f] || {}, v = S[u], xt(v))
      break;
    ou(e, u, f, g, T), w = A;
  }
  if (!xt(v) || !nt(f))
    return a ? hs : u;
  let O = `${f}__${u}`;
  gs(h) || (O = `${O}__${JSON.stringify(h)}`);
  let C = i.get(O);
  return C || (C = new Intl.NumberFormat(f, wn({}, v, h)), i.set(O, C)), E ? C.formatToParts(c) : C.format(c);
}
const xp = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function pr(...e) {
  const [t, n, a, o] = e, l = Wt();
  let s = Wt();
  if (!yn(t))
    throw Va(An.INVALID_ARGUMENT);
  const i = t;
  return nt(n) ? l.key = n : xt(n) && Object.keys(n).forEach((u) => {
    xp.includes(u) ? s[u] = n[u] : l[u] = n[u];
  }), nt(a) ? l.locale = a : xt(a) && (s = a), xt(o) && (s = o), [l.key || "", i, l, s];
}
function Ac(e, t, n) {
  const a = e;
  for (const o in n) {
    const l = `${t}__${o}`;
    a.__numberFormatters.has(l) && a.__numberFormatters.delete(l);
  }
}
const gv = (e) => e, hv = (e) => "", bv = "text", vv = (e) => e.length === 0 ? "" : eu(e), yv = Zh;
function Rc(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function _v(e) {
  const t = yn(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (yn(e.named.count) || yn(e.named.n)) ? yn(e.named.count) ? e.named.count : yn(e.named.n) ? e.named.n : t : t;
}
function wv(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Iv(e = {}) {
  const t = e.locale, n = _v(e), a = $t(e.pluralRules) && nt(t) && Jt(e.pluralRules[t]) ? e.pluralRules[t] : Rc, o = $t(e.pluralRules) && nt(t) && Jt(e.pluralRules[t]) ? Rc : void 0, l = (S) => S[a(n, S.length, o)], s = e.list || [], i = (S) => s[S], u = e.named || Wt();
  yn(e.pluralIndex) && wv(n, u);
  const c = (S) => u[S];
  function p(S, f) {
    const v = Jt(e.messages) ? e.messages(S, !!f) : $t(e.messages) ? e.messages[S] : !1;
    return v || (e.parent ? e.parent.message(S) : hv);
  }
  const h = (S) => e.modifiers ? e.modifiers[S] : gv, g = xt(e.processor) && Jt(e.processor.normalize) ? e.processor.normalize : vv, b = xt(e.processor) && Jt(e.processor.interpolate) ? e.processor.interpolate : yv, E = xt(e.processor) && nt(e.processor.type) ? e.processor.type : bv, I = {
    list: i,
    named: c,
    plural: l,
    linked: (S, ...f) => {
      const [v, w] = f;
      let A = "text", T = "";
      f.length === 1 ? $t(v) ? (T = v.modifier || T, A = v.type || A) : nt(v) && (T = v || T) : f.length === 2 && (nt(v) && (T = v || T), nt(w) && (A = w || A));
      const O = p(S, !0)(I), C = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        A === "vnode" && un(O) && T ? O[0] : O
      );
      return T ? h(T)(C, A) : C;
    },
    message: p,
    type: E,
    interpolate: b,
    normalize: g,
    values: wn(Wt(), s, u)
  };
  return I;
}
const Mc = () => "", ta = (e) => Jt(e);
function Pc(e, ...t) {
  const { fallbackFormat: n, postTranslation: a, unresolving: o, messageCompiler: l, fallbackLocale: s, messages: i } = e, [u, c] = mr(...t), p = sn(c.missingWarn) ? c.missingWarn : e.missingWarn, h = sn(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, g = sn(c.escapeParameter) ? c.escapeParameter : e.escapeParameter, b = !!c.resolvedMessage, E = nt(c.default) || sn(c.default) ? sn(c.default) ? l ? u : () => u : c.default : n ? l ? u : () => u : null, m = n || E != null && (nt(E) || Jt(E)), I = au(e, c);
  g && Sv(c);
  let [S, f, v] = b ? [
    u,
    I,
    i[I] || Wt()
  ] : jp(e, u, I, s, h, p), w = S, A = u;
  if (!b && !(nt(w) || ha(w) || ta(w)) && m && (w = E, A = w), !b && (!(nt(w) || ha(w) || ta(w)) || !nt(f)))
    return o ? hs : u;
  if (process.env.NODE_ENV !== "production" && nt(w) && e.messageCompiler == null)
    return La(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${u}'.`), u;
  let T = !1;
  const O = () => {
    T = !0;
  }, C = ta(w) ? w : $p(e, u, f, w, A, O);
  if (T)
    return w;
  const k = Nv(e, f, v, c), M = Iv(k), z = Ev(e, C, M);
  let j = a ? a(z, u) : z;
  if (g && nt(j) && (j = Hh(j)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const K = {
      timestamp: Date.now(),
      key: nt(u) ? u : ta(w) ? w.key : "",
      locale: f || (ta(w) ? w.locale : ""),
      format: nt(w) ? w : ta(w) ? w.source : "",
      message: j
    };
    K.meta = wn({}, e.__meta, /* @__PURE__ */ dv() || {}), Ub(K);
  }
  return j;
}
function Sv(e) {
  un(e.list) ? e.list = e.list.map((t) => nt(t) ? fc(t) : t) : $t(e.named) && Object.keys(e.named).forEach((t) => {
    nt(e.named[t]) && (e.named[t] = fc(e.named[t]));
  });
}
function jp(e, t, n, a, o, l) {
  const { messages: s, onWarn: i, messageResolver: u, localeFallbacker: c } = e, p = c(e, a, n);
  let h = Wt(), g, b = null, E = n, m = null;
  const I = "translate";
  for (let S = 0; S < p.length; S++) {
    if (g = m = p[S], process.env.NODE_ENV !== "production" && n !== g && !Rp(n, g) && bs(o, t) && i(To(Bn.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: g
    })), process.env.NODE_ENV !== "production" && n !== g) {
      const A = e.__v_emitter;
      A && A.emit("fallback", {
        type: I,
        key: t,
        from: E,
        to: m,
        groupId: `${I}:${t}`
      });
    }
    h = s[g] || Wt();
    let f = null, v, w;
    if (process.env.NODE_ENV !== "production" && za && (f = window.performance.now(), v = "intlify-message-resolve-start", w = "intlify-message-resolve-end", Kn && Kn(v)), (b = u(h, t)) === null && (b = h[t]), process.env.NODE_ENV !== "production" && za) {
      const A = window.performance.now(), T = e.__v_emitter;
      T && f && b && T.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: b,
        time: A - f,
        groupId: `${I}:${t}`
      }), v && w && Kn && Eo && (Kn(w), Eo("intlify message resolve", v, w));
    }
    if (nt(b) || ha(b) || ta(b))
      break;
    if (!fv(g, p)) {
      const A = ou(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        g,
        l,
        I
      );
      A !== t && (b = A);
    }
    E = m;
  }
  return [b, g, h];
}
function $p(e, t, n, a, o, l) {
  const { messageCompiler: s, warnHtmlMessage: i } = e;
  if (ta(a)) {
    const g = a;
    return g.locale = g.locale || n, g.key = g.key || t, g;
  }
  if (s == null) {
    const g = (() => a);
    return g.locale = n, g.key = t, g;
  }
  let u = null, c, p;
  process.env.NODE_ENV !== "production" && za && (u = window.performance.now(), c = "intlify-message-compilation-start", p = "intlify-message-compilation-end", Kn && Kn(c));
  const h = s(a, Tv(e, n, o, a, i, l));
  if (process.env.NODE_ENV !== "production" && za) {
    const g = window.performance.now(), b = e.__v_emitter;
    b && u && b.emit("message-compilation", {
      type: "message-compilation",
      message: a,
      time: g - u,
      groupId: `translate:${t}`
    }), c && p && Kn && Eo && (Kn(p), Eo("intlify message compilation", c, p));
  }
  return h.locale = n, h.key = t, h.source = a, h;
}
function Ev(e, t, n) {
  let a = null, o, l;
  process.env.NODE_ENV !== "production" && za && (a = window.performance.now(), o = "intlify-message-evaluation-start", l = "intlify-message-evaluation-end", Kn && Kn(o));
  const s = t(n);
  if (process.env.NODE_ENV !== "production" && za) {
    const i = window.performance.now(), u = e.__v_emitter;
    u && a && u.emit("message-evaluation", {
      type: "message-evaluation",
      value: s,
      time: i - a,
      groupId: `translate:${t.key}`
    }), o && l && Kn && Eo && (Kn(l), Eo("intlify message evaluation", o, l));
  }
  return s;
}
function mr(...e) {
  const [t, n, a] = e, o = Wt();
  if (!nt(t) && !yn(t) && !ta(t) && !ha(t))
    throw Va(An.INVALID_ARGUMENT);
  const l = yn(t) ? String(t) : (ta(t), t);
  return yn(n) ? o.plural = n : nt(n) ? o.default = n : xt(n) && !gs(n) ? o.named = n : un(n) && (o.list = n), yn(a) ? o.plural = a : nt(a) ? o.default = a : xt(a) && wn(o, a), [l, o];
}
function Tv(e, t, n, a, o, l) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: o,
    onError: (s) => {
      if (l && l(s), process.env.NODE_ENV !== "production") {
        const i = Cv(a), u = `Message compilation error: ${s.message}`, c = s.location && i && Xh(i, s.location.start.offset, s.location.end.offset), p = e.__v_emitter;
        p && i && p.emit("compile-error", {
          message: i,
          error: s.message,
          start: s.location && s.location.start.offset,
          end: s.location && s.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(c ? `${u}
${c}` : u);
      } else
        throw s;
    },
    onCacheKey: (s) => Uh(t, n, s)
  };
}
function Cv(e) {
  if (nt(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function Nv(e, t, n, a) {
  const { modifiers: o, pluralRules: l, messageResolver: s, fallbackLocale: i, fallbackWarn: u, missingWarn: c, fallbackContext: p } = e, g = {
    locale: t,
    modifiers: o,
    pluralRules: l,
    messages: (b, E) => {
      let m = s(n, b);
      if (m == null && (p || E)) {
        const [, , I] = jp(
          p || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          b,
          t,
          i,
          u,
          c
        );
        m = s(I, b);
      }
      if (nt(m) || ha(m)) {
        let I = !1;
        const f = $p(e, b, t, m, b, () => {
          I = !0;
        });
        return I ? Mc : f;
      } else return ta(m) ? m : Mc;
    }
  };
  return e.processor && (g.processor = e.processor), a.list && (g.list = a.list), a.named && (g.named = a.named), yn(a.plural) && (g.pluralIndex = a.plural), g;
}
Nb();
/*!
  * vue-i18n v11.1.12
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const Lv = "11.1.12";
function Ov() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (fo().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (fo().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (fo().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (fo().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Sn = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Wb,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function Ql(e, ...t) {
  return ml(e, null, process.env.NODE_ENV !== "production" ? { messages: Dv, args: t } : void 0);
}
const Dv = {
  [Sn.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Sn.INVALID_ARGUMENT]: "Invalid argument",
  [Sn.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Sn.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Sn.UNEXPECTED_ERROR]: "Unexpected error",
  [Sn.REQUIRED_VALUE]: "Required in value: {0}",
  [Sn.INVALID_VALUE]: "Invalid value",
  [Sn.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Sn.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Sn.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Sn.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, fr = /* @__PURE__ */ Ya("__translateVNode"), gr = /* @__PURE__ */ Ya("__datetimeParts"), hr = /* @__PURE__ */ Ya("__numberParts"), br = /* @__PURE__ */ Ya("__enableEmitter"), vr = /* @__PURE__ */ Ya("__disableEmitter"), Av = Ya("__setPluralRules"), Fp = /* @__PURE__ */ Ya("__injectWithOption"), yr = /* @__PURE__ */ Ya("__dispose"), Ia = {
  FALLBACK_TO_ROOT: av,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 13
}, Rv = {
  [Ia.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Ia.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Ia.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Ia.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Ia.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [Ia.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function Ki(e, ...t) {
  return fs(Rv[e], ...t);
}
function ei(e) {
  if (!$t(e) || ha(e))
    return e;
  for (const t in e)
    if (fa(e, t))
      if (!t.includes("."))
        $t(e[t]) && ei(e[t]);
      else {
        const n = t.split("."), a = n.length - 1;
        let o = e, l = !1;
        for (let s = 0; s < a; s++) {
          if (n[s] === "__proto__")
            throw new Error(`unsafe key: ${n[s]}`);
          if (n[s] in o || (o[n[s]] = Wt()), !$t(o[n[s]])) {
            process.env.NODE_ENV !== "production" && La(Ki(Ia.IGNORE_OBJ_FLATTEN, {
              key: n[s]
            })), l = !0;
            break;
          }
          o = o[n[s]];
        }
        if (l || (ha(o) ? Ep.includes(n[a]) || delete e[t] : (o[n[a]] = e[t], delete e[t])), !ha(o)) {
          const s = o[n[a]];
          $t(s) && ei(s);
        }
      }
  return e;
}
function kp(e, t) {
  const { messages: n, __i18n: a, messageResolver: o, flatJson: l } = t, s = xt(n) ? n : un(a) ? Wt() : { [e]: Wt() };
  if (un(a) && a.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: u, resource: c } = i;
      u ? (s[u] = s[u] || Wt(), Mi(c, s[u])) : Mi(c, s);
    } else
      nt(i) && Mi(JSON.parse(i), s);
  }), o == null && l)
    for (const i in s)
      fa(s, i) && ei(s[i]);
  return s;
}
function Vp(e) {
  return e.type;
}
function Mv(e, t, n) {
  let a = $t(t.messages) ? t.messages : Wt();
  "__i18nGlobal" in n && (a = kp(e.locale.value, {
    messages: a,
    __i18n: n.__i18nGlobal
  }));
  const o = Object.keys(a);
  o.length && o.forEach((l) => {
    e.mergeLocaleMessage(l, a[l]);
  });
  {
    if ($t(t.datetimeFormats)) {
      const l = Object.keys(t.datetimeFormats);
      l.length && l.forEach((s) => {
        e.mergeDateTimeFormat(s, t.datetimeFormats[s]);
      });
    }
    if ($t(t.numberFormats)) {
      const l = Object.keys(t.numberFormats);
      l.length && l.forEach((s) => {
        e.mergeNumberFormat(s, t.numberFormats[s]);
      });
    }
  }
}
function xc(e) {
  return d(yg, null, e, 0);
}
const jc = "__INTLIFY_META__", $c = () => [], Pv = () => !1;
let Fc = 0;
function kc(e) {
  return ((t, n, a, o) => e(n, a, ns() || void 0, o));
}
const xv = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = ns();
  let t = null;
  return e && (t = Vp(e)[jc]) ? { [jc]: t } : null;
};
function jv(e = {}) {
  const { __root: t, __injectWithOption: n } = e, a = t === void 0, o = e.flatJson, l = za ? B : vg;
  let s = sn(e.inheritLocale) ? e.inheritLocale : !0;
  const i = l(
    // prettier-ignore
    t && s ? t.locale.value : nt(e.locale) ? e.locale : Hi
  ), u = l(
    // prettier-ignore
    t && s ? t.fallbackLocale.value : nt(e.fallbackLocale) || un(e.fallbackLocale) || xt(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), c = l(kp(i.value, e)), p = l(xt(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), h = l(xt(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let g = t ? t.missingWarn : sn(e.missingWarn) || zi(e.missingWarn) ? e.missingWarn : !0, b = t ? t.fallbackWarn : sn(e.fallbackWarn) || zi(e.fallbackWarn) ? e.fallbackWarn : !0, E = t ? t.fallbackRoot : sn(e.fallbackRoot) ? e.fallbackRoot : !0, m = !!e.fallbackFormat, I = Jt(e.missing) ? e.missing : null, S = Jt(e.missing) ? kc(e.missing) : null, f = Jt(e.postTranslation) ? e.postTranslation : null, v = t ? t.warnHtmlMessage : sn(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, w = !!e.escapeParameter;
  const A = t ? t.modifiers : xt(e.modifiers) ? e.modifiers : {};
  let T = e.pluralRules || t && t.pluralRules, O;
  O = (() => {
    a && Tc(null);
    const W = {
      version: Lv,
      locale: i.value,
      fallbackLocale: u.value,
      messages: c.value,
      modifiers: A,
      pluralRules: T,
      missing: S === null ? void 0 : S,
      missingWarn: g,
      fallbackWarn: b,
      fallbackFormat: m,
      unresolving: !0,
      postTranslation: f === null ? void 0 : f,
      warnHtmlMessage: v,
      escapeParameter: w,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    W.datetimeFormats = p.value, W.numberFormats = h.value, W.__datetimeFormatters = xt(O) ? O.__datetimeFormatters : void 0, W.__numberFormatters = xt(O) ? O.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (W.__v_emitter = xt(O) ? O.__v_emitter : void 0);
    const ee = mv(W);
    return a && Tc(ee), ee;
  })(), Tl(O, i.value, u.value);
  function k() {
    return [
      i.value,
      u.value,
      c.value,
      p.value,
      h.value
    ];
  }
  const M = Ce({
    get: () => i.value,
    set: (W) => {
      O.locale = W, i.value = W;
    }
  }), z = Ce({
    get: () => u.value,
    set: (W) => {
      O.fallbackLocale = W, u.value = W, Tl(O, i.value, W);
    }
  }), j = Ce(() => c.value), K = /* @__PURE__ */ Ce(() => p.value), x = /* @__PURE__ */ Ce(() => h.value);
  function N() {
    return Jt(f) ? f : null;
  }
  function G(W) {
    f = W, O.postTranslation = W;
  }
  function ce() {
    return I;
  }
  function re(W) {
    W !== null && (S = kc(W)), I = W, O.missing = S;
  }
  function Se(W, ee) {
    return W !== "translate" || !ee.resolvedMessage;
  }
  const se = (W, ee, $, R, D, V) => {
    k();
    let Z;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (O.fallbackContext = t ? pv() : void 0), Z = W(O);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (O.fallbackContext = void 0);
    }
    if ($ !== "translate exists" && // for not `te` (e.g `t`)
    yn(Z) && Z === hs || $ === "translate exists" && !Z) {
      const [X, Ae] = ee();
      if (process.env.NODE_ENV !== "production" && t && nt(X) && Se($, Ae) && (E && (bs(b, X) || Ap(g, X)) && La(Ki(Ia.FALLBACK_TO_ROOT, {
        key: X,
        type: $
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: De } = O;
        De && E && De.emit("fallback", {
          type: $,
          key: X,
          to: "global",
          groupId: `${$}:${X}`
        });
      }
      return t && E ? R(t) : D(X);
    } else {
      if (V(Z))
        return Z;
      throw Ql(Sn.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Le(...W) {
    return se((ee) => Reflect.apply(Pc, null, [ee, ...W]), () => mr(...W), "translate", (ee) => Reflect.apply(ee.t, ee, [...W]), (ee) => ee, (ee) => nt(ee));
  }
  function Y(...W) {
    const [ee, $, R] = W;
    if (R && !$t(R))
      throw Ql(Sn.INVALID_ARGUMENT);
    return Le(ee, $, wn({ resolvedMessage: !0 }, R || {}));
  }
  function pe(...W) {
    return se((ee) => Reflect.apply(Lc, null, [ee, ...W]), () => dr(...W), "datetime format", (ee) => Reflect.apply(ee.d, ee, [...W]), () => Yi, (ee) => nt(ee) || un(ee));
  }
  function fe(...W) {
    return se((ee) => Reflect.apply(Dc, null, [ee, ...W]), () => pr(...W), "number format", (ee) => Reflect.apply(ee.n, ee, [...W]), () => Yi, (ee) => nt(ee) || un(ee));
  }
  function le(W) {
    return W.map((ee) => nt(ee) || yn(ee) || sn(ee) ? xc(String(ee)) : ee);
  }
  const q = {
    normalize: le,
    interpolate: (W) => W,
    type: "vnode"
  };
  function he(...W) {
    return se((ee) => {
      let $;
      const R = ee;
      try {
        R.processor = q, $ = Reflect.apply(Pc, null, [R, ...W]);
      } finally {
        R.processor = null;
      }
      return $;
    }, () => mr(...W), "translate", (ee) => ee[fr](...W), (ee) => [xc(ee)], (ee) => un(ee));
  }
  function ne(...W) {
    return se((ee) => Reflect.apply(Dc, null, [ee, ...W]), () => pr(...W), "number format", (ee) => ee[hr](...W), $c, (ee) => nt(ee) || un(ee));
  }
  function te(...W) {
    return se((ee) => Reflect.apply(Lc, null, [ee, ...W]), () => dr(...W), "datetime format", (ee) => ee[gr](...W), $c, (ee) => nt(ee) || un(ee));
  }
  function Ie(W) {
    T = W, O.pluralRules = T;
  }
  function Ee(W, ee) {
    return se(() => {
      if (!W)
        return !1;
      const $ = nt(ee) ? ee : i.value, R = Ke($), D = O.messageResolver(R, W);
      return ha(D) || ta(D) || nt(D);
    }, () => [W], "translate exists", ($) => Reflect.apply($.te, $, [W, ee]), Pv, ($) => sn($));
  }
  function xe(W) {
    let ee = null;
    const $ = Tp(O, u.value, i.value);
    for (let R = 0; R < $.length; R++) {
      const D = c.value[$[R]] || {}, V = O.messageResolver(D, W);
      if (V != null) {
        ee = V;
        break;
      }
    }
    return ee;
  }
  function Qe(W) {
    const ee = xe(W);
    return ee ?? (t ? t.tm(W) || {} : {});
  }
  function Ke(W) {
    return c.value[W] || {};
  }
  function qe(W, ee) {
    if (o) {
      const $ = { [W]: ee };
      for (const R in $)
        fa($, R) && ei($[R]);
      ee = $[W];
    }
    c.value[W] = ee, O.messages = c.value;
  }
  function rt(W, ee) {
    c.value[W] = c.value[W] || {};
    const $ = { [W]: ee };
    if (o)
      for (const R in $)
        fa($, R) && ei($[R]);
    ee = $[W], Mi(ee, c.value[W]), O.messages = c.value;
  }
  function P(W) {
    return p.value[W] || {};
  }
  function F(W, ee) {
    p.value[W] = ee, O.datetimeFormats = p.value, Oc(O, W, ee);
  }
  function me(W, ee) {
    p.value[W] = wn(p.value[W] || {}, ee), O.datetimeFormats = p.value, Oc(O, W, ee);
  }
  function de(W) {
    return h.value[W] || {};
  }
  function We(W, ee) {
    h.value[W] = ee, O.numberFormats = h.value, Ac(O, W, ee);
  }
  function Q(W, ee) {
    h.value[W] = wn(h.value[W] || {}, ee), O.numberFormats = h.value, Ac(O, W, ee);
  }
  Fc++, t && za && (lt(t.locale, (W) => {
    s && (i.value = W, O.locale = W, Tl(O, i.value, u.value));
  }), lt(t.fallbackLocale, (W) => {
    s && (u.value = W, O.fallbackLocale = W, Tl(O, i.value, u.value));
  }));
  const ie = {
    id: Fc,
    locale: M,
    fallbackLocale: z,
    get inheritLocale() {
      return s;
    },
    set inheritLocale(W) {
      s = W, W && t && (i.value = t.locale.value, u.value = t.fallbackLocale.value, Tl(O, i.value, u.value));
    },
    get availableLocales() {
      return Object.keys(c.value).sort();
    },
    messages: j,
    get modifiers() {
      return A;
    },
    get pluralRules() {
      return T || {};
    },
    get isGlobal() {
      return a;
    },
    get missingWarn() {
      return g;
    },
    set missingWarn(W) {
      g = W, O.missingWarn = g;
    },
    get fallbackWarn() {
      return b;
    },
    set fallbackWarn(W) {
      b = W, O.fallbackWarn = b;
    },
    get fallbackRoot() {
      return E;
    },
    set fallbackRoot(W) {
      E = W;
    },
    get fallbackFormat() {
      return m;
    },
    set fallbackFormat(W) {
      m = W, O.fallbackFormat = m;
    },
    get warnHtmlMessage() {
      return v;
    },
    set warnHtmlMessage(W) {
      v = W, O.warnHtmlMessage = W;
    },
    get escapeParameter() {
      return w;
    },
    set escapeParameter(W) {
      w = W, O.escapeParameter = W;
    },
    t: Le,
    getLocaleMessage: Ke,
    setLocaleMessage: qe,
    mergeLocaleMessage: rt,
    getPostTranslationHandler: N,
    setPostTranslationHandler: G,
    getMissingHandler: ce,
    setMissingHandler: re,
    [Av]: Ie
  };
  return ie.datetimeFormats = K, ie.numberFormats = x, ie.rt = Y, ie.te = Ee, ie.tm = Qe, ie.d = pe, ie.n = fe, ie.getDateTimeFormat = P, ie.setDateTimeFormat = F, ie.mergeDateTimeFormat = me, ie.getNumberFormat = de, ie.setNumberFormat = We, ie.mergeNumberFormat = Q, ie[Fp] = n, ie[fr] = he, ie[gr] = te, ie[hr] = ne, process.env.NODE_ENV !== "production" && (ie[br] = (W) => {
    O.__v_emitter = W;
  }, ie[vr] = () => {
    O.__v_emitter = void 0;
  }), ie;
}
function Vc(e, t) {
}
const lu = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function $v({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((a, o) => [
    ...a,
    // prettier-ignore
    ...o.type === He ? o.children : [o]
  ], []) : t.reduce((n, a) => {
    const o = e[a];
    return o && (n[a] = o()), n;
  }, Wt());
}
function Bp() {
  return He;
}
wn({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => yn(e) || !isNaN(e)
  }
}, lu);
function Fv(e) {
  return un(e) && !nt(e[0]);
}
function Up(e, t, n, a) {
  const { slots: o, attrs: l } = t;
  return () => {
    const s = { part: !0 };
    let i = Wt();
    e.locale && (s.locale = e.locale), nt(e.format) ? s.key = e.format : $t(e.format) && (nt(e.format.key) && (s.key = e.format.key), i = Object.keys(e.format).reduce((g, b) => n.includes(b) ? wn(Wt(), g, { [b]: e.format[b] }) : g, Wt()));
    const u = a(e.value, s, i);
    let c = [s.key];
    un(u) ? c = u.map((g, b) => {
      const E = o[g.type], m = E ? E({ [g.type]: g.value, index: b, parts: u }) : [g.value];
      return Fv(m) && (m[0].key = `${g.type}-${b}`), m;
    }) : nt(u) && (c = [u]);
    const p = wn(Wt(), l), h = nt(e.tag) || $t(e.tag) ? e.tag : Bp();
    return Jd(h, p, c);
  };
}
wn({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, lu);
const kv = /* @__PURE__ */ Ya("global-vue-i18n");
function Ht(e = {}) {
  const t = ns();
  if (t == null)
    throw Ql(Sn.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Ql(Sn.NOT_INSTALLED);
  const n = Vv(t), a = Uv(n), o = Vp(t), l = Bv(e, o);
  if (l === "global")
    return Mv(a, e, o), a;
  if (l === "parent") {
    let u = Gv(n, t, e.__useComponent);
    return u == null && (process.env.NODE_ENV !== "production" && La(Ki(Ia.NOT_FOUND_PARENT_SCOPE)), u = a), u;
  }
  const s = n;
  let i = s.__getInstance(t);
  if (i == null) {
    const u = wn({}, e);
    "__i18n" in o && (u.__i18n = o.__i18n), a && (u.__root = a), i = jv(u), s.__composerExtend && (i[yr] = s.__composerExtend(i)), zv(s, t, i), s.__setInstance(t, i);
  } else
    process.env.NODE_ENV !== "production" && l === "local" && La(Ki(Ia.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function Vv(e) {
  const t = Xn(e.isCE ? kv : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw Ql(e.isCE ? Sn.NOT_INSTALLED_WITH_PROVIDE : Sn.UNEXPECTED_ERROR);
  return t;
}
function Bv(e, t) {
  return gs(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Uv(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Gv(e, t, n = !1) {
  let a = null;
  const o = t.root;
  let l = Wv(t, n);
  for (; l != null; ) {
    const s = e;
    if (e.mode === "composition")
      a = s.__getInstance(l);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = s.__getInstance(l);
      i != null && (a = i.__composer, n && a && !a[Fp] && (a = null));
    }
    if (a != null || o === l)
      break;
    l = l.parent;
  }
  return a;
}
function Wv(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function zv(e, t, n) {
  let a = null;
  Dt(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, a = Jh();
      const o = n;
      o[br] && o[br](a), a.on("*", Vc);
    }
  }, t), Ha(() => {
    const o = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (a && a.off("*", Vc), o[vr] && o[vr](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const l = o[yr];
    l && (l(), delete o[yr]);
  }, t);
}
wn({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, lu);
Ov();
sv(kb);
rv(nv);
uv(Tp);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = fo();
  e.__INTLIFY__ = !0, Vb(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const Hv = { class: "picker-container" }, Yv = { style: { "white-space": "nowrap" } }, Kv = /* @__PURE__ */ Je({
  __name: "ViewerSettingsColorPicker",
  props: {
    label: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const { t: n } = Ht(), a = e, o = t, l = Do(), { modelValue: s } = on(a), i = async () => {
      const p = await l.showColorPickerModal(n("medic-web-engine.setColor"), s.value);
      p && u(p);
    }, u = (p) => {
      o("update:modelValue", p);
    }, c = Ce(() => ({
      backgroundColor: `rgb(${s.value[0]}, ${s.value[1]}, ${s.value[2]})`
    }));
    return (p, h) => (L(), H("div", Hv, [
      y("div", {
        class: "color-preview-button",
        onClick: i
      }, [
        y("div", {
          style: Et(c.value),
          class: "color-preview-button-inner"
        }, null, 4)
      ]),
      y("div", Yv, U(e.label), 1)
    ]));
  }
});
function Zv(e, t) {
  return e ? e.classList ? e.classList.contains(t) : new RegExp("(^| )" + t + "( |$)", "gi").test(e.className) : !1;
}
function Gp(e, t) {
  if (e && t) {
    const n = (a) => {
      Zv(e, a) || (e.classList ? e.classList.add(a) : e.className += " " + a);
    };
    [t].flat().filter(Boolean).forEach((a) => a.split(" ").forEach(n));
  }
}
function Xv() {
  return window.innerWidth - document.documentElement.offsetWidth;
}
function Wp(e) {
  for (const t of document == null ? void 0 : document.styleSheets)
    try {
      for (const n of t == null ? void 0 : t.cssRules)
        for (const a of n == null ? void 0 : n.style)
          if (e.test(a))
            return { name: a, value: n.style.getPropertyValue(a).trim() };
    } catch {
    }
  return null;
}
function Jv(e = "p-overflow-hidden") {
  const t = Wp(/-scrollbar-width$/);
  t != null && t.name && document.body.style.setProperty(t.name, Xv() + "px"), Gp(document.body, e);
}
function qv(e, t) {
  if (e && t) {
    const n = (a) => {
      e.classList ? e.classList.remove(a) : e.className = e.className.replace(new RegExp("(^|\\b)" + a.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };
    [t].flat().filter(Boolean).forEach((a) => a.split(" ").forEach(n));
  }
}
function Bc(e = "p-overflow-hidden") {
  const t = Wp(/-scrollbar-width$/);
  t != null && t.name && document.body.style.removeProperty(t.name), qv(document.body, e);
}
function Qv() {
  let e = document.documentElement;
  return (window.pageXOffset || e.scrollLeft) - (e.clientLeft || 0);
}
function ey() {
  let e = document.documentElement;
  return (window.pageYOffset || e.scrollTop) - (e.clientTop || 0);
}
function Ro(e) {
  return typeof HTMLElement == "object" ? e instanceof HTMLElement : e && typeof e == "object" && e !== null && e.nodeType === 1 && typeof e.nodeName == "string";
}
function ty() {
  if (window.getSelection) {
    const e = window.getSelection() || {};
    e.empty ? e.empty() : e.removeAllRanges && e.rangeCount > 0 && e.getRangeAt(0).getClientRects().length > 0 && e.removeAllRanges();
  }
}
function _r(e, t = {}) {
  if (Ro(e)) {
    const n = (a, o) => {
      var l, s;
      const i = (l = e == null ? void 0 : e.$attrs) != null && l[a] ? [(s = e == null ? void 0 : e.$attrs) == null ? void 0 : s[a]] : [];
      return [o].flat().reduce((u, c) => {
        if (c != null) {
          const p = typeof c;
          if (p === "string" || p === "number")
            u.push(c);
          else if (p === "object") {
            const h = Array.isArray(c) ? n(a, c) : Object.entries(c).map(([g, b]) => a === "style" && (b || b === 0) ? `${g.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}:${b}` : b ? g : void 0);
            u = h.length ? u.concat(h.filter((g) => !!g)) : u;
          }
        }
        return u;
      }, i);
    };
    Object.entries(t).forEach(([a, o]) => {
      if (o != null) {
        const l = a.match(/^on(.+)/);
        l ? e.addEventListener(l[1].toLowerCase(), o) : a === "p-bind" || a === "pBind" ? _r(e, o) : (o = a === "class" ? [...new Set(n("class", o))].join(" ").trim() : a === "style" ? n("style", o).join(";").trim() : o, (e.$attrs = e.$attrs || {}) && (e.$attrs[a] = o), e.setAttribute(a, o));
      }
    });
  }
}
function zp(e, t) {
  return Ro(e) ? Array.from(e.querySelectorAll(t)) : [];
}
function iu(e, t) {
  return Ro(e) ? e.matches(t) ? e : e.querySelector(t) : null;
}
function Pi(e, t) {
  e && document.activeElement !== e && e.focus(t);
}
function Hp(e, t) {
  if (Ro(e)) {
    const n = e.getAttribute(t);
    return isNaN(n) ? n === "true" || n === "false" ? n === "true" : n : +n;
  }
}
function ny(e, t = "") {
  let n = zp(
    e,
    `button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t},
            [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${t}`
  ), a = [];
  for (let o of n)
    getComputedStyle(o).display != "none" && getComputedStyle(o).visibility != "hidden" && a.push(o);
  return a;
}
function Uc(e, t) {
  const n = ny(e, t);
  return n.length > 0 ? n[0] : null;
}
function ay(e) {
  if (e) {
    let t = e.parentNode;
    return t && t instanceof ShadowRoot && t.host && (t = t.host), t;
  }
  return null;
}
function Gc() {
  if (window.getSelection) return window.getSelection().toString();
  if (document.getSelection) return document.getSelection().toString();
}
function oy(e) {
  return !!(e !== null && typeof e < "u" && e.nodeName && ay(e));
}
function ly(e, t, n) {
  return Ro(e) ? Hp(e, t) === n : !1;
}
function Yp() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function iy(e) {
  return e ? getComputedStyle(e).direction === "rtl" : !1;
}
function sy(e, t = "", n) {
  Ro(e) && n !== null && n !== void 0 && e.setAttribute(t, n);
}
function ry() {
  const e = /* @__PURE__ */ new Map();
  return {
    on(t, n) {
      let a = e.get(t);
      return a ? a.push(n) : a = [n], e.set(t, a), this;
    },
    off(t, n) {
      let a = e.get(t);
      return a && a.splice(a.indexOf(n) >>> 0, 1), this;
    },
    emit(t, n) {
      let a = e.get(t);
      a && a.slice().map((o) => {
        o(n);
      });
    },
    clear() {
      e.clear();
    }
  };
}
function pi(e) {
  return e == null || e === "" || Array.isArray(e) && e.length === 0 || !(e instanceof Date) && typeof e == "object" && Object.keys(e).length === 0;
}
function wr(e, t, n = /* @__PURE__ */ new WeakSet()) {
  if (e === t) return !0;
  if (!e || !t || typeof e != "object" || typeof t != "object" || n.has(e) || n.has(t)) return !1;
  n.add(e).add(t);
  let a = Array.isArray(e), o = Array.isArray(t), l, s, i;
  if (a && o) {
    if (s = e.length, s != t.length) return !1;
    for (l = s; l-- !== 0; ) if (!wr(e[l], t[l], n)) return !1;
    return !0;
  }
  if (a != o) return !1;
  let u = e instanceof Date, c = t instanceof Date;
  if (u != c) return !1;
  if (u && c) return e.getTime() == t.getTime();
  let p = e instanceof RegExp, h = t instanceof RegExp;
  if (p != h) return !1;
  if (p && h) return e.toString() == t.toString();
  let g = Object.keys(e);
  if (s = g.length, s !== Object.keys(t).length) return !1;
  for (l = s; l-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(t, g[l])) return !1;
  for (l = s; l-- !== 0; )
    if (i = g[l], !wr(e[i], t[i], n)) return !1;
  return !0;
}
function uy(e, t) {
  return wr(e, t);
}
function su(e) {
  return !!(e && e.constructor && e.call && e.apply);
}
function At(e) {
  return !pi(e);
}
function $a(e, t) {
  if (!e || !t)
    return null;
  try {
    const n = e[t];
    if (At(n)) return n;
  } catch {
  }
  if (Object.keys(e).length) {
    if (su(t))
      return t(e);
    if (t.indexOf(".") === -1)
      return e[t];
    {
      let n = t.split("."), a = e;
      for (let o = 0, l = n.length; o < l; ++o) {
        if (a == null)
          return null;
        a = a[n[o]];
      }
      return a;
    }
  }
  return null;
}
function Zi(e, t, n) {
  return n ? $a(e, n) === $a(t, n) : uy(e, t);
}
function Ci(e, t) {
  let n = -1;
  if (At(e))
    try {
      n = e.findLastIndex(t);
    } catch {
      n = e.lastIndexOf([...e].reverse().find(t));
    }
  return n;
}
function ll(e, t = !0) {
  return e instanceof Object && e.constructor === Object && (t || Object.keys(e).length !== 0);
}
function ga(e, ...t) {
  return su(e) ? e(...t) : e;
}
function Ca(e, t = !0) {
  return typeof e == "string" && (t || e !== "");
}
function eo(e) {
  return Ca(e) ? e.replace(/(-|_)/g, "").toLowerCase() : e;
}
function Kp(e, t = "", n = {}) {
  const a = eo(t).split("."), o = a.shift();
  return o ? ll(e) ? Kp(ga(e[Object.keys(e).find((l) => eo(l) === o) || ""], n), a.join("."), n) : void 0 : ga(e, n);
}
function ru(e, t = !0) {
  return Array.isArray(e) && (t || e.length !== 0);
}
function cy(e) {
  return At(e) && !isNaN(e);
}
function dy(e = "") {
  return At(e) && e.length === 1 && !!e.match(/\S| /);
}
function Ba(e, t) {
  if (t) {
    const n = t.test(e);
    return t.lastIndex = 0, n;
  }
  return !1;
}
function Gl(e) {
  return e && e.replace(/\/\*(?:(?!\*\/)[\s\S])*\*\/|[\r\n\t]+/g, "").replace(/ {2,}/g, " ").replace(/ ([{:}]) /g, "$1").replace(/([;,]) /g, "$1").replace(/ !/g, "!").replace(/: /g, ":");
}
function Jn(e) {
  if (e && /[\xC0-\xFF\u0100-\u017E]/.test(e)) {
    const n = {
      A: /[\xC0-\xC5\u0100\u0102\u0104]/g,
      AE: /[\xC6]/g,
      C: /[\xC7\u0106\u0108\u010A\u010C]/g,
      D: /[\xD0\u010E\u0110]/g,
      E: /[\xC8-\xCB\u0112\u0114\u0116\u0118\u011A]/g,
      G: /[\u011C\u011E\u0120\u0122]/g,
      H: /[\u0124\u0126]/g,
      I: /[\xCC-\xCF\u0128\u012A\u012C\u012E\u0130]/g,
      IJ: /[\u0132]/g,
      J: /[\u0134]/g,
      K: /[\u0136]/g,
      L: /[\u0139\u013B\u013D\u013F\u0141]/g,
      N: /[\xD1\u0143\u0145\u0147\u014A]/g,
      O: /[\xD2-\xD6\xD8\u014C\u014E\u0150]/g,
      OE: /[\u0152]/g,
      R: /[\u0154\u0156\u0158]/g,
      S: /[\u015A\u015C\u015E\u0160]/g,
      T: /[\u0162\u0164\u0166]/g,
      U: /[\xD9-\xDC\u0168\u016A\u016C\u016E\u0170\u0172]/g,
      W: /[\u0174]/g,
      Y: /[\xDD\u0176\u0178]/g,
      Z: /[\u0179\u017B\u017D]/g,
      a: /[\xE0-\xE5\u0101\u0103\u0105]/g,
      ae: /[\xE6]/g,
      c: /[\xE7\u0107\u0109\u010B\u010D]/g,
      d: /[\u010F\u0111]/g,
      e: /[\xE8-\xEB\u0113\u0115\u0117\u0119\u011B]/g,
      g: /[\u011D\u011F\u0121\u0123]/g,
      i: /[\xEC-\xEF\u0129\u012B\u012D\u012F\u0131]/g,
      ij: /[\u0133]/g,
      j: /[\u0135]/g,
      k: /[\u0137,\u0138]/g,
      l: /[\u013A\u013C\u013E\u0140\u0142]/g,
      n: /[\xF1\u0144\u0146\u0148\u014B]/g,
      p: /[\xFE]/g,
      o: /[\xF2-\xF6\xF8\u014D\u014F\u0151]/g,
      oe: /[\u0153]/g,
      r: /[\u0155\u0157\u0159]/g,
      s: /[\u015B\u015D\u015F\u0161]/g,
      t: /[\u0163\u0165\u0167]/g,
      u: /[\xF9-\xFC\u0169\u016B\u016D\u016F\u0171\u0173]/g,
      w: /[\u0175]/g,
      y: /[\xFD\xFF\u0177]/g,
      z: /[\u017A\u017C\u017E]/g
    };
    for (let a in n)
      e = e.replace(n[a], a);
  }
  return e;
}
function Zp(e) {
  return Ca(e) ? e.replace(/(_)/g, "-").replace(/[A-Z]/g, (t, n) => n === 0 ? t : "-" + t.toLowerCase()).toLowerCase() : e;
}
function Wc(e) {
  return Ca(e) ? e.replace(/[A-Z]/g, (t, n) => n === 0 ? t : "." + t.toLowerCase()).toLowerCase() : e;
}
var Ni = {};
function Xp(e = "pui_id_") {
  return Ni.hasOwnProperty(e) || (Ni[e] = 0), Ni[e]++, `${e}${Ni[e]}`;
}
function py() {
  let e = [];
  const t = (s, i, u = 999) => {
    const c = o(s, i, u), p = c.value + (c.key === s ? 0 : u) + 1;
    return e.push({ key: s, value: p }), p;
  }, n = (s) => {
    e = e.filter((i) => i.value !== s);
  }, a = (s, i) => o(s).value, o = (s, i, u = 0) => [...e].reverse().find((c) => !0) || { key: s, value: u }, l = (s) => s && parseInt(s.style.zIndex, 10) || 0;
  return {
    get: l,
    set: (s, i, u) => {
      i && (i.style.zIndex = String(t(s, !0, u)));
    },
    clear: (s) => {
      s && (n(l(s)), s.style.zIndex = "");
    },
    getCurrent: (s) => a(s)
  };
}
var Vs = py(), my = Object.defineProperty, fy = Object.defineProperties, gy = Object.getOwnPropertyDescriptors, Xi = Object.getOwnPropertySymbols, Jp = Object.prototype.hasOwnProperty, qp = Object.prototype.propertyIsEnumerable, zc = (e, t, n) => t in e ? my(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, pa = (e, t) => {
  for (var n in t || (t = {}))
    Jp.call(t, n) && zc(e, n, t[n]);
  if (Xi)
    for (var n of Xi(t))
      qp.call(t, n) && zc(e, n, t[n]);
  return e;
}, Bs = (e, t) => fy(e, gy(t)), xa = (e, t) => {
  var n = {};
  for (var a in e)
    Jp.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && Xi)
    for (var a of Xi(e))
      t.indexOf(a) < 0 && qp.call(e, a) && (n[a] = e[a]);
  return n;
}, hy = ry(), Qa = hy;
function Hc(e, t) {
  ru(e) ? e.push(...t || []) : ll(e) && Object.assign(e, t);
}
function by(e) {
  return ll(e) && e.hasOwnProperty("value") && e.hasOwnProperty("type") ? e.value : e;
}
function vy(e) {
  return e.replaceAll(/ /g, "").replace(/[^\w]/g, "-");
}
function Ir(e = "", t = "") {
  return vy(`${Ca(e, !1) && Ca(t, !1) ? `${e}-` : e}${t}`);
}
function Qp(e = "", t = "") {
  return `--${Ir(e, t)}`;
}
function yy(e = "") {
  const t = (e.match(/{/g) || []).length, n = (e.match(/}/g) || []).length;
  return (t + n) % 2 !== 0;
}
function em(e, t = "", n = "", a = [], o) {
  if (Ca(e)) {
    const l = /{([^}]*)}/g, s = e.trim();
    if (yy(s))
      return;
    if (Ba(s, l)) {
      const i = s.replaceAll(l, (p) => {
        const g = p.replace(/{|}/g, "").split(".").filter((b) => !a.some((E) => Ba(b, E)));
        return `var(${Qp(n, Zp(g.join("-")))}${At(o) ? `, ${o}` : ""})`;
      }), u = /(\d+\s+[\+\-\*\/]\s+\d+)/g, c = /var\([^)]+\)/g;
      return Ba(i.replace(c, "0"), u) ? `calc(${i})` : i;
    }
    return s;
  } else if (cy(e))
    return e;
}
function _y(e, t, n) {
  Ca(t, !1) && e.push(`${t}:${n};`);
}
function Yo(e, t) {
  return e ? `${e}{${t}}` : "";
}
var Wl = (...e) => wy(gn.getTheme(), ...e), wy = (e = {}, t, n, a) => {
  if (t) {
    const { variable: o, options: l } = gn.defaults || {}, { prefix: s, transform: i } = (e == null ? void 0 : e.options) || l || {}, c = Ba(t, /{([^}]*)}/g) ? t : `{${t}}`;
    return a === "value" || pi(a) && i === "strict" ? gn.getTokenValue(t) : em(c, void 0, s, [o.excludedKeyRegex], n);
  }
  return "";
};
function Iy(e, t = {}) {
  const n = gn.defaults.variable, { prefix: a = n.prefix, selector: o = n.selector, excludedKeyRegex: l = n.excludedKeyRegex } = t, s = (c, p = "") => Object.entries(c).reduce(
    (h, [g, b]) => {
      const E = Ba(g, l) ? Ir(p) : Ir(p, Zp(g)), m = by(b);
      if (ll(m)) {
        const { variables: I, tokens: S } = s(m, E);
        Hc(h.tokens, S), Hc(h.variables, I);
      } else
        h.tokens.push((a ? E.replace(`${a}-`, "") : E).replaceAll("-", ".")), _y(h.variables, Qp(E), em(m, E, a, [l]));
      return h;
    },
    { variables: [], tokens: [] }
  ), { variables: i, tokens: u } = s(e, a);
  return {
    value: i,
    tokens: u,
    declarations: i.join(""),
    css: Yo(o, i.join(""))
  };
}
var ca = {
  regex: {
    rules: {
      class: {
        pattern: /^\.([a-zA-Z][\w-]*)$/,
        resolve(e) {
          return { type: "class", selector: e, matched: this.pattern.test(e.trim()) };
        }
      },
      attr: {
        pattern: /^\[(.*)\]$/,
        resolve(e) {
          return { type: "attr", selector: `:root${e}`, matched: this.pattern.test(e.trim()) };
        }
      },
      media: {
        pattern: /^@media (.*)$/,
        resolve(e) {
          return { type: "media", selector: `${e}{:root{[CSS]}}`, matched: this.pattern.test(e.trim()) };
        }
      },
      system: {
        pattern: /^system$/,
        resolve(e) {
          return { type: "system", selector: "@media (prefers-color-scheme: dark){:root{[CSS]}}", matched: this.pattern.test(e.trim()) };
        }
      },
      custom: {
        resolve(e) {
          return { type: "custom", selector: e, matched: !0 };
        }
      }
    },
    resolve(e) {
      const t = Object.keys(this.rules).filter((n) => n !== "custom").map((n) => this.rules[n]);
      return [e].flat().map((n) => {
        var a;
        return (a = t.map((o) => o.resolve(n)).find((o) => o.matched)) != null ? a : this.rules.custom.resolve(n);
      });
    }
  },
  _toVariables(e, t) {
    return Iy(e, { prefix: t == null ? void 0 : t.prefix });
  },
  getCommon({ name: e = "", theme: t = {}, params: n, set: a, defaults: o }) {
    var l, s, i, u, c, p, h;
    const { preset: g, options: b } = t;
    let E, m, I, S, f, v, w;
    if (At(g) && b.transform !== "strict") {
      const { primitive: A, semantic: T, extend: O } = g, C = T || {}, { colorScheme: k } = C, M = xa(C, ["colorScheme"]), z = O || {}, { colorScheme: j } = z, K = xa(z, ["colorScheme"]), x = k || {}, { dark: N } = x, G = xa(x, ["dark"]), ce = j || {}, { dark: re } = ce, Se = xa(ce, ["dark"]), se = At(A) ? this._toVariables({ primitive: A }, b) : {}, Le = At(M) ? this._toVariables({ semantic: M }, b) : {}, Y = At(G) ? this._toVariables({ light: G }, b) : {}, pe = At(N) ? this._toVariables({ dark: N }, b) : {}, fe = At(K) ? this._toVariables({ semantic: K }, b) : {}, le = At(Se) ? this._toVariables({ light: Se }, b) : {}, Re = At(re) ? this._toVariables({ dark: re }, b) : {}, [q, he] = [(l = se.declarations) != null ? l : "", se.tokens], [ne, te] = [(s = Le.declarations) != null ? s : "", Le.tokens || []], [Ie, Ee] = [(i = Y.declarations) != null ? i : "", Y.tokens || []], [xe, Qe] = [(u = pe.declarations) != null ? u : "", pe.tokens || []], [Ke, qe] = [(c = fe.declarations) != null ? c : "", fe.tokens || []], [rt, P] = [(p = le.declarations) != null ? p : "", le.tokens || []], [F, me] = [(h = Re.declarations) != null ? h : "", Re.tokens || []];
      E = this.transformCSS(e, q, "light", "variable", b, a, o), m = he;
      const de = this.transformCSS(e, `${ne}${Ie}`, "light", "variable", b, a, o), We = this.transformCSS(e, `${xe}`, "dark", "variable", b, a, o);
      I = `${de}${We}`, S = [.../* @__PURE__ */ new Set([...te, ...Ee, ...Qe])];
      const Q = this.transformCSS(e, `${Ke}${rt}color-scheme:light`, "light", "variable", b, a, o), ie = this.transformCSS(e, `${F}color-scheme:dark`, "dark", "variable", b, a, o);
      f = `${Q}${ie}`, v = [.../* @__PURE__ */ new Set([...qe, ...P, ...me])], w = ga(g.css, { dt: Wl });
    }
    return {
      primitive: {
        css: E,
        tokens: m
      },
      semantic: {
        css: I,
        tokens: S
      },
      global: {
        css: f,
        tokens: v
      },
      style: w
    };
  },
  getPreset({ name: e = "", preset: t = {}, options: n, params: a, set: o, defaults: l, selector: s }) {
    var i, u, c;
    let p, h, g;
    if (At(t) && n.transform !== "strict") {
      const b = e.replace("-directive", ""), E = t, { colorScheme: m, extend: I, css: S } = E, f = xa(E, ["colorScheme", "extend", "css"]), v = I || {}, { colorScheme: w } = v, A = xa(v, ["colorScheme"]), T = m || {}, { dark: O } = T, C = xa(T, ["dark"]), k = w || {}, { dark: M } = k, z = xa(k, ["dark"]), j = At(f) ? this._toVariables({ [b]: pa(pa({}, f), A) }, n) : {}, K = At(C) ? this._toVariables({ [b]: pa(pa({}, C), z) }, n) : {}, x = At(O) ? this._toVariables({ [b]: pa(pa({}, O), M) }, n) : {}, [N, G] = [(i = j.declarations) != null ? i : "", j.tokens || []], [ce, re] = [(u = K.declarations) != null ? u : "", K.tokens || []], [Se, se] = [(c = x.declarations) != null ? c : "", x.tokens || []], Le = this.transformCSS(b, `${N}${ce}`, "light", "variable", n, o, l, s), Y = this.transformCSS(b, Se, "dark", "variable", n, o, l, s);
      p = `${Le}${Y}`, h = [.../* @__PURE__ */ new Set([...G, ...re, ...se])], g = ga(S, { dt: Wl });
    }
    return {
      css: p,
      tokens: h,
      style: g
    };
  },
  getPresetC({ name: e = "", theme: t = {}, params: n, set: a, defaults: o }) {
    var l;
    const { preset: s, options: i } = t, u = (l = s == null ? void 0 : s.components) == null ? void 0 : l[e];
    return this.getPreset({ name: e, preset: u, options: i, params: n, set: a, defaults: o });
  },
  getPresetD({ name: e = "", theme: t = {}, params: n, set: a, defaults: o }) {
    var l;
    const s = e.replace("-directive", ""), { preset: i, options: u } = t, c = (l = i == null ? void 0 : i.directives) == null ? void 0 : l[s];
    return this.getPreset({ name: s, preset: c, options: u, params: n, set: a, defaults: o });
  },
  applyDarkColorScheme(e) {
    return !(e.darkModeSelector === "none" || e.darkModeSelector === !1);
  },
  getColorSchemeOption(e, t) {
    var n;
    return this.applyDarkColorScheme(e) ? this.regex.resolve(e.darkModeSelector === !0 ? t.options.darkModeSelector : (n = e.darkModeSelector) != null ? n : t.options.darkModeSelector) : [];
  },
  getLayerOrder(e, t = {}, n, a) {
    const { cssLayer: o } = t;
    return o ? `@layer ${ga(o.order || "primeui", n)}` : "";
  },
  getCommonStyleSheet({ name: e = "", theme: t = {}, params: n, props: a = {}, set: o, defaults: l }) {
    const s = this.getCommon({ name: e, theme: t, params: n, set: o, defaults: l }), i = Object.entries(a).reduce((u, [c, p]) => u.push(`${c}="${p}"`) && u, []).join(" ");
    return Object.entries(s || {}).reduce((u, [c, p]) => {
      if (p != null && p.css) {
        const h = Gl(p == null ? void 0 : p.css), g = `${c}-variables`;
        u.push(`<style type="text/css" data-primevue-style-id="${g}" ${i}>${h}</style>`);
      }
      return u;
    }, []).join("");
  },
  getStyleSheet({ name: e = "", theme: t = {}, params: n, props: a = {}, set: o, defaults: l }) {
    var s;
    const i = { name: e, theme: t, params: n, set: o, defaults: l }, u = (s = e.includes("-directive") ? this.getPresetD(i) : this.getPresetC(i)) == null ? void 0 : s.css, c = Object.entries(a).reduce((p, [h, g]) => p.push(`${h}="${g}"`) && p, []).join(" ");
    return u ? `<style type="text/css" data-primevue-style-id="${e}-variables" ${c}>${Gl(u)}</style>` : "";
  },
  createTokens(e = {}, t, n = "", a = "", o = {}) {
    return Object.entries(e).forEach(([l, s]) => {
      const i = Ba(l, t.variable.excludedKeyRegex) ? n : n ? `${n}.${Wc(l)}` : Wc(l), u = a ? `${a}.${l}` : l;
      ll(s) ? this.createTokens(s, t, i, u, o) : (o[i] || (o[i] = {
        paths: [],
        computed(c, p = {}) {
          var h, g;
          return this.paths.length === 1 ? (h = this.paths[0]) == null ? void 0 : h.computed(this.paths[0].scheme, p.binding) : c && c !== "none" ? (g = this.paths.find((b) => b.scheme === c)) == null ? void 0 : g.computed(c, p.binding) : this.paths.map((b) => b.computed(b.scheme, p[b.scheme]));
        }
      }), o[i].paths.push({
        path: u,
        value: s,
        scheme: u.includes("colorScheme.light") ? "light" : u.includes("colorScheme.dark") ? "dark" : "none",
        computed(c, p = {}) {
          const h = /{([^}]*)}/g;
          let g = s;
          if (p.name = this.path, p.binding || (p.binding = {}), Ba(s, h)) {
            const E = s.trim().replaceAll(h, (S) => {
              var f;
              const v = S.replace(/{|}/g, ""), w = (f = o[v]) == null ? void 0 : f.computed(c, p);
              return ru(w) && w.length === 2 ? `light-dark(${w[0].value},${w[1].value})` : w == null ? void 0 : w.value;
            }), m = /(\d+\w*\s+[\+\-\*\/]\s+\d+\w*)/g, I = /var\([^)]+\)/g;
            g = Ba(E.replace(I, "0"), m) ? `calc(${E})` : E;
          }
          return pi(p.binding) && delete p.binding, {
            colorScheme: c,
            path: this.path,
            paths: p,
            value: g.includes("undefined") ? void 0 : g
          };
        }
      }));
    }), o;
  },
  getTokenValue(e, t, n) {
    var a;
    const l = ((u) => u.split(".").filter((p) => !Ba(p.toLowerCase(), n.variable.excludedKeyRegex)).join("."))(t), s = t.includes("colorScheme.light") ? "light" : t.includes("colorScheme.dark") ? "dark" : void 0, i = [(a = e[l]) == null ? void 0 : a.computed(s)].flat().filter((u) => u);
    return i.length === 1 ? i[0].value : i.reduce((u = {}, c) => {
      const p = c, { colorScheme: h } = p, g = xa(p, ["colorScheme"]);
      return u[h] = g, u;
    }, void 0);
  },
  getSelectorRule(e, t, n, a) {
    return n === "class" || n === "attr" ? Yo(At(t) ? `${e}${t},${e} ${t}` : e, a) : Yo(e, At(t) ? Yo(t, a) : a);
  },
  transformCSS(e, t, n, a, o = {}, l, s, i) {
    if (At(t)) {
      const { cssLayer: u } = o;
      if (a !== "style") {
        const c = this.getColorSchemeOption(o, s);
        t = n === "dark" ? c.reduce((p, { type: h, selector: g }) => (At(g) && (p += g.includes("[CSS]") ? g.replace("[CSS]", t) : this.getSelectorRule(g, i, h, t)), p), "") : Yo(i ?? ":root", t);
      }
      if (u) {
        const c = {
          name: "primeui"
        };
        ll(u) && (c.name = ga(u.name, { name: e, type: a })), At(c.name) && (t = Yo(`@layer ${c.name}`, t), l == null || l.layerNames(c.name));
      }
      return t;
    }
    return "";
  }
}, gn = {
  defaults: {
    variable: {
      prefix: "p",
      selector: ":root",
      excludedKeyRegex: /^(primitive|semantic|components|directives|variables|colorscheme|light|dark|common|root|states|extend|css)$/gi
    },
    options: {
      prefix: "p",
      darkModeSelector: "system",
      cssLayer: !1
    }
  },
  _theme: void 0,
  _layerNames: /* @__PURE__ */ new Set(),
  _loadedStyleNames: /* @__PURE__ */ new Set(),
  _loadingStyles: /* @__PURE__ */ new Set(),
  _tokens: {},
  update(e = {}) {
    const { theme: t } = e;
    t && (this._theme = Bs(pa({}, t), {
      options: pa(pa({}, this.defaults.options), t.options)
    }), this._tokens = ca.createTokens(this.preset, this.defaults), this.clearLoadedStyleNames());
  },
  get theme() {
    return this._theme;
  },
  get preset() {
    var e;
    return ((e = this.theme) == null ? void 0 : e.preset) || {};
  },
  get options() {
    var e;
    return ((e = this.theme) == null ? void 0 : e.options) || {};
  },
  get tokens() {
    return this._tokens;
  },
  getTheme() {
    return this.theme;
  },
  setTheme(e) {
    this.update({ theme: e }), Qa.emit("theme:change", e);
  },
  getPreset() {
    return this.preset;
  },
  setPreset(e) {
    this._theme = Bs(pa({}, this.theme), { preset: e }), this._tokens = ca.createTokens(e, this.defaults), this.clearLoadedStyleNames(), Qa.emit("preset:change", e), Qa.emit("theme:change", this.theme);
  },
  getOptions() {
    return this.options;
  },
  setOptions(e) {
    this._theme = Bs(pa({}, this.theme), { options: e }), this.clearLoadedStyleNames(), Qa.emit("options:change", e), Qa.emit("theme:change", this.theme);
  },
  getLayerNames() {
    return [...this._layerNames];
  },
  setLayerNames(e) {
    this._layerNames.add(e);
  },
  getLoadedStyleNames() {
    return this._loadedStyleNames;
  },
  isStyleNameLoaded(e) {
    return this._loadedStyleNames.has(e);
  },
  setLoadedStyleName(e) {
    this._loadedStyleNames.add(e);
  },
  deleteLoadedStyleName(e) {
    this._loadedStyleNames.delete(e);
  },
  clearLoadedStyleNames() {
    this._loadedStyleNames.clear();
  },
  getTokenValue(e) {
    return ca.getTokenValue(this.tokens, e, this.defaults);
  },
  getCommon(e = "", t) {
    return ca.getCommon({ name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  getComponent(e = "", t) {
    const n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return ca.getPresetC(n);
  },
  getDirective(e = "", t) {
    const n = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return ca.getPresetD(n);
  },
  getCustomPreset(e = "", t, n, a) {
    const o = { name: e, preset: t, options: this.options, selector: n, params: a, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return ca.getPreset(o);
  },
  getLayerOrderCSS(e = "") {
    return ca.getLayerOrder(e, this.options, { names: this.getLayerNames() }, this.defaults);
  },
  transformCSS(e = "", t, n = "style", a) {
    return ca.transformCSS(e, t, a, n, this.options, { layerNames: this.setLayerNames.bind(this) }, this.defaults);
  },
  getCommonStyleSheet(e = "", t, n = {}) {
    return ca.getCommonStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  getStyleSheet(e, t, n = {}) {
    return ca.getStyleSheet({ name: e, theme: this.theme, params: t, props: n, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  onStyleMounted(e) {
    this._loadingStyles.add(e);
  },
  onStyleUpdated(e) {
    this._loadingStyles.add(e);
  },
  onStyleLoaded(e, { name: t }) {
    this._loadingStyles.size && (this._loadingStyles.delete(t), Qa.emit(`theme:${t}:load`, e), !this._loadingStyles.size && Qa.emit("theme:load"));
  }
}, Cl = {
  _loadedStyleNames: /* @__PURE__ */ new Set(),
  getLoadedStyleNames: function() {
    return this._loadedStyleNames;
  },
  isStyleNameLoaded: function(t) {
    return this._loadedStyleNames.has(t);
  },
  setLoadedStyleName: function(t) {
    this._loadedStyleNames.add(t);
  },
  deleteLoadedStyleName: function(t) {
    this._loadedStyleNames.delete(t);
  },
  clearLoadedStyleNames: function() {
    this._loadedStyleNames.clear();
  }
};
function ti(e) {
  "@babel/helpers - typeof";
  return ti = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ti(e);
}
function Yc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function Kc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Yc(Object(n), !0).forEach(function(a) {
      Sy(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Yc(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function Sy(e, t, n) {
  return (t = Ey(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ey(e) {
  var t = Ty(e, "string");
  return ti(t) == "symbol" ? t : t + "";
}
function Ty(e, t) {
  if (ti(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (ti(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Cy(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  ns() ? Dt(e) : t ? e() : mn(e);
}
var Ny = 0;
function Ly(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = B(!1), a = B(e), o = B(null), l = Yp() ? window.document : void 0, s = t.document, i = s === void 0 ? l : s, u = t.immediate, c = u === void 0 ? !0 : u, p = t.manual, h = p === void 0 ? !1 : p, g = t.name, b = g === void 0 ? "style_".concat(++Ny) : g, E = t.id, m = E === void 0 ? void 0 : E, I = t.media, S = I === void 0 ? void 0 : I, f = t.nonce, v = f === void 0 ? void 0 : f, w = t.first, A = w === void 0 ? !1 : w, T = t.onMounted, O = T === void 0 ? void 0 : T, C = t.onUpdated, k = C === void 0 ? void 0 : C, M = t.onLoad, z = M === void 0 ? void 0 : M, j = t.props, K = j === void 0 ? {} : j, x = function() {
  }, N = function(re) {
    var Se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (i) {
      var se = Kc(Kc({}, K), Se), Le = se.name || b, Y = se.id || m, pe = se.nonce || v;
      o.value = i.querySelector('style[data-primevue-style-id="'.concat(Le, '"]')) || i.getElementById(Y) || i.createElement("style"), o.value.isConnected || (a.value = re || e, _r(o.value, {
        type: "text/css",
        id: Y,
        media: S,
        nonce: pe
      }), A ? i.head.prepend(o.value) : i.head.appendChild(o.value), sy(o.value, "data-primevue-style-id", Le), _r(o.value, se), o.value.onload = function(fe) {
        return z == null ? void 0 : z(fe, {
          name: Le
        });
      }, O == null || O(Le)), !n.value && (x = lt(a, function(fe) {
        o.value.textContent = fe, k == null || k(Le);
      }, {
        immediate: !0
      }), n.value = !0);
    }
  }, G = function() {
    !i || !n.value || (x(), oy(o.value) && i.head.removeChild(o.value), n.value = !1);
  };
  return c && !h && Cy(N), {
    id: m,
    name: b,
    el: o,
    css: a,
    unload: G,
    load: N,
    isLoaded: _g(n)
  };
}
function ni(e) {
  "@babel/helpers - typeof";
  return ni = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ni(e);
}
function Zc(e, t) {
  return Ry(e) || Ay(e, t) || Dy(e, t) || Oy();
}
function Oy() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Dy(e, t) {
  if (e) {
    if (typeof e == "string") return Xc(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Xc(e, t) : void 0;
  }
}
function Xc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = Array(t); n < t; n++) a[n] = e[n];
  return a;
}
function Ay(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var a, o, l, s, i = [], u = !0, c = !1;
    try {
      if (l = (n = n.call(e)).next, t !== 0) for (; !(u = (a = l.call(n)).done) && (i.push(a.value), i.length !== t); u = !0) ;
    } catch (p) {
      c = !0, o = p;
    } finally {
      try {
        if (!u && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw o;
      }
    }
    return i;
  }
}
function Ry(e) {
  if (Array.isArray(e)) return e;
}
function Jc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function Us(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Jc(Object(n), !0).forEach(function(a) {
      My(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jc(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function My(e, t, n) {
  return (t = Py(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Py(e) {
  var t = xy(e, "string");
  return ni(t) == "symbol" ? t : t + "";
}
function xy(e, t) {
  if (ni(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (ni(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var jy = function(t) {
  var n = t.dt;
  return `
*,
::before,
::after {
    box-sizing: border-box;
}

/* Non vue overlay animations */
.p-connected-overlay {
    opacity: 0;
    transform: scaleY(0.8);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1),
        opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
}

.p-connected-overlay-visible {
    opacity: 1;
    transform: scaleY(1);
}

.p-connected-overlay-hidden {
    opacity: 0;
    transform: scaleY(1);
    transition: opacity 0.1s linear;
}

/* Vue based overlay animations */
.p-connected-overlay-enter-from {
    opacity: 0;
    transform: scaleY(0.8);
}

.p-connected-overlay-leave-to {
    opacity: 0;
}

.p-connected-overlay-enter-active {
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1),
        opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
}

.p-connected-overlay-leave-active {
    transition: opacity 0.1s linear;
}

/* Toggleable Content */
.p-toggleable-content-enter-from,
.p-toggleable-content-leave-to {
    max-height: 0;
}

.p-toggleable-content-enter-to,
.p-toggleable-content-leave-from {
    max-height: 1000px;
}

.p-toggleable-content-leave-active {
    overflow: hidden;
    transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);
}

.p-toggleable-content-enter-active {
    overflow: hidden;
    transition: max-height 1s ease-in-out;
}

.p-disabled,
.p-disabled * {
    cursor: default;
    pointer-events: none;
    user-select: none;
}

.p-disabled,
.p-component:disabled {
    opacity: `.concat(n("disabled.opacity"), `;
}

.pi {
    font-size: `).concat(n("icon.size"), `;
}

.p-icon {
    width: `).concat(n("icon.size"), `;
    height: `).concat(n("icon.size"), `;
}

.p-overlay-mask {
    background: `).concat(n("mask.background"), `;
    color: `).concat(n("mask.color"), `;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.p-overlay-mask-enter {
    animation: p-overlay-mask-enter-animation `).concat(n("mask.transition.duration"), ` forwards;
}

.p-overlay-mask-leave {
    animation: p-overlay-mask-leave-animation `).concat(n("mask.transition.duration"), ` forwards;
}

@keyframes p-overlay-mask-enter-animation {
    from {
        background: transparent;
    }
    to {
        background: `).concat(n("mask.background"), `;
    }
}
@keyframes p-overlay-mask-leave-animation {
    from {
        background: `).concat(n("mask.background"), `;
    }
    to {
        background: transparent;
    }
}
`);
}, $y = function(t) {
  var n = t.dt;
  return `
.p-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

.p-hidden-accessible input,
.p-hidden-accessible select {
    transform: scale(0);
}

.p-overflow-hidden {
    overflow: hidden;
    padding-right: `.concat(n("scrollbar.width"), `;
}
`);
}, Fy = {}, ky = {}, ja = {
  name: "base",
  css: $y,
  theme: jy,
  classes: Fy,
  inlineStyles: ky,
  load: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(l) {
      return l;
    }, o = a(ga(t, {
      dt: Wl
    }));
    return At(o) ? Ly(Gl(o), Us({
      name: this.name
    }, n)) : {};
  },
  loadCSS: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.load(this.css, t);
  },
  loadTheme: function() {
    var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return this.load(this.theme, n, function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return gn.transformCSS(n.name || t.name, "".concat(o).concat(a));
    });
  },
  getCommonTheme: function(t) {
    return gn.getCommon(this.name, t);
  },
  getComponentTheme: function(t) {
    return gn.getComponent(this.name, t);
  },
  getDirectiveTheme: function(t) {
    return gn.getDirective(this.name, t);
  },
  getPresetTheme: function(t, n, a) {
    return gn.getCustomPreset(this.name, t, n, a);
  },
  getLayerOrderThemeCSS: function() {
    return gn.getLayerOrderCSS(this.name);
  },
  getStyleSheet: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.css) {
      var a = ga(this.css, {
        dt: Wl
      }) || "", o = Gl("".concat(a).concat(t)), l = Object.entries(n).reduce(function(s, i) {
        var u = Zc(i, 2), c = u[0], p = u[1];
        return s.push("".concat(c, '="').concat(p, '"')) && s;
      }, []).join(" ");
      return At(o) ? '<style type="text/css" data-primevue-style-id="'.concat(this.name, '" ').concat(l, ">").concat(o, "</style>") : "";
    }
    return "";
  },
  getCommonThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return gn.getCommonStyleSheet(this.name, t, n);
  },
  getThemeStyleSheet: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = [gn.getStyleSheet(this.name, t, n)];
    if (this.theme) {
      var o = this.name === "base" ? "global-style" : "".concat(this.name, "-style"), l = ga(this.theme, {
        dt: Wl
      }), s = Gl(gn.transformCSS(o, l)), i = Object.entries(n).reduce(function(u, c) {
        var p = Zc(c, 2), h = p[0], g = p[1];
        return u.push("".concat(h, '="').concat(g, '"')) && u;
      }, []).join(" ");
      At(s) && a.push('<style type="text/css" data-primevue-style-id="'.concat(o, '" ').concat(i, ">").concat(s, "</style>"));
    }
    return a.join("");
  },
  extend: function(t) {
    return Us(Us({}, this), {}, {
      css: void 0,
      theme: void 0
    }, t);
  }
}, qc = ja.extend({
  name: "common"
});
function ai(e) {
  "@babel/helpers - typeof";
  return ai = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ai(e);
}
function Vy(e) {
  return am(e) || By(e) || nm(e) || tm();
}
function By(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Nl(e, t) {
  return am(e) || Uy(e, t) || nm(e, t) || tm();
}
function tm() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nm(e, t) {
  if (e) {
    if (typeof e == "string") return Qc(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Qc(e, t) : void 0;
  }
}
function Qc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = Array(t); n < t; n++) a[n] = e[n];
  return a;
}
function Uy(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var a, o, l, s, i = [], u = !0, c = !1;
    try {
      if (l = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        u = !1;
      } else for (; !(u = (a = l.call(n)).done) && (i.push(a.value), i.length !== t); u = !0) ;
    } catch (p) {
      c = !0, o = p;
    } finally {
      try {
        if (!u && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw o;
      }
    }
    return i;
  }
}
function am(e) {
  if (Array.isArray(e)) return e;
}
function ed(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function Ct(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ed(Object(n), !0).forEach(function(a) {
      Pl(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ed(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function Pl(e, t, n) {
  return (t = Gy(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Gy(e) {
  var t = Wy(e, "string");
  return ai(t) == "symbol" ? t : t + "";
}
function Wy(e, t) {
  if (ai(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (ai(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ka = {
  name: "BaseComponent",
  props: {
    pt: {
      type: Object,
      default: void 0
    },
    ptOptions: {
      type: Object,
      default: void 0
    },
    unstyled: {
      type: Boolean,
      default: void 0
    },
    dt: {
      type: Object,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    }
  },
  watch: {
    isUnstyled: {
      immediate: !0,
      handler: function(t) {
        t || (this._loadCoreStyles(), this._themeChangeListener(this._loadCoreStyles));
      }
    },
    dt: {
      immediate: !0,
      handler: function(t) {
        var n = this;
        t ? (this._loadScopedThemeStyles(t), this._themeChangeListener(function() {
          return n._loadScopedThemeStyles(t);
        })) : this._unloadScopedThemeStyles();
      }
    }
  },
  scopedStyleEl: void 0,
  rootEl: void 0,
  $attrSelector: void 0,
  beforeCreate: function() {
    var t, n, a, o, l, s, i, u, c, p, h, g = (t = this.pt) === null || t === void 0 ? void 0 : t._usept, b = g ? (n = this.pt) === null || n === void 0 || (n = n.originalValue) === null || n === void 0 ? void 0 : n[this.$.type.name] : void 0, E = g ? (a = this.pt) === null || a === void 0 || (a = a.value) === null || a === void 0 ? void 0 : a[this.$.type.name] : this.pt;
    (o = E || b) === null || o === void 0 || (o = o.hooks) === null || o === void 0 || (l = o.onBeforeCreate) === null || l === void 0 || l.call(o);
    var m = (s = this.$primevueConfig) === null || s === void 0 || (s = s.pt) === null || s === void 0 ? void 0 : s._usept, I = m ? (i = this.$primevue) === null || i === void 0 || (i = i.config) === null || i === void 0 || (i = i.pt) === null || i === void 0 ? void 0 : i.originalValue : void 0, S = m ? (u = this.$primevue) === null || u === void 0 || (u = u.config) === null || u === void 0 || (u = u.pt) === null || u === void 0 ? void 0 : u.value : (c = this.$primevue) === null || c === void 0 || (c = c.config) === null || c === void 0 ? void 0 : c.pt;
    (p = S || I) === null || p === void 0 || (p = p[this.$.type.name]) === null || p === void 0 || (p = p.hooks) === null || p === void 0 || (h = p.onBeforeCreate) === null || h === void 0 || h.call(p), this.$attrSelector = Xp("pc");
  },
  created: function() {
    this._hook("onCreated");
  },
  beforeMount: function() {
    this.rootEl = iu(this.$el, '[data-pc-name="'.concat(eo(this.$.type.name), '"]')), this.rootEl && (this.$attrSelector && !this.rootEl.hasAttribute(this.$attrSelector) && this.rootEl.setAttribute(this.$attrSelector, ""), this.rootEl.$pc = Ct({
      name: this.$.type.name,
      attrSelector: this.$attrSelector
    }, this.$params)), this._loadStyles(), this._hook("onBeforeMount");
  },
  mounted: function() {
    this._hook("onMounted");
  },
  beforeUpdate: function() {
    this._hook("onBeforeUpdate");
  },
  updated: function() {
    this._hook("onUpdated");
  },
  beforeUnmount: function() {
    this._hook("onBeforeUnmount");
  },
  unmounted: function() {
    this._unloadScopedThemeStyles(), this._hook("onUnmounted");
  },
  methods: {
    _hook: function(t) {
      if (!this.$options.hostName) {
        var n = this._usePT(this._getPT(this.pt, this.$.type.name), this._getOptionValue, "hooks.".concat(t)), a = this._useDefaultPT(this._getOptionValue, "hooks.".concat(t));
        n == null || n(), a == null || a();
      }
    },
    _mergeProps: function(t) {
      for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
        a[o - 1] = arguments[o];
      return su(t) ? t.apply(void 0, a) : je.apply(void 0, a);
    },
    _loadStyles: function() {
      var t = this, n = function() {
        Cl.isStyleNameLoaded("base") || (ja.loadCSS(t.$styleOptions), t._loadGlobalStyles(), Cl.setLoadedStyleName("base")), t._loadThemeStyles();
      };
      n(), this._themeChangeListener(n);
    },
    _loadCoreStyles: function() {
      var t, n;
      !Cl.isStyleNameLoaded((t = this.$style) === null || t === void 0 ? void 0 : t.name) && (n = this.$style) !== null && n !== void 0 && n.name && (qc.loadCSS(this.$styleOptions), this.$options.style && this.$style.loadCSS(this.$styleOptions), Cl.setLoadedStyleName(this.$style.name));
    },
    _loadGlobalStyles: function() {
      var t = this._useGlobalPT(this._getOptionValue, "global.css", this.$params);
      At(t) && ja.load(t, Ct({
        name: "global"
      }, this.$styleOptions));
    },
    _loadThemeStyles: function() {
      var t, n;
      if (!(this.isUnstyled || this.$theme === "none")) {
        if (!gn.isStyleNameLoaded("common")) {
          var a, o, l = ((a = this.$style) === null || a === void 0 || (o = a.getCommonTheme) === null || o === void 0 ? void 0 : o.call(a)) || {}, s = l.primitive, i = l.semantic, u = l.global, c = l.style;
          ja.load(s == null ? void 0 : s.css, Ct({
            name: "primitive-variables"
          }, this.$styleOptions)), ja.load(i == null ? void 0 : i.css, Ct({
            name: "semantic-variables"
          }, this.$styleOptions)), ja.load(u == null ? void 0 : u.css, Ct({
            name: "global-variables"
          }, this.$styleOptions)), ja.loadTheme(Ct({
            name: "global-style"
          }, this.$styleOptions), c), gn.setLoadedStyleName("common");
        }
        if (!gn.isStyleNameLoaded((t = this.$style) === null || t === void 0 ? void 0 : t.name) && (n = this.$style) !== null && n !== void 0 && n.name) {
          var p, h, g, b, E = ((p = this.$style) === null || p === void 0 || (h = p.getComponentTheme) === null || h === void 0 ? void 0 : h.call(p)) || {}, m = E.css, I = E.style;
          (g = this.$style) === null || g === void 0 || g.load(m, Ct({
            name: "".concat(this.$style.name, "-variables")
          }, this.$styleOptions)), (b = this.$style) === null || b === void 0 || b.loadTheme(Ct({
            name: "".concat(this.$style.name, "-style")
          }, this.$styleOptions), I), gn.setLoadedStyleName(this.$style.name);
        }
        if (!gn.isStyleNameLoaded("layer-order")) {
          var S, f, v = (S = this.$style) === null || S === void 0 || (f = S.getLayerOrderThemeCSS) === null || f === void 0 ? void 0 : f.call(S);
          ja.load(v, Ct({
            name: "layer-order",
            first: !0
          }, this.$styleOptions)), gn.setLoadedStyleName("layer-order");
        }
      }
    },
    _loadScopedThemeStyles: function(t) {
      var n, a, o, l = ((n = this.$style) === null || n === void 0 || (a = n.getPresetTheme) === null || a === void 0 ? void 0 : a.call(n, t, "[".concat(this.$attrSelector, "]"))) || {}, s = l.css, i = (o = this.$style) === null || o === void 0 ? void 0 : o.load(s, Ct({
        name: "".concat(this.$attrSelector, "-").concat(this.$style.name)
      }, this.$styleOptions));
      this.scopedStyleEl = i.el;
    },
    _unloadScopedThemeStyles: function() {
      var t;
      (t = this.scopedStyleEl) === null || t === void 0 || (t = t.value) === null || t === void 0 || t.remove();
    },
    _themeChangeListener: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
      };
      Cl.clearLoadedStyleNames(), Qa.on("theme:change", t);
    },
    _getHostInstance: function(t) {
      return t ? this.$options.hostName ? t.$.type.name === this.$options.hostName ? t : this._getHostInstance(t.$parentInstance) : t.$parentInstance : void 0;
    },
    _getPropValue: function(t) {
      var n;
      return this[t] || ((n = this._getHostInstance(this)) === null || n === void 0 ? void 0 : n[t]);
    },
    _getOptionValue: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return Kp(t, n, a);
    },
    _getPTValue: function() {
      var t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, s = /./g.test(a) && !!o[a.split(".")[0]], i = this._getPropValue("ptOptions") || ((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.ptOptions) || {}, u = i.mergeSections, c = u === void 0 ? !0 : u, p = i.mergeProps, h = p === void 0 ? !1 : p, g = l ? s ? this._useGlobalPT(this._getPTClassValue, a, o) : this._useDefaultPT(this._getPTClassValue, a, o) : void 0, b = s ? void 0 : this._getPTSelf(n, this._getPTClassValue, a, Ct(Ct({}, o), {}, {
        global: g || {}
      })), E = this._getPTDatasets(a);
      return c || !c && b ? h ? this._mergeProps(h, g, b, E) : Ct(Ct(Ct({}, g), b), E) : Ct(Ct({}, b), E);
    },
    _getPTSelf: function() {
      for (var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
        a[o - 1] = arguments[o];
      return je(
        this._usePT.apply(this, [this._getPT(t, this.$name)].concat(a)),
        // Exp; <component :pt="{}"
        this._usePT.apply(this, [this.$_attrsPT].concat(a))
        // Exp; <component :pt:[passthrough_key]:[attribute]="{value}" or <component :pt:[passthrough_key]="() =>{value}"
      );
    },
    _getPTDatasets: function() {
      var t, n, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", o = "data-pc-", l = a === "root" && At((t = this.pt) === null || t === void 0 ? void 0 : t["data-pc-section"]);
      return a !== "transition" && Ct(Ct({}, a === "root" && Ct(Ct(Pl({}, "".concat(o, "name"), eo(l ? (n = this.pt) === null || n === void 0 ? void 0 : n["data-pc-section"] : this.$.type.name)), l && Pl({}, "".concat(o, "extend"), eo(this.$.type.name))), Yp() && Pl({}, "".concat(this.$attrSelector), ""))), {}, Pl({}, "".concat(o, "section"), eo(a)));
    },
    _getPTClassValue: function() {
      var t = this._getOptionValue.apply(this, arguments);
      return Ca(t) || ru(t) ? {
        class: t
      } : t;
    },
    _getPT: function(t) {
      var n = this, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 ? arguments[2] : void 0, l = function(i) {
        var u, c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, p = o ? o(i) : i, h = eo(a), g = eo(n.$name);
        return (u = c ? h !== g ? p == null ? void 0 : p[h] : void 0 : p == null ? void 0 : p[h]) !== null && u !== void 0 ? u : p;
      };
      return t != null && t.hasOwnProperty("_usept") ? {
        _usept: t._usept,
        originalValue: l(t.originalValue),
        value: l(t.value)
      } : l(t, !0);
    },
    _usePT: function(t, n, a, o) {
      var l = function(m) {
        return n(m, a, o);
      };
      if (t != null && t.hasOwnProperty("_usept")) {
        var s, i = t._usept || ((s = this.$primevueConfig) === null || s === void 0 ? void 0 : s.ptOptions) || {}, u = i.mergeSections, c = u === void 0 ? !0 : u, p = i.mergeProps, h = p === void 0 ? !1 : p, g = l(t.originalValue), b = l(t.value);
        return g === void 0 && b === void 0 ? void 0 : Ca(b) ? b : Ca(g) ? g : c || !c && b ? h ? this._mergeProps(h, g, b) : Ct(Ct({}, g), b) : b;
      }
      return l(t);
    },
    _useGlobalPT: function(t, n, a) {
      return this._usePT(this.globalPT, t, n, a);
    },
    _useDefaultPT: function(t, n, a) {
      return this._usePT(this.defaultPT, t, n, a);
    },
    ptm: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this._getPTValue(this.pt, t, Ct(Ct({}, this.$params), n));
    },
    ptmi: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return je(this.$_attrsWithoutPT, this.ptm(t, n));
    },
    ptmo: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this._getPTValue(t, n, Ct({
        instance: this
      }, a), !1);
    },
    cx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.isUnstyled ? void 0 : this._getOptionValue(this.$style.classes, t, Ct(Ct({}, this.$params), n));
    },
    sx: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (n) {
        var o = this._getOptionValue(this.$style.inlineStyles, t, Ct(Ct({}, this.$params), a)), l = this._getOptionValue(qc.inlineStyles, t, Ct(Ct({}, this.$params), a));
        return [l, o];
      }
    }
  },
  computed: {
    globalPT: function() {
      var t, n = this;
      return this._getPT((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.pt, void 0, function(a) {
        return ga(a, {
          instance: n
        });
      });
    },
    defaultPT: function() {
      var t, n = this;
      return this._getPT((t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.pt, void 0, function(a) {
        return n._getOptionValue(a, n.$name, Ct({}, n.$params)) || ga(a, Ct({}, n.$params));
      });
    },
    isUnstyled: function() {
      var t;
      return this.unstyled !== void 0 ? this.unstyled : (t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.unstyled;
    },
    $inProps: function() {
      var t, n = Object.keys(((t = this.$.vnode) === null || t === void 0 ? void 0 : t.props) || {});
      return Object.fromEntries(Object.entries(this.$props).filter(function(a) {
        var o = Nl(a, 1), l = o[0];
        return n == null ? void 0 : n.includes(l);
      }));
    },
    $theme: function() {
      var t;
      return (t = this.$primevueConfig) === null || t === void 0 ? void 0 : t.theme;
    },
    $style: function() {
      return Ct(Ct({
        classes: void 0,
        inlineStyles: void 0,
        load: function() {
        },
        loadCSS: function() {
        },
        loadTheme: function() {
        }
      }, (this._getHostInstance(this) || {}).$style), this.$options.style);
    },
    $styleOptions: function() {
      var t;
      return {
        nonce: (t = this.$primevueConfig) === null || t === void 0 || (t = t.csp) === null || t === void 0 ? void 0 : t.nonce
      };
    },
    $primevueConfig: function() {
      var t;
      return (t = this.$primevue) === null || t === void 0 ? void 0 : t.config;
    },
    $name: function() {
      return this.$options.hostName || this.$.type.name;
    },
    $params: function() {
      var t = this._getHostInstance(this) || this.$parent;
      return {
        instance: this,
        props: this.$props,
        state: this.$data,
        attrs: this.$attrs,
        parent: {
          instance: t,
          props: t == null ? void 0 : t.$props,
          state: t == null ? void 0 : t.$data,
          attrs: t == null ? void 0 : t.$attrs
        }
      };
    },
    $_attrsPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(t) {
        var n = Nl(t, 1), a = n[0];
        return a == null ? void 0 : a.startsWith("pt:");
      }).reduce(function(t, n) {
        var a = Nl(n, 2), o = a[0], l = a[1], s = o.split(":"), i = Vy(s), u = i.slice(1);
        return u == null || u.reduce(function(c, p, h, g) {
          return !c[p] && (c[p] = h === g.length - 1 ? l : {}), c[p];
        }, t), t;
      }, {});
    },
    $_attrsWithoutPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(t) {
        var n = Nl(t, 1), a = n[0];
        return !(a != null && a.startsWith("pt:"));
      }).reduce(function(t, n) {
        var a = Nl(n, 2), o = a[0], l = a[1];
        return t[o] = l, t;
      }, {});
    }
  }
}, uu = {
  name: "BaseEditableHolder",
  extends: Ka,
  emits: ["update:modelValue", "value-change"],
  props: {
    modelValue: {
      type: null,
      default: void 0
    },
    defaultValue: {
      type: null,
      default: void 0
    },
    name: {
      type: String,
      default: void 0
    },
    invalid: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    formControl: {
      type: Object,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    },
    $pcForm: {
      default: void 0
    },
    $pcFormField: {
      default: void 0
    }
  },
  data: function() {
    return {
      d_value: this.defaultValue || this.modelValue
    };
  },
  watch: {
    modelValue: function(t) {
      this.d_value = t;
    },
    defaultValue: function(t) {
      this.d_value = t;
    },
    $formName: {
      immediate: !0,
      handler: function(t) {
        var n, a;
        this.formField = ((n = this.$pcForm) === null || n === void 0 || (a = n.register) === null || a === void 0 ? void 0 : a.call(n, t, this.$formControl)) || {};
      }
    },
    $formControl: {
      immediate: !0,
      handler: function(t) {
        var n, a;
        this.formField = ((n = this.$pcForm) === null || n === void 0 || (a = n.register) === null || a === void 0 ? void 0 : a.call(n, this.$formName, t)) || {};
      }
    },
    $formDefaultValue: {
      immediate: !0,
      handler: function(t) {
        this.d_value !== t && (this.d_value = t);
      }
    }
  },
  formField: {},
  methods: {
    writeValue: function(t, n) {
      var a, o;
      this.controlled && (this.d_value = t, this.$emit("update:modelValue", t)), this.$emit("value-change", t), (a = (o = this.formField).onChange) === null || a === void 0 || a.call(o, {
        originalEvent: n,
        value: t
      });
    }
  },
  computed: {
    $filled: function() {
      return At(this.d_value);
    },
    $invalid: function() {
      var t, n, a, o;
      return (t = (n = this.invalid) !== null && n !== void 0 ? n : (a = this.$pcFormField) === null || a === void 0 || (a = a.$field) === null || a === void 0 ? void 0 : a.invalid) !== null && t !== void 0 ? t : (o = this.$pcForm) === null || o === void 0 || (o = o.states) === null || o === void 0 || (o = o[this.$formName]) === null || o === void 0 ? void 0 : o.invalid;
    },
    $formName: function() {
      var t;
      return this.name || ((t = this.$formControl) === null || t === void 0 ? void 0 : t.name);
    },
    $formControl: function() {
      var t;
      return this.formControl || ((t = this.$pcFormField) === null || t === void 0 ? void 0 : t.formControl);
    },
    $formDefaultValue: function() {
      var t, n, a, o;
      return (t = (n = this.d_value) !== null && n !== void 0 ? n : (a = this.$pcFormField) === null || a === void 0 ? void 0 : a.initialValue) !== null && t !== void 0 ? t : (o = this.$pcForm) === null || o === void 0 || (o = o.initialValues) === null || o === void 0 ? void 0 : o[this.$formName];
    },
    controlled: function() {
      return this.$inProps.hasOwnProperty("modelValue") || !this.$inProps.hasOwnProperty("modelValue") && !this.$inProps.hasOwnProperty("defaultValue");
    },
    // @deprecated use $filled instead
    filled: function() {
      return this.$filled;
    }
  }
};
const zy = {
  name: "BaseSlider",
  extends: uu,
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    orientation: {
      type: String,
      default: "horizontal"
    },
    step: {
      type: Number,
      default: null
    },
    range: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: 0
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: Ug,
  provide() {
    return {
      $pcSlider: this,
      $parentInstance: this
    };
  }
}, Vt = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, o] of t)
    n[a] = o;
  return n;
}, Hy = {
  name: "Slider",
  extends: zy,
  inheritAttrs: !1,
  emits: ["change", "slideend"],
  dragging: !1,
  handleIndex: null,
  initX: null,
  initY: null,
  barWidth: null,
  barHeight: null,
  dragListener: null,
  dragEndListener: null,
  beforeUnmount() {
    this.unbindDragListeners();
  },
  methods: {
    updateDomData() {
      let e = this.$el.getBoundingClientRect();
      this.initX = e.left + Qv(), this.initY = e.top + ey(), this.barWidth = this.$el.offsetWidth, this.barHeight = this.$el.offsetHeight;
    },
    setValue(e) {
      let t, n = e.touches ? e.touches[0].pageX : e.pageX, a = e.touches ? e.touches[0].pageY : e.pageY;
      this.orientation === "horizontal" ? iy(this.$el) ? t = (this.initX + this.barWidth - n) * 100 / this.barWidth : t = (n - this.initX) * 100 / this.barWidth : t = (this.initY + this.barHeight - a) * 100 / this.barHeight;
      let o = (this.max - this.min) * (t / 100) + this.min;
      if (this.step) {
        const l = this.range ? this.value[this.handleIndex] : this.value, s = o - l;
        s < 0 ? o = l + Math.ceil(o / this.step - l / this.step) * this.step : s > 0 && (o = l + Math.floor(o / this.step - l / this.step) * this.step);
      } else
        o = Math.floor(o);
      this.updateModel(e, o);
    },
    updateModel(e, t) {
      let n = parseFloat(t.toFixed(10)), a;
      this.range ? (a = this.value ? [...this.value] : [], this.handleIndex == 0 ? (n < this.min ? n = this.min : n >= this.max && (n = this.max), a[0] = n) : (n > this.max ? n = this.max : n <= this.min && (n = this.min), a[1] = n)) : (n < this.min ? n = this.min : n > this.max && (n = this.max), a = n), this.writeValue(a, e), this.$emit("change", a);
    },
    onDragStart(e, t) {
      this.disabled || (this.$el.setAttribute("data-p-sliding", !0), this.dragging = !0, this.updateDomData(), this.range && this.value[0] === this.max ? this.handleIndex = 0 : this.handleIndex = t, e.currentTarget.focus());
    },
    onDrag(e) {
      this.dragging && this.setValue(e);
    },
    onDragEnd(e) {
      this.dragging && (this.dragging = !1, this.$el.setAttribute("data-p-sliding", !1), this.$emit("slideend", { originalEvent: e, value: this.value }));
    },
    onBarClick(e) {
      this.disabled || Hp(e.target, "data-pc-section") !== "handle" && (this.updateDomData(), this.setValue(e));
    },
    onMouseDown(e, t) {
      this.bindDragListeners(), this.onDragStart(e, t);
    },
    onKeyDown(e, t) {
      switch (this.handleIndex = t, e.code) {
        case "ArrowDown":
        case "ArrowLeft":
          this.decrementValue(e, t), e.preventDefault();
          break;
        case "ArrowUp":
        case "ArrowRight":
          this.incrementValue(e, t), e.preventDefault();
          break;
        case "PageDown":
          this.decrementValue(e, t, !0), e.preventDefault();
          break;
        case "PageUp":
          this.incrementValue(e, t, !0), e.preventDefault();
          break;
        case "Home":
          this.updateModel(e, this.min), e.preventDefault();
          break;
        case "End":
          this.updateModel(e, this.max), e.preventDefault();
          break;
      }
    },
    onBlur(e, t) {
      var n, a;
      (a = (n = this.formField).onBlur) == null || a.call(n, e);
    },
    decrementValue(e, t, n = !1) {
      let a;
      this.range ? this.step ? a = this.value[t] - this.step : a = this.value[t] - 1 : this.step ? a = this.value - this.step : !this.step && n ? a = this.value - 10 : a = this.value - 1, this.updateModel(e, a), e.preventDefault();
    },
    incrementValue(e, t, n = !1) {
      let a;
      this.range ? this.step ? a = this.value[t] + this.step : a = this.value[t] + 1 : this.step ? a = this.value + this.step : !this.step && n ? a = this.value + 10 : a = this.value + 1, this.updateModel(e, a), e.preventDefault();
    },
    bindDragListeners() {
      this.dragListener || (this.dragListener = this.onDrag.bind(this), document.addEventListener("mousemove", this.dragListener)), this.dragEndListener || (this.dragEndListener = this.onDragEnd.bind(this), document.addEventListener("mouseup", this.dragEndListener));
    },
    unbindDragListeners() {
      this.dragListener && (document.removeEventListener("mousemove", this.dragListener), this.dragListener = null), this.dragEndListener && (document.removeEventListener("mouseup", this.dragEndListener), this.dragEndListener = null);
    },
    rangeStyle() {
      if (this.range) {
        const e = this.rangeEndPosition > this.rangeStartPosition ? this.rangeEndPosition - this.rangeStartPosition : this.rangeStartPosition - this.rangeEndPosition, t = this.rangeEndPosition > this.rangeStartPosition ? this.rangeStartPosition : this.rangeEndPosition;
        return this.horizontal ? { "inset-inline-start": t + "%", width: e + "%" } : { bottom: t + "%", height: e + "%" };
      } else
        return this.horizontal ? { width: this.handlePosition + "%" } : { height: this.handlePosition + "%" };
    },
    handleStyle() {
      return this.horizontal ? { "inset-inline-start": this.handlePosition + "%" } : { bottom: this.handlePosition + "%" };
    },
    rangeStartHandleStyle() {
      return this.horizontal ? { "inset-inline-start": this.rangeStartPosition + "%" } : { bottom: this.rangeStartPosition + "%" };
    },
    rangeEndHandleStyle() {
      return this.horizontal ? { "inset-inline-start": this.rangeEndPosition + "%" } : { bottom: this.rangeEndPosition + "%" };
    }
  },
  computed: {
    value() {
      var e, t;
      return this.range ? [((e = this.d_value) == null ? void 0 : e[0]) ?? this.min, ((t = this.d_value) == null ? void 0 : t[1]) ?? this.max] : this.d_value ?? this.min;
    },
    horizontal() {
      return this.orientation === "horizontal";
    },
    vertical() {
      return this.orientation === "vertical";
    },
    handlePosition() {
      return this.value < this.min ? 0 : this.value > this.max ? 100 : (this.value - this.min) * 100 / (this.max - this.min);
    },
    rangeStartPosition() {
      return this.value && this.value[0] !== void 0 ? this.value[0] < this.min ? 0 : (this.value[0] - this.min) * 100 / (this.max - this.min) : 0;
    },
    rangeEndPosition() {
      return this.value && this.value.length === 2 && this.value[1] !== void 0 ? this.value[1] > this.max ? 100 : (this.value[1] - this.min) * 100 / (this.max - this.min) : 100;
    }
  }
}, Yy = ["tabindex", "aria-valuemin", "aria-valuenow", "aria-valuemax", "aria-labelledby", "aria-label", "aria-orientation"], Ky = ["tabindex", "aria-valuemin", "aria-valuenow", "aria-valuemax", "aria-labelledby", "aria-label", "aria-orientation"], Zy = ["tabindex", "aria-valuemin", "aria-valuenow", "aria-valuemax", "aria-labelledby", "aria-label", "aria-orientation"];
function Xy(e, t, n, a, o, l) {
  return L(), H("div", je({
    class: e.cx("root"),
    onClick: t[18] || (t[18] = (...s) => l.onBarClick && l.onBarClick(...s))
  }, e.ptmi("root"), { "data-p-sliding": !1 }), [
    y("span", je({
      class: e.cx("range"),
      style: [e.sx("range"), l.rangeStyle()]
    }, e.ptm("range")), null, 16),
    e.range ? ue("", !0) : (L(), H("span", je({
      key: 0,
      class: e.cx("handle"),
      style: [e.sx("handle"), l.handleStyle()],
      onTouchstartPassive: t[0] || (t[0] = (s) => l.onDragStart(s)),
      onTouchmovePassive: t[1] || (t[1] = (s) => l.onDrag(s)),
      onTouchend: t[2] || (t[2] = (s) => l.onDragEnd(s)),
      onMousedown: t[3] || (t[3] = (s) => l.onMouseDown(s)),
      onKeydown: t[4] || (t[4] = (s) => l.onKeyDown(s)),
      onBlur: t[5] || (t[5] = (s) => l.onBlur(s)),
      tabindex: e.tabindex,
      role: "slider",
      "aria-valuemin": e.min,
      "aria-valuenow": e.d_value,
      "aria-valuemax": e.max,
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "aria-orientation": e.orientation
    }, e.ptm("handle")), null, 16, Yy)),
    e.range ? (L(), H("span", je({
      key: 1,
      class: e.cx("handle"),
      style: [e.sx("handle"), l.rangeStartHandleStyle()],
      onTouchstartPassive: t[6] || (t[6] = (s) => l.onDragStart(s, 0)),
      onTouchmovePassive: t[7] || (t[7] = (s) => l.onDrag(s)),
      onTouchend: t[8] || (t[8] = (s) => l.onDragEnd(s)),
      onMousedown: t[9] || (t[9] = (s) => l.onMouseDown(s, 0)),
      onKeydown: t[10] || (t[10] = (s) => l.onKeyDown(s, 0)),
      onBlur: t[11] || (t[11] = (s) => l.onBlur(s, 0)),
      tabindex: e.tabindex,
      role: "slider",
      "aria-valuemin": e.min,
      "aria-valuenow": e.d_value ? e.d_value[0] : null,
      "aria-valuemax": e.max,
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "aria-orientation": e.orientation
    }, e.ptm("startHandler")), null, 16, Ky)) : ue("", !0),
    e.range ? (L(), H("span", je({
      key: 2,
      class: e.cx("handle"),
      style: [e.sx("handle"), l.rangeEndHandleStyle()],
      onTouchstartPassive: t[12] || (t[12] = (s) => l.onDragStart(s, 1)),
      onTouchmovePassive: t[13] || (t[13] = (s) => l.onDrag(s)),
      onTouchend: t[14] || (t[14] = (s) => l.onDragEnd(s)),
      onMousedown: t[15] || (t[15] = (s) => l.onMouseDown(s, 1)),
      onKeydown: t[16] || (t[16] = (s) => l.onKeyDown(s, 1)),
      onBlur: t[17] || (t[17] = (s) => l.onBlur(s, 1)),
      tabindex: e.tabindex,
      role: "slider",
      "aria-valuemin": e.min,
      "aria-valuenow": e.d_value ? e.d_value[1] : null,
      "aria-valuemax": e.max,
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "aria-orientation": e.orientation
    }, e.ptm("endHandler")), null, 16, Zy)) : ue("", !0)
  ], 16);
}
const Jy = /* @__PURE__ */ Vt(Hy, [["render", Xy]]), qy = { class: "slider-container" }, Qy = { style: { "white-space": "nowrap" } }, e1 = /* @__PURE__ */ Je({
  __name: "ViewerSettingsSlider",
  props: {
    label: {},
    modelValue: {},
    min: {},
    max: {},
    step: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t, a = (o) => {
      n("update:modelValue", o);
    };
    return (o, l) => {
      const s = Jy;
      return L(), H("div", qy, [
        y("div", Qy, U(e.label), 1),
        d(s, {
          max: e.max,
          min: e.min,
          modelValue: e.modelValue,
          range: !1,
          step: e.step,
          style: { width: "100%" },
          "onUpdate:modelValue": a
        }, null, 8, ["max", "min", "modelValue", "step"])
      ]);
    };
  }
});
var cu = {
  name: "BaseInput",
  extends: uu,
  props: {
    size: {
      type: String,
      default: null
    },
    fluid: {
      type: Boolean,
      default: null
    },
    variant: {
      type: String,
      default: null
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    },
    $pcFluid: {
      default: void 0
    }
  },
  computed: {
    $variant: function() {
      var t;
      return (t = this.variant) !== null && t !== void 0 ? t : this.$primevue.config.inputStyle || this.$primevue.config.inputVariant;
    },
    $fluid: function() {
      var t;
      return (t = this.fluid) !== null && t !== void 0 ? t : !!this.$pcFluid;
    },
    // @deprecated use $fluid instead
    hasFluid: function() {
      return this.$fluid;
    }
  }
};
const t1 = {
  name: "BaseRadioButton",
  extends: cu,
  props: {
    value: null,
    binary: Boolean,
    readonly: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: Gg,
  provide() {
    return {
      $pcRadioButton: this,
      $parentInstance: this
    };
  }
}, n1 = {
  name: "RadioButton",
  extends: t1,
  inheritAttrs: !1,
  emits: ["change", "focus", "blur"],
  inject: {
    $pcRadioButtonGroup: {
      default: void 0
    }
  },
  methods: {
    getPTOptions(e) {
      return (e === "root" ? this.ptmi : this.ptm)(e, {
        context: {
          checked: this.checked,
          disabled: this.disabled
        }
      });
    },
    onChange(e) {
      if (!this.disabled && !this.readonly) {
        const t = this.binary ? !this.checked : this.value;
        this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.writeValue(t, e) : this.writeValue(t, e), this.$emit("change", e);
      }
    },
    onFocus(e) {
      this.$emit("focus", e);
    },
    onBlur(e) {
      var t, n;
      this.$emit("blur", e), (n = (t = this.formField).onBlur) == null || n.call(t, e);
    }
  },
  computed: {
    groupName() {
      return this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.groupName : this.$formName;
    },
    checked() {
      const e = this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.d_value : this.d_value;
      return e != null && (this.binary ? !!e : Zi(e, this.value));
    }
  }
}, a1 = ["data-p-checked", "data-p-disabled"], o1 = ["id", "value", "name", "checked", "tabindex", "disabled", "readonly", "aria-labelledby", "aria-label", "aria-invalid"];
function l1(e, t, n, a, o, l) {
  return L(), H("div", je({
    class: e.cx("root")
  }, l.getPTOptions("root"), {
    "data-p-checked": l.checked,
    "data-p-disabled": e.disabled
  }), [
    y("input", je({
      id: e.inputId,
      type: "radio",
      class: [e.cx("input"), e.inputClass],
      style: e.inputStyle,
      value: e.value,
      name: l.groupName,
      checked: l.checked,
      tabindex: e.tabindex,
      disabled: e.disabled,
      readonly: e.readonly,
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "aria-invalid": e.invalid || void 0,
      onFocus: t[0] || (t[0] = (...s) => l.onFocus && l.onFocus(...s)),
      onBlur: t[1] || (t[1] = (...s) => l.onBlur && l.onBlur(...s)),
      onChange: t[2] || (t[2] = (...s) => l.onChange && l.onChange(...s))
    }, l.getPTOptions("input")), null, 16, o1),
    y("div", je({
      class: e.cx("box")
    }, l.getPTOptions("box")), [
      y("div", je({
        class: e.cx("icon")
      }, l.getPTOptions("icon")), null, 16)
    ], 16)
  ], 16, a1);
}
const i1 = /* @__PURE__ */ Vt(n1, [["render", l1]]), s1 = { class: "container" }, r1 = { style: { "font-weight": "bold" } }, u1 = { style: { "padding-top": "16px", "flex-direction": "column", "flex-gap": "16px" } }, c1 = /* @__PURE__ */ Je({
  __name: "ViewerSettingsSection",
  props: {
    title: {}
  },
  setup(e) {
    return (t, n) => (L(), H("div", s1, [
      y("div", r1, U(e.title), 1),
      n[0] || (n[0] = y("div", { class: "divider" }, null, -1)),
      y("div", u1, [
        It(t.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}), d1 = /* @__PURE__ */ Vt(c1, [["__scopeId", "data-v-b710c6d5"]]), p1 = { class: "switch-container" }, m1 = {
  class: "ml-2",
  style: { "white-space": "nowrap" }
}, f1 = /* @__PURE__ */ Je({
  __name: "ViewerSettingsSwitch",
  props: /* @__PURE__ */ Rn({
    label: {}
  }, {
    state: { type: Boolean, required: !0 },
    stateModifiers: {}
  }),
  emits: ["update:state"],
  setup(e) {
    const t = Nn(e, "state"), n = B({
      state: t.value,
      clicked: !1,
      disabled: !1
    });
    return lt(
      n.value,
      () => {
        t.value = n.value.state;
      },
      { deep: !0 }
    ), (a, o) => (L(), H("div", p1, [
      d(r(Tg), {
        state: r(n).state,
        "onUpdate:state": o[0] || (o[0] = (l) => r(n).state = l),
        style: { margin: "0px" }
      }, {
        trueLabel: _(() => [
          y("span", m1, U(e.label), 1)
        ]),
        _: 1
      }, 8, ["state"])
    ]));
  }
});
var g1 = `
.p-icon {
    display: inline-block;
    vertical-align: baseline;
}

.p-icon-spin {
    -webkit-animation: p-icon-spin 2s infinite linear;
    animation: p-icon-spin 2s infinite linear;
}

@-webkit-keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
`, h1 = ja.extend({
  name: "baseicon",
  css: g1
});
function oi(e) {
  "@babel/helpers - typeof";
  return oi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oi(e);
}
function td(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function nd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? td(Object(n), !0).forEach(function(a) {
      b1(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : td(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function b1(e, t, n) {
  return (t = v1(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function v1(e) {
  var t = y1(e, "string");
  return oi(t) == "symbol" ? t : t + "";
}
function y1(e, t) {
  if (oi(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(e, t);
    if (oi(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var ra = {
  name: "BaseIcon",
  extends: Ka,
  props: {
    label: {
      type: String,
      default: void 0
    },
    spin: {
      type: Boolean,
      default: !1
    }
  },
  style: h1,
  provide: function() {
    return {
      $pcIcon: this,
      $parentInstance: this
    };
  },
  methods: {
    pti: function() {
      var t = pi(this.label);
      return nd(nd({}, !this.isUnstyled && {
        class: ["p-icon", {
          "p-icon-spin": this.spin
        }]
      }), {}, {
        role: t ? void 0 : "img",
        "aria-label": t ? void 0 : this.label,
        "aria-hidden": t
      });
    }
  }
}, om = {
  name: "AngleDownIcon",
  extends: ra
};
function _1(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    d: "M3.58659 4.5007C3.68513 4.50023 3.78277 4.51945 3.87379 4.55723C3.9648 4.59501 4.04735 4.65058 4.11659 4.7207L7.11659 7.7207L10.1166 4.7207C10.2619 4.65055 10.4259 4.62911 10.5843 4.65956C10.7427 4.69002 10.8871 4.77074 10.996 4.88976C11.1049 5.00877 11.1726 5.15973 11.1889 5.32022C11.2052 5.48072 11.1693 5.6422 11.0866 5.7807L7.58659 9.2807C7.44597 9.42115 7.25534 9.50004 7.05659 9.50004C6.85784 9.50004 6.66722 9.42115 6.52659 9.2807L3.02659 5.7807C2.88614 5.64007 2.80725 5.44945 2.80725 5.2507C2.80725 5.05195 2.88614 4.86132 3.02659 4.7207C3.09932 4.64685 3.18675 4.58911 3.28322 4.55121C3.37969 4.51331 3.48305 4.4961 3.58659 4.5007Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
om.render = _1;
var lm = {
  name: "AngleUpIcon",
  extends: ra
};
function w1(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    d: "M10.4134 9.49931C10.3148 9.49977 10.2172 9.48055 10.1262 9.44278C10.0352 9.405 9.95263 9.34942 9.88338 9.27931L6.88338 6.27931L3.88338 9.27931C3.73811 9.34946 3.57409 9.3709 3.41567 9.34044C3.25724 9.30999 3.11286 9.22926 3.00395 9.11025C2.89504 8.99124 2.82741 8.84028 2.8111 8.67978C2.79478 8.51928 2.83065 8.35781 2.91338 8.21931L6.41338 4.71931C6.55401 4.57886 6.74463 4.49997 6.94338 4.49997C7.14213 4.49997 7.33276 4.57886 7.47338 4.71931L10.9734 8.21931C11.1138 8.35994 11.1927 8.55056 11.1927 8.74931C11.1927 8.94806 11.1138 9.13868 10.9734 9.27931C10.9007 9.35315 10.8132 9.41089 10.7168 9.44879C10.6203 9.48669 10.5169 9.5039 10.4134 9.49931Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
lm.render = w1;
const I1 = {
  name: "BaseInputNumber",
  extends: cu,
  props: {
    format: {
      type: Boolean,
      default: !0
    },
    showButtons: {
      type: Boolean,
      default: !1
    },
    buttonLayout: {
      type: String,
      default: "stacked"
    },
    incrementButtonClass: {
      type: String,
      default: null
    },
    decrementButtonClass: {
      type: String,
      default: null
    },
    incrementButtonIcon: {
      type: String,
      default: void 0
    },
    incrementIcon: {
      type: String,
      default: void 0
    },
    decrementButtonIcon: {
      type: String,
      default: void 0
    },
    decrementIcon: {
      type: String,
      default: void 0
    },
    locale: {
      type: String,
      default: void 0
    },
    localeMatcher: {
      type: String,
      default: void 0
    },
    mode: {
      type: String,
      default: "decimal"
    },
    prefix: {
      type: String,
      default: null
    },
    suffix: {
      type: String,
      default: null
    },
    currency: {
      type: String,
      default: void 0
    },
    currencyDisplay: {
      type: String,
      default: void 0
    },
    useGrouping: {
      type: Boolean,
      default: !0
    },
    minFractionDigits: {
      type: Number,
      default: void 0
    },
    maxFractionDigits: {
      type: Number,
      default: void 0
    },
    roundingMode: {
      type: String,
      default: "halfExpand",
      validator(e) {
        return ["ceil", "floor", "expand", "trunc", "halfCeil", "halfFloor", "halfExpand", "halfTrunc", "halfEven"].includes(e);
      }
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    step: {
      type: Number,
      default: 1
    },
    allowEmpty: {
      type: Boolean,
      default: !0
    },
    highlightOnFocus: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: Wg,
  provide() {
    return {
      $pcInputNumber: this,
      $parentInstance: this
    };
  }
}, S1 = {
  name: "InputNumber",
  extends: I1,
  inheritAttrs: !1,
  emits: ["input", "focus", "blur"],
  inject: {
    $pcFluid: { default: null }
  },
  numberFormat: null,
  _numeral: null,
  _decimal: null,
  _group: null,
  _minusSign: null,
  _currency: null,
  _suffix: null,
  _prefix: null,
  _index: null,
  groupChar: "",
  isSpecialChar: null,
  prefixChar: null,
  suffixChar: null,
  timer: null,
  data() {
    return {
      // @deprecated
      d_modelValue: this.d_value,
      focused: !1
    };
  },
  watch: {
    d_value(e) {
      this.d_modelValue = e;
    },
    locale(e, t) {
      this.updateConstructParser(e, t);
    },
    localeMatcher(e, t) {
      this.updateConstructParser(e, t);
    },
    mode(e, t) {
      this.updateConstructParser(e, t);
    },
    currency(e, t) {
      this.updateConstructParser(e, t);
    },
    currencyDisplay(e, t) {
      this.updateConstructParser(e, t);
    },
    useGrouping(e, t) {
      this.updateConstructParser(e, t);
    },
    minFractionDigits(e, t) {
      this.updateConstructParser(e, t);
    },
    maxFractionDigits(e, t) {
      this.updateConstructParser(e, t);
    },
    suffix(e, t) {
      this.updateConstructParser(e, t);
    },
    prefix(e, t) {
      this.updateConstructParser(e, t);
    }
  },
  created() {
    this.constructParser();
  },
  methods: {
    getOptions() {
      return {
        localeMatcher: this.localeMatcher,
        style: this.mode,
        currency: this.currency,
        currencyDisplay: this.currencyDisplay,
        useGrouping: this.useGrouping,
        minimumFractionDigits: this.minFractionDigits,
        maximumFractionDigits: this.maxFractionDigits,
        roundingMode: this.roundingMode
      };
    },
    constructParser() {
      this.numberFormat = new Intl.NumberFormat(this.locale, this.getOptions());
      const e = [...new Intl.NumberFormat(this.locale, { useGrouping: !1 }).format(9876543210)].reverse(), t = new Map(e.map((n, a) => [n, a]));
      this._numeral = new RegExp(`[${e.join("")}]`, "g"), this._group = this.getGroupingExpression(), this._minusSign = this.getMinusSignExpression(), this._currency = this.getCurrencyExpression(), this._decimal = this.getDecimalExpression(), this._suffix = this.getSuffixExpression(), this._prefix = this.getPrefixExpression(), this._index = (n) => t.get(n);
    },
    updateConstructParser(e, t) {
      e !== t && this.constructParser();
    },
    escapeRegExp(e) {
      return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    },
    getDecimalExpression() {
      const e = new Intl.NumberFormat(this.locale, { ...this.getOptions(), useGrouping: !1 });
      return new RegExp(`[${e.format(1.1).replace(this._currency, "").trim().replace(this._numeral, "")}]`, "g");
    },
    getGroupingExpression() {
      const e = new Intl.NumberFormat(this.locale, { useGrouping: !0 });
      return this.groupChar = e.format(1e6).trim().replace(this._numeral, "").charAt(0), new RegExp(`[${this.groupChar}]`, "g");
    },
    getMinusSignExpression() {
      const e = new Intl.NumberFormat(this.locale, { useGrouping: !1 });
      return new RegExp(`[${e.format(-1).trim().replace(this._numeral, "")}]`, "g");
    },
    getCurrencyExpression() {
      if (this.currency) {
        const e = new Intl.NumberFormat(this.locale, { style: "currency", currency: this.currency, currencyDisplay: this.currencyDisplay, minimumFractionDigits: 0, maximumFractionDigits: 0, roundingMode: this.roundingMode });
        return new RegExp(`[${e.format(1).replace(/\s/g, "").replace(this._numeral, "").replace(this._group, "")}]`, "g");
      }
      return new RegExp("[]", "g");
    },
    getPrefixExpression() {
      if (this.prefix)
        this.prefixChar = this.prefix;
      else {
        const e = new Intl.NumberFormat(this.locale, { style: this.mode, currency: this.currency, currencyDisplay: this.currencyDisplay });
        this.prefixChar = e.format(1).split("1")[0];
      }
      return new RegExp(`${this.escapeRegExp(this.prefixChar || "")}`, "g");
    },
    getSuffixExpression() {
      if (this.suffix)
        this.suffixChar = this.suffix;
      else {
        const e = new Intl.NumberFormat(this.locale, { style: this.mode, currency: this.currency, currencyDisplay: this.currencyDisplay, minimumFractionDigits: 0, maximumFractionDigits: 0, roundingMode: this.roundingMode });
        this.suffixChar = e.format(1).split("1")[1];
      }
      return new RegExp(`${this.escapeRegExp(this.suffixChar || "")}`, "g");
    },
    formatValue(e) {
      if (e != null) {
        if (e === "-")
          return e;
        if (this.format) {
          let n = new Intl.NumberFormat(this.locale, this.getOptions()).format(e);
          return this.prefix && (n = this.prefix + n), this.suffix && (n = n + this.suffix), n;
        }
        return e.toString();
      }
      return "";
    },
    parseValue(e) {
      let t = e.replace(this._suffix, "").replace(this._prefix, "").trim().replace(/\s/g, "").replace(this._currency, "").replace(this._group, "").replace(this._minusSign, "-").replace(this._decimal, ".").replace(this._numeral, this._index);
      if (t) {
        if (t === "-")
          return t;
        let n = +t;
        return isNaN(n) ? null : n;
      }
      return null;
    },
    repeat(e, t, n) {
      if (this.readonly)
        return;
      let a = t || 500;
      this.clearTimer(), this.timer = setTimeout(() => {
        this.repeat(e, 40, n);
      }, a), this.spin(e, n);
    },
    spin(e, t) {
      if (this.$refs.input) {
        let n = this.step * t, a = this.parseValue(this.$refs.input.$el.value) || 0, o = this.validateValue(a + n);
        this.updateInput(o, null, "spin"), this.updateModel(e, o), this.handleOnInput(e, a, o);
      }
    },
    onUpButtonMouseDown(e) {
      this.disabled || (this.$refs.input.$el.focus(), this.repeat(e, null, 1), e.preventDefault());
    },
    onUpButtonMouseUp() {
      this.disabled || this.clearTimer();
    },
    onUpButtonMouseLeave() {
      this.disabled || this.clearTimer();
    },
    onUpButtonKeyUp() {
      this.disabled || this.clearTimer();
    },
    onUpButtonKeyDown(e) {
      (e.code === "Space" || e.code === "Enter" || e.code === "NumpadEnter") && this.repeat(e, null, 1);
    },
    onDownButtonMouseDown(e) {
      this.disabled || (this.$refs.input.$el.focus(), this.repeat(e, null, -1), e.preventDefault());
    },
    onDownButtonMouseUp() {
      this.disabled || this.clearTimer();
    },
    onDownButtonMouseLeave() {
      this.disabled || this.clearTimer();
    },
    onDownButtonKeyUp() {
      this.disabled || this.clearTimer();
    },
    onDownButtonKeyDown(e) {
      (e.code === "Space" || e.code === "Enter" || e.code === "NumpadEnter") && this.repeat(e, null, -1);
    },
    onUserInput() {
      this.isSpecialChar && (this.$refs.input.$el.value = this.lastValue), this.isSpecialChar = !1;
    },
    onInputKeyDown(e) {
      if (this.readonly)
        return;
      if (e.altKey || e.ctrlKey || e.metaKey) {
        this.isSpecialChar = !0, this.lastValue = this.$refs.input.$el.value;
        return;
      }
      this.lastValue = e.target.value;
      let t = e.target.selectionStart, n = e.target.selectionEnd, a = n - t, o = e.target.value, l = null;
      switch (e.code || e.key) {
        case "ArrowUp":
          this.spin(e, 1), e.preventDefault();
          break;
        case "ArrowDown":
          this.spin(e, -1), e.preventDefault();
          break;
        case "ArrowLeft":
          if (a > 1) {
            const i = this.isNumeralChar(o.charAt(t)) ? t + 1 : t + 2;
            this.$refs.input.$el.setSelectionRange(i, i);
          } else this.isNumeralChar(o.charAt(t - 1)) || e.preventDefault();
          break;
        case "ArrowRight":
          if (a > 1) {
            const i = n - 1;
            this.$refs.input.$el.setSelectionRange(i, i);
          } else this.isNumeralChar(o.charAt(t)) || e.preventDefault();
          break;
        case "Tab":
        case "Enter":
        case "NumpadEnter":
          l = this.validateValue(this.parseValue(o)), this.$refs.input.$el.value = this.formatValue(l), this.$refs.input.$el.setAttribute("aria-valuenow", l), this.updateModel(e, l);
          break;
        case "Backspace": {
          if (e.preventDefault(), t === n) {
            const i = o.charAt(t - 1), { decimalCharIndex: u, decimalCharIndexWithoutPrefix: c } = this.getDecimalCharIndexes(o);
            if (this.isNumeralChar(i)) {
              const p = this.getDecimalLength(o);
              if (this._group.test(i))
                this._group.lastIndex = 0, l = o.slice(0, t - 2) + o.slice(t - 1);
              else if (this._decimal.test(i))
                this._decimal.lastIndex = 0, p ? this.$refs.input.$el.setSelectionRange(t - 1, t - 1) : l = o.slice(0, t - 1) + o.slice(t);
              else if (u > 0 && t > u) {
                const h = this.isDecimalMode() && (this.minFractionDigits || 0) < p ? "" : "0";
                l = o.slice(0, t - 1) + h + o.slice(t);
              } else c === 1 ? (l = o.slice(0, t - 1) + "0" + o.slice(t), l = this.parseValue(l) > 0 ? l : "") : l = o.slice(0, t - 1) + o.slice(t);
            }
            this.updateValue(e, l, null, "delete-single");
          } else
            l = this.deleteRange(o, t, n), this.updateValue(e, l, null, "delete-range");
          break;
        }
        case "Delete":
          if (e.preventDefault(), t === n) {
            const i = o.charAt(t), { decimalCharIndex: u, decimalCharIndexWithoutPrefix: c } = this.getDecimalCharIndexes(o);
            if (this.isNumeralChar(i)) {
              const p = this.getDecimalLength(o);
              if (this._group.test(i))
                this._group.lastIndex = 0, l = o.slice(0, t) + o.slice(t + 2);
              else if (this._decimal.test(i))
                this._decimal.lastIndex = 0, p ? this.$refs.input.$el.setSelectionRange(t + 1, t + 1) : l = o.slice(0, t) + o.slice(t + 1);
              else if (u > 0 && t > u) {
                const h = this.isDecimalMode() && (this.minFractionDigits || 0) < p ? "" : "0";
                l = o.slice(0, t) + h + o.slice(t + 1);
              } else c === 1 ? (l = o.slice(0, t) + "0" + o.slice(t + 1), l = this.parseValue(l) > 0 ? l : "") : l = o.slice(0, t) + o.slice(t + 1);
            }
            this.updateValue(e, l, null, "delete-back-single");
          } else
            l = this.deleteRange(o, t, n), this.updateValue(e, l, null, "delete-range");
          break;
        case "Home":
          e.preventDefault(), At(this.min) && this.updateModel(e, this.min);
          break;
        case "End":
          e.preventDefault(), At(this.max) && this.updateModel(e, this.max);
          break;
      }
    },
    onInputKeyPress(e) {
      if (this.readonly)
        return;
      let t = e.key, n = this.isDecimalSign(t);
      const a = this.isMinusSign(t);
      e.code !== "Enter" && e.preventDefault(), (Number(t) >= 0 && Number(t) <= 9 || a || n) && this.insert(e, t, { isDecimalSign: n, isMinusSign: a });
    },
    onPaste(e) {
      e.preventDefault();
      let t = (e.clipboardData || window.clipboardData).getData("Text");
      if (t) {
        let n = this.parseValue(t);
        n != null && this.insert(e, n.toString());
      }
    },
    allowMinusSign() {
      return this.min === null || this.min < 0;
    },
    isMinusSign(e) {
      return this._minusSign.test(e) || e === "-" ? (this._minusSign.lastIndex = 0, !0) : !1;
    },
    isDecimalSign(e) {
      return this._decimal.test(e) ? (this._decimal.lastIndex = 0, !0) : !1;
    },
    isDecimalMode() {
      return this.mode === "decimal";
    },
    getDecimalCharIndexes(e) {
      let t = e.search(this._decimal);
      this._decimal.lastIndex = 0;
      const a = e.replace(this._prefix, "").trim().replace(/\s/g, "").replace(this._currency, "").search(this._decimal);
      return this._decimal.lastIndex = 0, { decimalCharIndex: t, decimalCharIndexWithoutPrefix: a };
    },
    getCharIndexes(e) {
      const t = e.search(this._decimal);
      this._decimal.lastIndex = 0;
      const n = e.search(this._minusSign);
      this._minusSign.lastIndex = 0;
      const a = e.search(this._suffix);
      this._suffix.lastIndex = 0;
      const o = e.search(this._currency);
      return this._currency.lastIndex = 0, { decimalCharIndex: t, minusCharIndex: n, suffixCharIndex: a, currencyCharIndex: o };
    },
    insert(e, t, n = { isDecimalSign: !1, isMinusSign: !1 }) {
      const a = t.search(this._minusSign);
      if (this._minusSign.lastIndex = 0, !this.allowMinusSign() && a !== -1)
        return;
      const o = this.$refs.input.$el.selectionStart, l = this.$refs.input.$el.selectionEnd;
      let s = this.$refs.input.$el.value.trim();
      const { decimalCharIndex: i, minusCharIndex: u, suffixCharIndex: c, currencyCharIndex: p } = this.getCharIndexes(s);
      let h;
      if (n.isMinusSign)
        o === 0 && (h = s, (u === -1 || l !== 0) && (h = this.insertText(s, t, 0, l)), this.updateValue(e, h, t, "insert"));
      else if (n.isDecimalSign)
        i > 0 && o === i ? this.updateValue(e, s, t, "insert") : i > o && i < l ? (h = this.insertText(s, t, o, l), this.updateValue(e, h, t, "insert")) : i === -1 && this.maxFractionDigits && (h = this.insertText(s, t, o, l), this.updateValue(e, h, t, "insert"));
      else {
        const g = this.numberFormat.resolvedOptions().maximumFractionDigits, b = o !== l ? "range-insert" : "insert";
        if (i > 0 && o > i) {
          if (o + t.length - (i + 1) <= g) {
            const E = p >= o ? p - 1 : c >= o ? c : s.length;
            h = s.slice(0, o) + t + s.slice(o + t.length, E) + s.slice(E), this.updateValue(e, h, t, b);
          }
        } else
          h = this.insertText(s, t, o, l), this.updateValue(e, h, t, b);
      }
    },
    insertText(e, t, n, a) {
      if ((t === "." ? t : t.split(".")).length === 2) {
        const l = e.slice(n, a).search(this._decimal);
        return this._decimal.lastIndex = 0, l > 0 ? e.slice(0, n) + this.formatValue(t) + e.slice(a) : this.formatValue(t) || e;
      } else return a - n === e.length ? this.formatValue(t) : n === 0 ? t + e.slice(a) : a === e.length ? e.slice(0, n) + t : e.slice(0, n) + t + e.slice(a);
    },
    deleteRange(e, t, n) {
      let a;
      return n - t === e.length ? a = "" : t === 0 ? a = e.slice(n) : n === e.length ? a = e.slice(0, t) : a = e.slice(0, t) + e.slice(n), a;
    },
    initCursor() {
      let e = this.$refs.input.$el.selectionStart, t = this.$refs.input.$el.value, n = t.length, a = null, o = (this.prefixChar || "").length;
      t = t.replace(this._prefix, ""), e = e - o;
      let l = t.charAt(e);
      if (this.isNumeralChar(l))
        return e + o;
      let s = e - 1;
      for (; s >= 0; )
        if (l = t.charAt(s), this.isNumeralChar(l)) {
          a = s + o;
          break;
        } else
          s--;
      if (a !== null)
        this.$refs.input.$el.setSelectionRange(a + 1, a + 1);
      else {
        for (s = e; s < n; )
          if (l = t.charAt(s), this.isNumeralChar(l)) {
            a = s + o;
            break;
          } else
            s++;
        a !== null && this.$refs.input.$el.setSelectionRange(a, a);
      }
      return a || 0;
    },
    onInputClick() {
      const e = this.$refs.input.$el.value;
      !this.readonly && e !== Gc() && this.initCursor();
    },
    isNumeralChar(e) {
      return e.length === 1 && (this._numeral.test(e) || this._decimal.test(e) || this._group.test(e) || this._minusSign.test(e)) ? (this.resetRegex(), !0) : !1;
    },
    resetRegex() {
      this._numeral.lastIndex = 0, this._decimal.lastIndex = 0, this._group.lastIndex = 0, this._minusSign.lastIndex = 0;
    },
    updateValue(e, t, n, a) {
      let o = this.$refs.input.$el.value, l = null;
      t != null && (l = this.parseValue(t), l = !l && !this.allowEmpty ? 0 : l, this.updateInput(l, n, a, t), this.handleOnInput(e, o, l));
    },
    handleOnInput(e, t, n) {
      var a, o;
      this.isValueChanged(t, n) && (this.$emit("input", { originalEvent: e, value: n, formattedValue: t }), (o = (a = this.formField).onInput) == null || o.call(a, { originalEvent: e, value: n }));
    },
    isValueChanged(e, t) {
      if (t === null && e !== null)
        return !0;
      if (t != null) {
        let n = typeof e == "string" ? this.parseValue(e) : e;
        return t !== n;
      }
      return !1;
    },
    validateValue(e) {
      return e === "-" || e == null ? null : this.min != null && e < this.min ? this.min : this.max != null && e > this.max ? this.max : e;
    },
    updateInput(e, t, n, a) {
      t = t || "";
      let o = this.$refs.input.$el.value, l = this.formatValue(e), s = o.length;
      if (l !== a && (l = this.concatValues(l, a)), s === 0) {
        this.$refs.input.$el.value = l, this.$refs.input.$el.setSelectionRange(0, 0);
        const u = this.initCursor() + t.length;
        this.$refs.input.$el.setSelectionRange(u, u);
      } else {
        let i = this.$refs.input.$el.selectionStart, u = this.$refs.input.$el.selectionEnd;
        this.$refs.input.$el.value = l;
        let c = l.length;
        if (n === "range-insert") {
          const p = this.parseValue((o || "").slice(0, i)), g = (p !== null ? p.toString() : "").split("").join(`(${this.groupChar})?`), b = new RegExp(g, "g");
          b.test(l);
          const E = t.split("").join(`(${this.groupChar})?`), m = new RegExp(E, "g");
          m.test(l.slice(b.lastIndex)), u = b.lastIndex + m.lastIndex, this.$refs.input.$el.setSelectionRange(u, u);
        } else if (c === s)
          n === "insert" || n === "delete-back-single" ? this.$refs.input.$el.setSelectionRange(u + 1, u + 1) : n === "delete-single" ? this.$refs.input.$el.setSelectionRange(u - 1, u - 1) : (n === "delete-range" || n === "spin") && this.$refs.input.$el.setSelectionRange(u, u);
        else if (n === "delete-back-single") {
          let p = o.charAt(u - 1), h = o.charAt(u), g = s - c, b = this._group.test(h);
          b && g === 1 ? u += 1 : !b && this.isNumeralChar(p) && (u += -1 * g + 1), this._group.lastIndex = 0, this.$refs.input.$el.setSelectionRange(u, u);
        } else if (o === "-" && n === "insert") {
          this.$refs.input.$el.setSelectionRange(0, 0);
          const h = this.initCursor() + t.length + 1;
          this.$refs.input.$el.setSelectionRange(h, h);
        } else
          u = u + (c - s), this.$refs.input.$el.setSelectionRange(u, u);
      }
      this.$refs.input.$el.setAttribute("aria-valuenow", e);
    },
    concatValues(e, t) {
      if (e && t) {
        let n = t.search(this._decimal);
        return this._decimal.lastIndex = 0, this.suffixChar ? n !== -1 ? e.replace(this.suffixChar, "").split(this._decimal)[0] + t.replace(this.suffixChar, "").slice(n) + this.suffixChar : e : n !== -1 ? e.split(this._decimal)[0] + t.slice(n) : e;
      }
      return e;
    },
    getDecimalLength(e) {
      if (e) {
        const t = e.split(this._decimal);
        if (t.length === 2)
          return t[1].replace(this._suffix, "").trim().replace(/\s/g, "").replace(this._currency, "").length;
      }
      return 0;
    },
    updateModel(e, t) {
      this.writeValue(t, e);
    },
    onInputFocus(e) {
      this.focused = !0, !this.disabled && !this.readonly && this.$refs.input.$el.value !== Gc() && this.highlightOnFocus && e.target.select(), this.$emit("focus", e);
    },
    onInputBlur(e) {
      var a, o;
      this.focused = !1;
      let t = e.target, n = this.validateValue(this.parseValue(t.value));
      this.$emit("blur", { originalEvent: e, value: t.value }), (o = (a = this.formField).onBlur) == null || o.call(a, e), t.value = this.formatValue(n), t.setAttribute("aria-valuenow", n), this.updateModel(e, n), !this.disabled && !this.readonly && this.highlightOnFocus && ty();
    },
    clearTimer() {
      this.timer && clearInterval(this.timer);
    },
    maxBoundry() {
      return this.d_value >= this.max;
    },
    minBoundry() {
      return this.d_value <= this.min;
    }
  },
  computed: {
    upButtonListeners() {
      return {
        mousedown: (e) => this.onUpButtonMouseDown(e),
        mouseup: (e) => this.onUpButtonMouseUp(e),
        mouseleave: (e) => this.onUpButtonMouseLeave(e),
        keydown: (e) => this.onUpButtonKeyDown(e),
        keyup: (e) => this.onUpButtonKeyUp(e)
      };
    },
    downButtonListeners() {
      return {
        mousedown: (e) => this.onDownButtonMouseDown(e),
        mouseup: (e) => this.onDownButtonMouseUp(e),
        mouseleave: (e) => this.onDownButtonMouseLeave(e),
        keydown: (e) => this.onDownButtonKeyDown(e),
        keyup: (e) => this.onDownButtonKeyUp(e)
      };
    },
    formattedValue() {
      const e = !this.d_value && !this.allowEmpty ? 0 : this.d_value;
      return this.formatValue(e);
    },
    getFormatter() {
      return this.numberFormat;
    }
  },
  components: {
    InputText: da,
    AngleUpIcon: lm,
    AngleDownIcon: om
  }
}, E1 = ["disabled"], T1 = ["disabled"], C1 = ["disabled"], N1 = ["disabled"];
function L1(e, t, n, a, o, l) {
  const s = Tn("InputText");
  return L(), H("span", je({
    class: e.cx("root")
  }, e.ptmi("root")), [
    d(s, {
      ref: "input",
      id: e.inputId,
      role: "spinbutton",
      class: Ge([e.cx("pcInputText"), e.inputClass]),
      style: Et(e.inputStyle),
      value: l.formattedValue,
      "aria-valuemin": e.min,
      "aria-valuemax": e.max,
      "aria-valuenow": e.d_value,
      inputmode: e.mode === "decimal" && !e.minFractionDigits ? "numeric" : "decimal",
      disabled: e.disabled,
      readonly: e.readonly,
      placeholder: e.placeholder,
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      size: e.size,
      invalid: e.invalid,
      variant: e.variant,
      onInput: l.onUserInput,
      onKeydown: l.onInputKeyDown,
      onKeypress: l.onInputKeyPress,
      onPaste: l.onPaste,
      onClick: l.onInputClick,
      onFocus: l.onInputFocus,
      onBlur: l.onInputBlur,
      pt: e.ptm("pcInputText"),
      unstyled: e.unstyled
    }, null, 8, ["id", "class", "style", "value", "aria-valuemin", "aria-valuemax", "aria-valuenow", "inputmode", "disabled", "readonly", "placeholder", "aria-labelledby", "aria-label", "size", "invalid", "variant", "onInput", "onKeydown", "onKeypress", "onPaste", "onClick", "onFocus", "onBlur", "pt", "unstyled"]),
    e.showButtons && e.buttonLayout === "stacked" ? (L(), H("span", je({
      key: 0,
      class: e.cx("buttonGroup")
    }, e.ptm("buttonGroup")), [
      It(e.$slots, "incrementbutton", { listeners: l.upButtonListeners }, () => [
        y("button", je({
          class: [e.cx("incrementButton"), e.incrementButtonClass]
        }, Ii(l.upButtonListeners, !0), {
          disabled: e.disabled,
          tabindex: -1,
          "aria-hidden": "true",
          type: "button"
        }, e.ptm("incrementButton")), [
          It(e.$slots, e.$slots.incrementicon ? "incrementicon" : "incrementbuttonicon", {}, () => [
            (L(), be(Sa(e.incrementIcon || e.incrementButtonIcon ? "span" : "AngleUpIcon"), je({
              class: [e.incrementIcon, e.incrementButtonIcon]
            }, e.ptm("incrementIcon"), { "data-pc-section": "incrementicon" }), null, 16, ["class"]))
          ])
        ], 16, E1)
      ]),
      It(e.$slots, "decrementbutton", { listeners: l.downButtonListeners }, () => [
        y("button", je({
          class: [e.cx("decrementButton"), e.decrementButtonClass]
        }, Ii(l.downButtonListeners, !0), {
          disabled: e.disabled,
          tabindex: -1,
          "aria-hidden": "true",
          type: "button"
        }, e.ptm("decrementButton")), [
          It(e.$slots, e.$slots.decrementicon ? "decrementicon" : "decrementbuttonicon", {}, () => [
            (L(), be(Sa(e.decrementIcon || e.decrementButtonIcon ? "span" : "AngleDownIcon"), je({
              class: [e.decrementIcon, e.decrementButtonIcon]
            }, e.ptm("decrementIcon"), { "data-pc-section": "decrementicon" }), null, 16, ["class"]))
          ])
        ], 16, T1)
      ])
    ], 16)) : ue("", !0),
    It(e.$slots, "incrementbutton", { listeners: l.upButtonListeners }, () => [
      e.showButtons && e.buttonLayout !== "stacked" ? (L(), H("button", je({
        key: 0,
        class: [e.cx("incrementButton"), e.incrementButtonClass]
      }, Ii(l.upButtonListeners, !0), {
        disabled: e.disabled,
        tabindex: -1,
        "aria-hidden": "true",
        type: "button"
      }, e.ptm("incrementButton")), [
        It(e.$slots, e.$slots.incrementicon ? "incrementicon" : "incrementbuttonicon", {}, () => [
          (L(), be(Sa(e.incrementIcon || e.incrementButtonIcon ? "span" : "AngleUpIcon"), je({
            class: [e.incrementIcon, e.incrementButtonIcon]
          }, e.ptm("incrementIcon"), { "data-pc-section": "incrementicon" }), null, 16, ["class"]))
        ])
      ], 16, C1)) : ue("", !0)
    ]),
    It(e.$slots, "decrementbutton", { listeners: l.downButtonListeners }, () => [
      e.showButtons && e.buttonLayout !== "stacked" ? (L(), H("button", je({
        key: 0,
        class: [e.cx("decrementButton"), e.decrementButtonClass]
      }, Ii(l.downButtonListeners, !0), {
        disabled: e.disabled,
        tabindex: -1,
        "aria-hidden": "true",
        type: "button"
      }, e.ptm("decrementButton")), [
        It(e.$slots, e.$slots.decrementicon ? "decrementicon" : "decrementbuttonicon", {}, () => [
          (L(), be(Sa(e.decrementIcon || e.decrementButtonIcon ? "span" : "AngleDownIcon"), je({
            class: [e.decrementIcon, e.decrementButtonIcon]
          }, e.ptm("decrementIcon"), { "data-pc-section": "decrementicon" }), null, 16, ["class"]))
        ])
      ], 16, N1)) : ue("", !0)
    ])
  ], 16);
}
const O1 = /* @__PURE__ */ Vt(S1, [["render", L1]]), D1 = { class: "number-input-container" }, A1 = { style: { "white-space": "nowrap" } }, R1 = /* @__PURE__ */ Je({
  __name: "ViewerSettingsNumberInput",
  props: {
    label: {},
    modelValue: {},
    min: {},
    max: {},
    step: {},
    showButtons: { type: Boolean },
    suffix: {},
    minFractionDigits: {},
    maxFractionDigits: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t, a = (o) => {
      n("update:modelValue", o);
    };
    return (o, l) => {
      const s = O1;
      return L(), H("div", D1, [
        y("div", A1, U(e.label), 1),
        d(s, {
          max: e.max,
          min: e.min,
          modelValue: e.modelValue,
          showButtons: e.showButtons,
          step: e.step,
          suffix: e.suffix,
          minFractionDigits: e.minFractionDigits,
          maxFractionDigits: e.maxFractionDigits,
          "onUpdate:modelValue": a
        }, null, 8, ["max", "min", "modelValue", "showButtons", "step", "suffix", "minFractionDigits", "maxFractionDigits"])
      ]);
    };
  }
}), M1 = {
  name: "BaseDivider",
  extends: Ka,
  props: {
    align: {
      type: String,
      default: null
    },
    layout: {
      type: String,
      default: "horizontal"
    },
    type: {
      type: String,
      default: "solid"
    }
  },
  style: zg,
  provide() {
    return {
      $pcDivider: this,
      $parentInstance: this
    };
  }
}, P1 = {
  name: "Divider",
  extends: M1,
  inheritAttrs: !1
}, x1 = ["aria-orientation"];
function j1(e, t, n, a, o, l) {
  return L(), H("div", je({
    class: e.cx("root"),
    style: e.sx("root"),
    role: "separator",
    "aria-orientation": e.layout
  }, e.ptmi("root")), [
    e.$slots.default ? (L(), H("div", je({
      key: 0,
      class: e.cx("content")
    }, e.ptm("content")), [
      It(e.$slots, "default")
    ], 16)) : ue("", !0)
  ], 16, x1);
}
const im = /* @__PURE__ */ Vt(P1, [["render", j1]]), $1 = ["src", "alt"], F1 = {
  class: "pointer-events-none flex grow",
  style: { "font-weight": "600", color: "black" }
}, pn = /* @__PURE__ */ Je({
  __name: "IPAboutInfoInput",
  props: {
    label: String,
    value: String,
    logo: String,
    center: Boolean
  },
  setup(e) {
    const t = sa(), n = e, a = B(n.value);
    return (o, l) => (L(), be(r(ke), {
      class: Ge(["items-center h-full", { "justify-center": e.center, "gap-1": !0 }])
    }, {
      default: _(() => [
        (n.label ?? "").length > 0 ? (L(), be(r(ot), {
          key: 0,
          class: "grow"
        }, {
          default: _(() => [
            y("span", null, U(n.label), 1)
          ]),
          _: 1
        })) : ue("", !0),
        e.logo ? (L(), be(r(ot), {
          key: 1,
          class: "items-center"
        }, {
          default: _(() => [
            y("img", {
              src: r(t).getAssetUrl(`/icons/info/${e.logo}.png`),
              width: "15",
              alt: e.logo
            }, null, 8, $1)
          ]),
          _: 1
        })) : ue("", !0),
        d(r(ot), null, {
          default: _(() => [
            y("span", F1, U(a.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Ll = /* @__PURE__ */ Je({
  __name: "IPAboutInfoDivider",
  setup(e) {
    return (t, n) => (L(), be(r(ke), { class: "w-full" }, {
      default: _(() => [
        d(r(Ot), null, {
          default: _(() => [...n[0] || (n[0] = [
            y("hr", { style: { border: "none", "border-top": "1px solid lightgrey", width: "100%" } }, null, -1)
          ])]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), k1 = ["src"], V1 = ["src"], B1 = {
  class: "text-2xl",
  style: { color: "black", "font-weight": "600" }
}, U1 = ["src"], G1 = ["src"], W1 = ["src"], z1 = ["src"], H1 = ["src"], Y1 = ["src"], sm = /* @__PURE__ */ Je({
  __name: "IPAboutInfoBody",
  props: {
    model: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:model"],
  setup(e) {
    const t = Nn(e, "model"), n = sa();
    return (a, o) => (L(), be(r(ot), { class: "gap-2 bg-white all-radius-16 overflow-y-auto h-full" }, {
      default: _(() => [
        d(Ll),
        d(r(ke), null, {
          default: _(() => [
            d(r(Bo), { class: "justify-center" }, {
              default: _(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/factory.png"),
                  width: "100",
                  alt: "factory"
                }, null, 8, k1)
              ]),
              _: 1
            }),
            d(r(Bo), null, {
              default: _(() => [
                d(r(ot), { class: "grow" }, {
                  default: _(() => [
                    d(pn, {
                      value: t.value.company.name
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.company.address
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.company.website
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.company.email
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.company.telephone
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(Ll),
        d(r(ke), null, {
          default: _(() => [
            d(r(Bo), { class: "justify-center" }, {
              default: _(() => [
                d(r(ot), { class: "items-center justify-center grow md:p-6 lg:p-20" }, {
                  default: _(() => [
                    d(r(ke), { class: "justify-start" }, {
                      default: _(() => [...o[0] || (o[0] = [
                        y("span", {
                          class: "ml-3",
                          style: { color: "black" }
                        }, "LBL 01 04 0 00 REV 10_05-2025", -1)
                      ])]),
                      _: 1
                    }),
                    y("img", {
                      src: r(n).getAssetUrl("/icons/info/infobook.png"),
                      width: "100",
                      alt: "infobook"
                    }, null, 8, V1),
                    d(r(ke), { class: "justify-center" }, {
                      default: _(() => [
                        y("span", B1, U(a.$t("medic-web-framework.eIFU")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(Bo), null, {
              default: _(() => [
                d(r(ot), { class: "grow" }, {
                  default: _(() => [
                    d(pn, {
                      value: t.value.model
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.version,
                      logo: "modelNumber"
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.license,
                      logo: "softwareLicence"
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.softwareVersion,
                      logo: "softwareVersions"
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.udi,
                      logo: "UDIsymbol"
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.build,
                      logo: "manufactureDate"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(Ll),
        d(r(ke), null, {
          default: _(() => [
            d(r(ot), { class: "items-center justify-center grow" }, {
              default: _(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/certificate.png"),
                  width: "75",
                  alt: "certificate"
                }, null, 8, U1)
              ]),
              _: 1
            }),
            d(r(ot), { class: "items-center justify-center grow" }, {
              default: _(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/MD.png"),
                  width: "75",
                  alt: "MD"
                }, null, 8, G1)
              ]),
              _: 1
            }),
            d(r(ot), { class: "items-center justify-center grow" }, {
              default: _(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/RX.png"),
                  width: "75",
                  alt: "RX"
                }, null, 8, W1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(Ll),
        d(r(ke), null, {
          default: _(() => [
            d(r(ot), { class: "items-center justify-center grow" }, {
              default: _(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/black_rg.png"),
                  width: "75",
                  alt: "RG"
                }, null, 8, z1),
                d(r(ke), { class: "justify-center" }, {
                  default: _(() => [...o[1] || (o[1] = [
                    y("span", {
                      class: "text-2xl",
                      style: { color: "black", "font-weight": "600" }
                    }, "RealGUIDE®", -1)
                  ])]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(ot), { class: "grow" }, {
              default: _(() => [
                d(pn, {
                  value: t.value.company.name,
                  center: !0
                }, null, 8, ["value"]),
                d(pn, {
                  value: t.value.company.address,
                  center: !0
                }, null, 8, ["value"]),
                d(pn, {
                  value: t.value.company.website,
                  center: !0
                }, null, 8, ["value"]),
                d(pn, {
                  value: t.value.company.email,
                  center: !0
                }, null, 8, ["value"]),
                d(pn, {
                  value: t.value.company.telephone,
                  center: !0
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            d(r(ot), { class: "items-center justify-center grow" }, {
              default: _(() => [
                y("img", {
                  src: r(n).getAssetUrl("/icons/info/distributor.png"),
                  width: "75",
                  alt: "distributor"
                }, null, 8, H1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(Ll),
        d(r(ke), null, {
          default: _(() => [
            d(r(Bo), null, {
              default: _(() => [
                d(r(ot), { class: "items-center justify-center grow" }, {
                  default: _(() => [
                    y("img", {
                      src: r(n).getAssetUrl("/icons/info/CH-REP.png"),
                      width: "150",
                      alt: "CH-REP"
                    }, null, 8, Y1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(Bo), null, {
              default: _(() => [
                d(r(ot), { class: "grow" }, {
                  default: _(() => [
                    d(pn, {
                      value: t.value.headquarter.name
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.headquarter.address
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.headquarter.city
                    }, null, 8, ["value"]),
                    d(pn, {
                      value: t.value.headquarter.country
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), K1 = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
function rm() {
  return K1;
}
let Sr, Er;
function MP(e) {
  Sr = e;
}
function PP(e) {
  Er = e;
}
function Z1() {
  return Sr || rm().VITE_APP_ENVIRONMENT;
}
function ad() {
  return Er !== void 0 ? Er : rm().NODE_ENV === "development";
}
function um() {
  const e = Z1();
  return console.log("isDevelopmentModulesEnabled", e, ad()), ad() || ["sigma"].includes(e || "");
}
class X1 {
  constructor() {
    an(this, "SHOW_CAD_WIZARD", !1);
    an(this, "VENDOR_ID");
  }
}
const bo = new X1(), J1 = {
  style: { width: "860px" },
  class: "ip-viewer-settings -mt-2"
}, q1 = { class: "p-tabmenu p-component -mt-2" }, Q1 = { key: 0 }, e_ = { class: "settings-rows" }, t_ = { style: { width: "100%", display: "grid", "grid-template-columns": "1fr 1fr", "grid-template-rows": "auto auto auto", "grid-gap": "16px" } }, n_ = { class: "grid-auto-equal-columns" }, a_ = { class: "settings-rows" }, o_ = { class: "settings-rows" }, l_ = { class: "grid-auto-equal-columns" }, i_ = ["for"], s_ = { class: "settings-rows" }, r_ = { style: { width: "100%", display: "grid", "grid-template-columns": "1fr 1fr", "grid-template-rows": "auto auto auto", "grid-gap": "16px" } }, u_ = { key: 1 }, c_ = { class: "settings-rows" }, d_ = { style: { width: "100%", display: "grid", "grid-auto-rows": "1fr", "grid-auto-columns": "1fr", gap: "16px" } }, p_ = { class: "settings-rows" }, m_ = { class: "grid-auto-equal-columns" }, f_ = { style: { display: "flex", width: "100%", "justify-content": "center", gap: "16px" } }, g_ = { class: "grid-auto-equal-columns" }, h_ = { class: "settings-rows" }, b_ = { class: "settings-rows" }, v_ = { class: "settings-rows" }, y_ = {
  key: 2,
  class: "pt-4"
}, __ = {
  key: 0,
  style: { display: "flex", "justify-content": "center" }
}, du = /* @__PURE__ */ Je({
  __name: "IPViewerSettings",
  props: {
    visible: { type: Boolean, default: !1 },
    settings: {},
    license: {}
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = e, a = t, { visible: o } = on(n), l = (m) => {
      s.value = ic(m, bo.VENDOR_ID);
    }, s = B(ic(n.license, bo.VENDOR_ID)), i = () => ({
      general: Wn(h),
      implants: Wn(g),
      defaultColors: Wn(b)
      // freeFormTool: toRaw(freeFromTool),
      // meshFreeFormTool: toRaw(meshFreeFromTool),
    }), u = () => {
      n.settings.update(structuredClone(i())), a("confirm");
    }, c = () => {
      a("cancel");
    }, p = B(null);
    lt(o, async () => {
      var m;
      o.value && (await mn(), (m = p.value) == null || m.$el.focus());
    }), Dt(() => {
      var m;
      o.value && ((m = p.value) == null || m.$el.focus());
    }), lt(
      () => n.license,
      (m) => {
        l(m);
      }
    ), lt(
      () => o.value,
      (m) => {
        m && l(n.license);
      },
      { immediate: !0 }
    );
    const h = tt(structuredClone(n.settings.general)), g = tt(structuredClone(n.settings.implants)), b = tt(structuredClone(n.settings.defaultColors)), E = B(
      0
      /* General */
    );
    return (m, I) => {
      const S = im, f = R1, v = f1, w = d1, A = i1, T = e1, O = Kv;
      return L(), be(r(Cg), {
        onClose: c,
        visible: r(o),
        style: { width: "1200px !important" }
      }, {
        header: _(() => [
          It(m.$slots, "header", {}, () => [
            vt(U(m.$t("shared.settings")), 1)
          ])
        ]),
        default: _(() => [
          y("div", J1, [
            y("div", q1, [
              d(r(ke), {
                class: "gap-2 -mt-1",
                role: "tablist"
              }, {
                default: _(() => [
                  d(r(Vl), {
                    state: E.value,
                    "onUpdate:state": I[0] || (I[0] = (C) => E.value = C),
                    index: 0,
                    class: "mt-1"
                  }, {
                    default: _(() => [
                      vt(U(m.$t("implant-planner.general")), 1)
                    ]),
                    _: 1
                  }, 8, ["state", "index"]),
                  d(r(Vl), {
                    state: E.value,
                    "onUpdate:state": I[1] || (I[1] = (C) => E.value = C),
                    index: 1,
                    class: "mt-1"
                  }, {
                    default: _(() => [
                      vt(U(m.$t("implant-planner.implants")), 1)
                    ]),
                    _: 1
                  }, 8, ["state", "index"]),
                  d(r(Vl), {
                    state: E.value,
                    "onUpdate:state": I[2] || (I[2] = (C) => E.value = C),
                    index: 2,
                    class: "mt-1",
                    style: { width: "75px !important" }
                  }, {
                    default: _(() => [
                      vt(U(m.$t("shared.info")), 1)
                    ]),
                    _: 1
                  }, 8, ["state", "index"])
                ]),
                _: 1
              })
            ]),
            d(S),
            E.value === 0 ? (L(), H("div", Q1, [
              d(w, {
                title: m.$t("implant-planner.general")
              }, {
                default: _(() => [
                  y("div", e_, [
                    y("div", t_, [
                      d(f, {
                        modelValue: h.autosaveIntervalMinutes,
                        "onUpdate:modelValue": I[3] || (I[3] = (C) => h.autosaveIntervalMinutes = C),
                        max: 240,
                        min: 0,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.autosaveInterval"),
                        style: { "grid-column": "1", "grid-row": "1" },
                        suffix: " min"
                      }, null, 8, ["modelValue", "label"]),
                      d(f, {
                        modelValue: h.measurementFont,
                        "onUpdate:modelValue": I[4] || (I[4] = (C) => h.measurementFont = C),
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.measurementFont"),
                        style: { "grid-column": "1", "grid-row": "2" }
                      }, null, 8, ["modelValue", "label"]),
                      d(f, {
                        modelValue: h.topCenterlineSizeOn3dMm,
                        "onUpdate:modelValue": I[5] || (I[5] = (C) => h.topCenterlineSizeOn3dMm = C),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.topCenterlineSizeOnD"),
                        style: { "grid-column": "1", "grid-row": "3" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"]),
                      d(f, {
                        modelValue: h.crossSectionSizeMm,
                        "onUpdate:modelValue": I[6] || (I[6] = (C) => h.crossSectionSizeMm = C),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.crossSectionSize"),
                        style: { "grid-column": "2", "grid-row": "2" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"]),
                      d(f, {
                        modelValue: h.bottomCenterlineSizeOn3dMm,
                        "onUpdate:modelValue": I[7] || (I[7] = (C) => h.bottomCenterlineSizeOn3dMm = C),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.bottomCenterlineSizeOnD"),
                        style: { "grid-column": "2", "grid-row": "3" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    y("div", n_, [
                      y("div", a_, [
                        d(v, {
                          state: h.useUSStyleToothChart,
                          "onUpdate:state": I[8] || (I[8] = (C) => h.useUSStyleToothChart = C),
                          label: m.$t("implant-planner.useUsStyleToothChart")
                        }, null, 8, ["state", "label"]),
                        d(v, {
                          state: h.refreshAll2dWhileMovingObjects,
                          "onUpdate:state": I[9] || (I[9] = (C) => h.refreshAll2dWhileMovingObjects = C),
                          label: m.$t("implant-planner.refreshAllDImagesWhileMovingImplantsAndObjects")
                        }, null, 8, ["state", "label"]),
                        d(v, {
                          state: h.useLeftButtonForRotationOn3d,
                          "onUpdate:state": I[10] || (I[10] = (C) => h.useLeftButtonForRotationOn3d = C),
                          label: m.$t("implant-planner.useLeftMouseButtonInsteadOfRightForRotationInD")
                        }, null, 8, ["state", "label"])
                      ]),
                      y("div", o_, [
                        d(v, {
                          state: h.snapToImplant,
                          "onUpdate:state": I[11] || (I[11] = (C) => h.snapToImplant = C),
                          label: m.$t("implant-planner.snapToImplant")
                        }, null, 8, ["state", "label"]),
                        d(v, {
                          state: h.showCPRScoutPlane,
                          "onUpdate:state": I[12] || (I[12] = (C) => h.showCPRScoutPlane = C),
                          label: m.$t("implant-planner.showCprScoutPlane")
                        }, null, 8, ["state", "label"]),
                        d(v, {
                          state: h.showHintWindow,
                          "onUpdate:state": I[13] || (I[13] = (C) => h.showHintWindow = C),
                          label: m.$t("implant-planner.showHintWindow")
                        }, null, 8, ["state", "label"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              d(w, {
                title: m.$t("implant-planner.crosshairType")
              }, {
                default: _(() => [
                  y("div", l_, [
                    (L(!0), H(He, null, jt(r(Hg), (C) => (L(), H("div", {
                      key: C,
                      style: { display: "flex", gap: "8px" }
                    }, [
                      d(A, {
                        modelValue: h.crosshairType,
                        "onUpdate:modelValue": (k) => h.crosshairType = k,
                        inputId: C,
                        value: C
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId", "value"]),
                      y("label", { for: C }, U(m.$t("implant-planner.crosshairType" + C)), 9, i_)
                    ]))), 128))
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              d(w, {
                title: m.$t("implant-planner.defaultBrightnesscontrast")
              }, {
                default: _(() => [
                  y("div", s_, [
                    y("div", r_, [
                      d(f, {
                        modelValue: h.defaultWindowWidth,
                        "onUpdate:modelValue": I[14] || (I[14] = (C) => h.defaultWindowWidth = C),
                        max: 1e4,
                        maxFractionDigits: 0,
                        min: -1e4,
                        minFractionDigits: 0,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.ww"),
                        style: { "grid-column": "1", "grid-row": "1" },
                        suffix: ""
                      }, null, 8, ["modelValue", "label"]),
                      d(f, {
                        modelValue: h.defaultWindowLevel,
                        "onUpdate:modelValue": I[15] || (I[15] = (C) => h.defaultWindowLevel = C),
                        max: 1e4,
                        maxFractionDigits: 0,
                        min: -1e4,
                        minFractionDigits: 0,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.wl"),
                        style: { "grid-column": "2", "grid-row": "1" },
                        suffix: ""
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ])) : ue("", !0),
            E.value === 1 ? (L(), H("div", u_, [
              d(w, {
                title: m.$t("implant-planner.warnings")
              }, {
                default: _(() => [
                  y("div", c_, [
                    y("div", d_, [
                      d(v, {
                        state: g.showWarningsPopup,
                        "onUpdate:state": I[16] || (I[16] = (C) => g.showWarningsPopup = C),
                        label: m.$t("implant-planner.showWarningsPopup"),
                        style: { "grid-column": "1", "grid-row": "1" }
                      }, null, 8, ["state", "label"]),
                      d(v, {
                        state: g.nerveWarning,
                        "onUpdate:state": I[17] || (I[17] = (C) => g.nerveWarning = C),
                        label: m.$t("implant-planner.nerveWarning"),
                        style: { "grid-column": "1", "grid-row": "2" }
                      }, null, 8, ["state", "label"]),
                      d(v, {
                        state: g.securityZone,
                        "onUpdate:state": I[18] || (I[18] = (C) => g.securityZone = C),
                        label: m.$t("implant-planner.securityZone"),
                        style: { "grid-column": "1", "grid-row": "3" }
                      }, null, 8, ["state", "label"]),
                      d(f, {
                        modelValue: g.minimumDistanceFromNerveMm,
                        "onUpdate:modelValue": I[19] || (I[19] = (C) => g.minimumDistanceFromNerveMm = C),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 1,
                        label: m.$t("implant-planner.minimumDistanceFromNerve"),
                        style: { "grid-column": "2", "grid-row": "2" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"]),
                      d(f, {
                        modelValue: g.securityZoneSizeMm,
                        "onUpdate:modelValue": I[20] || (I[20] = (C) => g.securityZoneSizeMm = C),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 0.5,
                        label: m.$t("implant-planner.securityZoneSize"),
                        style: { "grid-column": "2", "grid-row": "3" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    d(T, {
                      modelValue: g.securityZoneTransparencyPercent,
                      "onUpdate:modelValue": I[21] || (I[21] = (C) => g.securityZoneTransparencyPercent = C),
                      max: 100,
                      min: 0,
                      step: 1,
                      label: m.$t("implant-planner.securityZoneTransparency")
                    }, null, 8, ["modelValue", "label"])
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              d(w, { title: "" }, {
                default: _(() => [
                  y("div", p_, [
                    y("div", m_, [
                      d(v, {
                        state: g.showImplantStepButtons,
                        "onUpdate:state": I[22] || (I[22] = (C) => g.showImplantStepButtons = C),
                        label: m.$t("implant-planner.showImplantStepButtons")
                      }, null, 8, ["state", "label"]),
                      d(v, {
                        state: g.showBLAngle,
                        "onUpdate:state": I[23] || (I[23] = (C) => g.showBLAngle = C),
                        label: m.$t("implant-planner.showBlAngle")
                      }, null, 8, ["state", "label"]),
                      d(v, {
                        state: g.showAllAbutmentManufacturers,
                        "onUpdate:state": I[24] || (I[24] = (C) => g.showAllAbutmentManufacturers = C),
                        label: m.$t("implant-planner.showAllTheAbutmentManufacturers")
                      }, null, 8, ["state", "label"])
                    ]),
                    y("div", f_, [
                      d(f, {
                        modelValue: g.preciseMovementStepMm,
                        "onUpdate:modelValue": I[25] || (I[25] = (C) => g.preciseMovementStepMm = C),
                        max: 99.99,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 0.5,
                        label: m.$t("implant-planner.preciseMovementStep"),
                        style: { "flex-grow": "1" },
                        suffix: " mm"
                      }, null, 8, ["modelValue", "label"]),
                      d(f, {
                        modelValue: g.preciseRotationStepDeg,
                        "onUpdate:modelValue": I[26] || (I[26] = (C) => g.preciseRotationStepDeg = C),
                        max: 9.99,
                        maxFractionDigits: 2,
                        min: 0.1,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 0.2,
                        label: m.$t("implant-planner.preciseRotationStep"),
                        style: { "flex-grow": "1" },
                        suffix: "°"
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ])
                ]),
                _: 1
              }),
              d(w, {
                title: m.$t("implant-planner.defaultColors")
              }, {
                default: _(() => [
                  y("div", g_, [
                    y("div", h_, [
                      d(O, {
                        modelValue: b.implant,
                        "onUpdate:modelValue": I[27] || (I[27] = (C) => b.implant = C),
                        label: m.$t("implant-planner.implant color")
                      }, null, 8, ["modelValue", "label"]),
                      d(O, {
                        modelValue: b.abutment,
                        "onUpdate:modelValue": I[28] || (I[28] = (C) => b.abutment = C),
                        label: m.$t("implant-planner.abutment color")
                      }, null, 8, ["modelValue", "label"]),
                      d(O, {
                        modelValue: b.securityZone,
                        "onUpdate:modelValue": I[29] || (I[29] = (C) => b.securityZone = C),
                        label: m.$t("implant-planner.security zone color")
                      }, null, 8, ["modelValue", "label"]),
                      d(O, {
                        modelValue: b.sleeves,
                        "onUpdate:modelValue": I[30] || (I[30] = (C) => b.sleeves = C),
                        label: m.$t("implant-planner.sleeves color")
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    y("div", b_, [
                      d(O, {
                        modelValue: b.nerves,
                        "onUpdate:modelValue": I[31] || (I[31] = (C) => b.nerves = C),
                        label: m.$t("implant-planner.nerves color")
                      }, null, 8, ["modelValue", "label"]),
                      d(O, {
                        modelValue: b.collision,
                        "onUpdate:modelValue": I[32] || (I[32] = (C) => b.collision = C),
                        label: m.$t("implant-planner.collision color")
                      }, null, 8, ["modelValue", "label"]),
                      d(O, {
                        modelValue: b.modelTools,
                        "onUpdate:modelValue": I[33] || (I[33] = (C) => b.modelTools = C),
                        label: m.$t("implant-planner.model tools color")
                      }, null, 8, ["modelValue", "label"]),
                      d(O, {
                        modelValue: b.teeth,
                        "onUpdate:modelValue": I[34] || (I[34] = (C) => b.teeth = C),
                        label: m.$t("implant-planner.teeth color")
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    y("div", v_, [
                      d(O, {
                        modelValue: b.prosthesisScanStl,
                        "onUpdate:modelValue": I[35] || (I[35] = (C) => b.prosthesisScanStl = C),
                        label: m.$t("implant-planner.prosthesis scan STL color")
                      }, null, 8, ["modelValue", "label"]),
                      d(O, {
                        modelValue: b.teethScanStl,
                        "onUpdate:modelValue": I[36] || (I[36] = (C) => b.teethScanStl = C),
                        label: m.$t("implant-planner.teeth scan STL color")
                      }, null, 8, ["modelValue", "label"]),
                      d(O, {
                        modelValue: b.guides,
                        "onUpdate:modelValue": I[37] || (I[37] = (C) => b.guides = C),
                        label: m.$t("implant-planner.guides color")
                      }, null, 8, ["modelValue", "label"]),
                      d(O, {
                        modelValue: b.cprColor,
                        "onUpdate:modelValue": I[38] || (I[38] = (C) => b.cprColor = C),
                        label: m.$t("implant-planner.cprColor")
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title"])
            ])) : ue("", !0),
            E.value === 2 ? (L(), H("div", y_, [
              d(sm, {
                model: s.value,
                "onUpdate:model": I[39] || (I[39] = (C) => s.value = C)
              }, null, 8, ["model"])
            ])) : ue("", !0)
          ])
        ]),
        actions: _(() => [
          E.value === 2 ? (L(), H("div", __, [
            d(r(Ng), {
              label: m.$t("shared.close"),
              icon: "pi pi-times",
              onClick: c
            }, null, 8, ["label"])
          ])) : (L(), be(r(Lg), {
            key: 1,
            acceptLabel: m.$t("shared.ok"),
            rejectLabel: m.$t("shared.cancel"),
            onAccept: u,
            onReject: c
          }, null, 8, ["acceptLabel", "rejectLabel"]))
        ]),
        _: 3
      }, 8, ["visible"]);
    };
  }
}), w_ = { class: "h-full" }, pu = /* @__PURE__ */ Je({
  __name: "IPWizardCardContainer",
  props: {
    isFirstItem: { type: Boolean },
    isLastItem: { type: Boolean },
    isVisible: { type: Boolean }
  },
  emits: ["hideWizard", "previousStep", "nextStep"],
  setup(e, { emit: t }) {
    const n = e, a = t;
    return (o, l) => (L(), H("div", w_, [
      d(r(ot), {
        class: "h-full",
        style: { width: "309px", position: "relative" }
      }, {
        default: _(() => [
          d(r(ot), {
            class: "overflow-x-hidden overflow-y-auto h-full grow",
            id: "wizardBody"
          }, {
            default: _(() => [
              It(o.$slots, "default", {
                onHideWizard: l[0] || (l[0] = (s) => a("hideWizard"))
              })
            ]),
            _: 3
          }),
          e.isVisible ? (L(), be(r(ke), {
            key: 0,
            class: "horizontal-padding gap-2 pt-16px pb-16px"
          }, {
            default: _(() => [
              d(r(Ne), {
                id: "btnPreviousStep",
                disabled: n.isFirstItem,
                iconSrc: "/icons/rg_chevron_left.svg",
                "icon-src-height": "21px",
                "icon-src-width": "21px",
                class: Ge(["web-rg-icon-btn"]),
                label: o.$t("implant-planner.previousStep"),
                style: { flex: "1 1 0" },
                onClick: l[1] || (l[1] = (s) => o.$emit("previousStep"))
              }, null, 8, ["disabled", "label"]),
              d(r(Ne), {
                id: "btnNextStep",
                disabled: n.isLastItem,
                iconRight: !0,
                iconSrc: "/icons/rg_chevron_right.svg",
                "icon-src-height": "21px",
                "icon-src-width": "21px",
                class: Ge(["h-56px grow"]),
                label: o.$t("implant-planner.nextStep"),
                style: { "border-radius": "16px", flex: "1 1 0" },
                onClick: l[2] || (l[2] = (s) => o.$emit("nextStep"))
              }, null, 8, ["disabled", "label"])
            ]),
            _: 1
          })) : ue("", !0)
        ]),
        _: 3
      })
    ]));
  }
});
function il(e) {
  return {
    wizardIndex: 0,
    oldLayout: e || Fe._FULLSCREEN_3D,
    newLayout: e || Fe._FULLSCREEN_3D,
    fullscreen: void 0,
    wizardPanelVisible: !0
  };
}
function I_(e, t, n) {
  return {
    wizardIndex: e,
    oldLayout: Fe._FULLSCREEN_3D,
    newLayout: void 0,
    availableLayouts: t || (n ? E_() : S_()),
    wizardPanelVisible: !1
  };
}
function S_() {
  return [
    { name: "MPR", code: Fe._MPR },
    { name: "3D + MPR", code: Fe._3D_MPR },
    { name: "LARGE 3D + MPR", code: Fe._LARGE_3D_MPR },
    { name: "FULLSCREEN", code: Fe._FULLSCREEN_3D },
    { name: "3D + 3x1 + CPR XRay", code: Fe._3D_3X1_CPR_XRAY },
    { name: "3D + Cross + Axial", code: Fe._3D_CROSS_AXIAL },
    { name: "3D + Cross + CPR", code: Fe._3D_CROSS_CPR },
    { name: "3D + Cross + Tangent + Axial", code: Fe._3D_CROSS_TANGENT_AXIAL },
    { name: "3D + CPR + Cross + Tangent + Axial", code: Fe._3D_CPR_CROSS_TANGENT_AXIAL },
    { name: "3D + Axial + 5x1", code: Fe._3D_AXIAL_5X1 }
  ];
}
function E_() {
  return [
    { name: "MPR", code: Fe._MPR },
    { name: "3D + MPR", code: Fe._3D_MPR },
    { name: "LARGE 3D + MPR", code: Fe._LARGE_3D_MPR },
    { name: "FULLSCREEN", code: Fe._FULLSCREEN_3D },
    { name: "3D + Cross + Axial", code: Fe._3D_CROSS_AXIAL },
    // { name: "3D + Cross + CPR", code: LayoutTemplate._3D_CROSS_CPR },
    { name: "3D + Cross + Tangent + Axial", code: Fe._3D_CROSS_TANGENT_AXIAL }
    // { name: "3D + CPR + Cross + Tangent + Axial", code: LayoutTemplate._3D_CPR_CROSS_TANGENT_AXIAL },
  ];
}
function T_() {
  return [
    { name: "Preview + Cross + Tangent", code: Fe._STL_PICKER_PREVIEW },
    { name: "Preview + Cross + 3D", code: Fe._STL_PICKER_PREVIEW_2 }
  ];
}
function C_() {
  return [
    { name: "3D", code: Fe._FULLSCREEN_3D },
    { name: "AXIAL", code: Fe._FULLSCREEN_AXIAL },
    { name: "CORONAL", code: Fe._FULLSCREEN_CORONAL },
    { name: "SAGITTAL", code: Fe._FULLSCREEN_SAGITTAL },
    { name: "CPR", code: Fe._FULLSCREEN_CPR },
    { name: "CROSS", code: Fe._FULLSCREEN_CROSS }
  ];
}
const N_ = { class: "layout-dialog-grid mt-6" }, L_ = ["data-cy", "onClick"], O_ = ["src"], D_ = {
  key: 0,
  class: "flex items-center justify-center layout-dialog-grid-item-label"
}, A_ = {
  key: 0,
  class: "mt-1"
}, R_ = /* @__PURE__ */ Je({
  __name: "IPLayoutDialog",
  props: /* @__PURE__ */ Rn({
    modelValue: {}
  }, {
    cadMode: { type: Boolean, default: !1 },
    cadModeModifiers: {}
  }),
  emits: /* @__PURE__ */ Rn(["updateLayout"], ["update:cadMode"]),
  setup(e, { emit: t }) {
    const n = e, a = Nn(e, "cadMode"), o = tt(I_(n.modelValue.wizardIndex, void 0, a.value)), l = dn(), s = l.objects.hasCPR(), i = t, u = B(Number(n.modelValue.oldLayout)), c = sa(), p = (f) => {
      const v = Object.keys(Fe).indexOf(f.toString());
      return l.layoutManager.layoutTemplateContainsCpr(v);
    }, h = (f) => !s && p(f), g = C_().filter((f) => !h(f.code)), b = B(g.find((f) => f.code === n.modelValue.newLayout));
    Ga(() => {
      n.modelValue && Object.assign(o, n.modelValue);
    }), Dt(() => {
      n.modelValue && Object.assign(o, n.modelValue);
    });
    const E = (f) => {
      u.value = f, i("updateLayout", Object.keys(Fe).indexOf(f.toString()));
    }, m = () => {
      b.value && i("updateLayout", Object.keys(Fe).indexOf(b.value.code.toString()));
    }, I = (f, v) => {
      const w = "/img/" + f + ".svg";
      return c.getAssetUrl(w);
    }, S = (f) => f === 3;
    return (f, v) => (L(), H("div", N_, [
      (L(!0), H(He, null, jt(o.availableLayouts, (w) => (L(), H("div", {
        key: w.name,
        class: "cursor-pointer flex flex-col items-center",
        style: Et({
          opacity: h(w.code) ? "0.5" : "1",
          pointerEvents: h(w.code) ? "none" : "auto"
        }),
        "data-cy": `layout-${w.name}`,
        onClick: (A) => E(w.code)
      }, [
        y("div", null, [
          y("div", {
            class: Ge(["flex colored-background", { "colored-background-selected": w.code == u.value }])
          }, [
            y("img", {
              src: I(w.code, u.value),
              alt: "",
              class: Ge(["filter-class", { "filter-class-selected": w.code == u.value }]),
              draggable: "false"
            }, null, 10, O_)
          ], 2),
          S(w.code) ? ue("", !0) : (L(), H("span", D_, U(w.name), 1))
        ]),
        S(w.code) ? (L(), H("div", A_, [
          d(r($n), {
            modelValue: b.value,
            "onUpdate:modelValue": v[0] || (v[0] = (A) => b.value = A),
            options: r(g),
            optionLabel: "name",
            placeholder: f.$t("implant-planner.fullscreen"),
            style: { width: "192px" },
            onChange: m
          }, null, 8, ["modelValue", "options", "placeholder"])
        ])) : ue("", !0)
      ], 12, L_))), 128))
    ]));
  }
}), mu = /* @__PURE__ */ Vt(R_, [["__scopeId", "data-v-564ee045"]]), M_ = {}, P_ = { class: "text-2xl" };
function x_(e, t) {
  return L(), H("div", P_, [
    It(e.$slots, "default")
  ]);
}
const io = /* @__PURE__ */ Vt(M_, [["render", x_]]), Mo = /* @__PURE__ */ Je({
  __name: "IPWizardTitle",
  props: {
    hideWizardBtn: { type: Boolean, default: !1 },
    hideWizardBtnModifiers: {},
    ignoreHorizontalPadding: { type: Boolean, default: !1 },
    ignoreHorizontalPaddingModifiers: {}
  },
  emits: /* @__PURE__ */ Rn(["hideWizard", "showWizard"], ["update:hideWizardBtn", "update:ignoreHorizontalPadding"]),
  setup(e, { emit: t }) {
    const n = Nn(e, "hideWizardBtn"), a = Nn(e, "ignoreHorizontalPadding"), o = t, l = Ce(() => a.value ? "" : "padding-left: 16px"), s = Ce(() => a.value ? "" : "padding-right: 16px");
    return (i, u) => (L(), be(r(ke), {
      class: "vertical-padding",
      style: { "border-bottom": "1px var(--p-rg-border-color) solid" }
    }, {
      default: _(() => [
        d(r(Ot), {
          class: "text-2xl items-center",
          style: Et(r(l))
        }, {
          default: _(() => [
            It(i.$slots, "default")
          ]),
          _: 3
        }, 8, ["style"]),
        n.value ? ue("", !0) : (L(), be(r(we), {
          key: 0,
          class: "items-center",
          style: Et(r(s))
        }, {
          default: _(() => [
            d(r(Ne), {
              class: "web-rg-toggle-wiz-btn",
              "icon-src-height": "21px",
              "icon-src-width": "21px",
              iconSrc: "/icons/rg_left_panel_close.svg",
              onClick: u[0] || (u[0] = (c) => o("hideWizard"))
            })
          ]),
          _: 1
        }, 8, ["style"]))
      ]),
      _: 3
    }));
  }
}), fl = /* @__PURE__ */ Je({
  __name: "IPWizardBody",
  setup(e) {
    return (t, n) => (L(), be(r(ot), {
      class: "mt-2 gap-2 horizontal-padding",
      style: { height: "100% !important", "overflow-y": "auto" }
    }, {
      default: _(() => [
        It(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), j_ = { class: "font-medium mr-2" }, $_ = { class: "font-medium ml-2" }, F_ = /* @__PURE__ */ Je({
  __name: "IPVoiSettingsWizard",
  emits: ["hideWizard"],
  setup(e, { emit: t }) {
    const n = t;
    let a = tt({
      disabled: !1,
      pressable: !0,
      pressed: !0
    });
    const o = B(!1), l = B(!1);
    let s = tt({
      disabled: !0,
      pressable: !1,
      pressed: !1
    }), i = tt({
      disabled: !0,
      pressable: !1,
      pressed: !1
    }), u = tt({
      disabled: !0,
      pressable: !0,
      toggleable: !0
    });
    lt(a, () => {
      console.log("btnPermanentlyTrim", a);
    });
    let c;
    Dt(async () => {
      c = dn();
    });
    let p = B(!1), h = null, g = null;
    lt(p, () => {
      if (console.log("Switch changed"), p.value)
        console.log("crop on"), a.pressed = !1, c.toolManager.setTool(_n.CROPPING, rn.PRIMARY), g = c.toolManager.getToolInstance(rn.PRIMARY);
      else {
        console.log("crop off"), c.toolManager.setTool(_n.NONE, rn.PRIMARY);
        const { volumeMapper: v } = c.getVolume();
        v && (v.removeAllClippingPlanes(), v.modified()), c.repaint(), a.pressed = !0;
      }
    });
    async function b() {
      p.value && (console.log("Permanently trim!"), await (g == null ? void 0 : g.permanentlyCrop()), p.value = !1);
    }
    const E = () => {
      console.log("Calling flipZ"), c.flipImage(!1, !1, !0);
    };
    function m(v, w, A) {
      console.log("Rotating image!"), c.rotateImage(v, w, A);
    }
    async function I(v) {
      v ? (await c.toolManager.setTool(_n.SCULPTING, rn.PRIMARY), h = c.toolManager.getToolInstance(rn.PRIMARY), h.sculptingEnabled(!0), o.value = !0, i.disabled = !1, l.value = !1, u.disabled = !1, s.disabled = !1) : (h = c.toolManager.getToolInstance(rn.PRIMARY), h && h.sculptingEnabled(!1), o.value = !1, i.disabled = !0, l.value = !1, u.disabled = !0, s.disabled = !0);
    }
    async function S() {
      await (h == null ? void 0 : h.sculpt()), o.value = !1, i.disabled = !0, u.disabled = !0, s.disabled = !0;
    }
    function f() {
      console.log("Invert pressed", l.value), h == null || h.invert(l.value);
    }
    return (v, w) => {
      const A = Mo, T = io;
      return L(), H(He, null, [
        d(A, {
          onHideWizard: w[0] || (w[0] = (O) => n("hideWizard"))
        }, {
          default: _(() => [
            vt(U(v.$t("implant-planner.imageWizard")), 1)
          ]),
          _: 1
        }),
        d(fl, null, {
          default: _(() => [
            d(r(ke), null, {
              default: _(() => [
                d(r(Ot), null, {
                  default: _(() => [
                    d(T, null, {
                      default: _(() => [
                        vt(U(v.$t("implant-planner.trimming")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(we), null, {
                  default: _(() => [
                    d(r(no), {
                      id: "switchTrimming",
                      state: r(p),
                      "onUpdate:state": w[1] || (w[1] = (O) => Wa(p) ? p.value = O : p = O)
                    }, {
                      falseLabel: _(() => [
                        y("span", j_, U(v.$t("implant-planner.off")), 1)
                      ]),
                      trueLabel: _(() => [
                        y("span", $_, U(v.$t("implant-planner.on")), 1)
                      ]),
                      _: 1
                    }, 8, ["state"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(ke), null, {
              default: _(() => [
                d(r(Ot), { class: "mt-2" }, {
                  default: _(() => [
                    d(r(Ne), {
                      id: "btnPermanentlyTrim",
                      class: "w-full web-rg-wiz-btn",
                      disabled: r(a).pressed,
                      label: v.$t("implant-planner.permanentlyTrim"),
                      onClick: b
                    }, null, 8, ["disabled", "label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(ot), null, {
              default: _(() => [
                d(r(Ot), null, {
                  default: _(() => [
                    d(T, null, {
                      default: _(() => [
                        vt(U(v.$t("implant-planner.sculpting")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ot), { class: "mt-2 gap-2" }, {
                  default: _(() => [
                    d(r(Ne), {
                      toggled: o.value,
                      togglable: !0,
                      class: "w-full web-rg-wiz-btn",
                      label: v.$t("implant-planner.startSculpting"),
                      "data-cy": "startSculpting",
                      onToggledChange: w[2] || (w[2] = (O) => I(!o.value))
                    }, null, 8, ["toggled", "label"]),
                    d(r(Ne), {
                      disabled: r(u).disabled,
                      togglable: !0,
                      toggled: l.value,
                      "onUpdate:toggled": w[3] || (w[3] = (O) => l.value = O),
                      class: "w-full web-rg-wiz-btn",
                      label: v.$t("implant-planner.invert"),
                      "data-cy": "invertSculpting",
                      onToggledChange: w[4] || (w[4] = (O) => f())
                    }, null, 8, ["disabled", "toggled", "label"]),
                    d(r(Ne), {
                      disabled: r(i).disabled,
                      class: "w-full web-rg-wiz-btn",
                      label: v.$t("implant-planner.sculpt"),
                      "data-cy": "sculpt",
                      onClick: S
                    }, null, 8, ["disabled", "label"]),
                    d(r(Ne), {
                      disabled: r(s).disabled,
                      class: "w-full web-rg-wiz-btn",
                      label: v.$t("shared.cancel"),
                      "data-cy": "cancelSculpting",
                      onClick: w[5] || (w[5] = (O) => I(!1))
                    }, null, 8, ["disabled", "label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(ot), { class: "gap-2" }, {
              default: _(() => [
                d(r(Ot), null, {
                  default: _(() => [
                    d(T, null, {
                      default: _(() => [
                        vt(U(v.$t("implant-planner.changeOrientation")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Ot), null, {
                  default: _(() => [
                    d(r(Ne), {
                      id: "btnFlipZ",
                      class: "w-full web-rg-wiz-btn",
                      label: v.$t("implant-planner.flipZ"),
                      onClick: E
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ot), { class: "items-center" }, {
                      default: _(() => [
                        y("span", null, U(v.$t("implant-planner.rotateAxial")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(we), { class: "gap-2" }, {
                      default: _(() => [
                        d(r(Ne), {
                          id: "btnRotateAxialMinus",
                          class: "w-full web-rg-wiz-btn",
                          label: "90 -",
                          onClick: w[6] || (w[6] = (O) => m(0, 0, -90))
                        }),
                        d(r(Ne), {
                          id: "btnRotateAxialPlus",
                          class: "w-full web-rg-wiz-btn",
                          label: "90 +",
                          onClick: w[7] || (w[7] = (O) => m(0, 0, 90))
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ot), { class: "items-center" }, {
                      default: _(() => [
                        y("span", null, U(v.$t("implant-planner.rotateCoronal")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(we), { class: "gap-2" }, {
                      default: _(() => [
                        d(r(Ne), {
                          id: "btnRotateCoronalMinus",
                          class: "w-full web-rg-wiz-btn",
                          label: "90 -",
                          onClick: w[8] || (w[8] = (O) => m(0, 90, 0))
                        }),
                        d(r(Ne), {
                          id: "btnRotateCoronalPlus",
                          class: "w-full web-rg-wiz-btn",
                          label: "90 +",
                          onClick: w[9] || (w[9] = (O) => m(0, -90, 0))
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ke), { class: "mt-2" }, {
                  default: _(() => [
                    d(r(Ot), { class: "items-center" }, {
                      default: _(() => [
                        y("span", null, U(v.$t("implant-planner.rotateSaggital")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(we), { class: "gap-2" }, {
                      default: _(() => [
                        d(r(Ne), {
                          id: "btnRotateSaggitalMinus",
                          class: "w-full web-rg-wiz-btn",
                          label: "90 -",
                          onClick: w[10] || (w[10] = (O) => m(-90, 0, 0))
                        }),
                        d(r(Ne), {
                          id: "btnRotateSaggitalPlus",
                          class: "w-full web-rg-wiz-btn",
                          label: "90 +",
                          onClick: w[11] || (w[11] = (O) => m(90, 0, 0))
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), fu = /* @__PURE__ */ Vt(F_, [["__scopeId", "data-v-a19fc1bd"]]), Ko = 1e-6;
function Na(e, t, n) {
  return Number.isFinite(e) ? Math.max(t, Math.min(n, e)) : t;
}
function vn(e) {
  return Na(e, 0, 1);
}
function cm(e) {
  return Math.sqrt(Math.sqrt(vn(e)));
}
function k_(e) {
  const t = vn(e);
  return t * t * t * t;
}
function zl(e) {
  return e.map((t) => ({ ...t }));
}
function dm(e) {
  return [...e].sort((t, n) => t.intensity - n.intensity);
}
function na(e) {
  const t = Number.isFinite(e[0]) ? e[0] : 0, n = Number.isFinite(e[1]) ? e[1] : 1;
  return t <= n ? [t, n] : [n, t];
}
function Tr(e, t) {
  const n = Number(e);
  return Number.isFinite(n) ? n : t;
}
function Gs(e) {
  const t = Tr(e, 0);
  return t > 1 && t <= 255 ? vn(t / 255) : vn(t);
}
function Ws(e, t, n) {
  const a = e, o = a[t];
  return o ?? a[n];
}
function aa(e) {
  return {
    red: Gs(Ws(e, "red", "r")),
    green: Gs(Ws(e, "green", "g")),
    blue: Gs(Ws(e, "blue", "b"))
  };
}
function pm(e, t) {
  const n = na(t), a = aa(e);
  return {
    intensity: Na(Tr(e.intensity, n[0]), n[0], n[1]),
    alpha: vn(Tr(e.alpha, 0)),
    red: a.red,
    green: a.green,
    blue: a.blue
  };
}
function oo(e, t) {
  const n = na(t), a = dm(e).map((o) => pm(o, n));
  if (a.length === 0)
    return [
      { intensity: n[0], alpha: 0, red: 0, green: 0, blue: 0 },
      { intensity: n[1], alpha: 1, red: 1, green: 1, blue: 1 }
    ];
  if (a.length === 1) {
    const o = a[0];
    return [
      { ...o, intensity: n[0] },
      { ...o, intensity: n[1] }
    ];
  }
  return a[0] = { ...a[0], intensity: n[0] }, a[a.length - 1] = { ...a[a.length - 1], intensity: n[1] }, a;
}
function V_(e, t, n) {
  const a = zl(e);
  if (a.length === 0)
    return a;
  if (a.length >= 4) {
    const l = a.length - 2;
    return a[1] = { ...a[1], red: vn(t[0]), green: vn(t[1]), blue: vn(t[2]) }, a[l] = { ...a[l], red: vn(n[0]), green: vn(n[1]), blue: vn(n[2]) }, a;
  }
  return a[0] = { ...a[0], red: vn(t[0]), green: vn(t[1]), blue: vn(t[2]) }, a[a.length - 1] = { ...a[a.length - 1], red: vn(n[0]), green: vn(n[1]), blue: vn(n[2]) }, a;
}
function B_(e, t) {
  return t.map((n, a) => {
    const o = e[a];
    if (!o)
      return n;
    const l = aa(o);
    return {
      ...n,
      red: l.red,
      green: l.green,
      blue: l.blue
    };
  });
}
function U_(e) {
  const t = dm(e);
  if (t.length >= 4) {
    const n = aa(t[1]), a = aa(t[t.length - 2]);
    return {
      left: [Math.round(n.red * 255), Math.round(n.green * 255), Math.round(n.blue * 255)],
      right: [Math.round(a.red * 255), Math.round(a.green * 255), Math.round(a.blue * 255)]
    };
  }
  if (t.length >= 2) {
    const n = aa(t[0]), a = aa(t[t.length - 1]);
    return {
      left: [Math.round(n.red * 255), Math.round(n.green * 255), Math.round(n.blue * 255)],
      right: [Math.round(a.red * 255), Math.round(a.green * 255), Math.round(a.blue * 255)]
    };
  }
  return {
    left: [255, 255, 255],
    right: [255, 255, 255]
  };
}
function Cr(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++) {
    const a = e[n], o = t[n];
    if (Math.abs(a.intensity - o.intensity) > Ko || Math.abs(a.alpha - o.alpha) > Ko || Math.abs(a.red - o.red) > Ko || Math.abs(a.green - o.green) > Ko || Math.abs(a.blue - o.blue) > Ko)
      return !1;
  }
  return !0;
}
function li(e, t) {
  const n = na(t), a = Math.max(n[1] - n[0], Ko);
  return Na((e - n[0]) / a, 0, 1);
}
function Nr(e, t) {
  const n = na(t);
  return n[0] + Na(e, 0, 1) * (n[1] - n[0]);
}
function G_(e, t, n) {
  if (e.length === 0)
    return "";
  const a = oo(e, t), o = n.top + n.height, l = [`M ${n.left} ${o}`];
  for (const s of a) {
    const i = li(s.intensity, t), u = cm(s.alpha), c = n.left + i * n.width, p = o - u * n.height;
    l.push(`L ${c} ${p}`);
  }
  return l.push(`L ${n.left + n.width} ${o}`), l.push("Z"), l.join(" ");
}
function W_(e, t) {
  if (!e.length)
    return "";
  const n = t.width / Math.max(e.length - 1, 1), a = e.map((l, s) => {
    const i = t.left + n * s, u = t.top + (1 - vn(l)) * t.height;
    return [i, u];
  }), o = [`M ${a[0][0]} ${a[0][1]}`];
  for (let l = 1; l < a.length; l++) {
    const [s, i] = a[l];
    o.push(`L ${s} ${i}`);
  }
  return o.join(" ");
}
const z_ = ["viewBox"], H_ = ["offset", "stop-color"], Y_ = ["x", "y", "width", "height", "fill"], K_ = ["x", "y", "width", "height"], Z_ = ["d"], X_ = ["d"], J_ = ["x", "y", "width", "height"], q_ = ["cx", "cy", "onPointerdown", "onContextmenu"], Q_ = ["x", "y", "width", "height"], od = 640, ld = 360, e0 = /* @__PURE__ */ Je({
  __name: "TransferFunctionEditor",
  props: {
    modelValue: {},
    intensityRange: {},
    histogram: { default: () => [] },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: o } = Ht(), l = Do(), s = B(), i = {
      left: 12,
      top: 12,
      width: 616,
      height: 312
    }, u = `tf-gradient-${Math.random().toString(36).slice(2)}`, c = B([]);
    let p = 1;
    function h(x, N) {
      return oo(zl(x), N).map((ce) => ({ ...ce, __id: p++ }));
    }
    lt(
      () => [n.modelValue, n.intensityRange],
      ([x, N]) => {
        const G = na(N), ce = oo(x || [], G), re = c.value.map(({ __id: Se, ...se }) => se);
        Cr(ce, re) || (c.value = h(ce, G));
      },
      { immediate: !0, deep: !0 }
    );
    const g = Ce(() => {
      const x = na(n.intensityRange);
      return c.value.map((N) => ({
        offset: li(N.intensity, x) * 100,
        color: m(N)
      }));
    }), b = Ce(() => W_(n.histogram || [], i)), E = Ce(() => {
      const x = c.value.map(({ __id: N, ...G }) => G);
      return G_(x, n.intensityRange, i);
    });
    function m(x) {
      const N = aa(x);
      return `rgb(${Math.round(N.red * 255)}, ${Math.round(N.green * 255)}, ${Math.round(N.blue * 255)})`;
    }
    function I(x) {
      const N = aa(x);
      return 0.299 * N.red + 0.587 * N.green + 0.114 * N.blue > 0.5 ? "#111111" : "#f5f5f5";
    }
    function S(x) {
      const N = li(x, n.intensityRange);
      return i.left + N * i.width;
    }
    function f(x) {
      const N = cm(x);
      return i.top + (1 - N) * i.height;
    }
    function v(x) {
      const N = Na((i.top + i.height - x) / i.height, 0, 1);
      return k_(N);
    }
    function w(x) {
      const N = s.value;
      if (!N)
        return { x: 0, y: 0 };
      const G = N.getBoundingClientRect(), ce = od / G.width, re = ld / G.height;
      return {
        x: (x.clientX - G.left) * ce,
        y: (x.clientY - G.top) * re
      };
    }
    function A(x) {
      const N = na(n.intensityRange), G = oo(
        x.map(({ __id: ce, ...re }) => pm(re, N)),
        N
      );
      c.value = G.map((ce, re) => {
        var Se;
        return { ...ce, __id: ((Se = x[re]) == null ? void 0 : Se.__id) ?? p++ };
      }), a("update:modelValue", G);
    }
    let T = null;
    function O(x, N) {
      n.disabled || N.button !== 0 || (T = x, window.addEventListener("pointermove", C), window.addEventListener("pointerup", k));
    }
    function C(x) {
      if (T === null)
        return;
      const N = c.value.findIndex((le) => le.__id === T);
      if (N === -1)
        return;
      const G = N === 0, ce = N === c.value.length - 1, re = w(x), Se = na(n.intensityRange);
      let se = Nr(Na((re.x - i.left) / i.width, 0, 1), Se);
      G ? se = Se[0] : ce && (se = Se[1]);
      const Le = v(Na(re.y, i.top, i.top + i.height)), Y = c.value.map((le) => ({ ...le }));
      Y[N] = {
        ...Y[N],
        intensity: se,
        alpha: Le
      };
      const pe = Y.sort((le, Re) => le.intensity - Re.intensity), fe = B_(c.value, pe);
      A(fe);
    }
    function k() {
      T = null, window.removeEventListener("pointermove", C), window.removeEventListener("pointerup", k);
    }
    function M(x) {
      if (n.disabled || x.button !== 0)
        return;
      const N = w(x);
      if (!(N.x >= i.left && N.x <= i.left + i.width && N.y >= i.top && N.y <= i.top + i.height))
        return;
      const ce = Nr((N.x - i.left) / i.width, n.intensityRange), re = v(N.y), Se = {
        __id: p++,
        intensity: ce,
        alpha: re,
        red: 1,
        green: 1,
        blue: 1
      }, se = [...c.value.map((Le) => ({ ...Le })), Se].sort((Le, Y) => Le.intensity - Y.intensity);
      A(se);
    }
    async function z(x, N) {
      if (n.disabled)
        return;
      const G = c.value.findIndex((Se) => Se.__id === x);
      if (G === -1)
        return;
      if (G === 0 || G === c.value.length - 1) {
        await j(x);
        return;
      }
      const re = await l.showContextMenu([o("shared.changeColor"), o("shared.delete")], N.clientX, N.clientY);
      re === 0 ? await j(x) : re === 1 && await K(x);
    }
    async function j(x) {
      const N = c.value.findIndex((Le) => Le.__id === x);
      if (N === -1)
        return;
      const G = c.value[N], ce = aa(G), re = [Math.round(ce.red * 255), Math.round(ce.green * 255), Math.round(ce.blue * 255)], Se = await l.showColorPickerModal(o("shared.changeColor"), re);
      if (!Se)
        return;
      const se = c.value.map((Le) => ({ ...Le }));
      se[N] = {
        ...se[N],
        red: Se[0] / 255,
        green: Se[1] / 255,
        blue: Se[2] / 255
      }, A(se);
    }
    async function K(x) {
      if (c.value.length <= 4) {
        await l.showInfoModal(o("implant-planner.warning"), o("implant-planner.transferFunctionMinPointsWarning"));
        return;
      }
      const N = c.value.filter((G) => G.__id !== x).map((G) => ({ ...G }));
      A(N);
    }
    return Ln(() => {
      k();
    }), (x, N) => (L(), H("div", {
      class: "tf-editor",
      style: { width: "100%", userSelect: "none", maxHeight: "52vh" },
      onMousedown: N[0] || (N[0] = ka(() => {
      }, ["prevent"]))
    }, [
      (L(), H("svg", {
        ref_key: "svgRef",
        ref: s,
        class: "tf-editor-svg",
        style: { width: "100%", height: "100%", display: "block" },
        viewBox: `0 0 ${od} ${ld}`,
        preserveAspectRatio: "none"
      }, [
        y("defs", null, [
          y("linearGradient", {
            id: u,
            x1: "0%",
            y1: "0%",
            x2: "100%",
            y2: "0%"
          }, [
            (L(!0), H(He, null, jt(g.value, (G, ce) => (L(), H("stop", {
              key: `s-${ce}`,
              offset: `${G.offset}%`,
              "stop-color": G.color
            }, null, 8, H_))), 128))
          ])
        ]),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          fill: `url(#${u})`,
          rx: "4",
          ry: "4"
        }, null, 8, Y_),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          fill: "rgba(255,255,255,0.08)",
          rx: "4",
          ry: "4"
        }, null, 8, K_),
        b.value ? (L(), H("path", {
          key: 0,
          d: b.value,
          class: "tf-editor-histogram",
          style: { fill: "none", stroke: "rgba(0, 255, 0, 0.5)", "stroke-width": "5" }
        }, null, 8, Z_)) : ue("", !0),
        E.value ? (L(), H("path", {
          key: 1,
          d: E.value,
          class: "tf-editor-opacity",
          style: { fill: "rgba(255, 255, 255, 0.15)", stroke: "rgba(255, 255, 255, 0.9)", "stroke-width": "2" }
        }, null, 8, X_)) : ue("", !0),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          class: "tf-editor-hit-area",
          style: { fill: "transparent", cursor: "crosshair" },
          onPointerdown: M
        }, null, 40, J_),
        y("g", null, [
          (L(!0), H(He, null, jt(c.value, (G) => (L(), H("circle", {
            key: G.__id,
            cx: S(G.intensity),
            cy: f(G.alpha),
            r: "12",
            class: "tf-editor-point",
            style: Et({ fill: m(G), stroke: I(G), strokeWidth: 2, cursor: "pointer" }),
            onPointerdown: ka((ce) => O(G.__id, ce), ["stop"]),
            onContextmenu: ka((ce) => z(G.__id, ce), ["stop", "prevent"])
          }, null, 44, q_))), 128))
        ]),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          class: "tf-editor-border",
          style: { fill: "none", stroke: "rgb(146, 146, 146)", "stroke-width": "1" },
          rx: "4",
          ry: "4"
        }, null, 8, Q_)
      ], 8, z_))
    ], 32));
  }
}), t0 = ["viewBox"], n0 = ["offset", "stop-color"], a0 = ["x", "y", "width", "height", "fill"], o0 = ["x", "y", "width", "height"], l0 = ["cx", "cy"], i0 = ["cx", "cy"], s0 = ["cx", "cy"], r0 = ["height"], u0 = ["x", "y", "text-anchor"], zs = 640, id = 86, Hs = 54, c0 = /* @__PURE__ */ Je({
  __name: "TransferFunctionWindowLevelStrip",
  props: {
    points: {},
    intensityRange: {},
    windowWidth: {},
    windowLevel: {},
    showIntermediatePoints: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    height: { default: 45 }
  },
  emits: ["update:windowLevel", "update:endpointColors"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = Do(), { t: l } = Ht(), s = B(), i = {
      left: 12,
      top: 10,
      width: 616,
      height: 36
    }, u = `tf-strip-gradient-${Math.random().toString(36).slice(2)}`, c = Ce(() => n.windowLevel - n.windowWidth / 2), p = Ce(() => n.windowLevel + n.windowWidth / 2), h = Ce(() => n.height ? `${Math.max(40, Math.round(n.height))}px` : "clamp(74px, 9vw, 96px)"), g = Ce(() => {
      const j = na(n.intensityRange), K = n.points.length ? n.points : [
        { intensity: j[0], alpha: 0, red: 0, green: 0, blue: 0 },
        { intensity: j[1], alpha: 1, red: 1, green: 1, blue: 1 }
      ];
      return oo(K, j);
    }), b = Ce(() => {
      const j = na(n.intensityRange);
      return g.value.map((K) => {
        const x = aa(K);
        return {
          offset: li(K.intensity, j) * 100,
          color: `rgb(${Math.round(x.red * 255)}, ${Math.round(x.green * 255)}, ${Math.round(x.blue * 255)})`
        };
      });
    });
    function E(j, K) {
      return K >= 4 ? j === 1 || j === K - 2 : j === 0 || j === K - 1;
    }
    const m = Ce(() => {
      if (!n.showIntermediatePoints)
        return [];
      const j = g.value;
      return j.filter((K, x) => !E(x, j.length));
    });
    function I(j) {
      const K = aa(j);
      return `rgb(${Math.round(K.red * 255)}, ${Math.round(K.green * 255)}, ${Math.round(K.blue * 255)})`;
    }
    function S(j) {
      const K = aa(j);
      return 0.299 * K.red + 0.587 * K.green + 0.114 * K.blue > 0.55 ? "#101010" : "#f2f2f2";
    }
    function f(j) {
      return i.left + li(j, n.intensityRange) * i.width;
    }
    function v(j) {
      const K = Na((j - i.left) / i.width, 0, 1);
      return Nr(K, n.intensityRange);
    }
    function w() {
      return U_(n.points);
    }
    let A = null;
    function T(j) {
      const K = s.value;
      if (!K)
        return 0;
      const x = K.getBoundingClientRect(), N = zs / x.width;
      return (j.clientX - x.left) * N;
    }
    function O(j, K) {
      n.disabled || K.button !== 0 || (A = j, window.addEventListener("pointermove", C), window.addEventListener("pointerup", k));
    }
    function C(j) {
      if (!A)
        return;
      const K = Na(T(j), i.left, i.left + i.width), x = v(K);
      let N = c.value, G = p.value;
      A === "left" ? N = Math.min(x, G - 1e-6) : G = Math.max(x, N + 1e-6), a("update:windowLevel", {
        width: G - N,
        level: (G + N) / 2
      });
    }
    function k() {
      A = null, window.removeEventListener("pointermove", C), window.removeEventListener("pointerup", k);
    }
    async function M(j) {
      if (n.disabled)
        return;
      const K = w(), x = await o.showColorPickerModal(l("shared.changeColor"), j === "left" ? K.left : K.right);
      x && a("update:endpointColors", {
        left: j === "left" ? x : K.left,
        right: j === "right" ? x : K.right
      });
    }
    const z = Ce(() => {
      const j = na(n.intensityRange), K = Hs + 20, x = `${Math.round(j[0])}`, N = `${Math.round(c.value)}`, G = `${Math.round(p.value)}`, ce = `${Math.round(j[1])}`, re = (le, Re, q, he) => {
        const ne = Math.max(20, Re.length * 7 + 8);
        return he === "start" ? { key: le, text: Re, x: q, y: K, anchor: he, left: q, right: q + ne } : he === "end" ? { key: le, text: Re, x: q, y: K, anchor: he, left: q - ne, right: q } : { key: le, text: Re, x: q, y: K, anchor: he, left: q - ne / 2, right: q + ne / 2 };
      }, Se = 6, se = [], Le = re("left", x, i.left, "start");
      se.push(Le);
      const Y = re("low", N, f(c.value), "middle");
      Y.left >= se[se.length - 1].right + Se && se.push(Y);
      const pe = re("high", G, f(p.value), "middle");
      pe.left >= se[se.length - 1].right + Se && se.push(pe);
      const fe = re("right", ce, i.left + i.width, "end");
      return fe.left >= se[se.length - 1].right + Se && se.push(fe), se;
    });
    return Ln(() => {
      k();
    }), (j, K) => (L(), H("div", {
      class: "tf-strip",
      style: { width: "100%", userSelect: "none" },
      onMousedown: K[4] || (K[4] = ka(() => {
      }, ["prevent"]))
    }, [
      (L(), H("svg", {
        ref_key: "svgRef",
        ref: s,
        class: "tf-strip-svg",
        style: Et({ width: "100%", height: h.value, display: "block" }),
        viewBox: `0 0 ${zs} ${id}`,
        preserveAspectRatio: "none"
      }, [
        y("defs", null, [
          y("linearGradient", {
            id: u,
            x1: "0%",
            y1: "0%",
            x2: "100%",
            y2: "0%"
          }, [
            (L(!0), H(He, null, jt(b.value, (x, N) => (L(), H("stop", {
              key: `stop-${N}`,
              offset: `${x.offset}%`,
              "stop-color": x.color
            }, null, 8, n0))), 128))
          ])
        ]),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          fill: `url(#${u})`,
          rx: "4",
          ry: "4"
        }, null, 8, a0),
        y("rect", {
          x: i.left,
          y: i.top,
          width: i.width,
          height: i.height,
          class: "tf-strip-border",
          style: { fill: "transparent", stroke: "rgb(146, 146, 146)", "stroke-width": "1" },
          rx: "4",
          ry: "4"
        }, null, 8, o0),
        (L(!0), H(He, null, jt(m.value, (x, N) => (L(), H("circle", {
          key: `preview-${N}`,
          cx: f(x.intensity),
          cy: i.top + i.height / 2,
          r: "5",
          style: Et({ fill: I(x), stroke: S(x), strokeWidth: 1.6 })
        }, null, 12, l0))), 128)),
        y("circle", {
          class: "tf-strip-handle",
          cx: f(c.value),
          cy: i.top + i.height / 2,
          r: "8",
          style: { fill: "rgba(191, 191, 191, 0.95)", stroke: "#ffffff", "stroke-width": "2", cursor: "ew-resize" },
          onPointerdown: K[0] || (K[0] = ka((x) => O("left", x), ["stop"])),
          onContextmenu: K[1] || (K[1] = ka((x) => M("left"), ["stop", "prevent"]))
        }, null, 40, i0),
        y("circle", {
          class: "tf-strip-handle",
          cx: f(p.value),
          cy: i.top + i.height / 2,
          r: "8",
          style: { fill: "rgba(191, 191, 191, 0.95)", stroke: "#ffffff", "stroke-width": "2", cursor: "ew-resize" },
          onPointerdown: K[2] || (K[2] = ka((x) => O("right", x), ["stop"])),
          onContextmenu: K[3] || (K[3] = ka((x) => M("right"), ["stop", "prevent"]))
        }, null, 40, s0),
        y("rect", {
          x: 0,
          y: Hs,
          width: zs,
          height: id - Hs,
          fill: "rgba(0, 0, 0, 0.28)"
        }, null, 8, r0),
        (L(!0), H(He, null, jt(z.value, (x) => (L(), H("text", {
          key: x.key,
          x: x.x,
          y: x.y,
          "text-anchor": x.anchor,
          style: { fill: "#ffffff", "font-size": "1.5rem", "font-weight": "bold" }
        }, U(x.text), 9, u0))), 128))
      ], 12, t0))
    ], 32));
  }
});
function d0(e) {
  if (!e)
    return null;
  const t = e.getPointData(), n = t.getScalars() || t.getArrays()[0];
  return n ? n.getData() : null;
}
function p0(e, t, n = 64, a = 8) {
  const o = new Array(Math.max(1, Math.floor(n))).fill(0);
  if (!e || e.length === 0)
    return o;
  const l = na(t), s = l[0], i = l[1], u = Math.max(i - s, 1e-6), c = Math.max(1, Math.floor(a));
  for (let h = 0; h < e.length; h += c) {
    const g = Number(e[h]);
    if (!Number.isFinite(g) || g < s || g > i)
      continue;
    const b = Na((g - s) / u, 0, 1), E = Math.min(o.length - 1, Math.floor(b * o.length));
    o[E] += 1;
  }
  const p = Math.max(...o);
  return p <= 0 ? o : o.map((h) => h / p);
}
function m0(e, t, n = 64, a = 8) {
  const o = d0(e);
  return p0(o, t, n, a);
}
function f0(e) {
  if (typeof window > "u") {
    setTimeout(e, 0);
    return;
  }
  const t = window.requestIdleCallback;
  t ? t(e, { timeout: 40 }) : setTimeout(e, 0);
}
async function g0(e, t, n = 64, a = 8) {
  return new Promise((o) => {
    f0(() => {
      o(m0(e, t, n, a));
    });
  });
}
let Qo = null;
function xP(e) {
  Qo = e.global;
}
function h0() {
  return Qo || (console.warn("[lib] i18n not initialized. Returning fallback composer."), {
    t: (e) => e
    // just echoes the key back
    // you can add other methods as needed (d, n, locale, etc.)
  });
}
function b0() {
  const e = Qo == null ? void 0 : Qo.locale;
  if (typeof e == "string")
    return e;
  if (e && typeof e.value == "string")
    return e.value;
  if (typeof localStorage < "u") {
    const t = localStorage.getItem("langApp");
    if (t)
      try {
        const n = JSON.parse(t);
        if (typeof n == "string")
          return n;
      } catch {
      }
  }
  return "en";
}
function it(e, t) {
  return h0().t(e);
}
function v0() {
  return {
    volumeOptions: [],
    selectedVolumeOption: {
      name: it("implant-planner.noShading"),
      code: 0
    },
    mip: !1,
    wWidth: 406,
    wLevel: -310,
    dicomTransparency: {
      value: 23,
      isRange: !1,
      iconSrc: "",
      minValue: 0,
      maxValue: 100,
      step: 1,
      showValue: !1
    },
    templates: [],
    transferFunction: [
      { intensity: -1024, alpha: 0, red: 0, green: 0, blue: 0 },
      { intensity: 3071, alpha: 1, red: 1, green: 1, blue: 1 }
    ]
  };
}
const y0 = {
  class: "ip3d-volume-header",
  style: { display: "flex", "align-items": "center", "justify-content": "space-between", gap: "clamp(8px, 1.6vw, 14px)" }
}, _0 = { style: { width: "100%", flex: "1 1 auto" } }, w0 = { class: "flex-1" }, I0 = ["src", "alt"], S0 = { class: "text-lg text-center" }, gu = /* @__PURE__ */ Je({
  __name: "IP3dSettingsWizard",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "hideWizard"],
  setup(e, { emit: t }) {
    const { t: n } = Ht(), a = e, o = t, l = tt(v0());
    Og(l, a, o);
    const s = dn(), i = sa(), u = B(null), c = B(), p = B(!0), h = B(!0), g = B([]), b = B([-1024, 3071]), E = B(new Array(64).fill(0)), m = B(null);
    let I = 0;
    Ga(() => {
      a.modelValue && Object.assign(l, a.modelValue);
    });
    const S = Ce(() => ({
      disabled: u.value === null || Object.values(A).length <= 1
    })), f = Ce(() => ({
      disabled: u.value === null
    })), v = tt({
      value: l.dicomTransparency.value,
      minValue: l.dicomTransparency.minValue,
      maxValue: l.dicomTransparency.maxValue,
      step: 1
    });
    let w = 0;
    const A = B(
      structuredClone(Object.values(Yg.Dental).map((fe) => [(w++).toString(), fe]))
    ), T = B([]), O = {
      Airways: "medic-web-engine.airways",
      Bones: "medic-web-engine.bones",
      Default: "weblink.default",
      "Soft Tissues": "medic-web-engine.softTissues",
      Teeth: "shared.teeth",
      "X-Ray": "medic-web-engine.xRay",
      "Bone Vessels": "medic-web-engine.boneVessels",
      MIP: "medic-web-engine.mip",
      "Vessels Bones Airways": "medic-web-engine.vesselsBonesAirways",
      Vessels: "medic-web-engine.vessels"
    };
    lt(
      A,
      async (fe) => {
        const le = [];
        for (const [Re, q] of fe) {
          let he = "";
          q.thumbnailFile ? he = i.getAssetUrl(`/resources/3d_template_thumbnails/${q.thumbnailFile}`) : he = await Kg(s, q) || "";
          const ne = O[q.name];
          le.push({
            id: Number(Re),
            name: ne ? n(ne).replace(":", "") : q.name,
            image: he
          });
        }
        T.value = le;
      },
      { immediate: !0, deep: !0 }
    ), l.volumeOptions = [
      { name: n("implant-planner.noShading"), code: Sl.NO_SHADING },
      { name: n("implant-planner.bright"), code: Sl.LIGHT_SHADING },
      { name: n("medic-web-framework.dark"), code: Sl.DARK_SHADING },
      { name: n("implant-planner.shining"), code: Sl.SHINY_SHADING }
    ];
    function C() {
      const le = s.getImageData().getPointData(), Re = le.getScalars() || le.getArrays()[0], q = Re == null ? void 0 : Re.getRange(), he = Number.isFinite(q == null ? void 0 : q[0]) ? q[0] : -1024, ne = Number.isFinite(q == null ? void 0 : q[1]) ? q[1] : 3071;
      return he <= ne ? [Math.floor(he), Math.ceil(ne)] : [Math.floor(ne), Math.ceil(he)];
    }
    function k(fe) {
      if (fe.length >= 2) {
        const le = [...fe].sort((Re, q) => Re.intensity - q.intensity);
        return [Math.floor(le[0].intensity), Math.ceil(le[le.length - 1].intensity)];
      }
      return C();
    }
    async function M() {
      const fe = ++I, le = await g0(s.getImageData(), b.value, 64, 8);
      fe === I && (E.value = le);
    }
    function z() {
      const fe = s.getCurrentVolumeOptions();
      j();
      const le = l.volumeOptions.findIndex((he) => he.code === fe.shading);
      le !== -1 && (l.selectedVolumeOption = l.volumeOptions[le]);
      const Re = (1 - (fe.volumeOpacity || 0)) * 100;
      if (l.dicomTransparency.value = Re, v.value = Re, b.value = k(fe.points || []), g.value = oo(zl(fe.points || []), b.value), l.transferFunction = g.value.map((he) => ({ ...he })), u.value !== null) {
        const he = A.value.findIndex((ne) => ne[0] === u.value);
        he !== -1 && (A.value[he][1] = fe);
      }
      (!m.value || m.value[0] !== b.value[0] || m.value[1] !== b.value[1]) && (m.value = [...b.value], M());
    }
    function j() {
      const [fe, le] = s.getVolumeWindowWidthLevel();
      l.wWidth = Math.max(1, Math.round(fe)), l.wLevel = Math.round(le);
    }
    function K(fe, le) {
      u.value = fe.toString(), s.setVolumeOptions(le), z();
    }
    K("-1", s.getCurrentVolumeOptions());
    function x() {
      if (u.value === null)
        return;
      const fe = A.value.findIndex((le) => le[0] === u.value);
      fe !== -1 && A.value.splice(fe, 1), A.value.length > 0 ? fe > 0 ? K(...A.value[fe - 1]) : K(...A.value[0]) : u.value = null;
    }
    function N() {
      var q;
      let fe;
      u.value !== null && (fe = (q = A.value.find((he) => he[0] === u.value)) == null ? void 0 : q[1]), fe || (fe = s.getCurrentVolumeOptions());
      const le = JSON.parse(JSON.stringify(fe));
      le.name = `${fe.name} (copy)`;
      const Re = (w++).toString();
      A.value.push([Re, le]), K(Re, le);
    }
    function G(fe) {
      const le = fe.value.code;
      if (!(le in Sl)) {
        console.warn("unknown shading mode");
        return;
      }
      s.setVolumeShading(le);
    }
    function ce(fe) {
      Number.isFinite(fe) && (l.wWidth = Math.max(1, Math.round(fe)), s.setVolumeWindowWidthLevel(l.wWidth, l.wLevel), j());
    }
    function re(fe) {
      Number.isFinite(fe) && (l.wLevel = Math.round(fe), s.setVolumeWindowWidthLevel(l.wWidth, l.wLevel), j());
    }
    function Se(fe) {
      const le = Math.max(1, Math.round(fe.width)), Re = Math.round(fe.level);
      if (le === l.wWidth && Re === l.wLevel)
        return;
      l.wWidth = le, l.wLevel = Re, s.setVolumeWindowWidthLevel(le, Re), j();
      const q = s.getCurrentVolumeOptions().points || [], he = k(q);
      b.value = he, g.value = oo(zl(q), he), l.transferFunction = g.value.map((ne) => ({ ...ne }));
    }
    function se(fe) {
      const le = oo(zl(fe), b.value);
      Cr(le, g.value) || (g.value = le, l.transferFunction = le.map((Re) => ({ ...Re })), s.setVolumePoints(le));
    }
    function Le(fe) {
      const le = [fe.left[0] / 255, fe.left[1] / 255, fe.left[2] / 255], Re = [fe.right[0] / 255, fe.right[1] / 255, fe.right[2] / 255], q = V_(g.value, le, Re);
      Cr(q, g.value) || (g.value = q, l.transferFunction = q.map((he) => ({ ...he })), s.setVolumePoints(q));
    }
    function Y(fe) {
      if (!fe.value || !fe.value.length)
        return;
      const le = fe.value[0].id.toString();
      p.value = !1;
      const Re = A.value.find((q) => q[0] === le);
      Re && K(...Re);
    }
    function pe() {
      z();
    }
    return s.onVolumeOptionsModified.subscribe(pe), Ha(() => {
      s.onVolumeOptionsModified.unsubscribe(pe);
    }), (fe, le) => (L(), H(He, null, [
      d(Mo, {
        onHideWizard: le[0] || (le[0] = (Re) => o("hideWizard"))
      }, {
        default: _(() => [
          vt(U(fe.$t("implant-planner.dSettings")), 1)
        ]),
        _: 1
      }),
      d(fl, null, {
        default: _(() => [
          d(r(ot), { style: { gap: "clamp(10px, 1.8vh, 16px)", padding: "clamp(12px, 2.4vw, 20px) clamp(12px, 2.4vw, 20px) clamp(10px, 2vw, 14px)", "margin-bottom": "10px" } }, {
            default: _(() => [
              y("div", y0, [
                d(io, null, {
                  default: _(() => [
                    vt(U(fe.$t("implant-planner.volumeOptions")), 1)
                  ]),
                  _: 1
                }),
                d(r(Ne), {
                  icon: "pi pi-ellipsis-h",
                  onToggledChange: le[1] || (le[1] = (Re) => h.value = !h.value),
                  toggled: !h.value,
                  togglable: !0
                }, null, 8, ["toggled"])
              ]),
              h.value ? ue("", !0) : (L(), be(r(ke), { key: 0 }, {
                default: _(() => [
                  d(r($n), {
                    modelValue: l.selectedVolumeOption,
                    "onUpdate:modelValue": le[2] || (le[2] = (Re) => l.selectedVolumeOption = Re),
                    options: l.volumeOptions,
                    class: "w-full mt-1 p-inputtext",
                    optionLabel: "name",
                    style: { "align-items": "center" },
                    onChange: G
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              })),
              y("div", _0, [
                h.value ? ue("", !0) : (L(), be(e0, {
                  key: 0,
                  modelValue: g.value,
                  intensityRange: b.value,
                  histogram: E.value,
                  "onUpdate:modelValue": se
                }, null, 8, ["modelValue", "intensityRange", "histogram"])),
                d(c0, {
                  points: g.value,
                  intensityRange: b.value,
                  windowWidth: l.wWidth,
                  windowLevel: l.wLevel,
                  showIntermediatePoints: !h.value,
                  "onUpdate:windowLevel": Se,
                  "onUpdate:endpointColors": Le
                }, null, 8, ["points", "intensityRange", "windowWidth", "windowLevel", "showIntermediatePoints"])
              ]),
              d(r(ke), { style: { display: "flex", "flex-wrap": "wrap", gap: "12px 18px", "align-items": "flex-start" } }, {
                default: _(() => [
                  d(r(ke), { style: { display: "flex", "align-items": "center", gap: "10px", flex: "1 1 260px", "min-width": "min(100%, 260px)" } }, {
                    default: _(() => [
                      y("span", null, U(fe.$t("implant-planner.wWidth")), 1),
                      d(r(sc), {
                        class: "w-full ip3d-number-input",
                        style: { flex: "1 1 auto" },
                        max: 3e4,
                        min: 1,
                        modelValue: l.wWidth,
                        "onUpdate:modelValue": ce
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  d(r(ke), { style: { display: "flex", "align-items": "center", gap: "10px", flex: "1 1 260px", "min-width": "min(100%, 260px)" } }, {
                    default: _(() => [
                      y("span", null, U(fe.$t("implant-planner.wLevel")), 1),
                      d(r(sc), {
                        class: "w-full ip3d-number-input",
                        style: { flex: "1 1 auto" },
                        max: 3e4,
                        min: -3e4,
                        modelValue: l.wLevel,
                        "onUpdate:modelValue": re
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          ue("", !0),
          d(r(ot), { class: "gap-2 h-full overflow-y-auto" }, {
            default: _(() => [
              d(io, null, {
                default: _(() => [
                  vt(U(fe.$t("implant-planner.templates")), 1)
                ]),
                _: 1
              }),
              d(r(ke), { class: "h-full overflow-y-auto" }, {
                default: _(() => [
                  d(r(vh), {
                    modelValue: T.value,
                    "onUpdate:modelValue": le[4] || (le[4] = (Re) => T.value = Re),
                    selection: c.value,
                    "onUpdate:selection": le[5] || (le[5] = (Re) => c.value = Re),
                    class: "h-full overflow-y-auto w-full",
                    metaKeySelection: !0,
                    dataKey: "id",
                    breakpoint: "575px",
                    "pt:pcListbox:root": "w-full h-full overflow-y-auto p-listbox-template",
                    "pt:pcListbox:option": "p-listbox-option-template",
                    onSelectionChange: Y
                  }, {
                    option: _(({ option: Re, selected: q }) => [
                      d(r(ke), {
                        class: Ge([q ? "rg-primary-color" : "rg-main-bg-color", "p-4 justify-center items-center gap-2 w-full cardListHover"]),
                        style: { border: "2px var(--p-rg-border-color) solid", "border-radius": "16px" }
                      }, {
                        default: _(() => [
                          y("div", w0, [
                            y("img", {
                              src: Re.image,
                              alt: Re.name,
                              draggable: "false"
                            }, null, 8, I0)
                          ]),
                          d(r(we), { class: "flex-1 justify-center" }, {
                            default: _(() => [
                              y("span", S0, U(Re.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "selection"])
                ]),
                _: 1
              }),
              d(r(ke), { class: "gap-2" }, {
                default: _(() => [
                  d(r(Ne), {
                    disabled: S.value.disabled || p.value,
                    class: "web-rg-wiz-btn grow",
                    label: fe.$t("implant-planner.deleteTemplate"),
                    onClick: x
                  }, null, 8, ["disabled", "label"]),
                  d(r(Ne), {
                    disabled: f.value.disabled || p.value,
                    class: "web-rg-wiz-btn grow",
                    label: fe.$t("implant-planner.saveTemplate"),
                    style: { background: "var(--p-primary-color) !important" },
                    onClick: N
                  }, null, 8, ["disabled", "label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 64));
  }
});
var Gn = /* @__PURE__ */ ((e) => (e[e.MATCHING = 0] = "MATCHING", e[e.KEEP_ORIGINAL_POSTION = 1] = "KEEP_ORIGINAL_POSTION", e[e.SAME_AS = 2] = "SAME_AS", e))(Gn || {});
const E0 = /* @__PURE__ */ Je({
  __name: "IPMatchingCAD",
  emits: ["nextStepNested", "previousStepNested"],
  setup(e, { emit: t }) {
    let n = B([]), a, o = B("");
    const l = B(Math.random());
    let s = B();
    const i = Ao();
    let u;
    const c = t;
    return Dt(() => {
      i.enableNavbarButtons([_e.UNDO, _e.REDO]);
    }), Ln(() => {
      i.disableNavbarButtons([_e.UNDO, _e.REDO]);
    }), Dt(async () => {
      u = dn(), u.showLoading(it("implant-planner.loadingMatchingWizard"), !1, void 0, !0), u.setCADMode(!0), u.contextCAD.GetMainForm().SetJSLambda((h) => {
        console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI start toolwidget exists", !!h), h ? (n.value = h.GetWidgetOrder().slice(), a = h.GetWidgets(), o.value = h.GetToolTitle(), console.log(
          "000000 DynamicGUIComponent RETRIEVESTATICGUI widgets, order title",
          h.GetWidgetOrder().slice(),
          h.GetToolTitle(),
          h.GetWidgets()
        )) : (n.value = [], a = void 0, o.value = ""), l.value = Math.random(), console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI end");
      }, qt.eJSLT_RETIEVE_GUI);
      const p = (h) => {
        console.log("DEBUGG: finalizeCADWizard"), u.objects.stls.forEach((g) => {
          g.IsVolume() || g.syncWasmInfo();
        }), setTimeout(() => {
          u.setCADMode(!1), c(h ? "nextStepNested" : "previousStepNested");
        }, 300);
      };
      u.contextCAD.GetMainForm().SetJSLambda(p, qt.eJSLT_FINALIZE_CAD_WIZARD), await u.contextCAD.showSTLMatchingWizard(), s.value = u.contextCAD.tabWidgetHandler, console.log("tabWidgetHandler", s), u.hideLoading();
    }), Ln(() => {
      try {
        u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_RETIEVE_GUI), u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_FINALIZE_CAD_WIZARD), u.setCADMode(!1), console.log("DEBUGG: finalizeCADWizard onBeforeUnmount destroying cad!"), u.setTabIndex(1);
      } catch (p) {
        console.error("Error during unmount: ", p);
      }
    }), (p, h) => (L(), be(r(ot), {
      class: "flex h-full horizontal-padding",
      style: { "margin-bottom": "1rem", "margin-top": "1rem", "min-height": "0" }
    }, {
      default: _(() => [
        d(r(ot), {
          class: "grow overflow-x-hidden overflow-y-auto",
          style: { "min-height": "0" }
        }, {
          default: _(() => [
            r(n).length ? (L(), be(r(ls), {
              key: l.value,
              "widget-params": r(a),
              "widget-order": r(n),
              "tool-title": r(o),
              class: "mb-2"
            }, null, 8, ["widget-params", "widget-order", "tool-title"])) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(ot), { style: { flex: "0 0 auto" } }, {
          default: _(() => [
            r(s) ? (L(), be(r(is), {
              key: 0,
              "tab-handler": r(s),
              context: r(u),
              onNextStepNested: h[0] || (h[0] = (g) => c("nextStepNested")),
              onPreviousStepNested: h[1] || (h[1] = (g) => c("previousStepNested"))
            }, null, 8, ["tab-handler", "context"])) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), mm = /* @__PURE__ */ Je({
  __name: "IPSTLEditCAD",
  props: /* @__PURE__ */ Rn({
    isDemo: { type: Boolean, default: !1 }
  }, {
    selectedObjectId: { required: !0 },
    selectedObjectIdModifiers: {}
  }),
  emits: /* @__PURE__ */ Rn(["nextStepNested", "previousStepNested"], ["update:selectedObjectId"]),
  setup(e, { emit: t }) {
    const n = e, a = Nn(e, "selectedObjectId");
    let o = dn();
    const l = t;
    async function s() {
      var u;
      a.value.length > 0 && (await ((u = o.contextCAD.GetMainForm()) == null ? void 0 : u.setEditObjectAsync(a.value)) || console.log("Object not found in CAD context", a.value));
    }
    lt(a, async () => {
      await s();
    });
    const i = async () => {
      var u;
      a.value.length > 0 && await ((u = o.contextCAD.GetMainForm()) == null ? void 0 : u.setEditObjectAsync(a.value)), await o.contextCAD.showSTLEditWizard(n.isDemo), await s();
    };
    return (u, c) => (L(), be(r(pp), {
      context: r(o),
      wizardType: "STL Edit",
      initializeLambda: i,
      onNextStepNested: c[0] || (c[0] = (p) => l("nextStepNested")),
      onPreviousStepNested: c[1] || (c[1] = (p) => l("previousStepNested"))
    }, null, 8, ["context"]));
  }
}), T0 = /* @__PURE__ */ Je({
  __name: "IPBooleanOperationCAD",
  emits: ["nextStepNested", "previousStepNested"],
  setup(e, { emit: t }) {
    const n = t;
    let a = dn();
    const o = async () => {
      await a.contextCAD.showBooleanOperationWizard();
    };
    return (l, s) => (L(), be(r(pp), {
      context: r(a),
      wizardType: "Boolean",
      initializeLambda: o,
      onNextStepNested: s[0] || (s[0] = (i) => n("nextStepNested")),
      onPreviousStepNested: s[1] || (s[1] = (i) => n("previousStepNested"))
    }, null, 8, ["context"]));
  }
}), C0 = {
  class: "text-14 mr-1",
  style: { "font-weight": "bold" }
}, N0 = { class: "text-14" }, L0 = /* @__PURE__ */ Je({
  __name: "IPDataImportMatchingDialog",
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data, o = t, l = Ce(() => {
      const E = [];
      return a.existingObjects.forEach((m) => {
        m.getGUIName() !== a.nameO && E.push({
          label: `Same as: ${m.getGUIName()}`,
          name: m.getGUIName()
        });
      }), E;
    }), s = B(null), i = B(1);
    let u = Ce(() => i.value === 1), c = Ce(() => i.value === 0);
    const p = (E) => {
      i.value = E ? 1 : 0, s.value = null;
    }, h = () => {
      i.value = 2;
    }, g = () => {
      var m;
      let E = Gn.MATCHING;
      i.value == 0 ? E = Gn.KEEP_ORIGINAL_POSTION : i.value == 2 && (E = Gn.SAME_AS), o("close", { state: E, name: (m = s.value) == null ? void 0 : m.name }), n.value.close();
    }, b = () => {
      o("close", { state: Gn.KEEP_ORIGINAL_POSTION, name: "" }), n.value.close();
    };
    return (E, m) => (L(), H(He, null, [
      d(r(ot), {
        class: "mt-3 mb-3 gap-4",
        style: { "min-width": "50vw" }
      }, {
        default: _(() => [
          y("span", C0, U(E.$t("implant-planner.objectName")) + " " + U(r(a).nameO), 1),
          d(r(ot), { class: "gap-4 grow" }, {
            default: _(() => [
              y("span", N0, U(E.$t("implant-planner.objectPosition")), 1),
              d(r(ke), { class: "gap-2" }, {
                default: _(() => [
                  d(r(Ne), {
                    toggled: r(u),
                    label: E.$t("implant-planner.matching"),
                    onClick: m[0] || (m[0] = (I) => p(!0)),
                    style: { flex: "1 1 0" }
                  }, null, 8, ["toggled", "label"]),
                  d(r(Ne), {
                    toggled: r(c),
                    label: E.$t("implant-planner.keepOriginalPosition"),
                    onClick: m[1] || (m[1] = (I) => p(!1)),
                    style: { flex: "1 1 0" }
                  }, null, 8, ["toggled", "label"]),
                  d(r($n), {
                    modelValue: s.value,
                    "onUpdate:modelValue": m[2] || (m[2] = (I) => s.value = I),
                    options: l.value,
                    class: "flex-auto items-center",
                    "option-label": "label",
                    placeholder: E.$t("implant-planner.sameAs"),
                    style: Et({
                      background: s.value ? "var(--p-primary-color) !important" : "",
                      flex: "1 1 0"
                    }),
                    onChange: h
                  }, null, 8, ["modelValue", "options", "placeholder", "style"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      d(r(we), { class: "p-dialog-footer justify-center" }, {
        default: _(() => [
          d(r(la), {
            class: "mt-6",
            label: E.$t("shared.ok"),
            "data-cy": "confirmMatching",
            onClick: g
          }, null, 8, ["label"]),
          d(r(ya), {
            class: "mt-6",
            label: E.$t("shared.cancel"),
            "data-cy": "cancelMatching",
            onClick: b
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
}), O0 = {
  name: "BaseProgressSpinner",
  extends: Ka,
  props: {
    strokeWidth: {
      type: String,
      default: "2"
    },
    fill: {
      type: String,
      default: "none"
    },
    animationDuration: {
      type: String,
      default: "2s"
    }
  },
  style: yh,
  provide() {
    return {
      $pcProgressSpinner: this,
      $parentInstance: this
    };
  }
}, D0 = {
  name: "ProgressSpinner",
  extends: O0,
  inheritAttrs: !1,
  computed: {
    svgStyle() {
      return {
        "animation-duration": this.animationDuration
      };
    }
  }
}, A0 = ["fill", "stroke-width"];
function R0(e, t, n, a, o, l) {
  return L(), H("div", je({
    class: e.cx("root"),
    role: "progressbar"
  }, e.ptmi("root")), [
    (L(), H("svg", je({
      class: e.cx("spin"),
      viewBox: "25 25 50 50",
      style: l.svgStyle
    }, e.ptm("spin")), [
      y("circle", je({
        class: e.cx("circle"),
        cx: "50",
        cy: "50",
        r: "20",
        fill: e.fill,
        "stroke-width": e.strokeWidth,
        strokeMiterlimit: "10"
      }, e.ptm("circle")), null, 16, A0)
    ], 16))
  ], 16);
}
const fm = /* @__PURE__ */ Vt(D0, [["render", R0]]), M0 = (e) => {
  if (!e)
    return {};
  try {
    return JSON.parse(e);
  } catch (t) {
    return console.warn("Failed to parse attachment jsonData", t), {};
  }
}, Ys = (e, t) => {
  if (!e || !t)
    return null;
  const n = e.value, a = M0(n.jsonData), o = Number(a.color ?? 0), l = Number(a.connector_height ?? 0), s = Number(a.angle ?? 0), i = Number(a.rotation_z ?? 0), u = new Int8Array(t);
  return {
    abutmentSellingCode: n.sellingCode ?? "",
    angle: s,
    connectorHeight: l,
    fileName: "",
    rotationZ: i,
    color: o,
    guid: n.uuid ?? "",
    manufacturerName: n.manufacturerName ?? "",
    modelName: "",
    name: n.name ?? "",
    stlFile: {
      fileName: "",
      data: u,
      fileSize: u.length
    }
  };
};
function Ji(e) {
  var l, s;
  const t = (l = e.sleeve) == null ? void 0 : l.value, n = (s = e.implant) == null ? void 0 : s.value;
  if (!t || !n) return !1;
  const a = n.sleeveIds ?? [], o = t.id;
  return !!(n.defaultSleeveId !== void 0 && n.defaultSleeveId === o || a.includes(o));
}
function Lr() {
  return [
    { name: "Face Scan", code: 0 },
    { name: "Marker Scan", code: 1 },
    { name: "Anatomy", code: 2 },
    { name: "Antagonist", code: 3 },
    { name: "Waxup-Prosthesis", code: 4 },
    { name: "Antagonist Waxup", code: 5 },
    { name: "Bone Surface", code: 6 },
    { name: "Bone Graft", code: 7 },
    { name: "Surgical Guide", code: 8 },
    { name: "Bone Reduction Guide", code: 9 },
    { name: "Acrylic Flange", code: 10 },
    { name: "Bar", code: 11 },
    { name: "Generic", code: 12 },
    { name: "Movement Scan Marker", code: 13 },
    { name: "Other", code: 14 }
  ];
}
function jP() {
  return Lr().length > 0 ? Lr()[0] : { name: "Face Scan", code: 0 };
}
function P0(e, t, n, a, o) {
  var b, E, m, I, S;
  if (!e.implant || !e.implantData)
    return null;
  const l = new Int8Array(e.implantData), s = {
    color: parseInt(e.implant.value.color || "") || 0,
    diameter: Ri(parseFloat(e.implant.value.diameter) || 0),
    guid: e.implant.value.uuid || "",
    implantConnectorHeight: Ri(parseFloat(e.implant.value.connector_height) || 0),
    implantFileName: "",
    implantOriginalName: e.implant.value.name || "",
    length: Ri(parseFloat(e.implant.value.length) || 0),
    manufacturerName: ((b = e.manufacturer) == null ? void 0 : b.name) || "",
    modelName: ((E = e.model) == null ? void 0 : E.name) || "",
    name: t,
    nonSymmetric: parseInt(e.implant.value.non_symmetric) || 0,
    orientation: 0,
    sameManufacturerImplants: "",
    sellingCode: e.implant.value.sellingCode || "",
    objectName: t,
    displayText: "",
    objectType: Oe._IMPLANT,
    objectSubType: Oe._NONE,
    fileSha: "",
    stlFile: {
      fileName: "",
      data: l,
      fileSize: l.length
    },
    plyFilename: "",
    stlSuffix: "",
    connectionSides: e.implant.value.connection_sides
  }, i = ip();
  if (i.color = Wo(parseInt(e.implant.value.color ?? "")), i.origin = n ?? [0, 0, 0], i.viewUp = o ?? [0, 1, 0], i.normal = a ?? [0, 0, 1], i.tangent = [0, 0, 0], i.name = t, i.objectType = Oe._IMPLANT, i.objectSubType = Oe._NONE, i.implantInfo = s, e.abutment && e.abutmentData) {
    const f = new Int8Array(e.abutmentData), v = {
      abutmentSellingCode: e.abutment.value.sellingCode,
      angle: e.abutment.value.angle || 0,
      connectorHeight: e.abutment.value.connector_height,
      fileName: "",
      rotationZ: e.abutment.value.rotation_z || 0,
      color: e.abutment.value.color || 0,
      guid: e.abutment.value.uuid || "",
      manufacturerName: ((m = e.abManufacturer) == null ? void 0 : m.value.name) || "",
      modelName: ((I = e.abModel) == null ? void 0 : I.value.name) || "",
      name: e.abutment.value.name,
      stlFile: {
        fileName: "",
        data: f,
        fileSize: f.length
      }
    };
    i.abutment = v, i.abutmentColor = [...Wo(e.abutment.value.color), 255], i.rotation = v.rotationZ;
  } else
    i.abutment = void 0;
  const u = Ys(e.scanAbutment, e.scanAbutmentData);
  u ? (i.scanAbutment = u, i.scanAbutmentColor = [...Wo(u.color), 255]) : i.scanAbutment = void 0;
  const c = Ys(e.secondaryAbutment, e.secondaryAbutmentData);
  c ? (i.secondaryAbutment = c, i.secAbutmentColor = [...Wo(c.color), 255]) : i.secondaryAbutment = void 0;
  const p = Ys(e.secondaryScanAbutment, e.secondaryScanAbutmentData);
  p ? (i.secondaryScanAbutment = p, i.secScanAbutmentColor = [...Wo(p.color), 255]) : i.secondaryScanAbutment = void 0;
  let h = null;
  if (e.sleeve && e.sleeveManufacturer) {
    const f = Ji(e), v = e.sleeveData ? new Int8Array(e.sleeveData) : new Int8Array(), w = (v == null ? void 0 : v.length) || 0, A = e.sleeveNegativeData ? new Int8Array(e.sleeveNegativeData) : new Int8Array(), T = (A == null ? void 0 : A.length) || 0;
    h = {
      // implant: false,
      manufacturerName: ((S = e.sleeveManufacturer) == null ? void 0 : S.name) ?? "",
      modelName: e.sleeve.value.name,
      sellingCode: e.sleeve.value.sellingCode,
      dExternal: parseFloat(e.sleeve.value.dextsleeve),
      dInternal: parseFloat(e.sleeve.value.dintsleeve),
      lSleeve: parseFloat(e.sleeve.value.lslsleeve),
      lLip: parseFloat(e.sleeve.value.lip_heightguide),
      lCut: parseFloat(e.sleeve.value.cut_sizeguide),
      reductionSystemSize: parseFloat(e.sleeve.value.reductionsystemsleeve),
      rotationAll: parseFloat(e.sleeve.value.rotation_allguide),
      rotationCut: parseFloat(e.sleeve.value.rotation_cutguide),
      dHexagon: parseFloat(e.sleeve.value.hexagon_diameterguide),
      originalDistanceFromImplant: parseFloat(e.sleeve.value.hslsleeve),
      distanceFromImplant: parseFloat(e.sleeve.value.hslsleeve),
      drillLengthSizes: e.sleeve.value.drill_lenght_sizes ?? "",
      originalName: qd(e.sleeveManufacturer.name, e.sleeve.name),
      stlData: e.sleeveData ? {
        fileName: "",
        data: v,
        fileSize: w
      } : void 0,
      stlNegativeData: e.sleeveNegativeData ? {
        fileName: "",
        data: A,
        fileSize: T
      } : void 0,
      stlFileGuid: e.sleeve.value.stl_guid ?? w ? e.sleeve.value.s3ObjectRef : "",
      stlFileNegativeGuid: e.sleeve.value.stl_negative_guid ?? T ? e.sleeve.value.inverses3ObjectRef : "",
      cylinderShape: e.sleeve.value.cylinder_hexagonguide,
      connectionIndex: 0,
      // TODO add from library!!!
      referencedSleeve: f ? 1 : 0
    }, !h || (!h.dInternal || !h.dExternal && !h.dHexagon || !h.lSleeve) && !(h != null && h.stlData) ? (console.warn("error in sleeve data, sleeve data", h), h = null) : i.sleeveInfo = h;
  }
  if (e.sleeve && e.sleeveManufacturer) {
    const f = Ji(e);
    i.sleeveManuallyChanged = f ? 0 : 1;
  }
  let g = null;
  if (e.implantExtrusion) {
    let f = e.implantExtrusion.value.doublecutmodel, v = e.implantExtrusion.value.cutsizemodel;
    f && (v = -Math.abs(v)), g = {
      name: e.implantExtrusion.value.name,
      d1Model: e.implantExtrusion.value.d1model,
      d2Model: e.implantExtrusion.value.d2model,
      l1Model: e.implantExtrusion.value.l1model,
      l2Model: e.implantExtrusion.value.l2model,
      cutSizeModel: v,
      bottomExtrusionRModel: e.implantExtrusion.value.bottomextrusionrmodel,
      support_lenght: 30,
      supportRModel: e.implantExtrusion.value.supportrmodel,
      base_lenght: 40,
      rotation_cutModel: e.implantExtrusion.value.rotation_cutmodel,
      stlFileGuid: e.implantExtrusion.value.stl_file_guid && e.implantExtrusion.value.stl_file_guid.length ? e.implantExtrusion.value.stl_file_guid : void 0,
      s3ObjectRef: e.implantExtrusion.value.s3ObjectRef,
      uuid: e.implantExtrusion.value.uuid || ""
    }, e.implantExtrusionData && e.implantExtrusionData.then((w) => {
      var O, C;
      const A = new Int8Array(w), T = A.length || 0;
      g && (g.stlData = {
        fileName: "",
        data: A,
        fileSize: T
      }, g.stlFileGuid = ((O = e.implantExtrusion) == null ? void 0 : O.value.stl_file_guid) ?? T ? (C = e.implantExtrusion) == null ? void 0 : C.value.s3ObjectRef : "");
    }), i.implantModel = g ?? void 0;
  } else
    i.implantModel = void 0;
  return i;
}
const x0 = { key: 0 }, j0 = { class: "text-14 mr-1" }, $0 = { class: "text-14" }, F0 = /* @__PURE__ */ Je({
  __name: "IPDataImportDialog",
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), { t: a } = Ht(), o = n.value.data, l = t, s = B(o.modelValue), i = B(
      3
      /* INIT */
    ), u = ui(), c = Lr(), p = B(c.find((x) => x.name === o.modelValue.name) ?? { name: "Face Scan" }), h = `${ki},${Qd}`, g = B([]), b = B(null);
    let E = o.context;
    const m = B(null), I = B(1);
    let S = Ce(() => I.value === 1), f = Ce(() => I.value === 0);
    const v = (x) => {
      I.value = x ? 1 : 0, m.value = null;
    }, w = () => {
      I.value = 2;
    }, A = Ce(
      () => o.existingObjects.map((x) => ({
        label: `Same as: ${x.getGUIName()}`,
        name: x.getGUIName()
      }))
    ), T = Ce(() => i.value === 3 ? "w-full" : ""), O = Ce(() => !(i.value === 1 || i.value === 2)), C = Ce(() => g.value.length > 0), k = (x, N) => {
      i.value = 4, g.value = x, b.value = N && N.length ? N[0] : null, z();
    }, M = () => {
      g.value = [], i.value = 3;
    }, z = async () => {
      var N, G;
      let x = Wn(b.value) ?? void 0;
      if (!x && g.value.length && (x = await ss(g.value, E, p.value.name, !1)), x && m.value != null) {
        const ce = Wn(o.existingObjects.find((re) => {
          var Se;
          return re.getGUIName() == ((Se = m.value) == null ? void 0 : Se.name);
        }));
        ce && (x.setMatrix(ce.getMatrix()), (N = E.toolManager.matchingTool) == null || N.endMatching(!0), (G = E.toolManager.matchingTool) == null || G.apply(!0, !0));
      }
      s.value.name = p.value.name, I.value == 1 ? s.value.position = Gn.MATCHING : I.value == 0 ? s.value.position = Gn.KEEP_ORIGINAL_POSTION : I.value == 2 && (s.value.position = Gn.SAME_AS), s.value.sameAs = m.value ? "Same as selected" : null, x && (s.value.id = x.id), E.sceneRepaint(), o.context && o.context.objects.clearTmpStls(), l("close", s.value), s.value.position == Gn.MATCHING ? n.value.close() : M(), b.value = null;
    }, j = async () => {
      i.value = 0;
      const x = E.objects.findStlByName(p.value.name);
      x ? u.require({
        message: a("implant-planner.deleteOldObjectPrompt"),
        header: a("implant-planner.deleteObject"),
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          x.delete(), await z(), u.close();
        },
        reject: async () => {
          p.value.name != "Anatomy" ? await z() : (s.value.position = Gn.KEEP_ORIGINAL_POSTION, l("close", s.value)), u.close();
        }
      }) : await z();
    }, K = () => {
      o.context && o.context.objects.clearTmpStls(), l("close"), n.value.close();
    };
    return (x, N) => {
      const G = fm;
      return O.value ? (L(), H("div", x0, [
        d(r(ke), { class: "mt-4 gap-4" }, {
          default: _(() => [
            d(r(ot), {
              class: "gap-4",
              style: { width: "25%" }
            }, {
              default: _(() => [
                y("span", j0, U(x.$t("implant-planner.objectName")), 1),
                d(r($n), {
                  modelValue: p.value,
                  "onUpdate:modelValue": N[0] || (N[0] = (ce) => p.value = ce),
                  options: r(c),
                  class: "grow w-full items-center",
                  "data-cy": "objectNameSelect",
                  "option-label": "name"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            d(r(ot), { class: "gap-4 grow" }, {
              default: _(() => [
                y("span", $0, U(x.$t("implant-planner.objectPosition")), 1),
                d(r(ke), { class: "gap-2" }, {
                  default: _(() => [
                    d(r(Ne), {
                      toggled: r(S),
                      label: x.$t("implant-planner.matching"),
                      "data-cy": "matching",
                      onClick: N[1] || (N[1] = (ce) => v(!0)),
                      style: { flex: "1 1 0", "min-width": "fit-content" }
                    }, null, 8, ["toggled", "label"]),
                    d(r(Ne), {
                      toggled: r(f),
                      label: x.$t("implant-planner.keepOriginalPosition"),
                      "data-cy": "keepOriginalPosition",
                      onClick: N[2] || (N[2] = (ce) => v(!1)),
                      style: { flex: "1 1 0", "min-width": "fit-content" }
                    }, null, 8, ["toggled", "label"]),
                    d(r($n), {
                      modelValue: m.value,
                      "onUpdate:modelValue": N[3] || (N[3] = (ce) => m.value = ce),
                      options: A.value,
                      class: "flex-auto items-center",
                      "option-label": "label",
                      placeholder: x.$t("implant-planner.sameAs"),
                      style: Et([{
                        background: m.value ? "var(--p-primary-color) !important" : ""
                      }, { flex: "2 1 0", "min-width": "fit-content" }]),
                      onChange: w
                    }, null, 8, ["modelValue", "options", "placeholder", "style"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(r(we), { class: "w-full mt-4 mb-2 items-center justify-center" }, {
          default: _(() => [
            i.value === 0 ? (L(), be(r(we), {
              key: 0,
              class: "w-full justify-center items-center",
              style: { height: "400px" }
            }, {
              default: _(() => [
                d(G, {
                  style: { width: "100px", height: "100px" },
                  animationDuration: ".75s"
                })
              ]),
              _: 1
            })) : ue("", !0),
            Pt(y("div", {
              class: Ge(T.value)
            }, [
              d(r(Zl), {
                dropArea: !0,
                selectFilesBtn: !0,
                selectFolderBtn: !0,
                accept: h,
                context: r(E),
                objectName: p.value.name,
                singleSelection: !0,
                embedded: !0,
                importTmpStls: !0,
                showTypeColumn: !1,
                hideTreeWhenNoFolders: !0,
                showAccept: !0,
                onUploadFiles: k
              }, null, 8, ["context", "objectName"])
            ], 2), [
              [
                ln,
                i.value !== 0
                /* UPLOADING_OBJECT */
              ]
            ])
          ]),
          _: 1
        }),
        Pt(d(r(we), { class: "p-dialog-footer justify-center" }, {
          default: _(() => [
            C.value ? (L(), be(r(la), {
              key: 0,
              class: "mt-6",
              label: x.$t("implant-planner.add"),
              "data-cy": "importData",
              onClick: j
            }, null, 8, ["label"])) : ue("", !0),
            d(r(ya), {
              class: "mt-6",
              label: x.$t("shared.cancel"),
              onClick: K
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 512), [
          [
            ln,
            i.value !== 0
            /* UPLOADING_OBJECT */
          ]
        ])
      ])) : ue("", !0);
    };
  }
}), k0 = /* @__PURE__ */ Vt(F0, [["__scopeId", "data-v-31156ca3"]]);
function Ra() {
  const e = Zg();
  return Ln(() => e.cleanupAll()), e;
}
const V0 = { class: "text-2xl" }, B0 = {
  key: 0,
  class: "flex min-h-0",
  style: { overflowY: "auto", borderRadius: "16px" }
}, U0 = {
  key: 3,
  style: { "margin-top": "auto" }
}, G0 = {
  key: 1,
  class: "mt-1 ml-2"
}, hu = /* @__PURE__ */ Je({
  __name: "IPDataImportWizard",
  props: {
    patientName: {}
  },
  emits: ["hideWizard"],
  setup(e, { emit: t }) {
    const { t: n } = Ht(), a = Ra(), o = e, l = t, s = Aa(), i = B(""), u = B(!1), c = B(!1), p = B(!1), h = B(!1), g = B(!1), b = B(!1), E = B(!1), m = B(!0), I = B(!0), S = B(!1), f = B(0);
    let v;
    const w = () => {
      !m.value && !I.value ? N.disabled = !1 : N.disabled = !0, !m.value || !I.value ? O.disabled = !1 : O.disabled = !0;
    };
    let A = tt({
      disabled: I
    }), T = tt({
      disabled: m
    }), O = tt({
      disabled: !0
    }), C = tt({
      disabled: !1
    }), k = tt({
      disabled: !1
    }), M = tt({
      disabled: !0
    }), z = tt({
      disabled: !0
    }), j = tt({
      disabled: !0
    }), K = B(!1), x = tt({
      disabled: !1
    }), N = tt({
      disabled: !0
    }), G = tt({
      disabled: !0
    }), ce = tt({
      disabled: !0
    }), re = tt({
      visible: !1,
      name: "Face Scan",
      position: Gn.MATCHING,
      sameAs: "Same as...",
      id: ""
    });
    const Se = {
      async hideObject(J) {
        await Le(J);
      },
      async toggleObjectPlacement(J) {
        await se(J);
      },
      async toogleObjectVisibility(J) {
        await Le(J);
      },
      async deleteObject(J) {
        await Y(J);
      },
      async editNotes(J) {
        await pe(J);
      },
      async changeColor(J) {
        await fe(J);
      },
      async changeTransparency(J, Pe) {
        await le(J, Pe);
      },
      async toggleWireframe(J) {
        await Re(J);
      },
      async matchObject(J) {
        await q(J);
      },
      async renameObject(J) {
        await he(J);
      },
      async changeObjectType(J, Pe) {
        await te(J, Pe);
      },
      async duplicateObject(J) {
        await ne(J);
      },
      async calculateVolume(J) {
        await Ie(J);
      }
    }, se = (J) => {
      v.objects.toggleObjectPlacement(J);
    }, Le = async (J) => {
      var Ze;
      const Pe = (Ze = v.objects.stls.get(J)) == null ? void 0 : Ze.getVisibility();
      Pe !== void 0 && v.objects.setObjectVisibility(J, !Pe);
    }, Y = async (J) => {
      v.objects.removeObject(J, Oe._STL_OBJECT), v.sceneRepaint();
    }, pe = async (J) => {
      const Pe = v.getModalsInstance(), Ze = v.objects.stls.get(J);
      if (Ze) {
        const st = Ze.getNotes();
        Pe.showTextInputModal(n("shared.notes"), st).then((ae) => {
          ae !== null && ae !== st && Ze.setNotes(ae);
        });
      }
    }, fe = async (J) => {
      const Pe = v.getModalsInstance(), Ze = v.objects.getStlObject(J);
      if (Ze) {
        const st = Ze.getColor(), ae = sp(st);
        Pe.showColorPickerModal(n("shared.setItemColor"), ae).then((ve) => {
          ve !== null && ve !== ae && (v.objects.setObjectColor(J, ve), v.repaint());
        });
      }
    }, le = async (J, Pe) => {
      v.objects.setObjectTransparency(J, Pe);
    }, Re = async (J) => {
      v.objects.toggleObjectWireframe(J);
    }, q = async (J) => {
      ht(J);
    }, he = async (J) => {
      const Pe = v.objects.getStlObject(J);
      if (!Pe)
        return console.warn("create dropdown: object not found"), null;
      const Ze = v.getModalsInstance(), st = Pe.getDisplayText();
      Ze.showTextInputModal(n("medic-web-engine.newObjectName"), st).then((ae) => {
        ae !== null && ae !== st && v.objects.setSTLName(J, ae);
      });
    }, ne = async (J) => {
      v.objects.duplicateSTL(J);
    }, te = async (J, Pe) => {
      v.objects.setSTLType(J, Pe), xe(), await P();
    }, Ie = async (J) => {
      v.objects.getObjectVolume(J);
    }, Ee = B([]), xe = () => {
      Ee.value = v.objects.getStlObjectList();
    }, Qe = B([]), Ke = B(Math.random()), qe = B(), rt = B(0);
    lt(
      Ke,
      (J, Pe) => {
        Pe !== J && mn(() => {
          var st, ae;
          const Ze = (ae = (st = qe.value) == null ? void 0 : st.$el.firstElementChild) == null ? void 0 : ae.firstElementChild;
          Ze && (Ze.scrollTop = rt.value);
        });
      },
      { immediate: !1 }
    );
    const P = async () => {
      var Ze, st;
      const J = (st = (Ze = qe.value) == null ? void 0 : Ze.$el.firstElementChild) == null ? void 0 : st.firstElementChild;
      J && (rt.value = J.scrollTop);
      const Pe = [...Qe.value];
      Qe.value = [];
      for (const ae of Ee.value) {
        if (ae.type == Oe._STL_TOOTH)
          continue;
        const ve = Pe.map((Ut) => Ut.id).indexOf(ae.id);
        let ut = "";
        ve != -1 && (ut = Pe[ve].imgSrc);
        const yt = v.viewConfiguration.colorScheme.get();
        Qe.value.push({
          id: ae.id,
          header: ae.getDisplayText() != "" ? ae.getDisplayText() + " (" + ae.getName() + ")" : ae.getName(),
          imgSrc: ut != "" ? ut : await Bi(ae, !0, yt) || "",
          isCentered: !1,
          isVisible: ae.getVisibility(),
          isLocked: ae.getLocked(),
          isTracked: ae.isTrackedObject()
        });
      }
      j.disabled = Qe.value.length < 2, Ke.value = Math.random();
    }, F = B(), me = (J) => {
      console.log("itemSelected item: ", J), F.value = J.id, !h.value && (M.disabled = !1, z.disabled = !1, ce.disabled = !1);
    }, de = async () => {
      E.value = !E.value, v.toolManager.matchingTool && (v.toolManager.matchingTool.enabled = E.value);
    }, We = async () => {
      var J, Pe;
      u.value || b.value || (Bt(), await ((J = v.toolManager.matchingTool) == null ? void 0 : J.registerSTLAutomatic()), f.value = ((Pe = v.toolManager.matchingTool) == null ? void 0 : Pe.getDelta()) || 0, S.value = !0);
    }, Q = () => {
      var J, Pe;
      b.value || ((J = v.toolManager.matchingTool) == null || J.registerSTL(), G.disabled = !((Pe = v.toolManager.matchingTool) != null && Pe.bestFitFlag.get()));
    }, ie = async () => {
      var J, Pe;
      await ((J = v.toolManager.matchingTool) == null ? void 0 : J.registerBestFit()), f.value = ((Pe = v.toolManager.matchingTool) == null ? void 0 : Pe.getDelta()) || 0, S.value = !0;
    }, W = () => {
      var J;
      (J = v.toolManager.matchingTool) == null || J.removeLastPickedDICOMPoint();
    }, ee = () => {
      var J;
      (J = v.toolManager.matchingTool) == null || J.removeLastPickedSTLPoint();
    }, $ = () => {
      var J;
      (J = v.toolManager.matchingTool) == null || J.removeAllPoints();
    }, R = async () => {
      var J;
      (J = v.toolManager.matchingTool) == null || J.cancel(), Bt(), b.value = !1, c.value = !1, xe(), await P();
    }, D = () => {
      var J;
      (J = v.toolManager.matchingTool) == null || J.apply(), Bt(), b.value = !1, c.value = !1;
    }, V = () => {
      p.value = !p.value;
    }, Z = B(!1), X = () => {
      if (p.value = !1, !v.objects.getStlObject(F.value))
        return null;
      h.value = !0, Z.value = !0;
    }, Ae = () => {
      p.value = !1, g.value = !0;
    }, De = () => {
      Z.value = !1, h.value = !1;
    }, at = () => {
      De();
    }, Be = () => {
      g.value = !1, xe(), P();
    }, ze = () => {
      b.value = !0, c.value = !0, p.value = !1, v.nextPrevVisible.set(!1);
    }, ct = (J, Pe) => {
      const Ze = Wi.clone(J.getMatrix()), st = Wi.clone(Pe);
      let ae = 0, ve = 0;
      for (let yt = 0; yt < 16; yt++)
        ae += Ze[yt], ve += st[yt];
      if (Math.abs(ae - ve) < 1e-6) {
        console.log("Adding undo skipped - sum of elements is equal");
        return;
      }
      const ut = new Bl({
        onUndo: () => {
          J.setMatrix(Ze), (J.type == Oe._STL_OBJECT || J.type === Oe._STL_TEETH_MODEL || J.type === Oe._STL_PROSTHESIS || J.type == Oe._STL_TOOTH) && J.updateCrosssections(), J.update3dInfo(), v.sceneRepaint();
        },
        onRedo: () => {
          console.log("Matching same as onRedo", st), J.setMatrix(st), (J.type == Oe._STL_OBJECT || J.type === Oe._STL_TEETH_MODEL || J.type === Oe._STL_PROSTHESIS || J.type == Oe._STL_TOOTH) && J.updateCrosssections(), J.update3dInfo(), v.sceneRepaint();
        }
      });
      ut.onRedo(), v.undoManager.pushPop(J, ut, "Move Object", Ul.NONE);
    }, ht = (J, Pe = !0) => {
      const Ze = v.objects.stls.get(J);
      if (Ze && !Ze.IsVolume()) {
        const st = () => {
          var ve;
          b.value = !1, Ze.setVisibility(!1);
          const ae = v.objects.addMatchingSTL(Ze, {
            ignoreScaling: !1,
            ply: Ze.isPly
          });
          (ve = v.toolManager.matchingTool) == null || ve.initializeSTLView(J, ae, Pe), c.value = !0, i.value = F.value, Ke.value = Math.random(), Bt();
        };
        Pe ? s.open(L0, {
          props: {
            closable: !0,
            modal: !0,
            header: n("implant-planner.matchingOptions"),
            contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
          },
          data: {
            nameO: Ze.getGUIName(),
            existingObjects: Ee.value
          },
          emits: {
            onClose: (ae) => {
              if (console.log("OnCLose ", ae.state, ae.name), ae.state != Gn.KEEP_ORIGINAL_POSTION)
                if (ae.state == Gn.SAME_AS) {
                  const ve = Ee.value.find((ut) => ut.getGUIName() == ae.name);
                  ve && ct(Ze, ve.getMatrix());
                } else
                  st();
            }
          }
        }) : st(), p.value = !1;
      } else
        console.log("STL object with id not found");
    }, mt = async () => {
      xe(), await P(), re.position == Gn.MATCHING && ht(re.id, !1);
    }, Bt = () => {
      E.value = !1, v.toolManager.matchingTool && (v.toolManager.matchingTool.enabled = E.value), K.value = E.value, G.disabled = !0, S.value = !1;
    };
    let Nt = tt({
      value: 2,
      minValue: 0.1,
      maxValue: 10,
      step: 0.1
    });
    lt(Nt, () => {
      var J;
      Nt.value && ((J = v.toolManager.matchingTool) == null || J.setSurrounding(Nt.value));
    });
    const Tt = Ce(() => Qe.value.length > 0), Rt = Ce(() => "max-height: 65vh"), bn = () => {
      s.open(k0, {
        props: {
          closable: !0,
          modal: !0,
          header: n("implant-planner.matchingOptions"),
          style: { width: "90vw" }
          // , height: "90vh"
        },
        data: {
          patientName: o.patientName,
          existingObjects: Ee.value,
          modelValue: re,
          context: v
        },
        emits: {
          onClose: () => {
            mt();
          }
        }
      });
    };
    Dt(async () => {
      v = dn(), u.value = !!(v.license.versionType & ho.START), xe(), await P(), a.watch(v.getState().object3DInfos, async () => {
        xe(), await P();
      }), v.toolManager.matchingTool && (a.watch(v.toolManager.matchingTool.stlNumOfPoints, () => {
        var Pe;
        const J = (Pe = v.toolManager.matchingTool) == null ? void 0 : Pe.stlNumOfPoints.get();
        J && J > 0 ? m.value = !1 : m.value = !0, w();
      }), a.watch(v.toolManager.matchingTool.dicomNumOfPoints, () => {
        var Pe;
        const J = (Pe = v.toolManager.matchingTool) == null ? void 0 : Pe.dicomNumOfPoints.get();
        J && J > 0 ? I.value = !1 : I.value = !0, w();
      })), a.onEvent(v.objects.object3DColorChangedEvent, async (J) => {
        const Pe = Qe.value.findIndex((Ze) => Ze.id === J);
        if (Pe !== -1) {
          const Ze = v.objects.stls.get(J);
          if (Ze) {
            const st = v.viewConfiguration.colorScheme.get();
            Qe.value[Pe].imgSrc = await Bi(Ze, !0, st) || "";
          }
        }
        Ke.value = Math.random();
      }), v.startMatchingWithObjectId && (ht(v.startMatchingWithObjectId), v.startMatchingWithObjectId = null);
    }), Ln(() => {
      v.toolManager.setTool(_n.NONE, rn.SECONDARY);
    });
    const Te = () => {
      console.log("finalizeSTLonSTL"), Bt(), b.value = !1, c.value = !1, v.nextPrevVisible.set(!0);
    };
    return (J, Pe) => {
      const Ze = io;
      return L(), H(He, null, [
        !b.value && !g.value && !Z.value ? (L(), H(He, { key: 0 }, [
          d(Mo, {
            onHideWizard: Pe[0] || (Pe[0] = (st) => l("hideWizard"))
          }, {
            default: _(() => [
              vt(U(J.$t("implant-planner.importDObjects")), 1)
            ]),
            _: 1
          }),
          d(fl, {
            style: Et({ overflowY: h.value ? void 0 : "auto", height: h.value ? void 0 : "100% !important" })
          }, {
            default: _(() => [
              !b.value && !c.value && !h.value ? (L(), H(He, { key: 0 }, [
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ne), {
                      label: J.$t("shared.import"),
                      class: Ge("w-full web-rg-icon-btn"),
                      "data-cy": "importObject",
                      onClick: bn
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }),
                d(r(ot), null, {
                  default: _(() => [
                    d(r(ke), null, {
                      default: _(() => [
                        d(Ze, null, {
                          default: _(() => [
                            vt(U(J.$t("shared.dObjects")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 64)) : c.value ? (L(), be(r(ke), { key: 1 }, {
                default: _(() => [
                  y("span", V0, U(J.$t("implant-planner.matchingStlOnDicom")), 1)
                ]),
                _: 1
              })) : ue("", !0),
              b.value ? ue("", !0) : (L(), H(He, { key: 2 }, [
                Tt.value ? (L(), H("div", B0, [
                  d(r(we), { class: "h-full w-full justify-center" }, {
                    default: _(() => [
                      (L(), be(r(Dg), {
                        ref_key: "scrollableDiv",
                        ref: qe,
                        class: "w-full",
                        heightStyle: Rt.value,
                        items: Qe.value,
                        showItemsDropdown: h.value || c.value,
                        hideDropdown: c.value,
                        callbacks: h.value || c.value ? void 0 : Se,
                        forceSelected: i.value,
                        onPickListItemSelected: me,
                        key: Ke.value
                      }, null, 8, ["heightStyle", "items", "showItemsDropdown", "hideDropdown", "callbacks", "forceSelected"]))
                    ]),
                    _: 1
                  })
                ])) : ue("", !0)
              ], 64)),
              !c.value && !Z.value && Tt.value ? (L(), H("div", U0, [
                d(r(ot), { class: "gap-2 mb-2" }, {
                  default: _(() => [
                    ue("", !0),
                    d(r(Ne), {
                      disabled: r(M).disabled,
                      onClick: Pe[2] || (Pe[2] = (st) => X()),
                      label: J.$t("shared.edit"),
                      class: Ge("w-full web-rg-wiz-btn")
                    }, null, 8, ["disabled", "label"]),
                    d(r(Ne), {
                      disabled: r(z).disabled,
                      toggled: p.value,
                      "data-cy": "matching",
                      onClick: Pe[3] || (Pe[3] = (st) => V()),
                      label: J.$t("implant-planner.matching"),
                      class: Ge("w-full web-rg-wiz-btn")
                    }, null, 8, ["disabled", "toggled", "label"]),
                    d(r(Ne), {
                      disabled: r(j).disabled,
                      onClick: Pe[4] || (Pe[4] = (st) => Ae()),
                      label: J.$t("implant-planner.booleanOperations"),
                      class: Ge("w-full web-rg-wiz-btn")
                    }, null, 8, ["disabled", "label"])
                  ]),
                  _: 1
                })
              ])) : ue("", !0),
              p.value ? (L(), be(r(we), {
                key: 4,
                class: "flex-row gap-2 mb-2"
              }, {
                default: _(() => [
                  d(r(Ne), {
                    disabled: r(C).disabled,
                    "data-cy": "matchingSTLonDICOM",
                    onClick: Pe[5] || (Pe[5] = (st) => ht(F.value)),
                    label: J.$t("implant-planner.stlOnDicom"),
                    class: Ge("web-rg-wiz-btn grow"),
                    style: { flex: "1 1 0" }
                  }, null, 8, ["disabled", "label"]),
                  d(r(Ne), {
                    disabled: r(k).disabled,
                    "data-cy": "matchingSTLonSTL",
                    onClick: Pe[6] || (Pe[6] = (st) => ze()),
                    label: J.$t("implant-planner.stlOnStl"),
                    class: Ge("web-rg-wiz-btn grow"),
                    style: { flex: "1 1 0" }
                  }, null, 8, ["disabled", "label"])
                ]),
                _: 1
              })) : ue("", !0),
              c.value ? (L(), H(He, { key: 5 }, [
                d(r(ke), null, {
                  default: _(() => [
                    d(Ze, null, {
                      default: _(() => [
                        vt(U(J.$t("implant-planner.matchingOptions")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ot), { class: "gap-2" }, {
                  default: _(() => [
                    d(r(Ne), {
                      icon: "pi pi-sparkles",
                      iconRight: !0,
                      disabled: r(x).disabled || u.value,
                      onClick: Pe[7] || (Pe[7] = (st) => We()),
                      label: J.$t("implant-planner.assisted"),
                      class: "web-rg-wiz-btn"
                    }, null, 8, ["disabled", "label"]),
                    d(r(Ne), {
                      togglable: !0,
                      toggled: r(K),
                      "data-cy": "byPoints",
                      onToggledChange: Pe[8] || (Pe[8] = (st) => de()),
                      label: J.$t("implant-planner.byPoints"),
                      class: "web-rg-wiz-btn"
                    }, null, 8, ["toggled", "label"])
                  ]),
                  _: 1
                }),
                E.value ? (L(), H(He, { key: 0 }, [
                  d(r(we), {
                    class: "w-full",
                    style: { "justify-content": "center" }
                  }, {
                    default: _(() => [
                      d(r(Vi), {
                        modelValue: r(Nt).value,
                        "onUpdate:modelValue": Pe[9] || (Pe[9] = (st) => r(Nt).value = st),
                        min: r(Nt).minValue,
                        max: r(Nt).maxValue,
                        step: r(Nt).step,
                        scrollable: !0,
                        label: J.$t("implant-planner.diameter"),
                        "unit-label": "mm",
                        style: { flex: "1 1 0" }
                      }, null, 8, ["modelValue", "min", "max", "step", "label"])
                    ]),
                    _: 1
                  }),
                  d(r(we), { class: "flex-row gap-2" }, {
                    default: _(() => [
                      d(r(Ne), {
                        disabled: r(A).disabled,
                        "data-cy": "removePointDICOM",
                        onClick: W,
                        label: b.value ? J.$t("implant-planner.removeLeftMarker") : J.$t("implant-planner.removeDicomMarker"),
                        class: Ge("web-rg-wiz-btn grow"),
                        style: { "font-size": "0.8rem", "white-space": "normal" }
                      }, null, 8, ["disabled", "label"]),
                      d(r(Ne), {
                        disabled: r(T).disabled,
                        "data-cy": "removePointSTL",
                        onClick: ee,
                        label: b.value ? J.$t("implant-planner.removeRightMarker") : J.$t("implant-planner.removeStlMarker"),
                        class: Ge("web-rg-wiz-btn grow"),
                        style: { "font-size": "0.8rem", "white-space": "normal" }
                      }, null, 8, ["disabled", "label"])
                    ]),
                    _: 1
                  }),
                  b.value ? (L(), be(r(ke), { key: 0 }, {
                    default: _(() => [
                      d(r(Ne), {
                        disabled: r(O).disabled,
                        onClick: $,
                        label: J.$t("implant-planner.clearAllPoints"),
                        class: Ge("web-rg-wiz-btn grow")
                      }, null, 8, ["disabled", "label"])
                    ]),
                    _: 1
                  })) : ue("", !0),
                  d(r(ke), { class: "mt-2" }, {
                    default: _(() => [
                      d(r(Ne), {
                        disabled: r(N).disabled,
                        "data-cy": "fitPoints",
                        onClick: Q,
                        label: J.$t("implant-planner.fitPoints"),
                        class: Ge("web-rg-wiz-btn grow")
                      }, null, 8, ["disabled", "label"])
                    ]),
                    _: 1
                  }),
                  b.value ? ue("", !0) : (L(), be(r(ke), {
                    key: 1,
                    class: "mt-2"
                  }, {
                    default: _(() => [
                      d(r(Ne), {
                        disabled: r(G).disabled,
                        "data-cy": "bestFit",
                        onClick: ie,
                        label: J.$t("implant-planner.bestFit"),
                        class: Ge("web-rg-wiz-btn grow")
                      }, null, 8, ["disabled", "label"])
                    ]),
                    _: 1
                  }))
                ], 64)) : ue("", !0),
                S.value ? (L(), H("div", G0, [
                  y("span", null, U(J.$t("implant-planner.delta")) + " " + U(f.value.toFixed(3)), 1)
                ])) : ue("", !0),
                d(r(ke), {
                  class: "mt-2 gap-2 mb-2",
                  style: { "margin-top": "auto" }
                }, {
                  default: _(() => [
                    d(r(Ne), {
                      "data-cy": "cancelMatching",
                      onClick: Pe[10] || (Pe[10] = (st) => R()),
                      label: J.$t("shared.cancel"),
                      class: Ge("web-rg-wiz-btn"),
                      style: { flex: "1 1 0" }
                    }, null, 8, ["label"]),
                    d(r(Ne), {
                      "data-cy": "applyMatching",
                      onClick: Pe[11] || (Pe[11] = (st) => D()),
                      label: J.$t("shared.apply"),
                      class: Ge("web-rg-wiz-btn"),
                      style: { flex: "1 1 0" }
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })
              ], 64)) : ue("", !0)
            ]),
            _: 1
          }, 8, ["style"])
        ], 64)) : !Z.value && !g.value ? (L(), be(E0, {
          key: 1,
          onNextStepNested: Te,
          onPreviousStepNested: Te
        })) : ue("", !0),
        Z.value ? (L(), be(mm, {
          key: 2,
          selectedObjectId: F.value,
          onNextStepNested: De,
          onPreviousStepNested: at
        }, null, 8, ["selectedObjectId"])) : ue("", !0),
        g.value ? (L(), be(T0, {
          key: 3,
          onNextStepNested: Be,
          onPreviousStepNested: Be
        })) : ue("", !0)
      ], 64);
    };
  }
});
var xl = /* @__PURE__ */ ((e) => (e[e.MAXILLA = 0] = "MAXILLA", e[e.MANDIBLE = 1] = "MANDIBLE", e))(xl || {});
function W0() {
  return {
    curveType: 0,
    panoramicRegion: 0
  };
}
const bu = /* @__PURE__ */ Je({
  __name: "IPCprSettingsWizard",
  emits: ["hideWizard"],
  setup(e, { emit: t }) {
    const { t: n } = Ht(), a = tt(W0()), o = B(!1), l = t, s = ui();
    let i, u;
    i = dn();
    const c = ia(), p = B(!1);
    Dt(() => {
      var k;
      const T = i.getViewWidget(Cn._3D);
      T && T.hideObjectList(!0);
      let O = i.getViewWidget(Cn.CPR);
      O && (u = O);
      const C = u.getCPRType();
      C == nn.MAXILLA ? m() : C == nn.MANDIBLE && I(), i.objects.hasCPR() && (p.value = !0), i.objects.hasCPR() || (o.value = !0), (k = i.toolManager.cprTool) == null || k.getPointPicker().pointAddedEvent.subscribe(() => {
        i.objects.hasCPR() ? p.value = !0 : p.value = !1;
      });
    }), Ln(() => {
      try {
        const T = i.getViewWidget(Cn._3D);
        T && (T.fitZoomToScreen(), T.hideObjectList(!1));
      } catch (T) {
        console.log("error:", T);
      }
    });
    let h = tt({
      disabled: !1,
      pressable: !0,
      pressed: a.curveType === xl.MAXILLA
    }), g = tt({
      disabled: !1,
      pressable: !0,
      pressed: a.curveType === xl.MANDIBLE
    });
    const b = B(!1);
    lt(b, () => {
      console.log("byPointsPressed", b.value), i.toolManager.cprTool && i.toolManager.cprTool.enableEditingCPRByPoints(b.value);
    });
    let E = tt({
      disabled: !1,
      pressable: !0,
      toggleable: !0
    });
    const m = () => {
      h.pressed = !0, g.pressed = !1, a.curveType = xl.MAXILLA, u.setCPRType(nn.MAXILLA);
    }, I = () => {
      h.pressed = !1, g.pressed = !0, a.curveType = xl.MANDIBLE, u.setCPRType(nn.MANDIBLE);
    }, S = () => {
      var T;
      (T = i.toolManager.cprTool) == null || T.removeLastPickedPoint();
    }, f = () => {
      var T;
      (T = i.toolManager.cprTool) == null || T.clearAllPoints();
    }, v = () => {
      u.adjustCPRHeight(5);
    }, w = () => {
      u.adjustCPRHeight(-5);
    }, A = async () => {
      const T = async () => {
        var O;
        f(), await ((O = i.toolManager.cprTool) == null ? void 0 : O.automaticCPRLandmarkLocalization(c)), b.value = !0, p.value = !0;
      };
      i.objects.hasCPR() ? s.require({
        message: n("implant-planner.resetAutomaticCprPrompt"),
        header: n("implant-planner.automaticCprLocalization"),
        icon: "pi pi-question-circle",
        accept: async () => {
          await T();
        },
        reject: () => {
          s.close();
        }
      }) : await T();
    };
    return (T, O) => {
      const C = io;
      return L(), H(He, null, [
        d(r(Un), {
          visible: o.value,
          "onUpdate:visible": O[2] || (O[2] = (k) => o.value = k),
          closable: !1,
          draggable: !1,
          modal: "",
          header: T.$t("implant-planner.selectPanoRegion"),
          style: { width: "25vw" }
        }, {
          default: _(() => [
            d(r(we), { class: "flex-row gap-2 mt-4" }, {
              default: _(() => [
                d(r(Ne), {
                  class: "w-full web-rg-icon-btn",
                  label: T.$t("implant-planner.maxilla"),
                  "data-cy": "selectMaxilla",
                  onClick: O[0] || (O[0] = (k) => [m(), o.value = !1])
                }, null, 8, ["label"]),
                d(r(Ne), {
                  class: "w-full web-rg-icon-btn",
                  label: T.$t("implant-planner.mandible"),
                  "data-cy": "selectMandible",
                  onClick: O[1] || (O[1] = (k) => [I(), o.value = !1])
                }, null, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(Mo, {
          onHideWizard: O[3] || (O[3] = (k) => l("hideWizard"))
        }, {
          default: _(() => [
            vt(U(T.$t("implant-planner.cprSettings")), 1)
          ]),
          _: 1
        }),
        d(fl, null, {
          default: _(() => [
            d(r(ke), null, {
              default: _(() => [
                d(C, null, {
                  default: _(() => [
                    vt(U(T.$t("implant-planner.curveType")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(ke), { class: "gap-2" }, {
              default: _(() => [
                d(r(Ne), {
                  disabled: r(h).disabled,
                  toggled: r(h).pressed,
                  label: T.$t("implant-planner.maxilla"),
                  class: Ge(["web-rg-icon-btn grow"]),
                  "data-cy": "setMaxilla",
                  onClick: m
                }, null, 8, ["disabled", "toggled", "label"]),
                d(r(Ne), {
                  disabled: r(g).disabled,
                  toggled: r(g).pressed,
                  label: T.$t("implant-planner.mandible"),
                  class: Ge(["web-rg-icon-btn grow"]),
                  "data-cy": "setMandible",
                  onClick: I
                }, null, 8, ["disabled", "toggled", "label"])
              ]),
              _: 1
            }),
            d(r(ot), { class: "gap-2" }, {
              default: _(() => [
                d(r(ke), null, {
                  default: _(() => [
                    d(C, null, {
                      default: _(() => [
                        vt(U(T.$t("implant-planner.cprDrawing")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ne), {
                      icon: "pi pi-sparkles",
                      label: T.$t("implant-planner.automaticCprLocalization"),
                      class: Ge("w-full web-rg-icon-btn"),
                      "data-cy": "automaticCPRLocalization",
                      disabled: !r(i).AIEnabled,
                      onClick: A
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ne), {
                      id: "btnByPoints",
                      label: T.$t("implant-planner.byPoints"),
                      class: Ge("w-full web-rg-icon-btn"),
                      toggled: b.value,
                      "onUpdate:toggled": O[4] || (O[4] = (k) => b.value = k),
                      disabled: r(E).disabled,
                      togglable: r(E).toggleable
                    }, null, 8, ["label", "toggled", "disabled", "togglable"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(ot), { class: "gap-2" }, {
              default: _(() => [
                d(r(ke), null, {
                  default: _(() => [
                    d(C, null, {
                      default: _(() => [
                        vt(U(T.$t("implant-planner.cprOptions")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ne), {
                      label: T.$t("implant-planner.deleteLastPoint"),
                      class: Ge("w-full web-rg-icon-btn"),
                      "data-cy": "deleteLastPoint",
                      onClick: S,
                      disabled: !p.value
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ne), {
                      label: T.$t("shared.reset"),
                      class: Ge("w-full web-rg-icon-btn"),
                      "data-cy": "reset",
                      onClick: f,
                      disabled: !p.value
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ne), {
                      label: T.$t("implant-planner.increasePanoramicRegion"),
                      class: Ge("w-full web-rg-icon-btn"),
                      "data-cy": "increasePanoramicPoint",
                      onClick: v,
                      disabled: !p.value
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ne), {
                      label: T.$t("implant-planner.decreasePanoramicRegion"),
                      class: Ge("w-full web-rg-icon-btn"),
                      "data-cy": "decreasePanoramicPoint",
                      onClick: w,
                      disabled: !p.value
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), z0 = {
  name: "BaseInputText",
  extends: cu,
  style: _h,
  provide() {
    return {
      $pcInputText: this,
      $parentInstance: this
    };
  }
}, H0 = {
  name: "InputText",
  extends: z0,
  inheritAttrs: !1,
  methods: {
    onInput(e) {
      this.writeValue(e.target.value, e);
    }
  },
  computed: {
    attrs() {
      return je(
        this.ptmi("root", {
          context: {
            filled: this.$filled,
            disabled: this.disabled
          }
        }),
        this.formField
      );
    }
  }
}, Y0 = ["value", "disabled", "aria-invalid"];
function K0(e, t, n, a, o, l) {
  return L(), H("input", je({
    type: "text",
    class: e.cx("root"),
    value: e.d_value,
    disabled: e.disabled,
    "aria-invalid": e.$invalid || void 0,
    onInput: t[0] || (t[0] = (...s) => l.onInput && l.onInput(...s))
  }, l.attrs), null, 16, Y0);
}
const vu = /* @__PURE__ */ Vt(H0, [["render", K0]]);
function Z0() {
  return {
    nerve: {
      name: "",
      length: 0,
      diameter: 3
    },
    objects: []
  };
}
const X0 = ["data-cy", "onClick"], J0 = { class: "col-4-no-padding" }, q0 = ["src", "alt"], Q0 = { class: "col-6-no-padding" }, ew = { class: "flex flex-col mt-6 ml-6" }, tw = { class: "text-sm" }, nw = { class: "text-sm" }, aw = { class: "text-sm" }, ow = { class: "text-sm" }, yu = /* @__PURE__ */ Je({
  __name: "IPNerveDrawingWizard",
  emits: ["hideWizard"],
  setup(e, { emit: t }) {
    const n = tt(Z0()), { t: a } = Ht(), o = t;
    let l;
    const s = ia();
    let i, u = !1, c = !0;
    const p = B(!1), h = B(!1), g = B(!1), b = B(nn.MANDIBLE), E = Ce(() => h.value || g.value || b.value != nn.MANDIBLE || !p.value), m = B(Math.random() * 1e3), I = B("ff0000"), S = (q) => q.replace("#", "").toLowerCase(), f = (q) => {
      let he = S(q);
      if (he.length === 3 && (he = he.split("").map((Ee) => Ee + Ee).join("")), he.length !== 6)
        return null;
      const ne = parseInt(he.slice(0, 2), 16), te = parseInt(he.slice(2, 4), 16), Ie = parseInt(he.slice(4, 6), 16);
      return Number.isNaN(ne) || Number.isNaN(te) || Number.isNaN(Ie) ? null : [ne, te, Ie];
    }, v = (q) => q.map(
      (he) => Math.max(0, Math.min(255, Math.round(he))).toString(16).padStart(2, "0")
    ).join(""), w = () => {
      const q = i.getNerveId();
      if (q) {
        const he = l.objects.nerveObjects.get(q);
        if (he != null && he.nerve)
          return he.nerve;
      }
      return (G == null ? void 0 : G.nerve) ?? null;
    }, A = (q) => {
      const he = (q == null ? void 0 : q.getColor()) ?? rc(l.settings.defaultColors.nerves), ne = sp(he);
      I.value = v(ne);
    }, T = (q) => {
      const he = f(q);
      if (!he)
        return;
      I.value = S(q);
      const ne = rc(he);
      if (i.setNerveColor(ne), G != null && G.nerve) {
        G.nerve.setColor(ne);
        const Ie = N.value.get(G.id);
        Ie && (Ie.projectNerve.color = he);
      }
      const te = l.objects.nerveObjects.get(i.getNerveId() || "");
      te && (te.projectNerve.color = he), l.repaint();
    };
    Dt(async () => {
      l = dn(), p.value = l.AIEnabled, b.value = l.CPRType;
      const q = l.getViewWidget(Cn._3D);
      q && q.hideObjectList(!0);
      const he = l.toolManager.nerveTool;
      if (he)
        i = he;
      else
        throw new Error(a("medic-web-engine.nerveToolNotFound"));
      lt(
        () => n.nerve.name,
        async () => {
          if (i.setNerveName(n.nerve.name), G) {
            const Ie = N.value.get(G.id);
            Ie && (Ie.name = n.nerve.name, N.value.set(G.id, Ie));
            const Ee = l.objects.nerveObjects.get(i.getNerveId() || "");
            Ee && (Ee.name = n.nerve.name, Ee.projectNerve.name = n.nerve.name, l.objects.nerveObjects.set(i.getNerveId() || "", Ee));
          }
        }
      ), C(-1), A(null), G = null, K.disabled = !0, K.pressed = !1, i.takeScreenshotEvent.subscribe(async () => {
        let Ie = i.addNerveToList();
        if (Ie) {
          if (c && Ie.nerve && Ie.projectNerve.points.length > 1) {
            let Ee = await Re(Ie.nerve);
            Ee && (Ie.projectNerve.objectSubType == Oe._NERVE_LEFT ? h.value = !0 : Ie.projectNerve.objectSubType == Oe._NERVE_RIGHT && (g.value = !0), Ie.nervePreview = Ee);
          } else
            Ie.nervePreview = void 0;
          N.value.set(Ie.id, Ie), G = Ie, ce = Ie.id, n.nerve.length = Ie.length, u = !1, n.nerve.diameter = Ie.nerve.getRadius() * 2;
        }
      }), i.removeObjectEvent.subscribe((Ie) => {
        N.value.delete(Ie), i.disableEditing();
      }), i.syncWithContext.subscribe(async () => {
        N.value.clear();
        let Ie = !1, Ee = !1;
        for (let [xe, Qe] of l.objects.nerveObjects) {
          if (Qe.nerve) {
            let Ke = await Re(Qe.nerve);
            Ke && (Qe.nervePreview = Ke);
          }
          Qe.projectNerve.objectSubType == Oe._NERVE_LEFT ? Ee = !0 : Qe.projectNerve.objectSubType == Oe._NERVE_RIGHT && (Ie = !0), N.value.set(xe, Qe);
        }
        h.value = Ee, g.value = Ie;
      });
      let ne = !1, te = !1;
      for (let [Ie, Ee] of l.objects.nerveObjects) {
        if (Ee.nerve) {
          let xe = await Re(Ee.nerve);
          xe && (Ee.nervePreview = xe);
        }
        Ee.projectNerve.objectSubType == Oe._NERVE_LEFT ? te = !0 : Ee.projectNerve.objectSubType == Oe._NERVE_RIGHT && (ne = !0), N.value.set(Ie, Ee);
      }
      h.value = te, g.value = ne;
    }), Ln(() => {
      try {
        const q = l.getViewWidget(Cn._3D);
        q && q.hideObjectList(!1);
      } catch (q) {
        console.log(q);
      }
    });
    const O = B([!1, !1, !1]), C = (q) => {
      O.value = [!1, !1, !1], q != -1 && (O.value[q] = !0), M.pressed = O.value[0], z.pressed = O.value[1], j.pressed = O.value[2];
    };
    let k = tt({
      disabled: E,
      pressable: !0
    }), M = tt({
      disabled: g,
      pressable: !0,
      pressed: O.value[0]
    }), z = tt({
      disabled: h,
      pressable: !0,
      pressed: O.value[1]
    }), j = tt({
      disabled: !1,
      pressable: !0,
      pressed: O.value[2]
    }), K = tt({
      disabled: !1,
      pressable: !0,
      pressed: !1,
      label: it("implant-planner.finishDrawing")
    }), x = tt({
      value: n.nerve.diameter,
      minValue: 0.1,
      maxValue: 10,
      step: 0.1
    });
    lt(x, () => {
      u && x.value ? i.setNerveRadius(x.value / 2, !0) : u = !0;
    });
    const N = B(/* @__PURE__ */ new Map());
    let G = null, ce = "";
    const re = (q) => {
      if (i.getNerveNumberOfPoints() == 0) {
        const te = l.objects.nerveObjects.get(i.getNerveId() || "");
        te && (te.projectNerve.objectSubType == Oe._NERVE_LEFT ? h.value = !1 : te.projectNerve.objectSubType == Oe._NERVE_RIGHT && (g.value = !1), te.nerve.delete()), l.objects.nerveObjects.delete(i.getNerveId() || ""), N.value.delete(i.getNerveId() || "");
      }
      G = null, C(0);
      let he = "";
      if (q)
        he = q.nerve.id;
      else
        for (let [te, Ie] of N.value)
          Ie.nerve.objectSubType == Oe._NERVE_RIGHT && (he = Ie.nerve.id);
      i.getDataFromObject(he, !1, !0), i.enableEditing(), n.nerve.name = i.getNerveName() || a("implant-planner.rightNerve"), n.nerve.length = (q == null ? void 0 : q.length) || 0, u = !1, n.nerve.diameter = i.getNerveRadius() * 2, x.value = n.nerve.diameter, K.disabled = !1;
      const ne = N.value.get(i.getNerveId() || "");
      ne && (G = ne, ce = ne.id), A(w());
    }, Se = (q) => {
      if (i.getNerveNumberOfPoints() == 0) {
        const te = l.objects.nerveObjects.get(i.getNerveId() || "");
        te && (te.projectNerve.objectSubType == Oe._NERVE_LEFT ? h.value = !1 : te.projectNerve.objectSubType == Oe._NERVE_RIGHT && (g.value = !1), te.nerve.delete()), l.objects.nerveObjects.delete(i.getNerveId() || ""), N.value.delete(i.getNerveId() || "");
      }
      G = null, C(1);
      let he = "";
      if (q)
        he = q.nerve.id;
      else
        for (let [te, Ie] of N.value)
          Ie.nerve.objectSubType == Oe._NERVE_LEFT && (he = Ie.nerve.id);
      i.getDataFromObject(he, !0, !1), i.enableEditing(), n.nerve.name = i.getNerveName() || a("implant-planner.leftNerve"), n.nerve.length = (q == null ? void 0 : q.length) || 0, u = !1, n.nerve.diameter = i.getNerveRadius() * 2, x.value = n.nerve.diameter, K.disabled = !1;
      const ne = N.value.get(i.getNerveId() || "");
      ne && (G = ne, ce = ne.id), A(w());
    }, se = (q) => {
      var te;
      C(2), G = null;
      let he = "";
      q && (he = q), i.getDataFromObject(he, !1, !1), i.enableEditing(), n.nerve.name = i.getNerveName() || a("implant-planner.customObject"), n.nerve.length = ((te = i.addNerveToList()) == null ? void 0 : te.length) || 0, u = !1, n.nerve.diameter = i.getNerveRadius() * 2, x.value = n.nerve.diameter, K.disabled = !1;
      const ne = N.value.get(i.getNerveId() || "");
      ne && (G = ne, ce = ne.id), A(w()), l.sceneRepaint();
    }, Le = async () => {
      if (C(-1), i.getNerveNumberOfPoints() == 0) {
        const q = l.objects.nerveObjects.get(i.getNerveId() || "");
        q && (q.projectNerve.objectSubType == Oe._NERVE_LEFT ? h.value = !1 : q.projectNerve.objectSubType == Oe._NERVE_RIGHT && (g.value = !1), q.nerve.delete()), l.objects.nerveObjects.delete(i.getNerveId() || ""), N.value.delete(i.getNerveId() || "");
      } else {
        console.log("finishDrawing - Not Deleting");
        const q = i.addNerveToList();
        if (q) {
          if (n.nerve.name = q.name, n.nerve.length = q.length, u = !1, n.nerve.diameter = q.nerve.getRadius() * 2, q.nerve) {
            let he = await Re(q.nerve);
            he && (q.nervePreview = he);
          }
          q.projectNerve.objectSubType == Oe._NERVE_LEFT ? h.value = !0 : q.projectNerve.objectSubType == Oe._NERVE_RIGHT && (g.value = !0), N.value.set(q.id, q);
        }
      }
      i.disableEditing(), G = null, ce = "", K.disabled = !0;
    }, Y = (q) => {
      G = q, ce = q.id, m.value = Math.random() * 1e3, q.nerve.objectSubType == Oe._NERVE_LEFT ? Se(q) : q.nerve.objectSubType == Oe._NERVE_RIGHT ? re(q) : se(q.id);
    }, pe = async () => {
      await i.automaticNerveLandmarkLocalization(s);
    }, fe = () => {
      G != null && (i.getNerveNumberOfPoints() == 1 ? le() : i.removeLastPickedPoint());
    }, le = () => {
      if (c = !1, G) {
        const q = l.objects.nerveObjects.get(i.getNerveId() || "");
        if (q) {
          const he = q.nerve.toProjectNerve();
          he.objectSubType == Oe._NERVE_LEFT ? h.value = !1 : he.objectSubType == Oe._NERVE_RIGHT && (g.value = !1);
          const ne = i.getNerveId() || "", te = new Bl({
            onUndo: () => {
              l.objects.addNerve(he, ne), l.insertFlag = !0, i.insertPointsFromProject();
            },
            onRedo: () => {
              const Ie = l.objects.nerveObjects.get(ne);
              Ie && (Ie.projectNerve.objectSubType == Oe._NERVE_LEFT ? h.value = !1 : Ie.projectNerve.objectSubType == Oe._NERVE_RIGHT && (g.value = !1), Ie.nerve.delete()), l.objects.nerveObjects.delete(ne), i.removeObjectEvent.notify(ne);
            }
          });
          l.undoManager.pushPop(this, te, it("medic-web-engine.deleteNerve"), Ul.SCENE_REPAINT), i.clearAllPoints();
        }
      }
      C(-1), c = !0, G = null, K.disabled = !0;
    };
    async function Re(q) {
      if (!q)
        return;
      const he = l.viewConfiguration.colorScheme.get();
      return await ea(q, he);
    }
    return (q, he) => {
      const ne = Mo, te = io, Ie = vu, Ee = fl;
      return L(), H(He, null, [
        d(ne, {
          onHideWizard: he[0] || (he[0] = (xe) => o("hideWizard"))
        }, {
          default: _(() => [
            vt(U(q.$t("implant-planner.nerveWizard")), 1)
          ]),
          _: 1
        }),
        d(Ee, null, {
          default: _(() => [
            d(r(ke), null, {
              default: _(() => [
                d(te, null, {
                  default: _(() => [
                    vt(U(q.$t("implant-planner.assistedDrawing")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(ke), null, {
              default: _(() => [
                d(r(Ne), {
                  icon: "pi pi-sparkles",
                  disabled: r(k).disabled,
                  label: q.$t("implant-planner.automaticNerveDetection"),
                  class: Ge("w-full web-rg-icon-btn"),
                  onClick: pe
                }, null, 8, ["disabled", "label"])
              ]),
              _: 1
            }),
            d(r(ke), null, {
              default: _(() => [
                d(te, null, {
                  default: _(() => [
                    vt(U(q.$t("implant-planner.manualDrawing")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(ke), null, {
              default: _(() => [
                d(r(Ne), {
                  id: "btnAddRightNerve",
                  disabled: r(M).disabled,
                  toggled: r(M).pressed,
                  label: q.$t("implant-planner.addRightNerve"),
                  class: Ge("w-full web-rg-wiz-btn"),
                  onClick: he[1] || (he[1] = (xe) => re())
                }, null, 8, ["disabled", "toggled", "label"])
              ]),
              _: 1
            }),
            d(r(ke), null, {
              default: _(() => [
                d(r(Ne), {
                  id: "btnAddLeftNerve",
                  disabled: r(z).disabled,
                  toggled: r(z).pressed,
                  label: q.$t("implant-planner.addLeftNerve"),
                  class: Ge("w-full web-rg-wiz-btn"),
                  onClick: he[2] || (he[2] = (xe) => Se())
                }, null, 8, ["disabled", "toggled", "label"])
              ]),
              _: 1
            }),
            d(r(ke), null, {
              default: _(() => [
                d(r(Ne), {
                  id: "btnAddCustomObject",
                  disabled: r(j).disabled,
                  toggled: r(j).pressed,
                  label: q.$t("implant-planner.addCustomObject"),
                  class: Ge("w-full web-rg-wiz-btn"),
                  onClick: he[3] || (he[3] = (xe) => se(void 0))
                }, null, 8, ["disabled", "toggled", "label"])
              ]),
              _: 1
            }),
            d(r(ke), null, {
              default: _(() => [
                d(te, null, {
                  default: _(() => [
                    vt(U(q.$t("implant-planner.objectsClickToEdit")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (L(!0), H(He, null, jt(N.value, (xe, Qe) => (L(), H("div", {
              key: m.value,
              class: Ge([xe[1].id === r(ce) ? "p-highlight" : "", "cursor-pointer flex-row-wrap w-full"]),
              "data-cy": "selectNerve" + Qe,
              onClick: (Ke) => Y(xe[1])
            }, [
              y("div", J0, [
                y("img", {
                  src: xe[1].nervePreview,
                  alt: q.$t("medic-web-engine.nervePreview"),
                  class: "w-full all-radius",
                  draggable: "false"
                }, null, 8, q0)
              ]),
              y("div", Q0, [
                y("span", ew, [
                  y("span", null, U(xe[1].name), 1),
                  y("span", null, U(q.$t("implant-planner.length")) + ": " + U(xe[1].length.toFixed(2)) + " mm", 1)
                ])
              ])
            ], 10, X0))), 128)),
            r(K).disabled ? ue("", !0) : (L(), be(r(ot), {
              key: 0,
              class: "gap-2",
              style: { "margin-top": "auto", "padding-bottom": "0.5rem !important" }
            }, {
              default: _(() => [
                d(r(ke), {
                  class: "ml-1 gap-4",
                  style: { "align-items": "center" }
                }, {
                  default: _(() => [
                    d(r(we), { style: { flex: "1 1 0" } }, {
                      default: _(() => [
                        y("span", tw, U(q.$t("shared.name")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(we), { style: { flex: "5 0" } }, {
                      default: _(() => [
                        d(Ie, {
                          class: "flex justify-end w-full",
                          modelValue: n.nerve.name,
                          "onUpdate:modelValue": he[4] || (he[4] = (xe) => n.nerve.name = xe),
                          pt: {
                            root: {
                              style: {
                                height: "28px !important",
                                fontSize: "0.875rem",
                                lineSize: "1.25rem"
                              }
                            }
                          }
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ke), {
                  class: "ml-1 gap-4",
                  style: { "align-items": "center" }
                }, {
                  default: _(() => [
                    d(r(we), { style: { flex: "1 1 0" } }, {
                      default: _(() => [
                        y("span", nw, U(q.$t("implant-planner.length")) + ":", 1)
                      ]),
                      _: 1
                    }),
                    d(r(we), { style: { flex: "4 0 0" } }, {
                      default: _(() => [
                        y("span", aw, U(n.nerve.length.toFixed(2)) + " " + U(q.$t("shared.mm")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Vi), {
                  class: "w-full",
                  modelValue: r(x).value,
                  "onUpdate:modelValue": he[5] || (he[5] = (xe) => r(x).value = xe),
                  min: r(x).minValue,
                  max: r(x).maxValue,
                  step: r(x).step,
                  label: q.$t("implant-planner.diameter"),
                  "show-buttons": !0,
                  "unit-label": q.$t("shared.mm")
                }, null, 8, ["modelValue", "min", "max", "step", "label", "unit-label"]),
                d(r(ke), {
                  class: "ml-1 gap-4",
                  style: { "align-items": "center" }
                }, {
                  default: _(() => [
                    d(r(we), { style: { flex: "1 1 0" } }, {
                      default: _(() => [
                        y("span", ow, U(q.$t("shared.color")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(we), { style: { flex: "4 0 0" } }, {
                      default: _(() => [
                        (L(), be(r(Ag), {
                          key: I.value,
                          color: I.value,
                          onColorValueChanged: T
                        }, null, 8, ["color"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ke), { class: "mt-2" }, {
                  default: _(() => [
                    d(r(Ne), {
                      label: q.$t("implant-planner.deleteLastPoint"),
                      class: Ge("w-full web-rg-icon-btn"),
                      "data-cy": "deleteLastPoint",
                      onClick: fe
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }),
                d(r(ke), { class: "w-full" }, {
                  default: _(() => [
                    d(r(Ne), {
                      id: "btnFinishDrawing",
                      disabled: r(K).disabled,
                      label: r(K).label,
                      class: Ge("w-full web-rg-icon-btn"),
                      onClick: Le
                    }, null, 8, ["disabled", "label"])
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ne), {
                      label: q.$t("shared.delete"),
                      class: Ge("w-full web-rg-icon-btn"),
                      "data-cy": "deleteObject",
                      onClick: le
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), lw = {
  class: "relative",
  style: { width: "248px", height: "160px", "user-select": "none" }
}, iw = ["src"], sw = ["data-cy", "onClick", "onMouseout", "onMouseover"], rw = { style: { "font-size": "x-small", "font-weight": "bold", color: "red", "white-space": "pre-wrap", "text-shadow": "1px 1px 5px rgba(0, 0, 0, 1)" } }, uw = ["src"];
[...Array(9).keys()].map((e) => e + 1);
const sd = ["NULL", "A", "B", "C", "D", "E", "F", "G", "H", "I"], cw = /* @__PURE__ */ Je({
  __name: "IPPinView",
  props: {
    jawboneType: {},
    pins: {},
    modelValue: {},
    isReadonly: { type: Boolean },
    warningString: {}
  },
  emits: ["pinClick", "pinMouseOver", "pinMouseOut", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = {
      8: ["Pin H", [218, 101]],
      6: ["Pin F", [204, 70]],
      4: ["Pin D", [181, 43]],
      2: ["Pin B", [150, 25]],
      1: ["Pin A", [112, 19]],
      3: ["Pin C", [74, 25]],
      5: ["Pin E", [43, 44]],
      7: ["Pin G", [20, 69]],
      9: ["Pin I", [6, 101]]
    }, a = {
      8: ["Pin H", [209, 73]],
      6: ["Pin F", [191, 100]],
      4: ["Pin D", [171, 123]],
      2: ["Pin B", [142, 138]],
      1: ["Pin A", [111, 143]],
      3: ["Pin C", [81, 138]],
      5: ["Pin E", [52, 122]],
      7: ["Pin G", [31, 99]],
      9: ["Pin I", [13, 73]]
    }, o = {
      [pt.EMPTY]: [
        [255, 255, 255],
        [41, 110, 179]
      ],
      [pt.OK]: [
        [210, 255, 162],
        [41, 110, 179]
      ],
      [pt.OK_SELECTED]: [
        [111, 215, 0],
        [255, 255, 255]
      ],
      [pt.COLLISION]: [
        [233, 200, 200],
        [41, 110, 179]
      ],
      [pt.COLLISION_SELECTED]: [
        [199, 2, 2],
        [255, 255, 255]
      ]
    }, l = e, s = t, { pins: i, jawboneType: u, isReadonly: c } = on(l), p = sa(), h = Ce(() => u.value === nn.MAXILLA ? n : a), g = Ce(
      () => u.value === nn.MAXILLA ? p.getAssetUrl("/resources/teeth/maxilla_pin-02.png") : p.getAssetUrl("/resources/teeth/mandible_pin-02.png")
    ), b = (A, T, O) => `rgb(${A}, ${T}, ${O})`, E = Ce(() => {
      const A = {};
      for (const T in h.value) {
        const O = i.value[T] || pt.EMPTY, [C, k] = o[O];
        A[T] = {
          backgroundColor: b(C[0], C[1], C[2]),
          color: b(k[0], k[1], k[2])
        };
      }
      return A;
    }), m = B(0), I = (A, T) => {
      s("pinClick", A, T);
    }, S = (A, T) => {
      s("pinMouseOver", A, T), s("update:modelValue", A), m.value = A;
    }, f = (A, T) => {
      s("pinMouseOut", A, T), s("update:modelValue", 0), m.value = 0;
    }, v = Ce(() => !c.value && m.value && (!i.value[m.value] || i.value[m.value] === pt.EMPTY)), w = () => u.value === nn.MAXILLA ? { top: "70%" } : { top: "10%" };
    return (A, T) => (L(), H("div", lw, [
      y("img", {
        src: g.value,
        alt: "",
        draggable: "false"
      }, null, 8, iw),
      (L(!0), H(He, null, jt(h.value, (O, C) => (L(), H("div", {
        key: C,
        style: Et([[
          {
            left: O[1][0] + "px",
            top: O[1][1] + "px"
          },
          E.value[C]
        ], { width: "24px", height: "24px", "font-weight": "bold", "font-size": "12px", "border-radius": "12px" }]),
        class: "absolute flex justify-center items-center",
        "data-cy": `pin-${sd[C]}`,
        onClick: (k) => I(+C, k),
        onMouseout: (k) => f(+C, k),
        onMouseover: (k) => S(+C, k)
      }, [
        y("div", null, U(sd[C]), 1)
      ], 44, sw))), 128)),
      y("div", {
        class: "absolute w-6/12 h-6 flex justify-center",
        style: Et([w(), { "text-align": "center", left: "25%" }])
      }, [
        y("span", rw, U(e.warningString), 1)
      ], 4),
      v.value ? (L(), H("img", {
        key: 0,
        style: Et([{
          left: h.value[m.value][1][0] + "px",
          top: h.value[m.value][1][1] + "px"
        }, { width: "24px", height: "24px" }]),
        alt: "",
        class: "absolute pointer-events-none",
        src: r(p).getAssetUrl("/resources/teeth/AddPin.png"),
        draggable: "false"
      }, null, 12, uw)) : ue("", !0)
    ]));
  }
}), Li = {
  sleeveInfo: null,
  stale: !1
};
function dw(e, t) {
  return `${e}__${t}`;
}
function Uo(e, t = 0) {
  const n = typeof e == "number" ? e : Number(e);
  return Number.isFinite(n) ? n : t;
}
function Oi(e) {
  if (typeof e != "string")
    return "";
  const t = e.trim();
  return t.length > 0 ? t : "";
}
function pw(e) {
  const t = new Int8Array(e);
  if (t.length !== 0)
    return {
      fileName: "",
      data: t,
      fileSize: t.length
    };
}
async function rd(e, t) {
  var n, a;
  try {
    const o = pw(await t.loadFile(e));
    return (n = t.isStale) != null && n.call(t) ? { file: void 0, stale: !0 } : { file: o, stale: !1 };
  } catch (o) {
    return (a = t.isStale) != null && a.call(t) ? { file: void 0, stale: !0 } : (console.warn("Failed to load sleeve STL file", { s3ObjectRef: e, error: o }), { file: void 0, stale: !1 });
  }
}
async function mw(e, t) {
  var h, g;
  if ((h = t.isStale) != null && h.call(t))
    return { ...Li, stale: !0 };
  const n = Oi(e.s3ObjectRef), a = Oi(e.inverses3ObjectRef), o = Oi(e.stl_guid), l = Oi(e.stl_negative_guid);
  let s, i;
  if (n) {
    const b = await rd(n, t);
    if (b.stale)
      return { ...Li, stale: !0 };
    s = b.file;
  }
  if (a) {
    const b = await rd(a, t);
    if (b.stale)
      return { ...Li, stale: !0 };
    i = b.file;
  }
  const u = {
    manufacturerName: e.manufacturer ?? "",
    modelName: e.name,
    sellingCode: e.sellingCode,
    dExternal: Uo(e.dextsleevepin),
    dInternal: Uo(e.dintsleevepin),
    lSleeve: Uo(e.lslsleevepin),
    lLip: Uo(e.llipsleevepin),
    dHexagon: Uo(e.dlipsleevepin),
    distanceFromImplant: Uo(e.lpinsleeve),
    drillLengthSizes: "",
    originalName: dw(e.manufacturer, e.name),
    stlFileGuid: o ?? n ?? "",
    stlFileNegativeGuid: l ?? a ?? "",
    cylinderShape: e.cylinder_shape ?? !1,
    lCut: 0,
    originalDistanceFromImplant: -1,
    reductionSystemSize: 0,
    rotationAll: 0,
    rotationCut: 0,
    connectionIndex: 0,
    referencedSleeve: 1,
    stlData: s,
    stlNegativeData: i
  }, c = !!((g = u.stlData) != null && g.data.length), p = u.dInternal > 0 && (u.dExternal > 0 || u.dHexagon > 0) && u.lSleeve > 0;
  return !c && !p ? Li : {
    sleeveInfo: u,
    stale: !1
  };
}
const fw = { class: "flex content-center justify-center" }, gw = { class: "text-12 font-medium" }, hw = ["src"], bw = { class: "ml-1 flex items-center" }, vw = { class: "flex content-center justify-center" }, yw = { class: "text-12 font-medium" }, _w = { key: 0 }, ww = ["src"], Iw = /* @__PURE__ */ Je({
  __name: "IPPinPlanning",
  props: {
    isReadOnly: { type: Boolean }
  },
  setup(e) {
    const { t } = Ht(), n = e, { isReadOnly: a } = on(n);
    let o;
    if (!n.isReadOnly) {
      const Q = dl();
      if (!Q.cachedResponse)
        throw new Error("STL Library cache not initialized");
      o = new Wr(Q.cachedResponse, zr());
    }
    function l(Q) {
      return { name: `${Q.manufacturer} / ${Q.name}`, value: Q };
    }
    function s(Q) {
      return (Q == null ? void 0 : Q.trim().toLowerCase()) ?? "";
    }
    function i(Q, ie) {
      return Q.uuid && ie.uuid ? Q.uuid === ie.uuid : s(Q.manufacturer) === s(ie.manufacturer) && s(Q.name) === s(ie.name);
    }
    function u(Q, ie) {
      return Q.id && ie.id ? Q.id === ie.id : Q.stl_guid && ie.stl_guid ? Q.stl_guid === ie.stl_guid : Q.s3ObjectRef && ie.s3ObjectRef ? Q.s3ObjectRef === ie.s3ObjectRef : Q.original_name && ie.original_name ? s(Q.original_name) === s(ie.original_name) : s(Q.manufacturer) === s(ie.manufacturer) && s(Q.name) === s(ie.name);
    }
    function c(Q, ie) {
      const W = s(ie);
      return W ? s(Q.stl_guid) === W || s(Q.s3ObjectRef) === W : !1;
    }
    function p(Q, ie, W) {
      return Q.find((ee) => W(ee.value, ie));
    }
    function h(Q, ie, W) {
      if (!ie)
        return Q;
      const ee = p(Q, ie.value, W);
      return ee ? ee === ie ? Q : Q.map(($) => $ === ee ? ie : $) : [ie, ...Q];
    }
    function g(Q) {
      if (!Q)
        return;
      const ie = Q.sleeveIds;
      if (!(!ie || ie.length === 0))
        return ie;
    }
    const b = B(!1), E = B(!1), m = B(!1), I = B(!1), S = B(), f = B(), v = B(0);
    let w, A, T, O;
    const { watch: C, onEvent: k } = Ra(), M = B([]), z = B([]), j = B();
    let K = tt({
      clicked: !1,
      state: !1,
      disabled: !1
    });
    tt({
      clicked: !1,
      state: !1,
      disabled: !1
    });
    function x() {
      const Q = o.pins().map((ie) => l(ie));
      M.value = h(Q, S.value, i), S.value && (S.value = p(M.value, S.value.value, i)), N();
    }
    function N(Q = ((ie) => (ie = S.value) == null ? void 0 : ie.value)()) {
      const W = g(Q), ee = K.state || !W, $ = o.getPinSleevesFiltered(ee, W);
      z.value = h($, f.value, u), f.value && (f.value = p(z.value, f.value.value, u));
    }
    async function G() {
      N(), !K.state && S.value && await Ke(S.value);
    }
    function ce(Q) {
      const ie = Q.stlFileGuid ? z.value.find(($) => c($.value, Q.stlFileGuid || "")) : void 0;
      if (ie)
        return ie;
      const W = Q.originalName ? z.value.find(($) => s($.value.original_name) === s(Q.originalName)) : void 0;
      if (W)
        return W;
      const ee = z.value.find(
        ($) => s($.value.manufacturer) === s(Q.manufacturerName) && s($.value.name) === s(Q.modelName)
      );
      return ee || z.value.find(($) => s($.value.name) === s(Q.modelName));
    }
    const re = dn(), Se = B(0), se = () => {
      Se.value === 0 && re.showLoading(t("implant-planner.loadingObject")), Se.value += 1;
    }, Le = () => {
      Se.value > 0 && (Se.value -= 1), Se.value === 0 && re.hideLoading();
    };
    let Y = tt({
      jawboneType: re.CPRType,
      pins: [],
      selectedObject: null,
      warnString: ""
    });
    const pe = ["Pin 0", "Pin 1", "Pin 2", "Pin 3", "Pin 4", "Pin 5", "Pin 6", "Pin 7", "Pin 8", "Pin 9"];
    function fe() {
      return pe;
    }
    function le() {
      return ["NULL", "Pin A", "Pin B", "Pin C", "Pin D", "Pin E", "Pin F", "Pin G", "Pin H", "Pin I"];
    }
    function Re(Q) {
      return q(le()[Q]) || q(fe()[Q]);
    }
    function q(Q) {
      return re.objects.pinExists(Q);
    }
    function he(Q) {
      return re.objects.pins.getByName(le()[Q]) || re.objects.pins.getByName(fe()[Q]);
    }
    function ne(Q) {
      return Q ? !!(Q.collisions.nerveCollision || Q.collisions.sleeveCollision || Q.collisions.anatomyCollision || Q.collisions.implantCollision || Q.collisions.securityZoneCollision) : !1;
    }
    function te() {
      Y.warnString = "", Y.pins = le().map((Q, ie) => {
        if (q(Q) || q(pe[ie])) {
          const W = he(ie);
          return Y.selectedObject && (Y.selectedObject.pin.name === Q || Y.selectedObject.pin.name === pe[ie]) ? ne(W) ? (W && W.collisions && (W.collisions.nerveCollision && (Y.warnString += `${t("implant-planner.nerveCollision")} 
`), W.collisions.sleeveCollision && (Y.warnString += `${t("implant-planner.sleeveCollision")} 
`), W.collisions.anatomyCollision && (Y.warnString += `${t("implant-planner.anatomyCollision")} 
`), W.collisions.implantCollision && (Y.warnString += `${t("implant-planner.implantCollision")} 
`)), pt.COLLISION_SELECTED) : pt.OK_SELECTED : ne(W) ? pt.COLLISION : pt.OK;
        }
        return pt.EMPTY;
      });
    }
    te();
    function Ie(Q) {
      const ie = Re(Q), W = he(Q);
      ie && (ne(W) ? Y.pins[Q] = pt.COLLISION_SELECTED : Y.pins[Q] = pt.OK_SELECTED);
    }
    function Ee() {
      te();
    }
    function xe() {
      return o.pins()[0];
    }
    function Qe(Q, ie, W, ee, $, R) {
      const D = Wo(parseInt(W.color)), V = Xg();
      V.origin = ee ?? [0, 0, 0], V.viewUp = R ?? [0, 0, 1], V.normal = $ ?? [0, 1, 0], V.tangent = [0, 0, 0], V.name = Q, V.color = D, V.objectType = Oe._PIN, V.objectSubType = Oe._NONE;
      const Z = new Int8Array(ie);
      return V.pinInfo = {
        filename: "",
        manufacturerName: W.manufacturer,
        modelName: W.name,
        guid: W.uuid,
        name: Q,
        color: W.color,
        stlFile: {
          fileName: "",
          data: Z,
          fileSize: Z.length
        }
      }, V.implantGuide && V.sleeveInfo && (V.implantGuide.guide_radius_hexagon = -V.sleeveInfo.dHexagon / 2, V.implantGuide.guide_lip_length = V.sleeveInfo.lLip), V;
    }
    async function Ke(Q, ie) {
      var R;
      N(Q.value);
      const W = ie ? p(z.value, ie.value, u) : void 0;
      if (W) {
        f.value = W, await P(W);
        return;
      }
      const ee = (R = Q.value) == null ? void 0 : R.defaultSleeveId;
      if (ee) {
        const D = o.getPinSleevesById(ee);
        if (D) {
          const V = p(z.value, D, u);
          if (V) {
            f.value = V, await P(V);
            return;
          }
        }
      }
      const $ = z.value[0];
      f.value = $, $ && await P($);
    }
    async function qe(Q) {
      const ie = le()[Q];
      if (!q(ie) && !q(pe[Q])) {
        if (a.value)
          return;
        se();
        try {
          const W = xe(), ee = await o.getFile(W.s3ObjectRef), $ = re.toolManager.coordControl.getObjectPos(Oe._PIN), R = re.toolManager.coordControl.getObjectDir(Oe._PIN), D = re.toolManager.coordControl.getObjectViewup(Oe._PIN);
          re.objects.addPin(Qe(ie, ee, W, $, R, D), !0), re.objects.selectObject(ie), await Ke(l(W)), re.sceneRepaint();
        } finally {
          Le();
        }
      } else
        re.objects.selectObject(q(ie) ? ie : pe[Q]);
      te();
    }
    async function rt(Q) {
      if (Y.selectedObject && Q) {
        const ie = Y.selectedObject.pin.name;
        if (ie && q(ie)) {
          const W = f.value;
          se();
          try {
            const ee = await o.getFile(Q.value.s3ObjectRef);
            re.objects.replacePin(Qe(ie, ee, Q.value)), await Ke(Q, W), re.sceneRepaint();
          } finally {
            Le();
          }
        }
      }
    }
    async function P(Q) {
      if (Y.selectedObject && Q) {
        const ie = Y.selectedObject.pin.name;
        if (ie) {
          const W = re.objects.pins.getByName(ie);
          if (W) {
            const ee = ++v.value, $ = await mw(Q.value, {
              loadFile: (R) => o.getFile(R),
              isStale: () => ee !== v.value
            });
            if ($.stale)
              return;
            if ($.sleeveInfo) {
              W.replaceSleeve($.sleeveInfo);
              const R = W.getSleeve();
              m.value = !!R, E.value = (R == null ? void 0 : R.getVisibility()) || !1, Y.selectedObject = W.toProjectPin();
            } else
              console.warn("error in sleeve data", Q.value);
          }
        }
      }
    }
    async function F(Q) {
      var ie, W, ee, $, R, D, V;
      if (!(Q && Q.type !== Oe._PIN))
        if (n.isReadOnly)
          if (Q) {
            I.value = Q.getLocked(), b.value = Q.getVisibility(), Y.selectedObject = Q.toProjectPin();
            const Z = Y.selectedObject.sleeve, X = re.viewConfiguration.colorScheme.get();
            if (w = await ea(Q, X), T = ((ee = Y.selectedObject) == null ? void 0 : ee.pin.pinInfo.manufacturerName) + " / " + (($ = Y.selectedObject) == null ? void 0 : $.pin.pinInfo.modelName), Z) {
              m.value = !0, E.value = ((R = Q.getSleeve()) == null ? void 0 : R.getVisibility()) || !1;
              const Ae = Q.getSleeve();
              O = (V = (D = Y.selectedObject) == null ? void 0 : D.sleeve) == null ? void 0 : V.originalName, Ae ? A = await ea(Ae, X) : A = void 0;
            } else
              O = void 0, m.value = !1, A = void 0;
          } else
            A = void 0, T = void 0, O = void 0, w = void 0, Y.selectedObject = null, m.value = !1;
        else if (Q) {
          I.value = Q.getLocked(), b.value = Q.getVisibility(), Y.selectedObject = Q.toProjectPin();
          const Z = Y.selectedObject.pin.name, X = j.value !== Z;
          j.value = Z, X && (K.state = !1), x();
          const Ae = Y.selectedObject.pin.pinInfo;
          if (Ae) {
            const at = o.pins().find((Be) => Be.uuid === Ae.guid);
            at && (S.value = p(M.value, at, i));
          }
          K.disabled = !S.value, N((ie = S.value) == null ? void 0 : ie.value);
          const De = Y.selectedObject.sleeve;
          De ? (m.value = !0, f.value = ce(De), E.value = ((W = Q.getSleeve()) == null ? void 0 : W.getVisibility()) || !1) : (m.value = !1, f.value = void 0), await mn();
        } else
          Y.selectedObject = null, m.value = !1, K.disabled = !0, K.state = !1, j.value = void 0, S.value = void 0, f.value = void 0;
    }
    function me() {
      Y.selectedObject && (I.value = !I.value, re.objects.changeLockStatus(Y.selectedObject.pin.name, I.value));
    }
    function de(Q) {
      Q == Oe._PIN ? Y.selectedObject && (b.value = !b.value, re.objects.setObjectVisibility(Y.selectedObject.pin.name, b.value)) : Q == Oe._SLEEVE && Y.selectedObject && (E.value = !E.value, re.objects.setObjectPartVisibility(Y.selectedObject.pin.name, Q, E.value));
    }
    function We() {
      Y.selectedObject && (re.objects.removePin(Y.selectedObject.pin.name), re.sceneRepaint());
    }
    return C(re.objects.selectedObject, async (Q) => {
      await F(Q), te();
    }), k(re.objects.updateImplantPlannerGUIEvent, async (Q) => {
      Q != null && (await F(Q), te());
    }), Dt(() => {
      F(re.objects.selectedObject.get()), te();
    }), Ha(() => {
      Se.value > 0 && re.hideLoading();
    }), (Q, ie) => {
      const W = cw, ee = io;
      return L(), H(He, null, [
        d(r(ot), { class: "gap-2" }, {
          default: _(() => [
            d(r(ke), { class: "justify-center" }, {
              default: _(() => [
                vt(U(Q.$t("implant-planner.clickOnPinMarkerToAddAPin")), 1)
              ]),
              _: 1
            }),
            d(r(ke), null, {
              default: _(() => [
                d(W, {
                  isReadonly: r(a),
                  jawboneType: r(Y).jawboneType,
                  pins: r(Y).pins,
                  warningString: r(Y).warnString,
                  onPinClick: qe,
                  onPinMouseOut: Ee,
                  onPinMouseOver: Ie
                }, null, 8, ["isReadonly", "jawboneType", "pins", "warningString"])
              ]),
              _: 1
            }),
            d(r(ke), { class: "mt-2" }, {
              default: _(() => [
                d(r(Ot), null, {
                  default: _(() => [
                    d(ee, null, {
                      default: _(() => [
                        vt(U(Q.$t("implant-planner.pinType")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Ot), {
                  class: "gap-1",
                  style: { "justify-content": "end" }
                }, {
                  default: _(() => [
                    r(a) ? ue("", !0) : (L(), be(r(Ne), {
                      key: 0,
                      class: "shrink",
                      disabled: !S.value,
                      isToolbarButton: !0,
                      onClick: ie[0] || (ie[0] = ($) => We()),
                      iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"])),
                    d(r(Ne), {
                      class: "shrink",
                      disabled: !S.value,
                      iconSrc: b.value ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg",
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      isToolbarButton: !0,
                      onClick: ie[1] || (ie[1] = ($) => de(r(Oe)._PIN)),
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"]),
                    r(a) ? ue("", !0) : (L(), be(r(Ne), {
                      key: 1,
                      class: "shrink",
                      disabled: !S.value,
                      isToolbarButton: !0,
                      iconSrc: I.value ? "/icons/new_icons/ik_lock_28.svg" : "/icons/new_icons/ik_lock_open_28.svg",
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      onClick: ie[2] || (ie[2] = ($) => me()),
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            r(a) ? (L(), be(r(ke), {
              key: 1,
              class: "gap-4"
            }, {
              default: _(() => [
                y("span", gw, U(r(T)), 1),
                r(w) ? (L(), H("img", {
                  key: 0,
                  src: r(w),
                  alt: "Implant preview",
                  draggable: "false"
                }, null, 8, hw)) : ue("", !0)
              ]),
              _: 1
            })) : (L(), be(r(ke), { key: 0 }, {
              default: _(() => [
                d(r(kn), {
                  modelValue: S.value,
                  "onUpdate:modelValue": ie[3] || (ie[3] = ($) => S.value = $),
                  model: M.value,
                  class: "w-full",
                  listStyle: "height: 15vh",
                  onUserChange: rt,
                  "data-cy": "pin-list"
                }, {
                  empty: _(() => [
                    y("div", fw, [
                      y("div", null, U(Q.$t("implant-planner.selectOrAddAPin")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "model"])
              ]),
              _: 1
            })),
            r(a) ? ue("", !0) : (L(), be(r(ke), { key: 2 }, {
              default: _(() => [
                d(r(Ot), null, {
                  default: _(() => [
                    d(ee, null, {
                      default: _(() => [
                        vt(U(Q.$t("implant-planner.sleeve")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(Ot), {
                  class: "gap-2",
                  style: { "justify-content": "end" }
                }, {
                  default: _(() => [
                    r(a) ? ue("", !0) : (L(), be(r(no), {
                      key: 0,
                      state: r(K).state,
                      "onUpdate:state": ie[4] || (ie[4] = ($) => r(K).state = $),
                      disabled: r(K).disabled,
                      "onUpdate:disabled": ie[5] || (ie[5] = ($) => r(K).disabled = $),
                      onChange: G
                    }, {
                      trueLabel: _(() => [
                        y("span", bw, U(Q.$t("implant-planner.showAll")), 1)
                      ]),
                      _: 1
                    }, 8, ["state", "disabled"])),
                    d(r(Ne), {
                      class: "shrink",
                      disabled: !m.value,
                      iconSrc: E.value ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg",
                      isToolbarButton: !0,
                      onClick: ie[6] || (ie[6] = ($) => de(r(Oe)._SLEEVE)),
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })),
            r(a) ? (L(), be(r(ke), {
              key: 4,
              class: "gap-4"
            }, {
              default: _(() => [
                y("span", yw, U(r(O)), 1),
                r(A) ? (L(), H("div", _w, [
                  y("img", {
                    src: r(A),
                    alt: "Sleeve preview",
                    draggable: "false"
                  }, null, 8, ww)
                ])) : ue("", !0)
              ]),
              _: 1
            })) : (L(), be(r(ke), { key: 3 }, {
              default: _(() => [
                d(r(kn), {
                  modelValue: f.value,
                  "onUpdate:modelValue": ie[7] || (ie[7] = ($) => f.value = $),
                  model: z.value,
                  class: "w-full",
                  listStyle: "height: 14vh",
                  onUserChange: P,
                  "data-cy": "sleeve-list"
                }, {
                  empty: _(() => [
                    y("div", vw, [
                      y("div", null, U(Q.$t("implant-planner.selectOrAddAPin")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "model"])
              ]),
              _: 1
            }))
          ]),
          _: 1
        }),
        ue("", !0)
      ], 64);
    };
  }
}), Sw = { class: "text-xl font-medium" }, Ew = { class: "flex mt-2" }, Tw = { key: 0 }, Cw = ["src"], Nw = { class: "text-xl font-medium" }, Lw = { class: "flex mt-2" }, Ow = { key: 0 }, Dw = ["src"], Aw = { class: "text-xl font-medium" }, Rw = { class: "flex mt-2" }, Mw = { key: 0 }, Pw = ["src"], xw = { class: "text-xl font-medium" }, jw = { class: "flex mt-2" }, $w = { key: 0 }, Fw = ["src"], kw = /* @__PURE__ */ Je({
  __name: "IPSecondaryComponents",
  props: {
    object: {},
    objectsPreview: {},
    selectedObject: { type: Boolean },
    isReadOnly: { type: Boolean }
  },
  emits: ["changeObject", "removeObject", "changeVisibility"],
  setup(e, { emit: t }) {
    const n = e, a = tt({
      object: void 0,
      implantLock: !1,
      scanAbutmentVisibility: !1,
      secondaryAbutmentVisibility: !1,
      secondaryScanAbutmentVisibility: !1,
      analogExtrusionVisibility: !1
    }), o = t;
    lt(
      () => n.object,
      (b) => {
        var E, m, I, S;
        b && (a.object = b), a.scanAbutmentVisibility = ((E = b == null ? void 0 : b.scanAbutment) == null ? void 0 : E.visibility) ?? !1, a.secondaryAbutmentVisibility = ((m = b == null ? void 0 : b.secondaryAbutment) == null ? void 0 : m.visibility) ?? !1, a.secondaryScanAbutmentVisibility = ((I = b == null ? void 0 : b.secondaryScanAbutment) == null ? void 0 : I.visibility) ?? !1, a.analogExtrusionVisibility = ((S = b == null ? void 0 : b.analogExtrusion) == null ? void 0 : S.visibility) ?? !1, a.implantLock = (b == null ? void 0 : b.implant.locked) ?? !1;
      },
      { deep: !0, immediate: !0 }
    );
    const l = Ce(() => {
      var b;
      return !((b = a.object) != null && b.implant) || n.isReadOnly ? !1 : !a.implantLock;
    }), s = Ce(() => a.scanAbutmentVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), i = Ce(() => a.secondaryAbutmentVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), u = Ce(() => a.secondaryScanAbutmentVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), c = Ce(() => a.analogExtrusionVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), p = (b) => {
      n.object && o("changeObject", n.object.objectId, b);
    }, h = (b) => {
      n.object && o("removeObject", n.object.objectId, b);
    }, g = (b, E) => {
      n.object && o("changeVisibility", n.object.objectId, b, E);
    };
    return (b, E) => (L(), be(r(ot), { class: "mt-2 gap-2" }, {
      default: _(() => {
        var m, I, S, f, v, w, A, T, O, C, k, M, z, j, K, x, N, G, ce, re;
        return [
          d(r(we), { class: "gap-4 flex-row" }, {
            default: _(() => [
              d(r(Ot), null, {
                default: _(() => [
                  y("span", Sw, U(b.$t("implant-planner.scanAbutment")), 1)
                ]),
                _: 1
              }),
              d(r(Ot), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: _(() => {
                  var Se, se;
                  return [
                    d(r(Ne), {
                      class: "shrink",
                      disabled: !l.value,
                      onClick: E[0] || (E[0] = (Le) => p(r(Oe)._PRIMARY_SCAN_ABUTMENT)),
                      iconSrc: "/icons/new_icons/ik_edit_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"]),
                    e.isReadOnly ? ue("", !0) : (L(), be(r(Ne), {
                      key: 0,
                      class: "shrink",
                      disabled: !((Se = a.object) != null && Se.scanAbutment),
                      onClick: E[1] || (E[1] = (Le) => h(r(Oe)._PRIMARY_SCAN_ABUTMENT)),
                      iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"])),
                    d(r(Ne), {
                      class: "shrink",
                      disabled: !((se = a.object) != null && se.scanAbutment),
                      iconSrc: s.value,
                      onClick: E[2] || (E[2] = (Le) => g(r(Oe)._PRIMARY_SCAN_ABUTMENT, !a.scanAbutmentVisibility)),
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          (m = a.object) != null && m.scanAbutment ? (L(), H(He, { key: 0 }, [
            y("span", Ew, U((S = (I = a.object) == null ? void 0 : I.scanAbutment) == null ? void 0 : S.name), 1),
            (f = n.objectsPreview) != null && f.scanAbutmentPreview ? (L(), H("div", Tw, [
              y("img", {
                src: (v = n.objectsPreview) == null ? void 0 : v.scanAbutmentPreview,
                alt: "Scan abutment preview",
                style: { width: "75px", height: "75px" },
                draggable: "false"
              }, null, 8, Cw)
            ])) : ue("", !0)
          ], 64)) : ue("", !0),
          d(r(we), { class: "gap-4 flex-row mt-2" }, {
            default: _(() => [
              d(r(Ot), null, {
                default: _(() => [
                  y("span", Nw, U(b.$t("implant-planner.secondaryAbutment")), 1)
                ]),
                _: 1
              }),
              d(r(Ot), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: _(() => {
                  var Se, se;
                  return [
                    d(r(Ne), {
                      class: "shrink",
                      disabled: !l.value,
                      onClick: E[3] || (E[3] = (Le) => p(r(Oe)._SECONDARY_ABUTMENT)),
                      iconSrc: "/icons/new_icons/ik_edit_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"]),
                    e.isReadOnly ? ue("", !0) : (L(), be(r(Ne), {
                      key: 0,
                      class: "shrink",
                      disabled: !((Se = a.object) != null && Se.secondaryAbutment),
                      onClick: E[4] || (E[4] = (Le) => h(r(Oe)._SECONDARY_ABUTMENT)),
                      iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"])),
                    d(r(Ne), {
                      class: "shrink",
                      disabled: !((se = a.object) != null && se.secondaryAbutment),
                      iconSrc: i.value,
                      onClick: E[5] || (E[5] = (Le) => g(r(Oe)._SECONDARY_ABUTMENT, !a.secondaryAbutmentVisibility)),
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          (w = a.object) != null && w.secondaryAbutment ? (L(), H(He, { key: 1 }, [
            y("span", Lw, U((T = (A = a.object) == null ? void 0 : A.secondaryAbutment) == null ? void 0 : T.name), 1),
            (O = n.objectsPreview) != null && O.secondaryAbutmentPreview ? (L(), H("div", Ow, [
              y("img", {
                src: (C = n.objectsPreview) == null ? void 0 : C.secondaryAbutmentPreview,
                alt: "Secondary abutment preview",
                style: { width: "75px", height: "75px" },
                draggable: "false"
              }, null, 8, Dw)
            ])) : ue("", !0)
          ], 64)) : ue("", !0),
          d(r(we), { class: "gap-4 flex-row mt-2" }, {
            default: _(() => [
              d(r(Ot), null, {
                default: _(() => [
                  y("span", Aw, U(b.$t("implant-planner.secondaryScanAbutment")), 1)
                ]),
                _: 1
              }),
              d(r(Ot), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: _(() => {
                  var Se, se;
                  return [
                    d(r(Ne), {
                      class: "shrink",
                      disabled: !l.value,
                      onClick: E[6] || (E[6] = (Le) => p(r(Oe)._SECONDARY_SCAN_ABUTMENT)),
                      iconSrc: "/icons/new_icons/ik_edit_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"]),
                    e.isReadOnly ? ue("", !0) : (L(), be(r(Ne), {
                      key: 0,
                      class: "shrink",
                      disabled: !((Se = a.object) != null && Se.secondaryScanAbutment),
                      onClick: E[7] || (E[7] = (Le) => h(r(Oe)._SECONDARY_SCAN_ABUTMENT)),
                      iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"])),
                    d(r(Ne), {
                      class: "shrink",
                      disabled: !((se = a.object) != null && se.secondaryScanAbutment),
                      iconSrc: u.value,
                      onClick: E[8] || (E[8] = (Le) => g(r(Oe)._SECONDARY_SCAN_ABUTMENT, !a.secondaryScanAbutmentVisibility)),
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          (k = a.object) != null && k.secondaryScanAbutment ? (L(), H(He, { key: 2 }, [
            y("span", Rw, U((z = (M = a.object) == null ? void 0 : M.secondaryScanAbutment) == null ? void 0 : z.name), 1),
            (j = n.objectsPreview) != null && j.secondaryScanAbutmentPreview ? (L(), H("div", Mw, [
              y("img", {
                src: (K = n.objectsPreview) == null ? void 0 : K.secondaryScanAbutmentPreview,
                alt: "Secondary scan abutment preview",
                style: { width: "75px", height: "75px" },
                draggable: "false"
              }, null, 8, Pw)
            ])) : ue("", !0)
          ], 64)) : ue("", !0),
          d(r(we), { class: "gap-4 flex-row mt-2" }, {
            default: _(() => [
              d(r(Ot), null, {
                default: _(() => [
                  y("span", xw, U(b.$t("implant-planner.analogExtrusion")), 1)
                ]),
                _: 1
              }),
              d(r(Ot), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: _(() => {
                  var Se;
                  return [
                    d(r(Ne), {
                      class: "shrink",
                      disabled: !l.value,
                      onClick: E[9] || (E[9] = (se) => p(r(Oe)._ANALOG_EXTRUSION)),
                      iconSrc: "/icons/new_icons/ik_edit_28.svg",
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled"]),
                    d(r(Ne), {
                      class: "shrink",
                      disabled: !((Se = a.object) != null && Se.analogExtrusion) || !0,
                      iconSrc: c.value,
                      onClick: E[10] || (E[10] = (se) => g(r(Oe)._ANALOG_EXTRUSION, !a.analogExtrusionVisibility)),
                      isToolbarButton: !0,
                      "icon-src-height": "21px",
                      "icon-src-width": "21px",
                      style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                    }, null, 8, ["disabled", "iconSrc"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }),
          (x = a.object) != null && x.analogExtrusion ? (L(), H(He, { key: 3 }, [
            y("span", jw, U((G = (N = a.object) == null ? void 0 : N.analogExtrusion) == null ? void 0 : G.name), 1),
            (ce = n.objectsPreview) != null && ce.analogExtrusionPreview ? (L(), H("div", $w, [
              y("img", {
                src: (re = n.objectsPreview) == null ? void 0 : re.analogExtrusionPreview,
                alt: "Analog extrusion preview",
                style: { width: "75px", height: "75px" },
                draggable: "false"
              }, null, 8, Fw)
            ])) : ue("", !0)
          ], 64)) : ue("", !0)
        ];
      }),
      _: 1
    }));
  }
}), Vw = { class: "text-xl font-medium" }, Bw = { class: "mt-2" }, Uw = ["src"], Gw = { class: "text-xl font-medium" }, Ww = { class: "flex mt-2" }, zw = { key: 0 }, Hw = ["src"], Yw = { class: "font-medium mr-2" }, Kw = { class: "font-medium ml-2" }, Zw = { class: "text-xl font-medium" }, Xw = { class: "col-span-7 flex flex-col mt-2" }, Jw = { class: "text-12 font-medium" }, qw = {
  class: "text-12 font-medium mt-2",
  style: { "white-space": "nowrap" }
}, Qw = {
  class: "text-12 font-medium mt-2",
  style: { "white-space": "nowrap" }
}, eI = {
  key: 0,
  class: "col-span-5 flex flex-col justify-end"
}, tI = ["src"], nI = {
  key: 0,
  class: "flex flex-col mt-2"
}, aI = {
  class: "text-12 font-medium",
  style: { "white-space": "nowrap" }
}, oI = /* @__PURE__ */ Je({
  __name: "IPPrimaryComponents",
  props: {
    object: {},
    objectsPreview: {},
    selectedObject: { type: Boolean },
    isReadOnly: { type: Boolean }
  },
  emits: ["changeObject", "removeObject", "changeVisibility", "changeLock", "changeAngle", "changeSleeveDistance", "changeSleeveRotationStep", "changeDrillLength"],
  setup(e, { emit: t }) {
    const n = e;
    let a = tt({
      object: void 0,
      implantVisibility: !1,
      implantLock: !1,
      abutmentVisibility: !1,
      sleeveVisibility: !1,
      abutmentRotationZ: 0
    });
    const o = B(0), l = B(0);
    let s = tt({
      value: o,
      minValue: -180,
      maxValue: 180,
      step: 1,
      disabled: !0
    }), i = tt({
      clicked: !1,
      state: !1,
      disabled: !0
    }), u = !1, c = !1;
    lt(
      () => n.object,
      (Y) => {
        var fe, le, Re, q;
        Y && (a.object = Y), a.implantVisibility = (Y == null ? void 0 : Y.implant.visibility) ?? !1, a.abutmentVisibility = ((fe = Y == null ? void 0 : Y.abutment) == null ? void 0 : fe.visibility) ?? !1, a.sleeveVisibility = ((le = Y == null ? void 0 : Y.sleeve) == null ? void 0 : le.visibility) ?? !1, a.implantLock = (Y == null ? void 0 : Y.implant.locked) ?? !1, i.state ? a.abutmentRotationZ = ((Re = Y == null ? void 0 : Y.abutment) == null ? void 0 : Re.rotationZProsthetic) ?? 0 : a.abutmentRotationZ = ((q = Y == null ? void 0 : Y.abutment) == null ? void 0 : q.rotationZ) ?? 0, u = !0, o.value = Math.round(a.abutmentRotationZ);
        const pe = Math.round((Y == null ? void 0 : Y.sleeveRotationStep) ?? 0);
        l.value !== pe && (c = !0, l.value = pe);
      },
      {
        deep: !0,
        immediate: !0
      }
    ), lt(
      i,
      (Y) => {
        var pe, fe, le, Re;
        Y.state ? a.abutmentRotationZ = ((fe = (pe = n.object) == null ? void 0 : pe.abutment) == null ? void 0 : fe.rotationZProsthetic) ?? 0 : a.abutmentRotationZ = ((Re = (le = n.object) == null ? void 0 : le.abutment) == null ? void 0 : Re.rotationZ) ?? 0, u = !0, o.value = Math.round(a.abutmentRotationZ);
      },
      { deep: !0 }
    ), Dt(() => {
      var pe;
      u = !0, o.value = a.abutmentRotationZ;
      const Y = Math.round(((pe = a.object) == null ? void 0 : pe.sleeveRotationStep) ?? 0);
      l.value !== Y && (c = !0, l.value = Y);
    });
    const p = Ce(() => a.implantVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), h = Ce(() => a.implantLock ? "/icons/new_icons/ik_lock_28.svg" : "/icons/new_icons/ik_unLockB_28.svg"), g = Ce(() => a.abutmentVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), b = Ce(() => a.sleeveVisibility ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), E = t;
    let m = tt({
      disabled: !0
    }), I = tt({
      disabled: !0
    }), S = tt({
      disabled: !0
    }), f = tt({
      disabled: !0
    });
    const v = (Y) => {
      n.object && E("changeObject", n.object.objectId, Y);
    }, w = (Y) => {
      n.object && E("removeObject", n.object.objectId, Y);
    }, A = (Y, pe) => {
      n.object && E("changeVisibility", n.object.objectId, Y, pe);
    }, T = (Y, pe) => {
      n.object && (E("changeLock", n.object.objectId, Y, pe), a.implantLock = pe);
    }, O = (Y) => {
      n.object && E("changeAngle", n.object.objectId, Y, i.state);
    }, C = Ce(() => {
      var Y;
      return (Y = a.object) == null ? void 0 : Y.implant.name;
    }), k = Ce(() => {
      var Y, pe;
      return ((pe = (Y = a.object) == null ? void 0 : Y.implant) == null ? void 0 : pe.diameter) + "mm";
    }), M = Ce(() => {
      var Y, pe;
      return ((pe = (Y = a.object) == null ? void 0 : Y.implant) == null ? void 0 : pe.length) + "mm";
    }), z = Ce(() => {
      var Y, pe;
      return (pe = (Y = a.object) == null ? void 0 : Y.abutment) == null ? void 0 : pe.name;
    }), j = Ce(() => {
      var Y, pe;
      return (pe = (Y = a.object) == null ? void 0 : Y.sleeve) == null ? void 0 : pe.name;
    }), K = Ce(() => {
      var Y, pe;
      return "Overall length: " + ((pe = (Y = a.object) == null ? void 0 : Y.overallLength) == null ? void 0 : pe.toFixed(2)) + "mm";
    }), x = Ce(() => {
      var Y;
      return (Y = a.object) == null ? void 0 : Y.drillLength;
    }), N = Ce(() => {
      var Y;
      return (Y = a.object) == null ? void 0 : Y.sleeveDistance;
    }), G = Ce(() => {
      var Y;
      return ((Y = a.object) == null ? void 0 : Y.sleeveRotationMaxStep) ?? 0;
    }), ce = Ce(() => {
      var Y, pe;
      return ((Y = a.object) == null ? void 0 : Y.sleeve) != null && ((pe = a.object) == null ? void 0 : pe.sleeveRotationMaxStep) != null;
    }), re = (Y) => {
      n.object && E("changeDrillLength", n.object.objectId, Y);
    }, Se = (Y) => {
      n.object && E("changeSleeveDistance", n.object.objectId, Y);
    };
    lt(s, () => {
      o.value != null && !u && O(o.value), u = !1;
    }), lt(l, (Y) => {
      Y != null && !c && n.object && E("changeSleeveRotationStep", n.object.objectId, Y), c = !1;
    }), lt(
      () => n.object,
      (Y) => {
        Y ? se() : Le();
      },
      { immediate: !0 }
    );
    function se() {
      var Y, pe, fe, le, Re, q;
      m.disabled = !((Y = a.object) != null && Y.implant), I.disabled = !((pe = a.object) != null && pe.abutment), S.disabled = !((fe = a.object) != null && fe.sleeve), f.disabled = !((le = a.object) != null && le.implant), s.disabled = !((Re = a.object) != null && Re.implant), i.disabled = !((q = a.object) != null && q.abutment);
    }
    function Le() {
      m.disabled = !0, I.disabled = !0, S.disabled = !0, f.disabled = !0, s.disabled = !0, i.disabled = !0;
    }
    return (Y, pe) => (L(), be(r(ot), { class: "mt-2 gap-2" }, {
      default: _(() => {
        var fe, le, Re, q, he, ne;
        return [
          d(r(we), { class: "gap-4 flex-row" }, {
            default: _(() => [
              d(r(Ot), null, {
                default: _(() => [
                  y("span", Vw, U(Y.$t("shared.implant")), 1)
                ]),
                _: 1
              }),
              d(r(Ot), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: _(() => [
                  d(r(Ne), {
                    class: "shrink",
                    disabled: r(m).disabled || e.isReadOnly || r(a).implantLock,
                    onClick: pe[0] || (pe[0] = (te) => v(r(Oe)._IMPLANT)),
                    iconSrc: "/icons/new_icons/ik_edit_28.svg",
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0", "background-color": "#ffffff0f" }
                  }, null, 8, ["disabled"]),
                  e.isReadOnly ? ue("", !0) : (L(), be(r(Ne), {
                    key: 0,
                    class: "shrink",
                    isToolbarButton: !0,
                    disabled: r(m).disabled,
                    onClick: pe[1] || (pe[1] = (te) => w(r(Oe)._IMPLANT)),
                    iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled"])),
                  d(r(Ne), {
                    class: "shrink",
                    disabled: r(m).disabled,
                    iconSrc: p.value,
                    isToolbarButton: !0,
                    onClick: pe[2] || (pe[2] = (te) => A(r(Oe)._IMPLANT, !r(a).implantVisibility)),
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled", "iconSrc"]),
                  e.isReadOnly ? ue("", !0) : (L(), be(r(Ne), {
                    key: 1,
                    class: "shrink",
                    disabled: r(m).disabled,
                    iconSrc: h.value,
                    isToolbarButton: !0,
                    onClick: pe[3] || (pe[3] = (te) => T(r(Oe)._IMPLANT, !r(a).implantLock)),
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled", "iconSrc"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          d(r(we), null, {
            default: _(() => [
              y("span", Bw, U(r(m).disabled ? "" : C.value), 1)
            ]),
            _: 1
          }),
          d(r(we), { class: "mt-2" }, {
            default: _(() => [
              d(r(Ot), { class: "gap-2" }, {
                default: _(() => [
                  y("span", null, U(Y.$t("implant-planner.diameter")) + ":", 1),
                  y("span", null, U(r(m).disabled ? "" : k.value), 1)
                ]),
                _: 1
              }),
              d(r(Ot), { class: "gap-2" }, {
                default: _(() => [
                  y("span", null, U(Y.$t("implant-planner.length")) + ":", 1),
                  y("span", null, U(r(m).disabled ? "" : M.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (fe = n.objectsPreview) != null && fe.implantPreview ? (L(), H("img", {
            key: 0,
            src: (le = n.objectsPreview) == null ? void 0 : le.implantPreview,
            alt: "Implant preview",
            style: { width: "75px", height: "75px" },
            draggable: "false"
          }, null, 8, Uw)) : ue("", !0),
          ue("", !0),
          d(r(ke), { class: "gap-4 mt-2" }, {
            default: _(() => [
              d(r(Ot), null, {
                default: _(() => [
                  y("span", Gw, U(Y.$t("shared.abutment")), 1)
                ]),
                _: 1
              }),
              d(r(Ot), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: _(() => [
                  d(r(Ne), {
                    class: "shrink",
                    disabled: r(m).disabled || e.isReadOnly || r(a).implantLock,
                    onClick: pe[4] || (pe[4] = (te) => v(r(Oe)._ABUTMENT)),
                    iconSrc: "/icons/new_icons/ik_edit_28.svg",
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled"]),
                  e.isReadOnly ? ue("", !0) : (L(), be(r(Ne), {
                    key: 0,
                    class: "shrink",
                    disabled: r(I).disabled,
                    onClick: pe[5] || (pe[5] = (te) => w(r(Oe)._ABUTMENT)),
                    iconSrc: "/icons/new_icons/toolbar_3d/ik_X_28.svg",
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled"])),
                  d(r(Ne), {
                    class: "shrink",
                    disabled: r(I).disabled,
                    iconSrc: g.value,
                    onClick: pe[6] || (pe[6] = (te) => A(r(Oe)._ABUTMENT, !r(a).abutmentVisibility)),
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled", "iconSrc"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (Re = r(a).object) != null && Re.abutment ? (L(), H(He, { key: 2 }, [
            y("span", Ww, U(r(m).disabled ? "" : z.value), 1),
            (q = n.objectsPreview) != null && q.abutmentPreview ? (L(), H("div", zw, [
              y("img", {
                src: (he = n.objectsPreview) == null ? void 0 : he.abutmentPreview,
                alt: "Abutment preview",
                style: { width: "75px", height: "75px" },
                draggable: "false"
              }, null, 8, Hw)
            ])) : ue("", !0)
          ], 64)) : ue("", !0),
          d(r(we), { class: "mt-2" }, {
            default: _(() => [
              d(r(Vi), {
                class: "w-full",
                modelValue: r(o),
                "onUpdate:modelValue": pe[7] || (pe[7] = (te) => Wa(o) ? o.value = te : null),
                min: r(s).minValue,
                max: r(s).maxValue,
                step: r(s).step,
                disabled: r(s).disabled || e.isReadOnly,
                unitLabel: "°",
                scrollable: !0,
                "show-buttons": !0
              }, null, 8, ["modelValue", "min", "max", "step", "disabled"])
            ]),
            _: 1
          }),
          d(r(we), { class: "mt-2" }, {
            default: _(() => [
              d(r(Ot), { class: "justify-start" }, {
                default: _(() => [
                  y("span", null, U(Y.$t("implant-planner.useProstheticAxis")), 1)
                ]),
                _: 1
              }),
              d(r(we), { class: "justify-end" }, {
                default: _(() => [
                  d(r(no), {
                    class: "w-full flex justify-end",
                    state: r(i).state,
                    "onUpdate:state": pe[8] || (pe[8] = (te) => r(i).state = te),
                    disabled: r(i).disabled,
                    "onUpdate:disabled": pe[9] || (pe[9] = (te) => r(i).disabled = te)
                  }, {
                    falseLabel: _(() => [
                      y("span", Yw, U(Y.$t("implant-planner.off")), 1)
                    ]),
                    trueLabel: _(() => [
                      y("span", Kw, U(Y.$t("implant-planner.on")), 1)
                    ]),
                    _: 1
                  }, 8, ["state", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          d(r(we), { class: "mt-4 gap-4" }, {
            default: _(() => [
              d(r(Ot), null, {
                default: _(() => [
                  y("span", Zw, U(Y.$t("implant-planner.sleeve")), 1)
                ]),
                _: 1
              }),
              d(r(Ot), {
                class: "gap-1",
                style: { "justify-content": "right" }
              }, {
                default: _(() => [
                  d(r(Ne), {
                    class: "shrink",
                    disabled: r(m).disabled || e.isReadOnly || r(a).implantLock,
                    onClick: pe[10] || (pe[10] = (te) => v(r(Oe)._SLEEVE)),
                    iconSrc: "/icons/new_icons/ik_edit_28.svg",
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled"]),
                  d(r(Ne), {
                    class: "shrink",
                    disabled: r(S).disabled,
                    iconSrc: b.value,
                    onClick: pe[11] || (pe[11] = (te) => A(r(Oe)._SLEEVE, !r(a).sleeveVisibility)),
                    isToolbarButton: !0,
                    "icon-src-height": "21px",
                    "icon-src-width": "21px",
                    style: { height: "28px !important", width: "28px !important", "border-radius": "8px", padding: "0" }
                  }, null, 8, ["disabled", "iconSrc"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (ne = r(a).object) != null && ne.sleeve && !r(S).disabled ? (L(), H(He, { key: 3 }, [
            d(r(we), { class: "text-12 font-medium flex-col" }, {
              default: _(() => [
                vt(U(j.value), 1)
              ]),
              _: 1
            }),
            d(r(we), { class: "gap-6" }, {
              default: _(() => {
                var te, Ie, Ee;
                return [
                  y("div", Xw, [
                    y("span", Jw, U(K.value), 1),
                    (te = r(a).object.drillLengths) != null && te.length ? (L(), H(He, { key: 0 }, [
                      y("span", qw, U(Y.$t("implant-planner.drillLength")), 1),
                      d(r($n), {
                        "model-value": x.value,
                        disabled: r(S).disabled || e.isReadOnly || r(a).implantLock,
                        "onUpdate:modelValue": re,
                        options: r(a).object.drillLengths,
                        placeholder: "Select Drill Length",
                        class: "mt-2"
                      }, null, 8, ["model-value", "disabled", "options"])
                    ], 64)) : (L(), H(He, { key: 1 }, [
                      y("span", Qw, U(Y.$t("implant-planner.sleeveDistanceHsl")), 1),
                      d(r(mp), {
                        class: "mt-2",
                        inputClass: "w-7/12",
                        "model-value": N.value,
                        disabled: r(S).disabled || e.isReadOnly || r(a).implantLock,
                        "onUpdate:modelValue": Se,
                        max: 100,
                        maxFractionDigits: 2,
                        min: 0,
                        minFractionDigits: 2,
                        showButtons: !0,
                        step: 0.5,
                        label: "",
                        suffix: " mm"
                      }, null, 8, ["model-value", "disabled"])
                    ], 64))
                  ]),
                  (Ie = n.objectsPreview) != null && Ie.sleevePreview ? (L(), H("div", eI, [
                    y("img", {
                      src: (Ee = n.objectsPreview) == null ? void 0 : Ee.sleevePreview,
                      alt: "Sleeve preview",
                      draggable: "false"
                    }, null, 8, tI)
                  ])) : ue("", !0)
                ];
              }),
              _: 1
            }),
            ce.value ? (L(), H("div", nI, [
              y("span", aI, U(Y.$t("implant-planner.sleeveRotationStep")), 1),
              d(r(Vi), {
                class: "w-full mt-2",
                modelValue: r(l),
                "onUpdate:modelValue": pe[12] || (pe[12] = (te) => Wa(l) ? l.value = te : null),
                min: 0,
                max: G.value,
                step: 1,
                disabled: r(S).disabled || e.isReadOnly || r(a).implantLock,
                "show-buttons": !0
              }, null, 8, ["modelValue", "max", "disabled"])
            ])) : ue("", !0)
          ], 64)) : ue("", !0)
        ];
      }),
      _: 1
    }));
  }
});
function lI(e) {
  var a, o;
  (a = document.getElementById("sidebarContainer")) == null || a.classList.add("hidden");
  const t = document.getElementsByClassName("mainMenuTabs"), n = document.getElementsByClassName("show-horizontal-bar");
  t.length > 0 && e !== hn.HORIZONTAL && t[0].classList.add("hidden"), n.length > 0 && e === hn.HORIZONTAL && n[0].classList.add("hidden"), rI(), (o = document.getElementById("wizard-container")) == null || o.classList.add("wizard-hidden-padding");
}
function ud(e) {
  var a, o;
  (a = document.getElementById("sidebarContainer")) == null || a.classList.remove("hidden");
  const t = document.getElementsByClassName("mainMenuTabs"), n = document.getElementsByClassName("show-horizontal-bar");
  t.length > 0 && t[0].classList.remove("hidden"), n.length > 0 && e === hn.HORIZONTAL && n[0].classList.remove("hidden"), uI(), (o = document.getElementById("wizard-container")) == null || o.classList.remove("wizard-hidden-padding");
}
function iI() {
  var e, t;
  (e = document.getElementById("wizardBody")) == null || e.classList.remove("overflow-y-hidden"), (t = document.getElementById("wizardBody")) == null || t.classList.add("overflow-y-auto");
}
function sI() {
  var e, t;
  (e = document.getElementById("wizardBody")) == null || e.classList.remove("overflow-y-auto"), (t = document.getElementById("wizardBody")) == null || t.classList.add("overflow-y-hidden");
}
function rI() {
  const e = document.getElementById("menu-type-combo");
  e == null || e.classList.add("hidden");
}
function uI() {
  const e = document.getElementById("menu-type-combo");
  e == null || e.classList.remove("hidden");
}
function sl() {
  var e;
  (e = document.getElementById("mode5")) == null || e.click();
}
function rl() {
  var e;
  (e = document.getElementById("mode4")) == null || e.click();
}
function _u() {
  var e;
  (e = document.getElementById("mode3")) == null || e.click();
}
function wu() {
  const e = document.getElementById("btn_w_l");
  e && e.classList.remove("btn-clicked");
}
var cI = ArrayBuffer, cn = Uint8Array, qi = Uint16Array, dI = Int16Array, vs = Int32Array, Ks = function(e, t, n) {
  if (cn.prototype.slice) return cn.prototype.slice.call(e, t, n);
  (t == null || t < 0) && (t = 0), (n == null || n > e.length) && (n = e.length);
  var a = new cn(n - t);
  return a.set(e.subarray(t, n)), a;
}, Hl = function(e, t, n, a) {
  if (cn.prototype.fill) return cn.prototype.fill.call(e, t, n, a);
  for ((n == null || n < 0) && (n = 0), (a == null || a > e.length) && (a = e.length); n < a; ++n) e[n] = t;
  return e;
}, pI = function(e, t, n, a) {
  if (cn.prototype.copyWithin) return cn.prototype.copyWithin.call(e, t, n, a);
  for ((n == null || n < 0) && (n = 0), (a == null || a > e.length) && (a = e.length); n < a; ) e[t++] = e[n++];
}, mI = ["invalid zstd data", "window size too large (>2046MB)", "invalid block type", "FSE accuracy too high", "match distance too far back", "unexpected EOF"], fn = function(e, t, n) {
  var a = new Error(t || mI[e]);
  if (a.code = e, Error.captureStackTrace && Error.captureStackTrace(a, fn), !n) throw a;
  return a;
}, cd = function(e, t, n) {
  for (var a = 0, o = 0; a < n; ++a) o |= e[t++] << (a << 3);
  return o;
}, fI = function(e, t) {
  return (e[t] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] << 24) >>> 0;
}, gI = function(e, t) {
  var n = e[0] | e[1] << 8 | e[2] << 16;
  if (n == 3126568 && e[3] == 253) {
    var a = e[4], o = a >> 5 & 1, l = a >> 2 & 1, s = a & 3, i = a >> 6;
    a & 8 && fn(0);
    var u = 6 - o, c = s == 3 ? 4 : s, p = cd(e, u, c);
    u += c;
    var h = i ? 1 << i : o, g = cd(e, u, h) + (i == 1 && 256), b = g;
    if (!o) {
      var E = 1 << 10 + (e[5] >> 3);
      b = E + (E >> 3) * (e[5] & 7);
    }
    b > 2145386496 && fn(1);
    var m = new cn((t == 1 ? g || b : t ? 0 : b) + 12);
    return m[0] = 1, m[4] = 4, m[8] = 8, { b: u + h, y: 0, l: 0, d: p, w: t && t != 1 ? t : m.subarray(12), e: b, o: new vs(m.buffer, 0, 3), u: g, c: l, m: Math.min(131072, b) };
  } else if ((n >> 4 | e[3] << 20) == 25481893) return fI(e, 4) + 8;
  fn(0);
}, vo = function(e) {
  for (var t = 0; 1 << t <= e; ++t) ;
  return t - 1;
}, mi = function(e, t, n) {
  var a = (t << 3) + 4, o = (e[t] & 15) + 5;
  o > n && fn(3);
  for (var l = 1 << o, s = l, i = -1, u = -1, c = -1, p = l, h = new cI(512 + (l << 2)), g = new dI(h, 0, 256), b = new qi(h, 0, 256), E = new qi(h, 512, l), m = 512 + (l << 1), I = new cn(h, m, l), S = new cn(h, m + l); i < 255 && s > 0; ) {
    var f = vo(s + 1), v = a >> 3, w = (1 << f + 1) - 1, A = (e[v] | e[v + 1] << 8 | e[v + 2] << 16) >> (a & 7) & w, T = (1 << f) - 1, O = w - s - 1, C = A & T;
    if (C < O ? (a += f, A = C) : (a += f + 1, A > T && (A -= O)), g[++i] = --A, A == -1 ? (s += A, I[--p] = i) : s -= A, !A) do {
      var k = a >> 3;
      u = (e[k] | e[k + 1] << 8) >> (a & 7) & 3, a += 2, i += u;
    } while (u == 3);
  }
  (i > 255 || s) && fn(0);
  for (var M = 0, z = (l >> 1) + (l >> 3) + 3, j = l - 1, K = 0; K <= i; ++K) {
    var x = g[K];
    if (x < 1) {
      b[K] = -x;
      continue;
    }
    for (c = 0; c < x; ++c) {
      I[M] = K;
      do
        M = M + z & j;
      while (M >= p);
    }
  }
  for (M && fn(0), c = 0; c < l; ++c) {
    var N = b[I[c]]++, G = S[c] = o - vo(N);
    E[c] = (N << G) - l;
  }
  return [a + 7 >> 3, { b: o, s: I, n: S, t: E }];
}, hI = function(e, t) {
  var n = 0, a = -1, o = new cn(292), l = e[t], s = o.subarray(0, 256), i = o.subarray(256, 268), u = new qi(o.buffer, 268);
  if (l < 128) {
    var c = mi(e, t + 1, 6), p = c[0], h = c[1];
    t += l;
    var g = p << 3, b = e[t];
    b || fn(0);
    for (var E = 0, m = 0, I = h.b, S = I, f = (++t << 3) - 8 + vo(b); f -= I, !(f < g); ) {
      var v = f >> 3;
      if (E += (e[v] | e[v + 1] << 8) >> (f & 7) & (1 << I) - 1, s[++a] = h.s[E], f -= S, f < g) break;
      v = f >> 3, m += (e[v] | e[v + 1] << 8) >> (f & 7) & (1 << S) - 1, s[++a] = h.s[m], I = h.n[E], E = h.t[E], S = h.n[m], m = h.t[m];
    }
    ++a > 255 && fn(0);
  } else {
    for (a = l - 127; n < a; n += 2) {
      var w = e[++t];
      s[n] = w >> 4, s[n + 1] = w & 15;
    }
    ++t;
  }
  var A = 0;
  for (n = 0; n < a; ++n) {
    var T = s[n];
    T > 11 && fn(0), A += T && 1 << T - 1;
  }
  var O = vo(A) + 1, C = 1 << O, k = C - A;
  for (k & k - 1 && fn(0), s[a++] = vo(k) + 1, n = 0; n < a; ++n) {
    var T = s[n];
    ++i[s[n] = T && O + 1 - T];
  }
  var M = new cn(C << 1), z = M.subarray(0, C), j = M.subarray(C);
  for (u[O] = 0, n = O; n > 0; --n) {
    var K = u[n];
    Hl(j, n, K, u[n - 1] = K + i[n] * (1 << O - n));
  }
  for (u[0] != C && fn(0), n = 0; n < a; ++n) {
    var x = s[n];
    if (x) {
      var N = u[x];
      Hl(z, n, N, u[x] = N + (1 << O - x));
    }
  }
  return [t, { n: j, b: O, s: z }];
}, bI = mi(new cn([81, 16, 99, 140, 49, 198, 24, 99, 12, 33, 196, 24, 99, 102, 102, 134, 70, 146, 4]), 0, 6)[1], vI = mi(new cn([33, 20, 196, 24, 99, 140, 33, 132, 16, 66, 8, 33, 132, 16, 66, 8, 33, 68, 68, 68, 68, 68, 68, 68, 68, 36, 9]), 0, 6)[1], yI = mi(new cn([32, 132, 16, 66, 102, 70, 68, 68, 68, 68, 36, 73, 2]), 0, 5)[1], gm = function(e, t) {
  for (var n = e.length, a = new vs(n), o = 0; o < n; ++o) a[o] = t, t += 1 << e[o];
  return a;
}, Or = new cn(new vs([0, 0, 0, 0, 16843009, 50528770, 134678020, 202050057, 269422093]).buffer, 0, 36), _I = gm(Or, 0), Dr = new cn(new vs([0, 0, 0, 0, 0, 0, 0, 0, 16843009, 50528770, 117769220, 185207048, 252579084, 16]).buffer, 0, 53), wI = gm(Dr, 3), jl = function(e, t, n) {
  var a = e.length, o = t.length, l = e[a - 1], s = (1 << n.b) - 1, i = -n.b;
  l || fn(0);
  for (var u = 0, c = n.b, p = (a << 3) - 8 + vo(l) - c, h = -1; p > i && h < o; ) {
    var g = p >> 3, b = (e[g] | e[g + 1] << 8 | e[g + 2] << 16) >> (p & 7);
    u = (u << c | b) & s, t[++h] = n.s[u], p -= c = n.n[u];
  }
  (p != i || h + 1 != o) && fn(0);
}, II = function(e, t, n) {
  var a = 6, o = t.length, l = o + 3 >> 2, s = l << 1, i = l + s;
  jl(e.subarray(a, a += e[0] | e[1] << 8), t.subarray(0, l), n), jl(e.subarray(a, a += e[2] | e[3] << 8), t.subarray(l, s), n), jl(e.subarray(a, a += e[4] | e[5] << 8), t.subarray(s, i), n), jl(e.subarray(a), t.subarray(i), n);
}, SI = function(e, t, n) {
  var a, o = t.b, l = e[o], s = l >> 1 & 3;
  t.l = l & 1;
  var i = l >> 3 | e[o + 1] << 5 | e[o + 2] << 13, u = (o += 3) + i;
  if (s == 1) return o >= e.length ? void 0 : (t.b = o + 1, n ? (Hl(n, e[o], t.y, t.y += i), n) : Hl(new cn(i), e[o]));
  if (!(u > e.length)) {
    if (s == 0) return t.b = u, n ? (n.set(e.subarray(o, u), t.y), t.y += i, n) : Ks(e, o, u);
    if (s == 2) {
      var c = e[o], p = c & 3, h = c >> 2 & 3, g = c >> 4, b = 0, E = 0;
      p < 2 ? h & 1 ? g |= e[++o] << 4 | (h & 2 && e[++o] << 12) : g = c >> 3 : (E = h, h < 2 ? (g |= (e[++o] & 63) << 4, b = e[o] >> 6 | e[++o] << 2) : h == 2 ? (g |= e[++o] << 4 | (e[++o] & 3) << 12, b = e[o] >> 2 | e[++o] << 6) : (g |= e[++o] << 4 | (e[++o] & 63) << 12, b = e[o] >> 6 | e[++o] << 2 | e[++o] << 10)), ++o;
      var m = n ? n.subarray(t.y, t.y + t.m) : new cn(t.m), I = m.length - g;
      if (p == 0) m.set(e.subarray(o, o += g), I);
      else if (p == 1) Hl(m, e[o++], I);
      else {
        var S = t.h;
        if (p == 2) {
          var f = hI(e, o);
          b += o - (o = f[0]), t.h = S = f[1];
        } else S || fn(0);
        (E ? II : jl)(e.subarray(o, o += b), m.subarray(I), S);
      }
      var v = e[o++];
      if (v) {
        v == 255 ? v = (e[o++] | e[o++] << 8) + 32512 : v > 127 && (v = v - 128 << 8 | e[o++]);
        var w = e[o++];
        w & 3 && fn(0);
        for (var A = [vI, yI, bI], T = 2; T > -1; --T) {
          var O = w >> (T << 1) + 2 & 3;
          if (O == 1) {
            var C = new cn([0, 0, e[o++]]);
            A[T] = { s: C.subarray(2, 3), n: C.subarray(0, 1), t: new qi(C.buffer, 0, 1), b: 0 };
          } else O == 2 ? (a = mi(e, o, 9 - (T & 1)), o = a[0], A[T] = a[1]) : O == 3 && (t.t || fn(0), A[T] = t.t[T]);
        }
        var k = t.t = A, M = k[0], z = k[1], j = k[2], K = e[u - 1];
        K || fn(0);
        var x = (u << 3) - 8 + vo(K) - j.b, N = x >> 3, G = 0, ce = (e[N] | e[N + 1] << 8) >> (x & 7) & (1 << j.b) - 1;
        N = (x -= z.b) >> 3;
        var re = (e[N] | e[N + 1] << 8) >> (x & 7) & (1 << z.b) - 1;
        N = (x -= M.b) >> 3;
        var Se = (e[N] | e[N + 1] << 8) >> (x & 7) & (1 << M.b) - 1;
        for (++v; --v; ) {
          var se = j.s[ce], Le = j.n[ce], Y = M.s[Se], pe = M.n[Se], fe = z.s[re], le = z.n[re];
          N = (x -= fe) >> 3;
          var Re = 1 << fe, q = Re + ((e[N] | e[N + 1] << 8 | e[N + 2] << 16 | e[N + 3] << 24) >>> (x & 7) & Re - 1);
          N = (x -= Dr[Y]) >> 3;
          var he = wI[Y] + ((e[N] | e[N + 1] << 8 | e[N + 2] << 16) >> (x & 7) & (1 << Dr[Y]) - 1);
          N = (x -= Or[se]) >> 3;
          var ne = _I[se] + ((e[N] | e[N + 1] << 8 | e[N + 2] << 16) >> (x & 7) & (1 << Or[se]) - 1);
          if (N = (x -= Le) >> 3, ce = j.t[ce] + ((e[N] | e[N + 1] << 8) >> (x & 7) & (1 << Le) - 1), N = (x -= pe) >> 3, Se = M.t[Se] + ((e[N] | e[N + 1] << 8) >> (x & 7) & (1 << pe) - 1), N = (x -= le) >> 3, re = z.t[re] + ((e[N] | e[N + 1] << 8) >> (x & 7) & (1 << le) - 1), q > 3) t.o[2] = t.o[1], t.o[1] = t.o[0], t.o[0] = q -= 3;
          else {
            var te = q - (ne != 0);
            te ? (q = te == 3 ? t.o[0] - 1 : t.o[te], te > 1 && (t.o[2] = t.o[1]), t.o[1] = t.o[0], t.o[0] = q) : q = t.o[0];
          }
          for (var T = 0; T < ne; ++T) m[G + T] = m[I + T];
          G += ne, I += ne;
          var Ie = G - q;
          if (Ie < 0) {
            var Ee = -Ie, xe = t.e + Ie;
            Ee > he && (Ee = he);
            for (var T = 0; T < Ee; ++T) m[G + T] = t.w[xe + T];
            G += Ee, he -= Ee, Ie = 0;
          }
          for (var T = 0; T < he; ++T) m[G + T] = m[Ie + T];
          G += he;
        }
        if (G != I) for (; I < m.length; ) m[G++] = m[I++];
        else G = m.length;
        n ? t.y += G : m = Ks(m, 0, G);
      } else if (n) {
        if (t.y += g, I) for (var T = 0; T < g; ++T) m[T] = m[I + T];
      } else I && (m = Ks(m, I));
      return t.b = u, m;
    }
    fn(2);
  }
}, EI = function(e, t) {
  if (e.length == 1) return e[0];
  for (var n = new cn(t), a = 0, o = 0; a < e.length; ++a) {
    var l = e[a];
    n.set(l, o), o += l.length;
  }
  return n;
};
function TI(e, t) {
  for (var n = [], a = +!t, o = 0, l = 0; e.length; ) {
    var s = gI(e, a || t);
    if (typeof s == "object") {
      for (a ? (t = null, s.w.length == s.u && (n.push(t = s.w), l += s.u)) : (n.push(t), s.e = 0); !s.l; ) {
        var i = SI(e, s, t);
        i || fn(5), t ? s.e = s.y : (n.push(i), l += i.length, pI(s.w, 0, i.length), s.w.set(i, s.w.length - i.length));
      }
      o = s.b + s.c * 4;
    } else o = s;
    e = e.subarray(o);
  }
  return EI(n, l);
}
async function CI(e = {}) {
  var t, n = e, a;
  console.log.bind(console);
  var o = console.error.bind(console), l, s = !1, i = ($) => $.startsWith("file://"), u, c, p, h, g = !1;
  function b() {
    var $ = p.buffer;
    n.HEAPU8 = h = new Uint8Array($);
  }
  function E() {
    g = !0, C(ce), qe.c();
  }
  function m($) {
    $ = "Aborted(" + $ + ")", o($), s = !0, $ += ". Build with -sASSERTIONS for more info.";
    var R = new WebAssembly.RuntimeError($);
    throw c == null || c(R), R;
  }
  var I;
  let S = () => "";
  function f($) {
    if ($ == I && l) return new Uint8Array(l);
    throw "both async and sync fetching of the wasm failed";
  }
  async function v($) {
    if (!l) try {
      var R = await a($);
      return new Uint8Array(R);
    } catch {
    }
    return f($);
  }
  async function w($, R) {
    try {
      var D = await v($), V = await WebAssembly.instantiate(D, R);
      return V;
    } catch (Z) {
      o(`failed to asynchronously prepare wasm: ${Z}`), m(Z);
    }
  }
  async function A($, R, D) {
    if (!$ && !i(R)) try {
      var V = fetch(R, { credentials: "same-origin" }), Z = await WebAssembly.instantiateStreaming(V, D);
      return Z;
    } catch (X) {
      o(`wasm streaming compile failed: ${X}`), o("falling back to ArrayBuffer instantiation");
    }
    return w(R, D);
  }
  function T() {
    return { a: Qe };
  }
  async function O() {
    function $(X, Ae) {
      return qe = X.exports, p = qe.b, b(), xe(qe), qe;
    }
    function R(X) {
      return $(X.instance);
    }
    var D = T();
    I ?? (I = S());
    var V = await A(l, I, D), Z = R(V);
    return Z;
  }
  var C = ($) => {
    for (; $.length > 0; ) $.shift()(n);
  }, k = () => 2147483648, M = ($, R) => Math.ceil($ / R) * R, z = ($) => {
    var R = p.buffer.byteLength, D = ($ - R + 65535) / 65536 | 0;
    try {
      return p.grow(D), b(), 1;
    } catch {
    }
  }, j = ($) => {
    var R = h.length;
    $ >>>= 0;
    var D = k();
    if ($ > D) return !1;
    for (var V = 1; V <= 4; V *= 2) {
      var Z = R * (1 + 0.2 / V);
      Z = Math.min(Z, $ + 100663296);
      var X = Math.min(D, M(Math.max($, Z), 65536)), Ae = z(X);
      if (Ae) return !0;
    }
    return !1;
  }, K = typeof TextDecoder < "u" ? new TextDecoder() : void 0, x = ($, R, D, V) => {
    var Z = R + D;
    if (V) return Z;
    for (; $[R] && !(R >= Z); ) ++R;
    return R;
  }, N = ($, R = 0, D, V) => {
    var Z = x($, R, D, V);
    if (Z - R > 16 && $.buffer && K) return K.decode($.subarray(R, Z));
    for (var X = ""; R < Z; ) {
      var Ae = $[R++];
      if (!(Ae & 128)) {
        X += String.fromCharCode(Ae);
        continue;
      }
      var De = $[R++] & 63;
      if ((Ae & 224) == 192) {
        X += String.fromCharCode((Ae & 31) << 6 | De);
        continue;
      }
      var at = $[R++] & 63;
      if ((Ae & 240) == 224 ? Ae = (Ae & 15) << 12 | De << 6 | at : Ae = (Ae & 7) << 18 | De << 12 | at << 6 | $[R++] & 63, Ae < 65536) X += String.fromCharCode(Ae);
      else {
        var Be = Ae - 65536;
        X += String.fromCharCode(55296 | Be >> 10, 56320 | Be & 1023);
      }
    }
    return X;
  }, G = ($, R, D) => $ ? N(h, $, R, D) : "", ce = [];
  n.wasmBinary && (l = n.wasmBinary), n.UTF8ToString = G;
  var re, Se, se, Le, Y, pe, fe, le, Re, q, he, ne, te, Ie, Ee;
  function xe($) {
    n._webidl_free = $.d, n._webidl_malloc = $.e, n._emscripten_bind_VoidPtr___destroy___0 = re = $.f, n._emscripten_bind_zstd_version_0 = Se = $.g, n._emscripten_bind_zstd_malloc_1 = se = $.h, n._emscripten_bind_zstd_free_1 = Le = $.i, n._emscripten_bind_zstd_compress_5 = Y = $.j, n._emscripten_bind_zstd_decompress_4 = pe = $.k, n._emscripten_bind_zstd_getFrameContentSize_2 = fe = $.l, n._emscripten_bind_zstd_findFrameCompressedSize_2 = le = $.m, n._emscripten_bind_zstd_compressBound_1 = Re = $.n, n._emscripten_bind_zstd_isError_1 = q = $.o, n._emscripten_bind_zstd_getErrorName_1 = he = $.p, n._emscripten_bind_zstd_minCLevel_0 = ne = $.q, n._emscripten_bind_zstd_maxCLevel_0 = te = $.r, n._emscripten_bind_zstd_defaultCLevel_0 = Ie = $.s, n._emscripten_bind_zstd___destroy___0 = Ee = $.t;
  }
  var Qe = { a: j };
  function Ke() {
    function $() {
      n.calledRun = !0, !s && (E(), u == null || u(n));
    }
    $();
  }
  var qe;
  qe = await O(), Ke();
  function rt() {
  }
  rt.prototype = Object.create(rt.prototype), rt.prototype.constructor = rt, rt.prototype.__class__ = rt, rt.__cache__ = {}, n.WrapperObject = rt;
  function P($) {
    return ($ || rt).__cache__;
  }
  n.getCache = P;
  function F($, R) {
    var D = P(R), V = D[$];
    return V || (V = Object.create((R || rt).prototype), V.ptr = $, D[$] = V);
  }
  n.wrapPointer = F;
  function me($, R) {
    return F($.ptr, R);
  }
  n.castObject = me, n.NULL = F(0);
  function de($) {
    if (!$.__destroy__) throw "Error: Cannot destroy object. (Did you create it yourself?)";
    $.__destroy__(), delete P($.__class__)[$.ptr];
  }
  n.destroy = de;
  function We($, R) {
    return $.ptr === R.ptr;
  }
  n.compare = We;
  function Q($) {
    return $.ptr;
  }
  n.getPointer = Q;
  function ie($) {
    return $.__class__;
  }
  n.getClass = ie;
  function W() {
    throw "cannot construct a VoidPtr, no constructor in IDL";
  }
  W.prototype = Object.create(rt.prototype), W.prototype.constructor = W, W.prototype.__class__ = W, W.__cache__ = {}, n.VoidPtr = W, W.prototype.__destroy__ = W.prototype.__destroy__ = function() {
    var $ = this.ptr;
    re($);
  };
  function ee() {
    throw "cannot construct a zstd, no constructor in IDL";
  }
  return ee.prototype = Object.create(rt.prototype), ee.prototype.constructor = ee, ee.prototype.__class__ = ee, ee.__cache__ = {}, n.zstd = ee, ee.prototype.version = ee.prototype.version = function() {
    return G(Se());
  }, ee.prototype.malloc = ee.prototype.malloc = function($) {
    return $ && typeof $ == "object" && ($ = $.ptr), se($);
  }, ee.prototype.free = ee.prototype.free = function($) {
    $ && typeof $ == "object" && ($ = $.ptr), Le($);
  }, ee.prototype.compress = ee.prototype.compress = function($, R, D, V, Z) {
    return $ && typeof $ == "object" && ($ = $.ptr), R && typeof R == "object" && (R = R.ptr), D && typeof D == "object" && (D = D.ptr), V && typeof V == "object" && (V = V.ptr), Z && typeof Z == "object" && (Z = Z.ptr), Y($, R, D, V, Z);
  }, ee.prototype.decompress = ee.prototype.decompress = function($, R, D, V) {
    return $ && typeof $ == "object" && ($ = $.ptr), R && typeof R == "object" && (R = R.ptr), D && typeof D == "object" && (D = D.ptr), V && typeof V == "object" && (V = V.ptr), pe($, R, D, V);
  }, ee.prototype.getFrameContentSize = ee.prototype.getFrameContentSize = function($, R) {
    return $ && typeof $ == "object" && ($ = $.ptr), R && typeof R == "object" && (R = R.ptr), fe($, R);
  }, ee.prototype.findFrameCompressedSize = ee.prototype.findFrameCompressedSize = function($, R) {
    return $ && typeof $ == "object" && ($ = $.ptr), R && typeof R == "object" && (R = R.ptr), le($, R);
  }, ee.prototype.compressBound = ee.prototype.compressBound = function($) {
    return $ && typeof $ == "object" && ($ = $.ptr), Re($);
  }, ee.prototype.isError = ee.prototype.isError = function($) {
    return $ && typeof $ == "object" && ($ = $.ptr), q($);
  }, ee.prototype.getErrorName = ee.prototype.getErrorName = function($) {
    return $ && typeof $ == "object" && ($ = $.ptr), G(he($));
  }, ee.prototype.minCLevel = ee.prototype.minCLevel = function() {
    return ne();
  }, ee.prototype.maxCLevel = ee.prototype.maxCLevel = function() {
    return te();
  }, ee.prototype.defaultCLevel = ee.prototype.defaultCLevel = function() {
    return Ie();
  }, ee.prototype.__destroy__ = ee.prototype.__destroy__ = function() {
    var $ = this.ptr;
    Ee($);
  }, g ? t = n : t = new Promise(($, R) => {
    u = $, c = R;
  }), t;
}
var NI = CI, LI = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!#$%&()*+,./:;<=>?@[]^_`{|}~"';
function OI(e) {
  let t = e.length, n = [], a = 0, o = 0, l = -1;
  for (let s = 0; s < t; s++) {
    let i = LI.indexOf(e[s]);
    if (i !== -1) if (l < 0) l = i;
    else {
      l += i * 91, a |= l << o, o += (l & 8191) > 88 ? 13 : 14;
      do
        n.push(a & 255), a >>= 8, o -= 8;
      while (o > 7);
      l = -1;
    }
  }
  return l > -1 && n.push((a | l << o) & 255), new Uint8Array(n);
}
var DI = 'v7#aSXi3XB6yVnyKMN4c9y}4NTtUHvlhIiyubH?,cwrN<b!/_>%C?,WrJ:2#VbTPN5K|Zy/CqS,O].`p|qnZSnxP2}T}/s)lzu/FZb2{k>qj:^|;6W8XmJt[_,O9/8,<qJuCK@f8I3Dd=;PK?]bmp:{pV|ndGKih6>.PUxV)D9I5djQ=v)dQc]xSk1h/lrI5K5IlpK4[^ujw]U?a<}/IK6G((^g<62N9:@%xF;A!s~>*{7.9wV*#B^nR[3gc;m0Lnw:@dUh8+)8TQKdMc.YUIVT%Mdh^OVE=YMv}P&cri%<Qi{zji_F:D2G9$7ktvk5Te1QeJSJjE8=O,35Up8k5vV26E21{Vs+gE$Vsw&@f4jW%x6,<_{H{{+X%me8v>$PV4W.y;QeRg9@AZ.<Ek:QrybTek[5Un.<;qD4}q&K!g_vfohjd2D{:VK,yNel?pP~&@7ZQ=Gx7&Y@|yC1YQQh3u%X#C%?3xfZZwKE;s6MaeF3o>S)1>r?bO`@6kd4iF{cYiszQQnak``^^<2cn6Kvw/jvs*g/0T1Iq#%2&6=Ix0M?6DY9bN{Qr+|j{bHs|C[OZG[0T9]$Dt>f(nmUb+d$%6Yahrqvb89t=(lW>,5Oe0h7M=+~cR68+8=%YrJ}ng71=lm;99,$,n5$GEwMkEIT]$Se$*fKwdv+c>:[lYU65+]|:N4z$~7K,H/n@HP{jF`Ke{N%My3q#q3peR&DW(A.Yk*PJaHMNbgP:R8r0N.X3!YX+@`xzJ@^ie6Q0iVdP,dRHV6a.Ppd;X0rqwk//Sky(RoALnb3hD4in&X@qT1B}`oQf7X(*b=$7*K{6H0+lXYF]U$Rs;bk7DP146H3{,`1bM11$/eIq[3(vEIoZN^YwfV;R|;Vy{N^23o}&u[RoI?bx#7}PJr;2x;$crYKJXACJrkPrG_$a9vU4Px@322hz.%$v?38a7lO9:w18=O".cyyRM*Xl8=1{wHb9T@77.98jXr]VDWwF:U$Dc3eavdeV1o)/(XCYcP6B=/!l=9vx];$=Z@XK#v0K<n|]O)Wl$=^cn|xJ!zGHJ8EU?blAPrQM~EggFfYV^1cm6M{r_+FvMv.r"AX;30.rag*!W5P7xiuf,9wi!a;[{m,ZMDw)!X{7Heu_UWJ=5QodkJ,hSn][*L;4^qNUZJM{R7^qdw[rfr=Ezy62*CDm5GxMX+!e"Zd0,R_rk{h*_r$`c}Lb`]{0v4Qp*^`pl[T$QO<^=]5;Tnr8~$g^Ah+*7+sKy+H:BPy/c^l$MV*lUG<7xHGM3TfrA=W9dm:DsL,/JoB3C6>^2:,0Y~e9/RzQ,$LoS5x<U8(?GITk1Gkhd=NM@P.5Y0&QKkt^"<Tn0^A95<@[_StqW(wf:*!?1Y"g..8CGlP1<|rk=s6#z_e~"Z&KklOv.IhD/x*^*azUZ8ykU%l>ueQ8WIe7)D12Gx>[vqDg0,_t8pMTZ^1NV8@Kc:Ya=OZ8qOweKNL/BvmIi_YY"8l#5a}dv)gD<7h4X6}?.>Fvj.2.x;:#fi]xN|m=y~Z71&C9[`"U5HQmL>>X}Dq3ug6#o9d!zUtYcH?b|QTIOgfVW<5("fMplfczN/SqNnH]G8w}KxJ+vUym&O~PTId()9D1$4thx,/^aac/zwOX#dRE(p[ovIySV.}g!%oUZ6pzYa2d"|S/}k+dtR"pj4LonSi<lF,=aYrH?cF0S$wORnk{|%ZoDdK$@OJ6E;Q>z;iY<@zJ<sVWW$zJ!{Fv;QFqJ@kH5$/u0[X`FlP1^Ph_!80/TNM2.)|wR&!]6@RVzr8@Lpot6vEZO,[)i#FURXgj7{d`Z#>^<V+mW$)Yer/]nLpiz:n0}QA6kkT8.]+]@Dcx.avUcxr5GxPSGWsXPZc9*Rw2or+6yHV60^SG]Zk7R}nlM{l)6Q9.8ghYey3oXw0pVh*f.xMnMTP=CX#9H`EUa,?{feY{Bhb=De&3*wey$!Yg_%k(>7d`z0{w:<{<`q<nUbM>~Zn{erp>Q_OS>.To9>Y(jV;/29$7n0}|}?e:Zg4x;|wCX]~*~|AyW8KFJje[u~O_5hwraoPqK@oJ1L[yp+<7{z{N3:@bL{iuucG9|:;KWpOpAq5j}0Zhps@3xrm`p7:8u]02V@8bLgOT?b/_a!r/45${Q_u~:8!%sU05xKYkah/gY#N(`j?gPpeXR%P78zor{4bpa&s3:!p@1Q:RD?Xl}d]lo}R~#iG4o:UyC7Y#@+>{=Ui]>>XlVe87]^%{_<,?1#*FI>YYDX4L.EG4$IXO_[ILp@v)fr)HetHRS@eWKC{Q*/zl|bm7mj>sEx*(pL_Q8PUg+v;<aMjs;R0sl+aBG45,DF&^%{TJV<HfvYdcyP8BC.DS,Kf&%&Nkts}tEs4X6.Erwe/Ag:E8?8#]l$B/Br7GPSIgG`Mz(eq/f>8,Mh8;`KHxhN!HnrU]A;t=@MZl;4/Ih%b#"(=Yk=)bZ]Lm^2+*g|TIwa_%O6NFFSVOK]Oubg$%xmb&li)mjFf60EUm}q32S=m=MFNg`n0%UlZp"ps62]t6Cx_.]#6?^qBlU,/)INg>sL].=&TlA~v?T}Fvk`o;m=p@mtZf)g1L~q[w7[dY8&)K],3*f]F/_](`;+XN?%F:w]o:D)~^h{8]^]K_Ld2"jtmo0w;aYN<a.<z![7sy5_q&5n5KC++d@g24fLCf(gW$68).fvVfZ8Q)A,EChnY{FTBh$,u,m;u;Ikv^q8*zA|)S_lervQ$)u3(%NJ{657fmc9x#s^.[:e=hOuPdW}_LfE6B^V$,6Gy57<Lz$vedrVEVM/{ww6gVC`"U|gN{)]^pp;GoNT9a%pW(J$f_IZa0C78^E4C79gQpiy{ZC6<^33%vi.[?QK]}`@>m?NW_)/tQEl@%2<.#16p5<lws<r^<^i?NhQ;<zV>,5MQnQhy3*ex)A|P}:I"pCP63+v72w[u9z*VK$/Rnc^m=FLp$.Rx</#_N}VTE"W#%r3ZmLoF%x=Yp:lGjtT9n{qq=q=W3R;mPI2;$cn?{$R|=a1|maH:pW>Zj2iU:"pPSI{HpAlZZ3@sG8^WnCpWs"68wU[i)H_KZragp7a]m`{,EBo=@l!?odq.[(pm8H:)|zv/F6Yb7N&pu0_:`+)T!e$Z6lS|Y"?Q2JC@Fo6v&6Yi(IIw!My2{3tJ.EB%[^p,[7"sJy4"Ha8""/6oXe[5=/$@pkqod_u?pDFWd5=q=cF9,),AH_[@hJ.2=8=q=TUvI||14JK5.N)L?@qmQW.XN"8Ea(7pmn]k>5QmW`GJ?lriW{zoqG[=&s3n3JCk/|ONwKQf2F4*C4S_:(b`fhHa;RnR<C@Gor8K3R##,MqN5Zal!|`rHG<qoXYR&Jp#va<7`Pb`GE>O%^$y^rrr^UsV3>c<^?PA)I5s>^oi/<Q@ui8E@$bDc~%<`q)KlDh1@uwb/NyhF3EXB6t|f7eClFLmI3X9!W5rUqXra;$(CN)b=MgyYxmr}br;{HTa^2$QO`abCY0hqB4@>j>(o7D;/`Kq%1P]e0hxKaOf4+l6#9!s^Fqs65lOX6P62el2T!,mr4QXQMds6=#n)J>@kMTm>YmpFs/Nan?TiqpW.b8x5cbU|VTY|wH$RM+1KBZk7r^,Q<fun(q=)T$OU7H.5#<];l[y}[rMMQ6V:[#`>jmj}2>{8Fha.Ppi{JNC_oy1TRW]4[UBFMIC@~q&y2|JVPVfBPRpAf*BBDEsQ6&d~qI]>ytTC{IMk^3>JuI^>1tfCrJWmg$A^q_:(VBAFEu1)oBJGpZfDGh)$>h!t(CNLDv`R6}`9@(yB*CIF$UVB:VA<|>pt]BxHgoS:?2r_=(iB4FTL&Ov^:&rI_h&tCD!IyOVNH"N%)1MB;adSMR8Ftg}I*kQ)ZZ?#UU+ks"$bqaq1,uJH~1!kp"_fJ=*,qX)*3P_gASJ./hEG1#ooj/cuzSTPq1vukG~19kl"Ijkwh=vXG>hBVH0CdX+XJJHi;?JBoa{m*D8_JYdPRH=iey?#3N{Z`$"1aRufTNRam:amB[c@!C.1qdhu~>yr.[M@5d4dCM;L)Wy&3wB+v=|fRu0nC$V&v{]Kv.~NHaR0l^5rMz;VpD^Z|l=Mf#*P<0{,JuXw!!mB*Frf`#%P{M$P1*5xwPdq`EV@zjo;>k9Rm#Q1$f{2YX`F|w!I`w?TC2$f#L&Pt?`hFD)X,u_qt)tC+$?StDCCV/%To;4V53P5umHNDM0qrEd0jdg>$Lam}kESqkjG<eO%qi|4#L(j!*V+cUgn%j.f}0w3wc_v4XSh]T/Z)kJ6"Ou&J~h0Kf96^]S~Ae/"C7%7+8>)l,a.jfMRE?*7=^02B8?b<ZO,udh_>7Cv_HCV>{WpOE24KH;6|,;#x<gEW8g`p;FKrmtn`Sh:1J38xiYV"%QO!8+#<]^68?lw`I(oq;Mgz}8@J/MeN53$<`E@V@wQ9qfhXZ5_v!?k5l=*ESqkX:9o1PLqq=r6$omX,TszM.eXmZ&ZiQCN9acRuLy9]OKhl6ITn0qwzoXU?!~dnc%;]P#hch8zu&>M>d2Wu!Io8Wu!ff54b[jj8=0JElp;@x*d0bjl3cx7E6|(4%)wV3]5n<tKz,a(+{wE%)RTnOsz{<mz,&WURPV;",xH*c_VG$eWts$|^<L9.qb`<{I=|x#eK#)?<b6lUlIkablmCW.|m!t2C)/G0Vcwj`syI2ge6psfB679x<K.>b9gZYio50`VF]*BVk(wab)D1dh2{%L2].,5=&=4k;<gYUjYvv.n:n~@&UZ0wH.5p{F6ty%{2.n(*1YVuVvyNDT]+b14A19hj%P7|YJFk@8R2Ie5QPGD`gq!BPh8:@RsS+ej8XE*O8LpKWx_uz@H=86n`k!6[(^d6%2c%PheDMVTRT[^VK?0<7,5,ZQzf%U0QfldO5qO7dM$CVzOHxgG6g%Pi;N.Pyd;9.Av|o2</JC;8FD4Dx9]8a@C[c*M=1]y2iB[rNnEVDx3hetInSZ<x4NyZ3HF8:dkWnU)e[LW=|tyGYiG_a?y%R:d5/qN]DJe^g[6,E,TAUwU{2"oyYvwz%]8|cdH1c/[fPOQX.dU}lg:].N.*gnkm;8Ln$=l0eDaXD1@(632;5y41aMyozDNksyV#*XD+)hL10IU/;|LLRmx)<^.[7)*Ja_lh_]5n)rqOd^e|FVXCljkBc0q]h;&{)cmkdLy#v^GCc,6/;Hb>OXE)Pmc8Y|8?SE8J$w]G!/z7{d,Y<Jo[zqe,u5zpP1QQlq0nqF!u+Av"v*5bZHwG!~gN}:eb>.+:jMavO}/dz=fH8G:MWS1;8<f3BCN=_npO5PnEMQP#*TfNW5by{V+zUNJ=iymMTg<9aAuqH9wZ#*fyGC8nBI2&l3_?5Y0jQ]I1@n:8du.;qgr{R8?}kxz}b%r9erXxp#Fji5*AzC("74=b7MB|K+O;lal@XuCjGi*ds"q+F{E/}6%<)O<6gR+lTzrDe!F{Eb&gI:?&r%Q3*q|nhRx^_?&gI$~`fHd.dp2FYz}A]a{vG{z(S]S"C*T(!L`(]$PheY,pv95/j;O|dHU*T5bY,L94{O8R|PbvOGN3{o2O^{ShNud<6bZ@]R53c.d6LvyiSCp~juvcDqXpPlN0Z%Zb,<S3h}anfn9mj3NURPe%YB8LN1:u1@LGGhZv`g{eQv_sMNR)L7L9LBw&+lN"Hoi$GERy19Fe:}kMI"X)6dMgG$G81J*.07[~I`+11XjlNQSgw;a2i$Glq@)$s^_#G^yo7bLv#bLEU>O;[lB*N27eQH=`{28F#S>hwQ`/L<IBw#aE~i!bQiGVGct?/CSn`{.u2f1u)Nb>rlzT+.M`cy{:qVhymn{`3QvFI4aE4T5R*9*?7AH&Z]]bO5DM?pE%xv7.G$88Qn#&+,Zm0^6OF35GQP}F,wL<avn+C?$)@ek$QS%!_Y?64=rB~m:|wmQl&X6fyJaYec1pe,Sj2,=0S&%o]npO5PnQ7?c3N1v~1X)#UGGcY%_:Q4{v`;);6*:SZ:q2lJ$+95#g1va=a2iaw%,#)"j]8<6Jb@7{0a{TR.s=):6*PBmPtB?S+Y~3B!97Oi~BTuDIpilm459Z$zJl[64m}?]:;092?U|k>zrX_IrL<L@+&U>(@DNJ4|0%ZCj9Py`iltEadf3eYFS@e(VrXX98r%*oJaObZ[yeQblYg~.f3L9|w$i0un/W)1TtO~JKq<"B{a13j#:[GW*I6{ZjNv2YW;W.|sen67mux>[K=$/]TbRVU||DGPlsS{?)Z:F(%n1R1,a7I9|TJQF]8#>oJR:Lhb(o]nxtUC>K~U:tdbY%_n9OE~b.dCX}]wHQ>vO2z<{4S9ef!iUI=L2q;WjE81=;0/)P[0!,1WZ0e7C@yja<`>+@?K)q#!"l;IsWCPA/aMg7ATn`I@S]C&f(@2EVX]C4Lqu/FK)HDHIh(x;*K9QH@>|<SYpmy0e%@L:(rMq+274qHZKedt~3>5e`1a#V.4f9T<r&KA[i`x0*rqYoPTkaPQ[;/]eOyyl@&f28:pV{al+A(E$6eL/+.fV}}Jf^U,Yf%*HciMB}T7(?L*6t]^{2aCJYNS]7=XaaVW6#q^|U>Vq]_~H;/B+/I"Hn;Wj04Zd+lg7M)],hCM?lxhe>T0pI+Fb#%0ofd0ps6|d3L{yja7}6a+5jr>z7*0vZ|wzD/UlHL;E/n+CZ&6uM>sBwAF4$`@A|1#K1OaV/kp&Cvbw$ax&)T[vri>maFsk//5k.IOCJlr,SJ!{D&`=%z$yri>m"*>]Kxu,*!lkR6<>Wo09eZlQIURSvSO}>+5)=wl7Qj>:[Km7~&(^2:i7LN78/fB8v7NQh@D6@:aH+scoWQ]|LJ2NjW#/U8rX!9yPd1.lKf;%lP!,yxca!,q~6{TpgOxsFP14~7GrX8L`~8nZ2$eFckF1`bxn,@1kJ$gtp#70va91R*ZxTxu,4/kN(EGgu=,sZ&qmG4:qMM*:9+WU/kRrvEKFUDQ|S1n5w48V6zTA4_L?Xl<(+^%{]O=$;<i5]w&S%bs]jab(6frJxLxMnKo}PrV{[{f{|$~vvyx|mxn=:H/kOf_O7%2p&//*uoK]cO0Yh/p=M0Cah0*#R,(A?UD7"b^S<lBWE|_8F}5[74&KzTc#J#F{oy79b.E_$qZagf?|2=GPXC~&~+SZj8F8"bt)N{rUdUc[k>6Q1DW:Qm){o^e(9]`=t[,S&U^fWVf3ra.lsR={+p~!>*)l~_b/e,8od|rm2kH]q&3WY6T@B;D]c(<6Z^.+d^d6"7Y5GPkji[[!2zI#>^=yl/!ZD)!Qk4f:m5j]J[yrrEBopu2.dU)Z>MXymU/Nc?dkY9$bHV3C|UD&Y0{zxgld}:5on[eIOdx5K|b51/0h>CTk"?(g~8d.q3XUv)m_1Y`&ZUbU;<KQ^`UO3X;J,<i<l/c6?S7a`0_aPa8|!|_8j%&3%0QqQr*g[#=;{<_la+nyuJyf:<MP34$}f9C:k>`q[06;HpC>F@o]<K,^Odva<["0/=E4BOBR4|pfrYIqH`^0vQ]}grj>Ot&sXOO]o57/w7x;.xq$K$@^ek:XK?)le9@#1u!~:8,<>xon)lV.Od`=mS36L%a%^gp+1<5/PeGY7)}=|me=y`)bikA/cM.[uRZ^Qu5Yz/4SSraoep6O6$7!H)J"9r2aM,?fi4ChuBv5|Ov#LTJki^+:7ilC$?7ZtYH@r^8{0!7mX>}|s3`=ulXmTVyG`}NYAV65ou&swTM4~+Ds*.GQl3(&^ob.Y]$`Z"F_p,:?znotpuqDd=xwmw2oS?]n?o|U^ChxFk8cjSm/pVmq%?G}N%OU+4Sx1J|TRJd1#p[`IJgEJbN82=zUL/uo^Ul*OPRnhyLD&J6#PCh8wM%p8xN%,pwFakjo.P652]<9O/m[OUbl#oHKE/ku5<0+NuQ<kuw3Uebz1|,9yKuYre#~G}NnbQC>Y%sF^l`Uz^Y7Ey<<1s;#zxM6).1K0$oeDihx7[;&,lK)zXmSCy[70M]/Q()q3{gW]v7[&tpYok50T#Cxc.bnxkr<)K;hcE149[^pSQ&6/V7D]XvY6[]7a3aBy48=WV,(KCIaUEE!b/)="mquv8<`HbcH<kVhr}dpNJ,XNzw36}c;>m?Nj[vAQJd1Wk:bxcP,G92l!X%`+L,.{YU.xfY8aPZ`e%kJh).*Lnhcu21@HLgu|o#oPa~%M0(49V@uGkXM%K5gK__y=>H8L_A|C+w,a(%*T4,6JLV$a8e<;)?[3o6Mw|hv13a3&x1OvR.[t;gpr%oXmxe1LNOSV=8lPb$#:)YqMMd[9NRXzU*P^{{%d6UyZ+h04Osmj8nV6@rUY5vfac*P_{3eUZwfP#[n}P@.hcuOGN&b)b*YO5%o.VZ[?%@.<`&sC`#,3T!;3#}w,<Xg,U#vDG}By4tOS:U!Ka+Pa$B5#+#l"XvYdcmgqIXJ%_xcZ>6/KWmQgKB$@`L?7m4`VlJ@y5qpqVi4{=zwAkIO~U`N=Iv}Fv0ec]!pa0LuC"i~o,0kZK=TG4`z}pPHmz6.}>JQ!#H*"(r}%%H,(b&^@8h>"r=.O@{4lU.=ObV2%Zq5LUfbS(ER>+zq735;y/bI$Hdlad2YQ[v||9v=`o1lA_j~`UX++`%v>IXFvfGq{Y;I^P3SM6^?O3fduTQVx(uGfB_Gou[((u45oPdOzjuT|}Dg?+CJ{QX]Nm6[+|r3[B1UzoUR=$2n5>M6Q)i6@bf>76_ejkEhMe/IH8uuDe:&BPb5BPH%BPB%)DJ#b]Iz*!Bg4HC4Ds5_A8wb!TEj+K1/"zDJ(22y@+"db0K4Y1V+iY7#jy{=QA!rm^qU,SaKDBh*zlI}r}|bs3!2|BeW+sXAG9fCcrc3#N>K!C16IT9:kV7;+tnLF=_,k5EBb?X`uOCh>)t@FvJ{>Km]6v[1i<?IBo,E<XcxB7g&[d8R)[|i[i]2Nb16=qF/vIHSM+e;=6)gH7e9x?7]2Ciri(99]r%2$6&F7*g}Bl55QOLtqD4n8ZIV,>&);v9X$>|4>p1|9>&BYSQq3(sj?90t0yOk`6>Lh=v:CB4@QO`6D2w8uTr?Y3<aDcwkU$v[GoY*f&|0ZhX13#N1U;x`WZ(w?KZV2|"^D3}yLA56fN)*&YMcGv8RC2=NpN=^cOdk.]!+GC}W]V_A5}ln5qxt<H?NnvZw<KO^FIVwHJ~ZFXEVo1nxf6kZ+VE},%)Gj]C~Jxa>/rUSM<I?U}>]SDMXi9nT2,!v~jm6y9YO$qPrALHsDTnE@>l!s{%38H{Uw2.Bw1TpZhb//&Gd2x&;pxhyB]Edu.v.r|0c,bL8=Oah~&@p#p1`>^]2rst3Y@`6{`s3Q@AWA,#m1.09XKn0.ykCx@{@rk^i{nc5wo)!Q.R4@xd7(52?p%),gvK+5M],*b/^<1Z@0$0e^"_{*84c>{6U7{mE_=VEpuYNK]V1$sIT"pieQ#T*W..N`zXrYQ0!Gk{_Elk^Sx_/x24v!CVC.et{K2[h^n+*9f3KG]K2`"!Kk1jLW!^4TSP!E:.i_yh`#Ws3d~DV?Nxs+1?E,>vsCBh*1lXr[<{%>ZVs>g()}]V*)t"M?Tf>]`fN6<9(,Yi;k1]./XOk=+m<k7d3R+N,Gd#LAP<!ZG)x%xb0"Uzjqu%9QUy<Wt&lQUx<Wt~YBj:X<!k!]6HP,$TWahBRvq/c~@S:J4cm8&Oz6,^b6,uaZmoN!,wHUsIWVKS%Jt@be1)as%@il0.B,8As3i$,Bnwzm]S[!Cw?q86NZ^gfZx"UT`os_=mjH%IUA&6{l.39=)8)E*5v6K=iUw?7[8.h9n=>=:aCz!ain/{wcUi]$R_7Z?$2/`QPobME]gq1=D}#K]u|(;.b>txj$pXQQ[#t0xa8nXR_l~|FHG:bs3).5cCAJPX$NTf_F}6K`QXgN+W*.2qD6p:h[;A#k[_UbrTC"pJd6A+3:,FjNDzvZfu)@.8BZ3eN7}n#"jc~M+rIFLJK$^iDs1`rc#+pk.}Yp.B7}ZLg3@(RHSw>ddU%5"=d{u4<K_3fXnI]2|c;P5L^M`Y<9`psctxg]o1c5GVn6Q55}5dr#oY4XN1vPruMbd~]Pb9Sa^$K<7yPRGAJKlVh!y7{^4HyZVeU4(Vr|>7l:N0k0<P[{4[6N(nT9nf?%l2/o#L5)1.SwQPqGzvrlZ[E]l7mNYq3U6rYmF1i3UT+>@^[9<29En^X)/(X%7_U^ibt<?XlUB(b1?XlgUU@,y8QiS;D;P_cS31/.zY0[zv#CNX2[5tlM6KWT$h+1712_]^SBpaYa5|(P_Ivq2t0f]s&}M&ZZ7sNnQj;viCdBrNxg2j&$UZQaXl,B7o,(d3h^y/IIq.+SP3G(]<stS3U~O=6H[S+4{H539p}|j1qwVhsHdcOfQrZfR*k$q5L+:K0ou<CnC1dHCZYedB8omVXCd54]4aOVcu844%0QDxQH6e&:8bX4wHUnO]C5OVX_8TO@v!F>E+mQj:7xj}7jf%uV5VT_ZzP81R*WKjlka<mvhR`<^QGMTn/+vCF&N@Of)R@jXBF%y6o}J{ZFqe0`w?Rm[86;5$Z7LzLxQI0(VhO[KMb3ZVcouC2%RG9pO_Lj{=B9^a/drLK6Y~pMp.|o8(!P8L}oEWl4:cKi=`2]7a>%$>TFe^gM^r}4oEKxmFLqsah/rkd#x=@gC9f/FVX]C&N,TGZ)@@tT_il}ys5gj+%:gJ6.lzI%v_L$9Ye|<"7u8]kMoSIiNkq&%gK`7MTq<vk6|GeOd5@~U;I,+kGQcE6&{pzmQv_C{?q<{,Fvrg<^.28w%tLqu^_+V{/xvJ&#yGHqd7M5+hYeX7,pD!MbJYD.TLpSGB$^C.KT,`Z.fL[ym7:6`fx`0g0G:pzDd,*v.r,(dB844)$F0{WB;"0C2h*c:O]G1)Ddq~P@)z$4yjR9g2:x$Ki)@k|nhRx^_?&gIMb8c<ti@&Z"q]CCNvOYbsOKVDT&Zq4g0]W8ku`aLEdVrN6V:QNIyy%%ZK=Z7J6{S/63|7qY,*/LH2&]+w.}Vw>`V?gM6KWW<^hX[Tm;@Y<GNB~M.ced.rmCe/F^tG:^7m>2alQh3X{t`%owPy!0tyvpIQVa3sLY1%Z]^h@_#fj[)qr=nHLYhpu))hW[.A6hFhxlR7*wINiyuPG!Y$I;iZxGRa)HDfMhxlRYer4T^9={4WpBw0iYdprPBIFeDifa!nfzZBZ}Y0cFKqjwGlZT.Na_l:V7BcVH36MI[R54jA3iYWV8gb!p7(i[i]l^v.E$y[y`JHgbvi(h2bI=hGH+Jp8x=H:`knE?1v!BR|+VH^C,TEW!%HlEO$b[IpOJ0)OozHNC~fH49n]2:>&$Y1`3Zo*#oxLCm,Ls5}4#>/gwpATS7s1&~NHcF/i,3j"L#:db8$xS7QN@&XaqN9^Fd#*.z1buOb25RTa&dS2|ZKBNic.ims@6WgT#b9UsU#YDSuSHE8NG,fZ8^^LyZP`gj#7XXAG+kaiDPv0:06xo,U6v+UlLa=4:IzC]2T7biFa8FMaoTyvizqZ~Piu$M64SEsi:k3Hq7#OCdvHU!D6;CH6&2w5ZYWB6oyiMB<y#XhzGH3uAMZhNM_,Pzk)bXO5FZuOXKY^J5sOuVT{N/|c>8P!:Xt)9R1c%uiiqB1N?t/JIzz)DXTPA<5Bz&G%Yn796KmUblX3:XMrU)b6O#svP584&+U}Qv|!g`l?=.Rugjx?+5G640zy``R5pO]IO0X34D]2TO8t6wi@VgYoQaI!O,BlHh{mj2q7Dl(x|fW+$Y>gE~h8sS/6CJF6yofhoG+5ozA;{dV84uN!fxL3C21vAKNH.5mwq@&gbwD.BR@eHq4h|YR,N<DigMvSB8B;Z9;OCLHU1/$Y)q9LEUR]$xI$5#FNUGnJc@#vY0f[):zcb7.z8^mGM3XXS|83=&>XLlAOmd0N)72S;+dUtOozqzS{8R>6rV?!^P/(ucwn;N>FuI]gbtii8BU($v<klPV9Q!!o4HBi;{aSCL4CWl2e2i$G@J8{u1@jlNbR$BY&eGjsR~,$A*Oum&rvoQ($wk);o;MzL+O4e<2ghk[+R*Pvs%UE[hS:a?jx:}pPrsOxf|1J@M=QP5rL;V3x+9"cDlhKZ&sUZ&t~A(Khi6uVc>tq~jRr}f>i$Gfcf?A~Rg<Efm(FSNA/zQmEh<M(,L67`iUWn<9d9&{of&oS)|DmQN?QkI8fa9]38jfr3qt*6()@bMr2=>EB{nO(6:n0k1a:8laj[&o3dNE=P4CxYtv>HT;.Z]=pw%UE[hIu|`CKK[(@8{I5GI5._mS.W}e8|,X*H(+O`Owhe}v]AI8vj8=R:/dr]`cQy^5bZ>A#Fuy5Kp$=zC$pY^R1<60/4^vped]+mc(M(qi4}1q~!;*^>mr&W{np8o,&k|*`vYr}~=p_OuZ:j<53Z;*^>mZI^ep2LgK,Q4FIcW^.:$sV8&Wy=^<Mp{Oe0b/GTe0b/GTe0b:z%ZKY}dK;fp%XeRW)vOR,rUszjQsb%dKe{/gQcmK>bKg*KlN&c=b.EcS/j%5>3~Ldj3J]Xagca^bVLn{dHKaIm6bCASM?LoK4pER_px]xLdjewX>^B;30q8<mf7$RmT0NZxmR)mO.32oDIS4/;)jyo%~5DiDdkQnG=Sd)C]FeKf>gDJ~MP.KXb3DdK!Bknb|<Ac*Vz}~UN:+m&xdi9,JX=[[_Fkfq+dc]MfTWRkoUy^QxG`r/W#>^I[X`#LC<vJdyDhspw3b"rpHS]U4_BFKK]^bHw~S@(K1)$idb+PQu(|%/KtXYK^/.aRvU4,R[GH:`k<Ok@Zs[E;+MYJjdR37or~zNz2|q[VgFrdn+sVZ[Zgf%N(X+0e7}A]:r$rMMpg49#7:6pPg!jJ4bvcpJ<?Xll9skB/?wx;!)wJO<%m>1Kj:FXaP+ixMw+cT@|O2=n^M,?|^MoVxe78QD2xs3.<PEk:ro^kW.^qdjo}9V>f3ht{(dC.Tos{x5P]6j!0]x+cWQ8SMa_4M3XmkXcJg9EayDp=6t8xcKsmh(BbilhlJ|7(0vkX<$F?X}[xm0D#mN?Vn0o0TB+$bch?~;Uu5kq8|5Qe%^$pm~hJgHHdp}xE^CfK7`z_$/O3B%6?9)AH_BUsS_9}s}h~[{SV4nY*e[044QeUj2>@Fi)[AXg?90xnj.RQ`QckO~!qX77?FDDc5eKz9eXG_[pV}yy#<R%vTP;I}a9`7n9+PL$CPG^F`*=xsi}Uj82GiIxkU`TJan=NvAf1FC%VZ_5Wv&6((!JVfBrd^6yzgOQ[nR3K+U|;:^,>pR:YnXES,>O3|86"~i!j;$P7CBrcnoF>0ESuB+%:_sS")%0wQ_W(Z+]4y[C%zUz(A~z2$qZ7i(@7!Sf4Z8N`sHPdy+>w#ntb4L[8*7AGZ25w8MC"tB<ovv,:moK85Dm_paOPBcD{s]zYiY8+E:aggHH7m<Q0M>{8C"<*JoCpLr}qZVHAk8Tm^[i{$27W*yOr"O1e8j:bm_}Tk_BPhMUpZ^nxHzknS5`As859+>U59,Pd{nVhugh6Fl4q?[vTE5@`P5JV$OZxjHNZQGZxJ`vly/X"{N6Ro]9?T^XC3h/3:>9?7(ef(yZeM<@["M"Su`5.25Yg50llJ/+`jX}X}GOcb8N[<SYWyW+*/@jn"T1/Mc|<I7|A^L#A5a%p$r;;h=Y9"60%4/B+cPY]S^4,a(_*nYZE*xbzeN%oaX!;TVHnhcOAvbH7m:.)ibHq$>rNOws:R/+HRzk@4;Nyq%cP5P_oldUM]7;!NJ[,ZF/9Ms"l5*cPGI>*wHe57GF}9Sc.cm[V~E|%lH8d";gt%bhJGWV$s+^"8S[dH`Opi]7+c%c7[Y1;vW@HX6<Ee2RgU&7d1+9{b7Nk6DF&25,Y=@*`uW{NTVl:W{4<{a1({YwDy27+q@1q0/J<OW~Z]`"2:Vg{S6ax8+Q`LR_S]CFmHLpFrCFj?m)UZp?tYZmNPwHme.@?C2N|0c.=4d>!p~L2=|0cSr{:YDmY_UEa(bRr]Y6HNk2$|lPwR$#d{n{Ifwua,3(O`aZKI<8gN0wq3p`7Coaf;8|1<m/^2Kf&E5V%lqwG!%LgMpM%]^9]Qm?ld+"*MjG1Bkn.JsXp+tC7(^9]>:cR7V^I/3v#y"(aMBLCw&7&m;^2uA)~4KC@1P5=a3(oMM`O^{e[r7xSx;q5&U#4>=7%wYgT[b79p#x,n_pbliy<LQ]oO_*la8|*$4h>`Uup,$w="96t|%cvR2?*?CG4HNu2IhB"D=k=2+_EfWb;hO8Y.V7d%^wcyG3)~MfxXOPv}Z=F+H(IG4=;OEvwm}7QYaHrBvw[JYX0_{y*uwx,i6?k;hr3br&,6Y"|yBvsDJb?S)hDR0=psCL.|>sGiRz"`U5}{qr3[/scsnAl:pa#P4Vnf1J8`$5>s}l~NkY1a#>^;Id8MwT[TaV9*VUsZ3+*5cXK5PB[A&gyH5$VqYM#{^Lz#Ky{M<4C"=:$x(h4!6lJg2u^@pZaE5]#C3IvQ=>85DL[4%uU`n7YurUp7/a5,^rm/Tm<Ap`+SoJ|6h3wL=RUS/DWz}Prn>bnMTew~<+ObAxmxWM7@ALt+h5FlBt[QJ}__5X3=TGieOyo.&^p/bfk{^z(oAL[pt@&bC7m/&l7t*f?%Uhro)YYZJ(*`FCZS:V.x?i5~B53~9[NmHKy_epG&<Nag[PtrMzXK^WOg^%YvGE)?m47.bcHqhn(3UI#Fd).]k&oXK?=yQaAtp>Oz6j70fF%x;DzXbB&LrqUukcDE?p?YhAdGiM:~i%&_;mH&1E{F~FPiRKlo^Q?j=#}5$_Cd5KWMfx(,=Od6Z6@Tp:m)3kD%eX7#ccp(SAxx@)HKW]e+9buXuixS.I?w<jg&a8VUs?;VFFL?9Cfx`TUmSb<7n(_hw?{2xLHh]F00K?V,J+lS?.7.DwqW1CPtX6P#{35"I6Z"RHB,_v_awbp.+(2rwk*8])o~0!HD4!]FID%V>mHo(:f">P:/jv%,cy]+h@^4]ERe=awbp{>B>,.:sNeEjXcx&R,dr{5dD7Y%.cU>^cU;.*I~:0v`GRa+Z;dT_B?FcK2TSo@gbil^OQ,HN(3Ac=4Meclg&??:8b`Z7]RdmB7HFA1SMMDyV8vqgrU,5vYTm<e[oOH!Zv=HOndD;X0"&;HMkz/1mn#"%s`[9iykp5py(con6BUrP,`?mL{9v948/~Aop}/J8"7FrRg&M9rA>8);]Z7C9%lAV5HPm:TgyB:~^uy9SrkvKvvgv]4H^jB4+iONH1w*ltarZkK*W2JM/xc@7c7)YRhy2|q(r{6oU58iAyr.kY%G37t?d(=w`)dQh!YawR$[{s#>^%+<C|,/F2w*=0j^NaR!Ym+p4*aRe@avs$G,=?x%G,hk[$:ywnL"|cSTl@<FrCx2@zp98e:"5I(dl%nY;8${#2/G8MYql=hzvhVP/T$E{7h{^UqRSrrP#Cj.Zmf@GK}~MDeAP2Jrs7:0~%^|cMaWJA93MZ4tchT]2(:3ca7vxk1sj`bfRPTl6/V&rRZvEcG>V7ohS@91Qf>aT:X$V_*n)EbU/g.JgAxZWk~REz<9v#)/mK)6,SxPE"|X8i$n6:wPs>p}Qk7)DS#Hv!?~^ea3K3$;5m4;0"&<UKz(wZhrk+;G[p5k$rr!aajLTJII=<])K>=wXN^_64G=+932YLV3#"H(+9viL`4"%w0+eLTcv=;c6%W9KNz99E+@qJ?sQV5M.oh(!}]OFLg8S=sFLE#+@%jFuZ_jWE/YkY%];sSI;7G|r!iF@oG:]X("KAf?"aKQ3j1OYt<p%A>I;0+bp7qR.#]$,vVW*Z$wo@`L@(r>I,6h{7QU^B!tj@=eF|%jo:xg*tg2R4$GCxt=U`]FBevD/AH72tgXZ]vqZGm52?/3mFIj2r{N@UH*pRaOygof}2Yz5`1w`&Pm!g/gV%fc6FFrdQ7rU9]+hZ1S#~$`s2$UaxV,/TB^fYBeOE/gya<${%fVquC}=vMt3&BoYE~|:J{=p~$S>e0qDb>y!&MgS`o:3j[!q_Uy<lp#2_xY?N5bYT0#fkSb2k>]+03mIg>4$Jzi%%#3gs5A5*q,XKeo;UfKfSiPH?JCza$0wX<I<MbZ`?kc$A5Y3p3H8/l:pBVOw5a;[y,LnRTUC(l:iZsBUkNRD.jx<[l"_aYXY{?CUvi73K822L>JTW#a?wa91N51>tqqgjyh6E2J+KrDgE|O,LBX6&f6n;7<PdG9d5YpS"LhQkz&6T@ww[9aC7N;w"0y4qHS.7Efi*^T.x?$9p#bDNxQ&Y8df55_r@LJ]wHcLc#.:e/7}f&S75:<^33B%SEn1d./9x3Ye0(5Mz!w]`P?uYWi7T9%?T9C@kvTB3"5dyQ7}M9Ey=k=%izM9R8z(b+M^{aH}wO%x)?`"q#a.*^FaDDhp3HHrd=b;nW0W%J~(_WdLKV<EeCB5%(!Zy<U8OM8j,Egr)zDsEs[_Kb(8uy+4GSY]rKah76_8H#,O!YGQ2%NH*YBYd%y&s~ip87vB;dGi,/4l=;qf{?IzU,RpWqSRv[f<#kA~Sgy<,b0|7ahO:@rY.K`TG{%>Hiyw@:=ea2]om2;unk.]NmB<U&)5U#k?RW*__)}uE=KWz$U6so2vejuT%PUfL$VsQW~]r1q8jRnT{zvtv:_lle2&lKhK=sFmOf)~a"(w1p24dR=]X>S2TZR>omPm)]!B+iIIdSZpEXY`oUKZy,s2RL:Dw1Tp1V(b%|Oyvmr}e278a1a_d/T!_iU%avQC#jWyBb%$p#LK!DBH0S#*1Jqd=VK43CV6kYL8Ae$HBWMeTqi}WZ3Jqd(3?VVy$om/8P`WC.!*frtqD*A`91H#RyE[sk@.DV];U?M?y^JVrE%k8=;_~_91B,<u*uM{@UZ3Wvtj5GIHX1e1BHGR[)*9)/6?fD`WSaP0aJHR;,uRruASBJWJSApnBA6Wj?YYRDa7h@OW*BGOSOwO:+G:rX"t:W(F@vkX#*[F$AOC%I!SC2wDvDj`b1;mbS+5T.rx(w{TTCf<0`F^LyOX/Fc7P]Mi0^*}sezx!/05RQ&:%~1hmn~D&zaVUcJGx>*ROiJDggGT2cH?:%940Hx)I:%/CK##VPj+,;^rwi10Mm.A)(3!4au%9BMbMq:<_6$MK*/Xld)xA:>a.wD9w}P0lNyuCVdet}8}gN?7Q?pwOvDa7Byv3dK.O!]e<&L>B$dX32EFWFr)N@Nmw;G4~zPyu)*7A<R)aZmtd(.nO98c[87rZVz7^1aP7hkrFUbv]O;9_)?D8Q2hsb|Dv}+i+y++;]`K4B!Lzn~qvsXB;Cqka*!+TEJBs%:3g"cg83UD:3ntf*dc4u@b_Nt"ltv<[?d1Z$X^DrZc<V+.2sm+";@OQ8tEH9h2hTi?[P<Bs3]Tp`nakXxjgd7:,7,jPIPZJe83(g?,<Wt}Du|Bw{W)Fs$28P?!y}:Joj8J*VC|NC^0N$]bm]Y_V~2jt?|3:JBSoXER%$)BYA5<Bh65B98pyz}6!0360zBV.=*AsqU#g&RKkJV@8FZ:eL`_(hvp6[`^9LH{kvy9%8e&:C(L[p+U:#cCX]>8Ts4@(fbn+6p]+}!xD:fo;_@8j"#;Y2`^}f,BnpepM,~!wP+?z%$[@]QivCL/y!>OoqKDN,ckQ=75b%/nxGzZ>(yTnQ@D@XpoH,Vo9FJ#|{)z`%KCd1[N5DT.MWXVcd4q}glbsX*5*1Zhv1*i[*B/q.j_=^E^ysC3GcuC"L.c0N;&9K6e`iiYB0QuvWq@x4g!bVfa|hpK.W>|YR/q&k~o>^tt+9pIwi_V9zY"rZe#rau;!9#($(|3)qY`}VTiCxCE9Mi:7;%7Z8dG4V(f;]yE.:]:D]?Knf&JL_/H7X5Lc?/rrdv_Y7Olalr7,/;/HBd4i`@_PBpqH#@Y2y8cRI*wDCneS>[B>m}]%8{s"T~C_bi)ww;f}|bT<9_g3`Ot/NUXV|RH(fV}QK{CNN9?Q%}(pcTv$EtIV=.}x|A,IJiL})ddbWk:0%&DV=6|t&ha?h,}M8+?40t>x#zOfN=[RFgc6PP/R.Vh}+qz";00RY}O&?rEDS`.VbnOr)xNVB%/w8+BCt:|"6(6xq}sl,`&9MjDTP:hK*S5kpP1g>ps>lUS6`v}V:XC6UBo3qWQ71kIt)tq@tBna__tT#G)XJitP$QcmH&=GJ)k$#j+v=+[ro~GQ>67_}gKMQvsisYFq!_8N!^l#Ou|+pEKXgObQX;,Vs<PA$F@mIaB<TG^zhL|_3}&&fJBWTXkPC>=!|0RP:6KV%eYFaXST<yLeSfRRGw07YSEAY.@(=}T*ndY}qU}5CApz_chU9Wf8y|n&`&q>U#JO^G:Pf;c~P0(=?{.x|Q2LIq&m/fSBy?mk|IyUOPy}hjb@dmi/entd73fco8CHpTsMg&wQ3V[c1n_BW}RwBz~h~gsit8v+2sli%jeYD:j`o|;FFknU3JAl^O2`iEk:x`qtCf3d&F+VCQpsNRZ=:>>QxAH,Js=qD?tdF3Q2:.KwD+W96H:(W:U$fg!1(V,?)W>6iL1]Cx?FXg7"`Tohrm`L?!4>:#x=c,nV^@B$jRCUX|YT.O@k1K?OeG3%*NHT_9J#f#2z:Cc|,+#Qd(!+Rd*%T{,00kIOmDUKtj`juH(:_LDeK[t_MEq":[CTf|PcVXN,DFcUT6nEGF)b|N1DZmCcw+u#_mgM2_y>7r)5sv&f>Ilhy$#orJ1?%2N<t[dYKM{kX:lXH2mw85&?wB9uzlz6;$RzyiVzL+cApX`^vn<fF+bgs0&cmKfJNAnqa1;5E,4(b{YToMnZ0Y_;Y]pLf9LEErj,=NwZW*6@Ykmhk7@|p%(~QS#s`2hO2Un*NE&7`B!G>lhDPwyen^Z_I{!a(=apiFzX0pV|OI;i+r7$MZ7wZ)!0i[MtUP2xbFl8I|/6hyMW4^Uw?##d.}ixmweT3Uhv/1]Cl6TK}7jw;u_53b{!h=Vvyh?EO!%D8N)`1aYPes^2y)wUU/&2@!B(f0fo7^Pe#&d(olJC2?un.&@jK=4"Xf#YIxd?!e%k|jR|HBEsD6w]hT4[/c{Y|30pV`hB$Qkb0x|w&*CIbc73$EFe<PqpT!Q#kYHR}tBQ^)gRIg(7;!twd<&,,.M>oJlM6n<H)Pc8d}q_/`_#u[%Y{Qnjl4wjFM%yHbMD4]~dp``A+J*TWC?<5@oieS&yBhjZ]x<=|P+Gx?}zLdfHSqT>."%_Id9WpY>yr3[kYuf/Du=Z/_^fttARUIw.O4U~$qZ$$e0k^T8uFW9R#$Hf;]I82{l)CPCgG|}(}c%PVKg1]|gw{yb$<0GmTl^MpFPB_w1@Q>Y;kKTT_lkVdlZp}>?S&}{W,RgSLi5/}GW>rv.3pT:y[D6cxB^%(>faYPl#s"dw#zj|M$wJ,k]4tWk=rz&c?qW=3:sYL*:$FY!eP.AhQ&<o"!lk7Qbqe:,Sf)VF8=nW;hPld)86D|lH^Qi*>(@m.*8_RVTJX`pTMv~0^g&H2Iw}%,#Kz452jH8O_j5|Pehrx$@c&;InyZT(;dj6fCeM<Ogw%_&Ie{1`fHR*o6MqNZ{N}1)T{WUV!{IUBIRpHVY7Y3G_/w7gqG),jN|Gj1*bxhoqd:)n*uvABb^|b,E1_H$0~{mcWU#:vFU&~5juF6}BhlD&7N%H6F1(&a[(g+,2F{!A_b6oJDZsE&,hNyweJ9fyJa5F,QL0k"+e4}P%`m^C^q%swp[~KK`QYrh{>3;xfKJmk=.nf^lM7Ff_|~>c+.t0Lvs_"8g}(#fov3YG;^t2xSU*(M%$DMsY`K16DaEGn`y`cWLu1)r)I=BlanxN7)eSX(7WODvfu!q@B/2@z^Fq~Kj`KkN[8cI*)[>!^d;ai){_g#Q%h[[>6a@f&%vt!XV5t:p`:b5|S2SBtaexY6_<4bx;vOvaJ8XIf&#{t7S`lK7Kf$_sw_D&;Ng#|PeJtdhl8vlJUrO`B5:hd_,(E/or<iS|e[JB":V#:vSg0D)O?fi}2xVc8wEv!cO18"7|S.cZIE+R<,=^nopT;6&)n^;44gAFh8*#Rd0C*y8TDI~%BzJj%1]+3Y?:D>yP7u34SEI,1i.vU_;/n|mzJR(B(z.5)BsFJGeN*2.f9EuX<ogL~wlZu)Oc]F%LAs>*v{`)`"vg{)hRS{c"g4[hW8P~i*,aqMn>;"DP;[J$`MB(EfB7]o3&YG@]H#v/2;Fa3v/w]p^LDoDk@Qzp{*H4=Xr+e.veiZ"U~[=r>d.0[TQ*HThGMx)NTSrT^XbqOh1crymK`r9Me/=$*^mPC}OJh3hYdy;=#6XT1R.Z!jG|@93hpx,2+1[vPH!xBpYPi55!oNFMjOah4LuNzxJ.U679q/p.M(sHMpS4AY]Ph*Z3i#$(7GN?k{,Mk&u}m/MgI(=ZcC;mm*Uye]KZ@J(l+`>mN:M$G52I|F!S%d4Qkk>`X4BNcz1ND.X"kS;^EmDV^8v#Ws_A?EvP&A,rcqiC&{LsH>kSM;b,Vom|P{[T@[P`}+evT#UdOL[1I>*Bxi%d`.qKib11FVihg$?50,1#H+zWw_s7[Xq`YxJx1%w1L,Mlzi>D"7m?3`[P;Bgn&CJ6J@&x4PXwz@Ps3*gpc&+b*[eC;[*66cq:Py((<f]vulGKv/yC^|{7d>oX<fczhZ|{lPN8[cjX)I22g$OV`R{!5._HUY0/S<ZOwk4[cLeB6T7UV5*8#u,b!roFh2UE.`&v}Co9Bv{8("<I*tK5Ne{7zZ6#(>C?hw2:#@:6;?[t;#%`IhHLkH$=8{a)dA~qF{C*eXpJ0#QEv$F:+/p56RN^|+0X$m#B<DJ<Z{jBfcEH*9Zj(yG>)tuWlUZgzbppMV0*FjQUkN$k*aE*Gm}Wniv!,[;),@*V{EE[pLwJXa?&>Kpw*JI%8[5Q?MOB10C[ki!7@,}:)uCGhIENvMDp!YXa87VD.0*f96>!IU~W:iM]orzE]Yms*R*?9i$zX2bZL]_0ioj3Di*sqwCEUE*v/nQ^8qy}+=urUj:r!O3u0MrJ6~P#nhz*EYTe]MdQGY]vsX|=[cvjQIjD/3UbMV(1o(V[n(m=Pe|xW?r$sju,UA@{4]d!lQl&.*a,j?H5jV>^O)a+5LIWKK0Z{ma[)D&,{k1y0$qo4yXD$PMDt=#Q~wx"gcBw%h0O2#IPFSE]}lhEiVmP~3FgURQ}N88kH11?/;zLtK2^FY/]UN=xn/2XJKD!1G!C!fj,zH5G,c91&Dm`j_3t]=)*[?h$Yqto&aWA[CfpF0dsYFS=F0Z$z%0Ea6:u0%wcs%%_xSvOEu#)x#DLn8Y2QOQ4:~Oxc/+#,2&pj~+dX#eEB#/P*3i;.3DR|H0@S@ejK|q1~X="K__,#JCBU)pH,mq{Wn4Ge[7yznG4O|PX7!b!znD|SiLe5]?3t[g+XXkO%+$[Te|~xoa<53)tmD)r~k_CVo:Ot>o3btX>eM[w^H;7s?>0/y1M?.<1>uuEo:cnWQSjJ,!ldS@^)soo[PBinsR{~X[anj]nns@~VkL|h}S%f_$$ra5~<slVsFI#toHL_[mfhB_IG]7,&vjrO.cBE4R128<,/_xLFa3FQBIiQBb{BLo7(6lG,;63Hi9!tRC^ulU)wT(UD"o;O1ixt$c_GcGo6OdWBEW$%X<0_iOuPi(R}%RPc$5BsiZx+o;[w#^@`z%U]Q8aqR^zIEe#*8a*DJprNN!%lM7IS5QC;CyP$m}151K,wy[~lI<XNO!{IF+V1P5+=3PS,SLmH.@sNU,cKE*/(ARK5SM,O|2]Y.|OY,%Du*hgZ;*tV4fB_uPZhL>YYfY9a>P0<P"f6d)!c***]dJj5hhx+,HiM(RVDfe91PTdbOaY><5ChA&K[zzHHS+A/l`E)(<C2dn5LvN~ehu:4.Y5JRTvF6>a}(.Z4]85@r[ni$@k#s([og?O7uxSoiT7Lyto}K[h*#DO6tkD_su]YJh5;#yp7lg5ETKg2joYD$EOS:8N=mnvj}5V&W)YVWi6xi|/mQf3YzMD)k;@j+wk+rWBrWFB9"iNMmv&oBB4N<=kUksa.3k?P7oYU|rJsQ^UIo?8M`[jy2sotk.W*fS*fx.FDdKPP=T,xOl)=21Xa,j<vI#q}c<*LSAa.%3iD6LA?0Xa*lX+PE>.}?VU:]i^Q[7{nK4poFqKuUa$9Yy$VB4Xuv$xdcH~_v.;C3?]uJI6bJ0&?EK6*:/q_+Q&5Sm(qjR6splLI)BN=w)}x9tG=SkutI;FI:p$GoFcc%CVc~>os}ekB/C(;Dp3rD;a0ru;`sE|Pu3XztBO%HXyz(.(R+UvvFk*14P9532/C"5SaP(QaVYk5eDU?wy@@c4r.+V{r(YdS5`t0c3E]vL|IPe]J[YUYvS2EQciC}sqLDepv&bu8{}Q#>XbuUa(80u0EQi"Tca"D4rans^E:pLRbXYgzvLsKGZ@1rc7Z(Ky7!c;g><<GN_yu?6k/",ruF^{a=BpDO&J$x:!t/[<)J>8|0%,,D;C?[`372X)YlNLfqzO=TYMUn!QuJh[V|X_WB>Jy&LGNqD0IlsxlX`[$3:@;9D)%}0mjn6AhYOYba$N`~pYK!@d9wkXYF7BQV#;Xo;Se10Fwr|,zGzAJwKvnCT4HWHFw3add54yzdurC/U*UYdy*BZK6V!R@zbzbm#iKVsK[N@T;Gb>5FeAs+NtJ{325|`Ct*G#Xp_z$5VO+wF(a9?2>ngE{2^s<"B4r"`cYy~>Wi!P0NkLlHw@^x{&>ozV0Y.O0jf)IZt/?p#yFwv(s8A^fzM5?wpt`Mkoe39RkdDHwq!M(kp,tF!.@Bl6kmIV=]L~:I13m^zuI9&rVKPN@.@#LUy[}i#YM"Dy%T&YQH?nbz8vk|j~wjp:ka?~$(sAsbe)GP3"PU!DC`O!Cu_`?1*w#/r7Vnaf:oJgV80GbZ.XIH:{z8ut.y;3Y~#1a2cMZ%2qP@NU/zNHyro"y_#/`1*lWy`&u5d,B2i5bo]E>21}Q]H:JRp[=,"OK4Go!=|S1r1E!B78Y$;n}`D%Eu}aU1`4!]<eS`bB)i&}2!s8%$3`#T)*wYHF(b:4X&M[w9~LsIy&YAO`Ek_xll:wprT_Tk,7:nIT$eGKzpVC[GBH}#*vI%a=?1uc|~Q1P3f<E8tKyi?Sf&$vL>d*Rktq<"gYL!qpp9:^Hlz<_+:oxY=$dK9p@jUD~,zXE0a+39F`TQlc#r2&@m:Y*D)!8jf7``hZ9`f>VVvzMb)OH:Se51~*8s7UM#Y"S)pcnv/Qvt%Gs}4{5}O}a6K9KdJ4#r(6NF7v_K?#cJEUcdTdu[*6p_^GtymX6l^A4`94/%*n8U(&!Pxq5G+$sg0UizPM}YAWkUZ`c{ffe3CJ:GC#kN7Jjas+O*@7vP&M=]<f%!/9lQRLG+KQ2R@^iSvW~gZF9qZ"Ip75,,4:1IU0!g#(`G_lW[EW.>IZeE$}{[YG4TLXGLvXL6]Cc>b!tOtbNw;GOo!tQic4cl"%xWY}#2ZifkY6~]=R}glMG[Gy5H@{?%91cgyVa.=+05KEZDeX>qGN_O%.t<Og[E.M}vur3vB_vY..Rm:EkPrd{_(ix=L6*t*fvqrN,u,voz<AE2VmZ5r#;7YD]iz"Y@PV.jqKD&f@0.n1lKz[ogP#%phj7&?*S4cYU@&|)}*/]y9Q$QhU7F]G@},*H&*M&xWcfz?uca9H9I]Yb*Y;~e^,WuN%b}gd9Y=>me>>xuXn[a?(Kro}Oc(X3.Ej4qvj(~+$v$v")/+}jw*Z^mvA[>)tMD9nP+7&]K}A3sPw8(=HBM<vuF*HfrXR,zm)Xd&r$=(SPVgMAuZWj4)$)cls662h2z;q?Mv>TT65Y;z*xDbN!51rl+?5N0TO[J"w1~,foiuON>@KvOLTSv;*rZ!&qzhCj?KGl1!;A}fgKx#Gj~4vcne^l"Hzj[yB1L+jr?4"u~8U@sf@$:4w"+1/FO>qFFZ}[<W+h!|y&eyUH(zGBkQ}@B)bdP4g}*NEWague!$!"Zt(K&~=dtgAgxIt(|d>SAgv;OCcW6+/rk=JHue<GnFkWXPQ.:|6tjFtB[!Dbldz~_f3cnn]CL^Fw}&Wzp>]e0ay6g*eoB]T$.pBPr!N&e?clB/Q)R#lYqdK?Em4GeEsx7Y]#}a2?jHk+w*.];PxYTSW[N0ypYp~sC2s^,zcZ8zlZjQ^G,18u3.#}M|!~GPZa#0jBZa%JLF(>`}HVM<lnA,X2$H;OXjFPy0k2%dXXF1!H+U$z;?6H?+l2w=TMQNxJ4$1AX+fJQ;2,Y0X$q/C;o^q7WL#[,sVZ0@5;]IkD/t@)LZnqGJDQce|fgvW+hWWtr>$1i<5egU5e$ZaR84JCQIT6/o.W=7N^=/6+U^BGL=h90N~k^1|pcAm@FY)R7@?gH(MyGMnrqJ[$wXY4/}(o?X#@A.W7Dzf>Je!08UL0?SxyrqCw1OUDN&O[=%VP@][DPL+i,T~8~rBi$6qzJw4l8pb(8<E(N%PXZy!%$:m8;!f)Y]%Z<F1a`JHHx`}J@}A,D.I/Zq>*i.TPf|famJGym1hU]l1$;P)7N:#]Km6qbG:23lW*Hz?LuL_>Ta4&r]Y,9HV:*e*0~gSMmWN>1r[UW_$fY<70b/qX&aomXu/Fo)wiCsrXPaOF5oo#Pw<WE^*P#Fob~);,Fvp+#eURf9Ng}{emK8)i/FEw*xYmR!(3<]u?9xu35}e#o85N_2xq%WZk*&W+h+L:0,(y?@?r*0J!K}UVzK5FDQO]@5If=F{h}`rEF)?./OrDfem>zX6etz.t3ih.kd#&tJyS2)MCt>@1WX[m/o=b?/6V<vxw1>zt/[/RRF7Wpe"/44H//rLB:=Q<7(wUHB3CIF?OT2cEUN;D{u=nQVH4;aI[nU3&gQ7IFZv@8b}WT7|R^VaayY6d~Gc?G*+~:$/5<SW9>>Z|^{k"L>e7=T[7h6aW":[|oTP)M_N=kSz95Yzwfvg.9gd/~E[mOsBvLsi4B+Q1kNlH(i_B};8gFP}L$~5@vD*ok%n?:TD[L{#aly&q`2R2:|r}@iOUo$EsuBo0gZC@9/L|&^bV,>*Rcoe2GFDF|g4.0p?"fjPmp<T1f9TlejY}Rq~yAQyq@).T[inI]+aq4W$y#tdf{E)NT0&)Wjb46<Ev%>wF!bBn/0"R^!r1qr=(I_mesKqY[:Pa"6XTLP1IWQ>.R6_YPfI~_bx9loqYNSE.F|mOpW*HbWu~6+_7>gw1]UyqgYD7C7x9:uD^wFU.]#_6yj%$6;XT;:Y*ds40~)NLCX^CvR`sD9365PMPM~)./AD*+B:P4I1|T35H*J|T2NVZEQtl0{OH6e#uSeT>mh]h^[KS=*"K4XWy}CP!%BEJ(4F}cjcgLOeGX%z_@nA.k20^B9Y_]BZ;C!6U{n8wCUyYS0&HYSDur@4:Gl.7(r1YX#bF=vP#O7<u(i=,J::"XG+u|FLbEU:T7Fg5.3HQ]yMtjId+eNKUw199Mgwy7~WE}:mX=(6>|Y6EBia:LePNqCItbKXzE(;C.u~@M7IEq_v`$(J"Unr%aQsISEV]+Y2+}zv*B&IfK|3ASE"w@%[c<%U#N>_wV92EJJN4Ojwl*>95;(}/eC7N<oPsb)Uk4gW1!3En?u&a={2ZDB%{O)0vI[}v{(l4l4k9}`h1*.@8}nSW_0SKK0Ow5hoU(ZM^a_TVEI/OnIO!7RM}V!&=>4+sUEA1|OkBs/J<RbUT5!kzx7eTu{P7=fWvQKFBHQ8$Jv"iJog`z}R.kGs<QXuez33f!/RUFQD&u1<0r]7p>H2ogbU05Z9md"&gfw,HjOI|Y9$m3o;UEUTBrq7^EoD6773vhC%&7sT("@~p]rL^x8`EvAB+6*W0aM[<H",UR:0DEvf]?29i0YO9h*0%dkZiiKm}hxKf#KowVg<#F<*_sW9Z*mn4Jtf&_L#><5^*~KgM|}KsTw6ibI"dLC&A|xZQUgiPY~;eGcP0T`!@3>`4OeXT*f!d8y1mcvux(%U7ah#:Tl#zy7M{MW~Z(Z|{L8&d=,Mr]N9R~rK[;}ey4]khd)iw(aU{y!@q<d^v?PI4|w:jzFPm<Gaw_0*`[j^}YlcjYvWNt{HGEWl|F$DLpzH3d`IH*6$n;Xnfa1/UFnO&qKBw63T+I0o^3&]Gy6h}&DAsnttg2,//!))MP2w_s>7[@x&QW$XV$i"LL>4_6;+:{/a:v>&R&#Lm#{"w@nlpj|~fl=,exBD<tG4p"MrbGRe2p:,Qm69{/A%:1w.H^|V"k5z2"8Ac%Ds##DY&E7&9B5vNwL/JRFnTPa&2ynTGVLBgY6oL,GcBh)mOfKVFAI<&0468[I{3{6[$hAZG4h"_:}(Oc+<qlDs,mL3.xbdxdHrXx~A~kkWdQd]8XRhgG]0"$H]K$[?,#uw_!I0F/uW<:9c(iWV^x^pr?!tp_m15Zqv4Hnk9<D7ABzU1/Vs"=Q34_x|Lh>*)S[$DVMl3(i_T:ix2LYW$OFMq+[TQhbh;+SKz%az*VQ,]dh2lZN/>_>eKq~>Wuf^J>l9_fk1z?A_x{1vl/WdNP0z6G`u"=SO^8Bo39yu4fyTCPLo%T0F:{Lt*CIk(P"xl~B;|i.V]A@=U;%]SjE*P)>C5DULnrdR+PNN`#a?E)XeqoEIZwB@P3rbnq)0UANl25u15*$#swY`Bv)?DKMl;YWr[J8ox+CBYbB=a7w[(xY/GbliNQNhBHR?F?S?*;(ul25qd["gK;ckee|DGd0C$F@J$r*{_C:!i)l^M`/W`9?/eXBSP%z4PIBHgZmu^gRPd&jZLA{^nJXR!qV:[`NS?Q&*7WQH#.Auc{vMFsF)[]1i4$7vf69`?)H,M~L!E6`q`aFd04H6SH*~#eIlcREjzj6uY|frf2H.VVm1{UlEp|vxeXo3z7FPK5M+b:p;8X[C&NoEK>0!zoz!z6uM_}k>M(C&DVRgjo,2M5)TDGC_IGaBp}!t3^Fu}|>!tbKggOxV7I0FZKZRk#|a(Aba<TRKO]Z,wr>B?S!R0=K7u`W1PbQ3MP0%tV3Tj5*~Z>IHt,H?X7x<~x^~N~Jd7dKYXuP4H|<&%_k;}T7~agl@tN&NuRfkO+E{6JEl(BRr2T)5RN>1kCThV?{2dYccu]WcBirk).dPn_hIVp1bB>2hDWs+JkMT_NJ+;"04Cl`T![evMt}^eGJ)r!K56y/z7"lI.kUlEr>?SNRyJD=6fp>9<,Bpm/9h#]BU<.*[!A<$@cA[LP3l+yz9fs@k43b/o*??N|H4!EZqTA;5<sinmo$0Hp0y@=YSGl;*~R^et:V?4c#H#8=@+)QgviPI5(a%qfXv3O^r,!r/az8ExCqc+7Xz#[nx!R1OE2D5`X,~FG+J20hmp"%DGU?_r8ls8M<>ujVYoHhYos)*FkyjG8L[QBF~}5I<MNM?F]i0,)!Dq[5ppN~0I3bUE0FyV`)2XDd}umA#E,O>|1]^$e@[B|9t2`<Kt+J+TvzH,^K>)Xe(cZ*?#l3O"Sj:=vyP*(BR2RSw`^cMdtJ(!U(6)&O+/4eH>I,+|H2qK+PVb(b(Gi]kI14wd"{9b>9v9kjmKLId.T;o|FBBy#w/rdIy5U|Lo1Y,[C/^kSg><cb&YZB^xKi,5)Cf5(kZwVoRrV#`5Zubo]n4%CWCOj<~+;$ii6I#Ma^ct~Sq,DTM#*EnrziNTWnVx#jsDL=)#;"eR0f20Y4"V2(/v9@9VHv_=NECM*2yX4kleim%hb{*e}+U`C<]Q;Ij9Q?lcNPG1laOe5jc|fxsN=4Z&UX2P)?%d*7[k[+ii!`U6EL_y}Iy2#/gS{pas0|n(r@6l}=z3Rx^B/"B1QHdDJ~qO"whsk4S{Zj.iX_Ez<H:1t2T=v|E*K[S|p1|~8cp)>YL$.2WdQQF(_^=r&9n0q=re/6V,&h#B(6Ny7/sZ>_$g_5w9;"`2tbeNTG88+YvS^[1;ZFP{S*?H,Z~Q@[$UV|mG6(G$*t9#2,7Z8N/So/e%RO{!AS~&}ad[R:JP"~|lmbFwKW(o`kL(&]W,i.hZ}l;cfPVWKe,>igaC7%N2PljieJ"*r<LP5WL]fsGlSEV@numxrG_w0%4)O*1&|bm^b!H5*>qSr#_2>=24Kz%gnRRzol=GckwIf=.Fvpmyd/&eV*BKl1=7C{^F3(H_pp2Ll~MViQ8t4&#x+[`U{]$TXd/W?JhmiPl<u$`36Yd<Xb}dCoTb~VB=a/|~v;|?(]+`%@G%[eh?~wUUU;^.ttWInBn9orBcIf0Z"G6zW7`c{crKrNZ(>sAzsDx67tiZkl7Pkdwxi&N*f*D+w,#Td$p{2]L&[C3J<VI6)C]^Fb{,Nx/xb/%.x@H.!gkq1rmi`=,FB2Bw4cET:)E&>*D_#7zQt*MD1{!hbkt?LjM[I76d6Nf+uHQN+|4,$WX&dFk}B~PGA&]oIUY"!`w,[=qwN:WH,rKGwvQvWW=stks1g<RWhUL5*ov^IJd%NN"9n$Yhd]7B4EYhHGZuD*6p@l`U%U~.9xg>/C_Hzzqq[NS!N,@5c.d&|(beVi>P*qR=q:q7ZZ]qo4xw0#x?MD!([m5p+:oW{eK0EfC3&afM=ygR+`Pj5q6k7v7CPW~DG.t)aCR`l$vD>VoA|0vUl72nhB!WFSF5l_y;bi[o+j39i?w`MhP,JHZqG}YTwYT+"qw=y:L0`BDRuoeyZ+E`$Kokmk2X:NeBj]ed3ZgNFByej#2S]`PUq4Uw8uV*=~H`V4$^VOGe!!dvXqLSO|^%[{F<]?|4Ys/6+1>KU<n=$7=CxF{+SK(tzPX7""1{2>Rd0|W:X@2W;C}YDaNtYWQY`:sJaxaOjl;,}Zgj#RsXn|!};.KQ<(K|FdUc+4$~}09f.q8O?Ra:H^4owG%ny}qNb+KKtBBo33UVe&21Al>CeGV91ggtAOd1#TkYm_H[^R,eTdf[srlU8F6aV]UFU~QEYc7ML@ZiK3a?,F6bVdVXKVD&l0@}bT(vZvvkwbyE4_Uu^wYvbkk:,TtR5HOA57zPCgnf9~[YSGgp~}CdL&X&,r[vT575Avi{>/).+L*!iy??:LmE8>k)Gv1u`4nl]|K/`D:t"_>X+)uPF4GY^sW%JqEPgT56wO}fT|iubv*~TiW<;~JCyGKY$[(#:a+bUC0J;1t]|]vh^R^b;W"e#7s1NSHBND+!;7PZxz#"<Qg=@r^viY!I#m%ZZSoc{jfnvbozwBs}o2m`I04+q&wsbMOu5,{4I0KI29Lop0m?LJK~44W3a@Mo&a[lP!`8dRWzdO7rDb,PhHLfhkW)ECE/Sr.fd*>~]P9`,<o0s;uS"LI<Yst;w!pG?+ZpJ$x3dtD3{<$N0_UwDNP(sI1MYG1ll7l.O##YEO<7>gZiHHt1_t&e>+L**i$mAD)e<vZUD`y#?Z2LR8Xp[*q<:0LS`(.>v0aYkce4OW~=m1eKz1?[~4HF.y/$cve[SCeCI6=12[+z?.R9hATn)g:~U?Hujtl+iv>]X3?Wc#0Q8[)(69`@(}lt)G_G5=Z2/f:R=Wkan{!o}rJl]Nq6Pv+4>QGP;4YH05K[%G:lelGabZ{K4jI:>zCKZ_P]hyR2]NN]01Pv1SbRC{lNFw5+xof>J7@Ye|1+/t1:$,"_oiac+n}~{LF(VFslZ2q%j/h%Nh}1wE}b3.d)kybEv&26a/(4%$WUd[j@})vyuG_:fvWOX]4,qPmRG5&?l]BliS>wO|J19bIE8CI6?:=c;NFZQNm)5Bf`Z/Z#.`(0gcDHM@:gl3_ZD?/70lx=&::cD=OMQgoSHk9ygqTL7OX+6UTt$Q#q;J:b&Pgaaw9l/KE9pKsE8|70+8~FrG~|i:eankwiOGh@~%Vl=$&~(;oGo$D}dIQ_fu@I4LS})1";)Q,0Kmzm54[/ma5le`T/K.SW5h#!<o#f5y)HUN?JP3}0k2]SN|I+M?WN!^.f_H~.z$>yT;@{|p2CPYtS~+}u*EE}:6O,a,eBrB:,fJmx+ZDc}nb,SwM<7u{+I<{ui04J)TtYS{&S68VM6F#0?TxEV!e2;lOGotD6?ddyQfkA[g}vA/EES7kfbqC+SNJ]?E?r1Pv6.w<l4"FMo`KH/^|]~W9"WYJK!~tp#,Dz_R7C,64YT[]m@]isGMaVZ<pW$m=lm*(S|p=Akk`,Z5][:yu5=X6w:3d99VMo*fohf/|#Nl7yD:vQc;KE_Cv>cyX.cWm:bI>ZZP.`v>PeeJvGHonY<$YR:pISru7OSsVp%qbi@Vl?B!|JWbdx(SMmc%EfGEPS/,Gq{px3[9_Om%C1m5C|!6@RR&=n$J2|5vmU}0R$"+Xz=41N(K|9P;A&$s.>t=QZu<3_ut&E/$Oahnmf77co"[]^mi_AmZT+SR&W}$_v|1%pmay^xG,1f2Zq#aw=opk}?9>oTczlhb+bp>O)":i8+fIFv07dMPNs0,AeHrn2(Pt#gKI_`tt)*LnD(*=h:zv0uQ9)0C<R@,o__BCZOAbC:$Y;v4gG?~E,IL+!M?3ZyBr4Y#;n2GDFD]&(ArqiG8zM0HK4.+R/&oMY[K)zIRsn)bKDz2&FT%2%/o<)~hOfTrgDM+Fh_N4N_P@<Ddc<qDL*87M)dn6Ek6&_[YT{~xq?qM<NAmq.MkeLl{FC`3)k0@:n}6$"rZYc%Vgj7Js2^uh,0Z|hm*"L#TGvqI$e4tWt!YeruSn0o5jKO9R$m7Wy[j#vzXKZ?oT/#:dxNMi~cqF)e>Ym;=b"L)z$ow~S,wx{znOOrJAB,HXyK8PC:kL>.I7w#UhdY_BVP|<_m3(w%rY1L+9kAISg+t[ZST?:BxWRfcdNZBDXOG0~)mxbZj1S<_!}!7oTy1NiJdzju=d#Gm)|.t"Y^VT8.xZvW9nD=LqR`86^qecZQJ@sQz:w48W[+.:"f3{ZtMEVm|davr$:/1X)9<KzL|x,RsgP3.tEOauKn~$6:>.hdTqh_yS*4pb@D}W_NKB6.?fMfcj77<@!5;<:Nh<s;]YHnTHR7/n6S#AB;,VKU3Ixvg&!tb9z2@VZsjU`5_/muYXqD=66v=|r$M#0~0QSIk#v#8#rQWx4uUw@6|$$WL0~mk+MsVbDEF%G:^loGhyqfnJFt4dn`>No`~^/.eJQ:rzhDrXB0)$|oR6/NS%bFFv5_6[{|[RvN"l#IuEXVXiFQK}CzxnuiKp?:81QtZHXZP#|cm,~|HuB8R/u)87^`0:XZkOQ{b|8m[G^zz4DjaR)Zs0f{6)l04O.P^(N)qN=0lO;a7F[IVf7r]bTkaO.I`/(}}hw={p*z^coJlt@Q_K_pAhyxqP*f2d:rzpye@tU>YBB(mMNuc{uo^(=2R^K]?VdAY:82>l)cmN+DN,B#3Hd9iFo#CUedB"L[{L|jC=fC~[M7W7Kt^ZI8VE5S/A"J6#8]phpF3Ji^i@3wK+ujIc)nKub|AIu,HpT0J9`[M.?J8}XAo]e=kYGeV3bj9z`ii~}<=^h}e*W{;3RguK@J?E)L.=v2INjf&iY]uW@x&X{5C>a[#$h<d/hIk_7pRU*E>1ffV_5qZw%BxK7b)|f%X3F2aTL]lk[l{YV:Y<Zj!PogLp}{VLK=LxT.L6*MRy44MxEi@35hAGn80g0Z}3~Aa&^ni|9~A}i{*_GT/Ejo+N>V<^1k2@1xPQG`j0[i2`~sppdjmp>e&/[8MBNv`;e.,?tKm/iFwYLMC(wFS})#(2cVE01wgfxJaG6m@zUU~+}$IMNq8H@G&2OY<];uWmo8R2hMmg|yKl|445q~.pNLkFrM3$Pcjv7#/.zdfeIwnG.z:nGw1+9Arf)M<A5%Z}cFNLBRvPCV%Et.OhjN1@O.GUeub5Bh/#]dMhah!(okB""&eHLzlNr7e4z2fH5xXF!uO47yI$0L"z2*_XIYpLWQ_BqXM8!ft]1vMy$q!3V]Ny%Q`{#Mao$+7>$5++H{P7,KcF_"GyK9tEu#56"#,QgUCzb*F:m8jjD(Ds+ER}4C{/T=.guh,y8;Q1ilw$WW$Q|oag!^7b|TSKPk=lNnw[J4|i1`aQk>TJT/eNTM3[nL*qqamQSm*wzi%JM;1Z+2!Ola[}@bPqGzoo]}c,ak4>2oHDgw/,D~TR,zoE}d]$M(M$cN7{AlH+~]rYz<^qMLS]1R4T(="L,N0/zMWyvQu3pI59Fi%>5+z$tsT>K7|rNte`,l&=;&^c87#+F+,!N"Y@(jh&:CN[x}dfh,hiR7$(JT%g6<SN,@sh~^O_V;8{{r4>~H2z^0SY59GJEMWRrJ"{=CtVI0h}/"cjrm>Wb$Wu}hS(D@m$NdHd3#mBBq!*d0`sEwK,p11!(K=k=$N+s9]BZjp2k>t~kv_?}*3%5[]>s&Pv?"{P9iHFe1D?%LJ{_STi>BoVnEPxB6%JjJn]Ud0eQxaDl1_7oCqgLu%8*sLyR{*1`/[nUk.An#e[/z;r3.F+ja85EQSWke#PN:if),1*NL,RDN%lE^LM;f60+FXUoM|;hZI##eR6[QAz;)nkRXOtmn2QbNr8^5IKj~6`!k1+&}}hhjw9{32x:4wvvdHaliI{m^ZS%Z^4Dp+L2)<3{R}<M(rstCV;>*Bkgh[uWZ(k0M|ny_.ekZiMy:.uV915Nce[.P!}y6A"4!9W^<54:Fx}@C(Gu&wXs1yjZ1^~4pWl;Jb&Jn*,+3YWoULyRAeyFb?tKQD"l,Q~Uwy>+6U?aF9c!!W{|aB32[&+B@/Z59d6Q.C&;g4Mi2LqI0Kz@#uk42=y6b]JZ8Kxd,3{yQo,yMyYa.pIZ0cc+y4z10yM+qc"J@@P68uS;}"_^D]C.E<sLV.~Vy/eG#D]JCmH;_HxKsUC?EyT?WptV0sJx*0:8c]gh_v5:hgn*j8W8k=fjCi[BYn$qH2FouZ?LA:5`$[iSNm&w~II)IWX1?s.CNR{awtKO6S{RJH]Jy6B*.S`ouZ36I_@S6:|Ql)_4?YtDR)BYd}9ZGbzE^W+Wy"c"gjpZpu>Tv2C!$BhDlg(T?U"t<BZT%{*8nEu{aCPO2D`ItVzp[>gK8*cA/u1nOf=Y5[<LaLG<3xvbM~|{X7nGF_]YCWrYkL4|94"qlepwCngO_@t[]]hRN%yb33YS>g#3hCL3xw?gz9@7~M*<MwEk%hJLFNlpI;_D<z.9HZr;:@DxAwz((>Siqc!bhX+$="cM,CjFmqKEuQ_)&XX+uUdhT`k!Bamz.R$P{{b1stot>xV$$!^hm^0WT9U+;w`dC|`<psBY1BWV7!.ZfzG~[0?+yl;g*RI[E#JC8U&S=C{2NP5rAwgZU+,J(>6qC6:VLeA:^:YM6o(vk6iD8bn109+:N_T>OaqEHxrN2EC1{Kux./AhwzG`kG<k+K}?UE#&GnAiRf|K3+>c_86CXt]?Y~Kr?Tmjd?uSwC"LZ^bK8.?Ty_*^_LqPlde%<WvO!>[6hp[Q.8^1CwX{4i8k7ic_PMy*)=Jc)xPFUuvq$zybv5rE1{~9?O"9LASTzYnFT<O2!c|a8.kx"{iCrGS3wxcL%/}BcB/$P&MHs,)~4*TOm1J>Ak7L}/ew~E:=IaedkxsIh/Gn3&]29jvZYf?Wx$t={Y*(F333ZEMXG6TdwQ*.R/b|ZDTXsA&qx(=xbAJ[H%9@d;xg0;6`0BCol~%d=}jfZdl=E,4hRaFX+X)>6/t9`lwEOCk8d)VfCA=%w[<TybY[l<<ZNZ2]J1gaE{8A9cn#4dj|C?!mYJyHh7U[bcvbB~P2it{:{y%N#0QGeH=tw4Jy1:?2QLUnjTj=YK,U2+`)]Nl_7P:lB~p5G}PB(O=*.KE^a,6<j?Yd;.vYq(SsW$!x~Z"tFK,,X)AFV"AY=ayrG@.pq1fsU@n1lt_y5=m{Cp{sRMhK"`<pMoOf9m4Q6n4S*O[H.%#|`Wz+TIQGof8YDHHO%9p+[qUgM[n>8feVfrg1ES>)W7i;+QdcKa$nmCj{_k!&TF_AEQ@8t(@e}jhao<(?Pg2g"K{Y4i@@$Z`2lrW/>n{D_HVsJ^QJ+U{WJ~e%HwLHwdn@j0[NwgE34?l*]bx}<}:<1D8XC2w}$w<D_?IV@)N>,Pr.s/{D[)mrvTJ.MB4?Dzu;#CMmC5</I*S8S"+57zUVSJ(|jdH.l43in]kHbahw_+;+"F;Qo<!zK^%~#2Hx_93v!R$OKp~DPD%EHn`]Z$H7AXT?J@z~>]:S}sXJG;b<pE3XI8AG8%xcQF07$=$nM3CMK*X*L$1Mf5pK3o(JT3Qo0$17vL23Eo!nRWp@e[?xY"$Ng@s2A}nS;b}i5Jl}::uJ3[Xh~EPN;nQ,6S_t|RUc(*5]R7M66KO4/+jDG>bS:s6aVy.6fQDNeMFh=H~d1@.2Et7T"0^/];P1=sBUgEmyvPt9YUl6ab%Oj5Z7sZ]4DDfWC]"x(b1e]UI1y.g@cL+)fyJZIY=X?!D0?SCKfj9xTokQu[Too{:]MLfInV$!]cEm_tO#]OLQ*j}VdW_Y6%ybnKI#ELS7}6|WkQ)`BR,Qf9Sc9k!ujUeF?7UW+pRfsO:S}~lO+{w+YbV3%*+`mQQn3Mf.~{s9&[Pp<amVlMUY1!;k^NtMRv$:Z,Qg|z7)mL1DvJ"(9l[j2mgV!!rA%J!g4n4=0jdg~7iI7g$4xIo5r_47F"hm(;dyuuMf:s})3m@l%^C1I.[W!;2[^?AL;6pqsBsz]Z,Y8>(&$[[Rd.oYU(4UuP[%A;60O+tP5NO4fH:s~3[p)e|`I2_pKV+YN5(lka0_/(o{?*%!!ZaY0/IL6?|,e[rq@{S:~yLKZ4(&|1$etK$Jb9>P}YC0$)RZ~T`BKR4^n^D#Z/z]1DKu9C@"jSXrkoT/O5o~X@Bi"o=i<opR<We0r=sfv"c46tq`8pjZvu3nqF]q9Rex_hW!!d8QVM~CUk1pP)U!W;UJPuKV1(#q986[GlbyX>Ly$ht6k?RP~(5ewitLh7?V`;&#%MD&35NMO]nE,]@}v4K~zj)~+d*7+U:`Hv,Cw*~0D%es!K7F58e|?ejKNh,}8N!HemG/nuIvIbrZ=`z=e[U(Q+Ck+n>[0ii*L|f+vl>Q`Lc>55c}(,Lb~MH)vE&~hvG9iGJG0F@}8^%T.rz0TRs1g5iEy/}8+nlhLHAHM3.W:~G8,3s(=G2$HX&P_H1n{@vuO,Z_4:beM$ftV,[4&wuP3vui^E]{iHs>>w0RF:iWX~`TcIL/[zBW+XM5NIyuecYg_S&u{Lwe(U?/,n;y,gu`8BADhV^4p2v>h9D4]]d/w)S@l1_,mxW(KM_6$h(|II2nn_}SkWQ=]|v<LULLn<Exq<2&lmf|DZ|/x<zxpzC*zXUieW`ivJA:,k#0!SDEyf~=BvBKO^gn!D9&=eg*scHD#u@%KcX*VRYXGAAB9^ScM_K<<~o<$h(uM(.8$L.+nL2ZMc8Mc!*[cdSi9mPDu^$=3("xEjJZZ>QvE[d9UZ%R3)j!WgZhva2Xk0R831a2VyFDx+eiQwC{RkLuk,T*&MmJ0jW_]mrhnAP]GqL%rrwP)LFYYB,e]{>(&>GWJkO_1g)HD4LKUt:tFlRQLQ=[SR.QSA4j.7fp!gV7FLf,<P}d.UIu#N&@T~`1d92ZmDvjCDGiF5RSzD8KTO0b`j2n51LYm"&TDwK0Suyu0"2j8;`2~1>vCshWz`:6DKWR_)l_;#d~#{n4p0oyjB<|?;@GujP<SHNQ=#t;a$H=:5TYAM7LJ2ORZC%RO>@.tVWsD&pxs=OVE2Ez.Cjv!UV}K5Fmy$df(p+XMik/_<j>>XV(w>!Q6TqW<.Ysy~4+!nhlSmWo^ZD3YVq2&ck]}bw[~8wfI[}[Zx44[578PPgOH6Y0DdDdvO5QH6Y0(d&YvO}So5qc,ZGNY3p&4vd`nUe5Q0GghxDnDJVkX8jdPP%+wb%BH]>PG6u)6.rQ}1>GJlQ@)WH`wD?w|EObdH=iv]cLF9aY2zVw0K7`OZ3Y)K*dvwT_ZODwZODw[mkR!LZx8S1cwB4LmS1ozrX|=0KUxGCO<@4Y0_^V(l8ceCbY|>*]u]!{a$eI%99o5j$n4ka^nqjMTRou05RXq?}b[aPm(jDO&q|F2w.iLhS4Q)*]fh(D|WPZzZ;|@c5/Bd]YvO*Gwcz/E5J5wy]#]*h}5`A7l#8:QahOiZv]_duF6$<|RPs9_4)rJ6CQc61a?Ta.rGd*CwshObFQ1#ulQ3e<w__6eIv3)|FJP>%w"_sS,?JRXf5Sg7g2n52bKfH9[woes{DaebKYTk1)f{+B):YiB`Y.jR^r^Xo{[2Hntr8[CJ/{3PBx.l<TC$eIJktSFa"3P+C#x;#j~1{jrZ&JfVL{a>_8x`*2[W&}6gj.q2@}%>&>e&9cpP@W#0I:w,.0Zn?<y@7{m.ohk.Bya#c>/?Qrw^XoN(S~.&/|u}r|?)HTD}c.XFKPcz,xl,ng6O_Li5,YF4RTr9Fm.#~._<tx=gn{`p9z+qXUZt?Sq@~dejv!%EBe:/G#}x@qA3*#@t7zU;ik>&{FxiVZ)F.2"rm.?tqe<qd601F}uK/0R1q:%lp9jP{?]P*loQCp<{W]hkpb]SM`z*!naxNIH9GBh.p78@B:8Pd[9%uI9:g^GT0*~*E*S8U!V!LKr[/W1PjVskwJI8Y/eavEi.h|+EPIC<v0.`Kv({4+g,k.9j7VT[~$2o`{"@KkG||:4,D~r{c2L``h][IYr9iZ9f$)kKWfM6"^8#jATHOlN3l:t1ca%Mn{^F7@ENEFyb+2"5#OXCoPPvg``0KY:%f)TX>[WF%)_Lf.Zq#lL[d4TdaC!9n:>*?*.2ZUrOefO5`f)l~8vy?F7*pdA9NLY9l{eI50Sk]~iib+qTJ6C{D"ysx2bYvWN@EtgOKA$vPAH91Y.vY0VfO5GGAPhm0O@bD]e9TYY7<0EGt66D1RT+V2zAe2Nb0GHaH"wooutzJbPaH5+]e6MYf2Y7mGQ3ZOq6nTJ{oAG"jyGSuU2R/Uk.!Xj%(2T!<;Tx#IFEb&AO$>k0U^*}5qSm>$Y.7g5S,!rmbFVc;eL245E6Ehg0l?O`%W+dbUbNDGl&/@OtLNU1k/DVlVDTL)WR?;$3I]U#n::6J:L_[xN,!;20kq=m8b1TvVQ^Iu|K;*"K7!Ln4bS3K[FsC06OjelQszUWMbS3Rbuy@8ldWc=IF9$OKp;6n59A)|Nd_&tb8[C}.o.=>rGSoGP]76*];v*0wc06fei.(tALGl;;t5nTerl`&o+mV43oozqOMI{{Msbf|>|:5|+EE!WSXQcE.QH!?XO54(8WjH.E>$^aDNnCSJvK$K%w:6#of<Q(q!7hNH&JNF:Y{*6Fjg)xU2.z;.FVG3av391><lcm+>7o{Vn?LrcU9!#KN0*9pk2.dUV6S}eUfUe;9.v/viX7bOKmx1KhPdhS9FL5/R"[2*`|CbPd=[N;d3rxcc(~Z?pGi}M;HscgTY=fgr8*..k1V6Esp>@%8,;(76|cyfi,Gre,Zm>pB9`c^V,<e{*Cy3Mu[K_#:mVETwvQxYH#fi<D{7KF75F)ry/bHSdRB`>fFI+9e(+m1DG9H9=;k{9?|npFwnu8QJmYHc]4PIz:aEc5s%4TqY+;cqmrkw4y3xpK8tC=~RWgw`}!j(b,,tYF9Q!nv;>=h$<^>zno+v)KY15[MnTxHsBx^hIz5XEI6$TrTg"Kqh#n0TBck?IuM7bHOM}2hNww49:dR+|VJS6ptP|Yut5P@&S2eqq<4L7Bc;Y$3?KGU{=7CMm]B]3N23voXUMpJTBnb9s5}:Z=`|1l0ScTnA"kVhM23wiM|U6Q|`S^yJ"Jy|@&(2_3)nd.ax,031yP#"04{WJoYYon++kH.wAVPfjqlYhJV?|8!A4NNJ7I|,&3nNMOG|^ljk9^zqQxeq|Av5Jup;JteqWTBt.c7q~C$#}#9:`0GQ>$!<|vmpw+Cq8cA=d$Q)ei,n?<*1QF=_*RFeLPTNPH3cHs[d~*E1[{WPC?&(icWyEJq@A,~lGtbg6#1)XH)B;*_lHqTg{"C*~.ZwHQ1GQgQi+WP|z;goYJ=B$aj$n?a|pZH_rB8X)i~DDju^{tupIk)@($@2;P|B@:(?[JF:[:i<,7pV{CB`S_D]J>P_WKX8BdMqRy([y5ncw|YIpFQ5~cu|KJ>avn!}!Hl>FU>{k;v|NJfT%1D?#}eK2L%<ffC_$b5`;@ap<XXtlreG(l[0TSgUww`6n0KI5+W<fZy5Ou^JCsU[C.vp|o~ChvC<5.)F=*d=bmjJd(XtI^nFYXRFLbLu2EXx>{1oDt>X*/7*>0,G8v[Co0L1hF4Dd%o5h;}l:|,&l~_3|#^}o}}nnZ5(UT6s{f.[@[&{O`^UbB(cDlEJl=:Lh_%.gYDOT_7hybxX%k4~W!gp*)G|p_=TOkQT`iqTAhWs~Cyf4&bE!vUN"Esk#}H/Y$5:4Hsu(kHx9X0r.ZLxp.q{,{a5^|u[=%@WwB:+@VVG%To[GQKSE[]Hqn(2l7~>3$fEI&~uK*wtg*S08d#twV)Ti}9U_Y#S:_0e)1%lM^I(WB)BQ66*ab.r?]*{@+ko40soY%D?lzD3897S^lEg]Vr%*sC3,=P:X+w`;Hr_a^{a;/l?bm~,Dgqr%#AGUkWhkh|8uD7DW=*|02CnH`3M*]9Qs&)s}*zlNGDO7c60f!Oul<K+#21mMgPEgFP(7@5.{ZcptlxBEccaM9o*QTIqJ7|[6=)r(2MbMR+E4D8UvX1UoCdIsNLwDP$Hj8$H}=Rk>Lj=>;Ph(JdgOq_=o}tM)uLoHF_8&`sf5_Se*`hC)oCj=]&]a4qrQ6V[kVv+kH4o&Ln.8DVX$D<"yDgFD6}6]YP>eh1tr>1owW!7e&*{J[SYTxw53YFeuOc@E4|S^eV(H~U6$7Cr!&+g|a5gkj:g+d(8uHheN.KxA[c6T6KD1b<[&g[xcYy=C~:/v&6Znn1av/;uqt<(}J,dzC%~$q%66p%`K9T,4ZXiA@Q()BuA#(JA"|qkK;0;32Khlc<e^pIHT+E1MK~C=Bo&JEa&vGc8N[mt5(Wp"7N[ot#(H,8etnL/OFJG,.cl4NrV?@WK[6k1DVNmW/wD!;ZjjWjnGTce+&[ww4!!372rbrL>sv9Jp0[Ov<8(*i*2{*}~y:xr(&,%G!H*y6x#1:0u_=_U~%[sa*&Emg7~O8T}d$uI8IdbgO,lCRISH^2oqb1.oD8SFro#9v>N5PZAtDeaJn{y|0TJ*r_lc}IO]cNkG|(5b<}7:*us3[%5+Pm1,kO[V}uoO$O}c.~Pt/Gnl]`KXU2]?WQfF2;;Jw%n>`&qh`OpU[fV11Gomi}$`*n{v*p_e6XQbjv&Qs=)g7<VUWz4h|e._(@H0_T;ggYY,T}6/)VI_JM(p~*/*fogO5X_a=%DK,"{WPOGoY!Jr_gL&u(6oQr;3N}bem5lTbwi9*HR@@F*ot"_d;JB+HFaKa#r2kb4d;??SvuigsT_4f58TCg41mgL&mh9~_h4a/d;4)|B>)Tntm&nY#?nk2Zc4/QS)=<E,VgiD1o;@(w#!x`gkJ6_RtDW/hH>=YJ|YSJa,I|s70V,iy%Q@isrVV!&SM}FBx,0FEA42)D.0voZXN"4AW=kYu?(ZL_q"K?t_L7Wh}ujc.OphFHv]LajqV=FBlml7X`8&/A]A&D05Iala?G6({$mA:eI|`B(#&t5#Q"W]s]n4sJcb/U"l*oYujFZRVBFqCT?jZhzdJ[BSi5YvznU+!uIhg}I@u:LkLPc6&;k^8lko5$j<$a~Nghmz=1>KJr.rMd%Rq{?%YJftsyr#{@]UE&J9D4n/eJ=?zHaTyKm(aKUz!|ZvO%_?MadL{<u}MyuccL[{><0Y>_o%3c)$In"T2Lo[[+J%,_/`iZ;9s>^mTw%s$4UfYmf&#r659wT>,[?(r~@P.p:FzDxGnk{{+6)"!pv9G.l.aw]g|O`Hq3Ny;QYL)#rCRo>hbEv^2<VEzTha1y/rYhVhlD5n)n?skb[B@uNK#vrKNV#5/@b7<^iL49/&f<XNK?J,ivT*a0Yi$5x{VYU(KR>t!ev>F?|).eTVEwIhHN{4tW|_Qp_DZR1n(,D32K>gCENyN3JvpPf]i3R!zlDk.(nz[_rSw_+y!eU&B13QQYj^UR=fmz[|6xfGVGd<l;1fs~}G*<*;$!B2jYxYg]}29hw:m^x:6kxrVU&a>:M+_](%u9JZ06KVZHQ~.4%gD&ooy[Z|04$oE358`ZHIFRxNCs(4ymyfsaGP7#<=N8_#:3[&i!a]+m{nTL@nLR5bc=M$;Fo8V0b$$NMqS:,a;>Ka^JQg.1&r2iSKBY+3&35hb}_p}tvFo]R5<j$gaehi)5(R5Y`Us*)#Wm/nSOF"Y8jI>1F!m+KCKaOjiOVwFK93r"E^?};a.?T8%OR2QNKtv?xnB3|E0dt^"FHuCSoWuEK[4cSEyHbZ9?hET:X0H>xuJU*7gi}+>&(3(f[$=|v!n{wi=mG[Yhy|HG+2)NQ"h(nRu5.Yv*)bUP9~!($hW1P~.4Gi=Fc5lf?o$<LpI9H8U]4:<b|7#H9[fx>UdKg(oraQ>op/oraa@t}la|4d[4u,pvPiO]9X#YSW&hoG&p2`p_VukH*9BVZ~th&Jl_}(=qGXsSkq=R?j8OuUr7d>;b=Z{LNU]][Clrs=oo]U8<eV=4/Xay[zeJnb[&q]S}qUcab#o$:+g*W+]o]7o[iDh3yt,,5Yh>`Wn<s_6I:t!6/TKlJE1uOe8EJ5;;<MHrR[.%/S6ajk`(X.rcs.*{whB9r9@r`tc]_9k#8eqgOB9E5{">^(qfxj:<^Xf0/Bb^pf9T[X9NT<%B;HUav=]=v<=xSD~G$pU]6<ngi=O+NC:7)a@v8*&e*QGn!&kEbM8M2Y5VGF)?s&H?wP8g*rO5_*E}=Zopt},](^Ye*EfjEo&ve((M4~BlV~C|!RCVW~N1Vv1$OwPIu]3`Hqgoll!aas8R1}ls5:g_5~B5;fY3pYF(74?yMonXxTMbR;Zwrr=(zpt`8E1/ao7!#alZ9&5;BB_zhFf*dc[`f)lFd~^%%Mdq3Yk&ZW7<d,5z<}m5a)K~Mp$!%]Up$hMp9xv4ncpbovb/D=FPuRR~E*U$E)Ay/ZuB<fXH+}BZOw$%^9cSu>yr[w,O|aMKDh#|N7P0pRyz5E:v=gKbb~EdIxwibi=;u1wl&mJ0%2A6g6pG9P"D/UP$%w;11`Kl"XE%TPLoC}4`hKVvz&$]#,hQ:u.sB|"{GR>_oSkOErOnr<da*y$hMOeuCn=s2AZhF^t%_|Q6l.I~BVtjhXXg1I.)k+hRN*B>)3_C^GOqtY&xCB!DaZ~HHMExr#{Gi>JQ>_DycA_?>nnC{PyV7xMyMict>{cm^#UME!6ZdQT18m;zl``Y_pR~zWe.6{9X#{HB`~."J*/oI|=&tmz]4"/!2&mr,7Xv>KEB:63Mxgm~7,[r:%mba^e^N?|ck]`m8(,u>PC6X0(6wf]AWjk}ete02i.Lnn*apY/pt+PnS3v}e~.4I)Gs%%p+0LjuKyJLkpRDt.n&2{VxjMl((EUgO(1[u,kr@_LM^O9=`drWyZT|27Nfdd(B&NDm{<"R8,T(Y(a<j3V5BTr&jb7Fm;zy4h#ZQ=4Heav|zCw=L.B1rrns.Bd!qpTjY)$cGvoI`n_Ul}HX5Vo~w0{BlFb]Nox,b:#t9qZ$Au3"eTdgJeHVkR0UEafXI?D4%rcA^J#Iacs1uNqDs>@;h?4Vo=EM^7!A2yUw3mw0Tmtp!S}2G}>L^@(8nm{(`(FM+/OvT],}iyTu"#<h%f[n2X$uIrK7"Xo%gq4qc~ix!|m>SUGlFc[`t(1VSseINijac$x>2~gnW0B`^,?20=5`x<xG]NzX(MCPr;M7iOh|T3vO8k[_8ii$Tuo|B+}4}ZBKWlnOI"o4i~`oG5"0?gS(pY?RQ@s=)pL~?a|gl4KMmg/;JI|B6a,5$3Nl`8C|WVPJ49Pn?TCunPf<)QxTZMRd7)Ve;gz=@{eMF(cyt]iIf/jV:=E%`)9ETYWMJ!ZU|(OuT`9`fLQ$"WjH4I]KpKLbxwqDbc[]rG|$6N_iqGc=3+j{.=qQ1`#Y%Kd<gB^:0*=x[Q.1[e1>6SjX8ZsE2gc7M$bA1BE!d}`&W^Md?{iN]$k^[50bebFJM8:da~d=zW7kd)`0}Fq#wQx?yFT<X24c~m|R#6S_+_i,kx2mIRVr!N_bJIp%(f[R3s2{jwOLl3NCxToo.FdOW5$V.?$x>V}Dh0rqn@Xd$U#0mL{Wx3?ywP:rsjCh]3Y6,"[1Inl)Fm2V{=;j&!9ZabYU*n>h[1/iC~ioJYc05;Ru5;UxY7+CdOx<SYC{,mhy|^rUg,iPpDP{ZHV|%wY}y(U6KG0Og%?PJ>Tl:^?4Qep2xxPtQWT()Q<8;+^rNI&nX=A*Dgs()51DTj)xs9@rmW(q[Z!R<x8UFKG>|LfZ(H#;^,FO3a=x/1&,!_,Q3!ZMPi(j5u5YJSJ(}c9;>?{O?/aSNbp`6b[s$qZ5(&`NSt#M7((s7:8~3a_#PnSYcrom2EWdk]P37d7W?=p_EsBNu=yFT/yG^e;4mze4O9F+D2:32Or?0dUN.Vdk^n87u7vxSdmJ08`w^S0WV/ZcFh]4+|VMOX;<Qnp:lEbxv`4]}B0cebN(q%gCwF2$>N$C0`m*x^qi!{@q>)j4h(n.X5PjeRkBX7v#cg1tCbuZ^1h`:5I?@?{r$l:Zl{l{d3oo*>pQ]$on(+(DIKq8~0!4]ISG^ES}d?ie5SN*AQP27p~{k8X"t:S9P,fsOuN+sT6T6[bVktgK2^<U.XU#]r1}ar~3xO1cvX[:@/0ubihx7u;Ds}x7T8[U!p<+m*/^;p2!RnQ27bU:;7o1+h66MkpWVLlT>l+xiABaF)1*m%,p+v!GlGs[*|nS=Ei)M{?[7jNz$!Y}#Xp,i=QRn&l9d#F.SaLead4YWdkU)ot)K>UE1y1fVVXd,w%X8(%i6"xiq~@uYbNE,`MC<)&;Ry%FzHQgQVc`(V|*gPjhg={AqCM2IuCnuH;}v_p.Q:ZG>9sTL*28:ab]m.&q9&bf4T@u5FvS}}mK5RkI?,v87L?@HTkXy!E{2;&%cYi`)n{_b>%^O*|*<b>SfX>H=#c%C2nAB=&buLkUJ*%L}?>V=NXx2yQO<5w{@mIH^EutS50`>59E25Db0u;SYP1B*P(6^`xVI#I0I&}@KBw<($9*7dLke@3;HC8~fB8,l=;rzS?l1Dk%GPzvTmj_a6`KT+2vovJUtf{o2K&/QE?dQs?Xo49Zm4]yGn.<^:2>f9k0(LK4Cx30~!vsK,8@Kl&EO!2TISJw5:*nc$=@0a{jRF)g(zzb>9:R!TI,LjBt8<)0P%?F_A7X$*]LTI9VUhqH#ng+7+)Ns?L:N}v`f_dzs@5k15mc6G,8aE/:w``If,bRy!k^}#Jj5{mHB+LlviX7{(xs@L1zglpz}>!{cOM@w&&{rnfafEW%PnQ+0RMm0=5LHKlN@_WJ&Wn_Gq56J+~a:?#oa&YJMUb&YCRIp+2WRvOBWO=if4T%OA/@Vxq8NT@@r9yoU[Y}`y&3w(_bgyrT_,&V29{4bb^t5>|Hg|&@#t;`fr;`fo5N=s`n#Kk>B`j,xHl~:_f{f)l~8?Sw;y2GVDeuliRk2:x/e%;+:*cHJ5w2Q1.]]8VXUP*Eh{rkj(6jm:,)]672ufHN}&:J,YLP{u#Eg7S/Fd,rVNa#WFMa3I82m3T<8HCN9Rz%ZpYHn1ok&"O%Sh@HJH;02JbRm/`)2GnfUcpL31T~0&1#}n#xP~|q{.c{1_|A7Dj"^6yhh>_#7Z>WnJ#!K+`>TA0xHIUd.4UNe4w<y"m|%b;ZjTn""[!QLE*@!TmFjT>":~`Ln9QQYSthU>l>8UD`(/hVOrv`Q+Oh5m2vEh<cdxbxTcNBsi.K_sgz<[{*f8A^7q*xoguRrbC0}RoLzQW&*)B9z;)a1]/@R8,8CZy!vW70`2L6u)Ez~6Rk^LMZX01V2ni]1)r2rx4kgY4uK{Ncmnd|frCz5*%RKyJ"yFdD=Vwyb*%OvmY6:G5K`dSh?fHdR#*X8Q`1r}*h7Wx%Pv_@8_?v+K|*p^q>r{_]V<!Gc0eJ[L2Jn6gKq)vj`5qsMBadeMaD]456Z2rE^)Q3T5JpLJZH[cl;q>Yk?N5:Wu>6r<s$rTTb~x+W[a>jfUO]`hHW6GZH[/[`SO50ct1.^gygvz!mx&+nEsUZmY]Eb|1sk`3k(b;GDx3A.o,02DS_+S2/Z)_JB~b|>2R6J50|>iV#qr`W&>q_l>Imv?gj&C=[NoxXJjsuo27M@O[X8`{^j>E{@B[fwLsc1Q1|K]HX}DLA9?z^GFJxqpkKkq<lFSr;2Ee>HdqZWc#h%ppsHc&iH|$}gKoHw047<YMSogILE|<KS1^!g[}t,l`$}b=zJj:wy.mLx(wXT).CGPkrY^[(E%fRPQ.xvsoTgX=+*qMISM_GD;ksTHwPYj^cy+.TodB"SZR|3]nrY;pG!E}D5#r4]#QFE!Wk37U0Y]q2Wq&ll<8MLuJ;*0@r<Jfz?f{{Dy$K[6oj.uz*kqiR}`S&3`?kf5?GT^)^]e;|K([`2VOa[uSC0!N(p0o12)p<g2<P#[or=&Ntvx2F2sR4l1!%}5=:maG5yTPV,a^Q?cl0Y1KR63Ya;fYspa5GxAy($y<68>*#?:.$UE.U/43A7KJ55LB[#97B$LqOg/np:"k5)((m3ep?gL29;K8<.&OI47Nt$wf<zP9n&PE_!*VEV/5[?DuTlu#}o/P}%H;l..b^S2J<3+qj8*VjV:z$8Fz4uU__{"^sH)Z;<Ya&PpjN3H[GK=z}66<+mGoJcN;|q]n,52s~;pfuwg>X5)pnH^.WM>n=vf3>f&2I%nNZ5^}Yy&.l8!Owm9$6,8]`<wV@xbZYvBcu~"}3Uy<g~zL*:Eyt&pE`"}~K6x+5bM7*j)y%)l4GHnInZa~o_Y+%_:j0v@qK{U;we.a5}Vvqt^i$,^[/i"%)Kj+9GJ]DWD=hmb+`w63,&M2Mh@b<ZYvk~*U.eRt<:EyE#IqC0meaULjh[{3u^bbcWY%>x*q83KI9usQIUNh#_.x:v+l|^6p/]sv[dD*_%")giM5)7VZW!21Ml=v1}#v[LwLXwZ8*+Nhuz`S_WH.;+L)SS!s/C4MnT;owrIoGX{Y$2Lo8a6=S&kB2q9WV3/et+_R)21^0YjvC>HM()^}B~5.g^?.{mBHrHiOt8Yvm2WLZ.1nvQJ#z.U4O3CVbUz$(c$WPoG,bdz!;KShz!]_D#OZcF8b12jbJTq#%g>JveFc"0;e68:TSM5PqdU.<da@o#8#FTSr||)].;LpIOXamQ=fXEZ&hb{6K:XCC9!7h/G!GmcNTqKTR>/OB`KSAqXY#Je7%*^]7R4:}]({lS#nNO7tGkv"gvkRk_D|hryrtsFaOON$L9)0c=nEKqQxr[G+BNUG<8P"cu)cRUu}l=%DB>*2Z!OX&uIIz*[DtiBiZTa9IQKR##]qgBm5GufG)X<DhWpXa/_2Bdz:?m~k$nOpT)7#zl>zM;e%K|5lOu|kx>dUE<F!N;R]6dzfW()/PH/&@S=k9Qdng7`xWw{x,QXyyf4p9>S7/)<L/WgZTh%6+(cU/.2Zxb]^%@8X35Q0W5)/FZ%Y?O_bM18`J4<RZ,X{{E{yVt2RL6x*|:Y%#kA}VlAU5fe3iYqlDe)N0v(/BeOG}8?zokvXcJ63E[#{fb+*.)@*x1Zaq5/DM%TfQbyo2.BCCW^lCWlP]5(:=77jgU"2a{r;&(xZAOBlo8.Pjh5?Dd,ZbKR0_68b<<zZF6im32H6zT`ixkoH,!8+LVbOXx[|qqTU+[#cJZ+YhQT8,2@|***q6wPp,qQZA/_3,[$]kQT3Sy.,u,26J,8GHSwrgvyu8B2jjy`H&0,aoPMj,&UY_4hx/R2U2&MM+acT^MLPzmIf0ul+N6E2FvjlCRu&9bO5oB%D~Y44FdrVfPl[8rA432%!OpR>Q!1Js*a.=8{Vk?))NkiD6Yz6MTX<PVKFZmHNeLuXs^8%FRncc[N@m7HgfV&Q#qK2]XrC1rjBY+!F1vafYmG2~O83L1i4$e8LpX.]`Hf;:+:ZS179K[.|k.Mo{VSb^Omv|4j&~3Mg/n[$Y:43k}~S{Mn.InOIAWilvLTYRT@54{.bg9&YSU6o0Opy5Z=&#7EKO^U97Zd(,{g:q~E~`:6%d>i[_|@sVh]oZVdCM`#`/:Wr~3?ci3KU?kZpF`9r8YyuOHAz4ug@hH=Q,r/`~[d.N[sW:|psQqXpE:|Z:N@fzUs5VS+Mk5xVB>^OsVxbtU:NCJ=<Dr8Ke.VwB}>5_zs.YGKgj]PXj7;)%yq0B(L~`fgB>%+__#,y&Bc5GBbDmt`94uy:;:(?8/tREoJ1EI$F<.&#:q8TJy>JS?KCu[Z3N>42bbF`n(W`J@`=T,:!wqSy+kwZ%:20*2K*^qjqqgGo=XNK|;z<MAdzchl9KropcK|/{2>)V!|1X.W.v0ZVZWG|@HmkQq+*2h]8k,Qkj&Ng:_Mf~g?b1,X$n8FeN`r^b>ISb&b=ib19eWEJRhF=iwO9o?12<~@z~tO_|q$?:.6$X%J9v}r;(mfi_mv1*+*jR(J9pih4F>rzTwv(6sR[,}U2:|%&,{9C7f@%x4f@gy7^@MW_OL0rDLV4N<hC<`c<UuDa.|.5L@YnNKAuJ/z%Q8CmHm;07G4P&0c;(?;4+Sm&Q(Y.M<W9O/(?t<|vNoJY^wdGDJtvnvq!*Jv2*_~Ur!*nab6G|$.@?KrRVfqWZn@_a<Mm`i%?g^302V!|leiEv|O<KW+m:s%2mPIS002`Jqr5t:|pQ8P8k5058hTorokWt>sOM32^_<t`02r:r0~`@[.*22n,uIH&`/uI*I;GkPFiNh]`@d]if5"/A`="~KOtmw@03&83^%Vwg6QIXNQDq?!mVw:|)$=M,,`<^dnpVV##<]L18uG>QU@CJ9Hu$.+FGd12y,u>I8r^p<zTz4N(s3"r=jyk}3E.{&2D`8Hr"8jqKKP6ENF6k.@sDsOp>fOp>#4k&~|?Be@_cNG/Ban!=i0rL`DqL`}b4Kd,=e%:6)ww0_6eHWT}02LloJ%PJS*sgGdN01#}*b"<$&_SxChmv|M(m(~,zs^Da7uDnUhqTUU|KcII;v3ev=QGDrZYDfdT^MXFuv9GC7qy|1%E_2Qp?O!F{gkqwN]+Q#q%aNZI|D+dA{V|[?"2@#O$Z3JyaJ4#sfLzL0kxd^1X2dsq5vr+ub6dn~PaCV/F6omo:Y_tK+bH:XVPnQSkZ.1Y|JqBEIB@MLU:d5+%?ox8FxzdS:?YXhuQ8I;&TqGX=NW?ME9YS6vvQPnfbY)K50=5}o,iLPLJx[(@^o^8<HA[[W:z;%kcl0:0T0@,Mh`D<E7wUkZ2`2kBft1];[CiG^4O_BLxzdfT4uWK?HKgRoEFyNzs__N#3{&7`SEGp]V({SS1uL))&|2a4js}To@pWYk11Jqr&,tQ!%Zm1)zvP:X%viIu/i"*vY?vgDbB*&0L$:$!Zu~PH;6,VoLvVaDn"0b4`FcKw>M={P:{gMagBxOv69.w;aC!*&phC5"^{.)/H(K^;@y0K:V(AcJu!z:n!7>kUswJ1n~NL#3:B<CdwrXIEGUh1ZK|;8QO(m"Q::V#k|pE0^Uvm4Hvn*nE?_2El;h|sm1=eF["Kz$q|uP:Ki._&mxTjgor])FR*JrH#vrtoJgCUN<mT&XJ{$gwIQSvB*VtDMHBZiYx%W)1h99uC}FPm?KMo=y0)mtT7}biE_X&vEH`haQv5L#Wrv:?$Qd$`Jc0CYqzIB~&j%_PiN:r&8Qmeb<zA;UXLw,=kwca#vX,R>[O*3ahUe:@1Q,i~k*:vEP`U_bbSg!G;*.6}kj<hrsJq+960GRk?a%M:hkfBs??q~~Z@5k.8o`=nO"d&wDN+ZJY}PNHT2YYqLj]VH<7DNGN1wGEe7(=qdyZwQb8THw?J%gN[E[>iA*MI_Jn<{,GKn_6o&7|~f:jWSx^8:}s]2<4~^<vn[#:/TmrUb$&9opd_C`8:)^Zp!b1)4frY~SZ]r#&h$77I(eqU=9}f0"VKT/0IY*Z%q8X%ZCPbhU;#uUt)~_8&!}P[#t;*#O_NMcg)l~8*@_8%cMaBsO:96qOT@KFuk?Iz9Prn:i&QL(I25zIJ^Fn8t_(iP?6[v+#(ZVX]C4Lqu!c>C%+PrTP&ZbXhz3fcX}OoJWJ*<+bp;7LmZxLTDG5K;:9B.vM,lEWNS,rS}``LgIrbbk4FxrxK+MmVETw9s%_6Yey3`(r//`+B~UM<Ly<r.z;dT.`>%]lj.?t9G?$AGv|*d5([wnNpy:BS!D#3br+IoE9w`mW0fmTN:@)gy(b#gw.YvBWH+p+pU/>,OIE{B)R.S3Lh/Yhz8.}G&G`p;PEEcNqD"A9V_otEX(IP#%gA^!i4X{C={7~~P6]te&A|lC)rWH<:SJ^jB3DZc&SkU*RJ]QxCs:4JO6JRn?ort[>JB_1@{>h.ZGTCG(lp|J59G4^U%ghey4yzYAqO=efxyMh`m2sI!Nq_i8.4+5&osCh+d;sXp3TdqI=)SZ<3@N=Gg)B_[V:jmSMG`s>]Or2t5X`Y0MavO1yI|"ZLw.Ky##92IaE_`,j^zc>xXOQ?d:cs>niIVDf[5tFc*MgPE%:2f%+HqmjJWP68m@dt0ZTo><x{{i}Nh".vE0aH^.j:#v0@$T,@Vqvtm.Ka^Iu@|gLUVkpGXrT/FC8u]nzW8THy?vKpId@v6zjwg^x%D0/=8)VPF`!sxSSMx2^c.@e,.%l__~v,_?>?,3sIH2IsNyFM#W;!?qcM*^R?pU(/w!>j{X/:<3Tz}Mi`6tKy{Ua4,age5WxX9|!oX|J4;aM;`tSBck[bVSK7]s>_lH#4aKd.It.dN+nv2<=[OFUc[^Lk[iQbf[{c(s^Py99Dhu[Y!^<ehp8Eq{nmIRk0o!CA)N>o^/Py})3n{MT+VW0viB&Nm5:,/&=@6R"pv/q*w|EZx}CbY&y~dIe(g4m5cEwKrFf%S[Gvp4Qz>{Rq#/FbLi"?j$Ar68FRt8MbBJoeu&"nL!+lleKc{xN{8#v9_Y:Zd/]&Z]Vnfgti#bzVkECQeO[6>eaGk}U23z]b>c8TOzUkNc@[#y}:yusQq1Z1caO8:xOXzK5/TUX`c4k1q+i7dX+^K<?AF2jf5O]@m%vHo27p%s=zoAO<URkHDblDnUmLaw}3F?CD6FaG!jOZx)5[6RPquOG.&K|aV{/73O]<18&9|0]_8gYi_oj44xxg1*Vl+=+uHGFofNO?)synfx9`VFeZ`uGuo!Xv?YeyZqx$HXajPi.KoLqZ%]2Y!wLg&e&f#i`5CNkG%n2]?{ilKd>6;GTc*e1RS`n.y8=/@*qJ#d;$NFy[Gf5mmtm>4>n(Qi/R*i6Wk?6hwp.4va*iAzWxpwQf2Ch;95$`][2D}.|D4hi5?Mb=0se?;yIWP[J?2|L*<nz"M}Zq5V7YHsVCb]|^RKH.3bX0&Pn#`W^J8~1^1SO&hg3G2YsDsY3vM;I3+6+*5Y0PwP3ux)o6M@rv`Yze/Pn&0/)CJ}M$b*[]Lo0wo&2N}~2bOYgT]q:<KxqQ@qFwg3N?$O{r9O5g>y2R&uRO3G%Y.VR1Y4"DrRVKs?3D48`xPvcw7[4b31qu_>xM$>4V$%rma5lH#w7%2t)BWWbC{C{"OR3VL!H.2a5oVBkG`akik.o67t.C`ld4:7u/Blr?8f>uVz$7[*<nTti3+%jsbzIKkG:&lTeF]~kI`>qG#IGfO[cObl@Zp8VLz9a]/k.>[g%M[{d8a?8+%39JTa1A6ef`fX8U0!vBzC+^RO0pUydz&c@gSZ,%rkxh:=iK{Rlu.6fT5&lz`1JBMQDmZe<!qg51ZvZl|{z^f9Q!s^N,gKMaN0?3,S17LG[v<e3$9iYctfIqWWIJCFeb%k./Sg<U9STYy[DV9odm,wTYpkFlB&us6U610S?cQIj42h%YrsEbBvongR}.Q8as[OMe._3_=g~b.&jkyCU=Ly<l.kVo[|}<lH#la%&]k`6xKDT(n;eotUzt)4CB*24p.zQm],u?`m9nZwz<B84X_xRE*l7(xwHJ%gf&$OkzTSD:2r<1[B#RNs:Zme@S8S6NK"IiVMx^}T]PsR[<^H,x{]w;j(gJ*%8>Hnv^Z$BQ3Ekja`n#{8w~^0pRd7on7a1$/4CT}%D&>`!^z/fbbr*slD!Xy8:6ZtaI{qLqu5VH6_oC]RTe)w%I0xz@m]K^Ee:*m0O^EC{F~#/s%YzKm`;:Q*b72<*beqWLP(5sz,iWx2xMvF)CqpR>!W%5Do[=gD4JqN,RI}yN,}8[n.0[[Hh.243|xxIrJ^`QaV0|oW5W%x;`5tk6H|Dxx%Gi0bJl:h)8#!]qYjoQFjc);k7GUCwCN7Ne{!{;v#m>XvEG|k/|>:EY;t7ehe!Yx$h;nTkFLQ7"^Pnxd}/ntNLl+GBQD"=xQx=v:+^.]%=vKjX8GpZPvNfMCowOc:by"1Wa4*h,^JEq}FE`#8"L`|hEMK02G1(MHdJ@tTq8MvDw)ZT1<11`6UY$Lx55X<,nUeVuIy)d;@(:Q^iMj58NY9]fwd;3AQ}4W9]?Y9]vwd;MBVf4F]i#a1xBcbSz~S/Q}.W9]AZ9]kB58o1d;GDVfjU$G&5ME;Bwn4[xd:CX)p4(T3e#DUM$[W)/*MqW5epbWb[2y;o.}(VL/5<i2gauD~y0*Q`={}N7aaMqM6Mj[DBFKnOaYU*x1DD$1@kX0vvV/9LADQ:L%&|8<y{y(QTBoNB<z*koI22CCpnc#cXw"QV[|I@;6%G=TZmJ5G[LZgml,?ZAP{,xEPToj~7b#*M{p)x^Z`N7NoE22p~1kLYh4JMqtlD<Q,rS!aPd(qBi`D?m.x|/p(1)V!=x=sRanwa(1`ST<jGsRy0NpQ*1A}N@,P:`A}nY*KB(1L@iB(1;@6B0O/*4sbS^pk4W%QB*/5=$t{@MGpRs[;,ru)7epzDuJi)oyupQg>{!=UpfETB5!z37NzWCti7S/q*2Gu7LC:"5WW|^X4IeR(m+OrBQ??hhQ(j.w;a>aDHB&?n@/`(!2eH3^6(qI0:/nPg9nuB,VSOPV/JnSuqkcLD^NcwA0q6X)t#RogLquld]Ol0cSMYYS2"M2v4UDh1}Y|$r#RoVJ*&{"=+:i"*^}Fj@V`Bqs}ziK:)/Qh|5eVNGBq!cu7N}^F%!,0;^JU3wpFJ[39t}k.kw_c"y//nyS8L$bR=PY}5AM.n}FP31K,?E1cdZwR6"<Kw:(9[t/U6FqfKfm?&+Q4EN?v_fv{@Bf@,fx,]Yf^w.n1ABc3LyG^B;[4!xd#<4EaDql]i"A:T=(sCGfq&ap]#^/Ta2[&ibD{P&x<EVf!zTGO)(jH+YG(1A[yC9Xro<fpRByb/5=~A&B94VU[4VUx/UMCwp:^hQTL[u2{@^kquCn=C(A]#ttB_mC7U.wILl3Hf!/yAdwrx/&r,u{y)5<sn~S?R=?`I|H1}7#!:vr?{/_y)Zs}B&)Fc7l%xy5anjxd;VeI_WfR:>Q/*tjz;nEk4?I!/8/9G;3n#Tx=NtRtj=*kqFX;QMqH4Sk{(#9]Nb4Txm.*xW3oncwj.@!!mr7/Ei7&WjvuLqa#iDulJ!<s.@GEi_g$2rvd,n{V}8]qSKk?SF5;S%xu*EE^iiR<K&oEe(?0U#d+rixa8`S~DdF"Bw!Tf(NJ)dZIIaC#twB&RF`m.<Zu[c`U!eml7Y+5jv(,K/w{$[k]l5oM<;2WJ1wh@{ibFFTz/8`2oDQ""7%F6nN(1dp6,nN(1dpcTB&Ah%G8=gCa;Hy_OtY`Iq#%Yw9ihnEhq#fF%2A*=/oj83EE*8wQY5IV"YOEoWtE6/E<c%pTP?Ro7p"+FmU0sBJLE&$tx4mqK}ZcCKxHFCcuDXA{lrq.?o}1=|Hc_CE2ub%U!,tMF<=WdP]FvT[TI`JH_9KX:9v6B1rY:#Rj|M(v3TX9er8W$@8~f)1<0gN0hq3B{}/+l,LJSY,XN8R:,gYnkUM~Y|o)Z~Nml2JI[oth?_"2=6Cl1w7NKH:Q5(d^e#LpG;olliMYAAAQYFAy"VBSwHHjS3ZtSnFKA>WLga3ww_MnG?c%*4ICAAAAAAABt?j6kAA_D`h.rK[];*D"Tc,^puxtL[T!IX~rU[s%=WhUCB,Oo@h&X[eO!iw5g/%<R7_rVw08"|Pf][X18Or0BPyo<^6{7kT92eR1M7E5~A4KpmL#tr~BU.S]?zD[aJJ~k<69q6iy%JV%LYj|p_&q2Eh!_P_=4gtkz,m8@1vdk6i{~5@;x2vx!.Li8MPJ5hkR;6yo8&3AsUlR0~#}_{@czy~Xo%D2W`W|d#?]&1l`i]WwI^h)od}wWZh+Vd$V6&SL%#[!$qF*1@.nOVd@:=y%wmI/pGuI8w|=pc2f%CwEk};jSCDo?7O8I3cD&{#8@A7;4<vQJ5D5"]&"bs@?!AcOg4Z)+|:zZPWA?`@(7W13aJ/A.I_f[R5t4+j}@/`&:C;h(N]fNOEnLt/xcc2>t@;~YpyB*kv#2!GP.EwEii]Aoi=bEG40xGN9IBqm)wXX=+TM]t&NfH<~YW0VyY;41qs?N?WE%eYfMm`&iGv2rp(^NfrYjK#/QI4uKPB=7}9qXnDIbeBUA}3l_(079ixOWR>Dh=rSNTO_h/f;iTr@D7LEF@P]sNkKC1;dvA^Uk+_&];6Jwhm|h8O0<v;7z;5=o4BM=<wNM*nwasav%9>[OaB2V$LD>oB@:Np_}{4byafEu6(3t^]`2%A{]m3hB=ud+U[3Kx]DO_dd5XmtJvh2J+[dW.DDeFbw3DI@S]M2:q#`lgJWK5N=2b62uo=Nx>pjLfZ%wUZOSx!"FxJf_;;89q9![6,L#3AQ=(yl;~Z22|]Ef8Jp[jWy5i6X7nK+OS]E8M/B)zw~4l>MR.Exn%nzIdHfz8,)]][r[RcpBflTVhoRsvz,XLxB+cg[H0=EzghS)^k/llwU:RfY6FxP;}2k/lFj|pQgvxv#]SPhu1=C@yc?%wRM_)vw(=V>=JW.tGQ_L*:pc`c[_.:s0F^l>X~]C:p<OghpGS28g~m,D}E5L5tYk[bXjt@D}0x|;Sk(K6:lq{:|NAwC5u0is0xi[rip,"xP605Iu=C>b}V(%yMyS0k+[+a$41|zBKgd1Uk}@?nss{^usJ%PX+(UwHR3?_`=7v{MH+YX;zOv|<rAE=VqFg0_Gbl]A=dbhN@TV_@ph)VrLhJ:fFaoNq3?GGiPrZX|J:=`E%BQ<0,9Ou@%=PmzcVx@$hRPLlEQuhl4EjpP"Z~>HX0`<qL3x<m#rq2Jz#1GbofN29%AOp}>Cx1MhrxTPZGXL;vP79excw0zkhsdVh=sFlB)SdyP.AD0q$zgIk;7Y@?DL>6`L^x@H?w1LW.b`a!|8"C!r?CpolIH]kL3JyyBcQYS89*s?jb_51xM)ZV1C4faw.fH%(WbWos9?/$3K?N=+CLG}wb7o^|I:0%=R*x&ELoeinok+3]Y$zSKa_UH8IF$qX}[jX5ZBY&3W0KX2y<e<MD6/O3q`BuMkt7<NCF@cKpC7<FL&UbVbFm0]OC$fAtK=8#HhgrShcqK>"bRiAmVcN_pHN.*n~&ZQC4f~*W&r)c]KhRl$Pw;1&&lRk9y,Lu;YL%8gB+#MfBxub:mIUsF2GD:H6Mnkz|sP"7W`S!_DaHf5yNG6u{EEIT#tUJ>qJ_4TxCar9Fu[f6jyz.n}IOn7GmbS@*$/::,]tH:`XhDMe&sfo;:uqN|BNp@D|xONpe[e$gyK|1a*ED=.|G0jNd::QxC,epFcUK)*@x+T[TyOB(X{cg$L!0TDrq^B^:!5O.IeQln<Gm+7^%;&mHgDvoU&<HZjK=.kiyB?fplv*`7XV^Dw,{/h,|UBu](&8@4P?_;XsZIhm_o3h~"A.^xLs^D5,7:Q{DaMpD"EOJ1%{y)8FwcrWauUbqU/%>Ma,RP0USY~:^tboW2.|f79Db<{A@_.m&[iz2V"OQs~:1{:/o9=peHanjfM{vvGB2pw5aH7}FIQjGa83+B[EW#uo1_+!L{1$lE+Sq/4p)TuS4#:qR*x1h|Nir/>B;~*&lxG]>/!,H5LoPGSL09sT("N{Yi(<MWVfs;VcJ,XHIfxs/b^N=ko{c"EGV&nk65bYydD3)S,`V>+oSP(bEcE]w5eu>BvK3ZoxLTxXJ3<2pjZM`OP*kj@Je#kNc.:LNZ#&`k^rb"?umi!6ajXy;VcDQf`_7H;6=^_6pre*iJdv^0gA+Da$|.sy=1G`*|(%{N|;pN{Hb+7_W2T4LBqLaJ/|kMRS3GX2WB}7CiI[|RK)Sc|U*D81oobB9"0u:b%>dcg_L~EXp>|h,JH"({+$q#xM|q^D$:2#1|VksU>IJ9@6[`/VG|[%rfiBU62N)/"X.<QamHn(v.k&|>!;,a.6=1}FF>O.v*QdOp.U+/aQ8V9V"X@>7(lH.u=Q~&_6;KRmCPv3@?WHfB1eLC+kXdBdv@VW~zg8v%BI2vQPsG)QI]QQCDz+rPV,|i9V3qo20mj{Z|LKs.H#vUg_Fu$oBS.5J`=PQX%@[A|%d54m=m{wnfv!IsCxVF=6y4oT5$YkLmxtug/<8I`vY4YkflR(vnreeMSy7X/}`+~<&{@`kA%m#.R+cwaXQ<(wZM]!nnn:9U+2M:,badya(M4O##{$G%G1nq"L;SZ{Hcv]zUE|%$<x]&}Dv"<VqTgN|8HX!HqIG2NN#,f`h:1&j3$X?*&]g,>C2sAo(.1a>%=~NMSSbh/TxG.(o]Md)yXEv:vGy!OdO@~IJ_7}g&m7k63Vpz@FM&@{U`<]QlM<65.^~338?&4ug<+nPub/@.[wrk(N?=XAzE>tAlbAZX1O,*[uDw{}v7U/6:vY.a0))A9BNWg%s2`q:qMLpI]]h{jmNchI_:SPk*URYI>YM&n1{o2$8=s`*k;Sj!sp/FQN8*~.kpptf}wH=@?2&6y1m9x:n~MYHe)X;rRMNL"S$Jz=OtebZg(Z91(<.Bz1n*%BqD@<=7LE4YNh@TZfZ"L6qLb%B2B!L_m$1]jmTF!e)+gL*eamZ7ad"Hl?Y,Yn)1HJWK@2JZ]5kry=Vv/IkhHPx55>:K#}(v?!$"L"#P.:xTV^,]?5g?g?mCE*[iLaPV:w8:X.v[8^qG<$6b6PfNw5z<(Ka8wKtWRnr+jMHEdf%nLuQqF1PA=#*JmgZV`&c=V7in57F)Tof?.*>9!!/EXIW<&/lX4n*owZSz+.h%BT+h]S=57[uA[:}O(zRc9B#r5}cSlIo7bD3OzizNTCZmK:70rpxbVdlz.nU=EiWvOA*ix^EYfSSB<#>$^/0~8<z|TqyJ|4P}D"HBt&mw/}nnwWnGP!glbM5EvYxy?oGPv[nz>`HLYttPbG)Zo10rE_;[o$k4e/DOP<r?ZV9FIa%+cILVd=L>gRbY{oYpOre"_IB>N,;V:`(Ku]eEx@cP7oD$VLaXer"<W~jC3ZS{#[(?,]v%/~#elG;[n&Mvi[8|/GH2U#s8,hlHZJ@<xyl_)QPh[}Y`{t513$0T]=5YIb%UhX4]4%8Ic+/$PRta3GPTbJ_bf8zYu_L9xpw@z"hH:UkUEv#B*,R9H%wt11jZ8~GVo4+ef9$h#Ul|WGw}e?.XHkfweL$x>M2fE+l#&,d=btsOZ|8)B;*1frH"w*.3"qmmo8z3Pz@5gWOCIm{;6G`/u16IujWbPcE^"Cuv.HVMCmz/36]|Ih:@pZ[Za1.~p7%@gL#&o(H*Q[$QZ#D/RZsz~:0"N]*c8Kekls}irsPIuZJ>6z/Rb)LucSMp8f/!i*^]Qc[[O:1RE}sd}1<5=]Tl24/++Ie*b%#5&lLF"&tg6:htHtl8ffc5MntDHp)8K{]FTR_S{5H$L*N6$P8{xKP/39zbLY4#o2!{O~"!kyDS/=[3y`N_4/%sU<<A8N<1<S]OoV==H~f]e7mEEe&|a7|og0w(U:wV.QY&|YVa93p#t=2JiyXTnZMN,o9yD"eZOD>[La#I)ucU]>^]$*J*f1jpc_M[vCNZfJ$WG^Q"<o<J`*%>zdFVu$eW!i6}6Pd}ssN5dxa/j#H![+tLP*tmx4AX:5Ce;iISmw>iKGjx#lL]f}0i/_L`Bu;ySDTHx{VO]S>eGbRdT.BhH/o%MVxVtH?$?>y~wnN&swwA8R!"[(q5:_}d/x34cl$iTsQ`}l~eCDn.+h@dE1zP%Sm"{|H{tFCm$N#X|SbQFGa,pS<"w6UWIDBx`W/DIgv`gJ3K|q_S]/sFA;G|msNSkyJ=;I1vB[]^EQPJr3<4*]EmGXkHEC"}S<oAQZI<s}}zr2`~!{?Qtn/9QrLc|G/,g/,p;a(gg&1)0"D=^4G@0:zXL%5=JH6,D?Ft*jT"8xKRiz=LH5%[jrT**B8jQC:}i>UuBP=(!Z8+(,j_rlIjFEMwVdj_le%ZT*E_x[D{2C0V+4Sr&.fEX=v|8c|1YW^iYdRizuHDV?:;T%q|bZ76Y<y"8_07KL@6J++)M&J>+]x4[Sm/W@l"0RbqKzcwb=z}iq@_i18=?}lR+]Bbh8mOu(anb6p`Hp&d(Q#KTa]iz2Z8VV!N@7HT1Y/LF6^8o#LyZp6N{)zE`8MO"_`OM=a$G|*v|G>]J|nNaHSds:kx){ki8Q+1R.JI^IryQ4QdGE#Mxs_3vg_{5ejp.hTj8RhfFvLr,9^.jg|QF{u~kXNqjU|ZURuB);QGjfLt,46/)*Cu+$rV"VLU5U2,fnv0PdOY0#h!)0D{|30IinKF9,/zqUyDbdq#D8c]b+@>;&TMV=7Mb,gSd,tK@3wDfj0oglAebT@^.nf+&_ptm#`]1;t~lV<(|Xoe/jJr:b%(<mkhG)I8NFHD94=#/#I?>X@>6`Ja9+@m|Jx5tl$yXggN#+87U}8ZikCE)i21Hx){M,hy:YH+nL!uS6omDT82]:5rj+0ji:$goXVD16@r/#ZN:s;h6O&bAu1rTGt.n~PD&C!AG/$n,jo#:.S9_EySDem?N)tnja]X/6"f(#>?RmHAuo~axLp6x3).is_dW1uA7W^vu_,+6B?P7q_|T&kaPm<_ug?%7T~ul&Y^*K%C2e%=l;gF?VIr#DvDps,^_&Q_R+f*jw%UI=r=s;&Y!C*Vum#;xBNFg6[$1_2e098l|0gG2/(DWZv]|s#x8#ex3EO)@FD{F;L5$I]@U3a~AoJqYNdDq$o_^U+:d:j!xo{D5^(HMQ]`#Tb[V/e4L>(~N%2OV^|MTB6;JI7grMGHG;G;ZV@L6bp*#saVTwEt2G_<dxs"|}bZD^;~.hIvnSnf}{q]VluGkdfAb}6vbDJi#PwweF]_j[&jjuATQH:m,Fw*z%|0Oag>Qi7CPDyc5pU3qMO,:J|!VOTg>;imP$V5c+zA4!imwd[.+H3xexX>UAc.nx9V[zz6Cm;hcc]4rdJ8z"|%$4uhr~Vqt^M?#z%F81cw8N{yORwc%Aq1B[piQ6z4S+}5;>bB!mG1WI3uYaLo*3`<oP"wDetfoFX|6QMp,?cIvl1jbr`k*7S~v54D,H*uFd(6WJ`E__y".[6FO|GgNvTf:)1M{[0Mnunk=,ty&]T4bM(PZfq]c$ZAZ+.R`HtXOKH_l<;vRCDMOUYE$cyCo9ZzL[L>*bHwr>V,q~Ow+j"Bq.0f:nNQ,k^CMOhr7&uo7f:^%D!0}Rza]v^C!A2sP?KXUPo.Pp{*YhryPq;_8G%22CE:qqx0E|Q.)TK!WCC3RCW]K$<H,m_a(.?azRuCn5+X99NXObaB/`W3q07$Ama/$FY`X;t|G9vlv^$F^dqGf"Iw<O?6+LG,DXm]Ua=|v[=fc,xI~/WW[o)Dvi>rX34*dALKc>1ht?s1ybYx{w{JLQDd~=_A`KH&66(<|9sL(*G9m+qw9D)icT=i.^iiQ?f|uC_{<fHG9o>T=c*U]p7sHXB/b@J=;4.#I!rsXeoyi;MxBVD;/2]k_/Z19x=MG+{xV*Erd%F$h?nTGt#KDY/lpFXclL3h{;MuR:Rq!Z?##!l(B}9<2mxzBAHa./dqa^|rc{Io=.q)Qm%4pizYTJ9JOOb6<d.0#rGto9#Z}$CXjwExDTu^pURJy16!Wux0M@Uw.9,)_1!OZ+b+][?d&;;u.(8<k1Xp&1fU1*Yowr;BX&:4/^GP}a7!{zIaSPZ#1T3@^=kXFo5`5sCqP(L;*vs#!)%(S9B_,oHt,BNF@i~smD;Oub?.jciH*E9b|z+zo~Xhq2bB)1)Ht}*wr1=Uwc)xj],ljlhNjL`q$NJ_@dr<~Sz?(UR+$zSs1s]!|#ZR|wXe:q4F`4bCoEzK@V?WhJDLeh]{0ZFyBTq*upaDv^M/pObbvuZy|NkYd"w+zmlLeVJNPNH"5wRv2H8dy^Un/0[3/k$mX/jV~HO?)ROq40Zix0=ip%OcLvmQqopo3}#2MrFu!9>X9&b173"c]sin#oBEKL;(OqM$apIqMG;UMRu&nqQ=i56roWlLH$v9`iaz_sO`%=$wdv/CmcuqK(y/T0wXxY%lFHnmt(d]ngQr5@j9&8z.s:NLK{sw]NTu3gw9TWdd_URmQfs[DK0{P`[bNB%nk5A.q^oq=D}q~gz#]J_L#GJsHcrh9/~NB8Q:+cN0VdjX+58G`fBY6o2OVfYGBS$!D/ls7[Z@uBpU.|trrv#n<gQ&~o.xpob?4Q#ZhPhu59ZLO07),+<ix);qk&xQPt[6konUh9Ej|yn{RqtJsLYH*}}{}$WqJd{z}]_Jz7GE}pS,!TO`|]bt?iWJO1t/F*cvmKBAn!tF`]cFwRw}pn>n;]$C9zK{sg8,8sq$K=;QS?7LkL&Ya?]$Tvw,#KC^ibNa.Vgs827>PKIhv=,oi~^,7G{xrRTL*<{2Q9H)hc`nJkU0V&YNC0~MN}v!E)Mf_$4>!zx@lZx>>"[6],ZOz?$eEw3L^K3:wU(siHB9%AED}(2emTIDs}O,MI#fVtU8;L7=%5:.AM/LXwiw])W5TVxSPQ:^fyg48[?u/oPF=nCU,6*u(cR!^1qx_)6d/w#p4+6RZB3`21g?SP[4x}jQNXv}He:k&9mJ`F+sKyk^u?b*+9[UT4e+FVRtY>m/IkG<ZXM5e2b9t?[jaq!vrR>{;iAVU0/<`s`&Y9I8l3Jf5]<{d{a):UlnHsg$5<S/;Z@+z7L9rt9DSYi>h,b_SMhjs7$5Ga=J_"M/6~fj8UEVyRFTW!,t_*(z]=_;.b0hJnUv|,Z95=aZ;}v>EAQ)]^YwIjKd;;~rjrG"SbarRrNILkc0maX(PrMMzs6`+yCTK5us%6xfJ7Gslv,bZ?IS;c]_XaNuEe5hcD2mP.M@W|AUBO#83yvC*+ctG`<;+"ng(JmQ&9dr[g}5#3|o<IX6J9`@_**(^F3ix+uu[cMcw#7_3gh+,@K3Z_3L!7jiTE&^P1B5kH@|0`7F2JO85Z7E|@`3H.IVzGL}LkkxM<:wFLK$>VOOh8_*o6D(`vv1wa~}TF5C4,GSFAy&?8PPCV>]I;=t>$[JJc@<;Rmc[aTO?e;/xaS.HrfV.=4c_20`/5YI1%3H5F;uhvq#epo7=T"@nAr5y?hO[?z=vPjaopkTM8)wiqT<9Xyym9d},"88W?/ZH}~+ze.x<j*(HndW8j!+&xLCt5dAnl2?I!l!4;yFHdsRh8DJ)p|3Y;{e4sE_p&>;oL58NVTf;!PS3Qj6vMwNS=YH8V6v`u8<FhRkGW&_W[&L+8x%jQc&07UFZIvKWzt&jkK{w<gAizcELhM!T6j_0ARN$nYj2Nra8;Z`FY~]:Vil2DA!+`h@WWQ"4aI9tws]HtkpRN_wz%Z8`DyLM&G]WehjUV?aH{~66e=R)#kwopgL/0v<@o~~?a0]pyniKFKu7sfMiF.dcq%Uv.2bhjFYM"ATfCAAvhHaAeThcjfSH?p.lzn+fIOy*ev4(:V:VZoTF^fQ`!2)0xZjvEwZoaafT"n`1e6p7(.mb%H:j%Bl{H``Xb#<sqRRuP6YnS(Oa8zfKvk8$]b9O2!AVX{`X/2Q?jkmp]fr@adyy3[hTCBV7ARFbqYR~7d*+|+2+rR"#wr_r;gKk+b,BxA)LVV&yGIrg498?oC2RL9.3[@##rBtMn[%RRCgzoj6Rk:zED?80,LXMV|U/U+^F+l4=LAGNk=P5V5?+?luC;*QPIT#T*<iXOp!t9?Hc5OV5:TkH,j64^P}fykjUS+{LUm}HC}XOg6|;_)7i2[7x`3XFoJnPrvaYscQ&^3JHv<OQc4=`Z4xpramfGM"@%%^3)<RLMm9|ZY_|*"(,>OP`qve8CLG%dsBRpjZmQO!ki}pSF9|I|8i3#E=V*r:0iGt}V~UtR(:Qxs7:eYLp3?<Z@8<.PJ_~ERr=v$QpvjB(hH8p5w"Hlco+QXE~>R}^O9uxM2!~RVBeea0R>rXi%nx53()#x~00cMfBsPnUM9h"nGKgsO[7j$>wBjKCTR,<6,*6zQ_3}4dgGri.zjCsFbZ&,eG7lvRQ9Pv6%}N!y.AFV=I41/^dS|10P.cMe+48}F~&L:4aOM=>5p8GQ1|,a@HY#iAhi&b1@s7k(h4%!05[ub0}W09K1KUG>Gu3AMSJJXd7ak}cA]&2NuRFZ&FRTlvVt;OUMG+~"y[FRN6dRLv86($2c@.#z#54rTid.d)}X*P#mu:o3FrkQE<ll5W[J!CNv|SBTUC[/2]b(z<S}ZNdPode)%<FPwqhNE8;iBNdd_f!{H;;plEdW86qYR<,+I1Kb^q4%12=TnzKPqB=54"TBNX)y+Q2a=l9!,uf?}Z6=f2M|Wx;Q_:e(Ki9&P47w:CkeEAB6#C^zJbS&V}6c[5W`KaK`?_,muSdX;mtFnP{ddc8_$?<sa{UI7z76DAcMcGl,`k#0O)eb,,Qd}z_gpkVjH1r*Ix301N@sl7+:4zoPurxl(uG;efU0HRG^*LJ?88ScKv{gzPB&Rg+k@ik.&{cAIi7^K,B{d/Fao$2MSFbNshLcU]VG6V:#]<7qwHWZprGMb$`Tdis/5dHL|6Ci@Dc`lc0lt8[6&rY`|oo)q;6Kwc.(t"|Dn$pL|X2Oii?omL_1+7`|Tur)HM|g15/|C*o=Hd`k4yxX$lbS{[O@oo0_5bW/NNS.1^.6h3Y"z`5`(BW`nYWdcMrsG2ii!M/BIBi2;19Rwq[qDXYnH(YjzV*P(LQSpg@*:jOdN@vBEk[*aKJCH}e(o"<I}amAp0$[S+dmlfsX}@t"[:y{b29,nM)4:mN}31%FPu1YaNY]R?P8yTu+>_U#{yI^^vz}|/,y.k`]KA1TQ1cn20K5qAZr,wD(>5`Fvb~~)tYhkW?.)Z*=aog~xDY?ttq`T#afQdiQ@=|lDNGV)#fo,x4s(y0Z*gI]N=YX1`ZOTx5w;opu/jA981iE%p?Mco+CrTPkB+)`#k"J{()u8%jS.GA2kRFB@Yk04Ac:cUX210Y_+UCy4e}~h*uK1H;;<]tB%h_$@{e>@{$;ji73*76U8}=)`B)f*>gL:x760_!3ZCOB1(Ip)1~"SZbM/@MJ4NS/|wV#4s+ip{$+U4N,^.mEr&taC*5`~1cBRFaEK<=`GI7vJEBI2So4PM!LS5%Q3gOyjf&[dAHTWif~^p=6:~F"M<wK.]R@u{CjD/b[W/QBG.lQ29G({fRazKg=vrz_E;ZtM;%`}`MJ=1%&qote^{+6,aa4,3nA.Q=y<MDHn,XN*A*{&{^;(jv*n]24#[C[JxV%+:rSo&OtWeCcpeUhAr2%3dYbv4L"xAR>{VR+~`liFYIw3o$F7P$r0Fg^2z*ZDNU{)9;UCM*}AR?U=SV1.MN+T_=e?8xT~yEd,8|Hzt2?p=z.kaMad3s:XjcbawG|g1=p;73NOS/cw4IjRY1LK]JUGS.iNtO3*Ou32M]*$/i^zNtpw7IsvJ34U0cYCm,Zz_9/fH9.acBZuHM(%GL~"<]kpwWdq4wbx]M`h!2enabcTsQ2(%nLTS(dtpNefC1K.#tE6/1|19^d9SsZW@84cIGlo3r/OAByqFdc6mk7Zjs,Gfk_q,Rq/VMCtgtW.STZT{}&CXV%(*)w#C16X}B5R+kohW4W5g__wa*tn:ex<`Tq$^pIyEVjCuN>W)~b1v,sabz](tOv?/9r{bX*Oer6[S@F(1A3P.ROYq/&FBhIpnHHk^]wdjDOXY[7O"6PSX=>^~0acT/kKCP4%(XcMVC]B6)~Tp60:0~!L:A?=hcC%v{j;>~#pRF=Pa1,hrT.3IfT~AS1i+<woy`6vj&Y?h[nXrX8ZOX*o1,B2$2f>g`$dgR:]~@%QpjpH/&XTogtDYo#BCyh`ujBCl4e0I;iaH%LpD0t95tC(4G=Dy)koaElj6,Cdyn:_fMXd7R{X[*Gc$Mn+!5SYEvU`mQab|7y[_>Va~&i_$iXx<a.M%Ot<oIh^^^`>E2gFoBd|R*"tnb{x0YPar1$L/prqMdE:|){B<hL09"w7e3Di9i.+?arfOPJ5x(Iq$(z?;;7Vo~"j=s_w|rDN2BJ1~tZ_|2$r?Na+9PE?.$W05i^:Q?NW8_>dRk/_$%r.wwTVWcBB4%yCk#oVT}<AmE65@Oy0P}A/CP#1/Y"J_(@OtZHzvU?5Zs(:Bxwq^dC+<<~}$$yJ])I[D{Zi]JL=kNfi1xVJx!wao/j%Qe@dCoGF8@+f]u==Q]S@oAD>>sQzQ5je[1f_.!rN"d7bVS_(PI(/6FteXsF_KCPsGb*H},gv[HPw=r;XlB]%##d$IGEtnu_baw~#Enr?b.%=0U?Kh2<Q&mOk|lw?c^_:$5tc9@SHBuGa1ooZw9F^QMc2&y+b[kdzhXWthr2Lxo,=&NIFEQe<e?;`>H@LfQYB!fQW;)im{=Z:(hgr/rBv9c|+K}$9Xynj(cR;Hs?p5.|)+/8~BudU%rj{K7kCt"db|Wl8Sz;S"Q5z)$#R.qk!`#_yk[B*uR2:.U`dZ+v[=gBj](2BnTP.@8>}`hRgYbu1rfB`]CeQX`UtiUYbx/wfaX1j.A%^XB~roki[^z!jXuaL%7wwg:*"?`IW[J#(L&UROA)~<(fj4}Yezu=$]EZ_IL&=<VL32Zf|J%kW~/A[DOxR]Z3D2`A$#3[Q`J|<Ue$n+SEhM3$K0Q1d?2:9]cnWT)*|)8a*Lh{oP<{y[bKxtAk8PQ!q[PjM:@(Ym:^=4bz28:tW*}Fq#D)<YC!I.r@w5f<GwDEfGCUrz(iB4:X5lanNIKaC/]d`S|NU_a9ci34!?*)6$Yb_qJ9(Sp;^AG/@[j.0^.h6*m?2&#w>MlqV)20|5KJgK=D"@RcIWTDK=CxbWiCq326#`&.:e`/hU97``*W3V&9R&id,Mp^<Fj=$r}N{urj*[Cr+z]C<ym#|cWHYF}WKc8eP&v~6^q[B{Oef?s_<xt.O[;Z#R7AD%J[w8<bH[7De~%"l#eRY|zK,f8&ia")]Uq*|m4>?;M;$*{E5J<79b&V<cd,}FwF;Qucgkc&)MnW=dM{T7pp8b2FGh|aJsewhp<_$#@aRbW35CkYpL,SH|,b>uz@>$hPnq|mHRb>R|D+Q|t4K&%B)gPWca}W0Tyk=*Ea(oKd[;@7>Ay|&GuHNl;M&y%_=JMtzNR.jx1Bj?c#dUg{r.9{}vfeTcKMVp_NcEWRicUdXdS}e[8^q]+d$l;=>5DIeaU|D/:rtaVgSoeATSXO]*T6j!s0cDvF619Jc_~v)gO9Bh|zwClM7%"8KQ%^RGd77j/]SrT/y}%|jK;Ddz`mDHe$)7}cO2dGv!u?@OCqSz|z4RM}tiSBsJ]<7C;(o&U4[fI;xXa,QZY6%1dQ79/*4i.9#%5:MR&eC%8Up%9nz{wYtY[ZkGL){<{{tCY4Un/;%,W9,XE6YTZHbwDEq8Ki1dinYjx]fF~0Eu1aYEm*4qp92IH_zc"i>pxu18m.bn/eNxzHie^@M9;yFs<mKiClsuHmX;VjB#nf&7Z,6YO)1)nips2XrWBg|<oLX/t0@*$b%$Mj*,Qd*vMTP>P##%jyRfM.v2xf7A[<9UB+([&kxX?<Lw|!K}S]XGkJ=}M.MG8!i{1XdGJ&2v>j33MWV?QuK],^%lB`K=C73Mos}>9uo:+/wD%zK@Dy2exlMx@6>N?8?t;/5T+!W<b#mY$"2&LgxR$}>^l<O/lA3I6,r#ax([SfPIQlGUV#hLmu$&3@!`z7C*6XzK.fD)w6}g256euk,Bugs+LoRKF%9cU"IZ%zE/BD0AYII_^Z2J31U*TuJ4>@WHv1W0n$MUdx1M}pa=]O!>1L9r=Hfz9P7*w[AfF6fGJ.PLKwX=,hS,9{!lKj/#kcGt,g^f@T:*fx}?}[y<msv1,`@TDouG>Alb,AF0#MOg24UST~dMQoE7Mld"Z3][Ix!=lvA@lqK402*H[Rw+{o^GOrA,M9mgF/FbLq{;NRv(:%]62U2EE:FW0|W{hi6MHs#k)LT`ZZJj4n33IcipUD_vA>zE=I:m/$>YA2bbDo.Q1+i}C3#ogIGzOJ8),~s2]}SN8hS"3}mvQ8iPoC)Z1ikyaI!:Y+=g`bVzxe8^&~dMy*T:h3a?(Y>d&cdWm**VK/UUuq=5R+feILytlg*".sq==~dh#^q2RO+_O|aZTjs<!sA"vrPV]Nh.|21>)2_NXPf7Z9!>Q056Z;?.Pg^mG.gr9M}VR}U[Ryyqi9+3tRy`KQ+Qrxt>KX(b~vKRwsaI>NH8h%;3%g_}[SdYL8VktgT/?km?>%#OC/038w;_BgXPG(H6lCV=1T,>UeR[:CYWd~1c~f;*j+aJ;1_k?HGD{n(f+z.n!(z~geilP8TLO{O0ncD8|gO@;mfGiv7Vl%G"c8@5i()Le?z5w%VAc<2&OzjXL.lCJ6D`b/EH7HS:cz:J`Njk>wX`C@q^((VPpacV6J8{lWpqEpw?614(7{DzY>y6Fl0|`.<@6nseV(u"D3cssn@/t#}]EfB:DfNS",Kfl9KzKG5!AI,(~|._LTqJ&wFT<z_QMX=*_uD|dv]Z`}.WpkH]{=OPG$JW4(;[t%0f+b28g2L[[dh"IB!gwoyRIZl(*(#EHJV4WvuL<RnWnq02fW}X~nR#j,i`{@HSTfX;ghWZ4bu$1r.9@&eZc*;ChdJhNv}h8Ud9~v/r:q|/YaFa|?Qajmq[BEM$toUW?+V]G;Uwwq^Fei]t0g7`74,A*.vx7D()*ib|J%5YMbX3?>2MX4[PR0I{u[%6[@BdFu_sI7!cGUD7oe4;^dk,qw5<SAGB5]YxxjT&9|PkH.}Uz2,?L[{Xg[m}5u%+loDf__(V<"WkK*9bSg:NR6u+:c93(Pe[o`yQ&26S)SDD=F0!eH9o`}4Tl13c>K1}Jkw&nv)EJ)GP&nSJmf}Yib7<uK2A1j>gVw1Fo^/TiZz4;O*<cNHEvJ8D!"[O_=Jhnl=2h5tF8I_f2:N,M9?gNJO&$G#}AF0zkyqB^9L@imLD%22:8sS:y[*uAa_uc5_.P"9v_V]VANW(%jiiK}M@WS?<P^:MD>M*`t+*t/*lhi^Y6O]FfSX4VJc{k5v@O#t5mcaEst}&@c~@A"#^Lz*3EN#[bvd[8xL_|dGKP.4Pki8Qly&ybv5*e#1o72QxbK9mT/%aKn,YOaZT$QmleaLM&fjlbfD,jB(Vh>SVp(lsMLE%Pg5CR_D7a<4=JjiQltcB_2J}82Ga!~4LTS<l]>1RqdIUqKpK&V3}}Ocu>B#sIlHY7E(>H|n&s]u2GBW=]/mxaM~{1f%,sW_tF>{iZ$<?Z,$[u#0!vydT7}9nH0tXM/pr]P?npn3~@e$d~*@|R?#=yWxf4hFBAzRbYZ+LJ!iwF&3Ng)&/GGny}lt#C2k2&EY,f`hLU0t,$~!>8VenB!d#[4m`WT<J?s@p*O*Y[>_442pr3YtZH[Le<9fbT3^7HbZGFKlGF<PGBv`jO4Bev=[S{E%&qgRkMTto_I~k[.eIa5Ih]=z#|(Mi<W+;y}64635gB^+62V;@T<"DQyvdp4u=D3E0Un2p)e|[>BfS=.vys9FgQi{!*5Hh?Vwo(q&Yy&*a]&kt)pa9;LPCHMnhn;|,G3#~MeHX(Kb@H3Qy3CVnY8u$)T:J]{zQ5u&LEp!v"*vVzlc$Fe03uj=&OeNq4*TU>W?9/GWTn1O^Po>E7rsMdq1w49i]pMZb1QMAyff|X+fc58u1F^CwFWfYYLkQu3".0EB0n*9P"GTIJny8OK;GPM^fd|}}P0A^htToRz|j7UJiRdc,3$7_.kMi)P.yry_/w?Rq|;uS;J{C^uw&Q?,9hq3z9ttic8Z,bb82qntz:/>L:1)K<:!(m7@RE>v2gUbUmEef7cb>X]dB~^yV:,qs?^1Q!]H=$oD<";e;Ap_+az3.?#S[CBG_He*yy:5aklDy<J#Qr+1yBo4.;1FSKvBmUsqx~M}_3:R"$;sAe94f@]kU}=/Wp&J/X70PjeR_Fyw{WE9wXa_(jU,2|dFRp8N:M/Q_enr|vU@T5YxoR@|<yZ#|7V_LN:?GACbT"!.I=pz6Kn.6M^K=;TAE?%yZ`=X5aDrpG_FzbvsYMZ>F#E(KI5~z%q)FJ}_u!VcNcZ(aC8@IZZOWHc3$=(noZV^moU%wN]#)c.`oX&M4,oC]*_(o_)/{5E@SDk~"N.T5OoGDy2w*x6XC>aEL9r~fm:_"Q::1Q=hiL_RNDS>Q)cD4AgLf^~`CQHOwiNEda{*`^XgotjK,Wx+^rvZtU69xTTzhf<ziM`WW&)p_^u~Ynjx9JS&7,9.G=hR@Xs{WXCbAt(_6GS,[H|ErLx<BYLg)1"Wv.nbg4;Zakqf4CEdV=<=f;4K86F|G!`pKL/N_JaofZJtHrmGz1/$:KNQX&G""$89PnsKPMGT,=JfEuB03heMrDGnt[SM,~eYknunB78k^Jj.[{D?onf+1xmcO*cX^GzxqQBg[[Qu:.oiZC5{Sq/;mgsecVr8SNj@mc=1EUW:;f_T+M]e"?$oB@@w{`!+L[!TpC1nZ<!{>j0JID+dl~HxUEqHz~qy0ws/X!vRqty/8xt_%Ov*,*"oEpo;fOo`^,2E?Hwe6=J=dJJ>9n8a)n4G=Hx,m8|X*Rfgq<e8ED]Oy%Zl`W~W$aic/"?=R@|0enOP(d1U!/wDP;7u7M[6Wp~6Mfi0Rv0wd6q+eh<]}nJ/DW)y@&^35Zb%Xf1&#[9[kwbO4?DK#DlueOMy38RiJ{#G=BcXpzo+LI&CW{Z2JGY_Wc/u|L_j{;|Qo,22~rFM`I.N5`.QHrQ.|(Wn+T<.KH2D*u3$]toi[vh$Hf616Oe!:S$Y+<650%@xPb+ZK:`]Dzhls)y{~A?<CPN%FwzT;D_`XORf&TG8T5)3Wawul@#M[zo+7<*VQ}]t,Ptu!,616#BP^58cgwu9@(w#I_s{tjG>,>I`coUI5x#,p{$u~qZGAsb(8G_uQJ>/?K|0WtUK}]wu1se!vvR_`*86~Y0pClpxQ~W<uI6`fV1Okdek&V_9N=`uop=7(vNO]2.Z22g_tRtk_[O$T5V!06])L/SWmQ*M5;*iFK7nh#$&O:0OUlaCG,YUHM>eJnt?;f8!aS/,QJN1{EYf%%6y>ig32:LXZg<+64;QrK#q}H//)["c40P+9EgGRGnTF#O65_1|"]iM]1Ny`dXJ/i:X2+Dr8=rduPbUq8o0X=GRLaR;MIaGXDcP`H!H.iTqe[Y!Tx!zO<]T4SQx#XDNsd4v7SWtIx6!|=qRw+5&QcV910Vqw1[lLjfuF;VJT2r)o)Wp]7nlrGaIE<F)xPS|kUKFnx4.[+S$7d5v`P:J"}P<3+4c4^4oYpa`GFEp=QfgzS]/eXcX]p$Dx[gmwF3d[n=cIXo!XyyHC51,mEtNiP;*iT>@kDC8+ecNaVCG2#WjQqr,Toz#"xO6%$Hn`nDl>_@!oLkg7cgahDAU][Ep0zFs1#{cr[_Y[g@!+K|<wzh>{e}Rmky%fe1p![=uq,u~HPD8Aw#vvOj79`JL=qSoGs~MB7]68TiOXUBc6JU;6TGv*f#SJhNA8XR2k`j}8P>0g18[|[$Y_,b3={bD[tx_gt{S4Dy7QpslaWAKaJ|SFxC;x=t53]rKhZZ`QU._+Rl2!mw^(mM7*tj?|Nh.kygkM&F3*^!f,:%=,@n/mVWN"<GeD3bjm0&`bWzon84BnJytk=TJYcQ`0Z4J}n4Lntk/:jS?5Wj[o#zE/ZlN/9>gnXYa1tefZo$Fu7i_KCeq_k<y31vtjQ,ylz!Gx3P].|@=L?<^+rBY7BGbHdOnMlXzFt<`mCLHj0abQy?TMRg8bQTQTO"$*;j_GA`56GzL$p$I,&f:wn4R0@>_H&!XF9~I^C7i>6nHk7twkOd.4u6domCF"Bu!mdZ{(oa7C8]#6IdhDZXToBpauFXjOKNG5gR44KTO0YYMM1H[Mdk<ea2<nHeP!O~y(HpcJHBZkRX|CZ@u0f)E6z#(<u>X(QD[CCctt=o1dlOx*ZJ$v>#vCnr{dl}Dny$Q9)[U]q3]#oBF_2cH~`FFBma+M7d>e^v$U+H"uo_i+j/jVVtL:AiX`N>PhMrZIT2UOzm0:pd|+gGY3xPiy]5?7ag/VjK06N#14z~WT@~NQQ)g;MCWdDd$8G(B50Dy)I+n:U2Kxh?0I^"l~P;/G^.w=JT[ALE{!P@4&q9v}OtF$[Vylr%#]Z~39SOaDSdUt#qx)z[nJglt!TGRJReXWq/4"pNPmc?b?P28CAfr"[ol[(eL("GI](1RYx]CHWp@ZZXJJQ"]28"ngYQJaBiq(FA@tqY*$+gpu~M5ON1/6f%T|CgzT&8mF2gC!;F%PD~}LnO]_l"3?IkJfBZFLH2_TgoKomjiKX+U3BoWlgfZ9I9u{cW[xE3:.4NFXb.kz,hjHCQ0[d8+auL%cyY"!sgV#]Hc,UnpN2&38~7^/dib!U34|#R:Xqs}FLSo/h1lUXYF1r"Mp[XVWaNeCl2F~Tde5VN.WD7k+z&Lks(/"9]qP7Z$2j8o5btf8HAtDs<;{X:cPbPd&AG|OSy3fw]?skWv;^0nVr%n]5Z`daQ%%_xj^)rT^^S1v~}?/Gh`#;"%L:h/uEM4p9qxV=Df|?yO!GR32>e?(]l~j[5u|i$CGC~^`QlC^QFS.W,s3/n~;6AkZaoetpoym!%IF3}LYtE].m<tEQ8!/T^WO#^uK)i|_<A$aiDHias7_$M&u`a&je&r]TQ*}Rcv>Qf;}*jsK5dj0f|}S6vA*q9@v"HarJMCF!}u;8`$sagsTkr)m52%=m`~u(.p7N:D!qfw&aQYjdR>Anpa?TQ%$3xo@.kpx2CafT75%fi~P$b%+vn%AN9{087)k&3)#}y3n_HsAxV{Y$ZNkX/a+_bT%NaMKYJ:{;+Ci^[wU.Xvr}3)WgK&ci#E*3ySY?+i}YA*Jbv~<:??RP9_&I*aNNZUcaTGd^OQMB"mbuDp!pl~EZGHrur4PK%C?Ns*&m.xz=jv](00=:DJw7Wch~Oqb[:3)SA{~GbC}P2h#g@_H.u]EAT%T5Z:a+j*L`Xg[ZhkYuL#^/pTvFWIQO4(+1((PPr6;}_R}P97OQ6VtXOEI1{1U]G5gRjv83[Z+oFOJ}U~uCVV?0|)&z[X=D7R+o7e:57Dml/t.Jj#4xZv@6;~q8;puhA>{]QT#L",KJhZ^Yy[PD:T0Fk]x^jo>Z^V"ps`hW/~aT+#`;,|,&{hTeGXiV1R`k68IRFZPkZ|)*<&sb/@lh%]r[54:uV/>#AL_BQCDNKFAFc{36|Pj31/wxx*BRNfV{C53Opa1DrZTxr%3R_h62L](:X[kHJtPXmChRZ{K&~~iu>+&`$hL+]4#cICAH2"5_,%lO975q|Y>%Hlh7G/pgD6@f.?Dpy[b&0sho,K#CD0_LfQuQr~p1bEM(Vrf&7}BE6:Ye_VP7MB5~H%O3gpcED5I,rEH/6)XA^5Z7z)xYE^raekj=o@`B@S[7b{evDo09_iD)`haSAk1D#>.(#X`S@0~{&li1!ewy?fpJ{;Z!i)!<#81T0M@/#Cizh%t0pp:b^U_cQ?HXV/ZeKzq}e<l?7yfSK%7EF4]:Zk+knUD|"%g|1s;$<h}?s?!v_oJPjN1S=Fv,Mex7QIJ(UhAA79HD]b*/qzUb"m`FS&!(^9EA?i}6b4Z8bm3Yt~d`/KlVh/V3815BSax"Z76,.zM#f"t_E)uZyO_&~kovv%:p*Efyzj5SGZdZvM|^kKTZf.YN90ieeHYs2b/uQ2AHH0L6,8Wpo[b)WB(("Al52X<uc]aAgN{=&|Rs~m)w2?Ky)$b%jc~s`{AG0O(@6~+6[mJYzg*cjWuwS6w1{42jc1}rY#[@j/_EwWqZdrnWK[*Fu]w,67.25EA6JSZIVr*}^`c%I:IYu}myrB49k5JHx[EIq^0xfl4$3@YV*ycrU+JuyMKsE2>P!n{DRQnUU2MD(X9Vlc~B[3W]baP!6wIf6X!akG%(?xdJ^N4Izl8PXgR#_+[1;.IM*jbRP%z`F>O#!c?QPq!UB{PqJvGGrPq`pfFWFv_|r(;:):36zfJ)QU%=)$23*X(d+XUW!7ihT$UT9P_r__,sN%n+&{>fbk=x]17$%Z?zJ#aho#TF@qj</Y?5K`z]{(ujp4y<@94Iz0SY:1HE+NoXDW,)P!svl]#ilLP#&Rq&Qyd8Ue}28bVa(y#E0j}UXqOMR>cT2q;xWGRM,n&B;]VfCVp!`U#jG2]ssJtq#a,$q]%9e~qr{gg@gSI7<17!KrxyX.0q=U([x~};aQw6uHOCwou##t=uzg3mqHx]2/25!_d3LEmczaDIAb,{36Q?2h#$6?NU~Ci/+?$MT%N#HrwJal1#7x@{Pg:Y47es1rbJA#00*@K]c{Q^c{W470,%O|Q!9y2<hL#v9C]rIV3H_wxTreHr^<Q:tFB/9ck0I{]_{;Lwsrct_s<s[n,)J$."+},QC*a[ZdHDO,E4wa/KNC]R4isAfC24juX>;"&NFIcx+wClK/KU&A^%[uH..l[vL()JrqEI02C80qWvyLL7+J,MSMiCxW%**s_N.PV>D6K@Pd;pT;"OxtCiVr_D4xod<=.pSh=gHHN&qK+EV+DL8PlkWDx+7`baUM6G05v~9:*%E*`f8rX:`Fs,v2k/0s$;IG;}]#Fu9RCge#S`LgSRc(qGl/OKjt6!+R4!aJHz{VMhRq@{{aBb42bSwr3VrN>q,Xyxc/!^vSa}%o%*@`w/rF>.c{&i)+xd:LQr4p35ne?Mvyb9$3msIp:8#"buyrkpBz#MyY[i.g"CbBu#8U{>ITtA1OL29E"K2691%&7.LmBtuPq`D2N$e(/m;MUHWy)U@@ZjYsI=$y>tV1WU7@BJQBun$=+%7UC(&5uxqR5y?}=UC`$32RXunCBN:pr]x2<**mcJYyKtIms?/}:~8%3nuw]JEo(l.&AE=r?8<ldnsSWuL7L!;o~Mq6Y703R$#=W(R~#/H5m7t{>dpP=S3Lk|M{FA=`c<S{_v,pOC1p8,c{M~;hY~F.)h@<xT(C60bE23d::}/g^uP41YJ#HP?!l.voFN!?8Jr~qX?Fz2{r8xA+/6e&UP{ifA2+96B@<K+eBrC]:7+?@3,FBLw3Ts1TTyb?rG1$5q9eY1}|Umi6"fN7*.QZC~4fg`pttJFHSbACIy0W%?ut#^%eYpPUj?FhH(g4a/yL5|>6uNr.=<WhN}HbxBZj`u&IxQis`oa0uQC}1jx#H{#:|6.T,G|)fSiEup#6Og,zYmDt4sX@>+,gv8=9VOiJCVw>HUXLIqTC5[A4=LcqQjM/vop(MKK_C2O#o%A[&#RVFIf+0t0Mc0K)e.4Jg:Iz[mGG;Z,o$2M!gg:iq_5O1.]2O6<0I=B."_~p83&zT$Ip}K)@rrr7$],fc4@Q<qXg~TE0oRAwH2Vq2*vL;VaGZR5bv|.j6<[,;/^WyH8.8,@K(2IMRDElg@K@:)Z:Ik6cr3.2q96H8"o8E/t8&Yu&kR%ls(%_SU=Q)sob*K=yw%)?QmbhdD+p9kNdtfcXmy)sc8G/:]u:;G8]Vn%:(ZB<A{f`c?Csa=]IqYG^q^M,c(9*}"V{!wNgZ@R!!*Ne6mHZUI+~Z4l>z+0%j^gWx}"}n=C}F9{qcg~Kt&+vo/~r:S<DsV|Af$[)3pe?wO)/!9A^)$:.XuLhJ53/2.qK^1VcW/TXy(n5v?(JNBBp>9V`EoZ@2ZdP",29P^4u&XTisRuP"J[<~l]X[c"XY~*_)NM|p*`}^N+y4%T|:<<5SYTlhDS)Zrf]mI#TVjh^kwU*=uo@HU|G{@"!1<q>CgM#nIcFa}#Vll2ig@MMPx!D@%l*5=Wec8e*.oI>he0L>t@MoRQE4FL~IoQ"g]#e3>Gsk*E+4@`=/JgjRw7(KH)_;uzB;xs,nK~`HdBqobe>WJWpE8}Ug|G(5kpAVy+a+)>99wllJ/+v7SwN9}~e|ysl`955)YcV2%mWx2bl&4ZD{#:$CxY@6!JLFQM{`%fJ]n)i`3p{0*%2,gDa:m+|s0H7}{1}T(_}=Whw4[Hu6apW$|}*n*BZpOuGJo8b.WDeBL7GxwIbonjt(r1/MBV8szL#YgoGp=:OII?_HNG[QgkpUK5cM,7;}{9U]Q:$orDKS5s*o/x++^f>|4MYp%7+cyNv7J@;r:+WL"NV/U/_q+qF*?.$z*b.sYp6?Rb9F&Y?N:^d^ks+@EJzzgfr2SZ+iuZvOR(`bUH*rIiuhMtS&_g_Rvp$8R)Y{9cRZ@QzzUP3R7zv+/xON7i:s@W248m*Nk4v"SnrYZydOj)$zP@>RieX:G}*g:pdwV6h?#<[.e<w,IOpj<B_`F33;o#~LS5.{Wrn"*<{a.[jg>$d>oW$4,Ol.q#D:bDE06WF+p(1if4&^02KKM<=B<RDr$lh@x[oWzM;rEQ#O@c}dDDkdU;cUYO8Z]M1l1}SK9~["a}?{4xL(}QFpsG$&XBOp@(&F<|uo1CIoT,X2%{rijCHdM;yw3/VkgwrYeJ;hGhJ:Z2nfZakOU][!Muuu5NQSE}[4})e,jk7EmeNmAJ$9fPlKv?6i~rl7qVuEd:+!I15pX?}ZSk?sL_HTTyI=IJuAM>/#4eOIo}:%iZ}=l?Qnt[Vi}SonMiEGS1w@BTW*$`7^Y{DLU/F"@mYx[`[7m+4IG7?!r|*j=_]@vqTx6707t|b``v=*{oi3yR{%i~GgDfBL_M:j|+UT+ry^4VZl3So,{_)Wxm;O,3kRZp~l^?Ugt4yMxQ/]b0=%D4>}0!KK^AsEC>?:|v0fkL{WE,COc~pL>r<Ler3_!a^ka%%lalKu1%J+`<(|6&dqZRL`B:!;Y(>#gF$Vjsyy(eNN^OFm@]<zI9g3:,3"|h%[(CaVxpwml!c68rvk`!5jeSxA>Ui:R8vOb=._HY?~wsf6Q6|(Uf;jQmr^Bg!79L!*`:2IL`|D(I!$UV6%]O!kpOZ[6p9!>U^Wlj4dopB]uDvPdtIuHhlx;*~^F[Hh<8H2Oj$8~qb`h&4_Jb>9=S9|t.4M4M`[3g.,!nN05RHuL|C$!4W[*XplnHwMQV/b{;P!="$Y%M+A$*D)w,BH29HWe:Acg.>1OGYB:FN?pA^aZ0Gh@QD%`k6PP}b<lK}aC.$G@mjS@3i?06P492)EQdgG3gwzx?%/I6F=CxA^FFwVEVk~Kj)@Z)10K6|_K85o5@Fm9]eW72vcy>+O|*{5z^l1D.x%auiXn#>3OjwwH^y,HUvG>"gSpQ|pBWx0/W,&T:Qp~r~o3XtXl@lO/%a0=8i#>Z:AFTg3|Zx>Mr.rRx@h<Z5LevV<oOLu?ERJ#&FHxakd9v8cuO+9GTd.C"J9BQj+Ri4M1DMjnDri_s_oWlx#dRo"?DP@6qh(%pw*5Nce>4ODk&^/>hzsn8U}Pku[`Xq{,L0"d9F?dt+DNlwD&0hA~!n!L{Q6BAzuQp>"l7_ZobX|X#c#O6LwObWc1hE?{3kv_SzYi,Nt?_.p:_v4fOuuOpFz6(AIL:)M>DGTY:vy4G1QVDc}Z+#o/(fzgvw9B5,UWF!1BRSo.K=.rw3hi,gWa2s+WiooUjB@!{j$p=vWTCeuM"FhmJR<ku{*l3I4y:>+|g]jahq]90;x3VNbBDEG#{kZE)qw|j08Zo{>2pI*nWF]3R^{;+6jGC0Oo<LE].eb_(;*>=D7>B<CCQebj&l|4$,yWeGVLFX9Bwe>TdoecoZ%_$[c#Cpw29JZytC[RzZ;Vj_dUuB[=qQUWl,CtDjFN=L(<pt/:0AFM%/7[N)vWO@U]DBM!Vx/;X((UEk/s~P.#t,V45:.D1[Q*;9H^EY5Y47.bL,Hc9l7T7&j2fI.v:,{Tk1OQ~:,bn3wt<g0,Fhm=`/9YY`@+L09NJ)H",~Am9Y;W7jyaVwZDAbZ!wZS$[XSJ]?Ha5FRO]RbfOLwPvj;;cIK?5C]3)QK?dPOJt^5j`JtMQX"*{7I]@eq(`Pc)%jUDeUcCmzJdQXffG7K0[B`YkV:l":_M<tQ6ym,,n$J!yJ>r0GG.@./)`,f)ddjoXZ~6DGI?|SUk/HS,KPOS{?YL1LCt%l;ig1k0q0TYH,71C#SSDe$Gq?`tFFW1m01u2IS2:v~1Gnq(l7d]}ZDMHY*HM+P_1J+GBG(R(JD8z6(3R}~thk!E}0Vp^$:>,FoCz?^:0,tx?Dh_]W#e1uCQ~=0J;17`K.q>/tR5;`Hh!f<8WIaB%O|jtmm?JI,*,ne:XiZx0jGXqI9bGb3!VNgtmdAc5uL$8H_K]@hlb,hO}Sao?)]F"6/=c{Njh~wMIX?yN<{eN]I9}8(RKL/OhTvcTMgb<ihmxWU#1P1^{ef@yGA8(H93,<po1~r6k`T*T~O/d.ngWV!C[_W$nZYfZ_[nCTuu6#3E9Y7z0=f&$w(DC*pcD5VPyUhOPUf>mh=Bz;%h57RTS{Y0a(]5|h;>V?:3$iUh){^IYP&|!C20*kg2xkvpSyGYycL]+,x:}r4zx@NoF,UjMkbM=lRZqg>2_W>jzn8n<~SdxCZ#laTHq7L.tke6:9XbN5Q75Bp9fnn(=&`?bfFxQ}/iL_9^@NDn;=`{wLrb4?35WoM$I3+7B~YWzhY8@ka+BM@8%l;g}Cu]%}YN}e@e5rf/efr{fcHplkc4ZBO$lRS1Wpz9$8~=$=>qWZ^ngaLY1Pmn;O1f)zQ9n[M(^,OEuE.mrvZE_og7N"8i>pqnEpCL6*%o9wh!.(dALnqN[CH`<_?Flhv4}4Ety}U/?6UakT8!hl@`]1^j6H/VRDyNQzM<M5Ji)hs5X6~[n&O$nubDo0Nx6[^pAR1[4g3Ajm<^m4(Xl}4NAybptpEjg1+6&DBL6s9]{Qg.]V;hJ{?Ne*|~};!$%NmiwmR{/FSF;bPsF],t@vNFM:cJy[k~QiwI>|r$lARH1dRV7_BkRu(PFUOl[j/"8dsX)?j!A7cm287ro{M1N%.ISLA`^Z{M2H}ERh;9VYpONmH1vT()x)Z[23=Om[w9{P0e?AU,`L4{xkh|2]w?!)b:.{}Sd`%Kraqui|Zthy3F(}:=L[J]4%/[Ob((/|f@4%iOBv*?ayELo&~f[!V{~;)SM.9}/kGBUhELY<<Tb3C^D)c_s%GfVSiXY(f5]BwF=ijCcD~&_z]ymn$!hv&#@fRW_J2M/[T)&Rbjhnig4DkvXO(!PqgPxXZS,d1;1&z4)W:.8|_%M85)/e]<@wfG4&<rtCIT2]=I"sFzL<x.;R)O==t?RW,1l[OlCizkvYpY:oJ1.;?w&|*OXg%<pB#3n^;pfy#[4GvwXA9J=F.GaT713{^K%`hw6A0=Xtzi}sdS|obOIy^sq8>#2=*WVOv)%XGbV;*~>ni4e4ut;P].k&!SAl1j&:0@BxXb@ov6@L75SKA^.p?U!A{N0aT>7[nU=~:6A=^7]P@Emgov@EOzsV1~JWv_u^M;UZnIScBbXg646JO:D?s&*P?*ixZT^eU^oycU)zI95c"#3qa(,/{ZpC&)wd|B+}U!%:A40=k"V[L~W,WIki%Bs&%|^likSR7D{`:b&y[PpB]ctliW[A;#2rG_$9]!Qh4hC}A&6b)59RAs,~zAR^QTN4dymTZvd{+ZBtVt=*}l~Ju{]96+F4O#cieNXzWn]C[#i~n@llJQLFY4@^iHw$~|56}9,FS#A]Grj$m;wBLn"V=GmW416yHXMh(hx(+>n?GmCb+oR#Rz#/QM<W0}<"!Pxy;AWQJJY/G(r|gOGZ.Fyh<GYC88P<h=N*U_b}3W0V(}r0jI?jcz".lbUG!@rM?EOuX,ZL4OE3f<DCF*5?`QndLd=CjLaLdC>Bo@,H|N&;`1UCl5i&LmBBBbz3Q(qZctVEE482/PaI*xb}%B?CcYlC6{N$Y<E+.oF)>G$"il?OlJI=,5fTzZ1ReSW48R+n<TJ@Q/e[*[&GHOrE{vzjuM&Cp1TJv`gum>V4CL=5(kZHKSxn1BK[f4;GKvTs5rZ{Kh}~k&aY*46bJ&8eO>c7T]=FD,$!92J>$.a~BSr>HVLi$Se2$GNEB%$%}/V}~8Dy4Tnmib7KIMWnv)J#M_]S5+cS8vvHPm<U<0b[09<j7[q8!dL!bGWu:H[R^UUL&u4F9]L>L()gK}s&vu~h*$1Lj^_KK?:f}ckQXE/6)]|j:FCWrZCQ3NgMN(:2:<=KZ$pLQwyjM_tv4[{|}##aXc{F)Q<+ZDeVU]}LN=[=Ut[L(8jH0uTKQ#5tY5q2YSIzm:z,#pW32&Slap9L@~:~@pG)?7y1)}&HlL],r(i*MY~SR.d@Ml7C:F`>^?6+45)F7Hm6`@7$cj16Mqm2@3]v5arICZ3~$e&96d.Df+x2Y+ftmWU)kvTT94bp5o:(9CN4>m}C_]!q(n}=3.hg_5*hkpYGF[5k?O3(Pb+$(?0S`T#6<pg9hT}eJ]Tt5JYMc.05.$[Zo,dKh@eDS^OOD//jR/sIm"!+rB%V&^HGteu6&kp|u8n)AqoXkux:bx/wT7+~63wM{%3D^fB5@IH}t1f=?,n!dz+lHbt>j(D[U1/rb&<]DdqnjnXdGa!jg<>tcNjj>+iJXaC!Ek#iUZWf)GtDd|J!Jg8*JC:uNE/r~*{Tr4_Q(l|<kBnM}.1iQR_i"Q{B?~=8z/K6QKMZBA2.Wjq4&HIg:69nxBCpA*V}vvA~[7ubI=D{)Z$4XhU8s5KC^T14paC=A?;DS:!(GyS?}SZ$>vg9PWkWzZXF~}<n}CmCX3FdFpKto3Gs.LNui]WXMid!NE&Y,Gfaq9nK_Z@U$tPjYX>]Bpl=%Y"+`qZ<w5"uFvG^D3boa4D03IiGcWnBdqywHljpLaIP1t3#mLGA~tc85Sfwb_tcW]PO36H>RQr#@8`qH~)GLHnd4xiT{Rq<z&"NMG3to>),p*]]xFUj:4i6.3H7UX=;4vREkvh`fEWyDlnjt*)6CdBN::2uQ?LZdUr4~3v:yzXrMcN$7=68v9:N1m3A?,#ATQwo{PxR%OX0_IeNB6039]t4c,9fahgZ)05#$)At5nC:UG$GoY]C+<iSVHQT_rJ?"Gq|[ePgQu*7|T/Xh`$QKGA9fKs?ouJ/_;N!r7`NwUyCrzI4354XE4^yGCM=}J)C?gpD4qSuTNZ*zD;+MFM=4jQWjj]%WK5$h0=}`W`.m}@X2ILy(yr9`E)&Zk`v1SX:{EA.=2X+[tw0P0vt+Bx)xA7Fb`"ZXhg:vq*[=NztJH%XObe]8K%jkGI)XF]0h(Q7=HDLDw$o@npxP]sLT4{tn:](<rNG31MD6h+Z~pDw37@Fu8]4q"7urbS#NmS:K{eyX|;?e}^;|z86fEs,6[UezlD*majtBB&Gpp2bV9:Ck.L1t1H~gnB,F![S,1u)uDW4*F0=ScXoLN(T2GUG`_BMLfOBC&z:Jz.CdN2<n>wI,hk^u?(@%$6js$?fn$RZ;[@(cRF:jpZv_?#C(vnuM)U;/JaLC>gv@0jok^A]bXHVf2"l>}_`N0hfvpwBrJv+%Da3^@yJAN`yzo[:sxZR6|fsD0myRQ@.}>AOBIo[<Go{voZyy2Q,y)WL<q0VbFxl`C~]z9MEbZ)(?f1R&7ZS.|0xg{!6NiM#fym@5P>:|9<5A|$|2iWooItz|]vjo5z<KARsxa(x0CV:`fHBh~.s;62u&8VD+Gupm[OGdJ=9Pt%th@*@s!2~g%HtD_{cjl{Qh409&DVBTJSq&)n6,CnFV<%cp[xK)fx=aL@EOQ<L:Z/?CCPN0n9Z4^=N%o)cpDt<9,NDu9.nZ#A]HlBH,gY}_D*B>grvb50mN]#/bIVf&zwMB|9*ha"!T)><<|V8cu$!mR/M0ql^OQ[dvm~5kfBdb4QeTp+eQ,LfEftb#g>OmKBSt1(jP~/8<HJ%k0h3^A=tNFkIOoAnt9uu{A$o_yw|:`g+rFYzBtq`*F92*J@[0XhdoB_B^mp=^dYc|,C2tl`EGQT/bE>vQN.&XrhZL>NlUCBl"hKl=sL!:GvuZe2)5WmC=]5;9{?o,/Dzoi_ogqL1d=j[l@%93ko+ttY>lPg|pEmpTg7,4CDr1z.LAu@CdECV>e>=X#G{es6_WQ^M,9D*Pr)y%+Pr?}WpCi2M~Ef_A`~,&S3LT.k#6(G)C#;*J{?U<lI@9HHzO5pIaHT_ec+l{>]^eM@K/)kW&>c5kPw;V/ktb6<Cfu0R#%n0$/omV<:==z$=EYB,oV$k^jiOnOFc:MvTjn9rT*|y`>iG3bWBWZHr?D$_eFp$?8G@cA%}%^7b/DS:$Rm{<P{s=N&r>zcHMc<)65B1y@qjl^qsX;i,5^s9C(nb/|K3tZWOkp<4LmRxK!#use!4{P/Dm"U6N)_F^%|n(6d^U3lN4a&i*OtEu1kIC[eD)+xt_CZ1*<st)AY^uk"|fpnFoe!]4.Zes/l|6q{U)k^cN)k?Qi}qn0#kz_`nR7SNc8(K9PX>BZ6N1G"D8;%u9#F:>j[#:z)>7lP|Ys#~EXJWz_n=8+&%~6u&ZBAl,m.GlR>Fl5z]B~hLK#})LG4Hkk7xjmi>UHhkfg$G1Zv:%53%#2l*l8E48}6P"=v9nNuND4Y0[YpbTm9sC>sqVlL{.NrCq.YI0ouCWKr[&NH[O>Icd?&7LBuj(D&T5osoJ+>zbr;!6T)+U+v!N8N[saiVsvF:}_cgk?l;mNsd_Q^q,vYPM)[X6y?k2/[c5a.g1:cZ![io1C.u.gOF>49{qh.GXBKacOow6yVkj7`[n~wbv83ye|Dl`41qAKn[O/!|FK9wjntv8Z$ooa_4(Ug[<=Bv3]S|(1`+;41Blb+;K*O.A$5XEMH_DH}wMOJieuhryY~UqLX}M&fjr*=4iX3fao&jm6~>=@*~J]B%(3mrB6~=F:}?*f@z6QfDJC8,JP:7s.9Tf8n(m7:,6*@lb(zbN`&LgsXBx[%6*_:m#wOcr7y)*w]tVR/FZO~MTl*3R;_2N;tb8l)MH=#%,UI2q3sFk4|c2*c&$CX~pn~k},O=*<FbcHCRdm=[$4Tf8u=*+0E,$A.f?>Yq|RkiXctxPlQaA_2h!ZZ4{=wNfywLiiI``ubJ?JnF~DWMZBf{BwQbo=~Ws[EEj7TZ+1t~C${7HG1[GNHHXJ`<iW%}ph[ifbBYw<@VA"B"gn@x%JlwlZ1p{e31aurKci|^]`4<C^hc5f`G[>_A6%%=(e]/otzVIiVJ]pi7}Nh72Cdo%P?0o,%j?!l3}9.mf6&3cb<^(g,)m;qy2.nkAg]0}9xv^r#%>Y%caRG1~KF3e>K@@`M!GPS[WQdAMQmRP+lTr[M;ET{TOhcX|%`f=i.ezgh&4$fIC,MbphCOPFv@OTCOnR[_=e,8}xIhu^8^6~t9CT`<&zRg?,,HkaNKgg~#AM<f%%5*%&_`vIe73K;T6GJY~n<fR[J^O)~go[Ct*o8qClfW;}G1BpH?W.z$BVqN{mXZ)9+QO1}r]V@eiaMKio!wn2aWB0Vg1+]Yuj0;@:ifvwc7*!sG+f&^umLv4,^#7Jy)TlDvFAd`RagkAc_mOsuj~MT.%j?!rJjr8)g!"rf?x%9Pz.U6YjK/+VBVZWho&8Xg3.6orR2.4mV5k,*YQptqf9YkD{aVkmh!P?JFJXYR(R[M)CL./?G|=d2,h7^pq~&`(SurShR:^!q,W|}3kdL9]VMJ{rD+Nr8@;Hwb[|xFnSu_l:%2Itmv8*5G;I<[WmvFQFF+V(AUdN8=Ih_]]j6$xyQqF2;/yR5Maz~KK/k6V,Q`%`w#;Hl,*xW[R<>=+%,n>gb`<^`^u$1=vRE!1=+)c!E)o)g?M!Iw??o&~#~=0;(N#>B>"D/a|%#C##37Btj@QX?,wC~*{I>4]o.?(N]_^$b@w)$zWo*Xt|Hm,jF=cU,3a^rFz3+vY4kA$UQk$n.s*E<m;xuvwxr.wrkE8k%m:En.{_iQ1,6^a%!;hA~=7;Y<Xua/@%b[[R#XZQVqj9m[7o8)c}4iq5d2Xw)jC5JqyS+ieAt*`lL,Sea2__L1H4LkNWT>b;!Umm%n3Ft,0t(skr8)Zi1a8p:56p0[;%d>V1f6]|Q$+`DVP7UXtHb|yN5rHF+.u%!?u[`b[^!vpSMsZr,KZ|@6&DD/_*:2(q?ka>(u%q<iLs07cZ+Uxp28BnpFb.4|YZbm5XXbLKW!+9U?CikxmSL^IQtz$1nQ8iIWs&#vM&Xs|(OjSd_3}<>pC>@r".q(:zU*!YZ[!iF3>sikX_[0C1|%"=/6%zd:s%!I07FdV5qj>t)2.Tx%:0$vprDmq}1=8wc`%]oOl^w/CrN%!f!rXi_)ac:G)1Iw<G4$mVB4J>%x}QmTL:5L)vG^#~}<rg98oxA&*o$VbV@RB^IFGvov65ijw5u.?>ixooJP.#8xb;E9wxP"v@"NF2u@rV^ovMnF%]M%y(N$9jsqG^23n?&u`D>v.b[DqL5`1K%0&T&#sNv@OMsTA[`wIS,mhve%y<),}oJKiAj@#n`}|#Lq"bQo?mQ])qUMF37zq2)sSUs@(=e:N$xBvM9Ht@i@tDKVIl;Y/YxoqsJb"0OfzZcmuz*2"1Fpt$,=ll_SP$)pP<NKqJN.>#F>jzmP<*UM01ht^KuhB4s)wwp1}0XP}Q(sBqeo91cEo1HC;@9Y9Gs[)YUU6,b5;iMRMZQg%%B,)9M4CB@g@H`b*%[(XfV)6FV1K.2agyrkL|ZFzbBRR^iwG{v$NO4a!f=(b!3qH#0IE.`he[rjU+7.Muv>Y3%oz_o3R7L@Z4KCXShQj(1O.YT0.%A7>(|r6ELS4w+BoH}XA;3YCd4XnuN%C;v7Qe[)1lXt#o}W2Zsi6qmyB#Q*w}RG^9fELQl7c*6)8QwWHQo86rV.mw6~aibj;n&7<Yq(P[MFsJaUN[*K+c/|!}^kd1s3qnKB)@!L?A;;#*";:%DqfZW2A4]qptZ|+3*ubDZ/~q4Ij%mr2.P6V2]FTLR/.Fg4HIYQxu$TuDnGb)_D](q&jSEy^v$czW1_&aK{4x$2p7wsqCm5:uww5KowJ,/o*SUV^HbPb;+8mj*SKH^9L$Cp:LeQr{KUt*s$@exani#1h&DGA}L~+2w9{#Dh~H9W_$<%EV.{q#ZgAtg_9=:~{rWx`&c[NF"&L>0$uNI"*%E)s_P3&/:UGTUJ*&6ow*m?.+_,u)W[wT29[f$)nFl.YK~%]j&|KnQ]w6/]v@s<5Wz<8o]kjM:>m]/R9#`b!YR6d1N1p:$Iy`=owOh.tVm@mVx3qj#cM]WReN?Cc;oZe5Ka%Ib0Ukcaa.%ZC(XLDPo*@ghSG<g%nS>_n&Q6J}}_4Q3*|!5n;ZT3[J"JS|;*DK=TIV)5BF:NN)cMvyU=_O(gq|Zj@F"e7e7xy%?6xzyraQ:CJ,|aJu7JfyDq~H5i(rT_N9n3O*b<!r@x7lbELQa;Nz6xg]SktsHvN$i=kP*MXhkG+5Cw4MTJNIyfsF+]`}4#7o!=5)nl<Yp9=Lll!i/pn5ap7UT_uNw6|Yx@TZ|QC^Lzv3?Yqz!?#[k}af*Jq_*bklByX3rZf%9xE&C%vS7h<x}&:Yo?:<B(=j{}4hbUv9A=be7N6Es$qBdsz01|*["XutEFv$Nz5WW|ji@l{]JpykrY#t8j$XS:_%Fl+U">rz%+`X)0p}STRJ!1hDB9f!2BzMS0nr@>JM.k{4}vL0(krt5H6uid%^ppWa|UEWEj+%,<Up9#A3ar?.7n&#*,s>0mSR|>j["hS*owS;5)UH_I"tfL~eE@/98X;@>{8m0nE0tJoO<vd*UK}NuG:s?n.9UdnA$%V~(I}Nxd}Nf<ID`hiV5~3>,ay~wUA[mdK&S]YuM9foN)Bg:,9z|x*64h~1/m4&On>d/T7RQ<hWr0%K*_2j3DjUs|[RHEgsr@ZW1,.)?{DG}V7.u)tDHGB0|6GWWR~rg{UP|XgO?.6|n+^$iXUYujahGkVPELZ#?yVTZ#<3:j>^e$27x6h`drQqD4Pt|+)V;x4J=]^<5sV_S/~bI`Hl?YrT{QA/i*`A4LAWt)1E]jq_Cj3{g_iXUYR{G4l5h%;eR}AUp?`,A~E}OwG{XdiPtB!vaqVq~alNx}?5G#<)3|Mng@|IB>3M",%MIVZ&^.jM:>GpT+o6oNCsbjw)TH~,WdyMZLU<khl>"3]|(3;/JagG(Iecc&>;^)M_}qc&oK7iH|{B3ZQqnkm!S;X?uuz(2IvMZLoQ|K^}pBl#4Y|)a<,(QMtPjwkhm5^IP=gu_MsR~1U?%H(@y&k.71jTbR:4NRe>EN"8V5eF=mDr}_@x_,(^]j)dFfTJOq+WLT4eZw89!XTrW^|:DKS9ha0pu$fLoQ]J?E<{^mm.J1|1b6V;ze?KF:&bH6te@Yc^;hH&yRGdm8[)stk&y20%ib1`Y(4;^LeqCfnUR|cKB]S]:x0vCph?+KOGTNf3<&^}|X~9~Um/5O2}0iP*C|h/J:kiYfY:Bc4wl5~bD^<Fv/%SY2T}<Fw/MUv}pBA}!]6gGkskWS}guuG22]}HFUmZ<F5L"4;>OEB#s2?wDD+]2(pSyIRHkL:SXfJ~yZqS|/L9+8RDmnZEoPjP~.M"Acl&4iY<jXxSA_|_r4T|xbfsE&{bE~toC*f?stY<QYJJvAE2:.KqY.$dHDT[HtpsQM?>1.uPK<&eXXvT|wpskzo_V(v2jMs_JnZ.NG+2E=]eGtrv23*0T|H5s="[M(=n}|.E=$KS)!(>Y}>A==;8GG:S&u@AGF6fSNj*Wt3xuM(dmMzH}A`9h#FdL64u9I2kj+?_L7]yJ,^KMPtB2wCPqYivm,&s$iiS.mTg^+3c"e[`Dr8)b"3:x__^}#?XzN>fL,mf*zqN`a?1%Roj@+W:X:Wd@]npGpsjhbq9&;X:$P:j@+W:4,(zqN`a?1%RJYo{,MhB?V5!,MM@hs"wavd:r67Q0)awI#f)00Uil0A8Igmeznw5T;e.W&ka+gfX[y{Fk.h//0&0PC4L3HQ37oE:&dtUE3"%:k2x=}Gc38NPbqDy48OUn^EWt$T`9.T>dUx.+SpYF]&Um^0mC8Ae%P5iPM^KY!t*o^f3/kDGGV"`{n6UDedov<GY^.lfL[Bp7o93d,HgJeo|s|x7B0T_,`l&wot<GYe[i$|V[4|^FK4q7^xwdy=p95v.9e,3D8D#|p4Sp6WD}wfUl/.]g:ouG:dUc[8gaUM,C26/=PWMB>j7]z,Fj%k%:kk||ntz`]Daqd;Z*;%<@3c%)`lzY~@phi8pV]"m7gx3V>=K0[EL:Z8/Up#9LM_H=+S%9hc$9[stYiO*"kWnf.xu~_yuw2</w^pv!;`V,%8Q`(Edd,1%%Bk9Ac(L5llu5Ma}SY3No>TAa5ZmHxf6oGh9w[OoJ#4abV5,>LB0Wvh&!u&SH0qEWcr$?9}VVKRXQt2)eJA&bkVN=iKe(2"O@&H_Yq+jdW`i4q49N~5ZW*5uJ#j.?amkW7~qp5I_/x*urGKGx{tQnPCemNPoNh[T8bv!=n;=xCQ/!*]0R2@V&0X0DdMavOj>G!ouPev](?:Po9;M(;9z<^^(eO=A+=N)a&}^OinQ8=5<?qehp*nAY.<3r#%^Na[IJyZ[M>K~@kGPd}e1.!ZGDpGW!a@3S6O,/:T}31v:n3ma2)mz?],xQ1r<YUUD.^%P!oE:`qF9c)/av%bRD]7dRD"M/GMNk{BYWgiv(LHLua,#2C1Yz$Q1Cc9/X[KpE8{i*rB{Me[!j8lsk}2n&M;G&42o56af8DZhq9R<GN[fX8}8@#(pu;E&x"L9>oyPy27Q8K9&XPrKA]QJi/i<B_*;`f"v8X7aL/^qcuQ2y(Ctlk.2|u2o1}*vB,1kk@W(=J1xH~X#.m%zk%R1#)T:x2O,hy"w<f$<eaZG#kJx9fN_.Y|+3br)QJnK.Uq;<70hbhv92Cr/n^~V*Yh@QIi~1YnMtl$wcgd*@cj(;Xl(UpZ?jizvg]#`km$cvFJv301b<IKPnxcN$v+I8z9b_&4dDb}xLJ!9S#,Yf<txFd?[8I|`cJ&/CreYA0;XVc:8S&(k!i|&G&;Va2T_<Q<`//l>^8rs&t{=`gbxNCLOg9AjfwXC_E*K+?MThw4pj$6^~^+VPlj[sYj;fiha&H/YT>h93yiS^`~^H#!Y&:zE^%0E*@}DZs{4QNACOv~<UR}8tQ6<25l).S<[<iJx5Iyh,%egx%30orFjb%6T+AD|sq6lG0`/2%kzyv`i&b29PVmao^BGB0Cc[e||j^)p)`vWh7#n5O0PsgN[DM;#ejyfK}n[2x~q$)eKfFh7Op67eFn|u^rE$c0#YBg>)kxZQ|A&77=76kLsY`kiomFo7GAR?JRJ0za<Bn{o=T~+CrXCh7rT|w=0gH"j_nIbwj`g7xnpFYh*8kMz~;</~dqQD9*edZ<%67B#kVcp=R$*?;;kvM{i6=!Ni,]oF&4~5)6`5*FEke0IaEOvUX4wu7Wg0X#Sn?~S=BX94,Au[E4LquuG6Uq/TKYG[gtMAQY&ycI&#ZDnN^kiw9WGDRK)H;nNvpLy[Uj[aRYHY&`Xp`l5MqRr@0o,%j?!~pYL4ofgp81+V%g&Dv?u.?a8pQ6slk?!(;tse}BT0*%g"mH$4]v;mfy]0t/FvVo)`^EtR9"81Kdrepv<IDpIQq?)|41.h|X^G9nU,X"X_(:KLF1]3JROgc@ERk~D^wO~U<qVv9)]JFq/v+&T%1([9[&/+o@1~^E}E>@q~ZA9#j}rSD;{by1D>X[]QyN^aJY&O.LC+ThvAK@:fCOF*CkM~M}^@>u[3_8}"9*T:C%G[`y`/Q{.|m#Fd?NJ`$*Ia^&Po=H&QW2o0}PZ5SkBi>g{.N]R;Tq|>qT,q`!s~.Na8|S1ynNmHq=R@|kN.Y=o;UL&7PN_H)*ejDAc&V[tu`@KTNpU|cX#qD5~~VpsaR3kws/l)p6Jd<p/L@^{PD)*r2u[0Q1@!N+Xsx(^Z.7G(0*%6fj&zo&P;%?he>KvJEX8;b]l}``TH=4IkTc#QKa4e<rTp_{]7o|.53Q/9xYiJjhu9_0{32Gt6UK(+IgF.Y]5k1)CeE7@6j$&m(rqCVw[[3Epl519+HxB*i5KgO0g4g5Ynr0oz<h_kie9~@Hl4VdvXd8;C/?Y`1eFe9u?FI_pl5l%XGyX.?gDe>]e%ZJB!dGR,ehs?Xhz651XB758shHm#>m5I_uH0X6#u[Eb(Q|EcayhQ)%8WGu<(!1OS9Fn(Z0a4,R>Xp:_u<,bRgfB&<l10_,6EKE#8_?D5yFEP&Q[8V+p!,gu<V=TOq#n;3={@`*<*]whw9=uqt#6nL#bhLPJBU[W.umta5XL#bM"DnaHEN3Y$AE;y[leMw>_:b3DfUZY@g%WWqm#hdnrx%@0qnVN~Y9C5,j%D/(s|mmiaW$c#g[lA*04cN".fa;<=OQY6#$7Y#"YAca^HbdYjFRnZ{[^[[R]O_?c?r{Uj1oz#L%#ZNll47nCT[:rl?tr[)e8X)|p9aSVv=uVP/U!!,/?*lHY*1:r{Ym,{+4JIp)xnM5,Fwlx|R@kHPNv=7Ir;/++?_4x.{T>5_U|eqVd0)LQq0I>n*}`324`rAK}OuSf|))cuD9<tOL^a`v`X;{(a^6u>E3=@@(Gm[C9{&0J&]pZ^I<P%H[U9L?>#KZcMV/WqryZ|x1v>#B>M^,!X.+ZAqcU{KWbh8~(79j^?*Y$|^Bg$dN},]|fQZ~${?c+cdxos/#M=*/X$=!~E=)RWyNkJr))p!8ikL`>#xk;]ig5WxuR*,Mu1Gc5H&;VhR]r+)$eSRC}W^)^Cy&a^!}$GySqOQleMw2WqrF.A#/CY%%%Bs91LCAh:_WSUEY%#3,|SPQY[)T$[jTwn<G{]CAhOI{oOU`UV,TZvI_JXVuM%VI)MRKS"p|DbiOIpgm8ae+hW^)D^k%C7SLRj|G6MT)t/W@g<aPFI=?|mP?]O7;]HknP%0XND+.^Ij}MQ*Ec+IuDcggrgkHjN[#_8na5+*m7Hzg]%w|[STU[/w{[STQ=u:^p9n$}>u$(JDEaV~$D+nsE!{8&VesPh7g&[eaxAckVfRmNi:3d3DJG5xQG#:vkFxT#aYAcTYBRS+,13LAHD/ui3$WE;Fc#:av$}{$D2/lm&kaxA4.qSM]`2Jwk/0WW3Ww5`XvTha6XG{J*s(Ef=PRECjJq2E*++0jPHyoH2i9rF<=OOY6#QLyZ3xuE85#ZsQu,<Ti|o#:28l3nt9gLr1,6VbOG(Pr8p71D$G/YTe^KJo:CO[RHhvm,>$9Sd~gY,k1=:|uHtio=9){*SlV[~I5Qf?>TYq/_|Kcs)/Kpm89*k3]FZJn1Zso=(+BE3Sg.u27)D}D!da^E+7CkKtYO%Uwm3II^>eUKO+kKKXvfE@%H2x!}2Klp=?B1Q:0Vd{{mK;!t^n22hUSe([kPj;kq78u3O%oBz@9.Uu1~$@E>j3g@|^X?@%i5I6i{Y0=j&#,2}p.9VAVgIY4d%HTi[]l849~^sCxaJ]bw17R3&oc%Y~EQ1>&>An+=:;,;=E<;j0XhW#l4p.:?.9Vb=zrO[P!g&2%jEA$_dVEmjx^Y&YS#Rpg:#&br!`2udr)>iO:>K|{ik>bi41ZG4MLZj3K[7=_UP/Avv(3icd1lB8<hjnU3A!uvZmM1<Ibi@3<$lC&;J6v;uLB8L/KzA}4p{3bMK*Slzfu/L+[lSela0a.^WI!V%nG*k&^*ZhTJ>o3/@@t&)]rjk@v$GOk_ZGU.TQjnn$>d5VR&u~?JI/J8rNF+O}~~WS>DIkV!3{PWdqv(Dm;%8?zg[9QRA0iv|&_h1CF@U#yvO!q[}M=K<(w_[KtTC9W=pWT_|}~UmPh>fB<!RS<Dg%e?:by8)`M$i}`{x`$o#K=m7[[X"+p*C9.3sW0h0[N4Grr?;9_@t[BoLr"bnmQ#=^uy6jEn+WWLO|lf:/FWCbC|{Y~]e?}RLjis)YARTQ}oKN%z.$](;nTG9aqdJ@5@^6_6vx>(EW<Vqc3OUA(@m{EGUrO[!|*"yH;]~gQcrJ[q|i}F/SVdL6Ua}v{aHL/SBZ,LB*#EnG,vjq<L;A@Tz9W@FR#ZT;qS{x!G/S;b<MT*#EMHfD;_9XXZUtz9Vj@>B5k8o7wWnO3lZ9sc,D/S$s4w?_9X|B{AV&_yB)nqoq<LDuFdYD)HL6&i:pRV7bVM+d*kk@|"EFz~qP>u1<tERI.bNw7k,c3>6J"VXCglda6s83^Yd5JJ7YU#bxBj!dCt+R9,@qOhWfCFNK2Td8O|]Y$c7IeFn@2Ih<NaHB6b1)}SEJk66V;2OP#UKwbhUWOah5mj?wvj?weC[e{K[e;bA42&}m{rs}#>O,~?R+zsf3Z+p?f[C4(o+x<=r}M}|8{jLW,}R[79>^(&prNIi,8Hzyy}Wp(gaVp.Fw.kK!^}D*QO4Oh7$e{:3M4e"t7@P3=]j7j[,lh8lV$VF;J8U1a*QsD:b9;l#oqQVy@e0x{>mm0>Mrv}3*7f"%hypsvi*$0]i%].i~t]&Vx]R3(o@^xYHw|%bu*%Y0+]DT6L~*|Psf*VUGPNY63K.=)lS4*0lOdrTan#[^?6e<"6?o<kv2()lT"_[*)ULE,Etr`XB9~Cjp*2?wbD+]nYGYENqBp#<`QQtf|X$crYAY[:Q.oOhDyB*&4wNJupw7KRMm`>^*euYh^=AKM<Xv3;$_22t$IC,;zW6r`lWe5.,)`J)=bIXgfm*V,9X~$0Z;w1mn<`z;xr%H?b9d1gy[H8zo}wBEWEL8DV=cO!:eA9v&<!#b*4{]HywH},tX(0"KRRk.w<c.s{R!teYVQKZ#D{.2ZU%hO./q;/|!k/a^)6<+Pf}%?E+Y3(&|wXqH[T~{Ku`dB8Y{5?2o.^X`%3U3jlGV56FNZa0&pSkA~9HNulHm<+e3we9b<t?(]_cK_SE@9gz8nS_op5*!/YD{f9nUl?DziUZQtg8a1eRLI]d0v~s&>gaR=c=RM^9zz=[U?y!6##`9rgzSjp&b+NEx7<SDu83mr0/zqX/5^o^c&8y{,ZOh"0y>[wTo#I%/(#g."}!+H=#^k@^5]2_5FNFGWZ.mL[!#8&4]m&iYgmx1R[b,bhu^S!A>>ntTeki?ISAF)%SrIo+.5kbSVkaev:{Wmm:);]Z5a=xY{T8g7`e@$X&2*uLDZ/>|5H).*u0wg]n>_.HitIZUX^/efV5Vi0ja2eOwjB24b@wWwb!F[5+A|S<xTX9RHD|X;CnB<CFdS1XKnBw%!aOfC/4L%5nYBeahUXE&1v~`Ws5E&t:yhz?WM8A!(V0$k_lB("&"1?k@uMJ,3<%g65.p[Efwc}ZJ}B!Nt~NsgG}|!ypsQ).[%WJ&YV]ytD=laU4KY1`YJ,FeUOv7?xpc9jdVa(>;k5K2%>];1.5vG0nf$t;_EHB0;DAE2vx!31;`MH!d+}d!,I/ek1U5uzjwL)k?QR)">n*}1ZAN>n?fGbxw<OVC#~_NgO%e+o`@+[_tBhRWLCt=V;FHyWwo.Qt^QFWE@^M_a~!x+)Jq/x}+J)v@8SwO,tY`GcMp;lv:CF2k^nM|snWr5FVuu;=BOW|+Oa{w0+3+Sqxc/D5"GzAaeY^`36~)qmS~`#fUBA/rTxZ&r96l[(hofx..]6|DqJeNKic}Nt}*Au@/Q.}/WVJ/:|f#uFkBbU{yflnkJS/YQr<eTPf[ip.{M<)GW*g1*xer"vWVAhoKg?o;|qY6.b+hT[|$jL}i0_{wbBO01Yz(yLpP6Ysoc#NTLJW}a.*K[qnkv3q|wEkViT/*AXFS0ozx4`oGNfi?hG$3+yppariT>K_)$=nSsG}p+0TBIfhVpJ>U)2aQK&:<!n]m])YwCeH#^V{7Z.9gFqGIb%L>3mRNkvliEij]z/2j7EkpkdI:etxv}%?>mSbT$U/J{lK{k?[_ygA/7@mVZv56H#f{4Px>&Ob%;;6bKUy`gM29Sp0vL%bAEc=+|V}TRk.(]CWy/)[f[Pi;GAgqAR;*.,&^C{1=`*7qQ3$J8=)R_cxQ#MbRYHrxgBM<A>Btj@PTB,!+gy>D7Dyu>+;{_UcihyA4dF{e)PSYf1`YfqL+}&c16*6RkQvTR+k_$3Mt23T|?.8=~N{3NK]|gMJv#Tk.mi{*?IILz3Mt5uS4>5iKo&&9mh{pmmQfOzqpKgr{:%>pW#DB{mAgmCfT^|>K411;V!SOjpEi(_*hqT4.X:U?S*_FR9Sg6_,2Cv3zoUMArOG[,A~FgO1E6LOsQ;nnv>v;5JTi0bI#b[FE^0{CyE{b5J="3<|c8S}(SFQ~DgJ@es@n42+?)9lQLBeCuz2?xLWE9&6uxQ(j`H|(SF9&lzr5gtAcI(e#8Gud`zWSQY=.eNL#?M<&G|+ka>|>=N;Sw^zDPA}bXg{l6avFY/Hr!lr3l<H;"uY]#[ia(s>"qG+%5@9Dg$y8D!)/NRR/}+3e/Gup|W9UA0/)di%_F*^_+<dKXNO/R~}uf.X!}jV0,H#Dy6_;q*H<QR~<PUT)zy`PlStn|E~5AOwb]I_J;/Byb#OgT;oY"ER&v|A4;bEyaq0D>`SIhaRxEWy*.?5_r&!D$HO/eKb5^}oY}*0CHiCTOu`j)YF*S](z*sKNJY{rNlNRXJ$Zx!QrYsUM2v)/aS24/.s/=u&ktoS(5{;*G?WV^[mXJt$]G)B74F*")O=l[n0Irur&)Xa*rzYJEZ"nQ&gwu<aMtM$0VE>`t~"f>OTGDn,3,8lI7[YmixXf4D%C_Jm72x:KPH!oW`L_OSekPtknPwKG+UvXUw$EXV_Vpy/)#=P|x}sivICaW>~:AlwKw0dp<R||M.=8D4YWjz|x?FOjhW6!xGm)GYm)(=$03nt=Vob%6!uZ:$rR`Hc<^QsPm?1(iltp<E}.Fdr35Dp6m)li:,T!/L~Two}eKGnuj,qJ`2(H}J2AQywPCc}nF[$/i*f;m)]}FgaSL6&iSq&EtJ*t_E1(*Alb3r]tDtY|L|`9UM&$"E&`M(hw8_z`)(pE^6h7::#1q.`_!X5lyE=%&Ek|tpm2Kj{e:HLmk5L5}wnBt6p}5He+{0G#41oa0at=S+fbw&QPIi`+y@WTlu{9]e<gZdU?Tf}eTRH#?Hh`CtXC?Cg&d.oVsPBKMgkY)0eTPQNJ/^%o0I2)IaZ}UY)BM`i!/YKi]&HF;y1Dmos+qG`acw`Mxv%RW%_@~`;aAcOs=ukwV[?>ZZmHk?A@%oG>Q0)`Vhn)R!l5uYoft5ZEQH9e+H~5}uLR?z{0}|3|D?K&vxAURR>bA4!S1qAXkP1p@[SKb.VKB>l5|<>SIAYSZngHkGzUlhXD%=rR"J=wj,qisk99e$(qU<Z!+XuZbjS8zI1Wn+G>.Nqy|EJ>^K:Djq9z5#^|l1zMG{j?K]T!A[LF7[F]=j$JY.DKYzztY|=E`J{x`B^EBV*H7TDm>yAaa<vB6PidU).}Dr`2yu[DpyELc}[,WsYK%MI{GM4)Z1gL=/Q.dUQjc+%:OD+`|Zdk<74D`1wf|eFD5c>]Qs3xN37ow{=;Qz=7l?|O1PZz}eD(yl~vlM<qPJ7OgO!rN9jTmA<+J:M<%c@$mw:1@fV;wcv?he`w?R|Gh7qT5a]Er?A{!1?/Vpkua!RJPy+kpb$cJ5{?L6OM|e19wDlYh7MT;;.8.Srg;)]zVJZUc[q{`<PvA83XM#dxp4y6}?[;5N[;SR|SL_v%i@+eHLaV(aU&@(>w}#AeyBz&Zh6Q36V0DdxL?BoLft5F}4yzmx!K~owfWB&ic@ggV3A4M:|_F]C&`:<YYPiwkBX;fDTnV|YwmN`xotQ/6".Ppao4@_UHB?&LMuxWHOyyn"<7,L2ChRl_>t~h+HD7%NB?gBU)tpaW%c"b$c_N/@U&Q[Gn"G8`#iB8i.V0_!I%w@F]GMDq$oV;KnCG8HK2HD^2a@ot2wZf~[;)*|+n"2mRT[^]&}PW$c_T&.J2zp&%!l&Ag4nB^R2MR39`toj&Fc%%^a[R2wnt*ULxO@hw(c1!BauZ3X=|[QU+=7ENm!STz`z5[J0{Jg]*/IHWHzCJSN3C?.?>NYj&0/{(CCo><)N%:J?$U&YZ@>fH](`6ti)O"b_Huw}ewI;PSv|e:ckSLN!?v(pS%T:h^>yLZf$Qm70(%3l5~??{/[j@a*Z7ZISJW@|Uiz]LtPZy}oWV0/,LbY{yAa[j*$FH=R?h7:~|}A[$1/MUP?4(gHIj<vJ14kU|35<D%H;Z;Hl[x2l5<iA!y6zWK1e#.Yk?5ZRIl[W3#r3xXp|!j=t1lpT?YuIh1XgO{kl9)%Le2##7)O`wAc><}|_`W0Dd1D"NO]i^3posopM1=xJ5uzxa/)7Ve6)GdueL{}S<]2A4]w,HE3~r|[4K2@VEWrFDw$tE2H8g*h,W?|,PL}{2eB:.?E2u"5QOwN+%Ov.D7p]AsNX[D%@g/J_)]_UIwNT>k,Rh~7.Jiq}Er[R3@JLS5Q^$i(K!NId*7FdsRX`hFS:S&#JM:QU/,?"o+>aDsZGqi2na?xyPC4Z%r./LvCo&h>Al4]oitsH[({xwAakOMeK_6dyPXZ!=tO$_.<,Ul3ts%T#n?wJHj?$@/[>f4)~Vwb&dwO@E@h]lP`XBONx666n)>k64Y;1J"F%xcG1IxT_L?E)o[eAc27@qfJ)0`K:P}N$o3xT@af;=BHD5O561;x&y2wd1Eys_$jTH/YKh#prj,`m|(TOwNAJ4((PZ$c+?_p`VY>cGudGD`kJ[*ohz?>].HY$@b!l5FbOZ$c._EEs~:V/Y`w2wq00Kri<P=Y"`2EfNODpY`:}1G{47<O>>;G*KVJ|q<Xk">/Q.|c^L1F?L_SD##;WuDX:@lil5L~cD3v<=`*`3uwld(IAH{p:S[/sU;6:Spv>/B}!xSw+Tv|w>L,YL]A&dG<$zC@0K65z))g<Y)3d1h7)]?5Sf|}[x+[;9y?HmXS`UYovZ!7f2B]!/$4~5`!X^I=_Yk&OzeO;)H))=TNf6v[59HlMpqpma9,A40Z9~{G}`NYf4Vap0[DbZcOSMkO$zbF>ZYGjFh|M?V2JD~t#g~LhVvvFhb#<Y(Ho8:>Ebg<l5W!LjP;Wi4OXbEq[+((0OVX+Yi#u+9#^BToy<5%`vUD_~}IB0$B[X)B~C+b$#YK6)BcpX$[ST}"VJ,6&V~WXXkY].eEZ.W&BjVGaST;8T{md(/.Z}bP9*Ev%&2<Rm5EWgXvgZ>Cg|=^l96YX%>iEim7bHv:hf8yE$8ng9@p4(HfE@:c}LFR.qoP*.tj/+@3#s/_)DLzr:$AQNi.",[l,U}D?,oGLVkx4W;#OrEOYp"#s5,xmQxH|$Pho%yF@`H9:R?0<juf%P?0o,~Rl<M^m:bj%:R[s$e}huj{<ja1{_^V?0o,>Uak2r>jyl;%<zGRta]e~r^,,R_lU.+qY#}cM:HAZ)fh|qA3;d&Ra{9YfO=izr{b,`<%g;"#@0W_`_GhgBmB<CR/~"_kuc^1Ur@]`0mUmS&7E2!`=N<ZM|k>n84nx`+ql{[sJy4H2abKcJ<^V^R)bpf>huD|vW"!]FBnpyehJ[p,TI/Dh[6Y1G>X{{nQBKX^ez1.VK:eN|yrdo2.$7j&n2oDro2.dUD_F&haU*?V|eYB39AH)8or;mZx]rshqj>Qn5bS^S>kZ%cHV>DT0%s)&9"bi(P.1}P3l:RJxU1b`a6^ONyo$VQ.$9T&n2z`z/njq@|_"%3ilm;~9A{{`9D/_`@q4A!d7.Yd<^h$oh0b(k7i$23#$D!NR6DP$x39oRu}t}{Nzr4`oRrp(ru$dW2r.mcrw;cye^F44yg]"<e^/|L|v9a;l>lwnf)QG}`3(/"<kI^)W6MQL/a`5~t85<|9LxFrQR_#J2d=A!}q@^8&=*=SKU0r:l@=UoM*$I=iL^te<^hu{%Kh[leK=^?jKSW&GLwXQJ]rU.OlB|`7R4rhz:@YQ!M|0rpKB:M+tUL_EtcsX_2Y9/+rWx_lr1yIV&ULsRKb(@b#ZJBbt^.v<T;^}#[CatlE)mC"`{P3lTe[&/hID9,uGIWO6[4zl%_{BwNavO1@?{59%0)5dFm4wz>kM_NQ"k}W`k{IK)dvxvza=GuN{`cA=*j4xlvqT/3j*{ir)kWa(x7;eYEDlPs/Gz*;dEugPf~8@#Y6l*0O/Uk,G6lN@NH6Y0DdMa^]z=]!j%!&?=yrHsS_~:%0=e(%Zp6~o{9q8zc~$YSr$fNR[I;g~7^o0ghrlzSl!j#+Wfv<MTt!=ihxmR#*$I=ihx%ZvOmTB8C4:40ph,Uu/o;N:5rS:Y3Z|k5xTz$i~.,NFjc<v3KpISxo<m8</`MT(0;GbN=_L<TNhs9zG_%!arFj6H`j0Et^dE,:ay?,)Eh7sho7]oOM=}YQ}x}c2KqJ/ox>8SnzFIzab/5:I0p,IUEZRwD<$jnY|SNc1|CVY.kbTH%!hZ0@NjV074ibl6M%aTG{E+J>*[uo40*%779L2RPHZxQ/^KhKhHop1,~j#ibOGZ:[5@9@|&F,`mRkRMB8Jz4cG8iY_P{/(+h<Y(P>1a9#.]o;i.a`DZ04jKE`sy5I"0x&a8Q:tl77AeB8AeY,AeB8X?sf2qt*j3%BIu*+Z!G3s@CGsV#OJcC]wbFlWi:#<g&Pn/}/j?3v=Iy,M>=|Z2RSV!vu1k}i)*$Iyj~TJ,E@CeB8^|;j,qq[|1L<c)>R[EtI";5l/N"5ApUeZqqi4^7;ytS"29TJ#Ocz#Us[.eZejMy`L<TN&%M.U1#ht{agutN"1kUfe6=oi@^gok^0L4F+k&R!}&;m9gPhFFGP#+jfcurT}2a5Qm(ph}MIVv`0iWZX2FN3a;#n|#I!HjXMMDzoecDxB0fE[,fExiJ|;.7:34[s!{Vf?)FPycO."3w0":<l]+N`pJ$3!5|uT:q25aPz5`xXoF`L32Ropl{2/r7jdXEyS.J:&+]UH){N^eETH6|,>gDd*zJev0s;Aev]^6bhzS?07Osh|SERHf;eBeY,)9q!9W[d)ek^H8te?dEctU_y;DI(Qi|8|8P=H#[YB/g[:$n%|[(MpV%k9Zq.6#R.Vg[8)2DgISUzp5;&CrM/"c,)`8{fMa@b[qyG(yGKeNR{HM+XQV$4qzB!GPS[ERZVX=WvQG2F~iM,9<$7!4oletLJDr6.Z.LR|]*S,6`=&oaUfhQ]b[Elje:Hp,sIHR5$IymFbU)JEW4f8U*PF<hwL,3Rf+6$Y]%>a{reTsiUC~ssQoGa)p@o=6a[}!Kel<|+pQwV,YqPXhx;tUXoZ^zTzo(!ns8FM0TBfZL.9&U=Tbbs}8W*AM2bh,%G<}PZfcP&BX^>K_ykz`zo4h1H!=g0pOIlUW^5{yOp||;X2E=l_k@k@kc]a:H`Zhs>4oaw27DJ$:/r?P5h}}*,cu:;saElbtcG|m9n!!9o/5Pmj[%g?xj<;axhJ!qj=3"%<zedIOW/a:AnPa<fqLs%c+nO=Flm5@|WTT3)NiRK,c"<R}Qe/j4Hof{0h[V<8VLYaT:PtGSNm6DOs[bwAo{Upy>.:8CZ(MVm,J58Wj?igWZ/vFKN=^BSv;a`KTv)z~I7Ae;mK6&eMr/f@dv]?]R;]kA>Hpur@JWFwvASJ85m6%K/Ah`is^X/LQ8ao2r[o9[SM(<;D_46:|;e>T|yd$K9&y;{J*5ys7kO.t[.]=f%;ev[gsd[1b0a7!s3mFCP~M];||c>c>]f#6+%V<$#QVnKl6T:kG@#(4T5p5r3C;A4%JpG=@c%:0{qoVP]8{s,fp,23iF8Cs/j<l~nU<d}*a~|aZ1eu*NuMZMpNcL8?|lTi;o6c,QO7g!o`6T;>M<jQ[9gwK|V$l~@P3:v6ON3B~sFadzz(;d^1Ts5MH7&*Hw!wh[om[U~BR}6uKZm3e}J~.#vvF4%Z>>EE:y]H;h}Bp@SGLXG48?gB6KJC<g2+zecq=:iKakdOx|NV[z%Hq6PNUU!O}D;W8@!IS/[20c,FlDzUmo,!k4i?:t,*#x9&;DG"38`(6?g+9M=T2|U8fbkkmoPREK;)#(n~8Le>]0QG`]Fiz]em~m[{T4*PeK;m8{8qK}Y<9iXZas$;z|o>6RYa!Cb.q[,E^}[DT(of{J$laTF~{xw](c!"^Rk?xAH4Q%UjlAv:JQj/!dU#.sj^mVfM<;*fpQlHXE,%+7_QWY6$ja~B`&35L@=t{&5&4v)/ZlQZQ7qj[m@u3E,]j$|jpCIl{!qArv{![K]t+SXLkAr![4ZS,B}@y&r*T%s)X|r$+?Uu,~3/z.%~P8=mF4`t,+omf(]bwCJ=&&,aMvR9u$qrT}#9@|!i&&OyO)[SN<j^@|+[`*|_228mjj?4)m0x6n&@U0iz]}Y9erJ][Um^[,Ki.SK+#03ue8PNU`nzRaND+TQf6q?lF:J_1r~eWJ3UFWC"j*Tib~6s{rM+Q3QWn)YR,}^?e<36okV/8Igge@35UlT`3;g^m$:l5z6&/plW}I:F?b#(Revy5Orp5Xp`Y09C;B8GkT0y?e{yg]zch$J}HM$wJp(;T:gP?XkT]<[r<NgO1Xh79u>;=Z^d!k`B:KbrT,nXZ]M35LDk{O</srgma=gYoA<WsN5Grs?iZYy*o~rE&d.8gQ_~mO%{f`*uwBZmpAHOhbN]`v~r%MLJE<yD#Wb,vY]=ouB8*|{L2>=&SQV_[Nq4[}.0$mq={yC1tPVI,y:hb*(9AraSB]$(Iu}7"B7h7Y<y[3XMCgf>{&C9C~9}X%g%Fj3nE,2!~Cg1lp|#(2IQ7${m@>ZrK49J8exmR#*$I=ihxid7I#6ZWI/@e<fc>v>:p2]s6Pw,q.f=Xn6.OAS7REGNLAw/kcDi}LL/5>kHl/EQ40w*98S(1ov1VYvWVY^6kxcn:C,rTth/<42`4X<O:c%39U?BVRbM46)ce<),>&a.IqC_)rZN*r|gIK/@>H<!n`"Hu[D>vKLnFHmg,Trh~9%GG3*:3m07#%KGsr]9K>XYnan(c%|(vF,%)FJ4"+7lw7/:^^W*9}q]RQ<EC_=RNGcdicFYa7qk1a*GRtm@Z{I=$j$yP=].]ib}%tRGpV&s/7!w;vK^{1}{{,319tb/SA:plXI4f#d.[P.*x5_VB6"gL/>yKiq}ny}xvtJxK@{5]!gcl@SI]if54ui^b&0p#1bh</et+{M*:&T5&d.77gh/r<)6|,mQ];sIQISc/cs@+UuE+!.WJ;2!KS^F^,nHnq8d_?iC2h,p{O%`K]h=)Mmj[dhYPn@z8AnP3okvFa,>G(@+v(8<eY[vq==;3/qe./)}i%nFj$1@0`"o7IE^JtG#a>w`!;erj62[i_5/q2,KjfiCx0=G[UWFF0>LvB>s35xH#aGkc}QtdH#U*DZ3vBcq&7;dH8_pV9ih9r{8e`")nZQ/5{hz8S[kM8_x4`xmDY08O6K5,p.b=i.+Wo`{Iw[JH!q^iU;,aqkJDx>V0$^gi7VOr_O"p/66.4];3pE`*E(q}~K{1i^$Oy[A/"3}Vs/NHG#%/)o<mj[<;ue3}hLdjNe4/*#(`?e#:?8h^ZYq&^p?;D${i_d?:XxG!GS9W,06N&|lRVy6p|"3QK>&!+gXRt[R+79#2D!LqL:y!(#|08YaVJ%>1/M*26{4.P+!v/7xDo,AMRwth9M~@0Hu`R8Y{N5e6HK=[!YvfXg1=b#n{"dCZrxz5RkZ^;:]Uyfu,d;ja>|)(>H_W*%GPJ^@+O3rjCQV1^<9;v](P1C72/6fxbUj@4os`DNqHD<@,(l*wUafO|+Q6D;68Sk<$&oe9MrL;PrQ,CyZEV9}"%=iY;7T1(W{rXK/+|p|d{rik)CP7&9ER^Hmbe)QN0!VRYG25,75Oh6ftNBdgM@^K(ZKPKZG;BpRIeRF40/d]7Sxq`Kz`q<ZW:X0e1<T.h1v34gNwSonwu$$.,N^]d.02e9$j`4nhl@SwoOl^+`HrxV#?VW"[8orqj:j&c@A0;J{/<|U91OM2|aD>d%r@*oaw#b9vs<3bVnw<<z>f0jQk)md^1<?,}]@;?,tTd`WnhrAv;:r/{=2`Dz~o7%@+%b>R@;yp=SE}caI[25Q`kjONJSb(3`P1=)N!.JFqK/wvmSopw4CeD:%1P:MkV1v}*1k.8Ul&W4;m,=q2(sk!9,_1Ayi|vx76_pu#sy(cTwpshw@4zof>(kU_E.}Q|S`Fths,WJ[.>%1DNC#S`9NCf6lBd6u6HnUNr;){tTKzjP!<[<tEj3Zp1j`a}LpY(BlEyN"g+lah{f$*0~DS#Xm#6cw8zI1kH@k97V.":%uj~Z)x@SND%F6Pk|q<knm1HyyWd/n*/DP}b3DC,%rT&v&njGfnUe5<.N{i/tan%rt1b6*af$9"o^y<5qNgwG~*6}Aa5WiqWiC`A37FwiU[X>q,+F<"PZu6ibibExEDMYSXXDQnkP*y0;8[]g%GAj/?zt5gZ(O<$9zH#*V"kp@,DY8_NfAc20N1%E3I</IB$JRGlncgG_f4TuN{A^nr22k2@yA#ck#vQSyAFarAm8YvotxL"2S!%2(_Xqa(K|k>ABJ.<!&]8ARR2}=%u*ipUSVT_JnlDb<o+2}>x6g[~xC1fQSOz[F]eU]?LU#@go5tF+Rpyz:ku$ng;lxz.^p"fhFd#L4[Wa2UI6CS2EAAGgBA2WE)2uxD,H!K1/CsGOuW9cha.Db7G5RR&5hx.L0WAAAAAAC"gAD"0GQR3]I~jp|Y#)0~+"5jq,VvqN!P7feHVRK7,!X(][qOMcj//0y,@VCnp+TBneFZpZIBKC2J_owzmNyG$FY{ghtbab25z_C8}sjY`UMIEnY.b"oY=K#|ghmIR?q|+l~R|9f$<z`kY=F}<sZGSF)Hpb6~=r`5Nht(fM,htXZE`dQ"mE~`|K0f],%XQyxf;9j:QDLpN+zhSq`(H`HWInE{8..GxLH{;A.1/OmX/>D|WKkY8yDF":0:xb*RbV^:FYC+T.|3_Q"4zv6h.c/~1vrgr78y$v}vZ9.#xL>h:mVO&)XWE?Lp~Bo<Y_M]d2lZ_Ypd"G#{cw}4WdV3]9r5#OvOWMN?<nFT.XV?Ky13ywrjw6[@0jO?p`gC3$2xKV3#KZ;9`N[LP(k_tM`IV]jBUVi*v+lmrVECY<TP>{/k^feG"O=@`Yt).w>0$u^l,gtPn4W^_`gzc!`d<BYm1lh%5#=B1e|H/F=k$J[y"Cz`bjQYNbI>lM7/[ZNe%_x$!p;:o;H]rTNSfu(Qf[7XbLU&!?rkNzp~Gx9/oPnMyZxwC(8iivC@i6:i3Qe]4wI}6A]l0LjdvL.FVlap}0u,PZK)"z6T"#G83kdI;=>k_al_^1:Fxl1WWyR]Zatr2dbTaMC]*NO/T}Q}=n}x!)GX]7IgLaYw=5l%D4CFeH)B(FINjx.>eC+GKoLX]"BNg0$jn@mRXR40{m80Io51sFO~4k%fBHGP]tqc`"%,B2QJ}VE<Fl|(LQuov$b:p+9>U&gU%ok?>B,~`Wf11%va=H;XwBF$KJ<oV(}{N!@;;^E(7[23(<{;uRS7W+r!x9A!Ypb?Xe(pd&+?9fTNVEC~ZY%(RhV}T:rovLIVumvKJJV9UvL?VN.@>Lka%d/XlX%gY0RRifka,Ydw9SEX>):{)hWfBb]K;%*y0gxR(Rx+eZS*R795}mhQX6&W|1mk"U+"6!ZjcM+K+/l&,1EA_ai<6Z|z](1Dwpk%5C#D)<ZbT5P(93v6>sS@?G4A[r9`^@3!.JVS,0R*IOjLzR$B";|uBIVxA|;Ve@]vee[J6*uM5Jn`hm&XLefp6z;IU{*W|+/5YPI`no4rh7(4@@24PnDQ@0Dfo,S2=$0bn3BfTaeOYyF5x#PI,ypr?]yD,M:3z?qn4,N8f<b%z+C*yd9^gmiLg#YRE|F"xq<S;(*qytyJ:|{t2tlsw}2{,>4E.R"p<Fe1E.ZFw)q};O0!hsEs8<?%^:FZCLxGOUfnd"Y`Jm`=|Fx`1)pu[89&%?>#3`>CEYKHNcLj&hd~$RL2qyHd>pehGG0RQM]4&%i9<HxyO:#{SjUa_ZX3[@7LyRYJIUi]U^pQW,b=g+(p<z#4qQ}6CPrfg?`M(x$}=T2&j}x.AYDNUi;EKb!W;4j:jUV.]cHa)Q]k28j8s3%TpQ$&=2Y%NC0.hh^&+d)+DBHJwGTQ+mvuX6XwxIM?*Nl!3[*z@C?4">SvIlpP}GI_$)9[e>be0gJiI?8~_I.g1u]pquV8T6x$Mg6/3q1j[u=9ZY7|{X)u2.2H&swL#QHp!5j@m+>.vh<H$0:Dr=9W(5oDMCz,]D>DJYwcUi6%:pWtD12yZed)a(!G)mW|WuS/mEkZM@*W~)~jKuw/&Lw(/4F;s"}&.F&[Usmp"RF<J!>7LB*VMBTtt4j?fP7Wu/t)7ic5o+#np$yR&U>vO><;us.{]wGig@2VLR+E$8VHN^7m<]~<@HcMjuR:,J@|E|DdCs#w9I6rZ4~~i}`:&4!;HK1fr+<*DRe(Wutz!CrrZ4KW=H7n}%IL++V+6@GQb$1nVF35l!]&RZN&PBVTu#cq(i":BBXqrlVIIMv}SowfHE`u32a=SL{0~qCwx76b{j7_oR!WK|B4/ZW`,,p`C5bE<Y01(5_6hIeYYuD)%}5Gq)p#?rri=^Vr2N}X&WeM#6%yVX{;|8qGF8y3Cm(D21L/zlrxTPPwecX~jOcwIB6<r7&&T[tu#=.bL5oKG68u=R/5)oDLjZT;q*gjQ:gdK?R)cWuWmi];W7Q9>]7Ecv}F:};ha(2q%x7.%+N1hr/)4Zh:Ud/":t"}o,5+":|+WaFfjLNWlsQYTMA44FQp0Ka83/{JAS9FgA6#Obf*:CquBZkuONr04=WImA!eZitV3rgEsA$jFJIszh2tl$:b.O;zhO*^Otcc2JNvWdG;GYtRckjrUXE,gTV!]I~"Dj)]tVL+u3A([]]6a)ZNmFu5_2ID>2V,y}gD>UM1`,t;tDdl|yj"=?lcp^eJOa$Pe)($KfL$,B?&IM5WDIw~/mQdMP%*7G~?_4}CTjEIxFF_a1=!BvXSp0DOPxRgB9TDjC~ZF}jo)zJNVwV;K0A=~KeBz$j"IGJ`@0JW.z}qXggs>7AH2p:g$nZ!^et+2"e6DY(HRYSVj!pZv@3W^In|<b`R"&:I93._!L=Mx}aUGBZU7fixdVcXk]*&!V/,zw5$^z4wR45Ui!=(FytoTBUQEEVFa[hTONI}rw"/$vFgYjIhMCBrcVf>rJbaez9MX}pKB*IS=lx{8R`?tJo+ydohQ@kz+6rD>,>XR=stIj6e?cKVgx@56|2Kx?oU?kMzzcpi?ZERXm+$i4<r@Xz/^K(0sw=7#4?n`uH+t5[Z:X)f=7??|2f(^d2m)&F+x1rO03L;(^,*nOu5QM=zgq?xU0|pjctO&|%#)L^x3|p(zE@u~Y/seEtTX`wVxNi:m_OvL|q+P(.7WJ&>P&^s+$2v%S&5V1S/,$ty9>eC&W8[#G;n,.O6>|agD8MyU@b?c:g5p!ugGZ_v#!))l+3Sil6Xc.v1.<lh75i^,q9F^LvEzKcTb/#q@`JyD%J88[C?<b8VW%{S;nbdP$,F:TPTy^%ILJ?<h5wvLopvU<k=QP/O!>*P#%(O;fNX(16gvLA(kO@J1|zsRDJYF+6~PP%(?j_HkwA2FDxTb4nL{>XN}@)Prv6NL{@GkGuj:=KmGa:]gbzM=v5s),miUH2K=eual!:z4Yfqm#]&w1XYfqWt.Sh2LfcqFx7c=fx+Q&F/as^t*T1M!cV.|@I)&O$144]~LbI@Pe?yg*B45zsY2,HW}Vz2{n_Qzc49O(?|Bt{83wzBW,+$HkTp;;G12jo[o,l4"22=,Kk3[v?1FX$Az<jUjAlnSG"]k),5aD(!"`O0[?1TzZ_2G#q&L7*/1Fm&$!74%GtYa:l=TMAHlbz^#6H0=v8G3fU0D]o:0nJq_m?OVKG2=CP0$v(&Ev>(2E@$|3~GN7R>N&yyg>tGY]P]A`g:DIkPQafzZ{7xExi=MDdB0a;y,?%MEDL;J*R~"LFFY!O,|<QM=t5aKC~%7QwhtUhWb[uV"sM&hzVZ5"b0i1h3n4`wj{iv<kf!dfhyFZ"=T_pL}Man&^a3&|SR=YbnYC_rlL:W]aa.p8qkDwMp<hJ#;R.GUP:Isx/_q#Tdv^{&|(lj4ji|Q_"6W&O=hqO_LPPBG#?)"mUg<vinWO~{=}d70|8`L0S1w`J(pK2S;mg,:^3CwY5T2Uzo]NWCHv)Rb>U4ZIMDHQA2%q~G^PquH.?&+X|>:OT/1e8Y<D[hh7o4C:!x8&ufVSEBspkA_(Ak#1]]zE`BB[9gPMIl*Iew_XVb/K,ISkdl{CSI>MRJgJCV>We*k{UW$FHA;g<d6aH+|Q(fWCIiC8ZQv=n6QvxL:e>.Ck|qgW?w]G`WOW{2urTR]=xc6gtO]UZ&8F0W$r`e+H2cI+$dgq@HIz!(908$j52:CAS>5OHzbz314CzB&%`dx;m]RrC?ks;IV9!!k"SO*lYV#u?0rNu5"Sq[Z1Ue5e0!x~G[mk.kB<DG+Fq<a<UhY(Hjoh)3*e"&;7i6_NIS$`lf/:EuoDq%C8#jF1(nu]9hLrzBF?UAv!7PNvX,_<4r5IwYKnH}Pl+9x`=6R#ND{}c/hW:x9,JV%W3aN=tKMKCsppaYv/*u]9eXg"TPOc!2[E5g<#25R`Pti6doVtFA"NZqvihd;m6M*%5t}qv{b?U4!y"xO^Ml){OC<=dxnsuNW#+[(=el(wG[m0x;NW:uT=uxom_(.ZS#q#r1jnW(}<>%MgwJ&RWVqa,$|Gt7.q0LiI,$>=);d.5o/*bk%V}zOS}3zN2.Y[d{7TH!T]wH,LGL*.s}041xuSF?x(bhMxFHR>M05{i9{n6)z?&:;4&(uF0py8EpNJB~+`k/ZrDRQl/|~ZZ>cGQDNLs#B}~p3*7Ul4f^s!Mr/1@Re*XhIJKg3Hec@8Ir8Wp9x~c|_@>zDqD{BrD+ky"UyyWm_w0Zr/xdJAxS{k.gZmt!#)S.R+i[@R3z%L{9pBK*?/;6s/lQLn=rBp!v*d6F7A?.ig8alo5ppmo~<@~w)EprUoBB5R&[dzL~Qnf,!YzDI03bZ7ri>u8Y%F<QQo<#3>F`YF`2T)m0#H$|Eh&au#,sQI)jXz39BMl$7Z7GgdKM)=^qQ^kzZ3M<3Z:h_4yT_*`[@5Pv9`m_cM[&Ahb~Ah9lSg/G/P[[xeBp)1<(CgLAb,6*%anQU^56X2){5+54MFL]>r:x)orIuw5>Sw40Ok9*n=kJ8@D3&5?=[.%.<.qa*c649Vu1hORwZOX%pG),6COO?v}A<.%BTCUlvT@{@*R}Fhk]a/W!pP8[J^0@J/kk0X!Z+lJb2$#"(o,%OA(WgcZk2QJ)KwdrNPGa9mjQ]HVOMHFb{3J_Z4R}B8M,:j/N6zb?0ceE?D!S,zo/7:V+4`4parm5o}ZMc[Yh^v#MM3Dgi]?e@;sRz%^Q0WwM=m=Er:E}Rt$W/NbeEHM0,O*vRT}PD=@5X:<m*,M%XioPY8|5Nypfh+W6XznrrXatmh]mvl8</H38Ah*QOU{m2O@3T6U)2(KwcSUNkUBE;6FN,ev~v),QScAw%Z+h@sp.UNqg(Xt[=dt]P.I9=.O;<ggEwCZTeYF*kwJ5BR8h@>Zv/p6sdc85+^8a6ptR6!.&"8!t}~=roxB#wHv/su5oxMp$c7M#A5L9?#q_^(pH6;8]{r?h)z`IhD[JtByOa$B,k$=(&LN{.>)0^mA&Zqo.3$fC1lh>344H)JKIP5zyH.[y07B.<f+XFH36i,t(:|^HL$oZ`HU}P/oG$ohQNd]5{jD},#Aojf}q]N(Cf)1IHks!OV"9pxD?d#<[2Rihe4>)Fp#tc1K?zNk/5Fa=G`lYW3D2oW@,xiWV2ZR4~wNB+0F}olHpSK0i6_5nbnIfdWH.>1^5)_@S~M2UI#b?:%XtZZ?/2O,=/9bzzXd4U3oBxQ^QZXE*]C#Me.uWNU:;x|&T=#7QZLt}dxfii+<F>Ctu;U4K{wDd)`QHUp%MP:uaN:?:Bv22/M7bB&Hyr$y8v1i?>3qIIEtlD+0ydtyxLHx;dCb4F?$<G,Yi81)h#yX$}_[}KSfOIi[?8V*:VR5Eoq.#3)kpc1PCN;7U,8i,P3iWgvoo*;Sj#,%)R7|R~ig8$bUeBfjHO>6c!>:Q~s0SF@<5Z}v)rKid@CFZb,P[_;GDjb,7RX_q"5lZ$*XNuI$W1fa<w2yPZ&IGro,+wlqHq2yT!"XcAjY^.1sB6ULVV09wx<BmRbhC~,D$VtO?Baf^B/,YT.969niqyxr]rBW(/+})V*.,gjZ)dR>XjxX{/MvYSgi).wk{rXXp~:MvJD2*9xZZ}[.},JHsroNYa:.k6welV}cXK7".$#Qu:.1~nFL*nqDj^3l6q&@1]a#8z]XGLFiYqg1#bt(Q5qgo|CM]MZEwVh^O_k.H/upoYL~>t)|X;i]$7KrXK*0bM8D&59L=vaqm@78OX2@v_<oaG;}5?}|+6{NrarT8E5?E|!+qKllE67>t;X5h(PTS9P&7;<v^}NzH@R4Qu~9$3#e$ymkFgf>g^[^rB3j;#+D7]iEOiq{7"q/{sg?n,Z+^/PUSz]Q~Opj*bX90;_x9|r_H*S@dJFjp&hBN:(43jLgI0gqYSsXI%c`"UA~Q)t5V79U@*gA{n4{kDVz.m&$Wg)Z7JyB,1*y#UZ^,OqxUoJ<c,6K{{qtt7IzDW`k^g2fbn0m~$g|yi,(#$]c;Z=i]F4_GmQ(5aBmOA<S$ZKtRR5bMs]=^l>*148MY^F<M5OY/$HY%)[hV^q(wL}.9|;~lb=E?cr@jMial![:g!V6>+0Z5Yl%ll*<Brs##j~OsPR.q#?e"SfB"cWcCky_2x97D2NHZ~V^<4]kVEXXLDzpBur~g}cf}n]=/X%9WX`obe%@Wa}!`E+eeC9Y<P@3eLr@3F6T`v}FQSu<.QQ3i~b3kU{_#&~y@[x%0etY.?hcv;?(sn3|8NeB}SxvJ_i.8gs@towIF0y78T:]1M2)VTlDH&O0GO2e%#z*.oM1;]T)GMA)5j/[C6@n<FD"M*27zUfDmtV9<h$;sV#Ctns}(hV?}3,5Y0LWbZo_Cu2WW?c7n|xo`>oTp4mI8t~B]OPwhVIGh4U*D.+OV~`Xy6s;g/XMHiZn!0hryRJ]G<;CIJJ:yHbj"bRo:i%6PI!laHsZjjncmXYDVv]s;ks^?eywX;!jZKXHS_l[%NFsvUN9PClb{Z7"c(3$&GXGw6#"7Fe,yLg[HM#s4.P"0c(NrLc7I#s1Rm!kjWUYFFSL9ec{BN*.{XNs!EDk7{H&NIY2_Gd}`u)i8ER:PQR*SZdBqaam]Z{,60hDsQ.k|+Ou:jdj$]Y/y*nk,F))5d6B*bnl|.|LyyQ|~ptrVWmKoy_8}^IBr>FkiK[?^YTO&H.u:Q<5MyTk8GgUEd%i9Q,GZVDJ<:W,t>:W+hjBlSf&n06Wy)wN#@uf+ISW]^YGt]BT37UqSE=ry>5vhsb,/i,ob<:CPWf$xUVQ;[W>=3ON/h);ZxgF4@&3%dkRPJd0d5!l}":69)f^jQjv<C%YEl4se.X[JDWs1+euSC&thz^`n5V=~kKl:FM!z.#oRVo[{0CrZ|^/5q+gkNQUg7Tt`hg(yWyo50m&.}vgt@!EWRt4!1wsn?P3udPf*]9}g9AB|yFC2z7GJjvEesEVMFOUQ|}PcmV^_|QZkHLuCuF?T6qhq9CCbcF6fyBy1Vkp_"M&[NYCqmu`>>QjVCIBtAz0woN,`wD9rKiye]hAJuvszJ:K_A_cR/?:[&qB)g]~eoS]__%xa%H?@iqzo]B3fvuR~I~IOZIkn`c,ruWN(ORC=YA!uI+cv6U|pe/7.Oxdv>n)jA~~E^UmlGNZT1lkS}abUW^`>v%0X%cbY)X7%nH^f,ejBQk]o{ra322d)lNJy>`fCj]~(`LK>K<qnJY+K_Pp/4;w(R:N{W7Yf{Nvxv8XMr=OV}4ilcTeK)x&)FxwK]DdyPt!yT?]89"8];~q+!ZSJ]Ot7l9WD`3TrFVu2},a&tXo[,}%z3C*%XL?}f",Hs65P(8P_K&mO},@cMiSGIWZBVI@DB;NZ8#pIBs_YnE%P`9J^_Z#zNF14t2c;:M8Ys?#j/`AT4nFR@UrB7nu`,3gc`~7GuHV)R&n+CT)I,{c}I<K<v.NW(a]2;yzyxF>l"u_e<Z3Ci:Am:;RMCt_Y8}<o24}Wr*ZwNd)1xnN)[U&B0e_([Z!)BYZSIwD;G|@q^ZC2O/VYR|BwR{y=p3H*A!k6L/,tDPDf&bu(%|o`<wh%:TrawR}%q_1NY7p2{RX%KpN$CG3Qabzvzbd8Xo[=`:yGcq%^s+Ef`TOTfKfNT*x@TK!mS"F^gB2%4#pp%ZV.=Bd$|0]uTS>>6:o:j,V9S%Cgjmz!RbO/chQr$tVK6puf&~Avkme;%SK5hT9Z@CMbPk}%+>TEtzXPr@US]{V%_C)MN<l,=f*4Ra^q;tXYUyhtBB|U_Lg^"uLzzT(L(<^iaJp`/zcq{Q?zgC)p<KTj$NELAOG73@aiGnpV$ZR3}MQcwlcU4:%dptnuI)z[]BiO!+B16!o:BUo{)F?6[QQK>lP{M)t)r+=tu$C!b<)$VnQ^2A?W%b!^@pH~OauT,}?c9MA:t,=+r:..C"u(jw%bHwO@n,g7!OD1J+g3)$/UI}wFiQoz56Kp=O2:My8CR$g+d(grT4E}oF?6DoIET/u$aQtp=69ZdI=8=kfx8(:b%Ue4n;i^=l|U$7VWF170<im(xi%^&p86GCaAj>_4B9NF,B^~@kcNA{^P*dfZUhHcO6}<%hgDjV+BYNt?5V]oJ6Zn/LDY$_G}|7p7@OuIT|Mh7_4[ZfW~&]^{N^(Tlg%+Wd9;;k`QbYRHF!v2L.iKjlVd6;sqpqE4@k{qV8p<=#j^*x8&"mGkpecJZnqGknPW%FVp_o%ybY<EMd(05eO3%zUpMsD{xHf;%2kw"$*j:T#VVPi_y/Kh/*k(r~=P/i3&SpwMGSrDWCly:)kN[rJ^}"[b94k,IYBmv=WJjEI[*3%ND[)EH7J9|zaLR$m4Yv^?.eL._#Dyw+CGpp62b`b}xWJ|@e`CD%}G=t7StCR3at%H&x[WCG=R=Ww7o4G%}4GiR|x_PspG@N[fOM.8I3${H4YKJx*:^3Hs$:"&EQQlwGDz2zU}V1HrI}.6#&+HtSn.,joL#fX!on;0/0=f1&wZ><H4$kVwADN[p2q&l]*H}$nOHJo!GF)CB=9~,PDq|(#K+iKRfJCQmVXu^V;uG!WYi6{kk&ug.!pav)SDI"/yHW5uN&VG"Ly_y:2p&]YQa!d/s)Mcc8gPh,*h"XP">05C%7VY|}bJiP^Dnc<z!;P8eT}0hK}FhY~K.(2Z_#r^f])+&zA/A(qowv+d=iLCL;nDU90xmK^mFbx1uprKiTZO)Cr`](~fs/*P3t%^b7^:zmpW)d!MSVg2DUm"3fY`[?a>,]WB7HRFm}PrST=V{Z&RT(}WE1q2upni*XoY&i*xL/xRoOxZ,8"h.>5$+>O|]2Jr[to}Brv^7*txW;w|$~xll@{A*vJ9)Y.U`1(V]yDk&:9A{b@6{f&k)GU;*}Ut<$uUnz:uF.|w*r3Uj)&.>Eq9j.nM$<(n/J:5&3GP&gWNN.z2CWa)u$GvjE[c~dJF[r^]r1c7kQd!`pCiRn9Nz3W/,G!@}P9PIr&w%g{L*Ry.oK7>B5syM#m?wfzc&/{eqQmPhG$|Q!sZ%P?o_kT+tL!>VsN%8ZdN,WIs.W+=E5|Sw6&mn|<37lRz$S3D`6i7?I[,B*;xlH^p}WuP!+o(o/#[z0B3UIdt!_7=J*?MKgHT]~zXs[n_|asGG+Nr46L].:Uqn;[?[&:v^PjSWHDZ"_KTEz{:sI}wP[9cblB`^H.74n,oXOF};md.V@IKHAxm0ex)U[7Vw%:_wmK)s+"3%)[]6U<(K{]Jr6dmx%ZiF)TWdS~P:)AHV/pbX7xl$ew$ro%eQ#/8g/oMC&N~;R.VlN9"F!a4l^094BIgR(}W>NQD3Mdn~Y4gVtpgfZbXO{}3)UB81(o]Bhbz}+;6/u/sL>i8($[SmmFH~k=[;jg7.*/=fBZ+KM#DafW/juw4j[2y;/lds#g`jb"JbjRl/8m0`jHPZe"RaEp6JDV.d5PQb|GQR.{c$z=R/ojRQIdwdA];"c:F3qqCo=^uNL"FtJG]<#8w)N?sKzEro@,H2[`=k3{Tun#lYe*1_TV@;h#!ZB2%jcG$,:s4p~0?0z%{yam>/E4B5<AWx)hg{(Wxmu[S#8lSp76l[alKp%7Ze8G(.X+OZF/G2Ns<Y&gvsFv7d!F1*N86PF>,%^o`Rlv8E]a]92q^_j=zi9(V&WI`$FARDbfYb4<yuR.y,,:jMG0Sff}Cz[}sJld&2Q$k[$sY%:Dp5qb}g?c8UGTLU62e8?&&]Yzs1(cZX6^N^V]&w<iS8/1iHhPlbb5ia@9Q[V`VRIXlnrmnI9dxxz(xja$dG%EVcy+"A08kjoefWM[Pd:8x?Rn{K^PsV4mM5qvrg2g7lds.;`h+x4i1_HQk,,nc}Auyq[;5WQl1iLdiR;{[U&E*6uo6LD49Rqd2m4qMvOcY%5!EW!aykEf}~lZQodD9w/H{dihsA*[*m9W?LOJ6FRfY"bnOu;k+MC$G.J7+1gAKO8(yd@|Z;8Vt+$&4za_Vk;]8IEaF>+a|E`sIY6j2UEtipK!&WKn?_pZ~Nl}f61?AVHvNsjwX[47MZEp@E#S%osZN{*65Zb40]/5]c+UaT&.at6zUbiXiQ_`yvYz9Ah#HS~XSpV<.8(7/u958q#U/Xd8294S0gDqxDSHvA$;YB}m9,Q.tNI_k//x!j$=.6m3tVW?;iIfCSZ4+[)#P4OyJ(R}C@%u[DT~.ylkX/KX<xIh>~ix#|}^b23c0G~_/eOl(/Q:UyA3U+f#l&~>O~!pfmO_{JdHR4v(GRd6Pm"yVLz(,kiYD::.Hcj<?CnZ6KjcyyV?LV>H~"d5eBoRyVlxE94,1`Ob0kb4x.p]>u?g`#1[.OU}c4&>&n(c7rlUnYZ~M:i8^Z3!VR]hNO]#wFT_gKu>o4^`or!hf<UP7#[l1r3hUT9r</ROwCKU;*;9okF~Qy:3%1S!R6^#2TfU!>sVSL9?aXVBN@MDPI*_{.17yneR`PO~%vj>#<CD~vgeqa*zqv0YxgE6T46*$CF/&IaErCz8WW&#fB@!$+4T[X^kp>v$KAaun3`gg^:.g|WTrz7.kM5azJ;OBrZSEiAiQ5s0rpD<"(hDVI5@`|j^0QJ4(oq0`eKRJlK)=B3:CbnRa?#7vg9[[e+e<1i>k=~QmAts}Nh}/rwPtWtwjMb%jgF]4}y,URPSsO8`OsS6?czq@$X`>IgB]vAcLwyB!3:3v[i">iRh[J(q+..{qG]g~Pz=)]?xzw@Q({oIcu%D)sR<UaK~?=`x]E+GSmt?W|y(:Y48A($ZOidwvI=B({h(XgwSU+o{?{Mnuzw>KQy!+"Iq9a*]MFzRQJ8j*e&63yNE^4KqKeUB/"qSq:[<>cuDBvb"x3mi!Xt($b],If/,:M#aBKOA+wW.olQ~s^%_.rAhHwS@mN`$,qR7V(G@v;PX;)=vlouRo[$4K:8{QuXr<iCX"D;`OBf2y<pdO5tn2^"u3sl);B#s,_$,T7I&{iRb|[QB!9iU`aB<se|1n_ReD6C%u/^p0$N1h^iJtz#yS<!UFAMD2*Ht7TM1[i3pf$GS%#::IkIF%[)=kpp[9>piBfnTkpfl}}f5BUlI!1E&3$[f)u*[V%[X=EWxp3?j5Olk=0s;k"En}[VVHKa*=ZnY)KUYuiH1o54^bQMZN<i,(5eiB)az(f?a._KF"3Q]Ek2vmdy$.@4Fm`P$#/>`XI%2BSk96}nR:Jg,4pLknny#73X;XdE}K~4)$MHUksdh0lzET,H.?WQ5CjW6|A4tbUj_gGn4CkaA%ju[4&W[SS]cKCpvSnNP|9y/b>n^%`<wV_e$cO;9^M[44b#4]glU|?:GlkIE.u`_$OA:"GO=ygs&_ZyPO{8:qf0~{,I~J)"*(~}=,Ur5.X}}`u?!G#JG.xyW8p^u{$:"Q1htF>|_%("}V9VOB0$wIy&hI$uf1lG[Clw0%O@`,8JY,LUkY_c6KvRp?Tc3k4$Wmb_zVlw~}GIqF640Nl.$OcM_VR+x*,Hz}h1vc=0]i:Y7t>tVcZbo(5OQ;9)1@$.+YP5u?#GGVeUtwaC=S;JHWFCo$A4XNK`O.(0J]5k}#N4qqtCv0I0s<6@E/^rN#3Q[_C9thnM0~S+x:OcrWb=7mI7VLn)(vh=r})w1<TPGh5WcIMo$z!oZ_*/{xUMcId)xzjf/YO0j*Y/$3y~U`;Ohx=aR&DZ9eY|E2H:?@,s2;]9_;,jlS!ysUx)s6pgk).<%y]4puMfCp7h5KNq:&_:eM|7vTLm!r;45H+cr"sh=7d8LpwoPc}F<cwK8ig0a6@RpR)7JNu,zd&F;IW<xvp@$BjI<t<WpozB<P4o1YF+f@}%gqf!i&;H)03`Wmx`[VJE/?|ptBV!8R%U#[nB9m~m<Lev[>z_KVo2i*n#zG3Vg&(P_m017.%b`NvpTXGtiku2~9}DH!n&Mq"PFF@NEZ_u<y^Q[=vWV%oXPRJZS_)ePrz#imKsnWmx&P<iVhKP1}XW/CVYQ;8bX|aDqYFhNkp`;{s+ysNae4Hy8Zb^&.abzl=9C:]fA49FV)77XUvF$#[a.VLeJKIN<i<t;w~=_>6pc%N+eAg)VO{W[Yh4A;9E.L_*,PBfaFGVh1^+W{j87ha2o7J&7$Zi,2d.<@e):jj$Uu](_ystr[`k3L5$z025bP.FfN!ptIeKU``%fh|NlGBJL2*5wk2#a<xY7fw@yci,reAs&NOPJf3XpUynyDrg!j|2zER5K=w:N:R#=(H.tTPX`01F2ae)@DEBetl%.gXp{/WlOC>Y$YNSm<H0RLi.|<b.z[hzZ|MUs%<$)B:4?<a)!H#Y?qEq}g+i%%BmHyqA3=A*=p4T$cS/10*.4rk`%=}@MFQ]r}C<Fq2/#_?2}7e+nB<f=,=,<x1hs/]|>V^Co|v$<53I@I>;"6Vu21r3:(=Sv+OGs.0mn58.erI>|q%~Cp(CI!D{O:xuv*/z;WX2h1h@l,n[>?N[fQD4OV)p;dpYnRI))oa(~Pv%hXwVx0WuVbv^<RrKt$lqGi1Q~aAE2#kyPtf@G/3DcqSJKjbX,EzeF99!B4ane)y/_L9XQE<vGY"BGG*Q3v,h(xwERr|p$uIRkUI^>4MUXCceYEKY"^M/psx<nz<Pl5($_p?)XY6H{7BaI[/ff`wr/uAYsJy>T?pJ&]Sm?Ud,~NyMtp2zs5PrW8mX:J1/_,:N62uBqb;GV2ME5xD$z2W@uvI8r"g00;pS!4O>Iy6,gT5HSs$528.xI[8kLeAlKLB<0I4*/t|%"`JxQu#=*g^[78"NJ/;/Jy}:.@>j9oMB}H!iMOcJZ<M0X,ZXGKmmK&Ddx5+.6f=?r$Sl[:2RGMJvfVq<,dvic!a[xa[ETn}KblpLxVXpr,vvuwDJa~y?Z`D1G#U!CKt#hDV79Zs)1M0b4wl>8bjbHad/lw:Z&ZP)|KagM|u2BEfucg=WTlvg_WL2rX%n@p)zsZ)kLkd6&[D3)YnzW7@f.B?2AR~2Eks+VFqka0UUHu>W[yWGy|Jlne_:BMwX5c{6puV`gI@toT@zM6X8mpI3(3F!_:xZI@<H%c)Y*mK_OH?VO>"wQLx%~v!]!$4yL0r]vq+Ka+d<<[man#IjpUA_}ujnP%w+u:/2pmtai7eqFbF!2yEhskuz3vMt*;BHbNYHmi>[W)$Vxqgz"=]t:G4%2B*>*8V9G[MM)<!`a`Zk_[J]u0Zzu[N_cW!)JPUZyoz<la()QZMvwRz*o+S[J0$T!p47N)z{K*MTsY=&4de1}IXY:F:.?s0?:yF,TNIDDukJeaN`Np=aRjHn%xi*gsnMFQ*d?uo0?#pGvJ5&/c|(44}/Z>Du$d20,4b4:1usewK/|sccUVnPk71f(jb2B]R?cjYT0y5INDuznd06r{M|PPna}}HaPDcI>Tnk{u=![bQ{6Mifgx(S>);.y}!]jMZX)i.dv1AY23h995JZbV)*zQ+R<ymm>g$=d|rx;pCCG<":B_X{cOF4?O^$L}eBB^{$8=N="in_?<SCft}M(dI[|cl({k~<]Il7<fPoU)|O~u}&@4>!WW1/8.J9>TW.z*IgOwsy~*^YJ~c<AOq[7L]tt_r=k52M(]SY+g#8yn5t6L(Q<c|pf+J~$V*1%w^9>mAzf9!3V!"iHvqdFJp.h]ay1sqwew3?D.*3zWkLpo6>w)oNP{Lf6J!6o#]VR)Vz~zFMmzZPB9R>4ME,(#~4)oH?)IVV](^Kd=>UJuGNVXp7Gz&x]pM?$gCv|D{KqGm,x%M(%j`2lwCjTk]CO[S]8wqT*(K"w+d"yh)3K>Xs953wM^X5#P:ljz]gmmB3#.Hdu9H4wJTN2Kf}Xu},PcJ.H[V~)>otJO8oswZOu!HfF+!gaG>Q73/fUn}zPC?5nhhGk~3b|+rF)&e2l=B)6SlK;Pf32(fvH5?deNwPiiBpNXz%v+&y1E^}it(HR8GaaqF(4jInnbuWui<F}Jt7"3*ZYl=8E]JM5hT;tUIXM3$bi]v1]>Yz/7$;V<.m6qUm:vh/5.A*Z%ldZG,N$]TZ4*37NlfvS0gien|:fwjE"x+a@Hr~/]+!/,G@)gyV5G=o?6xvzAM4(d7,iwi,2DCgZDjXi;[qZrb+#pytHY`?Z/yzuN@7opjX"?|jbBV5Y?4enO[=>.UgDHWXm4oTGjK245!x|u[LSV0{f`37z%(vAkhdz*GFi`|5mZT,!0i=gdBxp9AB:[#HS,vYjLD?c&MzvExd,hT/ure_B;YNC9)w@Y^_Xzs/2H*</J&;1`}xtw8![Y3T[d@%D}Y(:NacTRs,j28eKBo9V1L&MdK&w)IGwl5dOh#!F!qsO,uVG{cpv;]dNy}/C~<i(.]R"gNc?J{{K(vQh|u9HnV8^~s/L7un}ZQGN7u>,9y.a<,2<c``_h{T8*Cy$W3sFjaC6:PNri$Lvkg8#OQ$t_+E2?*U+cg{xM!>c;Zh$RtSk["42,U;=PX>=@K{<Z[1/l^1i#Ch2_7@fU9(&n|Gx%UDNT/JHITy@,Ot4MFW;[fe%WW:,iPdJ6*`z|@H}u7a:y.5Mruh7VQ{JFS=KaK%qej(z+SeDCcygTr%{Q&$^oq<)?>9T:/n^"4yQN:eE/_9M|[R>{U.o{O?9dZY6~i[ayB2)7]WCK"r1Qvh@,QWqwsW.*%4f8`"t$l7$Pqf%d2J!N^kdV"8UD@JKqTYE;Z9o.$wN%vY_s!gjWtUy5df{G+bDE735LxW<"h$]w@.+izDf5,BL<EhKY,m@3?MRi:4f23YzQ``iE}kQ^[l@EZVUkxxu2s/;TxcOK`1N<C>H$/Ypg+tRptHTh@afYuE&{ez^ijoz[+!;MttmC"|q&TVk}d;Q>*Kmd1w:G6)gCS!UYYy5Z/=]dw+BqeNjkxa9{I17T^3m%9~nq+]YX1THfxRmFC.x,8RJkPfmP0L|1%%!l47C@*$@StoqV]%rPdrr60J;QHfsFZ)2[f%{HgJDN$b*,+rG7O12&+b30W6.NR8"_ekq>mG.==R+LQaD[f7NiB4[lKnJdWPTW(F^Cz2TJIq^@nG"Q$_Y&)SI[mZ2(+F*S_Nwd[`)n1(6a#lf+|G"q9W<O;ygJj5QdDaZc{*,;YYy:n..[.q{@*Vi3Y4S.2oBi#v+nDw|7[s9Xhs[dB6.bCTX}^jx$mec7OTowSF.<vAWVb.tlgAT*]1Xec|nGC)pz=.EWc+R@1,=15QL.Pqb4*^;PTBl5m7):qD)b#`R/GvPM}2&ZoegH~FAZ7OJCT6Bl1khPY>.sVUl&;oA}W[`q)Np/oXf{IKOtNRVViZVtg=&7+6Vx4vIf953"q/5qrNHPb00;qd[h`/K`%@%Ib)3;`6{e,BN[(XA7;`>9QW^;AS1kBS{$HG(Nj,mX,C.U%52uRW!xcvUW%}w#]qlzs%>$:$/^/)>b%Y[5w;6t<(1CoRbFFeWZHY[q_CJ7YyxpBF]IN9<fP"8l3_M4J6t=;d],4!&346G[4<(7qf@A&s"23x#}5E:`[A8S+eDC@|KulvB+[Ifz|Fg*+{!Om;U(L:9Nj[@P*tcbv+~$<t!O+rcWbUyAB)>w`X2O4%Gwpb;]FjF`wvo*J@RDn_v8Xe;<%f17:i(+)6uKZ{/d?v!?>}MR:1c$7pSI5"s7ci9ED/rV~^x&i^sOb|,Xrb3X:*NUJ(REKC9`#PW1z,8LdLhTIyDM$+fC9QO6FxkhOiQvre1KZ.7wCTp8]zQ(SM,H+q}Zw#0gY$94jeI0=DZvYHGmi.,:q[LNetNb5v*yce_iWeEUyD`Cvi(_wGN8d[#aw+)"!Y0[HDN4n!JroH4;H*8Oh#AkH]2jts:D8Nj)]6Q:^a=]=IpJDbQ0;vt9H8<ifT*_VhY?l8f>?^DV75b%,r];,zZR`vfH&/Kqnk`PHwP)TU!UeLR!K^g1B9Qe{80~wDAXPzNC@0LMSi~v5M&Gqc:Yl|/YS=NR`&~?th!RW2O&IVN`n}3,E7M~mG?CwEB+~K_oX<AZ6~"C"D9#%PLQw]b`"jyqZ|M)uDT.b6Z}VH/PK_X/P&aSO6BWcDish@4oDV1l(c`t]5qeR5im%]>qvP9~HK4n6_rwIczESkyPM&k=]H;&[@^,[)V:)@7fOJZPW@PJiS8pL)apSpO{,)^16MrZ)9Wl71OqgnXF>G)m|*BBT1&oD~?DjYMBE=7J)5qtEMZ.1koXLcI/C]wx%Z2$`C8kC>C+PDkz>P^;JNX@{RbtFHR$]6g},u5PL&%{@:l*./A:rC~JhU4C%mJR<3KyHGk1yUt61{pzJ}mNkc}FDp{n?v$||,%1lc(TnkK~+J]67LZ2bnq46_&o8;m].rbHg;#RS^5;i!@(d6ObJ}ijpjbV$(,2]5p$LU7!pnqxoC}N<1^]Z(UN1iS(sjAMwjV|!|XHVQu_V{x966um{b~qT}+8Vi_ei+yj(q8Y@&[bmCAtf(""B7.e6Ca>BLbKz90QUB=W7Zw!diL2~&2z>Yix))#XPTwRTXo(J$k3A!nv/!LJ>,fZm?!Vys#M&j6H51<^c1:X{[l~VStz0<9C"|IFs/<VY;Zm5ME{]inQBr2]T+9^=4b_.7x`Hz`;Q(i0jo{oZ>}Nv[7pWNHOKcdTM,8DraJvgGcsPH=c_E$$:vp6kru+f[g<?J|zTfX{},];z?794QKx64)3Zaye4*B>FuYjx8UI_1D^,H?uER7pehRiZC}lrShQ@2P!LLA{$gl(lCkE=u[$4Nvmm%6B3Uh3{DO}!YjXQQ;}[0:kf/Q2}lQDvP1LVJy{a("R!3R:?VU1:`"%pJRh@&zUo&XZ;[<rM4B+?GQh7pQNlzeRj.l9<Q^_:U<^OVD_2Qn$a2|gpM`u{s0d[n1XGh7~m>),6XY"/;LaLdFvwi%!?ja;WhIeu+6YO5SJB#R55?_6Y$7.Nnnu5Ex$4_f,NWVgbr$,;4I[qen:tWGFRAu[_ZFf(;K]n.^ufJB&S`?S)ZdGcp!Q&oCc{,*"^a,l&vJ^8{N,+{ep.u_l*4_};=Rw>?%hvuR%)6@.4_:m;9!.){S8b(YD@E|R}$DRJ~s.}IryaJDb<l6?H{6qgck4;HjN0"D.jUGDrm}?YVv`?q|x}C)oUg%%5KcGI|)@Y;,=1!oeHKaeF<ij3pJF]f[|3fOSJXYmyUwD"l&b!g|[zu"L}2BzKWMv1Q^4i8P#~VMB(7yPc7I?9g{w(:xHfsGVj&<hr;l#w4mADzJrfd6TBE)Mm/9T;yBQ&QV0Y:1>=6QW}b6xae#b"?nj1q}op6=ipq,?V;6&1ZIDb9*Qq9G~lt@yc&rjnjvFHZBjgz=06ef6&rp:E0g*Y/i,[<{Xj<o7+X#GBX}mo%Lm!tN[FtGF%=qp5x{{!~/R]mjuOg"e?Q"`[c#(_db5o/H#F@nK7GAdikZ/F1r04vEV5}FyL_qk:CZ+%ghA^?r,UCn.3(Y.!J,{+d),q1b>$Kjlk!Xa?1%;k7ZP+E1;D_a@+)=/mUI3BfYjSbI}z7M%4^CLxj3nj/ljxPdbX#u]N+KTF99&lfTHP6|aWNEt*6Bl!0X4TQZH#[ltDB0xbcU(#Qix7[W!gx>/1R,WzcP:&)kLXh~C+m$D`JFI&~IQyalAQ{{Dd?F!!7E8BnLY6#GQO,j|gg$&e<xj{!:s{}JzF1a@fB9=H];t?,R0wtV|kX:~{us8o]`XyT12OTQF{$Bsb.T;aKn,H"11Xog0R[<=eYi><b:eYR5)S2RDv$qrg,w9?J.4wR/R9n@Wd}.KUYT3fmYn4SxyZ?I%GhYCVH)@VzNb$C<B>.JmKRnm>GuY:yFQR^JXSg%Os)C}6)df&Bjz9,^XrgU!3^"j4+Md_?5[wF,6$]qCSf9z*v0moF,bH<6OXjp<PJ"(s4gE%Tp0S5HzrBlj9qyv6bFJNI0m@<.f9uI[$dg(LS8O@w?UyD`%l<%619f_e3;RFC9^gV0EGo|[lO^1:q[90g?3+8v5j)%KGv?rT2nn}xT,P=3Y`ue.WRw8`T6%H7i_([(<:{7Uw3p^3ga9{s=~XJv`s)US.R[RcDaaN.s?{CPh3TBG3Vb{qA1ryz1W@E":}rlln~~<$aYClp$w!&b!64b7G<2NU_(YW$zbkj}inGEMCh2f.LWWySO?^wZ^rlGa+_M.Gs{b3*!:wl;,Xtu)F<+ao6FQhY{XX,vz)yeLgQEds#5)GRHp4x>D0q&m@{q1q<ZRg9`s9e2D|)AQu8ml_tPsK$JA}F~pK4~#|Q5,2GL".MMvc~$cS:<]`L7*iyh;=k4_"a5b}zRPEPR+4mbA7,(~m:5Tu";B,VWej`f;/x@;JkOZ3cP^WZ?E{>@=3GRUq;EA*gx*tC1p"jjse5%#|HNVa?~2<s9)XG/7if{hF,2vLms,ML*]gDgLkHHzBhF5~8/2*7*Ies>_"98uj;_q#b%@0wJ95oP3#GynDp*fA*GHeiP6XHKIv$5GviwmiSczV+sy7%a?e@liY5VdT($MA[%F#:yt{`Kj3MeS"c,6[Ni82i<^kt&o{Og!!}e!X%#1G+Q5geP{<DAfic6WmUgN)#gqnhi0@r,F9|)C)vhOh&HL=uboy/;1f0ZKujNFq:uA$F)b|>[L&x|wc8=jpP;`J{U#Fx`VseWT1F6<ph1N<uCe_f(PO0%D^B?:wMG@L(n|ZQR2}jvi@X;6*)#*Pv60MsV~$5l6BIs|7PhOnbR7s{Gb?wHY/4:.{D;MQuXFw"8hMF~i(V;gNMC8:k{2kaxq[:bZO3Me6_Po`!h"d1`NEwvOe5pWRMQ@s)0K|B9&E@`OBBkLVCy8T!M7B=U5@fMTy*IB>5P&`2YH?:P&fR8:;6(%{=y:CumG8U$0vNGvnz:KSLeQOuzqgrq4c`kuw4RbQ<;mX&jQ*TsURFGPU`)l$Z}i9+Q:sp~rR&~#g@^Q*!%oTob`9hN73.U0Rt0egmtOIxceWNiXeC2(+m{i57|5E#Mm..t8OO4opK5sC,)SqmqXTVa?w8x=0{|7=0HsI:]GDAnn(pAN?8|OnKrr6hX{RLTLuMRUaO@~:UQa/DoV$3OO/qVq77$dJ(kMr>jRIeb2eSkJPkd3MYcj.`xZ)%!TV.,Z`ugC#uYHG,YECuK6Hh~%m:EWA#FQ=We*HWqWmXRXS;a>oO|kWT]>L@3g2o?hn(|[*I^L6_T)6np;4TXY!G1O2[Y`_hjN7BuSs)yj2]T#p~l<lz{AHJgsqUsMw[NkQrF4FZBcpL<VI`#CDv71?+4Cv.w1|qV}Rn).g<qeIsSr]x8d!yh$F_!p7!{XyH!}>T"%)~Ujd6;(=.r~z##lgqkw6+RajCtPWc$aAdf*NQjYv%PoiC@4tlnocx"JsJeJ6W_CnHE*n2iDZ_6TN33R6hatQdxc$G$8|S]Mm2@]NJ9@@k,f~pLHY,=@p+:nZEuo;lbgaGKM&s2Hq:f,rGox5a)1RS.?qhf^OwI0bvLY7Y|zingHrt1&|>P.0CCNr#9U/oe6qlz7/4i1a7~j76o1TSv)5F)o]fLlDPCop,NXosou2^BA^NR8fu,@*+k3V])sCc~dDwW6<I{*>j^TOweERo>{|a*5YxpKr:[T~Hd9Y$zsW)q7t[(aukq,l@#.xhJh"%eL^n<.b+mJB;>{P~H~Xd]}l<]t7B]UWfbPD=0j`q@5<**5MkH7)S~!dlOOCGek4TDR+H9*m6:G,f)2PdKm_$K9~XA<[7ecjc[*/U?I&?x*Xt]muD"|zD`*IW?|2RX%[9#]xojCD10ZDZq2qq4#GuNaZbugU{`E)RKCCcqV:9pxxQUAYr%RQrh)%@L{],bz&^$bOr|0hn;[^ee+a}&9t)<OL)8)CZ`TIJhZ2">@(pUl_k%%|PGNH*8nOJnhx![:[9ms0mf4YNd!t,!d~ENAFsVWD4H%yob&L!a+<ks_^r=|U"W!#sI02u@bSdHZ#_Yc03X+~~WxP#wYepnay&)zvCkMSuFEivGU6Q]pXCUKWifMc>Nw{tB>wi,$PfykJG,&AQ{n&g,9P98G6+|&l~y|0/]`FJ{K.uT=70q,R$Q|Z>]*F^eW)lc^D8QipBP0Tj*?#}g],2%PQ4g!O~^}beiBI:E^c!hnEFTCH65D`N_*q4)$g*"%nj>0)LLh"@9$c`?*FI9FCOu%_`2itcRZ6`uf!c?[P&$F/!9[0P+m+Q3K{W~Abb;?LqKv00<hM^S=f"Zspyla`wnaBLZ9.&MCp>2wWE6+td%)zG</NXZ8m2R]n|HkB/z[URVjqPTP0]d|4A2o9(}mB)0w]B+^~7&J642tHl}Zr@nSWKKepWXt+gVZSaW4r&cnp@fi$Ou}yPd96T`&zc)xDH~J5ARfJix7yc*hq?Rj/B=SZB:L/0h4/IQA{DeucrDj[r}PKc=&sm>w8bOQ.fAw{<c"s,0}=a_J4wn_V(|3m!Sch$XHSvzLBch#LgeIk9EeN~jDypV&bP%Ih~$rNXG[o2J%fMS<^;;R}Hs:G4?0Dv8d,rq(/1j5p;}zFESZ"5orN}%RR*D<Jv!Hi07;@V~M?jnvsI(<l#vUrs%YCPn^Q2wD=W*t^_Zgq4[PIt$HpPW0D7wy;:fFWj.FX">i>ic)ct76j1]O@c}wO#^TRngo{R%!Tpx>tjcIT8=X6J`)]P<%RCK`ySSo},f2$*hzDF(+,$qL!k7jflrjwc;H;~RfVcp[WmR6GS*)/Bw2AP#2X3"x`t+<SB@1QykQ[d=E)T/V`!r6D6U*nd:P~>]73]f&;9N`Mu+_|5`[5=};qUgSZN8kbbRv+x9Y(M9Nzg9KmZ+/^FYixsqFq(*jG6fpF*e8iFb?[JH>GDst%`8On0OGK[w,4sFO@kH6$+MFpk0Pr{}Sy<+tCW(D$%_~uo?7`I*hu]@l!lBQX${XjM<o@rX8Z/A:GY)9=V<&Sj0z0[+s1`CtwWuXMb_y#!gZ^"j:]IPC`_ok,+l`7nE9^=)iCdq8&*Q.4b=b`#/D?NXBOePB`@.9hxD^D_~nlflN(zU5Iyp9oCmxM@T7Iz7(1Ih`oh@5]6n>=xx)8coIxU4YC_~A%6<JTy!R:)[n$R{?b1|waeQh5XlVLSba9h*z[8iJ5mPRw,;^FlkU)cD,{JioD1Yda+s40E[v~Fh26.9{$FF4c,)eFD.o(cy39E<9#;N]s70LS^#";E&"[N_mX[uNT|D5R0(B??(]AjCw:"IZiNgkKa(euQXxhRL>;aG`,L5<OYi4E5nvz=`&P3sK{|[h5dgH`LcUpO[>M!.WjL_gks1iZspVYLar.+1CibqV.f76giQgWGCAzjb0Ozrs*Vw4/6D#b:C0xZ/efQCi?bS[n6z57n,({tU$LdymF{7]W}qV}?.2!F/2{[$@3$8,s4OHj8rjSL9@3r[CnLxlE2p>rbq7}H}RqOKU(5]X}I3S?3*pku@p<~qruRgSQjnS"i#v<3h<bKDo*}GU=sqYK,&Xql9]4Ln^}yj:Z;k0[I4f82p3>!L2%~9BD[Hy1p73s5,D@*U,bw&O:](HvtoO7hS~WG#<LVO997{H4ye[mphC25jSMG,tY(h]Vl$c[1Tzvz:~U{T(IYSzu(`]yF8igz[R?WW^fH4Jm>fT8aJ0[XsVq"x~yx<SR@LKG+VA$2J][$HwA2!FPb}2%#%6A1^e{Luk9B/iwkZk<j3E{~S9*GAOPqL#JWiL(QIz2TC(:y>J%s07g)}^G=!R16[.PRabz/%*CM~29Tu,c?$w}u:7ErIF/+`(C$|ULh5lm#jb46IZp;`0c%[0*MlB_rhlyf3{7Prp)k&,=dz8!^/NN4=*#v]O(Jh2ZG7euFu1>mSk>nJAiG|b?l#4^/4??&C}h~/!zXF9vwmx[T7;apPbb:)Zl2a&|+yo,z])U)hW(?qD%zw<NvHm`a,<.V6O/k+xAycO!JwYGrC8=s)(X?Akzn>;We=}b$1W2NuQ*%}!urL=y+nB>h<zX+_K$i7OR}X]c03LT*P^GN0j<GlziWibGnI#BdIfcZ:[(])*b7A4cblofd0@=f_p=y!)!A6T?5c4:u%^2amu]w^(ohr0f?52@?bv1#$h3z8i<3wI!%;3&DlJecM+&8e93.%@W/EV52V|x8O[?Dy)smtP2o9lk.tg6~0KybH#DJ>OZPlNtOn*Rf|:j^PN}vkdIB{<^#*8=Zj#}Yokl:I`f`{?`5*/xaWMVGYc#?C%E2Oh3]b5a?F,wQXrzVNR8jI#_2fz]Vu#"W+TUM[q=#mw}7g=)f3!F8d.lxsmhV!oV7^Di{?{2f(QKsnZHq>U+;Eq27;l:?52HhBk_QV)a)d&_vzW7I!#(@ErO5(aKe;8;6hUSC#T[hwRW<%y~X:[U/xnb*{(4Jr,8q|0EXdKM9b0"P:^~HVzUcpe:"jOZa.&=X^918q!_xD}+xN0(R3kQ^XfG=WpT}[i7Rb>"Sy9S<a"qN#r@7I(oP?p;hK}#7`Fo11Fe]r7~}DReaG}~pA3i+9=C0dNHEO?>ZrBR69/7I%p}UxzVZ4F#<Fu3qci$@Gw)pg5(.dx.V6H1=HQ@z>Mz/]p9qx.V,;=<Iy>b!bm[jDpNr8O:3f+@T*WEm`>F)P&OHQOIG!80&W4crt6x8,itZ.LB1gs73Y#UEk&Ra`EcD%F:BF$@2}2MB!)z|cS/8J05d]h~+$,hXcfBRv5*C"JrIFu0w#xlfwrP)(72WV[MqL`N+Pu8Fmzw"ocf3[}"vcP1CBB.BRqA9@79Dp/DgdNVV)&LjR2wun_^Y;hoL$)KctW;MdD1I%^jwU9"Q.N^(DsO2QPOHIO~~(:D#ZG2!hK.`T<pM2k#)bd5HkRWv8fNSxwcPF:M8?>H8`Z2Jy:?P=To6yjgL~IbP1E+fL(|Fsz,=8ft*V?@]`G$U`_H]yjcK($s!vcBJ?c"u7T~+qa[82v}Dc_5)~y,/O?TblAd#L_L7}[.>ohco.?_HEDs>YF+{eRsqJf<9;Om"C`LeHHr9=S53f/"Ybk">T8oC.fJZ}E0Fkam)$#qpz%@Ud4V+T#?0t[yPP0zTKLBb@{<jk`!/rav5;C1ElF&CFXMuZQCM~,]%gZTX#L`X,,{>u2|8SYgVbJ+7Zx8]HOv>|$OicFoydO[Et]@ec&43o59*5b1J<>WI84.kvdc;LX9R%;xifipE<&l5{:*4/?}r=5xg;,7Z:=Kv=VcYvPBb:V%WC=h{5~/q#QM6]m+i#He3c`7`AGJql48KGyB^x%sbe~.Kk1!`IoI<IQQXSPkEq^{>8cj[HaGx.Ut4)<EP)!VdY[<ajYx(0pG.wV~5eR*_?.yzm#S{(Z"fGoHL)Bp>d=jrmcP+Hi_,EYHamnVa=t?7r`;NkG{Zx:,CcyVdg49gav`MZt710E}yBE<qFyN8??B7]aOApf[N3;(?6`B2JP`HccY5j3`5Ow^+}Xo;gRM]awC]9I|C9H^tE.aa8}LbC&sqzkm;!C4cuoX74EMG!Rf?p$id#p)YECH&kZs*/CAKR~EYa$}SoNS#:2qA_q5SmOTGMT_oelPcoWnJZs):u|:pSXdUiEQ_X0pnC$]aOV:]aO*heMDCo#O~WlqO|<BBRh!fe>g*.M/i_JyS]Ix1O_Ny&HBeaz*:([B0OtJvflarkte>?I?7HuXn+fR[Yhj6gl)90P)H^Dvw&z14z.pN#0J!~e>S/GeApbjLx=CpADwXW@^2(KtaN~OJ%}LeJEZFEgqMRGNUDFE6Chq2Cag6G+57[NG2$$yB!iZvM^&kv}PJ|s[H&FxOnc4i>}D@NAh9+:=*B!|6P@6]PrHFwMbzJ!u&{`ZxhtZknFYG0&cQG9.^ffGDuHR.)Utd*+1F5Tbh]U4W$Y&^.qSre,&JF8sg438H/>4X/z(_pU.+<k]{m(`<|C_4^m,4?rq[DXjNvIly+u}9nrJ(N>bbpegf1G#n$Q6c690Hsc9j8Qp.YFZyjeLbWUm252){jyhtoa/:vBwt(ncSe?EghF8>d+|Nc9.C2v5<FP/wMuGjkC/$+u!Ec>0uMvqU=zp3zs;!MxfQE`KHpGQ^T,T$Ayb.$Yq[s/*:."D5ZHEFi/a5MuPzP><cb]"L$2);y:"TrS^T2b5i.MU"]KzpN0r4SqC3Pk$Ywr<2iRVKZ7><iCwVLOeJ(+~UB*kdsj."2392`nx%"wt*SU@ZA{Kxo3?:mTWDFv/3{L>=C0;eB$lS}03`x{ebR8*CMv,7<@|*8176.1Yb[^?8_.,"qmd,8[7:iRYvil#_!vAv,5oKO>?;"Bb@)96X^6W_yG=PkwxuP_bepeDM0D/Q)nR|u9|JBY9E<^~6d)Jb)i^4l"p>dC+e5<7^?;PMmV!H+^vB55R(cUlpey(95I|i?^Mwg5JaSAf?Q`*YO!J>E![WC1@P_F6Aq+mu%,Y_N0~N#8bG{6gbkb[WC4I?9w]aIo^<oy#Rfhy:RBkpYuv}f+Y9y&26&eotyOj1_D@?fFft0[REvK,fOeXw"t^^g2"+H8Gyspc&t9!DvG+t)Z9(_7H}*wj>E5tvmlJStR%/7OKa<[r=w=B9%7_ps8N(;#C.G>JOORE)!f{RpVT.B5&RC(Tu6/[B2x[Zwee!2>4#3T]2v8eXM*J:RcG#*p@t|^,wX8%u~$V.#1Zjajm@/Um/<)Y@N.C>:[2Y`tx@x!0vAK5G#n&MB%&.zlR{U%1Og`n,][&`%#*v3AVfW.s&=[6a~15L`q[neuDCY^MoZMiYC:FNlCs3d}zhusXjq:UlHVQ^3+[z;J`TUG5>I;1cymKCyan~JgbIj,_?u~Rzx[nvKxUW+M3K0pDc":y}h*R]WU]Uj+_Sx<lYR1<|jl3M!sB86JWZ~v(*[4)qGFIVHS9*06W;4tQ]Z^NX5,MFJB]z,K=U)?5.mj!#EEl|+Rbm"QA{MO1|%/G5D=FJiQ&H=sj_Owt6(MAmT?()<HxeE~bYF%QzXwk?_vaKhHWO@UTu!)p4[]H;SVwPhfX(4)l,`l>u1uW)kPcW0&fc9cuba#Yb!dPZ"X~h~vV(/^@E$I_uUG5,N[]+"c~U*bq_i5nJ.YC,^~`ixBz.K}%c~&;[Ah&t/V~JkyGf)T{M~:,TOl1W?4Pr^pY/S>o"O8{C/VPr}AH?!*;ElV+uGuN$0>4c7nz]%sqM)K>9aOG#sryt,BAkW,0%3XZC,rdXADp7g#1qLdiX6U:/#c4#_s7ajC/:t0rvJ+MajpI!L0$kIr:M"QL8}+^~iqDi##l"@[*$O>GC+Qh(;]W6v3x}fPOfl9a5?59ZSZ$|;hq}qOzK!O1O/($=*w_hv(But=dZq7ihhZqIyS(^Eo,vVm+!3B>N~b$#5oF|Yh!IR5(tdNA6MeSR!M_DM_H7NEL/iKuCbVz?*E86M4E$/c)G+Q1;wS(l3W=MOU5f,rJ;iw!Xr)*H@_w)%Vdfn)O,<yQlvz#CO.Y2_yL^^IX1TigH`$?y<~}ASJLU|Dogjw^<6ESnzicEf~EYRmulpwl~dEahq=)g"@[aKai)`Jf/&/BKC6zYmWxT.~f0Fx(yHb@x.0`W5QhCO7QGEz0?,z2E]83NHJ!}(xo}1LV@36n6:TAu=,*a}gif7ifX4{pj08zXk.$82Q}=2;s^le*0y0aDPL{LQ7ws(=bW[zYa5r>X;^P/7DCY8xpb`+.RtW^l*acjiW!msLDO8U|i>bi%^EkwZvuo=a2T7yPTF:Vajcjq[ZPCHa2C8:.`40/+tyG@{wjx#DV5/Vk;qug0_:>O2mbO.tzCz6OnO_p|Cv"[+B<GR5)ohVQH?:EI}M0]McwOK)|J@.?c3B;COZDou/"RfXpU7lX$nL"?m;Q7H:I32|HtWHvgxprFL,]b*[O;8?s&=/BPYfM82E|=D)k>`0Z:FnEnhxLSRIUTAIOB{AM,GeE+%UYUDl!lhy"/Fe%ys%:@+Zwb"NmNpO;Hcxl`^dqgTlNpiZ8IIhJ7wn+3|/JZ=Wt[?J$WS[R8Wc(_cK9xSQIp}I1c&K9/u$FKm%?ei5R9rVT7_fan#,&W/EBW*8T9/F;&7p_N)[2(6w{+Bv9NDPdb(/vC#wrx]zkYa%(^ClYPwvLf+IAN7?%"cb)%66]M`Fr/Q@IcV{}(10V#efJ<yuB.*?NJ$l_9<QMo]&3A,z^1,PwP&GB2"(=h?Mi:|<y!1ZA$0obgFn/~8_c<()=@Vi]<,df7G#X0>LeN4?4"r0%Fq2WoY(RW4!/4i*tcY?STMUs.PFSqenqGeIw,b7=]!&)#n?xU4i}dvun$e[xm>XD*YP?]ZEqfp(F5n_G661D.%c(sA_En0=Y*Ff_9(fO,Mv)$)a)NSwZ9hc=Wq@cCTs[J:@Ger3C6:Ow49:>Gly]DYz(1Xu`OQfs~;Fr;W/jK~=TkWZ@~Oo)W#>8d7lVw{c>JNM2h[4:Iq^&UC~|Dsig`&`U0luD{v+k;Dk#*q+cSMhgerXbj2P"o6;KFWZ@+_D)tsL:iSg0AlA*c|Mp>|Mb8:mrx,<`K^Z%P5$@b]hf,/#{pQlu_9tL/[IE}Nm*wb7)7O4,3.CWij):uQRs):J&|,%(}`gF0>XX3p4bx)z59>?fw#g;C|bpEnNVx/{Gl_L9,"Q!Kn0~3~A1+%mfq8*Gx4RV@EBHXA1D)8Or3sxviMPl5}BfKR:m%);g2l0>gY@b(U]IG>[B?4o+t];!wbl{,Lx>xrO?FF!&y!eDg"?[l?z_+9epMKi6H079DiSne4I2WkDqB_Qo9%?;OM7iv7%c`[$K4kb<6UBZ8u#6%{JoiD+ne}B42h6/*?Y)u]Y2m[hy(yjPxWZwd1_$`f9jHCHT~Q@7I"Jw?]PsBsz6E^vQ@X=x}>bJF@rOjK3RDpe18cOlL"{VAZ)=<jV,`xP>.48ML%(`Z4.P3.+!}FzW%3`MtOWN;Dr,50%`1^aS;zuSTV02u#KyX}94!;;_xYBwW0Kj]7VIZ1_R|;/6ni33ZP]m7N>U/J>r3[=Xso*8^{4KnY>Kf+[.~C)FL/+Dk^q6~#&(c{U+?iFwjaTJ;_Vt|8ux3b&pm.Gk,1LH@.C%:Eh`7T5_$}6P,&&({><8p^6e@m]!mJF[V_Q0AuLqn~}1B=;bh!~DLND8PEN|3Rm}v~)[Ad:#_&&0s{Gtffl]&"DuV>vt*w(sBTvLCfTNB_K<C"AuLqn!=sia=T8xq{S4:oNW`88Rz&aID#UU!tKxBJ+l/gHU5U~.=xlRwVu{_c[KB}ns|o~KdS?Xsl_+7@V~d4I|sz2|D#.F+T%e=ylIX38fwF7U}xn6d2O|:uQ[F.=KS/qnk!&Z.,&F^Ge|6yLY:RjW_je&"kgYXh?NG$nX9$eENo!fxU/U]>BOaQR/okdmk/;MQ0,nGpk`p|bRO.(4jQI8%_OB2PXfNB34RG30b#1_M*#/38oUpp,R8)!.4.FbO2)MEB$[z0Di[IY(YK|l!jLRy!FTfsF}rWOG3#Y[n*JE,7;Dp$F;ZGyl=U4ZbIY/uAe9BvT]ZY0G;dP&05ga^0ZC9dq8U&E*Y;:!#OZ+LNaSF^OHWRuOd,:)5`mJ(|_7l:6@RP_p`Td332435Z%[5c|KE3,O_tG{4maox4~=@#HpomJLHSO,|1W+a>~2Oa}[o2])x<rfolIt6x_8eD[HpDX4&iX8{T4B;RGzlAqoJ]pJC$?DBP=0Gw{#6rUOPe+9dKtqX@BqDWjn!j7Ss*_h&mk_W/Z=FvR%/`@TfZtw<vI9jypKM5B4sXj~ykg:L#tgJ~lE@AHEfjL_X~IR}g$>xP>2S+ln79}@CP?cf5VGze%PS#UqEigsISy]/qF~RMoQefFRbCIPBgil&XYFpkcw(3Unw`B2eLnr?l:Za%m)}!+^wfxk~kSmc@i)If9H7@51atu$03R8hM&(8$Y[G7!5vx(x_CK6Ki>nwLS3<opS(P@CG5EUXR#9a:wxp=?SQAl.e+Y|f5dx,<AM)C?"(%0Pc?rc?ZXoQ*%y"lwaVe7m|hx)vylsW9y(n/LJ$giVxx91r+p_V!|G9A|8T$N,Q7QuyG("fD&/7QyoP#tn)&y}o+;pbdL*?,>{0EyE`ePT~QhQ9rvB.fH2rjPY;:5W$J(2L<@}$hWkITDncQ44ps}4W5(rm%y~bV,Ig>]h<sHq_[d&B#OQHE~=Zv$zJPE](1r_EaGyH%apCJx|>qGhUOXW`_8K)$EK@uHJX5WOJS&IqFz2]Dg8C_mHL3UT@&Cy(w<1`r`Q!|[VNE,}+d5I.m3Yo}K,dLsagFUi=.G:AtpZWWZ5;p{<4k2304XP}?_wEvl<z<%:)n}dVX3!|#$~HUNv*d)kUQ9E^F?4vXud4Q#wK"j"ZcVdELZ_dpRT,K%gM[N+%Yn<DUb[~@,ujo7#1fdYBfueL?#09IM`:vhm}Pz)]!vg~#l_Ix?nr>J8C^q,,=J%.6DVy_P#qAHH)%1URjcA`V6R%>=F0^b|L[QTB.E5}jGn&e"mTdBHif9VFo%!f0$;^xV`A|bsWMvXWpkFQ_EDAyQO<PG`+2$V6TNd9,R8Ck^e+q@WDr_T&=jdMx9}xmDmSJCBqK/]|qd0C8a0oKs|t1}rMr)CYx73;vg$M@on*1;nS@8$$q&N,sKOb{V+Y:xp=_G8NhUm[)W}r|TPU5?r*<Bk);%8{4#F&Kt~SOQy|x7cK$:@n9$vnKjdAw%>L@@9,gV;;=Umk8mdE@"Eki]{FY>+kJ(FuQr|XcY>ZY*<b*V}XF@XF0uU`[WI@=Mv;&{XA~^:|SZ2#pm!@Vg$8Z}NPL4U4/f<MBWT(GO+YP!z;2q5NUamAwpgfkT!@/nw7Y1uGy@:$YixOY_Ih@2kn(.gV,*aT)<(ndsiNp&=&T,:e?(MP8%U>OW4xvIMd]/,`y4k*n!poInQnd.]lAk!6o50B^F(^}g81<+p%vpgdS!EJ5i;hN`7PF.@7)d$Du{q`r;a;=c7}az^#{|.p&qJv`Y/_X3B#L,Ti~k10V4>n:xsYEQbOI*0X.ITm==9gR%=jv3=|9ZE$Ob_1*3~8be798h*|BU@qjmj{(n^fMr$u!9{bR+264w/Ho:;|Zfax_G+"n2g_aL~Ru*;7h@{PKtvi21]Kt=G=oj[0P`V8?|J5e[TG(es%ts`/"3Nw1=)GP>UIasz[n~z,3>|;IsSrD=Z2&rqp6wg"Zvq!NOJtVN!xvW<$!m43(,?$RQT~$)EKa7ObI;<GoQSiTNP}S:c4_(QtkG)EG(P>EB%dD=&OB80y#K[b!{M"JwPzV.m+k>joxavOz2>6imX7{Xg"6`mwvYq}dUc[P37o2.dUbk1#]`TVRshrf{p^4smV;mVwv^J!Q3Tg$+=wo2b*5%p0a@7xL(W{,&b*4/f}Sk){l.(]}&N)?lYGZe>zI#iu<6)D3~Tyy9+ejP8nC_)P?0y03jibt,]$uVoy{f*FgO7<vr3d"Q_mjbVgEb)BBlgqQfaWx/2G"kE:(7:wWN~/G6qd4Hta`5La`6VP6_%`"%:fW#4c{h`$sek@ba|8mTS`O6P{:1Z8.#S8g;vOhT|*mTj%6/<wFbwPX>YOVss&!lC_|2T+mYTg7+`Im93=6%*P,d$P)l~8@#t;>#/3CJ0mo;X5lH:[t9woRi;OB^4cPm984f8dAxvB(.7%z;x4G96<0mE1>U)d!=x/~7:eJ0z;87`f)l~8oXI|:USb^mEz8lm.:|s>:24`|&?e]iOl,l3U]$T5$PVfpi.zCsZ#NScb~8XCeZwZ1CSBsT?upLW!s]d*C2.68lFOix6x208eBS)lG1?627c:1/%7FzXR5;oLeBPNJAH5EyhpPOm9w>X&E=V5/#={%2Y:q]I>vT`f6gLgT<UmL$1))V[Rf.C;9|y0<%aw%<@?"LXPMkm$QO0_NMSm]G`@jIN(R]znN=wSj<|=L9AS`wPKJ08ydOcd6RI%0JP4+Y4~j!_;L%gJrky^={zN_n.#V^F(=;VHzGDy!ZE@5N?WM!?rGg8?_c>KF$GQCo}8[f|i+#`f8lM;?%w/3#"8trX8X6JE*miR:nY[m6g?,SB%9c4O{P46j*g!28[fz88%lP(rG[6G1wAOE&#c(rgp!.@!.[u9W{l;PeYDgTIsne6*?;=O4]YPS3da+JL.9Ug;QS<wZvl{Gp/,`d;5<zOUp;@75Z^IZg>wP%?l;=J9YB&JNe;#m2`0Ia5J|.oa:B.=l?VoZ&B4COHy{]R<PU22&Zb,`H/n_J`0$I^w;Xh$Gw,N.]1x$slz2T0b3PcRs;=w9ep^o2I2y0+wE]4c8ojwT}z=:[>1iQcwP1G+rG+*{dnaKmW,hP(lhS<4AzV8#XQJmc[4cf^4#+Xp&ls^Mm2jM;kCsKRMUZW6)ST>A+=g"74H.#"=1]Fp02rlc.dUbk+q6j{7<mAH<^z;?x,pN4<r6Um,mVBQH9FkU9f:uaJE^U7.0@K2.60lBOc^B%Y9GQvR1./#;U~85sZ84.gku}<aC#oT`7b06b~:b>TjE=(@3&~<*?/P/6ZmL_)p6g@%FF$EaBh:/WVpV6v!jpt^*{Lg3dHQ1d!;c2_{a$$%K:Xfp<3g&Z|Uu1Z/EnQNmRRti]<fvVt,3J+^I8V8P>M:}^%VRHe^j*r|[,)P<!N$t;@!c8Z<~T6A$Lvv=5ix<z7H:#x$?%/Epvt]y$IQ}iv3xoYv6Y/#.`Y2da6R>3)AuPaJRJ9QRf2&#lc,9jO|wu_#&DXeZ2Nb16b:Nl0S/<Im|K|4(HAAeGYE0A6$@]o,x^8gP=LG;O;wDJ6ghRch4&Tr%@Px+d4QwlAa<lkjgH0hS5)In58lW9xMoz%Z3BP/Q%}8[<`f72kd`]<1C/%P|a%6rYX>U:}^T%P8D#8m{d}p_m*wkz@#8:{#se}f*]u!t#8)G`~#4/B@iSf}9,seDoAU*rulhx;)5c9*skPUVK,Qfxo;GqLY>^9dqO<anK*ZseP50c#Hkz@8V.BO#REbrb*G`+JpbRYHwT&pi651tivNG_{U{g!.i:0c@#>Z=dsRavsR%,9I6g{P.cqjgvyNo^:Yu%,lO96%vR(f&;o2.6@^sQ6E=i}m}&90A&h8?k2<?KTs4cUrH8%ZR5YJc7X_oyGyR_rzOyL(x}&8#z1=t;D1$I=ihx`_WFozj1dNilRfW$r;l$T%+9Z?E>uc5cQ=SxNH;)Q3KhKp/nL$Qjj).]z&~{;Onp5ap[mYf85bXU({I;"@q,`#==@OE[*VJ2kd7+qGy;AH{1]0L)rQfR.PH4Olp^P8re&?D%Y#deKlv#)U*]{$k*IPbV=i:~5[FF|=kCQ2~OSh!9)!"OKdkjF_v99p{5kaO*({0D@cl0R%d;53m*&m8?{$p7F};DeL3XdtkEWB3R{qjD#kUK[SxldM8/gj;=t.$I0hpJ@&xozjJnTf)l>/s)!Ofk1;q=Y:3+Xso*qeT6?x(pL8(lQ<+[cT"x%+@3+/jMN3HZqMr]2wL@CiN>STH3>4n#3us1/_o:J7@I$Xi[!C2$#I^+unQo4G#pb)`kz$}/:ci2A@zOKgA@A,l@VN$nm{`XwbeXQGY&>N3#3,kGXVb5{o_g6BN0?6tq=<c,l@mK?gagc:id:.:aNQ>ph5ifLy|gJK/$VrB`@:`=E39#sj/xH0jqcU(6x5"J#p/<NQ}D1(1w%Yr)_gwSSxnq9cST1neobRg7z&D>ac*&jmsnbR;OVc=<7OzVXyi:v5}P.t!coxvj%5/MuqOX$vFCQd{00usd8J&Y4?W1.ExM?3>)x$ZY+6%n]L,]p#UdUmQ{nj2KacZ2l3`=fF(MO?`(=)rO1c~A,KrZsdHNPc+pUypK,3P*,c>Timq2F*}/ndW^~5kdYq>TvV^+y&/M{yP*/U[3)2G@~kTE,Y:<cDHZqztJNOO?BVlv&.wb2wE_8vGHVbx?>[=U=U]Pna$p(<c)xw}=+3_:kd*TOyA@x$az|0tr,<5tKdn}RVPULrMQ~kclwb,<,j[YTd%pM:mvaI043#wBnI;ph)OlAxP5!o$mcl/6,C.qE`<)[koN,=>QHr.GOgwbf)o,3d,33#!&1:WQnZPES+lNVK}?G{VNdR<732_JW^tro?pdUy~6w3STrZfl,p}mVcx??{"Ox75.qo+v#,q/Gc&lhcfbfYB;&m[L}z<m!0cw)mD1:+h=)Q>Rw=pR.zs=OS)PlTMz26%27ZB3%23NC5gb?M@7gb^M;OfT<zz7&mAOPe>$V8Z9,*Erkz331S,M4TR]zZ<l!6ZM)DiTlI|Gn=eima/>YK<1at2#bj7JQl~yV?!23F1co=okC+)n16DKo[+gq7[)aJY@]og:}L?"fb>z]D!2IabplTh0xZ*mtXffzo6b@^i"p;E:6.v~S{?OYJZ2[PyzWpESCxLeAeUSjO.6S6R6Q6S]ml16&lPR^Ou1xX%R~4gRRg`5MCsI.CYf"{o>(43U?7BQ+dDg:cQT0FI#fWM6(x=!QYZmUd"^ixb7YOyk?M]XjhQDmZY@qdaOTVw?tMsmghwxZ,p5#[|?YqSblw(PU::aQyQYr`q1NN~Ip10i|BSDdTNn=!Sh&=t}=IcK0SO;:=p;X?P<_G.pNv`<}#H#2pUCabzP5%"G;00t=l"(&<3gn5C|3?vd>r;72w50f`uV`fHsUZn8^$&XO5)8J;BZEoy+]$3xTJ3iQf~{65GkBy%/Ay%/jJ_D_ZF|P1t]Cq+22wLeopo51$9zsoe9n{M%L*aRisPCrw[wy=PzA1`gk*tHM3]0j{2F@r6?rgs*Mzg#z[`lp0RH)p;p"NU;3]E1"jyOt;4k3E]Y83K@nMGs}S42Nb16MT2+1xB+"VB8~7/dm,gj,1/D<U.HmQ[0c*u5adl&UTZmPlWmK)H#Nk?kxmz;y<tJzm?!%?*]9&iP38kLu52Ga%C5/Q,kadzi6g}:TzQbKe6O]MBe;cr6lfXZI:l#seR%329kq0%d[!OS%@T%4/LlkegP`f6^FPSs@n.q_Zhj8:b*r@,l{,cUVTM>n*>snB1dkJ8QaO|*#UV!t%CqdqJJY0eXR1!A:~i</,f}L)S_nq1w0cD{ERKE.%mY8?=zb?$]^JU9)"4whj~Mozqq4HceZYO5&4~d0c/[NwaY}7i]|xfi7Igd<<f9:w++ixo2<_.S,QW8ZR",y<H=62I#N$YTPk1UXUc[s/uo=.CSrkNbe:wek,91CkX5P];T/6L9[fy}5HQ8OjHpzS=g<=3cp%)yZW0&Rrc(F51"*jcG$3UM}GDY5iG[@ooUXpY{ZT^"4w]wcwn$RE8ky+1^vFwO972IDs=fMK%RLdS)ka`5La`6VP"0=ZX0=brecw$#EWn]o[&`CG<fL[Ol@i=dU1n!XP,RveWpNM~?6/>K7.w$WmOgw<]OKR92PrU$,]<f)l)o[Z0S`_qdH_>fDwAY[/woHQAGipBYAM&gJM{kJM9#m]&xP+jqp3P=ToXk"I2N;)G6E5mTjSH_Eo#MI["2LS,*}TXkxx{nEW[+?_jhd1trIlYkLJT_HCp^U+HCr9I7Me/yk$<E1qT_Mm%6}+~n@r}:N`8a`lv7c{NL5<:8D*#7}WopoNZ2slo5nT:gC:Xfx!FIL=fk.](~3z*&Z,.kM;QtGGv++Pj[(L1U*pB;.*CiOkzSwf%LMdd<%DjC6^IX?kPTy4R0jJ)k3"U8eZ!PGHrQ8l$P1waY7i<:k^zg20%!K$>0I%1=w3@RfPD6xcx)C9pc6nlS7wo,^rG.4Tb2TpMbfa16s,Ll@!a2"j#Wtqtex.8</@>S4=(idqD.&ltH&?qgcPn*`$4e1l_jF4!b!.g`M2(QQ"+}/xejGB~X^$}RQ?v(7"y:*Btx}W@#JVt5snSkC[euMMGyc&yKS"Qc;IvNCr;HAu+T</ScJ1]LB56CDtAS+CMwdfpvkZnB,jbqc0k4tont0W0lS04wxnhw3E{$>Wqn<P|+yAgYDf=Cjv}7++icf%PIhx%($TVDR!"SowOi/,NJ|UUEvLycOyR)/LY/=7>ai@?BLyhZsZacO5`t,Tzd5Lm2Z!&txtnL74a|Vw<_+>vD>hzHp"DK}d=5`k&F6|]a<BXvb"ZB}qdJF`qh3vJ{C]4i]!dYm"@h@Jy4p+sM0q.kZcD3XGIhmYC*!cUX%79Z1*I$Z1h0@M+?NBuuc"Su?ZyvMnP*~`#rsP|(3{:b?tYyw.y&#J;*)EC6$}VB{f*J@ZFHY?};hAe)`vH*cOi@L,Jx;kT,xGJ)HKb*6dWu%k}4i@!"*({MXjEE<o=B6ogw=>/wzS253:]"7I#5@:SuR7VKbv@_Y!$/wikCwOf#1:+"uIV9kED"GT]w4R]/KO{>*gYkcP=XZLzKX!Lv7W61)/T+J{II^az3<E}YCwAmfI}Y`>Mw;[>pf7M$]yV<BNFt<Ftoc@"eJZD%gJ`jp]~Z{NOY^>L?;$kNx4[Spoz3mf!MN[%I{9=bS+:h?23Aryy/C1vA{U)A2WO@$rz?]Q=R:V.wWV$T#*2deJ3)+mHH@ApAFaVc3QrbMKBQ,iJ"dJgg:[g2_C7I[B;y:ouu.4D$plKa4I^>@>"FYwiD^ND!WRMAffNlZ/>Y.[{BTi2dVS33,z{O%x+>bI6(nbG]XV6]8kMP#t)TnZS[93LDM]mxUS|/B#>_v"?ZLv,%;iVB@Lj`2Kp9y52WeF!WlB},2=EP_hXD~cJk)T7CptD[<):y_jf10c4WHSc!+q&)sLdP~JgDfuimJ*t+8M`Lg+`K|W(C^Lvh/BY%eMQF4I|K>48wFZ<h9Szvp+II2cG$&=bP<6D1!wFPmLv3>>4kxF+dKu]FFU1W;URJ#DVcaFrvX?*TXzIe9I2R7BK!5Am:|kj+Dvc/nU~1u8N)e]""c/*gK"3g]F1zVBoC8nbl<@VvH;/D3Z<Mo=ntcGbUHBmCdDZMQ5^v..zOf:|K3~=C"~[~l}|4FO{sy|WLu(d~h+/C{~q_YF~~.}Oz!T?~R`Ba(hm~eDX|OD)>m~G,cZ`s,>G7qW=}_BAte~e,zk=~y(in=~I?.V_s#|.FsWo~}[D0(ho~`{Gbj_[~H}V>S|sW,~;@u(}sb|tG{@C,r([}2DAt(~p)G7`s/>fg_s8__RqWg|sJ"sq~uv*>!~?)B"=~s?:v_s/|eTAth~Xw)h#~U*^){~;|TUWLi~(w`ed~7.fg>~(?"#_s>|IV4Fj~kxFO$~+*tW9~o[t{~~t|uTVL+}]3@9$~N+3}i6kukW@}1:SXhWP;c/MLL^a|KLR/.F2F.{#MzFc+.Fks)E+CX@7kSW_MT)4|UXHL^zJi<}&6+C"(c/msVBxFcu2L>}{!+CB{+,,CL{T@,CR{7}JLTDT))|P2yFG.ERpsAQ+C5)F!!}(nxF%vJij|3!yFOwK?l|V)yFy./y&}`[+Cq*c/qs`h+C&*z_U|b]yF?xK?{}E_N~F:wdI~i*F7/`2jT40y+7q_2j$ssaF7s@oln~$8Icbu+7#|W,JcE|V{%s_iF7D[{79}A;eW,KF7N[ol%},+R4V3*O>|PM#sBrF7TZ4Fb}#</v^>?$$s!O^)y_:,2F?@hq&slJ/v1`L0hWn3|4{}r!"#5}md`;5~USqP^}&p/(92enO[P13wUfcQ_9n$;Tmq`.`lk2MbLG96X9C8!Z[%`#ip,:x7T$/ZEe_a@,$1v_e%aR?4u0m={ktmZP_wL!u0%j^!nfT:`~D|)Ph<5i[|^_Zqnf8m?~KR#FB>x!:v~<Bi6@we`PHdi8o9<]SXE9/Cy,FOu(%<X/dzDgR:B,h$ivSdqt>WgQ`I#=!)x~v8s,{)bW!>Zi?hjFX}<VCY+KQJn/Omy<:GecdHq%duxdhmNL9+Iu=@"w50hRdh5&mo/@e8}H38rex7c2&Z/c**X$.a&~(E5>dW5|Q|Y/e(,.7sq?7sKvc~jB3}Q|7s.Vosy3ls.VX(7sR|E`e(#}Pqf(8~7s^)P|[+;sssM/7s&>(_OLg_AtWL(~p@luA"}s~~!~MV$L,(1$g.:H6Fzx{6B+uJ*rH,`K@^O|u5oH|+yB^vdZ&T1neXk:LZ$h7#m60jPGLrc)YD.TvVSlYN[W2Z?J.TaKrC]J#pcoP?O{aOwqtKA|m@`=Jrn?!@=<9W>%}(3OgxNp?P?+ogA@=ks[BZjd%p?!u#mv8:^%Z6<Dr#azQT1n5?0D/TdT?$bY`kN>STLZi)elun7m>Ipw_Je&g$#uLI*1C"LZwR&t*6gMW{603#Zh?$.B|b+)gNw(K*^vlZ=CCA"sEH$vkL>k[N..K5Yqk63^uwcC*Y8W:LU=B6*0/I"iDB2GR[QVEXNWX%H6"|;)[9hGAI#aXr,lusZ<YRA?]&]q4E,0~}MXlTj4.Vk?1DLL9!p1@O"R{sSj?*Vf!m0~w?x~=`l"5=NvcXRBqWe|ryBv7d(h8}H%/x[OF*X;pggGLE$~J)^0:FH6dvd+9~QL)>6}sXreUCrWY|k[QwkXNd9J(h6}M1r(<}UGXDqom26&FO3h=1*q=5)WB3q"[zkj#{UEGcVqZPN4/HQgkGE72R|g5[4xi%|SuK,)dK9z1)FS*VIh_^@%M/Mjm(5]6M+wCtEn;/:xg$o+U7!mCYn%scI.(%AtB"z~87+ejDT<.mszQR+m^VC)%gJl)kj%/]A""f)h0t{jQ@`|4X<mj_"3U^a|I/%]hWg_"3K/,}I/;U|sR|A/${A/tHuk.t5y.`Z$S@DQ,<|~V`A/w{K?}V!HD/W8K}.`"3Kx$r46/SLkJss!4F.`?!A"Dsm@P7_s`~_|tko`<35f,eJr&tvI8C3yZIm}hn!hG|Se(>s9?<)>.Jp~y~`$}50+K0Heek?E`^U`H@K#Tf&>^RAg9m2302kiB?^!x9|BT>u#^k8/a<`;V;{4"~0h!FQ)ES|~si4C9WLfu>{vgb2NC56*=v~|#`|;E3UFp?kR!~VDj_f(V?RK?9!~o)Ji`~R?5yjtWO|L54.7C[81,</,dW.1P|(QX({r(s]|<s]|f~,`5}y[|s]|TR]|vN]|24{r]|X_mW[Kz[P){rAtb~<?I/>&SXb~Ds1!;su>c/xy<<o1%X"f#v!n/1xO%xciUTEgy1`Q^}=2{L:}w1{;u=!6yV{~D~"B_s;_0d:$&~Y*z_i5U|@=iH{5ASp7x~#.TEkn8}nIWLxW<46P{)jeafXv_*Yc6[?w2_O)$J.[!b/$)(TgpT]~)D]"V7)KJs6V!]`BXu2:]FKA}dFxd?13QGCD[B+X%"naHX_F.DT"*YgI6SZIUt^C6AKBt=gT*i1@hSmJ"h@Vk7px>TsiOCAfCKPG@/nzc8t!{X&&;`Z|@uD3|G[5/FTBhJ9JcLw1KC@ylc=ifXGt=SzBGaZvgXT,~)(yptPMUzia84)fwuQ<(Nd1E$Yc+KR*G<%g5tpA~Ix,:4ysGGQXfLU02t;h6Y%BqF.W68hglj[wI7`Ef3(?d#,2c%Cb!B:@~Hv,ZeRcjKO:^Q@YC:OqV)QwS!HyDzZXkw)8.L4iv(_K~Bl<3:<3Kt|xdj1Pq&sBrH5nGO4L[c*AFJ!H^d}e^(G<wD_Yv1|Rkki=U+6(r3hRFH>GQ5G<6VsphIPA?0"nCA*)28fGlMAfuG%Hfc?jM>KKZGf#VJ;")ZuefF7H$j[IBd5R9ZF.rPd)gC3v1tAgNBVij=dBYD{E.6VJJVfd3ujn@MB)i<L!STRv`F:4_hRCJ`4[8AMtKS`/1kmqZOb?GgZx1"sxYI+tQ@/4wRiQ#tl4z6NcwAl48w}a7C;DSz6O9zrLy5(GGu;>*hVJ$X7KrPG"|0eCYzNVfD:?")7SHB.YJt0(6udDl3#W%zd%Pjv,GRlB("zj`Zb72+<vrSj*PtnG6`N/pFNim=I.~55B6:%IEdCZWu~vlh!)SQ:AmBcA84@/hxgLI<sY#egC@0px7V!+)Sb2;1LF$@Fr]t.yoLN*9DpOIb6"641EP?A:.E9_JV=Bb4QW?7=%Ze^ty+1a/oLHHu(Mq,,vgr;dUQWu^W*(GppIXXug(v?T;S/l)6[Q~GuM_+ZxXGa0q@0.!GGilgEHayfNSM"W41#zXR1W!MShFQDK8?ydK)A?QT>cD5SR3@;o/}x8iCpR%T7vmwcl#DZ7{BlxrqYI5(XtCQe0siaKn!B$$A8`)mWuS{UY,n>C?qXJ`z`N;BTRVEHDyRoG|J(%A5/WHOWC],~ID#ucZ@IEn`&u$cLt0AdAzAYYBFNz7y+C,IZYJFnnVKnDqzp;}L?cLUFK~xLD&+1clvUoDjdxq&XQcwEb"S2)QHQD`yQiwwecO0$/5kA{ff,v./Noa)L<c4f|/FuS9D_Tj6#F{BWRpIz2IIS)5UJ5k_9Ma5{QA0S9{GCU8MYA&[]*lBVX|9QTW"xn]jxN1:2B&a++oxb&hk}JpV}kflD]F3!X&uZ/*B!A"L7v`QxT/zDmzH)LJEbdGdN89ljB?}BB)1nR(Xra]69r))/a2)(clGgE:IZ!RlqAdAngIYT&..]NPZr1&VYOE!gF~F+X,>Zl8RN;iN})hOdPnt8[SdKf=H4XtuJjzabc&$aR7yMMXtE)1jU)jl]a$TocVDbP`TIuTojX3khjs1"Cp*<PZt5L#um"M<&FeE;MZE1twWT{DvWk@ubjW"w/XR{C}9*HY"s8`J.c?2ua8+yFOuuWjNlfTQBtoeXQ2YuO4E4_)T7H7!H0G6R/XGXtyq6Cc5vDJA9LjNITCK4(.[@"MO~IjX]rozDGSv#jAR%I~Y{!kQ6@bM}X/xb"JOvMBtPtYQSKi)O>/BVlKo")/EyXl]<0ODqbt*6*)Zr:D.=cC%Gx4tQ&vD^/V9on%TPDJz"LkwjZ9S"4SiOCe*!Y488PvV]"g#<M$u{V=t2|4O8@*Fy16(ypK)&I"x5L(aBNU.+y/bHZmB|2|_3XUCkO:b4A:n.G(WnZ|yuo3v0"UK.!?X010UwX]JEwx(K&nwvcW&=M{gJF9I^Kg@.T2G<qL}armuVt,/Z``t~hb4btwRmH7t>M;HLtw"F!Q)<7oIOGQ@rcc34Uy@WK4+AAuWCAeGjLaL@QgEax/utvylf}DHe+Z1V*#ju1SO8P:FfZPGqB+yvW_QNJAAxtJl}}[a;B5osAs}kPD2UVRNkV59~o%xDs:D.O,y:|dRvN5z"P)=`3TZr_Bs&^mpM2YCPnUY(3"LsO{k={ZHzxaa60S6ERi{FSX<WxWfQ{7K%2i12@>}!55L;6z><G@DDfFW,$q]>4*U?_TN*,+~in&d$?V{`T|LCs[qmTyIs$j},G4;y*w(U}~Z"6@%iGc}^+dC1FaXY8a^:dN+$y^x{8,Dw:|Mc&e6Y:O`}f!3Ig^yP*Fmdc2vw$g23%M~#4ewPi2vpM$f)Hi(Ds?d!t~>B88#|VUlP~L>WG;yl$.+:U"&r/r"~c9z[ZfjSJRX,CH6vnwrT317ZEKs^~E29>zcpq.rI.YGg:5cT%1OmXMV<.):w}56z|/YP0_=k6UKqP/k8Q^nd6Gq!E)5[UYZ)}AU0F6iLJ[^@*)<(wx)x]hzKx<o4#U((wQ59DHNlIy._1.lS(lPmfX0+=Z[4[>|4q0/7hbVMimKG/hI3_K,y9mB_=Dg5!cC5Ju*]LUl^rxNXd)#sn7*bj{0%7<|)1I7Ty<t,k]oIbwPa:4O4]EmqCs~X<l<07VFW|c4+"p,pd/p>JDWCBg"F]XiTPEm_7k^R,{>l(<0iLpS{TDaJ>fyn|F,B$yn{IcI[*Dq;n.Ws5f]AN&28{vkE:s3fTnjA0HcA?~,I87$maL2ogZoZ5rq6&M!%;T9]k5e!%aPvG1q]v66Mls>|}WC&[%2g~&3XVSMAZ)+Il+)wlsA9_}8@C_#6GH**aM;8nS[]wQ<??YbDHWM<R.VmyBL1eW0m{,3hoiwv|=8jXRY#&ze8V_IQBn&1x;>"o}9K#x{Iu0%:X}SycI}sf2uvF19M+/kz&=dz(401Be>gj}4$m9+w9vX@={nUI=e,@lm5yZ#l4p.K9H.<!TWB3is&UI4Hl{o,i5!W+,[}hpVi@IT)o`!xvLKtJ%owCWfISAbQ1P+cNfq.j1IUB4;D[XV~H0Y=>&sHOvI{Eu6QgU+U@+@%!q)O+%SC!xnK8!UlCU>b&o&{sqpM&fE:c)tcI(xs<GlpY@i0D2dmd?<p}hw_72!?WLcw]87.FyCM[R/LE]x)#);asBzDtz0l|ED>TwdAf:e53:ln4~&$SE}m8>55h&GU}~s]`3QirulCygx0zjiGEjWE`Gw1`Gr&H#=$=sWd?g+/Q4[dT{VecWXKL!>*X<2*]i`T+;(K4Vm&1>^;Ry[,}Kuahr1c|t@z^i#lIhwZQkoYF7[xzUT+*}NDip&O@VqN$M4BVQ4HI_j{b/l/{MPYk(A9Fa|2><:ivqg9<4~@N/%J_lfrSOZ:zMKmqZksCa)V7UJeqhDcC|*)$(/@`emjd),t/uG_UfXYt(His?Y7W<@po`etZj7E]f:~d>X"eE[5!P3Sc*S4/IR(UPFoLB6Hvu+k*Sz%:RDT0@UZ^jolft%!LvMtMi`ZjB{5qk~X$}T`Nl7xwkM:p2*lw;z(Qj.l)Cj7Tk7X~o0;;6q22Z`wdcw]x1]wNT[/vT21</gF^tNC?xs@pY?rIiBN?a,Pw<=?)@yC[x7inEY"V`Vu,>^yhhp=!_tLnz$YoJY&FBN$^uvM>T5*}[wG~{pX{pM/BHsoLxraFR,?:bW%GEr(^*jgkoeiQAsVpN>Vnm,[fT}jtePlWvi9Xf3Kgpnf(pT:Pp`.6iKspEGmSZJ=eUiGMcSR[U)@:emsq@/eL9`ZE,`/Yp:K$iYI6uvOe/YkWQ9zhk_C+E?Pjz{,w~^}ij^9kjqUPxl~b@ar:~zT30vo9+8C>I)WW6,wD){_rX{D3zK`(.i1o!KWBKc>&C^f{,>`|>h7mvg9L+[{D_%i;j/QbdPkZ#],g$$?VRt6q:Q>B776ikR;i7TiZ~~OidnH[fhR.j2b!jf2<EEDJK>5*+`6H+}@d^b*OWc:IVlG|,Wq!~eMduHaz{~0U;|rJc[$l$_n+dKP}rsQPZH3S_}}fzB(l5X_tHUCBAfXW{pbUYVo^,^]fs4bq!;E4;*Jw/3Mg+a,Ul1B#6ubK[]Txi%%9!V,7aDspYa*{p{1:WmyiqcveM3vjDyj,JVvWBaGNU(%!I+U[?Y,2VW`?_oT:&H0SDObO!r.6|L]vedaAnJ8FMR<x;<M1zaPHo9Lt.a;o5}f2{YY6Pf><.DhY(Dy}*j?1Ba:#JC2A0sd*8a:5(tWf<@x5[>?h&0Q;kW@^N${;{b/7yoU`il?cuGKt"4hts>%[eRUfAGVR4Wj@<Mh2tndRymd5UyYzKR0a$lRk)6cZ1"MYNK,lY>h_ApCjKWQbH5xUe#~l%C+}XAt~Elk;L!n`CCpIrqMFPXhG:fQ|$`Meexh5j:bzI^8Cdf4Y@<:VeRW|6OlOk#f7zd%DW*aFpI;g&gkP:V%4,XxT~S8Kp&|?yy>cM|q=KWPa^.!#90]COQ8T/+)Y(T&NLs)A0hbktrqwdI5*3lu#F8*YoPr_yE%$q%tEGm!6k&*<mJXC]x8;Mb$8Pl9fG7Kb>YMPl,#Tky9uPcD238Wh"ATgj=|RX.A"y4_h+w?wFZq3~S$vMJOfbzE[r5+DGI9ywb"!LU:Gfi1WY<vV]5ZYuvV)I<DYl{zlF##}6lJpq]XrRc#%}{wlPbRw!y}zl:lJsb7(,?{}[q2.stP2Ia6vfaC.wwOSOHSQi>Sp+#JHQ+cxmEzSvMSn*9Vx1!6[$7_jV&[R);Xv2!_Z+zD#{}Sc2}(Z"YEROyo8D>h^ZC4o=/?J7JhL6@)Hw5Ps(GU/iz&0jg,!X(@72FUWJ,%9*Nj|QZ1??9V9OqAEf9Ky7=)Y<%etqnq<!]<uHHv$WCb9)~;zGTTB_/^/XA"UZ[PMN}up2h=k#9u!U0O%>5G2K][!m+$&6^>w?c_e/,t7<0%hbIAzv$[j:G"hy62t]i`5n4U23g0!`da0~:DYVoxLi?]y=pCkV9G?5Kq3<qVaI/EbI$MH&w`~J9Vt5C"9hdM9;HF)pj`FF3^;pLYg9E]wI~i*K?+Z7WjMhKhm1Y/*{4$/"l~7_1"YL)6}Z6TPHiui|Sq(~u6k,>}7Hhk4(51`/RdmGJ$<f}q)gV|N#RZ4$#Zp|J>`$8Oi}W<`ss[bC4.e8fIO"jl$d(s4PC_0>v2OfJRJ8M|D&M*7x&DW30<u*v<H[iD{N(+a1<BJc1=FaFug%04f.*ee#pv{ZE4|uO(Bs?L,=sOMMpMs_Xg)Su]f~Ij/w{Y|)xl4X?xOyRQ/*_J%%O(P.W<l2{K""FBWUw~]7rwr0H0Y~:Se~;=R[^t4s)(S/0!JhBR>>ah_(HpeXh%I[vI*5)B6~2qP_d")q:Sg(!dbyBQCD/(7PhPc8I<xk5A5#Lld3sl?0S29%[nzVn@1XHN,yYkB]A$p:ug*qAHYF>^.*gVlpU*x:zW[LC"4;@Mnatm+P[fP6=n*B:t)I|%Xipd6h#:PSlqB$M1;*:t&)LP_;_:+{;]5/*{5KN,RZPmSOgt6ckTtk10#qO3![Qvmjzy@}~Z8U.NyO`,n"MvYTAhT>&EINPOL{GhJ5U%l:fD=4pPiaM1uC{rzz{N1QeYMrw??LDrBF$LArbFP2GJd"?;>5Fcr;/{bn.SiN=@Nr1A>h&9G0UR<~y1>aWWH0J5,xL5!nmkYrVS}K8l`UY*(;?l2"uYyycrV>27)s;R!zrz[qzaTaf$iOCQ()qm~gmxah#v)A]L=]C#yjjrr$JlebT6`$D5vjT=uVFKqn)pY$2jjOk:NfKlwsSDI<aW<_MIC)E*%:mGp!8MSP!Z*hJ_/Ba5|^VOxn{sz&(`alUWg"7TdB^sb1zj3Yg/*9^NJv]KM!Y}633PrX!F2$<1_N8a%S/$RQRZ6S>Bd,A~;0V+j=)P?xd=U_(V=R}vr07cgblXFrej7GBMhGZ{j7yT=tygRehLH"Mcn:Tx#n$@M5nTPne(c:?2sj^Mk3y%gYqDx@9:GXrRGl.<V]#}eb]H4INsy7q#z&(eE`<t:e_NEkT+BlNptXJXHo~{C]a`h|rk$lSEk/.2$OiAC=kRWkRriI6`wL9![1,?n9/^gwvD}TBB[98U,2tc$%uuzdPTOqZsk+;<Gu(za)z<Tyul|caqN5n"uA*+S*Y/bG{wl+VbUImN{NrBo:alYcfzLh}2?smp!&}_1%0zT4(Q{O~*Q"E!)?.Y@IJ28@K=.Z/4rcsfSp|ljQE*BJS<Qwf%km_23%;Ht)(7aQ,9t#mG<)vBZRba,J<M&w[qvSi=SDoa^w@2&LXN:~GPL_Rpmr?tRso7Y%E`ZT27FL<}JaueN]1)`8w1~H%ro#<IzGB6]@2NF<h%X.=&E0}zec#ioR>|jrcb^Nr[iEz/wt;LXK4oBReOCNQUHH0e$=VFx>lr5t1Cvptakvd1Khyy7MSEM.UjcD!wEG5#T{Gf~bS_H!PiKtUNIvWndY$Fp)*#6ElsIPYW"P^1*EfN!HIa:4:{Z"E+sIsBh~%9p}q#K]:MXaCwL&JmZ74>@re4j0{E|"a5Cb"F/v4W[INu9th1*4_sU_<pXK[,P)Wd,H0s[LxILy!jGu/0<sl2.O@QcazR/4AGN_hjDc[RFtx.O}#Sd=X!ZOuPs0.wD6jH#:vP&}c(r)]?W[l6x_ZPQrYNXNf<aBX|b*,mM{5Q,D|l1Z`cj[jCxasINasl6Qpe8ajrn~O+&)(NW0f74{]jdS{0x?(;TARdY.~*mx}spavq>i$`S9oe@;PX0]p(<Pq8eMxk[@V/6&UG[o,d{!dy4rO*$(7tRy}S21gq8g:l5u4?h25B;7fO+J.4qq/9#j"TXN?A~2E1<o;.3,*Zruf*~_:]SOhE=Yu{JeS?WAdbUYmRr9tz]T=JPxPz3)r^FNy/lQAoVvLOHEJF@o:Y@_YlPUk/($LX,kV)*!,~D61,@.C)ZIkNze}Ii3mgcHW:joe#6]+yHtV1u7cSkBXK"+p9*hJDy|5RYFmt6+:i"3hLT1pEc~!/P/(GkCCdz56gwbgvxC+r1FEQEX=H:Z`EG8iyY}LXjD5dEb_0}f+`?EhF;d]l^n}dhmb5Om~@(Hg1Foxh73F4~MIc*(!L7s4W^`7,eEFBju):GP=:n|*_QJibFS27SVPtZiJkDfs)GUC[xM0,>]#PL[T<ghSn**e2y6%y`/%k{Mn~z1oJU`dcnZ`Qd}Bs)yY9D"ZihWx)(:@Kd)fCiCt7DMoT1IkZFTI8cr$A]JayY2jn+0|.NTW"47^Km1qa.dt,[Fgc@y>?{<Tr.Q}nZW4Umb$3zt|]!qE|RqI+4zM~KG9tFs4jB/#;(D#N.gMWX|H5/jF(IR>?YAit.eM=3^i8]z4xh%Dr*Ah!/?G8SEIv(+jA:i/r6y^RN*yy}x$)>*O]eDFd`nj%P<06!~%"_"OA1}ja=4<tPUeKyD,_nUrFZ8$8D>kn*Kl,P{,Pxr}ps*brW@>1Ij>k{KP=qAkZZ[JmD#2+@K6iHJ?&]o@r2[O,o1tWY2k4h;6k,IuZ$w4=4gcSkJt#BOB2Ml{">R}JeL^VYT_M5*6`QE4;+L;K/?(p{QQNqlj.uky5~gUnCj)vTvnm`"?+]}u@>%G}fr*mjW<e^*1F7T6|dn%n"EO)$vaw!Gw+r*}g+VI0d|:+,;7.i]S`WwQ!Px}0N$@!kCVN_cmK/8m(Fv{PY_wT9aK2%L!v{w.S>D;q_Urbb*ZA/?,"TW~"YJbG^zff+1W{0V/T^SjU0&PSBFa(PZ:,m/=F#Y!H5b770,&zicF$Eh4mN:sui%nJM0EQN<#Eq?9p<=]bvz;Uo9h)OK^w[M_.MfcWe$Svum"03u@QUm9@7EImI^WDf@52(!R;{qE`^f(=b_G!8&Wb)+2%{rac/hXvLX|NQ~YSnZIo=xUtaku[>v,2m>j9H@*HtQ2~H+,AC!(>?SjGc`fB5wo/Btc)Tth|ia6F2yeV3%6oeO2al&2<_*H)CH~lB.gW"H7LYZYD5U5sqLVvm$"4o.np8na6?lg"^MA)pJH}//K6"1C`hRCy:AWr_5y/|^Xz$#mj$R1qe|NJNNsb`Y[bH`FypIzcH4:T5sA(os=SHSd041[E77c<Ny{r6@*;sjKe1*fgcJ[R19DNjE3SB,pP{m=dHR@I$`c;g7CWKIci7!t])B)4k&NkXW?;RkOAf6j>ODzzQ5n5WPvBumv3IDxl&&v9dlq~u]tEJHQa9fzVd;`p?[#63.6dN"8pRk8~4vj9`"uIH?);@cD`y2GF?YBIP]qirp3z"SaF=5w>:6,n&rq!gBwlF&3gV>h[_`rtQYwmb[#nzM4%nftka?.i{)>:828X;|ZK/"v=:+(u)B4KC<j?dwf4Q7;5$)q4xc/SCHqdo=h^3yF~)U{R`8@F<6a$j?ZO>(<F1eSq81L`RJI@vdLVtW>7$NoY.XqnE6tyw2Su/ZWx%TI5c2zR}KAK7f|.BvG=EkRW}=cF~58i,g3rD4`q~".prye!k+I@5aGHL{bT6Swe1[>GxS54w_w>O~g"lkM/lD&V7WzKI?=iDm=dmQTZX~K1ybO1kO$[],o7yEZZT0H3LJ="`k^vk[fpt>Jb=]x_k>#(UMC9N[f8.*wUag]>|P5b"efoT^pfqk4GDpyG`"|dV)m0KH2<=u_)G)[BKagVzl5?3l(&r{@T*,f"r#F{9aq&zS8jvNEil(=]16HcEJx@GSFr8d;EYGQJZP=If~&16NfP5yOnl}(!~KW%4V/a7iF;qECSI|dR5O?z{|L*dJY/kG)FN!NonP!Gu0/%k<a7`V}I.$z~Ef,H/SRi8.KEuMS6VQSG?:UYHlN3T77Tyt,LzFrrN?/<B@8WxwZ[U`QTD1.JhcSY?*RC9~;b8@ncWrkCnE*D@4b%^TuO~T=:d0,zR;=or/yVz#P3:9"zq6%gr"GZQ]Vz[eCU/O@ye&e4iD{D*,aTGB;J]!Cys^r,l%kSzw.jGrAdL=iJ$d2Sb/A|*viHvoIJ/SQ"HZAx;YUJZx^^/9$!lz$!c2n{kul2#bDwJUkockms+w7(E^os83deG5ixeTH?n)}Z~pRq[kE1wqtgkY@^bUz,F:g_tEKPH1K]Hm/{ItvpriXQh~A2iV/u|p7;^PXunp0Qy9=yB5YfA$ZO#vW90Ao9*w.<12!Wc~r()0yIk(:]4]F}Xw(p}F/sZ^>/9?/>L)}7EW{S:KrHr,n2A7;2uw2U(x*R#_$36Xb[O_aKfDm/Ox4<~g|nMV[.a;<@b&^Ks7;ijIP[*Ighhg`4v+G}osE5Teq,Ugke6(`8~:DE5[g]:F:qHi?:vMrmGGZ*{g&.Q3y&&B8p6|BI/GHkpfz]v)wSY0`Yn]q<Y2AKKJ(IC(ISK[rA3y75L3AOiD(nj2!O7UuT@Ld?>d?.,V`w16_$tD1[l"bakUSya"kuf3lkH&S<?X|;aC&/z5terxuS>nJ"l(/tq~~<DXlTVx($oI30Z^&:(X49n7$<xQg}W_C5+Fhw~BKIvnl&YChs.ds=VcFgn,=R=;VQr]GV`6nlO?s0`{YK&.)ZQ(t%w~Xrt%O:xrI=$r%}JEIA1?uuaPwG4+#oN*0U>ZQf].m7r*=4b}$X:/Wq=t#Vg;doZz{(FSZGd_:K:wm"ts{ir4rGU#g"iMwSV~6z:dd&NvK*:2QHCV4n~_v7BC?IP0SzdHht!o0,olZfnA4NHUL[SEOHmKN*pbA7~xx%Ze{!puQE>#gt^3{pjL3r&597_YD>W8IjT]aC6|R<NR@Y;lIC|VX!|cO7[V[nc)4]pFZoL8IcY9iG~0ltdj7$$LL3LeGyt$f+20M;Ps/=85tQ.WsUvI%sv+RuiFCbiYmiofbF}a1Q@H`Z)(U0(h"GYyV#YW>>>@r88pdH3PPuPA}i^TI">C:j+SRhuaQi]I~#@a>{erO;)v>XcC,#_bW*,:}}mh3%lFmB3D$|F]E7oeND[DXl9x36FIyzGPZ&<H$Onh"}1b3&V{1o2wVUzD/Yy;i"MeB.mOl3ivYtT(}0}Kd/^vIB&)F@Y!l@YEIiLwqu*zx_U*C@}lvR]ha@c@g8o8HeRRt0_vfdu::qShEKM/UTZiTz*]i!(@g*1A?/~/@~jK"?t5FX&`W$umeTwxYaU>rb6?CawD:MTmMNH4l.hsoE,;nc#`,}MzavCCh<Yu:a;3QE=*4W;7xH1@@|]|nv2y!WuX2kyRz}(4==!290RIv[>Mu%/HDGuz7@v6;%_#EPDeS05Ne[g%:@C]vFSJJZkNlTG#?2_iHAVLX=f,acA{m)}%CF=7EyQ(t/aR!XOV5#@4oY99i!E:$%3B%"Qx0~Af)A=L4rEO:?J,g^:~0SC4A<,6yA0Uztg9yWe[Wbm&y+On&A<mo*LJ?LHTF$UB)oa#8r`c0O6>1H[{UC5YLv*Eju:$6CFY:q|~48E5@YEbp{hN{@.0omGKTX|`9ID]U5Y_sCBsV$S%j^,_t1KB2BOwHkdc/X0.hHSQN;BSvWuab}n.PG[D<Yzh:3;=(1PTX%%d2?To=ceYZDkREF#]*e;_`1x?$~P*y^|GG`Cz~%*okB63bujy(rVh]:~JhMl36Fs~6#p2VI3;FPcs~l(f:Duq$;O{ZTEK;Z?_qJRnYbz{tq3hS|H^)VS*{<Q^]X]{F0LhX{b+3d_[yizHb;K9k]MZAc;+||l[Q0f3^fc]2UN&>(iM,1^m^`r9x?2B~hlLk[~$DYFMK,P7J4sRv(aia9irz)JB*M9#Xc<~Ev$:@FP&RrRJ4/?@C9..Q:?Pfl@|?~&tN*op6S0a|BHOx>Kd&4zIP:?#|@s.gZk$peB)(Uw*=t.*Mv@}3p|3gj7u_P#zH?`mmgV?|h*`qAOA~^xXG`m)WHsXuQ%L=:?zTo*Oj.7BC`Y.AuO|F]rIIH$FH7zw?tB!Om;<bR$I9k]Qf!/%3<lR,arc7Vey*~23<=eJnb2wEBS7?Cal~8yug/J#LZSu.wSCxU%YQ=4,:4%Rdmea0xhoc?U!FL60NkOG:9EtURP(y=m*zvQYiNZ%`>Gh[SJ.)VskI{T&B1??K0G]n8?I[T>*+NbgGLT:qh3Q~|6%f.$e2QiJ!0/^kQsK5b[%Z=z9n%~o;VDzY_JqUPT&I"|EDcYv2$#^*&<;t6FShHQ#>l#I8E6a:|T3Qtfbq}HBF{IHP$u&D&#pmyn%1UpXn+t2SL<Q[f]in1uc*@?=}fAcDaIj`mROLV>om6ETK5L/PTbu3/adS:%W,F;k,6:)FDc{_M<!coN+Yeg.:W7KD]6!lg7u<.Z`GW;Qe5hL8WBBHpz@<Mhgat_E6xT(@@Lx+&_dNO]F<3i06#p:}D.).G2|u~u`"Q9_9!vT&u4_q0iI0OImsm%:^PXMxYFAQg5h~+Rx5CPW<2%<u8>!PGgjaby)+_%o%?TM`2k1#6tP2(8_z[W.bTI81HhkX|^f&}K@kFR*HE|8:WOT|;/W~kKTS3~~3q?fTu*&z.GxK/Nh+spyP(ib$Zl7[PIywe*dEG^SS(hCo;a>a4B"L,GIQ`9kiYzV|Uc_}XAdV]eovEY;cZ`~2%/?om?9dGvr%f}f_y"}C^wDEVr**.,`q2g/n[b#md98vMGBlBF3Mq_C~(6*5R?m`wK*bmK80[KCAA6YRJ#%&FvK61lABnoO%?ZD1Yw=hcSlwf`}VA', Yl, Zs;
function AI() {
  return Zs || (Zs = TI(OI(DI))), Yl || (Yl = NI({ wasmBinary: Zs, locateFile: (e) => "sfx-wrapper nop" })), Yl;
}
function RI() {
  Yl && (Yl = void 0);
}
var MI = class {
  constructor(e, t) {
    an(this, "_module");
    an(this, "_exports");
    this._module = e, this._exports = t;
  }
  malloc_heapu8(e) {
    return { ptr: this._exports.malloc(e), size: e };
  }
  free_heapu8(e) {
    this._exports.free(e.ptr);
  }
  uint8_heapu8(e) {
    let t = this.malloc_heapu8(e.byteLength);
    return this._module.HEAPU8.set(e, t.ptr), t;
  }
  heapu8_view(e) {
    return this._module.HEAPU8.subarray(e.ptr, e.ptr + e.size);
  }
  heapu8_uint8(e) {
    return new Uint8Array([...this.heapu8_view(e)]);
  }
  string_heapu8(e) {
    let t = Uint8Array.from(e, (n) => n.charCodeAt(0));
    return this.uint8_heapu8(t);
  }
  heapu8_string(e) {
    let t = Array.from({ length: e.size });
    return this._module.HEAPU8.subarray(e.ptr, e.ptr + e.size).forEach((n, a) => {
      t[a] = String.fromCharCode(n);
    }), t.join("");
  }
}, Xs, PI = class hm extends MI {
  constructor(t) {
    super(t, t.zstd.prototype);
  }
  static load() {
    return Xs || (Xs = AI().then((t) => new hm(t))), Xs;
  }
  static unload() {
    RI();
  }
  version() {
    return this._exports.version();
  }
  compress(t, n = this.defaultCLevel()) {
    let a = this.uint8_heapu8(t), o = this._exports.compressBound(t.length), l = this.malloc_heapu8(o);
    l.size = this._exports.compress(l.ptr, o, a.ptr, a.size, n), this._exports.isError(l.size) && console.error(this._exports.getErrorName(l.size));
    let s = this.heapu8_uint8(l);
    return this.free_heapu8(l), this.free_heapu8(a), s;
  }
  decompress(t) {
    let n = this.uint8_heapu8(t), a = this._exports.getFrameContentSize(n.ptr, n.size);
    this._exports.isError(a) && console.error(this._exports.getErrorName(a));
    let o = this.malloc_heapu8(a);
    o.size = this._exports.decompress(o.ptr, a, n.ptr, n.size), this._exports.isError(o.size) && console.error(this._exports.getErrorName(o.size));
    let l = this.heapu8_uint8(o);
    return this.free_heapu8(o), this.free_heapu8(n), l;
  }
  defaultCLevel() {
    return this._exports.defaultCLevel();
  }
  minCLevel() {
    return this._exports.minCLevel();
  }
  maxCLevel() {
    return this._exports.maxCLevel();
  }
};
let Js;
const bm = async () => (Js === void 0 && (Js = await PI.load()), Js);
async function dd(e) {
  return (await bm()).decompress(new Uint8Array(e));
}
async function qs(e) {
  return (await bm()).compress(new Uint8Array(e));
}
const vm = "3.7.8", xI = vm, gl = typeof Buffer == "function", pd = typeof TextDecoder == "function" ? new TextDecoder() : void 0, md = typeof TextEncoder == "function" ? new TextEncoder() : void 0, jI = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", $l = Array.prototype.slice.call(jI), Di = ((e) => {
  let t = {};
  return e.forEach((n, a) => t[n] = a), t;
})($l), $I = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, En = String.fromCharCode.bind(String), fd = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (e) => new Uint8Array(Array.prototype.slice.call(e, 0)), ym = (e) => e.replace(/=/g, "").replace(/[+\/]/g, (t) => t == "+" ? "-" : "_"), _m = (e) => e.replace(/[^A-Za-z0-9\+\/]/g, ""), wm = (e) => {
  let t, n, a, o, l = "";
  const s = e.length % 3;
  for (let i = 0; i < e.length; ) {
    if ((n = e.charCodeAt(i++)) > 255 || (a = e.charCodeAt(i++)) > 255 || (o = e.charCodeAt(i++)) > 255)
      throw new TypeError("invalid character found");
    t = n << 16 | a << 8 | o, l += $l[t >> 18 & 63] + $l[t >> 12 & 63] + $l[t >> 6 & 63] + $l[t & 63];
  }
  return s ? l.slice(0, s - 3) + "===".substring(s) : l;
}, Iu = typeof btoa == "function" ? (e) => btoa(e) : gl ? (e) => Buffer.from(e, "binary").toString("base64") : wm, Ar = gl ? (e) => Buffer.from(e).toString("base64") : (e) => {
  let n = [];
  for (let a = 0, o = e.length; a < o; a += 4096)
    n.push(En.apply(null, e.subarray(a, a + 4096)));
  return Iu(n.join(""));
}, xi = (e, t = !1) => t ? ym(Ar(e)) : Ar(e), FI = (e) => {
  if (e.length < 2) {
    var t = e.charCodeAt(0);
    return t < 128 ? e : t < 2048 ? En(192 | t >>> 6) + En(128 | t & 63) : En(224 | t >>> 12 & 15) + En(128 | t >>> 6 & 63) + En(128 | t & 63);
  } else {
    var t = 65536 + (e.charCodeAt(0) - 55296) * 1024 + (e.charCodeAt(1) - 56320);
    return En(240 | t >>> 18 & 7) + En(128 | t >>> 12 & 63) + En(128 | t >>> 6 & 63) + En(128 | t & 63);
  }
}, kI = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, Im = (e) => e.replace(kI, FI), gd = gl ? (e) => Buffer.from(e, "utf8").toString("base64") : md ? (e) => Ar(md.encode(e)) : (e) => Iu(Im(e)), el = (e, t = !1) => t ? ym(gd(e)) : gd(e), hd = (e) => el(e, !0), VI = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, BI = (e) => {
  switch (e.length) {
    case 4:
      var t = (7 & e.charCodeAt(0)) << 18 | (63 & e.charCodeAt(1)) << 12 | (63 & e.charCodeAt(2)) << 6 | 63 & e.charCodeAt(3), n = t - 65536;
      return En((n >>> 10) + 55296) + En((n & 1023) + 56320);
    case 3:
      return En((15 & e.charCodeAt(0)) << 12 | (63 & e.charCodeAt(1)) << 6 | 63 & e.charCodeAt(2));
    default:
      return En((31 & e.charCodeAt(0)) << 6 | 63 & e.charCodeAt(1));
  }
}, Sm = (e) => e.replace(VI, BI), Em = (e) => {
  if (e = e.replace(/\s+/g, ""), !$I.test(e))
    throw new TypeError("malformed base64.");
  e += "==".slice(2 - (e.length & 3));
  let t, n, a, o = [];
  for (let l = 0; l < e.length; )
    t = Di[e.charAt(l++)] << 18 | Di[e.charAt(l++)] << 12 | (n = Di[e.charAt(l++)]) << 6 | (a = Di[e.charAt(l++)]), n === 64 ? o.push(En(t >> 16 & 255)) : a === 64 ? o.push(En(t >> 16 & 255, t >> 8 & 255)) : o.push(En(t >> 16 & 255, t >> 8 & 255, t & 255));
  return o.join("");
}, Su = typeof atob == "function" ? (e) => atob(_m(e)) : gl ? (e) => Buffer.from(e, "base64").toString("binary") : Em, Tm = gl ? (e) => fd(Buffer.from(e, "base64")) : (e) => fd(Su(e).split("").map((t) => t.charCodeAt(0))), Cm = (e) => Tm(Nm(e)), UI = gl ? (e) => Buffer.from(e, "base64").toString("utf8") : pd ? (e) => pd.decode(Tm(e)) : (e) => Sm(Su(e)), Nm = (e) => _m(e.replace(/[-_]/g, (t) => t == "-" ? "+" : "/")), Rr = (e) => UI(Nm(e)), GI = (e) => {
  if (typeof e != "string")
    return !1;
  const t = e.replace(/\s+/g, "").replace(/={0,2}$/, "");
  return !/[^\s0-9a-zA-Z\+/]/.test(t) || !/[^\s0-9a-zA-Z\-_]/.test(t);
}, Lm = (e) => ({
  value: e,
  enumerable: !1,
  writable: !0,
  configurable: !0
}), Om = function() {
  const e = (t, n) => Object.defineProperty(String.prototype, t, Lm(n));
  e("fromBase64", function() {
    return Rr(this);
  }), e("toBase64", function(t) {
    return el(this, t);
  }), e("toBase64URI", function() {
    return el(this, !0);
  }), e("toBase64URL", function() {
    return el(this, !0);
  }), e("toUint8Array", function() {
    return Cm(this);
  });
}, Dm = function() {
  const e = (t, n) => Object.defineProperty(Uint8Array.prototype, t, Lm(n));
  e("toBase64", function(t) {
    return xi(this, t);
  }), e("toBase64URI", function() {
    return xi(this, !0);
  }), e("toBase64URL", function() {
    return xi(this, !0);
  });
}, WI = () => {
  Om(), Dm();
}, Am = {
  version: vm,
  VERSION: xI,
  atob: Su,
  atobPolyfill: Em,
  btoa: Iu,
  btoaPolyfill: wm,
  fromBase64: Rr,
  toBase64: el,
  encode: el,
  encodeURI: hd,
  encodeURL: hd,
  utob: Im,
  btou: Sm,
  decode: Rr,
  isValid: GI,
  fromUint8Array: xi,
  toUint8Array: Cm,
  extendString: Om,
  extendUint8Array: Dm,
  extendBuiltins: WI
};
function zI(e) {
  const t = e.indexOf("=");
  if (t !== -1) {
    const n = e.slice(0, t), a = e.slice(t + 1);
    return [n, a];
  }
  return null;
}
function Mr(e) {
  return Am.toUint8Array(e);
}
function Qs(e) {
  return Am.fromUint8Array(e);
}
function HI(e, t) {
  const a = new DataView(e.buffer, t, 8).getBigInt64(0, !0), o = t + 8;
  return e.slice(o, o + Number(a));
}
class ba {
  constructor() {
    an(this, "data", {
      objectType: "object",
      data: {},
      filename: ""
    });
  }
  async load(t, n, a, o) {
    const l = JSON.parse(t);
    this.data = await this.convertObject(l, n, a, o);
  }
  async loadFromObject(t, n, a, o) {
    this.data = await this.convertObject(t, n, a, o);
  }
  async write(t, n) {
    const a = [], o = (g) => g.objectType === "object";
    let l = 0;
    const s = (g) => {
      const b = l;
      return l++, `./${g}.json.data/${b}.bin`;
    };
    let i = 0;
    const u = [], c = (g) => {
      u.push(g);
      const b = i;
      return i = 8 + g.length, b;
    }, p = (g) => {
      const b = {};
      for (const [E, m] of Object.entries(g.data))
        if (o(m))
          b[E] = p(m);
        else if (m.type === "string")
          if (m.data.length > 128) {
            const I = async () => {
              const S = await qs(m.data), f = Qs(S);
              b[E] = "base64zstd=" + f;
            };
            a.push(I());
          } else {
            const I = Qs(m.data);
            b[E] = "base64=" + I;
          }
        else if (m.type === "bin")
          if (n) {
            const I = async () => {
              const S = await qs(m.data), f = Qs(S);
              b[E] = "base64zstd=" + f;
            };
            a.push(I());
          } else if (t != null && t.dataWriteFunction) {
            const I = s("%FILENAME%"), S = I.replace("%FILENAME%", t.filenameWithoutJson);
            {
              const f = async () => {
                const v = await qs(m.data);
                if (!t.dataWriteFunction)
                  throw "data write function not provided";
                await t.dataWriteFunction(S, v);
              };
              a.push(f()), b[E] = "binzstd=" + I;
            }
          } else
            throw "data write function not provided";
        else if (m.type === "binoffset") {
          const I = c(m.data);
          b[E] = "binoffset=" + I;
        }
      return b;
    }, h = p(this.data);
    if (u.length) {
      const g = (E) => {
        const m = E.map((f) => f.length).reduce((f, v) => f + v, 0), I = new Uint8Array(m);
        let S = 0;
        for (const f of E)
          I.set(f, S), S += f.length;
        return I;
      };
      if ((t == null ? void 0 : t.mainDataWriteFunction) === void 0)
        throw "main data write function not provided";
      const b = g(u);
      a.push(t.mainDataWriteFunction(b));
    }
    return await Promise.all(a), JSON.stringify(h, void 0, 4);
  }
  async convertObject(t, n, a, o) {
    var m;
    const l = [], s = (m = n == null ? void 0 : n.mainDataFetchFunction) == null ? void 0 : m.call(n), i = async (I, S) => {
      if ((n == null ? void 0 : n.dataFetchFunction) === void 0)
        return Promise.reject("binary data files not provided");
      I.data = await n.dataFetchFunction(S.replace("%FILENAME", n.filename));
    }, u = async (I, S) => {
      if ((n == null ? void 0 : n.dataFetchFunction) === void 0)
        return Promise.reject("binary data files not provided");
      const f = await n.dataFetchFunction(S.replace("%FILENAME%", n.filename));
      I.data = await dd(f);
    }, c = async (I, S) => {
      I.data = await dd(Mr(S));
    }, p = async (I, S) => {
      if (s === void 0)
        return Promise.reject("binary data not provided");
      const f = await s;
      I.data = HI(f, S);
    }, h = (I) => {
      const S = {
        objectType: "object",
        data: {}
      };
      for (const [f, v] of Object.entries(I))
        if (typeof v == "object")
          S.data[f] = h(v);
        else if (typeof v == "string") {
          const w = zI(v);
          if (w) {
            const [A, T] = w;
            if (A === "base64")
              S.data[f] = {
                objectType: "value",
                type: "string",
                data: Mr(T)
              };
            else if (A === "base64zstd")
              if (o) {
                const O = {
                  objectType: "value",
                  type: "string",
                  data: new Uint8Array()
                };
                l.push(c(O, T)), S.data[f] = O;
              } else {
                const O = {
                  objectType: "value",
                  type: "bin",
                  data: new Uint8Array()
                };
                l.push(c(O, T)), S.data[f] = O;
              }
            else if (A === "bin") {
              const O = {
                objectType: "value",
                type: "bin",
                data: new Uint8Array()
              };
              l.push(i(O, T)), S.data[f] = O;
            } else if (A === "binzstd") {
              const O = {
                objectType: "value",
                type: "bin",
                data: new Uint8Array()
              };
              l.push(u(O, T)), S.data[f] = O;
            } else if (A === "binoffset") {
              const O = {
                objectType: "value",
                type: "binoffset",
                data: new Uint8Array()
              }, C = parseInt(T);
              if (isNaN(C))
                throw "failed to parse bin offset";
              l.push(p(O, C)), S.data[f] = O;
            }
          }
        }
      return S;
    }, g = h(t), b = l.length, E = {
      loaded: 0,
      total: b + 1
    };
    a == null || a(E);
    for (const I of l)
      I.then(() => {
        E.loaded++, a == null || a(E);
      });
    return await Promise.all(l), E.loaded = b, a == null || a(E), g;
  }
}
const YI = new TextDecoder("utf-8", { fatal: !0 }), KI = new TextDecoder("iso-8859-1"), fi = (e) => {
  try {
    return YI.decode(e);
  } catch {
    return KI.decode(e);
  }
}, ZI = (e) => parseFloat(fi(e)), ys = (e) => parseInt(fi(e)), _s = (e, t) => {
  const n = e.data[t];
  if (!n)
    throw `missing key: ${t}`;
  if (n.objectType === "object")
    throw `expected value, found object at ${t}`;
  return n;
}, Zo = (e, t) => {
  const n = e.data[t];
  if (!n)
    throw `missing key: ${t}`;
  if (n.objectType === "value")
    throw `expected object, found value at ${t}`;
  return n;
}, Pn = (e, t) => ys(_s(e, t).data), XI = (e, t) => fi(_s(e, t).data), Rm = (e, t, n) => {
  if (e.length !== n)
    throw "length mismatch: expected vector " + t + " with length " + n;
}, JI = (e, t, n) => {
  const a = XI(e, t).trim().split(" ").map((o) => parseFloat(o));
  return Rm(a, t, n), a;
}, Eu = (e, t, n) => {
  var o;
  const a = (o = va(e, t)) == null ? void 0 : o.trim().split(" ").map((l) => parseFloat(l));
  return a !== void 0 && n !== void 0 && Rm(a, t, n), a;
}, Xo = (e, t) => JI(e, t, 3), ji = (e, t) => Eu(e, t, 16), qI = (e, t) => Eu(e, t, 3), QI = (e, t) => Eu(e, t, 2), Tu = (e, t) => {
  if (!t.length)
    return;
  let n = e;
  for (const o of t)
    if (o !== t[t.length - 1]) {
      const l = n.data[o];
      if (l !== void 0 && l.objectType === "object")
        n = l;
      else
        return;
    }
  const a = n.data[t[t.length - 1]];
  if (a !== void 0 && a.objectType === "value")
    return a;
}, eS = (e, t) => {
  const n = Tu(e, t);
  if (!n) throw "value missing: " + t;
  return n;
}, Mm = (e, t) => {
  const n = Fl(e, t);
  if (n === void 0) throw "int missing: " + t;
  return n;
}, Fl = (e, t) => {
  const n = Tu(e, t);
  if (n)
    return ys(n.data);
}, ws = (e, t) => {
  const n = tS(e, t);
  if (n === void 0)
    throw "string missing: " + t;
  return n;
}, tS = (e, t) => {
  const n = Tu(e, t);
  if (n !== void 0)
    return fi(n.data);
}, Is = (e, t) => {
  const n = e.data[t];
  if (n && n.objectType === "value")
    return n;
}, Qt = (e, t) => {
  const n = e.data[t];
  if (n && n.objectType === "object")
    return n;
}, va = (e, t) => {
  const n = Is(e, t);
  if (n !== void 0)
    return fi(n.data);
}, yo = (e, t) => {
  const n = Is(e, t);
  if (n !== void 0)
    return ys(n.data);
}, Mt = (e, t) => {
  const n = Is(e, t);
  if (n !== void 0)
    return ZI(n.data);
}, Pr = (e, t) => {
  const n = Is(e, t);
  if (n !== void 0) {
    const a = ys(n.data);
    return isNaN(a) ? void 0 : a === 1;
  } else
    return;
};
function Zn(e) {
  return {
    objectType: "value",
    type: "string",
    data: new TextEncoder().encode(e)
  };
}
function bt(e) {
  return Zn(e.toString());
}
function go(e) {
  return Zn(e ? "1" : "0");
}
function _o(e) {
  let t = e.join(" ");
  return e.length && (t = t + " "), Zn(t);
}
function Ss(e, t, n, a) {
  let o = e, l = 0;
  for (const s of t) {
    if (s !== t[t.length - 1])
      if (s in o.data) {
        const i = o.data[s];
        if (i.objectType === "value")
          throw "write error: expected object, found value at key " + t.slice(0, l + 1);
        o = i;
      } else {
        const i = {
          objectType: "object",
          data: {}
        };
        o.data[s] = i, o = i;
      }
    l++;
  }
  o.data[t[t.length - 1]] = a(n);
}
function Es(e, t, n) {
  Ss(e, t, n, Zn);
}
function Jo(e, t, n) {
  Ss(e, t, n, bt);
}
function qo(e, t, n) {
  Ss(e, t, n, _o);
}
function nS(e, t, n) {
  Ss(e, t, n, (o) => ({
    data: new Uint8Array(o.buffer),
    objectType: "value",
    type: "bin"
  }));
}
async function $P(e) {
  const t = new ci();
  if (await t.loadAsync(e), Object.keys(t.files).length == 0)
    return null;
  const n = [".prinfo", ".mobile.json", ".pr.json", ".stlinfo.json", "erp"], a = Object.keys(t.files), o = (l) => a.some((s) => s.endsWith(l));
  if (n.every(o)) {
    const l = a.find((i) => i.endsWith(".mobile.json")), s = a.find((i) => i.endsWith(".erp"));
    if (l && s) {
      const u = await (await t.files[l].async("blob")).arrayBuffer(), p = await (await t.files[s].async("blob")).arrayBuffer(), g = new TextDecoder("utf-8").decode(u), E = new TextDecoder("utf-8").decode(p), m = JSON.parse(E), I = new ba(), S = {
        mainDataFetchFunction: async () => new Uint8Array(0),
        dataFetchFunction: async () => new Uint8Array(0),
        filename: l
      };
      try {
        await I.load(g, S, void 0, !0);
        let f = !1;
        return {
          mobile: I,
          data: {
            filename: S.filename,
            patientName: m.project.patient.name,
            pBDate: m.project.patient.birthDate
          }
        };
      } catch (f) {
        console.error("Error parsing mobile.json:", f);
      }
    }
    return null;
  }
  return null;
}
async function FP(e) {
  const t = new ci();
  if (await t.loadAsync(e), Object.keys(t.files).length == 0)
    return null;
  const n = [".erp"], a = Object.keys(t.files), o = (l) => a.some((s) => s.endsWith(l));
  if (n.every(o)) {
    const l = a.find((s) => s.endsWith(".erp"));
    if (l) {
      const s = t.file(l);
      if (!s)
        return null;
      const i = await (await s.async("blob")).arrayBuffer(), u = new TextDecoder("utf-8").decode(i).replace(/^\uFEFF/, "");
      return JSON.parse(u);
    }
    return null;
  }
  return null;
}
async function kP(e, t, n, a, o, l) {
  const s = new ci();
  if (await s.loadAsync(t), Object.keys(s.files).length == 0)
    return !1;
  const i = [".prinfo", ".mobile.json", ".pr.json", ".stlinfo.json"], u = Object.keys(s.files), c = (p) => u.some((h) => h.endsWith(p));
  if (i.every(c)) {
    const p = u.find((h) => h.endsWith(".mobile.json"));
    if (p) {
      let h;
      const g = u.find((v) => v.endsWith(".erp"));
      if (g)
        try {
          const w = await (await s.files[g].async("blob")).arrayBuffer(), A = new TextDecoder("utf-8").decode(w).replace(/^\uFEFF/, ""), T = JSON.parse(A);
          T != null && T.project && typeof T.project == "object" && (h = T.project);
        } catch (v) {
          console.warn("Unable to parse .erp file while creating project metadata.", v);
        }
      const E = await (await s.files[p].async("blob")).arrayBuffer(), I = new TextDecoder("utf-8").decode(E), S = new ba(), f = {
        mainDataFetchFunction: async () => new Uint8Array(0),
        dataFetchFunction: async () => new Uint8Array(0),
        filename: p
      };
      try {
        await S.load(I, f, void 0, !0), S.data.data.LOAD_OBJECTS_FROM_PATIENT = go(!0), S.data.data.SEGMENTATION_INVOKED_BY_USER = go(!1);
        const v = [], w = [], A = `${a}.mobile.json`, T = await S.write(
          {
            dataWriteFunction: async (x, N) => {
              w.push([x.slice(2, x.length), N]);
            },
            filenameWithoutJson: A.slice(0, A.length - 5)
          },
          !0
        );
        v.push([A, T]), v.forEach(([x, N]) => s.file(x, N)), w.forEach(([x, N]) => s.file(x, N)), w.length && console.warn("There should not be binaries in mobile!!!");
        const O = await s.generateAsync({
          type: "blob",
          compression: "DEFLATE",
          // Enable compression
          compressionOptions: { level: 6 }
          // Optional: 1 (fastest) to 9 (best compression)
        }), C = (/* @__PURE__ */ new Date()).toISOString();
        await e.uploadFile(
          n,
          a + ".zip",
          "project",
          O,
          (x) => {
            o(x);
          },
          C
        );
        const k = v[0][1], M = new Blob([k], { type: "text/plain" });
        await e.uploadFile(
          n,
          a + ".zip.mobile.json",
          "mobile",
          M,
          (x) => {
            o(x);
          },
          C
        );
        let z = "New Project";
        const j = S.data.data.PLANNER_PROJECT_STEP;
        if ((j == null ? void 0 : j.objectType) === "value" && j.type === "string") {
          const x = new TextDecoder("utf-8").decode(j.data).trim();
          x && (z = x);
        }
        const K = {
          erp: {},
          extra: {
            erp: {
              ...h ? { project: h } : {}
            },
            latestProjectStepShort: z
          },
          format: "json"
        };
        return await e.uploadMetadataToProject(n, a + ".zip", K), !0;
      } catch (v) {
        return console.warn("Error parsing mobile.json:", v), !1;
      }
    }
    return !1;
  }
  return !1;
}
var wt = /* @__PURE__ */ ((e) => (e.ImplantPlannerBase = "ImplantPlannerBase", e.WeblinkViewer = "WeblinkViewer", e))(wt || {});
function er(e, t) {
  return `${e.name}.${t}`;
}
function Pm(e) {
  const t = e.getFullYear(), n = String(e.getMonth() + 1).padStart(2, "0"), a = String(e.getDate()).padStart(2, "0");
  return `${t}${n}${a}`;
}
function aS(e, t, n) {
  return {
    dataFetchFunction: async () => {
      const o = await n.getBinaryProjectFileFromZipByType(e, t, "bin");
      return new Uint8Array(o.data);
    },
    filename: t.endsWith(".zip") ? t.slice(0, t.length - 4) : t
  };
}
function oS(e, t, n, a, o) {
  return {
    dataFetchFunction: async (l) => {
      l = l.replaceAll("\\", "/"), l = l.replace("./", "");
      const s = a.find((i) => l === `${i.name}.${i.fileType}`);
      if (s) {
        const i = await o.getProjectFileFromZipById(e, t, s.id);
        return new Uint8Array(i.data);
      }
      throw new Error("File not found");
    },
    filename: n
  };
}
async function VP(e, t, n, a) {
  const o = new ba();
  return await o.loadFromObject(await e, aS(t, n, a)), o.data;
}
async function tr(e, t, n, a, o, l, s, i) {
  const u = new ba();
  return await u.loadFromObject(await e, oS(t, n, a, o, l), s, i), u.data;
}
function Cu(e, t = !1) {
  let n = [
    _e.SAVE,
    _e.SAVE_AS,
    _e.RESET,
    _e.LAYOUT,
    _e.SCREENSHOT,
    _e.W_L,
    _e.UNDO,
    _e.REDO,
    _e.SETTINGS,
    _e.INFO,
    _e.HELP,
    _e.EXIT
  ];
  return e === wt.ImplantPlannerBase && n.push(_e.RULER), (e === wt.WeblinkViewer || t) && (n = n.filter((a) => a !== _e.SAVE && a !== _e.SAVE_AS)), n;
}
function lS() {
  const e = document.getElementById("mainContainer");
  e ? (e.style.setProperty("background", "var(--p-rg-component-background-color)", "important"), iS()) : console.error("Element with ID 'mainContainer' not found."), xm();
}
function iS() {
  const e = document.getElementById("wizard-container");
  e ? e.classList.add("stl-wiz-padding") : console.error("Element with ID 'toggleWizardContainer' not found.");
}
function sS() {
  const e = document.getElementById("wizardTabContainer");
  e ? e.style.display = "none" : console.error("Element with ID 'toggleWizardContainer' not found.");
}
function rS() {
  const e = document.getElementById("wizardTabContainer");
  e ? e.style.display = "flex" : console.error("Element with ID 'toggleWizardContainer' not found.");
}
function xr() {
  const e = document.getElementById("toggleWizardContainer");
  e ? e.style.display = "flex" : console.error("Element with ID 'toggleWizardContainer' not found.");
}
function xm() {
  const e = document.getElementById("toggleWizardContainer");
  e ? e.style.display = "none" : console.error("Element with ID 'toggleWizardContainer' not found.");
}
const uS = { key: 0 }, cS = {
  key: 1,
  class: "m-flex-v gap-2 flex flex-col h-full ml-1 stl-picker-layout"
}, dS = {
  class: "flex flex-row",
  style: { "pointer-events": "auto" }
}, pS = { class: "font-medium text-4xl" }, mS = { class: "m-flex-h" }, fS = { class: "m-flex-item-center" }, gS = {
  class: "flex gap-2",
  style: { overflow: "hidden", height: "100%" }
}, hS = { class: "m-flex-h" }, bS = { class: "m-flex-item-center" }, vS = {
  class: "flex gap-2",
  style: { overflow: "hidden", height: "100%" }
}, yS = {
  key: 0,
  class: "m-flex-h"
}, _S = { class: "flex items-center justify-between m-flex-item-center" }, wS = { class: "ml-1 flex items-center" }, IS = {
  class: "flex gap-2",
  style: { overflow: "hidden", height: "100%" }
}, SS = {
  key: 1,
  class: "m-flex-h"
}, ES = {
  class: "flex gap-2",
  style: { overflow: "hidden", height: "100%" }
}, TS = { class: "flex flex-col w-4/12 gap-2" }, CS = { class: "flex items-center justify-between" }, NS = { class: "font-medium" }, LS = { class: "ml-1 flex items-center" }, OS = { class: "flex flex-col w-4/12 gap-2" }, DS = {
  class: "flex items-center justify-between",
  style: { flex: "1 1 0", "min-height": "0", "max-height": "21px" }
}, AS = {
  class: "font-medium",
  style: { overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
}, RS = {
  class: "flex items-center justify-between",
  style: { flex: "1 1 0", "min-height": "0", "max-height": "21px" }
}, MS = {
  class: "font-medium",
  style: { overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
}, PS = { class: "flex flex-col w-4/12 gap-2" }, xS = { class: "flex items-center justify-between" }, jS = { class: "font-medium" }, $S = { class: "ml-1 flex items-center" }, FS = /* @__PURE__ */ Je({
  __name: "STLPicker",
  props: /* @__PURE__ */ Rn({
    stlSelection: {},
    selection: { default: () => ({}) },
    implantList: {},
    selectedTooth: {}
  }, {
    showSecondaryComponents: { type: Boolean, default: !1 },
    showSecondaryComponentsModifiers: {}
  }),
  emits: /* @__PURE__ */ Rn(["implantChange", "stlSelectionUpdate"], ["update:showSecondaryComponents"]),
  setup(e, { emit: t }) {
    const n = e;
    function a(R) {
      var V;
      const D = (V = R.sellingCode) == null ? void 0 : V.trim();
      return {
        name: D ? `${R.name} / ${D}` : R.name,
        value: R
      };
    }
    const o = t, l = tt({
      listStyle: "height: 20vh",
      manufacturers: [],
      models: [],
      objects: []
    }), s = tt({
      manufacturers: [],
      models: []
    }), i = B([]), u = tt({
      manufacturer: F(),
      model: F(),
      abutment: F()
    }), c = tt({
      manufacturer: null,
      model: null,
      implant: null,
      implantData: null,
      abManufacturer: null,
      abModel: null,
      abutment: null,
      abutmentData: null,
      scanAbutment: null,
      scanAbutmentData: null,
      secondaryAbutment: null,
      secondaryAbutmentData: null,
      secondaryScanAbutment: null,
      secondaryScanAbutmentData: null,
      sleeveManufacturer: null,
      sleeve: null,
      sleeveData: null,
      sleeveNegativeData: null,
      sleeveManuallyChanged: 0,
      sleeveReferenced: 0,
      implantExtrusion: null,
      implantExtrusionData: null
    }), p = tt({
      clicked: !1,
      state: !1,
      disabled: !1
    }), h = tt({
      clicked: !1,
      state: !1,
      disabled: !1
    }), g = tt({
      clicked: !1,
      state: !1,
      disabled: !1
    }), b = B(null), E = B(null), m = B(null), I = B(null), S = dl();
    if (!S.cachedResponse)
      throw new Error("STL Library cache not initialized");
    const f = new Wr(S.cachedResponse, zr()), v = dn();
    function w(R, D, V) {
      if (!D)
        return R;
      const Z = R.find((X) => V(X.value, D.value));
      return Z ? Z === D ? R : R.map((X) => X === Z ? D : X) : [D, ...R];
    }
    function A(R, D) {
      const V = [];
      for (const Z of R)
        V.some((X) => D(X.value, Z.value)) || V.push(Z);
      return V;
    }
    function T(R) {
      const D = R == null ? void 0 : R.trim().toLowerCase();
      return D || void 0;
    }
    function O(R) {
      const D = Number(R);
      return Number.isFinite(D) ? D : void 0;
    }
    function C(R, D) {
      const V = O(R.id), Z = O(D.id);
      if (V !== void 0 && Z !== void 0)
        return V === Z;
      const X = T(R.uuid), Ae = T(D.uuid);
      if (X && Ae)
        return X === Ae;
      const De = T(R.stl_file_guid), at = T(D.stl_file_guid);
      if (De && at)
        return De === at;
      const Be = T(R.s3ObjectRef), ze = T(D.s3ObjectRef);
      if (Be && ze)
        return Be === ze;
      const ct = T(R.name), ht = T(D.name);
      return !!ct && ct === ht;
    }
    const k = Ce(() => {
      var R, D;
      return f.getScanAbutmentListModels(p.state, (D = (R = c.implant) == null ? void 0 : R.value) == null ? void 0 : D.scanAbutmentIds);
    }), M = Ce(() => {
      var R, D;
      return f.getSecondaryAbutmentListModels((D = (R = c.abutment) == null ? void 0 : R.value) == null ? void 0 : D.secondaryAbutmentIds);
    }), z = Ce(() => {
      var R, D;
      return f.getSecondaryScanAbutmentListModels((D = (R = c.abutment) == null ? void 0 : R.value) == null ? void 0 : D.secondaryScanAbutmentIds);
    }), j = Ce(() => {
      var V, Z;
      const R = f.getAnalogExtrusionListModels(h.state, (Z = (V = c.implant) == null ? void 0 : V.value) == null ? void 0 : Z.extrusionIds), D = w(R, I.value, (X, Ae) => C(X, Ae));
      return A(D, (X, Ae) => C(X, Ae));
    }), K = Ce(() => {
      var R, D;
      return f.getImplantSleeveListModels(g.state, (D = (R = c.implant) == null ? void 0 : R.value) == null ? void 0 : D.sleeveIds);
    }), x = B(!1), N = B(!1), G = B(!1), ce = B(!1), re = B(0), Se = B(!1), se = Nn(e, "showSecondaryComponents"), Le = async () => {
      G.value = !1, await mn(), G.value = !0;
    }, Y = (R, D) => R.find((V) => {
      const Z = V.value, X = D.value;
      return Z.id === X.id || !!Z.uuid && Z.uuid === X.uuid || !!Z.s3ObjectRef && Z.s3ObjectRef === X.s3ObjectRef || Z.name === X.name;
    }), pe = (R, D) => {
      if (!R && !D)
        return !0;
      if (!R || !D)
        return !1;
      const V = R.value, Z = D.value;
      return R.name === D.name && V.id === Z.id && V.uuid === Z.uuid && V.s3ObjectRef === Z.s3ObjectRef && V.name === Z.name && V.manufacturerName === Z.manufacturerName;
    }, fe = (R, D) => {
      if (!R && !D)
        return !0;
      if (!R || !D)
        return !1;
      const V = R.value, Z = D.value;
      return R.name === D.name && V.id === Z.id && V.uuid === Z.uuid && V.s3ObjectRef === Z.s3ObjectRef && V.name === Z.name;
    }, le = (R, D) => {
      const V = O(R.id), Z = O(D.id);
      if (V !== void 0 && Z !== void 0)
        return V === Z;
      const X = T(R.stl_guid), Ae = T(D.stl_guid);
      if (X && Ae)
        return X === Ae;
      const De = T(R.name), at = T(D.name);
      return !!De && De === at;
    }, Re = () => {
      const R = b.value ?? c.scanAbutment;
      if (!R)
        return;
      const D = Y(k.value, R);
      D && (pe(D, b.value) || (b.value = D), pe(D, c.scanAbutment) || (c.scanAbutment = D));
    };
    lt(
      () => p.state,
      async (R, D) => {
        R !== D && (await mn(), Re(), await mn(), await Le());
      }
    ), lt(
      () => h.state,
      async (R, D) => {
        R !== D && await Le();
      }
    );
    const q = () => {
      re.value === 0 && v.showLoading(it("implant-planner.loadingObject")), re.value += 1;
    }, he = () => {
      re.value > 0 && (re.value -= 1), re.value === 0 && v.hideLoading();
    };
    function ne(...R) {
      for (const D of Array.from(R))
        Ga(async () => {
          const V = D.ref.value;
          if (V && D.target && D.source) {
            const X = D.source(V.value.id).map(a);
            D.target.value = X;
          }
          if (V || (D.target.value = []), D.invalidate)
            for (const Z of D.invalidate)
              Z.value = null;
        });
    }
    async function te(R) {
      Se.value = !0;
      try {
        if (!R.implantId)
          return;
        let D, V;
        const Z = f.getImplantTreeById(R.implantId);
        if (Z) {
          const { object: X, model: Ae, manufacturer: De } = Z;
          if (D = X, c.manufacturer = a(De), await mn(), c.model = a(Ae), await mn(), c.implant = a(X), R.abutmentId) {
            const at = f.getAbutmentTreeById(R.abutmentId);
            if (at) {
              const { object: Be, model: ze, manufacturer: ct } = at;
              V = Be, await mn();
              const ht = i.value.find((mt) => mt.name === ct.name);
              if (ht) {
                u.manufacturer = ht;
                const mt = ht.children.find((Bt) => Bt.name === ze.name);
                if (mt) {
                  const Bt = mt;
                  u.model = Bt;
                  const Nt = Bt.children.find((Tt) => {
                    var Rt;
                    return ((Rt = Tt.value) == null ? void 0 : Rt.id) === Be.id;
                  });
                  Nt && (u.abutment = Nt);
                }
              }
            }
          }
        }
        if (R.sleeveId) {
          const X = f.getSleeveTreeByName(R.sleeveId);
          if (X) {
            const { object: Ae, manufacturer: De } = X;
            c.sleeveManufacturer = a(De), await mn(), c.sleeve = a(Ae);
          }
        }
        if (R.scanAbutmentId) {
          const Ae = f.getScanAbutmentListModels(p.state, D == null ? void 0 : D.scanAbutmentIds).find((De) => De.value.uuid === R.scanAbutmentId);
          Ae && (b.value = Ae, c.scanAbutment = Ae);
        }
        if (R.secondaryAbutmentId) {
          const Ae = f.getSecondaryAbutmentListModels(V == null ? void 0 : V.secondaryAbutmentIds).find(
            (De) => De.value.uuid === R.secondaryAbutmentId
          );
          Ae && (E.value = Ae, c.secondaryAbutment = Ae);
        }
        if (R.secondaryScanAbutmentId) {
          const Ae = f.getSecondaryScanAbutmentListModels(V == null ? void 0 : V.secondaryScanAbutmentIds).find(
            (De) => De.value.uuid === R.secondaryScanAbutmentId
          );
          Ae && (m.value = Ae, c.secondaryScanAbutment = Ae);
        }
        if (R.analogExtrusionUuid) {
          const X = f.getAnalogExtrusionListModels(h.state, D == null ? void 0 : D.extrusionIds), Ae = R.analogExtrusionUuid.trim(), De = X.find((at) => {
            const Be = at.value;
            return Be.uuid === Ae || Be.name === Ae || Be.name.toLowerCase() === Ae.toLowerCase();
          });
          De && (I.value = De, c.implantExtrusion = De, De.value.s3ObjectRef ? c.implantExtrusionData = f.getFile(De.value.s3ObjectRef) : c.implantExtrusionData = null);
        }
      } finally {
        await mn(), Se.value = !1;
      }
    }
    const { implantList: Ie, selectedTooth: Ee } = on(n), xe = B(), Qe = () => {
      var R;
      return (R = Ie == null ? void 0 : Ie.value) == null ? void 0 : R.find((D) => D.tooth == Number(Ee == null ? void 0 : Ee.value));
    }, Ke = () => {
      xe.value = Qe();
    };
    Ke(), lt(Ie, () => Ke()), lt(Ee, () => Ke());
    let qe = !1;
    const { stlSelection: rt } = on(n);
    lt(rt, async (R) => {
      if (P) {
        if (qe = !0, c.manufacturer = R.manufacturer, await mn(), c.model = R.model, await mn(), c.implant = R.implant, R.implant) {
          const D = await f.getDependantObjectsForImplant(R.implant.value.id);
          if (i.value = de(D.abManufacturers, D.abModels, D.abAbutments), R.abManufacturer) {
            const V = i.value.find((Z) => {
              var X;
              return Z.name === ((X = R.abManufacturer) == null ? void 0 : X.name);
            });
            V ? u.manufacturer = V : u.manufacturer = F();
          }
          if (R.abManufacturer && R.abModel) {
            const V = u.manufacturer.children.find((Z) => {
              var X;
              return Z.name === ((X = R.abModel) == null ? void 0 : X.name);
            });
            V ? u.model = V : u.model = F();
          }
          if (R.abManufacturer && R.abModel && R.abutment) {
            const V = u.model.children.find((Z) => {
              var X, Ae, De;
              return ((X = Z.value) == null ? void 0 : X.id) === ((De = (Ae = R.abutment) == null ? void 0 : Ae.value) == null ? void 0 : De.id);
            });
            V ? u.abutment = V : u.abutment = F();
          }
        }
        c.abManufacturer = R.abManufacturer, c.abModel = R.abModel, c.abutment = R.abutment, c.sleeveManufacturer = R.sleeveManufacturer, await mn(), c.sleeve = R.sleeve, c.sleeveReferenced = R.sleeveReferenced ?? (Ji(R) ? 1 : 0), c.sleeveManuallyChanged = R.sleeveManuallyChanged ?? (c.sleeveReferenced ? 0 : 1), c.implantData = R.implantData, c.abutmentData = R.abutmentData, c.scanAbutment = R.scanAbutment, c.scanAbutmentData = R.scanAbutmentData, c.secondaryAbutment = R.secondaryAbutment, c.secondaryAbutmentData = R.secondaryAbutmentData, c.secondaryScanAbutment = R.secondaryScanAbutment, c.secondaryScanAbutmentData = R.secondaryScanAbutmentData, b.value = R.scanAbutment, E.value = R.secondaryAbutment, m.value = R.secondaryScanAbutment, qe = !1;
      }
    });
    let P = !1;
    Dt(async () => {
      P = !0, l.manufacturers = f.implantManufacturers().map(a), n.selection && (await te(n.selection), await mn()), sI(), x.value = !0, await mn(), N.value = !0, G.value = !0, ce.value = !0, xm(), sS();
    }), Ha(() => {
      xr(), rS(), iI(), re.value > 0 && v.hideLoading();
    }), ne(
      {
        ref: on(c).manufacturer,
        invalidate: [on(c).model],
        target: on(l).models,
        source: (R) => f.getImplantModelsForManufacturer(R)
      },
      {
        ref: on(c).model,
        invalidate: [on(c).implant, on(c).implantData],
        target: on(l).objects,
        source: (R) => f.getImplantsForModel(R)
      }
    ), Ga(() => {
      const R = /* @__PURE__ */ new Map();
      for (const X of K.value) {
        const Ae = X.value.pId, De = X.value.manufacturerName;
        R.has(Ae) || R.set(Ae, {
          name: De,
          value: {
            id: Ae,
            name: De
          }
        });
      }
      const D = Array.from(R.values()), V = c.sleeveManufacturer, Z = V ? D.find((X) => X.value.id === V.value.id) ?? null : null;
      s.manufacturers = D, !Z && V ? c.sleeveManufacturer = null : Z && Z !== V && (c.sleeveManufacturer = Z);
    }), Ga(() => {
      var De, at, Be, ze;
      const R = (De = c.sleeveManufacturer) == null ? void 0 : De.value;
      if (!R) {
        s.models = [], c.sleeve = null;
        return;
      }
      const D = ((Be = (at = c.implant) == null ? void 0 : at.value) == null ? void 0 : Be.sleeveIds) ?? [], V = K.value.filter((ct) => ct.value.pId === R.id).map((ct) => ({ name: ct.name, value: ct.value })), Z = ((ze = c.sleeve) == null ? void 0 : ze.value.pId) === R.id ? c.sleeve : null, X = Z && (g.state || D.includes(Z.value.id)) ? Z : null;
      !X && c.sleeve && (c.sleeve = null);
      const Ae = X ? w(V, X, (ct, ht) => le(ct, ht)) : V;
      s.models = A(Ae, (ct, ht) => le(ct, ht));
    });
    function F(R, D, V = []) {
      return {
        children: V,
        name: R || "",
        value: D
      };
    }
    function me(R) {
      var V;
      const D = (V = R.sellingCode) == null ? void 0 : V.trim();
      return D ? `${R.name} / ${D}` : R.name;
    }
    function de(R, D, V) {
      const Z = [];
      for (const X of R) {
        const Ae = F(X.name, X);
        for (const De of D.filter((at) => at.pId === X.id)) {
          const at = F(De.name, De);
          for (const Be of V.filter((ze) => ze.pId === De.id))
            at.children.push(F(me(Be), Be));
          Ae.children.push(at);
        }
        Z.push(Ae);
      }
      return Z;
    }
    const We = {
      width: "13.7vw !important"
    }, Q = B("40%"), ie = B("calc(100% / 3)"), W = Ce(() => `calc(100% - ${Q.value} - ${ie.value})`);
    function ee(R, D) {
      lt(D, () => {
        var V;
        (V = D.value) != null && V.value ? R.value = { ...D.value, value: D.value.value } : R.value = null;
      });
    }
    ee(on(c).abManufacturer, on(u).manufacturer), ee(on(c).abModel, on(u).model), ee(on(c).abutment, on(u).abutment), lt(
      k,
      () => {
        Se.value || Re();
      },
      { flush: "post" }
    ), lt(
      j,
      (R) => {
        var Z;
        const D = (Z = I.value) == null ? void 0 : Z.value;
        if (Se.value || !D || !R.length)
          return;
        const V = R.find((X) => C(X.value, D));
        V && V !== I.value && (I.value = V);
      },
      { flush: "post" }
    ), lt(b, (R) => {
      qe || Se.value || pe(R, c.scanAbutment) || (c.scanAbutment = R);
    }), lt(E, (R) => {
      qe || Se.value || (c.secondaryAbutment = R);
    }), lt(m, (R) => {
      qe || Se.value || (c.secondaryScanAbutment = R);
    }), lt(I, (R) => {
      qe || Se.value || (fe(R, c.implantExtrusion) || (c.implantExtrusion = R), R != null && R.value.s3ObjectRef ? c.implantExtrusionData = f.getFile(R.value.s3ObjectRef) : c.implantExtrusionData = null, $());
    }), lt(
      () => c.implant,
      async (R) => {
        var D, V, Z, X, Ae;
        if (Se.value || (b.value = null, I.value = null, c.sleeve = null, c.sleeveData = null, c.sleeveNegativeData = null), R || (i.value = de([], [], []), u.manufacturer = F(), u.model = F(), u.abutment = F()), !qe && R) {
          q();
          try {
            c.implantData = null;
            const De = R.value.id, at = R.value.s3ObjectRef, Be = f.getFile(at), ze = await f.getDependantObjectsForImplant(De);
            i.value = de(ze.abManufacturers, ze.abModels, ze.abAbutments), u.manufacturer = F(), u.model = F(), u.abutment = F(), c.abutmentData = null;
            const ct = await Be;
            if (((D = c.implant) == null ? void 0 : D.value.s3ObjectRef) !== at)
              return;
            if (c.implantData = ct, (V = ze.extrusions) != null && V.length) {
              const mt = (Z = c.implantExtrusion) == null ? void 0 : Z.value, Bt = R.value.defaultExtrusionId;
              let Nt = ze.extrusions.find((Rt) => Rt.id === Bt) ?? ze.extrusions[0];
              if (mt) {
                const Rt = ze.extrusions.find((bn) => C(bn, mt));
                Rt && (Nt = Rt);
              }
              const Tt = j.value.find((Rt) => C(Rt.value, Nt)) ?? a(Nt);
              fe(Tt, c.implantExtrusion) || (c.implantExtrusion = Tt), fe(Tt, I.value) || (I.value = Tt), Nt.s3ObjectRef ? c.implantExtrusionData = f.getFile(Nt.s3ObjectRef) : c.implantExtrusionData = null;
            } else
              c.implantExtrusion = null, c.implantExtrusionData = null, I.value = null;
            const ht = (Ae = (X = c.implant) == null ? void 0 : X.value) == null ? void 0 : Ae.defaultSleeveId;
            if (ht) {
              const mt = f.getSleeveTreeById(ht);
              if (mt) {
                ce.value = !1;
                const { object: Bt, manufacturer: Nt } = mt;
                c.sleeveManufacturer = a(Nt), mn().then(() => {
                  c.sleeve = a(Bt), ce.value = !1;
                });
              }
            }
            $();
          } finally {
            he();
          }
        }
      }
    ), lt(
      () => c.abutment,
      async (R) => {
        var D;
        if (Se.value || (E.value = null, m.value = null), !qe && R) {
          q();
          try {
            c.abutmentData = null;
            const V = R.value.s3ObjectRef, Z = await f.getFile(V);
            if (((D = c.abutment) == null ? void 0 : D.value.s3ObjectRef) !== V)
              return;
            c.abutmentData = Z, $();
          } finally {
            he();
          }
        }
      }
    ), lt(
      () => c.scanAbutment,
      async (R) => {
        var D, V;
        if (!qe) {
          if (!R) {
            c.scanAbutmentData = null, $();
            return;
          }
          q();
          try {
            c.scanAbutmentData = null;
            const Z = (D = c.scanAbutment) == null ? void 0 : D.value.s3ObjectRef;
            if (Z) {
              const X = await f.getFile(Z);
              if (((V = c.scanAbutment) == null ? void 0 : V.value.s3ObjectRef) !== Z)
                return;
              c.scanAbutmentData = X;
            }
            $();
          } finally {
            he();
          }
        }
      }
    ), lt(
      () => c.secondaryAbutment,
      async (R) => {
        var D, V;
        if (!qe) {
          if (!R) {
            c.secondaryAbutmentData = null, $();
            return;
          }
          q();
          try {
            c.secondaryAbutmentData = null;
            const Z = (D = c.secondaryAbutment) == null ? void 0 : D.value.s3ObjectRef;
            if (Z) {
              const X = await f.getFile(Z);
              if (((V = c.secondaryAbutment) == null ? void 0 : V.value.s3ObjectRef) !== Z)
                return;
              c.secondaryAbutmentData = X;
            }
            $();
          } finally {
            he();
          }
        }
      }
    ), lt(
      () => c.secondaryScanAbutment,
      async (R) => {
        var D, V;
        if (!qe) {
          if (!R) {
            c.secondaryScanAbutmentData = null, $();
            return;
          }
          q();
          try {
            c.secondaryScanAbutmentData = null;
            const Z = (D = c.secondaryScanAbutment) == null ? void 0 : D.value.s3ObjectRef;
            if (Z) {
              const X = await f.getFile(Z);
              if (((V = c.secondaryScanAbutment) == null ? void 0 : V.value.s3ObjectRef) !== Z)
                return;
              c.secondaryScanAbutmentData = X;
            }
            $();
          } finally {
            he();
          }
        }
      }
    ), lt(
      () => c.sleeve,
      async (R) => {
        var D, V;
        if (!qe) {
          if (!R) {
            c.sleeveReferenced = 0, c.sleeveManuallyChanged = 0;
            return;
          }
          q();
          try {
            const Z = R.value.inverses3ObjectRef;
            if (Z && Z != "") {
              const De = await f.getFile(Z);
              ((D = c.sleeve) == null ? void 0 : D.value.inverses3ObjectRef) !== Z && console.log("WATNING: Selection of sleeve changed while loading!!!!!"), c.sleeveNegativeData = De;
            } else
              c.sleeveNegativeData = null;
            const X = R.value.s3ObjectRef;
            if (X && X != "") {
              const De = await f.getFile(X);
              ((V = c.sleeve) == null ? void 0 : V.value.s3ObjectRef) !== X && console.log("WATNING: Selection of sleeve changed while loading!!!!!"), c.sleeveData = De;
            } else
              c.sleeveData = null;
            const Ae = Ji(c);
            c.sleeveReferenced = Ae ? 1 : 0, c.sleeveManuallyChanged = Ae ? 0 : 1, $();
          } finally {
            he();
          }
        }
      }
    );
    const $ = () => {
      Se.value || c.implant && !c.implantData || c.abutment && !c.abutmentData || c.scanAbutment && !c.scanAbutmentData || c.secondaryAbutment && !c.secondaryAbutmentData || c.secondaryScanAbutment && !c.secondaryScanAbutmentData || o("stlSelectionUpdate", c);
    };
    return lt(
      xe,
      (R, D) => {
        R && (R == null ? void 0 : R.tooth) !== (D == null ? void 0 : D.tooth) && D && o("implantChange", R.toothId);
      },
      { deep: !0 }
    ), (R, D) => {
      var V, Z;
      return L(), H(He, null, [
        x.value ? ue("", !0) : (L(), H("div", uS, [
          d(r(Sh), { animationDuration: "0.75s" })
        ])),
        x.value ? (L(), H("div", cS, [
          (L(), be(Ur, { to: "#aboveRenderWindowContainer" }, [
            y("span", dS, [
              y("span", {
                class: "font-medium text-4xl",
                style: Et({ width: Q.value })
              }, U(R.$t("implant-planner.selectImplant")), 5),
              y("span", {
                class: "flex flex-row justify-between",
                style: Et({ width: W.value })
              }, [
                y("span", pS, U(R.$t("implant-planner.implantPreview")), 1),
                d(r($n), {
                  modelValue: xe.value,
                  "onUpdate:modelValue": D[0] || (D[0] = (X) => xe.value = X),
                  options: n.implantList,
                  optionLabel: "name",
                  placeholder: R.$t("implant-planner.selectAnImplant"),
                  class: "w-full md:w-56",
                  style: We
                }, null, 8, ["modelValue", "options", "placeholder"])
              ], 4)
            ])
          ])),
          y("div", {
            class: "m-flex-h h-full overflow-y-auto",
            style: Et([{ "pointer-events": "auto" }, { width: Q.value }])
          }, [
            y("div", mS, [
              y("label", fS, U(R.$t("implant-planner.implants")), 1),
              y("div", gS, [
                d(r(kn), {
                  modelValue: c.manufacturer,
                  "onUpdate:modelValue": D[1] || (D[1] = (X) => c.manufacturer = X),
                  model: l.manufacturers,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: N.value,
                  "data-cy": "implantManufacturerList",
                  filterPlaceholder: "Manufacturer"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"]),
                d(r(kn), {
                  modelValue: c.model,
                  "onUpdate:modelValue": D[2] || (D[2] = (X) => c.model = X),
                  model: l.models,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: N.value,
                  "data-cy": "implantModelList",
                  filterPlaceholder: "Model"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"]),
                d(r(kn), {
                  modelValue: c.implant,
                  "onUpdate:modelValue": D[3] || (D[3] = (X) => c.implant = X),
                  model: l.objects,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: N.value,
                  "data-cy": "implantList",
                  filterPlaceholder: "Sizes"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"])
              ])
            ]),
            y("div", hS, [
              y("label", bS, U(R.$t("implant-planner.abutments")), 1),
              y("div", vS, [
                d(r(kn), {
                  modelValue: u.manufacturer,
                  "onUpdate:modelValue": D[4] || (D[4] = (X) => u.manufacturer = X),
                  model: i.value,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: N.value,
                  "data-cy": "abManufacturerList",
                  filterPlaceholder: "Manufacturer"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"]),
                d(r(kn), {
                  modelValue: u.model,
                  "onUpdate:modelValue": D[5] || (D[5] = (X) => u.model = X),
                  model: ((V = u.manufacturer) == null ? void 0 : V.children) || [],
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: N.value,
                  "data-cy": "abModelList",
                  filterPlaceholder: "Model"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"]),
                d(r(kn), {
                  modelValue: u.abutment,
                  "onUpdate:modelValue": D[6] || (D[6] = (X) => u.abutment = X),
                  model: ((Z = u.model) == null ? void 0 : Z.children) || [],
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: N.value,
                  "data-cy": "abutmentList",
                  filterPlaceholder: "Sizes"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"])
              ])
            ]),
            se.value ? ue("", !0) : (L(), H("div", yS, [
              y("div", _S, [
                y("label", null, U(R.$t("implant-planner.sleeves")), 1),
                d(r(no), {
                  state: g.state,
                  "onUpdate:state": D[7] || (D[7] = (X) => g.state = X),
                  disabled: g.disabled,
                  "onUpdate:disabled": D[8] || (D[8] = (X) => g.disabled = X),
                  class: "ml-2"
                }, {
                  trueLabel: _(() => [
                    y("span", wS, U(R.$t("implant-planner.showAll")), 1)
                  ]),
                  _: 1
                }, 8, ["state", "disabled"])
              ]),
              y("div", IS, [
                d(r(kn), {
                  modelValue: c.sleeveManufacturer,
                  "onUpdate:modelValue": D[9] || (D[9] = (X) => c.sleeveManufacturer = X),
                  model: s.manufacturers,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: ce.value,
                  "data-cy": "sleeveManufacturerList",
                  filterPlaceholder: "Manufacturer"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"]),
                d(r(kn), {
                  modelValue: c.sleeve,
                  "onUpdate:modelValue": D[10] || (D[10] = (X) => c.sleeve = X),
                  model: s.models,
                  class: "w-4/12",
                  listStyle: l.listStyle,
                  disableScrollIntoView: ce.value,
                  "data-cy": "sleeveModelList",
                  filterPlaceholder: "Model"
                }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView"])
              ])
            ])),
            se.value ? (L(), H("div", SS, [
              y("div", ES, [
                y("div", TS, [
                  y("div", CS, [
                    y("span", NS, U(R.$t("implant-planner.scanAbutment")), 1),
                    d(r(no), {
                      state: p.state,
                      "onUpdate:state": D[11] || (D[11] = (X) => p.state = X),
                      disabled: p.disabled,
                      "onUpdate:disabled": D[12] || (D[12] = (X) => p.disabled = X)
                    }, {
                      trueLabel: _(() => [
                        y("span", LS, U(R.$t("implant-planner.showAll")), 1)
                      ]),
                      _: 1
                    }, 8, ["state", "disabled"])
                  ]),
                  d(r(kn), {
                    modelValue: b.value,
                    "onUpdate:modelValue": D[13] || (D[13] = (X) => b.value = X),
                    model: k.value,
                    class: "w-full",
                    listStyle: l.listStyle,
                    disableScrollIntoView: G.value,
                    "data-cy": "scanAbutmentList",
                    filterPlaceholder: R.$t("implant-planner.scanAbutment")
                  }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView", "filterPlaceholder"])
                ]),
                y("div", OS, [
                  y("div", DS, [
                    y("span", AS, U(R.$t("implant-planner.secondaryAbutment")), 1)
                  ]),
                  d(r(kn), {
                    modelValue: E.value,
                    "onUpdate:modelValue": D[14] || (D[14] = (X) => E.value = X),
                    model: M.value,
                    class: "w-full",
                    disableScrollIntoView: G.value,
                    "data-cy": "secondaryAbutmentList",
                    filterPlaceholder: R.$t("implant-planner.secondaryAbutment"),
                    style: { flex: "4 1 0", "min-height": "0" }
                  }, null, 8, ["modelValue", "model", "disableScrollIntoView", "filterPlaceholder"]),
                  y("div", RS, [
                    y("span", MS, U(R.$t("implant-planner.secondaryScanAbutment")), 1)
                  ]),
                  d(r(kn), {
                    modelValue: m.value,
                    "onUpdate:modelValue": D[15] || (D[15] = (X) => m.value = X),
                    model: z.value,
                    class: "w-full",
                    disableScrollIntoView: G.value,
                    "data-cy": "secondaryScanAbutmentList",
                    filterPlaceholder: R.$t("implant-planner.secondaryScanAbutment"),
                    style: { flex: "4 1 0", "min-height": "0" }
                  }, null, 8, ["modelValue", "model", "disableScrollIntoView", "filterPlaceholder"])
                ]),
                y("div", PS, [
                  y("div", xS, [
                    y("span", jS, U(R.$t("implant-planner.analogExtrusion")), 1),
                    d(r(no), {
                      state: h.state,
                      "onUpdate:state": D[16] || (D[16] = (X) => h.state = X),
                      disabled: h.disabled,
                      "onUpdate:disabled": D[17] || (D[17] = (X) => h.disabled = X)
                    }, {
                      trueLabel: _(() => [
                        y("span", $S, U(R.$t("implant-planner.showAll")), 1)
                      ]),
                      _: 1
                    }, 8, ["state", "disabled"])
                  ]),
                  d(r(kn), {
                    modelValue: I.value,
                    "onUpdate:modelValue": D[18] || (D[18] = (X) => I.value = X),
                    model: j.value,
                    class: "w-full",
                    listStyle: l.listStyle,
                    disableScrollIntoView: G.value,
                    "data-cy": "analogExtrusionList",
                    filterPlaceholder: R.$t("implant-planner.analogExtrusion")
                  }, null, 8, ["modelValue", "model", "listStyle", "disableScrollIntoView", "filterPlaceholder"])
                ])
              ])
            ])) : ue("", !0)
          ], 4)
        ])) : ue("", !0)
      ], 64);
    };
  }
});
var jm = typeof global == "object" && global && global.Object === Object && global, kS = typeof self == "object" && self && self.Object === Object && self, Ma = jm || kS || Function("return this")(), ul = Ma.Symbol, $m = Object.prototype, VS = $m.hasOwnProperty, BS = $m.toString, Ol = ul ? ul.toStringTag : void 0;
function US(e) {
  var t = VS.call(e, Ol), n = e[Ol];
  try {
    e[Ol] = void 0;
    var a = !0;
  } catch {
  }
  var o = BS.call(e);
  return a && (t ? e[Ol] = n : delete e[Ol]), o;
}
var GS = Object.prototype, WS = GS.toString;
function zS(e) {
  return WS.call(e);
}
var HS = "[object Null]", YS = "[object Undefined]", bd = ul ? ul.toStringTag : void 0;
function gi(e) {
  return e == null ? e === void 0 ? YS : HS : bd && bd in Object(e) ? US(e) : zS(e);
}
function hi(e) {
  return e != null && typeof e == "object";
}
var Nu = Array.isArray;
function Ts(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var KS = "[object AsyncFunction]", ZS = "[object Function]", XS = "[object GeneratorFunction]", JS = "[object Proxy]";
function Fm(e) {
  if (!Ts(e))
    return !1;
  var t = gi(e);
  return t == ZS || t == XS || t == KS || t == JS;
}
var nr = Ma["__core-js_shared__"], vd = (function() {
  var e = /[^.]+$/.exec(nr && nr.keys && nr.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function qS(e) {
  return !!vd && vd in e;
}
var QS = Function.prototype, eE = QS.toString;
function Po(e) {
  if (e != null) {
    try {
      return eE.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var tE = /[\\^$.*+?()[\]{}|]/g, nE = /^\[object .+?Constructor\]$/, aE = Function.prototype, oE = Object.prototype, lE = aE.toString, iE = oE.hasOwnProperty, sE = RegExp(
  "^" + lE.call(iE).replace(tE, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function rE(e) {
  if (!Ts(e) || qS(e))
    return !1;
  var t = Fm(e) ? sE : nE;
  return t.test(Po(e));
}
function uE(e, t) {
  return e == null ? void 0 : e[t];
}
function xo(e, t) {
  var n = uE(e, t);
  return rE(n) ? n : void 0;
}
var jr = xo(Ma, "WeakMap"), yd = Object.create, cE = /* @__PURE__ */ (function() {
  function e() {
  }
  return function(t) {
    if (!Ts(t))
      return {};
    if (yd)
      return yd(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
})(), _d = (function() {
  try {
    var e = xo(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})();
function dE(e, t) {
  for (var n = -1, a = e == null ? 0 : e.length; ++n < a && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var pE = 9007199254740991, mE = /^(?:0|[1-9]\d*)$/;
function fE(e, t) {
  var n = typeof e;
  return t = t ?? pE, !!t && (n == "number" || n != "symbol" && mE.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function gE(e, t, n) {
  t == "__proto__" && _d ? _d(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function km(e, t) {
  return e === t || e !== e && t !== t;
}
var hE = Object.prototype, bE = hE.hasOwnProperty;
function vE(e, t, n) {
  var a = e[t];
  (!(bE.call(e, t) && km(a, n)) || n === void 0 && !(t in e)) && gE(e, t, n);
}
var yE = 9007199254740991;
function Vm(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= yE;
}
function _E(e) {
  return e != null && Vm(e.length) && !Fm(e);
}
var wE = Object.prototype;
function Bm(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || wE;
  return e === n;
}
function IE(e, t) {
  for (var n = -1, a = Array(e); ++n < e; )
    a[n] = t(n);
  return a;
}
var SE = "[object Arguments]";
function wd(e) {
  return hi(e) && gi(e) == SE;
}
var Um = Object.prototype, EE = Um.hasOwnProperty, TE = Um.propertyIsEnumerable, CE = wd(/* @__PURE__ */ (function() {
  return arguments;
})()) ? wd : function(e) {
  return hi(e) && EE.call(e, "callee") && !TE.call(e, "callee");
};
function NE() {
  return !1;
}
var Gm = typeof exports == "object" && exports && !exports.nodeType && exports, Id = Gm && typeof module == "object" && module && !module.nodeType && module, LE = Id && Id.exports === Gm, Sd = LE ? Ma.Buffer : void 0, OE = Sd ? Sd.isBuffer : void 0, Wm = OE || NE, DE = "[object Arguments]", AE = "[object Array]", RE = "[object Boolean]", ME = "[object Date]", PE = "[object Error]", xE = "[object Function]", jE = "[object Map]", $E = "[object Number]", FE = "[object Object]", kE = "[object RegExp]", VE = "[object Set]", BE = "[object String]", UE = "[object WeakMap]", GE = "[object ArrayBuffer]", WE = "[object DataView]", zE = "[object Float32Array]", HE = "[object Float64Array]", YE = "[object Int8Array]", KE = "[object Int16Array]", ZE = "[object Int32Array]", XE = "[object Uint8Array]", JE = "[object Uint8ClampedArray]", qE = "[object Uint16Array]", QE = "[object Uint32Array]", Yt = {};
Yt[zE] = Yt[HE] = Yt[YE] = Yt[KE] = Yt[ZE] = Yt[XE] = Yt[JE] = Yt[qE] = Yt[QE] = !0;
Yt[DE] = Yt[AE] = Yt[GE] = Yt[RE] = Yt[WE] = Yt[ME] = Yt[PE] = Yt[xE] = Yt[jE] = Yt[$E] = Yt[FE] = Yt[kE] = Yt[VE] = Yt[BE] = Yt[UE] = !1;
function eT(e) {
  return hi(e) && Vm(e.length) && !!Yt[gi(e)];
}
function Lu(e) {
  return function(t) {
    return e(t);
  };
}
var zm = typeof exports == "object" && exports && !exports.nodeType && exports, Kl = zm && typeof module == "object" && module && !module.nodeType && module, tT = Kl && Kl.exports === zm, ar = tT && jm.process, cl = (function() {
  try {
    var e = Kl && Kl.require && Kl.require("util").types;
    return e || ar && ar.binding && ar.binding("util");
  } catch {
  }
})(), Ed = cl && cl.isTypedArray, nT = Ed ? Lu(Ed) : eT, aT = Object.prototype, oT = aT.hasOwnProperty;
function lT(e, t) {
  var n = Nu(e), a = !n && CE(e), o = !n && !a && Wm(e), l = !n && !a && !o && nT(e), s = n || a || o || l, i = s ? IE(e.length, String) : [], u = i.length;
  for (var c in e)
    oT.call(e, c) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    l && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    fE(c, u))) && i.push(c);
  return i;
}
function Hm(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var iT = Hm(Object.keys, Object), sT = Object.prototype, rT = sT.hasOwnProperty;
function uT(e) {
  if (!Bm(e))
    return iT(e);
  var t = [];
  for (var n in Object(e))
    rT.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function cT(e) {
  return _E(e) ? lT(e) : uT(e);
}
var ii = xo(Object, "create");
function dT() {
  this.__data__ = ii ? ii(null) : {}, this.size = 0;
}
function pT(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var mT = "__lodash_hash_undefined__", fT = Object.prototype, gT = fT.hasOwnProperty;
function hT(e) {
  var t = this.__data__;
  if (ii) {
    var n = t[e];
    return n === mT ? void 0 : n;
  }
  return gT.call(t, e) ? t[e] : void 0;
}
var bT = Object.prototype, vT = bT.hasOwnProperty;
function yT(e) {
  var t = this.__data__;
  return ii ? t[e] !== void 0 : vT.call(t, e);
}
var _T = "__lodash_hash_undefined__";
function wT(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = ii && t === void 0 ? _T : t, this;
}
function Co(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
Co.prototype.clear = dT;
Co.prototype.delete = pT;
Co.prototype.get = hT;
Co.prototype.has = yT;
Co.prototype.set = wT;
function IT() {
  this.__data__ = [], this.size = 0;
}
function Cs(e, t) {
  for (var n = e.length; n--; )
    if (km(e[n][0], t))
      return n;
  return -1;
}
var ST = Array.prototype, ET = ST.splice;
function TT(e) {
  var t = this.__data__, n = Cs(t, e);
  if (n < 0)
    return !1;
  var a = t.length - 1;
  return n == a ? t.pop() : ET.call(t, n, 1), --this.size, !0;
}
function CT(e) {
  var t = this.__data__, n = Cs(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function NT(e) {
  return Cs(this.__data__, e) > -1;
}
function LT(e, t) {
  var n = this.__data__, a = Cs(n, e);
  return a < 0 ? (++this.size, n.push([e, t])) : n[a][1] = t, this;
}
function Za(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
Za.prototype.clear = IT;
Za.prototype.delete = TT;
Za.prototype.get = CT;
Za.prototype.has = NT;
Za.prototype.set = LT;
var si = xo(Ma, "Map");
function OT() {
  this.size = 0, this.__data__ = {
    hash: new Co(),
    map: new (si || Za)(),
    string: new Co()
  };
}
function DT(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Ns(e, t) {
  var n = e.__data__;
  return DT(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function AT(e) {
  var t = Ns(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function RT(e) {
  return Ns(this, e).get(e);
}
function MT(e) {
  return Ns(this, e).has(e);
}
function PT(e, t) {
  var n = Ns(this, e), a = n.size;
  return n.set(e, t), this.size += n.size == a ? 0 : 1, this;
}
function hl(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
hl.prototype.clear = OT;
hl.prototype.delete = AT;
hl.prototype.get = RT;
hl.prototype.has = MT;
hl.prototype.set = PT;
function xT(e, t) {
  for (var n = -1, a = t.length, o = e.length; ++n < a; )
    e[o + n] = t[n];
  return e;
}
var jT = Hm(Object.getPrototypeOf, Object);
function $T() {
  this.__data__ = new Za(), this.size = 0;
}
function FT(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function kT(e) {
  return this.__data__.get(e);
}
function VT(e) {
  return this.__data__.has(e);
}
var BT = 200;
function UT(e, t) {
  var n = this.__data__;
  if (n instanceof Za) {
    var a = n.__data__;
    if (!si || a.length < BT - 1)
      return a.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new hl(a);
  }
  return n.set(e, t), this.size = n.size, this;
}
function bl(e) {
  var t = this.__data__ = new Za(e);
  this.size = t.size;
}
bl.prototype.clear = $T;
bl.prototype.delete = FT;
bl.prototype.get = kT;
bl.prototype.has = VT;
bl.prototype.set = UT;
var Ym = typeof exports == "object" && exports && !exports.nodeType && exports, Td = Ym && typeof module == "object" && module && !module.nodeType && module, GT = Td && Td.exports === Ym, Cd = GT ? Ma.Buffer : void 0;
Cd && Cd.allocUnsafe;
function WT(e, t) {
  return e.slice();
}
function zT(e, t) {
  for (var n = -1, a = e == null ? 0 : e.length, o = 0, l = []; ++n < a; ) {
    var s = e[n];
    t(s, n, e) && (l[o++] = s);
  }
  return l;
}
function HT() {
  return [];
}
var YT = Object.prototype, KT = YT.propertyIsEnumerable, Nd = Object.getOwnPropertySymbols, ZT = Nd ? function(e) {
  return e == null ? [] : (e = Object(e), zT(Nd(e), function(t) {
    return KT.call(e, t);
  }));
} : HT;
function XT(e, t, n) {
  var a = t(e);
  return Nu(e) ? a : xT(a, n(e));
}
function JT(e) {
  return XT(e, cT, ZT);
}
var $r = xo(Ma, "DataView"), Fr = xo(Ma, "Promise"), kr = xo(Ma, "Set"), Ld = "[object Map]", qT = "[object Object]", Od = "[object Promise]", Dd = "[object Set]", Ad = "[object WeakMap]", Rd = "[object DataView]", QT = Po($r), eC = Po(si), tC = Po(Fr), nC = Po(kr), aC = Po(jr), Fa = gi;
($r && Fa(new $r(new ArrayBuffer(1))) != Rd || si && Fa(new si()) != Ld || Fr && Fa(Fr.resolve()) != Od || kr && Fa(new kr()) != Dd || jr && Fa(new jr()) != Ad) && (Fa = function(e) {
  var t = gi(e), n = t == qT ? e.constructor : void 0, a = n ? Po(n) : "";
  if (a)
    switch (a) {
      case QT:
        return Rd;
      case eC:
        return Ld;
      case tC:
        return Od;
      case nC:
        return Dd;
      case aC:
        return Ad;
    }
  return t;
});
var oC = Object.prototype, lC = oC.hasOwnProperty;
function iC(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && lC.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var Md = Ma.Uint8Array;
function Ou(e) {
  var t = new e.constructor(e.byteLength);
  return new Md(t).set(new Md(e)), t;
}
function sC(e, t) {
  var n = Ou(e.buffer);
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var rC = /\w*$/;
function uC(e) {
  var t = new e.constructor(e.source, rC.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Pd = ul ? ul.prototype : void 0, xd = Pd ? Pd.valueOf : void 0;
function cC(e) {
  return xd ? Object(xd.call(e)) : {};
}
function dC(e, t) {
  var n = Ou(e.buffer);
  return new e.constructor(n, e.byteOffset, e.length);
}
var pC = "[object Boolean]", mC = "[object Date]", fC = "[object Map]", gC = "[object Number]", hC = "[object RegExp]", bC = "[object Set]", vC = "[object String]", yC = "[object Symbol]", _C = "[object ArrayBuffer]", wC = "[object DataView]", IC = "[object Float32Array]", SC = "[object Float64Array]", EC = "[object Int8Array]", TC = "[object Int16Array]", CC = "[object Int32Array]", NC = "[object Uint8Array]", LC = "[object Uint8ClampedArray]", OC = "[object Uint16Array]", DC = "[object Uint32Array]";
function AC(e, t, n) {
  var a = e.constructor;
  switch (t) {
    case _C:
      return Ou(e);
    case pC:
    case mC:
      return new a(+e);
    case wC:
      return sC(e);
    case IC:
    case SC:
    case EC:
    case TC:
    case CC:
    case NC:
    case LC:
    case OC:
    case DC:
      return dC(e);
    case fC:
      return new a();
    case gC:
    case vC:
      return new a(e);
    case hC:
      return uC(e);
    case bC:
      return new a();
    case yC:
      return cC(e);
  }
}
function RC(e) {
  return typeof e.constructor == "function" && !Bm(e) ? cE(jT(e)) : {};
}
var MC = "[object Map]";
function PC(e) {
  return hi(e) && Fa(e) == MC;
}
var jd = cl && cl.isMap, xC = jd ? Lu(jd) : PC, jC = "[object Set]";
function $C(e) {
  return hi(e) && Fa(e) == jC;
}
var $d = cl && cl.isSet, FC = $d ? Lu($d) : $C, Km = "[object Arguments]", kC = "[object Array]", VC = "[object Boolean]", BC = "[object Date]", UC = "[object Error]", Zm = "[object Function]", GC = "[object GeneratorFunction]", WC = "[object Map]", zC = "[object Number]", Xm = "[object Object]", HC = "[object RegExp]", YC = "[object Set]", KC = "[object String]", ZC = "[object Symbol]", XC = "[object WeakMap]", JC = "[object ArrayBuffer]", qC = "[object DataView]", QC = "[object Float32Array]", eN = "[object Float64Array]", tN = "[object Int8Array]", nN = "[object Int16Array]", aN = "[object Int32Array]", oN = "[object Uint8Array]", lN = "[object Uint8ClampedArray]", iN = "[object Uint16Array]", sN = "[object Uint32Array]", zt = {};
zt[Km] = zt[kC] = zt[JC] = zt[qC] = zt[VC] = zt[BC] = zt[QC] = zt[eN] = zt[tN] = zt[nN] = zt[aN] = zt[WC] = zt[zC] = zt[Xm] = zt[HC] = zt[YC] = zt[KC] = zt[ZC] = zt[oN] = zt[lN] = zt[iN] = zt[sN] = !0;
zt[UC] = zt[Zm] = zt[XC] = !1;
function $i(e, t, n, a, o, l) {
  var s;
  if (s !== void 0)
    return s;
  if (!Ts(e))
    return e;
  var i = Nu(e);
  if (i)
    s = iC(e);
  else {
    var u = Fa(e), c = u == Zm || u == GC;
    if (Wm(e))
      return WT(e);
    if (u == Xm || u == Km || c && !o)
      s = c ? {} : RC(e);
    else {
      if (!zt[u])
        return o ? e : {};
      s = AC(e, u);
    }
  }
  l || (l = new bl());
  var p = l.get(e);
  if (p)
    return p;
  l.set(e, s), FC(e) ? e.forEach(function(b) {
    s.add($i(b, t, n, b, e, l));
  }) : xC(e) && e.forEach(function(b, E) {
    s.set(E, $i(b, t, n, E, e, l));
  });
  var h = JT, g = i ? void 0 : h(e);
  return dE(g || e, function(b, E) {
    g && (E = b, b = e[E]), vE(s, E, $i(b, t, n, E, e, l));
  }), s;
}
var rN = 1, uN = 4;
function Vr(e) {
  return $i(e, rN | uN);
}
const cN = { style: { display: "flex", "flex-direction": "column", height: "100%" } }, dN = { style: { height: "100%" } }, pN = {
  class: "grid w-full items-center px-2",
  style: { "grid-template-columns": "minmax(0, 1fr) auto minmax(0, 1fr)" }
}, mN = { class: "flex items-center justify-start" }, fN = { class: "font-medium mr-2" }, gN = { class: "font-medium ml-2" }, hN = /* @__PURE__ */ Je({
  __name: "STLPickerWindow",
  props: /* @__PURE__ */ Rn({
    existingSelection: {},
    origin: {},
    direction: {},
    viewUp: {},
    tooth: {},
    implantList: {}
  }, {
    showSecondaryComponents: { type: Boolean, default: !1 },
    showSecondaryComponentsModifiers: {}
  }),
  emits: /* @__PURE__ */ Rn(["onConfirm", "onReject", "showWizard", "onImplantChange"], ["update:showSecondaryComponents"]),
  setup(e, { emit: t }) {
    const n = oa(), a = B({
      implant: null,
      manufacturer: null,
      model: null,
      implantData: null,
      abManufacturer: null,
      abModel: null,
      abutment: null,
      abutmentData: null,
      scanAbutment: null,
      scanAbutmentData: null,
      secondaryAbutment: null,
      secondaryAbutmentData: null,
      secondaryScanAbutment: null,
      secondaryScanAbutmentData: null,
      sleeveManufacturer: null,
      sleeve: null,
      sleeveData: null,
      sleeveNegativeData: null,
      sleeveManuallyChanged: 0,
      sleeveReferenced: 0,
      implantExtrusion: null,
      implantExtrusionData: null
    }), o = e, l = t, s = Nn(e, "showSecondaryComponents");
    lS();
    let i = B(!1);
    const u = () => {
      var re, Se, se, Le, Y, pe, fe, le, Re, q;
      const N = p.objects.getImplantObjectData(), G = N[N.length - 1], ce = {
        implantGuid: G.implantInfo.guid,
        abutmentGuid: (re = G.abutment) == null ? void 0 : re.guid,
        sleeveName: (Se = G.sleeveInfo) == null ? void 0 : Se.originalName,
        scanAbutmentGuid: (Le = (se = a.value.scanAbutment) == null ? void 0 : se.value) == null ? void 0 : Le.uuid,
        secondaryAbutmentGuid: (pe = (Y = a.value.secondaryAbutment) == null ? void 0 : Y.value) == null ? void 0 : pe.uuid,
        secondaryScanAbutmentGuid: (le = (fe = a.value.secondaryScanAbutment) == null ? void 0 : fe.value) == null ? void 0 : le.uuid,
        analogExtrusionUuid: ((Re = a.value.implantExtrusion) == null ? void 0 : Re.value.uuid) ?? ((q = a.value.implantExtrusion) == null ? void 0 : q.value.name)
      };
      n.updateLastAppliedImplant(ce), x(), l("onConfirm", { selection: a.value, implant: G }), l("showWizard");
    }, c = () => {
      l("onReject");
    }, p = dn(), { existingSelection: h, origin: g, direction: b, viewUp: E, tooth: m } = on(o);
    let I = o.existingSelection.implantId !== void 0, S = m.value && p.objects.implants.getByTooth(m.value) !== null;
    const f = Ce(() => ({
      width: "98.6vw"
      // marginTop: menuMode.value === MenuType.HORIZONTAL ? "6rem" : "",
    }));
    lt(h, (N) => {
      I = N.implantId !== void 0;
    });
    const v = Symbol(), w = (N, G) => {
      var pe, fe, le, Re;
      const ce = { ...G }, re = { ...N }, Se = (((pe = ce.implantData) == null ? void 0 : pe.byteLength) || 0) + (((fe = re.implantData) == null ? void 0 : fe.byteLength) || 0) + (((le = ce.abutmentData) == null ? void 0 : le.byteLength) || 0) + (((Re = ce.abutmentData) == null ? void 0 : Re.byteLength) || 0) >> 10, se = async () => {
        a.value = ce, await C(ce, !0), await mn();
      }, Le = async () => {
        a.value = re, await C(re, !0), await mn();
      }, Y = new Bl({
        onUndo: se,
        onRedo: Le,
        getMemory: () => Se
      });
      p.undoManager.pushPop(v, Y, "Change implant selection", Ul.SCENE_REFRESH);
    }, A = (N) => !(!N.manufacturer || !N.model || !N.implant || !N.implantData || N.abutment && (!N.abManufacturer || !N.abModel || !N.abutmentData) || N.sleeve && !N.sleeveManufacturer);
    let T = null;
    const O = (N, G) => {
      if (!N && !G)
        return !1;
      if (!N || !G)
        return !0;
      const ce = N.value, re = G.value;
      return !ce && !re ? !1 : !ce || !re ? !0 : ce.id !== re.id || ce.uuid !== re.uuid || ce.s3ObjectRef !== re.s3ObjectRef || ce.name !== re.name || ce.manufacturerName !== re.manufacturerName;
    }, C = (N, G) => {
      var Y, pe, fe, le, Re, q, he;
      if (!p) {
        i.value = !1;
        return;
      }
      if (m.value === void 0)
        throw i.value = !1, "stl picker implant tooth not set";
      if (!A(N)) {
        i.value = !1;
        return;
      }
      let ce = !0;
      if (T) {
        const ne = ((Y = N.implant) == null ? void 0 : Y.value.id) !== ((pe = T.implant) == null ? void 0 : pe.value.id) || N.implantData !== T.implantData, te = ((fe = N.abutment) == null ? void 0 : fe.value.id) !== ((le = T.abutment) == null ? void 0 : le.value.id) || N.abutmentData !== T.abutmentData, Ie = ((Re = N.sleeve) == null ? void 0 : Re.value.id) !== ((q = T.sleeve) == null ? void 0 : q.value.id) || N.sleeveData !== T.sleeveData, Ee = O(N.scanAbutment, T.scanAbutment) || N.scanAbutmentData !== T.scanAbutmentData, xe = O(N.secondaryAbutment, T.secondaryAbutment) || N.secondaryAbutmentData !== T.secondaryAbutmentData, Qe = O(N.secondaryScanAbutment, T.secondaryScanAbutment) || N.secondaryScanAbutmentData !== T.secondaryScanAbutmentData, Ke = O(N.implantExtrusion, T.implantExtrusion);
        ce = ne || te || Ie || Ee || xe || Qe || Ke;
      }
      if (!ce) return;
      const re = Vr(N), Se = P0(re, m.value, g.value, b.value, E.value);
      j = Se || void 0, Se ? (S ? p.objects.replaceImplant(Se, !0, {
        disableCenterLines: !1,
        ignoreScaling: !0
      }) : (p.objects.addImplant(Se, { disableCenterLines: !1, ignoreScaling: !0 }), I = !0, S = !0), p.objects.selectImplant(m.value, !1)) : (I && (p.objects.implants.deleteByTooth(m.value), I = !1, S = !1), p.objects.unSelectObject()), !G && T && w(re, T), T = re;
      const se = (he = p.objects.implants.getByTooth(m.value)) == null ? void 0 : he.id;
      se && p.objects.snapToObject(se), p.sceneRepaint(), i.value = !0;
      const Le = p.objects.getImplantByTooth(parseInt(m.value));
      Le ? p.objects.checkCollisions(Le) : p.objects.checkCollisions();
    }, k = async (N) => {
      await C(N, !1);
    }, M = (N) => {
      var G;
      p == null || p.undoManager.remove(v), x(), z = (G = p.objects.getImplantByTooth(N)) == null ? void 0 : G.toProjectImplantParts(), l("onImplantChange", N);
    };
    Dt(() => {
      const N = p.getViewWidget(Cn._3D);
      N && N.hideObjectList(!0);
    }), Ha(() => {
      const N = p.getViewWidget(Cn._3D);
      N && N.hideObjectList(!1), p == null || p.undoManager.remove(v);
    });
    let z, j;
    if (o.tooth) {
      const N = p.objects.implants.getByTooth(o.tooth);
      N && (z = N.toProjectImplantParts());
    }
    const K = (N) => {
      var ce, re, Se, se, Le, Y, pe, fe, le, Re, q, he, ne, te, Ie, Ee;
      if (!p)
        throw "context not set";
      const G = (((ce = N.oldImplant) == null ? void 0 : ce.implantInfo.stlFile.data.byteLength) || 0) + (((se = (Se = (re = N.oldImplant) == null ? void 0 : re.abutment) == null ? void 0 : Se.stlFile) == null ? void 0 : se.data.byteLength) || 0) + (((pe = (Y = (Le = N.oldImplant) == null ? void 0 : Le.sleeveInfo) == null ? void 0 : Y.stlData) == null ? void 0 : pe.data.byteLength) || 0) + (((Re = (le = (fe = N.oldImplant) == null ? void 0 : fe.sleeveInfo) == null ? void 0 : le.stlNegativeData) == null ? void 0 : Re.data.byteLength) || 0) + (N.newImplant.implantInfo.stlFile.data.byteLength || 0) + (((he = (q = N.newImplant.abutment) == null ? void 0 : q.stlFile) == null ? void 0 : he.data.byteLength) || 0) + (((te = (ne = N.newImplant.sleeveInfo) == null ? void 0 : ne.stlData) == null ? void 0 : te.data.byteLength) || 0) + (((Ee = (Ie = N.newImplant.sleeveInfo) == null ? void 0 : Ie.stlNegativeData) == null ? void 0 : Ee.data.byteLength) || 0) >> 10;
      if (N.oldImplant) {
        const xe = () => {
          N.oldImplant && (p.objects.replaceImplant(N.oldImplant, !0, {
            disableCenterLines: !1,
            ignoreScaling: !0
          }), p.objects.updateImplantPlannerGUIEvent.notify(null));
        }, Qe = () => {
          p.objects.replaceImplant(N.newImplant, !0, {
            disableCenterLines: !1,
            ignoreScaling: !0
          }), p.objects.updateImplantPlannerGUIEvent.notify(null);
        };
        return new Bl({
          onUndo: xe,
          onRedo: Qe,
          getMemory: () => G
        });
      } else {
        const xe = () => {
          p.objects.implants.deleteByTooth(N.newImplant.name);
          const Ke = p.objects.selectedObject.get();
          Ke && Ke.type === Oe._IMPLANT && Ke.getTooth().toString() === N.newImplant.name && p.objects.unSelectObject(), p.objects.updateImplantPlannerGUIEvent.notify(null);
        }, Qe = () => {
          p.objects.addImplant(N.newImplant, { disableCenterLines: !1, ignoreScaling: !1 }), p.objects.updateImplantPlannerGUIEvent.notify(null);
        };
        return new Bl({
          onUndo: xe,
          onRedo: Qe,
          getMemory: () => G
        });
      }
    }, x = () => {
      if (j) {
        const N = K({
          oldImplant: z,
          newImplant: j
        }), G = j.name;
        z ? p.undoManager.pushPop(p.objects, N, "Change Implant " + G, Ul.SCENE_REFRESH) : p.undoManager.pushPop(p.objects, N, "Add Implant " + G, Ul.SCENE_REFRESH);
      }
    };
    return (N, G) => {
      const ce = im;
      return L(), H("div", cN, [
        y("div", dN, [
          d(FS, {
            stlSelection: a.value,
            onStlSelectionUpdate: k,
            selection: r(h),
            implantList: o.implantList,
            selectedTooth: o.tooth,
            showSecondaryComponents: s.value,
            "onUpdate:showSecondaryComponents": G[0] || (G[0] = (re) => s.value = re),
            onImplantChange: M
          }, null, 8, ["stlSelection", "selection", "implantList", "selectedTooth", "showSecondaryComponents"])
        ]),
        (L(), be(Ur, { to: "#belowRenderWindowContainer" }, [
          d(r(ot), { class: "items-center" }, {
            default: _(() => [
              d(ce, {
                type: "solid",
                style: Et(f.value)
              }, null, 8, ["style"]),
              y("div", pN, [
                y("div", mN, [
                  y("label", null, U(N.$t("implant-planner.secondaryComponents")), 1),
                  d(r(no), {
                    state: s.value,
                    "onUpdate:state": G[1] || (G[1] = (re) => s.value = re),
                    class: "ml-2"
                  }, {
                    falseLabel: _(() => [
                      y("span", fN, U(N.$t("implant-planner.off")), 1)
                    ]),
                    trueLabel: _(() => [
                      y("span", gN, U(N.$t("implant-planner.on")), 1)
                    ]),
                    _: 1
                  }, 8, ["state"])
                ]),
                d(r(we), { class: "justify-center gap-2" }, {
                  default: _(() => [
                    d(r(la), {
                      id: "btnApplyAddImplant",
                      label: N.$t("shared.apply"),
                      disabled: !r(i),
                      icon: "pi pi-check",
                      onClick: u
                    }, null, 8, ["label", "disabled"]),
                    d(r(ya), {
                      label: N.$t("shared.cancel"),
                      icon: "pi pi-times",
                      onClick: c
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }),
                G[2] || (G[2] = y("div", null, null, -1))
              ])
            ]),
            _: 1
          })
        ]))
      ]);
    };
  }
}), Ls = wh({
  id: "ui-state",
  state: () => ({
    stlLibraryWindowVisible: !1
  }),
  actions: {
    setStlLibraryVisible(e) {
      this.stlLibraryWindowVisible = e;
    }
  }
}), bN = { class: "card-wiz hidden" }, vN = { class: "grid grid-cols-12 gap-4 grid-cols-12 gap-6 flex items-center justify-center" }, yN = { class: "mt-2" }, _N = { key: 0 }, wN = { key: 1 }, Fd = 1e-3, IN = /* @__PURE__ */ Je({
  __name: "IPImplantPlanning",
  props: /* @__PURE__ */ Rn({
    isReadOnly: { type: Boolean }
  }, {
    showSecondaryComponents: { type: Boolean, default: !1 },
    showSecondaryComponentsModifiers: {}
  }),
  emits: /* @__PURE__ */ Rn(["hideWizard", "showWizard"], ["update:showSecondaryComponents"]),
  setup(e, { emit: t }) {
    const { t: n } = Ht(), a = e, o = t, l = Nn(e, "showSecondaryComponents"), { isReadOnly: s } = on(a), i = dn(), { watch: u, cleanupAll: c, onEvent: p } = Ra(), h = dl(), g = zr();
    let b = null;
    const E = oa(), { menuMode: m, lastAppliedImplant: I } = So(oa()), S = /* @__PURE__ */ new Set();
    function f(D) {
      if (typeof D == "number")
        return Number.isFinite(D) ? D : 0;
      const V = Number.parseFloat(D ?? "");
      return Number.isFinite(V) ? V : 0;
    }
    function v(D) {
      if (typeof D == "number")
        return Number.isFinite(D) ? D : 0;
      const V = Number.parseInt(D ?? "", 10);
      return Number.isFinite(V) ? V : 0;
    }
    function w(D) {
      if (typeof D == "boolean")
        return D;
      if (typeof D == "number")
        return D !== 0;
      const V = (D ?? "").toString().trim().toLowerCase();
      return V === "true" || V === "1";
    }
    async function A() {
      if (!h.cachedResponse)
        try {
          await h.loadSTLLibrary();
        } catch (D) {
          return console.warn("Failed to load STL library for implant step", D), null;
        }
      return h.cachedResponse ? (b || (b = new Wr(h.cachedResponse, g)), b) : null;
    }
    function T(D) {
      i.objects.replaceImplant(D, !0, {
        disableCenterLines: !1,
        ignoreScaling: !0
      }), i.objects.selectImplant(D.name, !1);
      const V = i.objects.getImplantByTooth(parseInt(D.name));
      V ? (i.objects.checkCollisions(V), i.objects.updateImplantPlannerGUIEvent.notify(V)) : (i.objects.checkCollisions(), i.objects.updateImplantPlannerGUIEvent.notify(null)), i.sceneRepaint();
    }
    async function O(D, V) {
      var Nt;
      const Z = V.defaultSleeveId;
      if (!Z)
        return;
      const X = D.getSleeveTreeById(Z);
      if (!X)
        return;
      const { manufacturer: Ae, object: De } = X;
      let at = null, Be = null;
      if (De.s3ObjectRef)
        try {
          at = await D.getFile(De.s3ObjectRef);
        } catch (Tt) {
          console.warn("Failed to load default sleeve STL", { sleeveId: De.id, s3ObjectRef: De.s3ObjectRef, error: Tt });
        }
      if (De.inverses3ObjectRef)
        try {
          Be = await D.getFile(De.inverses3ObjectRef);
        } catch (Tt) {
          console.warn("Failed to load default sleeve negative STL", { sleeveId: De.id, s3ObjectRef: De.inverses3ObjectRef, error: Tt });
        }
      const ze = at ? new Int8Array(at) : void 0, ct = Be ? new Int8Array(Be) : void 0, ht = {
        manufacturerName: Ae.name,
        modelName: De.name,
        sellingCode: De.sellingCode,
        dExternal: f(De.dextsleeve),
        dInternal: f(De.dintsleeve),
        lSleeve: f(De.lslsleeve),
        lLip: f(De.lip_heightguide),
        lCut: f(De.cut_sizeguide),
        reductionSystemSize: f(De.reductionsystemsleeve),
        rotationAll: f(De.rotation_allguide),
        rotationCut: f(De.rotation_cutguide),
        dHexagon: f(De.hexagon_diameterguide),
        originalDistanceFromImplant: f(De.hslsleeve),
        distanceFromImplant: f(De.hslsleeve),
        drillLengthSizes: De.drill_lenght_sizes ?? "",
        originalName: qd(Ae.name, De.name),
        stlData: ze ? {
          fileName: "",
          data: ze,
          fileSize: ze.length
        } : void 0,
        stlNegativeData: ct ? {
          fileName: "",
          data: ct,
          fileSize: ct.length
        } : void 0,
        stlFileGuid: De.stl_guid || (ze != null && ze.length ? De.s3ObjectRef : ""),
        stlFileNegativeGuid: De.stl_negative_guid || (ct != null && ct.length ? De.inverses3ObjectRef : ""),
        cylinderShape: w(De.cylinder_hexagonguide),
        connectionIndex: 0,
        referencedSleeve: 1
      }, mt = !!((Nt = ht.stlData) != null && Nt.data.length), Bt = ht.dInternal > 0 && (ht.dExternal > 0 || ht.dHexagon > 0) && ht.lSleeve > 0;
      if (!mt && !Bt) {
        console.warn("Invalid default sleeve data for stepped implant", { sleeveId: De.id, sleeveName: De.name });
        return;
      }
      return ht;
    }
    async function C(D, V) {
      if (s.value || xe.value || S.has(D))
        return;
      const Z = i.objects.selectedObject.get();
      if (!Z || Z.id !== D || Z.type !== Oe._IMPLANT)
        return;
      const X = i.objects.implants.get(D);
      if (X) {
        S.add(D), i.showLoading();
        try {
          const Ae = await A();
          if (!Ae)
            return;
          const De = X.toProjectImplantParts(), at = De.implantInfo, Be = Ae.getImplantTreeById(at.guid);
          if (!Be)
            return;
          const ze = Ae.getImplantsForModel(Be.model.id).filter((Rt) => Math.abs(f(Rt.diameter) - at.diameter) < Fd).sort((Rt, bn) => {
            const Te = f(Rt.length) - f(bn.length);
            return Math.abs(Te) >= Fd ? Te : Rt.id - bn.id;
          });
          if (ze.length === 0)
            return;
          let ct = ze.findIndex((Rt) => Rt.uuid === at.guid);
          ct < 0 && (ct = ze.reduce((Rt, bn, Te, J) => {
            const Pe = Math.abs(f(J[Rt].length) - at.length);
            return Math.abs(f(bn.length) - at.length) < Pe ? Te : Rt;
          }, 0));
          const ht = ct + V;
          if (ht < 0 || ht >= ze.length)
            return;
          const mt = ze[ht];
          if (!mt.s3ObjectRef)
            return;
          const Bt = await Ae.getFile(mt.s3ObjectRef), Nt = await O(Ae, mt), Tt = {
            ...De,
            implantInfo: {
              ...De.implantInfo,
              color: v(mt.color) || De.implantInfo.color,
              diameter: f(mt.diameter),
              guid: mt.uuid || De.implantInfo.guid,
              implantConnectorHeight: f(mt.connector_height),
              implantOriginalName: mt.name || De.implantInfo.implantOriginalName,
              length: f(mt.length),
              manufacturerName: Be.manufacturer.name || De.implantInfo.manufacturerName,
              modelName: Be.model.name || De.implantInfo.modelName,
              nonSymmetric: v(mt.non_symmetric),
              sellingCode: mt.sellingCode || De.implantInfo.sellingCode,
              connectionSides: mt.connection_sides ?? De.implantInfo.connectionSides,
              stlFile: {
                fileName: "",
                data: new Int8Array(Bt),
                fileSize: Bt.byteLength
              }
            },
            sleeveInfo: Nt,
            sleeveManuallyChanged: Nt ? 0 : void 0,
            // Do not carry previous drill length to a new default sleeve.
            // Let sleeve initialization apply its own default drill length list.
            drillLength: void 0,
            drillLengthMm: void 0
          };
          T(Tt);
        } catch (Ae) {
          console.warn("Failed to step implant length", Ae);
        } finally {
          S.delete(D), i.hideLoading();
        }
      }
    }
    function k(D) {
      return D === Xt.MANDIBLE ? rs(i.settings.general.useUSStyleToothChart) : us(i.settings.general.useUSStyleToothChart);
    }
    function M(D) {
      if (!D) return null;
      const V = k(j.jawboneType)[D - 1], Z = j.teeth.find((X) => X.id === D);
      if (!Z) throw new Error(`Tooth with id ${D} not found!`);
      return { name: V, tooth: Z };
    }
    function z(D) {
      return (D == null ? void 0 : D.type) === Oe._IMPLANT;
    }
    const j = tt({
      jawboneType: Xt.MANDIBLE,
      teeth: [],
      selectedObject: null,
      objectsModel: null,
      objectsPreview: null,
      implants: [],
      warnString: ""
    });
    let K = 0;
    const x = B(i.settings.general.useUSStyleToothChart);
    p(i.settings.onSettingsModified, () => {
      x.value = i.settings.general.useUSStyleToothChart;
    });
    function N() {
      j.warnString = "", j.jawboneType = i.CPRType === nn.MANDIBLE ? Xt.MANDIBLE : Xt.MAXILLA;
      const D = s.value ? Ea.NO_EDIT : Ea.ADD;
      j.teeth = k(j.jawboneType).map((V, Z) => {
        var ct, ht;
        const X = i.objects.implantExists(V);
        let Ae = !1;
        X || (Ae = i.objects.markerExists(V));
        const De = X ? Ea.SELECT_ONLY : D, at = X || s.value ? Mn.NONE : Mn.ADD;
        let Be = X ? pt.OK : Ae ? pt.TEETH_MARKER : pt.EMPTY;
        ((ct = j.selectedObject) == null ? void 0 : ct.getName()) === V && (Be = pt.OK_SELECTED);
        const ze = i.objects.getImplantByTooth(parseInt(V));
        return (ze != null && ze.getColorOverride() || (ht = ze == null ? void 0 : ze.getSleeve()) != null && ht.getColorOverride()) && (Be == pt.OK_SELECTED ? (ze != null && ze.isSleeveChanged() && !(ze != null && ze.isInCollision()) ? Be = pt.WARNING_SELECTED : ze != null && ze.isInCollision() && (Be = pt.COLLISION_SELECTED), ze && ze.collisions && (ze.collisions.nerveCollision && (j.warnString += `${n("implant-planner.nerveCollision")} 
`), ze.collisions.sleeveCollision && (j.warnString += `${n("implant-planner.sleeveCollision")} 
`), ze.collisions.anatomyCollision && (j.warnString += `${n("implant-planner.anatomyCollision")} 
`), ze.collisions.implantCollision ? j.warnString += `${n("implant-planner.implantCollision")} 
` : ze.collisions.securityZoneCollision && (j.warnString += `${n("implant-planner.securityZoneCollision")} 
`), ze.collisions.sleeveChanged != null && (j.warnString += `${ze.collisions.sleeveChanged} 
`))) : ze != null && ze.isSleeveChanged() && !(ze != null && ze.isInCollision()) ? Be = pt.WARNING : ze != null && ze.isInCollision() && (Be = pt.COLLISION)), {
          id: Z + 1,
          editMode: De,
          status: Be,
          hoverIcon: at,
          toothName: V
        };
      });
    }
    const G = B(Math.random()), ce = B(!1);
    N(), Dt(async () => {
      await Le(i.objects.selectedObject.get()), re();
    });
    function re() {
      j.implants = [], i.objects.implants.forEach((D) => {
        var Z;
        const V = (Z = j.teeth.find((X) => X.toothName === D.getName())) == null ? void 0 : Z.id;
        if (!V) {
          console.warn("toothId not found: ", D.getName());
          return;
        }
        j.implants.push({
          id: D.id,
          toothId: V,
          name: D.getImplantDisplayName(),
          tooth: D.getTooth()
        });
      });
    }
    function Se(D) {
      var Z, X;
      if (D && D.type !== Oe._IMPLANT)
        return;
      const V = D;
      if (V) {
        const Ae = V.getImplantInfo().implantInfo, De = (Z = Ae.sellingCode) == null ? void 0 : Z.trim(), at = De ? ` / ${De}` : "", Be = {
          objectId: V.getName(),
          implant: {
            name: `${Ae.manufacturerName} / ${Ae.modelName}${at}`,
            diameter: Ae.diameter,
            length: Ae.length,
            visibility: V.getVisibility(),
            locked: V.getLocked()
          }
        }, ze = V.getAbutment();
        if (ze) {
          const Tt = ze.getAbutmentInfo(), Rt = (X = Tt.abutmentSellingCode) == null ? void 0 : X.trim(), bn = Rt ? ` / ${Rt}` : "";
          Be.abutment = {
            name: `${Tt.manufacturerName} / ${Tt.modelName} / ${Tt.name}${bn}`,
            visibility: ze.getVisibility(),
            rotationZ: V.GetRotation(),
            rotationZProsthetic: V.GetRotation(!0)
          };
        } else
          Be.abutment = void 0;
        const ct = V.getSleeve();
        if (ct) {
          const Tt = V.getProjectImplantInfo().connectionSides ?? 0;
          Be.sleeve = {
            name: ct.getSleeveName(),
            visibility: ct.getVisibility()
          }, Be.overallLength = ct.getOverallLength(), Be.sleeveDistance = ct.getDistanceFromImplant(), Be.sleeveRotationStep = ct.getSleeveInfo().connectionIndex ?? 0, Be.sleeveRotationMaxStep = Tt > 0 ? Tt - 1 : void 0, Be.drillLengths = ct.getDrillLengths(), Be.drillLength = ct.getDrillLength();
        } else
          Be.sleeve = void 0, Be.overallLength = void 0, Be.sleeveDistance = void 0, Be.sleeveRotationStep = void 0, Be.sleeveRotationMaxStep = void 0, Be.drillLengths = void 0, Be.drillLength = void 0;
        const ht = V.getScanAbutment();
        if (ht) {
          const Tt = ht.getAttachmentInfo();
          Be.scanAbutment = {
            name: Tt.name,
            visibility: ht.getVisibility()
          };
        } else
          Be.scanAbutment = void 0;
        const mt = V.getSecondaryAbutment();
        if (mt) {
          const Tt = mt.getAttachmentInfo();
          Be.secondaryAbutment = {
            name: Tt.name,
            visibility: mt.getVisibility()
          };
        } else
          Be.secondaryAbutment = void 0;
        const Bt = V.getSecondaryScanAbutment();
        if (Bt) {
          const Tt = Bt.getAttachmentInfo();
          Be.secondaryScanAbutment = {
            name: Tt.name,
            visibility: Bt.getVisibility()
          };
        } else
          Be.secondaryScanAbutment = void 0;
        const Nt = V.getAnalogExtrusion();
        if (Nt) {
          const Tt = Nt.name;
          Be.analogExtrusion = {
            name: Tt,
            visibility: !1
            //analogExtrusion.getVisibility(),
          };
        } else
          Be.analogExtrusion = void 0;
        j.objectsModel = Be;
      } else
        j.objectsModel = null;
    }
    async function se(D) {
      const V = ++K;
      if (xe.value)
        return;
      if (!D) {
        j.objectsPreview = null;
        return;
      }
      const Z = i.viewConfiguration.colorScheme.get(), X = {
        implantPreview: await ea(D, Z)
      }, Ae = D.getAbutment();
      Ae ? X.abutmentPreview = await ea(Ae, Z) : X.abutmentPreview = void 0;
      const De = D.getSleeve();
      De ? X.sleevePreview = await ea(De, Z) : X.sleevePreview = void 0;
      const at = D.getScanAbutment();
      at ? X.scanAbutmentPreview = await ea(at, Z) : X.scanAbutmentPreview = void 0;
      const Be = D.getSecondaryAbutment();
      Be ? X.secondaryAbutmentPreview = await ea(Be, Z) : X.secondaryAbutmentPreview = void 0;
      const ze = D.getSecondaryScanAbutment();
      ze ? X.secondaryScanAbutmentPreview = await ea(ze, Z) : X.secondaryScanAbutmentPreview = void 0, X.analogExtrusionPreview = void 0, V === K && (j.objectsPreview = X);
    }
    async function Le(D) {
      D !== null && !z(D) || (j.selectedObject = D, Se(D), await se(D), N());
    }
    u(i.objects.selectedObject, async (D) => {
      await Le(D);
    }), p(i.objects.updateImplantPlannerGUIEvent, async (D) => {
      const V = z(D) ? D : null;
      Se(V), ce.value || await se(V), ce.value = !1, N(), re();
    }), p(i.objectImplantLengthStepEvent, ({ objectId: D, step: V }) => {
      C(D, V);
    }), Ha(() => {
      c();
    });
    function Y(D) {
      var at;
      const V = M(D);
      if (!V || s.value && V.tooth.status === pt.EMPTY)
        return;
      const X = i.objects.getImplantByTooth(parseInt(V.name)), Ae = i.objects.markerExists(V.name), De = (X == null ? void 0 : X.getColorOverride()) || ((at = X == null ? void 0 : X.getSleeve()) == null ? void 0 : at.getColorOverride());
      X && De ? X != null && X.isSleeveChanged() && !(X != null && X.isInCollision()) ? V.tooth.status = pt.WARNING_SELECTED : X.isInCollision() && (V.tooth.status = pt.COLLISION_SELECTED) : V.tooth.status = Ae ? pt.TEETH_MARKER_SELECTED : pt.OK_SELECTED;
    }
    const pe = tt({
      origin: [0, 0, 0],
      direction: [0, 0, 0],
      viewUp: [0, 0, 0],
      existingSelection: {},
      tooth: void 0
    });
    function fe(D) {
      var Z, X, Ae, De, at, Be, ze, ct;
      const V = (Z = i.objects.implants.getByTooth(D)) == null ? void 0 : Z.toProjectImplantParts();
      if (V) {
        const ht = {
          origin: i.objects.scaleVectorFromImplantPlanner(V.origin),
          direction: V.normal,
          viewUp: V.viewUp
        }, mt = {
          implantId: V.implantInfo.guid,
          abutmentId: (X = V.abutment) == null ? void 0 : X.guid,
          sleeveId: (Ae = V.sleeveInfo) == null ? void 0 : Ae.originalName,
          scanAbutmentId: (De = V.scanAbutment) == null ? void 0 : De.guid,
          secondaryAbutmentId: (at = V.secondaryAbutment) == null ? void 0 : at.guid,
          secondaryScanAbutmentId: (Be = V.secondaryScanAbutment) == null ? void 0 : Be.guid,
          analogExtrusionUuid: ((ze = V.implantModel) == null ? void 0 : ze.uuid) ?? ((ct = V.implantModel) == null ? void 0 : ct.name)
        };
        pe.origin = Array.from(ht.origin), pe.direction = Array.from(ht.direction), pe.viewUp = Array.from(ht.viewUp), pe.existingSelection = mt, G.value = Math.random(), me(D);
      }
    }
    function le(D, V, Z) {
      const X = i.objects.implants.getByTooth(D);
      X && i.objects.changeLockStatus(X.id, Z);
    }
    function Re(D, V) {
      var Z;
      D === ((Z = j.selectedObject) == null ? void 0 : Z.getName()) && V == Oe._IMPLANT && (j.selectedObject = null), i.objects.removeImplantObjectByTooth(D, V), N();
    }
    function q(D, V, Z) {
      i.objects.changeAngle(D, V, Z), j.selectedObject != null && j.selectedObject.isImplant() && Se(j.selectedObject);
    }
    function he(D, V, Z) {
      ce.value = !0, i.objects.setImplantPartVisibility(D, V, Z);
    }
    function ne(D) {
      const V = {
        origin: i.toolManager.coordControl.getObjectPos(Oe._IMPLANT),
        direction: i.toolManager.coordControl.getObjectDir(Oe._IMPLANT),
        viewUp: i.toolManager.coordControl.getObjectViewup(Oe._IMPLANT)
      };
      pe.origin = Array.from(V.origin);
      const Z = i.objects.getMarkerByTooth(parseInt(D));
      Z && (pe.origin = Array.from(Z.getPosition())), pe.direction = Array.from(V.direction), pe.viewUp = Array.from(V.viewUp), I.value ? pe.existingSelection = {
        implantId: I.value.implantGuid,
        abutmentId: I.value.abutmentGuid,
        sleeveId: I.value.sleeveName,
        scanAbutmentId: I.value.scanAbutmentGuid,
        secondaryAbutmentId: I.value.secondaryAbutmentGuid,
        secondaryScanAbutmentId: I.value.secondaryScanAbutmentGuid,
        analogExtrusionUuid: I.value.analogExtrusionUuid
      } : pe.existingSelection = {
        implantId: E.lastSelectedImplantId,
        abutmentId: E.lastSelectedAbutmentId,
        sleeveId: E.lastSelectedSleeveId
      }, G.value = Math.random(), me(D);
    }
    function te(D) {
      const V = M(D);
      V && (V.tooth.editMode === Ea.ADD ? (o("hideWizard"), ne(V.name)) : (i.objects.selectImplant(V.name), xe.value && (o("hideWizard"), fe(V.name))));
    }
    function Ie(D) {
      We(!1), te(D);
    }
    const Ee = () => {
      console.log("Not yet implemented: switchToMandible");
    }, xe = B(!1), Qe = Ls();
    Qe.setStlLibraryVisible(xe.value), lt(xe, (D) => {
      Qe.setStlLibraryVisible(D);
    });
    let Ke;
    const qe = i.getOverlayContainer(), rt = tt({
      top: 0,
      left: 0,
      width: 0,
      height: 0
    }), P = () => {
      const D = qe.getBoundingClientRect();
      rt.top = D.top, rt.left = D.left, rt.width = D.width / 2.5, rt.height = D.height;
    };
    u(i.getState().canvasSize, () => {
      xe.value && P();
    }), Ih(qe, () => {
      xe.value && P();
    });
    let F = null;
    const me = (D) => {
      lI(m.value);
      const V = i.objects.implants.getByTooth(D);
      F = {
        implant: (V == null ? void 0 : V.toProjectImplantParts()) ?? null,
        position: (V == null ? void 0 : V.getPosition()) ?? null,
        tooth: D
      }, P(), pe.tooth = D, !xe.value && (xe.value = !0, Ke = i.layoutManager.getCurrentLayoutState(), i.layoutManager.restoreLayoutState({
        template: Fe._STL_PICKER_PREVIEW,
        presenterWindow2dLayouts: {
          [Cn.CROSS]: uc._1x1,
          [Cn.TANGENT]: uc._1x1
        }
      }));
    }, de = () => {
      xe.value = !1, Ke !== void 0 && i.layoutManager.restoreLayoutState(Ke), F = null, N(), j.selectedObject && j.selectedObject.type === Oe._IMPLANT && Le(j.selectedObject), i.objects.measurementsObjects.get().forEach((D, V) => {
        D.annotation.owner.getViewMode() == Cn._STL_3D_PREVIEW && i.toolManager.measurementsTool.deleteMeasurementById(V);
      });
    }, We = (D) => {
      F = null, D && (ud(m.value), de());
    }, Q = (D) => {
      if (F) {
        const { implant: V, position: Z, tooth: X } = F;
        if (V && Z) {
          i.objects.replaceImplant(V, !1, { ignoreScaling: !1, disableCenterLines: !1 });
          const Ae = i.objects.implants.getByTooth(X.toString());
          Ae && Ae.moveTo(Z), i.objects.selectImplant(X);
        } else
          i.objects.implants.deleteByTooth(X.toString()), i.objects.unSelectObject();
      }
      F = null, ud(m.value), de();
    }, ie = () => {
      xe.value && We(!0), xr(), o("showWizard");
    }, W = () => {
      xe.value && Q(), xr(), o("showWizard");
    }, ee = (D, V) => {
      var X;
      const Z = i.objects.implants.getByTooth(D);
      Z && V && ((X = Z.getSleeve()) == null || X.sleeveHeightChange(V), Z.updatePosition(), i.objects.checkCollisions(Z), i.objects.updateImplantPlannerGUIEvent.notify(i.objects.selectedObject.get()));
    }, $ = (D, V) => {
      var at;
      const Z = i.objects.implants.getByTooth(D);
      if (!Z || Number.isNaN(V))
        return;
      const X = (at = Z.getSleeve()) == null ? void 0 : at.getSleeveInfo();
      if (!X)
        return;
      const Ae = Z.getProjectImplantInfo().connectionSides ?? 0;
      if (Ae <= 0)
        return;
      const De = Math.max(0, Math.min(Ae - 1, Math.round(V)));
      (X.connectionIndex ?? 0) !== De && (X.connectionIndex = De, ce.value = !0, Z.updatePosition(), i.objects.checkCollisions(Z));
    }, R = (D, V) => {
      var X;
      const Z = i.objects.implants.getByTooth(D);
      Z && V && ((X = Z.getSleeve()) == null || X.setDrillLength(V), Z.updatePosition(), i.objects.checkCollisions(Z));
    };
    return (D, V) => {
      const Z = oI, X = kw;
      return L(), H(He, null, [
        y("div", bN, [
          y("div", vN, [
            y("div", yN, [
              d(r(Ne), {
                class: Ge("btn-wizard-lg"),
                label: D.$t("implant-planner.switchToMandibleProject"),
                onClick: Ee
              }, null, 8, ["label"])
            ])
          ])
        ]),
        d(r(sr), {
          jawboneType: j.jawboneType,
          teeth: j.teeth,
          useUSStyleToothChart: x.value,
          warningString: j.warnString,
          onToothClick: te,
          onToothMouseOut: N,
          onToothMouseOver: Y
        }, null, 8, ["jawboneType", "teeth", "useUSStyleToothChart", "warningString"]),
        l.value ? ue("", !0) : (L(), H("div", _N, [
          d(Z, {
            object: j.objectsModel,
            "objects-preview": j.objectsPreview,
            "selected-object": !!r(i).objects.selectedObject.get(),
            isReadOnly: r(s),
            onChangeLock: le,
            onChangeObject: fe,
            onChangeVisibility: he,
            onRemoveObject: Re,
            onChangeAngle: q,
            onChangeSleeveDistance: ee,
            onChangeSleeveRotationStep: $,
            onChangeDrillLength: R
          }, null, 8, ["object", "objects-preview", "selected-object", "isReadOnly"])
        ])),
        l.value ? (L(), H("div", wN, [
          d(X, {
            object: j.objectsModel,
            "objects-preview": j.objectsPreview,
            "selected-object": !!r(i).objects.selectedObject.get(),
            isReadOnly: r(s),
            onChangeObject: fe,
            onChangeVisibility: he,
            onRemoveObject: Re
          }, null, 8, ["object", "objects-preview", "selected-object", "isReadOnly"])
        ])) : ue("", !0),
        xe.value ? (L(), be(Ur, {
          key: 2,
          to: "#stlLibraryContainer"
        }, [
          (L(), be(hN, je(pe, {
            implantList: j.implants,
            showSecondaryComponents: l.value,
            "onUpdate:showSecondaryComponents": V[0] || (V[0] = (Ae) => l.value = Ae),
            onOnConfirm: ie,
            onOnReject: W,
            onOnImplantChange: Ie,
            key: G.value
          }), null, 16, ["implantList", "showSecondaryComponents"]))
        ])) : ue("", !0)
      ], 64);
    };
  }
}), SN = { style: { flex: "1 1 auto", "min-height": "0", "padding-bottom": "0.75rem", "overflow-y": "auto", "overflow-x": "hidden" } }, EN = { class: "text-lg" }, TN = { class: "font-medium mr-2" }, CN = { class: "font-medium ml-2" }, NN = /* @__PURE__ */ Je({
  __name: "IPImplantPlanningContainer",
  props: {
    isReadOnly: { type: Boolean }
  },
  emits: ["hideWizard", "showWizard"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = B(!0), { watch: l } = Ra(), s = dn(), i = !!(s.license.versionType & ho.START);
    let u = tt({
      disabled: !1,
      pressable: !0,
      pressed: o.value
    }), c = tt({
      disabled: !1,
      pressable: !0,
      pressed: !o.value
    });
    const p = tt({
      clicked: !1,
      state: !1,
      disabled: !1
    }), h = () => {
      o.value = !0, c.pressed = !1, u.pressed = !0;
    }, g = () => {
      o.value = !1, u.pressed = !1, c.pressed = !0, p.state = !1;
    };
    return l(s.objects.selectedObject, async (b) => {
      b && (u.pressed = b.type === Oe._IMPLANT, c.pressed = b.type === Oe._PIN, o.value = b.type === Oe._IMPLANT);
    }), (b, E) => {
      const m = Mo, I = IN, S = Iw;
      return L(), H(He, null, [
        d(m, {
          onHideWizard: E[0] || (E[0] = (f) => a("hideWizard")),
          onShowWizard: E[1] || (E[1] = (f) => a("showWizard"))
        }, {
          default: _(() => [
            vt(U(b.$t("implant-planner.implantPlanning")), 1)
          ]),
          _: 1
        }),
        d(r(ke), {
          class: "ml-4 vertical-padding gap-2",
          style: { "padding-right": "2rem !important" }
        }, {
          default: _(() => [
            d(r(Ne), {
              toggled: r(u).pressed,
              label: b.$t("implant-planner.implantPlanning"),
              class: Ge(["web-rg-icon-btn grow", r(u).pressed ? "default_cursor" : ""]),
              "data-cy": "btn_implant_planning",
              onClick: h
            }, null, 8, ["toggled", "label", "class"]),
            d(r(Ne), {
              toggled: r(c).pressed,
              label: b.$t("implant-planner.pinPlanning"),
              class: Ge(["web-rg-icon-btn grow", r(c).pressed ? "default_cursor" : ""]),
              "data-cy": "btn_pin_planning",
              onClick: g
            }, null, 8, ["toggled", "label", "class"])
          ]),
          _: 1
        }),
        d(r(ot), {
          class: "mt-2 gap-2 horizontal-padding h-full",
          style: { "min-height": "0" }
        }, {
          default: _(() => [
            y("div", SN, [
              o.value ? (L(), be(I, {
                key: 0,
                isReadOnly: n.isReadOnly || i,
                showSecondaryComponents: p.state,
                "onUpdate:showSecondaryComponents": E[2] || (E[2] = (f) => p.state = f),
                onShowWizard: E[3] || (E[3] = (f) => a("showWizard")),
                onHideWizard: E[4] || (E[4] = (f) => a("hideWizard"))
              }, null, 8, ["isReadOnly", "showSecondaryComponents"])) : ue("", !0),
              o.value ? ue("", !0) : (L(), be(S, {
                key: 1,
                isReadOnly: e.isReadOnly || i
              }, null, 8, ["isReadOnly"]))
            ]),
            o.value ? (L(), be(r(ke), {
              key: 0,
              style: { flex: "0 0 auto" }
            }, {
              default: _(() => [
                d(r(Ot), null, {
                  default: _(() => [
                    y("span", EN, U(b.$t("implant-planner.secondaryComponents")), 1)
                  ]),
                  _: 1
                }),
                d(r(Ot), {
                  class: "gap-2",
                  style: { "justify-content": "end" }
                }, {
                  default: _(() => [
                    d(r(no), {
                      state: p.state,
                      "onUpdate:state": E[5] || (E[5] = (f) => p.state = f),
                      disabled: p.disabled,
                      "onUpdate:disabled": E[6] || (E[6] = (f) => p.disabled = f)
                    }, {
                      falseLabel: _(() => [
                        y("span", TN, U(b.$t("implant-planner.off")), 1)
                      ]),
                      trueLabel: _(() => [
                        y("span", CN, U(b.$t("implant-planner.on")), 1)
                      ]),
                      _: 1
                    }, 8, ["state", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : ue("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), Du = /* @__PURE__ */ Vt(NN, [["__scopeId", "data-v-1f293ca5"]]);
var Jm = {
  name: "SpinnerIcon",
  extends: ra
};
function LN(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    d: "M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Jm.render = LN;
const ON = {
  name: "BaseButton",
  extends: Ka,
  props: {
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconPos: {
      type: String,
      default: "left"
    },
    iconClass: {
      type: [String, Object],
      default: null
    },
    badge: {
      type: String,
      default: null
    },
    badgeClass: {
      type: [String, Object],
      default: null
    },
    badgeSeverity: {
      type: String,
      default: "secondary"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingIcon: {
      type: String,
      default: void 0
    },
    as: {
      type: [String, Object],
      default: "BUTTON"
    },
    asChild: {
      type: Boolean,
      default: !1
    },
    link: {
      type: Boolean,
      default: !1
    },
    severity: {
      type: String,
      default: null
    },
    raised: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    text: {
      type: Boolean,
      default: !1
    },
    outlined: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: null
    },
    plain: {
      type: Boolean,
      default: !1
    },
    fluid: {
      type: Boolean,
      default: null
    }
  },
  style: Th,
  provide() {
    return {
      $pcButton: this,
      $parentInstance: this
    };
  }
}, DN = {
  name: "Button",
  extends: ON,
  inheritAttrs: !1,
  inject: {
    $pcFluid: { default: null }
  },
  methods: {
    getPTOptions(e) {
      return (e === "root" ? this.ptmi : this.ptm)(e, {
        context: {
          disabled: this.disabled
        }
      });
    }
  },
  computed: {
    disabled() {
      return this.$attrs.disabled || this.$attrs.disabled === "" || this.loading;
    },
    defaultAriaLabel() {
      return this.label ? this.label + (this.badge ? " " + this.badge : "") : this.$attrs.ariaLabel;
    },
    hasIcon() {
      return this.icon || this.$slots.icon;
    },
    attrs() {
      return je(this.asAttrs, this.a11yAttrs, this.getPTOptions("root"));
    },
    asAttrs() {
      return this.as === "BUTTON" ? { type: "button", disabled: this.disabled } : void 0;
    },
    a11yAttrs() {
      return {
        "aria-label": this.defaultAriaLabel,
        "data-pc-name": "button",
        "data-p-disabled": this.disabled,
        "data-p-severity": this.severity
      };
    },
    hasFluid() {
      return pi(this.fluid) ? !!this.$pcFluid : this.fluid;
    }
  },
  components: {
    SpinnerIcon: Jm,
    Badge: Eh
  },
  directives: {
    ripple: fp
  }
};
function AN(e, t, n, a, o, l) {
  const s = Tn("SpinnerIcon"), i = Tn("Badge"), u = Gr("ripple");
  return e.asChild ? It(e.$slots, "default", {
    key: 1,
    class: Ge(e.cx("root")),
    a11yAttrs: l.a11yAttrs
  }) : Pt((L(), be(Sa(e.as), je({
    key: 0,
    class: e.cx("root")
  }, l.attrs), {
    default: _(() => [
      It(e.$slots, "default", {}, () => [
        e.loading ? It(e.$slots, "loadingicon", je({
          key: 0,
          class: [e.cx("loadingIcon"), e.cx("icon")]
        }, e.ptm("loadingIcon")), () => [
          e.loadingIcon ? (L(), H("span", je({
            key: 0,
            class: [e.cx("loadingIcon"), e.cx("icon"), e.loadingIcon]
          }, e.ptm("loadingIcon")), null, 16)) : (L(), be(s, je({
            key: 1,
            class: [e.cx("loadingIcon"), e.cx("icon")],
            spin: ""
          }, e.ptm("loadingIcon")), null, 16, ["class"]))
        ]) : It(e.$slots, "icon", je({
          key: 1,
          class: [e.cx("icon")]
        }, e.ptm("icon")), () => [
          e.icon ? (L(), H("span", je({
            key: 0,
            class: [e.cx("icon"), e.icon, e.iconClass]
          }, e.ptm("icon")), null, 16)) : ue("", !0)
        ]),
        y("span", je({
          class: e.cx("label")
        }, e.ptm("label")), U(e.label || " "), 17),
        e.badge ? (L(), be(i, {
          key: 2,
          value: e.badge,
          class: Ge(e.badgeClass),
          severity: e.badgeSeverity,
          unstyled: e.unstyled,
          pt: e.ptm("pcBadge")
        }, null, 8, ["value", "class", "severity", "unstyled", "pt"])) : ue("", !0)
      ])
    ]),
    _: 3
  }, 16, ["class"])), [
    [u]
  ]);
}
const RN = /* @__PURE__ */ Vt(DN, [["render", AN]]), MN = {
  key: 0,
  class: "text-xl mt-3 mb-3"
}, PN = /* @__PURE__ */ Je({
  __name: "ImportObjectsPreviewList",
  emits: ["proceedToImport"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data, o = wg(a.importObjects), l = t, s = () => {
      l("proceedToImport", o.value), n.value.close();
    }, i = () => {
      n.value.close();
    };
    return (u, c) => (L(), H(He, null, [
      r(a).hideHeader ? ue("", !0) : (L(), H("div", MN, U(u.$t("implant-planner.selectObjectsToImport")), 1)),
      d(r(we), {
        class: "flex-row-wrap grow gap-6 col-span-12 justify-center overflow-auto h-full mb-3",
        style: { "max-width": "75vw", "max-height": "80vh" }
      }, {
        default: _(() => [
          (L(!0), H(He, null, jt(r(o), (p, h) => (L(), H("div", { key: h }, [
            d(r(Rg), {
              item: p,
              itemSelected: p.selected,
              "onUpdate:itemSelected": (g) => p.selected = g
            }, {
              default: _(() => [
                d(r($n), {
                  modelValue: p.typeCAD,
                  "onUpdate:modelValue": (g) => p.typeCAD = g,
                  options: r(Jg),
                  optionLabel: "label",
                  optionValue: "value",
                  class: "w-full mt-2"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
              ]),
              _: 2
            }, 1032, ["item", "itemSelected", "onUpdate:itemSelected"])
          ]))), 128))
        ]),
        _: 1
      }),
      d(r(we), { class: "p-dialog-footer justify-center" }, {
        default: _(() => [
          d(r(la), {
            autofocus: "",
            class: "mt-6",
            label: u.$t("shared.ok"),
            onClick: s
          }, null, 8, ["label"]),
          d(r(ya), {
            class: "mt-6",
            label: u.$t("shared.cancel"),
            onClick: c[0] || (c[0] = (p) => i())
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
}), xN = {
  class: "flex text-4xl",
  style: { flex: "1 1 0" }
}, jN = {
  class: "flex w-full",
  style: { position: "absolute", "justify-content": "center" }
}, $N = "pontics", FN = "upperjaw", kN = "lowerjaw", qm = /* @__PURE__ */ Je({
  __name: "TeethLibraryPreview",
  emits: ["confirm"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data, o = B(), l = B(!0), s = B(!0), i = Ce(() => l.value ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), u = Ce(() => s.value ? "/icons/new_icons/ik_eye_28.svg" : "/icons/new_icons/ik_eye_closed_28.svg"), c = t, p = () => {
      var C, k, M;
      c("confirm", ((C = v.value) == null ? void 0 : C.label) || "", ((k = v.value) == null ? void 0 : k.modelName) || "", ((M = v.value) == null ? void 0 : M.guid) || ""), n.value.close();
    }, h = () => {
      n.value.close();
    };
    let g, b, E;
    const m = [], I = [], S = ia();
    let f = [];
    const v = B(), w = async (C) => {
      await O(C);
    };
    Dt(async () => {
      g = a.context, b = g.createPreviewContext(o.value);
      const C = new qg(b, Qg, Cn._3D, {
        background: [0.24, 0.24, 0.24],
        toolbarDisable: !0
      });
      b.addWindow(C), b.setLayout([[C, rp.fullscreen]]);
      let k = C.getMainView();
      k && (E = k), await S.getCadLibrariesList(), f = await up(S), v.value = f[0], await O(v.value), b.resize();
    });
    const A = () => {
      l.value = !l.value, m.forEach((C) => {
        C.setVisibility(l.value, !0);
      }), b.repaint();
    }, T = () => {
      s.value = !s.value, I.forEach((C) => {
        C.setVisibility(s.value, !0);
      }), b.repaint();
    }, O = async (C) => {
      b.getObjects().stls.forEach((Le) => {
        Le.delete();
      }), m.length = 0, I.length = 0;
      const k = C.modelName;
      if (!k) return;
      const z = (await S.getCadLibrariesFilteredList(k)).data;
      if (!z.length) return;
      const j = z.find((Le) => Le.fileType === "xml");
      if (!j) return;
      const K = await S.getCadLibrariesXmlById(j.id);
      if (!K) return;
      const x = eh(K.data);
      x.Teeth_library.guid;
      const N = x.Teeth_library.teeth.tooth;
      let G = "stl";
      z.find((Le) => Le.type == "xpd") && (G = "xpd");
      const ce = $N, re = g.getEngine(), Se = new re.xFileUtilsWasm(), se = [];
      for (let Le = 1; Le < 9; Le++)
        for (let Y = 1; Y < 5; Y++) {
          const pe = (async () => {
            const fe = Wi.create(), le = N.findIndex((Ie) => Ie.number === Le && Ie.quadrant === Y);
            if (le != -1) {
              const Ie = N[le].transformation, Ee = new Float32Array(Ie.split(" ").map(parseFloat));
              Wi.transpose(fe, Ee);
            }
            const Re = Y < 3 ? FN : kN, q = z.find((Ie) => Ie.fileType === G && Ie.fileName === Le.toString() && Ie.subLvlOne === ce && Ie.subLvlTwo === Re);
            if (!q) return;
            const { data: he } = await S.getCadLibrariesFileById(q.id), ne = new Int8Array(he), te = await th.fromBuffer({
              context: b,
              fileType: G,
              intArr: ne,
              flip: Y % 2 == 0,
              iXFs: Se,
              skipCopyToWasm: !0,
              ipOType: Oe._STL_TOOTH,
              ipOSubType: Oe._STL_OBJECT
            });
            te.setMatrix(fe), Y < 3 ? m.push(te) : I.push(te);
          })();
          se.push(pe);
        }
      await Promise.all(se), console.log("parseTeethLibraryObjects - Done"), Se.delete(), b.sceneRepaint(), E.fitZoomToScreen(), b.repaint();
    };
    return (C, k) => (L(), H(He, null, [
      d(r(we), {
        class: "flex w-full mt-6 p-dialog-header",
        style: { position: "relative" }
      }, {
        default: _(() => [
          y("div", xN, U(C.$t("implant-planner.teethLibrary")), 1),
          y("div", jN, [
            d(r(Ne), {
              class: "btn-wizard-md",
              togglable: !0,
              toggled: l.value,
              onToggledChange: A,
              "icon-src": i.value,
              "icon-src-height": "24px",
              "icon-src-width": "24px",
              label: C.$t("implant-planner.maxilla")
            }, null, 8, ["toggled", "icon-src", "label"]),
            d(r(Ne), {
              class: "btn-wizard-md ml-2",
              togglable: !0,
              toggled: s.value,
              onToggledChange: T,
              "icon-src": u.value,
              "icon-src-height": "24px",
              "icon-src-width": "24px",
              label: C.$t("implant-planner.mandible")
            }, null, 8, ["toggled", "icon-src", "label"])
          ])
        ]),
        _: 1
      }),
      d(r(we), { class: "w-full mt-3" }, {
        default: _(() => [
          d(r($n), {
            class: "w-full",
            modelValue: v.value,
            "onUpdate:modelValue": [
              k[0] || (k[0] = (M) => v.value = M),
              w
            ],
            options: r(f),
            optionLabel: "label"
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }),
      y("div", {
        ref_key: "vtkContainer",
        ref: o,
        class: "mt-2",
        style: { width: "60vw !important", height: "35vh" }
      }, null, 512),
      d(r(we), { class: "p-dialog-footer justify-center" }, {
        default: _(() => [
          d(r(la), {
            autofocus: "",
            class: "mt-6",
            label: C.$t("shared.ok"),
            onClick: p
          }, null, 8, ["label"]),
          d(r(ya), {
            class: "mt-6",
            label: C.$t("shared.cancel"),
            onClick: k[1] || (k[1] = (M) => h())
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
});
var Qm = {
  name: "EyeIcon",
  extends: ra
};
function VN(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.0535499 7.25213C0.208567 7.59162 2.40413 12.4 7 12.4C11.5959 12.4 13.7914 7.59162 13.9465 7.25213C13.9487 7.2471 13.9506 7.24304 13.952 7.24001C13.9837 7.16396 14 7.08239 14 7.00001C14 6.91762 13.9837 6.83605 13.952 6.76001C13.9506 6.75697 13.9487 6.75292 13.9465 6.74788C13.7914 6.4084 11.5959 1.60001 7 1.60001C2.40413 1.60001 0.208567 6.40839 0.0535499 6.74788C0.0512519 6.75292 0.0494023 6.75697 0.048 6.76001C0.0163137 6.83605 0 6.91762 0 7.00001C0 7.08239 0.0163137 7.16396 0.048 7.24001C0.0494023 7.24304 0.0512519 7.2471 0.0535499 7.25213ZM7 11.2C3.664 11.2 1.736 7.92001 1.264 7.00001C1.736 6.08001 3.664 2.80001 7 2.80001C10.336 2.80001 12.264 6.08001 12.736 7.00001C12.264 7.92001 10.336 11.2 7 11.2ZM5.55551 9.16182C5.98308 9.44751 6.48576 9.6 7 9.6C7.68891 9.59789 8.349 9.32328 8.83614 8.83614C9.32328 8.349 9.59789 7.68891 9.59999 7C9.59999 6.48576 9.44751 5.98308 9.16182 5.55551C8.87612 5.12794 8.47006 4.7947 7.99497 4.59791C7.51988 4.40112 6.99711 4.34963 6.49276 4.44995C5.98841 4.55027 5.52513 4.7979 5.16152 5.16152C4.7979 5.52513 4.55027 5.98841 4.44995 6.49276C4.34963 6.99711 4.40112 7.51988 4.59791 7.99497C4.7947 8.47006 5.12794 8.87612 5.55551 9.16182ZM6.2222 5.83594C6.45243 5.6821 6.7231 5.6 7 5.6C7.37065 5.6021 7.72553 5.75027 7.98762 6.01237C8.24972 6.27446 8.39789 6.62934 8.4 7C8.4 7.27689 8.31789 7.54756 8.16405 7.77779C8.01022 8.00802 7.79157 8.18746 7.53575 8.29343C7.27994 8.39939 6.99844 8.42711 6.72687 8.37309C6.4553 8.31908 6.20584 8.18574 6.01005 7.98994C5.81425 7.79415 5.68091 7.54469 5.6269 7.27312C5.57288 7.00155 5.6006 6.72006 5.70656 6.46424C5.81253 6.20842 5.99197 5.98977 6.2222 5.83594Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Qm.render = VN;
var ef = {
  name: "RefreshIcon",
  extends: ra
};
function BN(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.77051 5.96336C6.84324 5.99355 6.92127 6.00891 7.00002 6.00854C7.07877 6.00891 7.1568 5.99355 7.22953 5.96336C7.30226 5.93317 7.36823 5.88876 7.42357 5.83273L9.82101 3.43529C9.93325 3.32291 9.99629 3.17058 9.99629 3.01175C9.99629 2.85292 9.93325 2.70058 9.82101 2.5882L7.42357 0.190763C7.3687 0.131876 7.30253 0.0846451 7.22901 0.0518865C7.15549 0.019128 7.07612 0.00151319 6.99564 9.32772e-05C6.91517 -0.00132663 6.83523 0.0134773 6.7606 0.0436218C6.68597 0.0737664 6.61817 0.118634 6.56126 0.175548C6.50435 0.232462 6.45948 0.300257 6.42933 0.374888C6.39919 0.449519 6.38439 0.529456 6.38581 0.609933C6.38722 0.690409 6.40484 0.769775 6.4376 0.843296C6.47036 0.916817 6.51759 0.982986 6.57647 1.03786L7.95103 2.41241H6.99998C5.46337 2.41241 3.98969 3.02283 2.90314 4.10938C1.81659 5.19593 1.20618 6.66961 1.20618 8.20622C1.20618 9.74283 1.81659 11.2165 2.90314 12.3031C3.98969 13.3896 5.46337 14 6.99998 14C8.53595 13.9979 10.0084 13.3868 11.0945 12.3007C12.1806 11.2146 12.7917 9.74218 12.7938 8.20622C12.7938 8.04726 12.7306 7.89481 12.6182 7.78241C12.5058 7.67001 12.3534 7.60686 12.1944 7.60686C12.0355 7.60686 11.883 7.67001 11.7706 7.78241C11.6582 7.89481 11.5951 8.04726 11.5951 8.20622C11.5951 9.11504 11.3256 10.0035 10.8207 10.7591C10.3157 11.5148 9.59809 12.1037 8.75845 12.4515C7.9188 12.7993 6.99489 12.8903 6.10353 12.713C5.21217 12.5357 4.3934 12.0981 3.75077 11.4554C3.10813 10.8128 2.67049 9.99404 2.49319 9.10268C2.31589 8.21132 2.40688 7.2874 2.75468 6.44776C3.10247 5.60811 3.69143 4.89046 4.44709 4.38554C5.20275 3.88063 6.09116 3.61113 6.99998 3.61113H7.95098L6.57647 4.98564C6.46423 5.09802 6.40119 5.25035 6.40119 5.40918C6.40119 5.56801 6.46423 5.72035 6.57647 5.83273C6.63181 5.88876 6.69778 5.93317 6.77051 5.96336Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
ef.render = BN;
var tf = {
  name: "SearchMinusIcon",
  extends: ra
};
function UN(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.0208 12.0411C4.83005 12.0411 3.66604 11.688 2.67596 11.0265C1.68589 10.3649 0.914216 9.42464 0.458534 8.32452C0.00285271 7.22441 -0.116374 6.01388 0.11593 4.84601C0.348235 3.67813 0.921637 2.60537 1.76363 1.76338C2.60562 0.921393 3.67838 0.34799 4.84625 0.115686C6.01412 -0.116618 7.22466 0.00260857 8.32477 0.45829C9.42488 0.913972 10.3652 1.68564 11.0267 2.67572C11.6883 3.66579 12.0414 4.8298 12.0414 6.02056C12.0395 7.41563 11.5542 8.76029 10.6783 9.8305L13.8244 12.9765C13.9367 13.089 13.9997 13.2414 13.9997 13.4003C13.9997 13.5592 13.9367 13.7116 13.8244 13.8241C13.769 13.8801 13.703 13.9245 13.6302 13.9548C13.5575 13.985 13.4794 14.0003 13.4006 14C13.3218 14.0003 13.2437 13.985 13.171 13.9548C13.0982 13.9245 13.0322 13.8801 12.9768 13.8241L9.83082 10.678C8.76059 11.5539 7.4159 12.0393 6.0208 12.0411ZM6.0208 1.20731C5.07199 1.20731 4.14449 1.48867 3.35559 2.0158C2.56669 2.54292 1.95181 3.29215 1.58872 4.16874C1.22562 5.04532 1.13062 6.00989 1.31572 6.94046C1.50083 7.87104 1.95772 8.72583 2.62863 9.39674C3.29954 10.0676 4.15433 10.5245 5.0849 10.7096C6.01548 10.8947 6.98005 10.7997 7.85663 10.4367C8.73322 10.0736 9.48244 9.45868 10.0096 8.66978C10.5367 7.88088 10.8181 6.95337 10.8181 6.00457C10.8181 4.73226 10.3126 3.51206 9.41297 2.6124C8.51331 1.71274 7.29311 1.20731 6.0208 1.20731ZM4.00591 6.60422H8.00362C8.16266 6.60422 8.31518 6.54104 8.42764 6.42859C8.5401 6.31613 8.60328 6.1636 8.60328 6.00456C8.60328 5.84553 8.5401 5.693 8.42764 5.58054C8.31518 5.46809 8.16266 5.40491 8.00362 5.40491H4.00591C3.84687 5.40491 3.69434 5.46809 3.58189 5.58054C3.46943 5.693 3.40625 5.84553 3.40625 6.00456C3.40625 6.1636 3.46943 6.31613 3.58189 6.42859C3.69434 6.54104 3.84687 6.60422 4.00591 6.60422Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
tf.render = UN;
var nf = {
  name: "SearchPlusIcon",
  extends: ra
};
function GN(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.67596 11.0265C3.66604 11.688 4.83005 12.0411 6.0208 12.0411C6.81143 12.0411 7.59432 11.8854 8.32477 11.5828C8.86999 11.357 9.37802 11.0526 9.83311 10.6803L12.9768 13.8241C13.0322 13.8801 13.0982 13.9245 13.171 13.9548C13.2437 13.985 13.3218 14.0003 13.4006 14C13.4794 14.0003 13.5575 13.985 13.6302 13.9548C13.703 13.9245 13.769 13.8801 13.8244 13.8241C13.9367 13.7116 13.9997 13.5592 13.9997 13.4003C13.9997 13.2414 13.9367 13.089 13.8244 12.9765L10.6806 9.8328C11.0529 9.37773 11.3572 8.86972 11.5831 8.32452C11.8856 7.59408 12.0414 6.81119 12.0414 6.02056C12.0414 4.8298 11.6883 3.66579 11.0267 2.67572C10.3652 1.68564 9.42488 0.913972 8.32477 0.45829C7.22466 0.00260857 6.01412 -0.116618 4.84625 0.115686C3.67838 0.34799 2.60562 0.921393 1.76363 1.76338C0.921637 2.60537 0.348235 3.67813 0.11593 4.84601C-0.116374 6.01388 0.00285271 7.22441 0.458534 8.32452C0.914216 9.42464 1.68589 10.3649 2.67596 11.0265ZM3.35559 2.0158C4.14449 1.48867 5.07199 1.20731 6.0208 1.20731C7.29311 1.20731 8.51331 1.71274 9.41297 2.6124C10.3126 3.51206 10.8181 4.73226 10.8181 6.00457C10.8181 6.95337 10.5367 7.88088 10.0096 8.66978C9.48244 9.45868 8.73322 10.0736 7.85663 10.4367C6.98005 10.7997 6.01548 10.8947 5.0849 10.7096C4.15433 10.5245 3.29954 10.0676 2.62863 9.39674C1.95772 8.72583 1.50083 7.87104 1.31572 6.94046C1.13062 6.00989 1.22562 5.04532 1.58872 4.16874C1.95181 3.29215 2.56669 2.54292 3.35559 2.0158ZM6.00481 8.60309C5.84641 8.60102 5.69509 8.53718 5.58308 8.42517C5.47107 8.31316 5.40722 8.16183 5.40515 8.00344V6.60422H4.00591C3.84687 6.60422 3.69434 6.54104 3.58189 6.42859C3.46943 6.31613 3.40625 6.1636 3.40625 6.00456C3.40625 5.84553 3.46943 5.693 3.58189 5.58054C3.69434 5.46809 3.84687 5.40491 4.00591 5.40491H5.40515V4.00572C5.40515 3.84668 5.46833 3.69416 5.58079 3.5817C5.69324 3.46924 5.84577 3.40607 6.00481 3.40607C6.16385 3.40607 6.31637 3.46924 6.42883 3.5817C6.54129 3.69416 6.60447 3.84668 6.60447 4.00572V5.40491H8.00362C8.16266 5.40491 8.31518 5.46809 8.42764 5.58054C8.5401 5.693 8.60328 5.84553 8.60328 6.00456C8.60328 6.1636 8.5401 6.31613 8.42764 6.42859C8.31518 6.54104 8.16266 6.60422 8.00362 6.60422H6.60447V8.00344C6.60239 8.16183 6.53855 8.31316 6.42654 8.42517C6.31453 8.53718 6.1632 8.60102 6.00481 8.60309Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
nf.render = GN;
var af = {
  name: "TimesIcon",
  extends: ra
};
function WN(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    d: "M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
af.render = WN;
var of = {
  name: "UndoIcon",
  extends: ra
};
function zN(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.77042 5.96336C6.84315 5.99355 6.92118 6.00891 6.99993 6.00854C7.07868 6.00891 7.15671 5.99355 7.22944 5.96336C7.30217 5.93317 7.36814 5.88876 7.42348 5.83273C7.53572 5.72035 7.59876 5.56801 7.59876 5.40918C7.59876 5.25035 7.53572 5.09802 7.42348 4.98564L6.04897 3.61113H6.99998C7.9088 3.61113 8.79722 3.88063 9.55288 4.38554C10.3085 4.89046 10.8975 5.60811 11.2453 6.44776C11.5931 7.2874 11.6841 8.21132 11.5068 9.10268C11.3295 9.99404 10.8918 10.8128 10.2492 11.4554C9.60657 12.0981 8.7878 12.5357 7.89644 12.713C7.00508 12.8903 6.08116 12.7993 5.24152 12.4515C4.40188 12.1037 3.68422 11.5148 3.17931 10.7591C2.67439 10.0035 2.4049 9.11504 2.4049 8.20622C2.4049 8.04726 2.34175 7.89481 2.22935 7.78241C2.11695 7.67001 1.9645 7.60686 1.80554 7.60686C1.64658 7.60686 1.49413 7.67001 1.38172 7.78241C1.26932 7.89481 1.20618 8.04726 1.20618 8.20622C1.20829 9.74218 1.81939 11.2146 2.90548 12.3007C3.99157 13.3868 5.46402 13.9979 6.99998 14C8.5366 14 10.0103 13.3896 11.0968 12.3031C12.1834 11.2165 12.7938 9.74283 12.7938 8.20622C12.7938 6.66961 12.1834 5.19593 11.0968 4.10938C10.0103 3.02283 8.5366 2.41241 6.99998 2.41241H6.04892L7.42348 1.03786C7.48236 0.982986 7.5296 0.916817 7.56235 0.843296C7.59511 0.769775 7.61273 0.690409 7.61415 0.609933C7.61557 0.529456 7.60076 0.449519 7.57062 0.374888C7.54047 0.300257 7.49561 0.232462 7.43869 0.175548C7.38178 0.118634 7.31398 0.0737664 7.23935 0.0436218C7.16472 0.0134773 7.08478 -0.00132663 7.00431 9.32772e-05C6.92383 0.00151319 6.84447 0.019128 6.77095 0.0518865C6.69742 0.0846451 6.63126 0.131876 6.57638 0.190763L4.17895 2.5882C4.06671 2.70058 4.00366 2.85292 4.00366 3.01175C4.00366 3.17058 4.06671 3.32291 4.17895 3.43529L6.57638 5.83273C6.63172 5.88876 6.69769 5.93317 6.77042 5.96336Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
of.render = zN;
const HN = {
  name: "BaseImage",
  extends: Ka,
  props: {
    preview: {
      type: Boolean,
      default: !1
    },
    class: {
      type: null,
      default: null
    },
    style: {
      type: null,
      default: null
    },
    imageStyle: {
      type: null,
      default: null
    },
    imageClass: {
      type: null,
      default: null
    },
    previewButtonProps: {
      type: null,
      default: null
    },
    indicatorIcon: {
      type: String,
      default: void 0
    },
    previewIcon: {
      type: String,
      default: void 0
    },
    zoomInDisabled: {
      type: Boolean,
      default: !1
    },
    zoomOutDisabled: {
      type: Boolean,
      default: !1
    }
  },
  style: Lh,
  provide() {
    return {
      $pcImage: this,
      $parentInstance: this
    };
  }
}, YN = {
  name: "Image",
  extends: HN,
  inheritAttrs: !1,
  emits: ["show", "hide", "error"],
  mask: null,
  data() {
    return {
      maskVisible: !1,
      previewVisible: !1,
      rotate: 0,
      scale: 1
    };
  },
  beforeUnmount() {
    this.mask && Vs.clear(this.container);
  },
  methods: {
    maskRef(e) {
      this.mask = e;
    },
    toolbarRef(e) {
      this.toolbarRef = e;
    },
    onImageClick() {
      this.preview && (Jv(), this.maskVisible = !0, setTimeout(() => {
        this.previewVisible = !0;
      }, 25));
    },
    onPreviewImageClick() {
      this.previewClick = !0;
    },
    onMaskClick(e) {
      const t = ly(e.target, "data-pc-section-group", "action") || e.target.closest('[data-pc-section-group="action"]');
      !this.previewClick && !t && (this.previewVisible = !1, this.rotate = 0, this.scale = 1), this.previewClick = !1;
    },
    onMaskKeydown(e) {
      switch (e.code) {
        case "Escape":
          this.hidePreview(), setTimeout(() => {
            Pi(this.$refs.previewButton);
          }, 200), e.preventDefault();
          break;
      }
    },
    onError() {
      this.$emit("error");
    },
    rotateRight() {
      this.rotate += 90, this.previewClick = !0;
    },
    rotateLeft() {
      this.rotate -= 90, this.previewClick = !0;
    },
    zoomIn() {
      this.scale = this.scale + 0.1, this.previewClick = !0;
    },
    zoomOut() {
      this.scale = this.scale - 0.1, this.previewClick = !0;
    },
    onBeforeEnter() {
      Vs.set("modal", this.mask, this.$primevue.config.zIndex.modal);
    },
    onEnter() {
      this.focus(), this.$emit("show");
    },
    onBeforeLeave() {
      !this.isUnstyled && Gp(this.mask, "p-overlay-mask-leave");
    },
    onLeave() {
      Bc(), this.$emit("hide");
    },
    onAfterLeave(e) {
      Vs.clear(e), this.maskVisible = !1;
    },
    focus() {
      let e = this.mask.querySelector("[autofocus]");
      e && e.focus();
    },
    hidePreview() {
      this.previewVisible = !1, this.rotate = 0, this.scale = 1, Bc();
    }
  },
  computed: {
    containerClass() {
      return [this.cx("root"), this.class];
    },
    rotateClass() {
      return "p-image-preview-rotate-" + this.rotate;
    },
    imagePreviewStyle() {
      return { transform: "rotate(" + this.rotate + "deg) scale(" + this.scale + ")" };
    },
    isZoomInDisabled() {
      return this.zoomInDisabled || this.scale >= 1.5;
    },
    isZoomOutDisabled() {
      return this.zoomOutDisabled || this.scale <= 0.5;
    },
    rightAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.rotateRight : void 0;
    },
    leftAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.rotateLeft : void 0;
    },
    zoomInAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.zoomIn : void 0;
    },
    zoomOutAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.zoomOut : void 0;
    },
    zoomImageAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.zoomImage : void 0;
    },
    closeAriaLabel() {
      return this.$primevue.config.locale.aria ? this.$primevue.config.locale.aria.close : void 0;
    }
  },
  components: {
    Portal: Nh,
    EyeIcon: Qm,
    RefreshIcon: ef,
    UndoIcon: of,
    SearchMinusIcon: tf,
    SearchPlusIcon: nf,
    TimesIcon: af
  },
  directives: {
    focustrap: Ch
  }
}, KN = ["aria-label"], ZN = ["aria-modal"], XN = ["aria-label"], JN = ["aria-label"], qN = ["disabled", "aria-label"], QN = ["disabled", "aria-label"], eL = ["aria-label"], tL = ["src"];
function nL(e, t, n, a, o, l) {
  const s = Tn("RefreshIcon"), i = Tn("UndoIcon"), u = Tn("SearchMinusIcon"), c = Tn("SearchPlusIcon"), p = Tn("TimesIcon"), h = Tn("Portal"), g = Gr("focustrap");
  return L(), H("span", je({
    class: l.containerClass,
    style: e.style
  }, e.ptmi("root")), [
    It(e.$slots, "image", { errorCallback: l.onError }, () => [
      y("img", je({
        style: e.imageStyle,
        class: e.imageClass,
        onError: t[0] || (t[0] = (...b) => l.onError && l.onError(...b))
      }, { ...e.$attrs, ...e.ptm("image") }), null, 16)
    ]),
    e.preview ? (L(), H("button", je({
      key: 0,
      ref: "previewButton",
      "aria-label": l.zoomImageAriaLabel,
      type: "button",
      class: e.cx("previewMask"),
      onClick: t[1] || (t[1] = (...b) => l.onImageClick && l.onImageClick(...b))
    }, { ...e.previewButtonProps, ...e.ptm("previewMask") }), [
      It(e.$slots, e.$slots.previewicon ? "previewicon" : "indicatoricon", {}, () => [
        (L(), be(Sa(e.previewIcon || e.indicatorIcon ? "i" : "EyeIcon"), je({
          class: e.cx("previewIcon")
        }, e.ptm("previewIcon")), null, 16, ["class"]))
      ])
    ], 16, KN)) : ue("", !0),
    d(h, null, {
      default: _(() => [
        o.maskVisible ? Pt((L(), H("div", je({
          key: 0,
          ref: l.maskRef,
          role: "dialog",
          class: e.cx("mask"),
          "aria-modal": o.maskVisible,
          onClick: t[8] || (t[8] = (...b) => l.onMaskClick && l.onMaskClick(...b)),
          onKeydown: t[9] || (t[9] = (...b) => l.onMaskKeydown && l.onMaskKeydown(...b))
        }, e.ptm("mask")), [
          y("div", je({
            class: e.cx("toolbar")
          }, e.ptm("toolbar")), [
            y("button", je({
              class: e.cx("rotateRightButton"),
              onClick: t[2] || (t[2] = (...b) => l.rotateRight && l.rotateRight(...b)),
              type: "button",
              "aria-label": l.rightAriaLabel
            }, e.ptm("rotateRightButton"), { "data-pc-group-section": "action" }), [
              It(e.$slots, "refresh", {}, () => [
                d(s, po(Il(e.ptm("rotateRightIcon"))), null, 16)
              ])
            ], 16, XN),
            y("button", je({
              class: e.cx("rotateLeftButton"),
              onClick: t[3] || (t[3] = (...b) => l.rotateLeft && l.rotateLeft(...b)),
              type: "button",
              "aria-label": l.leftAriaLabel
            }, e.ptm("rotateLeftButton"), { "data-pc-group-section": "action" }), [
              It(e.$slots, "undo", {}, () => [
                d(i, po(Il(e.ptm("rotateLeftIcon"))), null, 16)
              ])
            ], 16, JN),
            y("button", je({
              class: e.cx("zoomOutButton"),
              onClick: t[4] || (t[4] = (...b) => l.zoomOut && l.zoomOut(...b)),
              type: "button",
              disabled: l.isZoomOutDisabled,
              "aria-label": l.zoomOutAriaLabel
            }, e.ptm("zoomOutButton"), { "data-pc-group-section": "action" }), [
              It(e.$slots, "zoomout", {}, () => [
                d(u, po(Il(e.ptm("zoomOutIcon"))), null, 16)
              ])
            ], 16, qN),
            y("button", je({
              class: e.cx("zoomInButton"),
              onClick: t[5] || (t[5] = (...b) => l.zoomIn && l.zoomIn(...b)),
              type: "button",
              disabled: l.isZoomInDisabled,
              "aria-label": l.zoomInAriaLabel
            }, e.ptm("zoomInButton"), { "data-pc-group-section": "action" }), [
              It(e.$slots, "zoomin", {}, () => [
                d(c, po(Il(e.ptm("zoomInIcon"))), null, 16)
              ])
            ], 16, QN),
            y("button", je({
              class: e.cx("closeButton"),
              type: "button",
              onClick: t[6] || (t[6] = (...b) => l.hidePreview && l.hidePreview(...b)),
              "aria-label": l.closeAriaLabel,
              autofocus: ""
            }, e.ptm("closeButton"), { "data-pc-group-section": "action" }), [
              It(e.$slots, "close", {}, () => [
                d(p, po(Il(e.ptm("closeIcon"))), null, 16)
              ])
            ], 16, eL)
          ], 16),
          d(Ig, je({
            name: "p-image-original",
            onBeforeEnter: l.onBeforeEnter,
            onEnter: l.onEnter,
            onLeave: l.onLeave,
            onBeforeLeave: l.onBeforeLeave,
            onAfterLeave: l.onAfterLeave
          }, e.ptm("transition")), {
            default: _(() => [
              o.previewVisible ? (L(), H("div", po(je({ key: 0 }, e.ptm("originalContainer"))), [
                It(e.$slots, e.$slots.original ? "original" : "preview", {
                  class: Ge(e.cx("original")),
                  style: Et(l.imagePreviewStyle),
                  previewCallback: l.onPreviewImageClick
                }, () => [
                  y("img", je({
                    src: e.$attrs.src,
                    class: e.cx("original"),
                    style: l.imagePreviewStyle,
                    onClick: t[7] || (t[7] = (...b) => l.onPreviewImageClick && l.onPreviewImageClick(...b))
                  }, e.ptm("original")), null, 16, tL)
                ])
              ], 16)) : ue("", !0)
            ]),
            _: 3
          }, 16, ["onBeforeEnter", "onEnter", "onLeave", "onBeforeLeave", "onAfterLeave"])
        ], 16, ZN)), [
          [g]
        ]) : ue("", !0)
      ]),
      _: 3
    })
  ], 16);
}
const Au = /* @__PURE__ */ Vt(YN, [["render", nL]]);
class aL {
  constructor() {
    an(this, "CAN_USE_MODEL_PRO", 1);
    an(this, "CAN_USE_ENCODE_CONVERTOR", 1);
    an(this, "CAN_USE_BELLAK_ABUTMENT", 1);
    an(this, "CAN_USE_DIE_FIXATION", 1);
    an(this, "CAN_USE_TMJ_DIAGNOSIS", 1);
    an(this, "CAN_USE_ITAKA_VERSION", 1);
    an(this, "NA_ENTRY_LEVEL", !1);
    an(this, "VERSION_TYPE", 32);
  }
}
var lf = /* @__PURE__ */ ((e) => (e[e.CD_VIEWER = 1] = "CD_VIEWER", e[e.NORMAL = 2] = "NORMAL", e[e.START = 4] = "START", e[e.PRO = 8] = "PRO", e[e.DOUBLE_SCAN = 16] = "DOUBLE_SCAN", e[e.CAD = 32] = "CAD", e[e.SUBSCRIPTION = 64] = "SUBSCRIPTION", e[e.READ_ONLY = 128] = "READ_ONLY", e[e.PLAN = 256] = "PLAN", e))(lf || {});
const vl = new aL();
function oL() {
  return vl.CAN_USE_MODEL_PRO;
}
function sf() {
  return vl.NA_ENTRY_LEVEL;
}
function lL() {
  return vl.CAN_USE_ITAKA_VERSION;
}
function iL() {
  return vl.CAN_USE_TMJ_DIAGNOSIS;
}
function sL() {
  return vl.CAN_USE_BELLAK_ABUTMENT;
}
function rL() {
  return vl.VERSION_TYPE;
}
b0();
const kl = (e, t) => {
  const n = it(e);
  return n === e ? t : n;
}, uL = [
  [ge.eRD_CROWN_BRIDGE, "weblink.crownBridge", "Crown & Bridge"],
  [ge.eRD_DIGITAL_SMILE_DESIGN, "implant-planner.smileSetup", "Smile Setup"],
  [ge.eRD_BAR, "weblink.overdenture", "Overdenture"],
  [ge.eRD_PRE_OP, "weblink.preOp", "Pre-Op"],
  [ge.eRD_DENTURE, "weblink.denture", "Denture"],
  [ge.eRD_IL_PROVISIONAL, "weblink.immediateLoadProvisional", "Immediate Load Provisional"],
  [ge.eRD_MODEL_BUILDER, "weblink.modelSetup", "Model Setup"],
  [ge.eRD_MODEL_PRO, "weblink.modelPRO", "ModelPRO"],
  [ge.eRD_ORTHODONTIC_MODEL_BUILDER, "weblink.orthodonticModelSetup", "Orthodontic Model Setup"],
  [ge.eRD_BITE_SPLINT, "weblink.biteSplint", "Bite Splint"],
  [ge.eRD_TMJ_DIAGNOSIS, "weblink.tmjDiagnosis", "TMJ Diagnosis"],
  [ge.eRD_INNOVA_IMPLANT_CHECK, "weblink.innovaImplantCheck", "EasyCheck"],
  [ge.eRD_GUIDE, "implant-planner.guide", "Guide"],
  [ge.eRD_ANALOGS_MODEL, "implant-planner.analogsModel", "Analogs Model"],
  [ge.eRD_BONE_GRAFT, "medic-web-engine.boneGraft", "Bone Graft"],
  [ge.eRD_BONE_GRID, "medic-web-engine.boneGrid", "Bone Grid"],
  [ge.eRD_BONE_FROM_CT, "medic-web-engine.boneFromCt", "Bone From CT"],
  [ge.eRD_TEETH_FROM_CT, "medic-web-engine.teethFromCt", "Teeth From CT"],
  [ge.eRD_CROWNS_FROM_STL, "medic-web-engine.crownsFromStl", "Crowns From STL"],
  [ge.eRD_ADVANCED_FEATURES, "medic-web-engine.advancedFeatures", "Advanced Features"]
], rf = Ce(() => uL.reduce((e, [t, n, a]) => (e.set(t, kl(n, a)), e), /* @__PURE__ */ new Map())), cL = (e, t) => {
  const n = it(e);
  return n === e ? t : n;
}, dL = [
  [0, "implant-planner.stumpsTeethLibrary", "Stumps Teeth Library"],
  [6, "implant-planner.stumpsWaxup", "Stumps Waxup"],
  [1, "implant-planner.parametricProvisionalWaxup", "Parametric Provisional Waxup"],
  [2, "implant-planner.scannedTiBaseTeethLibrary", "Scanned TiBase Teeth Library"],
  [3, "implant-planner.scannedTiBaseWaxup", "Scanned TiBase Waxup"],
  [4, "implant-planner.scanAbutmentTeethLibrary", "Scan Abutment Teeth Library"],
  [7, "implant-planner.scanAbutmentWaxup", "Scan Abutment Waxup"],
  [26, "implant-planner.locatorOverdenture", "Locator Overdenture"],
  [27, "implant-planner.implantOverdenture", "Implant Overdenture"],
  [8, "implant-planner.abutment", "Abutment"],
  [9, "implant-planner.abutmentWaxup", "Abutment Waxup"],
  [10, "implant-planner.manualImplantWaxup", "Manual Implant Waxup"],
  [11, "implant-planner.mockupTeethLibrary", "Mockup Teeth Library"],
  [12, "implant-planner.healingAbutmentEggShell", "Healing Abutment + Egg Shell"],
  [18, "implant-planner.healingAbutmentEggShellWaxup", "Healing Abutment + Egg Shell Waxup"],
  [13, "implant-planner.shellTeethLibrary", "Shell Teeth Library"],
  [19, "implant-planner.shellWaxup", "Shell Waxup"],
  [14, "implant-planner.denture", "Denture"],
  [15, "implant-planner.mockUpSnapOnDigitalWaxup", "Mock-up/Snap-On/Digital Waxup"],
  [45, "implant-planner.smileSetup", "Smile Setup"],
  [16, "implant-planner.scannedTiBaseBar", "Scanned TiBase Bar"],
  [17, "implant-planner.scanAbutmentBar", "Scan Abutment Bar"],
  [20, "implant-planner.inlayOnlayVeneerRichmond", "Inlay/Onlay/Veneer/Richmond"],
  [24, "implant-planner.modelSetup", "Model Setup"],
  [28, "implant-planner.eggShellPreOp", "Egg Shell Pre-Op"],
  [31, "implant-planner.thimblePreOp", "Thimble Pre-Op"],
  [29, "implant-planner.guide", "Guide"],
  [30, "implant-planner.meshLabelEdit", "Mesh Label Edit"],
  [34, "implant-planner.libraryCrownBridge", "Library Crown & Bridge"],
  [36, "implant-planner.occlusion", "Occlusion"],
  [37, "implant-planner.biteSplint", "Bite Splint"],
  [38, "implant-planner.waxupCrownBridge", "Waxup Crown & Bridge"],
  [39, "implant-planner.modelPRO", "ModelPRO"],
  [42, "implant-planner.teethLibrary", "Teeth Library"],
  [43, "implant-planner.bellatekAbutment", "Bellatek Abutment"],
  [46, "implant-planner.tmjDiagnosis", "TMJ Diagnosis"],
  [48, "implant-planner.teethSetup", "Teeth Setup"],
  [51, "implant-planner.overdentureOnScannedStructure", "Overdenture On Scanned Structure"],
  [54, "implant-planner.innovaImplantCheckFromDenture", "INNOVA Implant Check From Denture"],
  [55, "implant-planner.innovaImplantCheckFromBridge", "INNOVA Implant Check From Bridge"],
  [56, "implant-planner.innovaImplantCheckCompare", "INNOVA Implant Check Compare"],
  [57, "implant-planner.innovaImplantCheckDirect", "INNOVA Implant Check Direct"],
  [58, "implant-planner.tryInRxGuide", "Try-in/Rx GUIDE"]
], Hn = new Map(dL.map(([e, t, n]) => [e, cL(t, n)]));
var $e = /* @__PURE__ */ ((e) => (e[e.eDI_MODEL_ANTAGONIST = 0] = "eDI_MODEL_ANTAGONIST", e[e.eDI_GINGIVA_ANTAGONIST = 1] = "eDI_GINGIVA_ANTAGONIST", e[e.eDI_WAXUP_ANTAGONIST = 2] = "eDI_WAXUP_ANTAGONIST", e[e.eDI_MARKER_ANTAGONIST = 3] = "eDI_MARKER_ANTAGONIST", e[e.eDI_DENTURE_ANTAGONIST = 4] = "eDI_DENTURE_ANTAGONIST", e[e.eDI_FACE_SCAN = 5] = "eDI_FACE_SCAN", e[e.eDI_MODEL = 6] = "eDI_MODEL", e[e.eDI_GINGIVA = 7] = "eDI_GINGIVA", e[e.eDI_WAXUP = 8] = "eDI_WAXUP", e[e.eDI_MARKER = 9] = "eDI_MARKER", e[e.eDI_DENTURE = 10] = "eDI_DENTURE", e[e.eDI_MOVEMENT_MARKER = 11] = "eDI_MOVEMENT_MARKER", e[e.eDI_UPPER_GENERIC = 12] = "eDI_UPPER_GENERIC", e[e.eDI_LOWER_GENERIC = 13] = "eDI_LOWER_GENERIC", e))($e || {});
const pL = "medic-web-engine", mL = [
  [0, "upperJaw", "Upper Jaw"],
  [1, "upperGingiva", "Upper Gingiva"],
  [2, "upperWaxup", "Upper Waxup"],
  [3, "upperMarker", "Upper Marker"],
  [4, "upperDenture", "Upper Denture"],
  [5, "faceScan", "Face Scan"],
  [6, "lowerJaw", "Lower Jaw"],
  [7, "lowerGingiva", "Lower Gingiva"],
  [8, "lowerWaxup", "Lower Waxup"],
  [9, "lowerMarker", "Lower Marker"],
  [10, "lowerDenture", "Lower Denture"],
  [11, "movementMarker", "Movement Marker"],
  [12, "upperGeneric", "Upper Generic"],
  [13, "lowerGeneric", "Lower Generic"]
], fL = (e, t) => {
  const n = `${pL}.${e}`, a = it(n);
  return a === n ? t : a;
}, Dl = Ce(() => mL.reduce(
  (e, [t, n, a]) => (e[t] = fL(n, a), e),
  {}
)), gL = {
  0: St.eOT_UPPER_JAW,
  1: St.eOT_UPPER_GINGIVA,
  2: St.eOT_UPPER_WAXUP,
  3: St.eOT_UPPER_MARKER,
  4: St.eOT_UPPER_DENTURE_MODEL,
  5: St.eOT_FACE_SCAN,
  6: St.eOT_LOWER_JAW,
  7: St.eOT_LOWER_GINGIVA,
  8: St.eOT_LOWER_WAXUP,
  9: St.eOT_LOWER_MARKER,
  10: St.eOT_LOWER_DENTURE_MODEL,
  11: St.eOT_MOVEMENT_SCAN_MARKER,
  12: St.eOT_GENERIC,
  13: St.eOT_GENERIC
}, kd = {
  0: et.eANTAGONIST,
  1: et.eGINGIVA_ANTAGONIST,
  2: et.eWAXUP_ANTAGONIST,
  3: et.eMARKER_ANTAGONIST,
  4: et.eDENTURE_ANTAGONIST,
  5: et.eFACE_SCAN,
  6: et.eMODEL,
  7: et.eGINGIVA,
  8: et.eWAXUP,
  9: et.eMARKER,
  10: et.eDENTURE,
  11: et.eMOVEMENT_MARKER,
  12: et.eGENERIC_UPPER,
  13: et.eGENERIC_LOWER
};
var Ua = /* @__PURE__ */ ((e) => (e[e.eP_LEFT = 0] = "eP_LEFT", e[e.eP_FRONT = 1] = "eP_FRONT", e[e.eP_RIGHT = 2] = "eP_RIGHT", e[e.eP_TOP = 3] = "eP_TOP", e))(Ua || {});
const qa = {
  0: { label: "implant-planner.leftProfile", iconSrc: "Head_Left_128" },
  1: { label: "implant-planner.front", iconSrc: "Head_Front_128" },
  2: { label: "implant-planner.rightProfile", iconSrc: "Head_Right_128" },
  3: { label: "implant-planner.top", iconSrc: "Head_Top_128" }
};
function uf(e) {
  const t = [], n = oL(), a = sf(), o = lL() == 1, l = iL() == 1, s = rL() & lf.CAD;
  console.log("licences CAD", s);
  for (let i of rf.value)
    if (e == ma.eDESIGN)
      switch (i[0]) {
        case ge.eRD_GUIDE:
        case ge.eRD_ANALOGS_MODEL:
          t.push(Go(i[1], i[0], !1));
        default:
          continue;
      }
    else if (e == ma.eSEGMENTATION)
      switch (i[0]) {
        case ge.eRD_BONE_FROM_CT:
          t.push(Go(i[1], i[0], !0));
          continue;
        case ge.eRD_TEETH_FROM_CT:
          t.push(Go(i[1], i[0], !0));
          continue;
        case ge.eRD_CROWNS_FROM_STL:
          t.push(Go(i[1], i[0], !0));
          continue;
        case ge.eRD_ADVANCED_FEATURES:
          t.push(Go(i[1], i[0], !1));
          continue;
        default:
          continue;
      }
    else {
      switch (i[0]) {
        case ge.eRD_GUIDE:
        case ge.eRD_ANALOGS_MODEL:
        case ge.eRD_BONE_GRAFT:
        case ge.eRD_BONE_GRID:
        case ge.eRD_BONE_FROM_CT:
        case ge.eRD_TEETH_FROM_CT:
        case ge.eRD_CROWNS_FROM_STL:
        case ge.eRD_ADVANCED_FEATURES:
          continue;
      }
      if (n == 0 && ge.eRD_MODEL_PRO == i[0] || n == 2 && ge.eRD_MODEL_PRO != i[0]) continue;
      if (ge.eRD_TMJ_DIAGNOSIS == i[0]) {
        if (!l && !o) continue;
      } else if (o && !s) continue;
      if (!l && !o && ge.eRD_TMJ_DIAGNOSIS == i[0]) continue;
      const u = a && [
        ge.eRD_BAR,
        ge.eRD_DENTURE,
        ge.eRD_IL_PROVISIONAL,
        ge.eRD_MODEL_PRO,
        ge.eRD_ORTHODONTIC_MODEL_BUILDER,
        ge.eRD_BITE_SPLINT,
        ge.eRD_DIGITAL_SMILE_DESIGN,
        ge.eRD_TMJ_DIAGNOSIS
      ].includes(i[0]);
      t.push(Go(i[1], i[0], u));
    }
  return t;
}
function hL(e) {
  const t = [], n = sf();
  switch (e) {
    case ge.eRD_CROWN_BRIDGE:
      t.push(In("From Library", ge.eRD_CROWN_BRIDGE, Ue.eWF_C_B_HYBRID, !1)), t.push(In("From Waxup", ge.eRD_CROWN_BRIDGE, Ue.eWF_C_B_HYBRID_WAXUP, !1)), t.push(
        In(
          Hn.get(
            20
            /* eRT_INLAY_ONLAY */
          ),
          ge.eRD_CROWN_BRIDGE,
          Ue.eWF_I_O_TEETH_LIBRARY,
          n
        )
      ), t.push(
        In(
          Hn.get(
            15
            /* eRT_DIGITAL_WAXUP */
          ),
          ge.eRD_CROWN_BRIDGE,
          Ue.eWF_C_B_DIGITAL_WAXUP,
          n
        )
      ), sL() && t.push(
        In(
          Hn.get(
            43
            /* eRT_BELLATEK_ABUTMENT */
          ),
          ge.eRD_CROWN_BRIDGE,
          Ue.eWF_C_B_BELLAK_ABUTMENT,
          n
        )
      );
      break;
    case ge.eRD_IL_PROVISIONAL:
      t.push(
        In(Hn.get(
          1
          /* eRT_IL_PROVISIONAL */
        ), ge.eRD_IL_PROVISIONAL, Ue.eWF_I_L_WAXUP, !1)
      ), t.push(
        In(Hn.get(
          12
          /* eRT_EGG_SHELL */
        ), ge.eRD_IL_PROVISIONAL, Ue.eWF_I_L_EGG_SHELL, !1)
      ), t.push(
        In(
          Hn.get(
            18
            /* eRT_EGG_SHELL_WAXUP */
          ),
          ge.eRD_IL_PROVISIONAL,
          Ue.eWF_I_L_EGG_SHELL_WAXUP,
          !1
        )
      );
      break;
    case ge.eRD_BAR:
      t.push(
        In(Hn.get(
          16
          /* eRT_BAR_CUSTOM_ABUTMENT */
        ), ge.eRD_BAR, Ue.eWF_BAR_MANUAL_IMPLANT, !1)
      ), t.push(
        In(Hn.get(
          17
          /* eRT_BAR_SCAN_ABUTMENT */
        ), ge.eRD_BAR, Ue.eWF_BAR_IMPLANT_LIBRARY, !1)
      ), t.push(
        In(
          Hn.get(
            26
            /* eRT_SCAN_ABUTMENT_LOCATOR_WAXUP */
          ),
          ge.eRD_BAR,
          Ue.eWF_C_B_IMPLANT_LIBRARY_LOCATOR_WAXUP,
          !1
        )
      ), t.push(
        In(
          Hn.get(
            27
            /* eRT_SCAN_ABUTMENT_IMPLANT_WAXUP */
          ),
          ge.eRD_BAR,
          Ue.eWF_C_B_IMPLANT_LIBRARY_IMPLANT_WAXUP,
          !1
        )
      ), t.push(
        In(Hn.get(
          51
          /* eRT_SCANNED_STRUCTURE */
        ), ge.eRD_BAR, Ue.eWF_SCANNED_STRUCTURE, !1)
      );
      break;
    case ge.eRD_PRE_OP:
      t.push(
        In(Hn.get(
          28
          /* eRT_EGG_SHELL_PRE_OP */
        ), ge.eRD_PRE_OP, Ue.eWF_EGG_SHELL_PRE_OP, !1)
      ), t.push(
        In(Hn.get(
          31
          /* eRT_THIMBLE_PRE_OP */
        ), ge.eRD_PRE_OP, Ue.eWF_THIMBLE_PRE_OP, n)
      );
      break;
    case ge.eRD_DENTURE:
      t.push(In("From Library", ge.eRD_DENTURE, Ue.eWF_DENTURE_FROM_TEETH_LIBRARY, !1)), t.push(In("From Copy", ge.eRD_DENTURE, Ue.eWF_DENTURE_FROM_COPY, !1));
      break;
  }
  return t;
}
const Go = (e, t, n) => {
  let a = "/cad/addreconstructionpanel/";
  const { retValue: o, comment: l } = cf(t);
  return a += o + "/" + o + ".png", {
    name: e,
    comment: l,
    imageSrc: a,
    reconstructionDesign: t,
    disabled: n
  };
}, In = (e, t, n, a) => {
  let o = "/cad/addreconstructionpanel/";
  const { retValue: l } = cf(t), { retValue: s, comment: i } = bL(n);
  return o += l + "/" + s + ".png", {
    name: e || "",
    comment: i,
    imageSrc: o,
    reconstructionDesign: t,
    workflow: n,
    disabled: a
  };
}, cf = (e) => {
  let t = "", n = "";
  switch (e) {
    case ge.eRD_CROWN_BRIDGE:
      t = "CrownBridge", n = it("medic-web-engine.reconCommentCrownBridge");
      break;
    case ge.eRD_BAR:
      t = "Overdenture", n = it("medic-web-engine.reconCommentOverdenture");
      break;
    case ge.eRD_PRE_OP:
      t = "PreOp", n = it("medic-web-engine.reconCommentPreOp");
      break;
    case ge.eRD_DENTURE:
      t = "Denture", n = it("medic-web-engine.reconCommentDenture");
      break;
    case ge.eRD_IL_PROVISIONAL:
      t = "ImmediateLoadProvisional", n = it("medic-web-engine.reconCommentImmediateLoadProvisional");
      break;
    case ge.eRD_MODEL_BUILDER:
      t = "ModelSetup", n = it("medic-web-engine.reconCommentModelSetup");
      break;
    case ge.eRD_MODEL_PRO:
      t = "ModelPRO", n = it("medic-web-engine.reconCommentModelPRO");
      break;
    case ge.eRD_ORTHODONTIC_MODEL_BUILDER:
      t = "OrthodonticModelSetup", n = it("medic-web-engine.reconCommentOrthodonticModelSetup");
      break;
    case ge.eRD_BITE_SPLINT:
      t = "BiteSplint", n = it("medic-web-engine.reconCommentBiteSplint");
      break;
    case ge.eRD_DIGITAL_SMILE_DESIGN:
      t = "DDSMockUp", n = it("medic-web-engine.reconCommentDDSMockUp");
      break;
    case ge.eRD_TMJ_DIAGNOSIS:
      t = "TMJDiagnosis", n = it("medic-web-engine.reconCommentTMJDiagnosis");
      break;
    case ge.eRD_INNOVA_IMPLANT_CHECK:
      t = "Innova", n = it("medic-web-engine.reconCommentInnova");
      break;
    case ge.eRD_GUIDE:
      t = "Guide", n = it("medic-web-engine.requirementsGuideHtml");
      break;
    case ge.eRD_ANALOGS_MODEL:
      t = "AnalogsModel", n = it("medic-web-engine.requirementsAnalogsModel");
      break;
    case ge.eRD_BONE_GRAFT:
      t = "BoneGraft", n = it("medic-web-engine.requirementsBoneGraft");
      break;
    case ge.eRD_BONE_GRID:
      t = "BoneGrid", n = it("medic-web-engine.requirementsBoneGrid");
      break;
    case ge.eRD_BONE_FROM_CT:
      t = "BoneFromCT", n = "";
      break;
    case ge.eRD_TEETH_FROM_CT:
      t = "TeethFromCT", n = "";
      break;
    case ge.eRD_CROWNS_FROM_STL:
      t = "CrownsFromSTL", n = "";
      break;
    case ge.eRD_ADVANCED_FEATURES:
      t = "AdvancedFeatures", n = "";
      break;
  }
  return { retValue: t, comment: n };
}, bL = (e) => {
  let t = "", n = "";
  switch (e) {
    /* Missing or no sub-type
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_TEETH_LIBRARY:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_WAXUP:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_MANUAL_IMPLANT:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_MANUAL_IMPLANT_WAXUP:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_IMPLANT_LIBRARY:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_IMPLANT_LIBRARY_WAXUP:
        retValue = "";
        break;
    case TAddNewReconstructionWidget::TReconstructionWorkflow::eWF_C_B_MOCKUP:
        retValue = "";
        break;
        */
    case Ue.eWF_C_B_IMPLANT_LIBRARY_LOCATOR_WAXUP:
      t = "LocatorOverdenture", n = it("medic-web-engine.reconWorkflowLocatorOverdenture");
      break;
    case Ue.eWF_C_B_IMPLANT_LIBRARY_IMPLANT_WAXUP:
      t = "ImplantOverdenture", n = it("medic-web-engine.reconWorkflowImplantOverdenture");
      break;
    case Ue.eWF_SCANNED_STRUCTURE:
      t = "ScannedStructure", n = it("medic-web-engine.reconWorkflowScannedStructure");
      break;
    case Ue.eWF_C_B_DIGITAL_WAXUP:
      t = "MockupSnapon", n = it("medic-web-engine.reconWorkflowMockupSnapon");
      break;
    case Ue.eWF_C_B_HYBRID:
      t = "FromLibrary", n = it("medic-web-engine.reconWorkflowFromLibrary");
      break;
    case Ue.eWF_C_B_HYBRID_WAXUP:
      t = "FromWaxup", n = it("medic-web-engine.reconWorkflowFromWaxup");
      break;
    case Ue.eWF_I_L_EGG_SHELL:
      t = "HealingAbutmentEggShell", n = it("medic-web-engine.reconWorkflowHealingAbutmentEggShell");
      break;
    case Ue.eWF_I_L_EGG_SHELL_WAXUP:
      t = "HealingAbutmentEggShellWaxup", n = it("medic-web-engine.reconWorkflowHealingAbutmentEggShellWaxup");
      break;
    case Ue.eWF_I_L_WAXUP:
      t = "ParametricProvisionalWaxup", n = it("medic-web-engine.reconWorkflowParametricProvisionalWaxup");
      break;
    case Ue.eWF_BAR_MANUAL_IMPLANT:
      t = "ScannedTiBaseBar", n = it("medic-web-engine.reconWorkflowScannedTiBaseBar");
      break;
    case Ue.eWF_BAR_IMPLANT_LIBRARY:
      t = "ScanAbutmentBar", n = it("medic-web-engine.reconWorkflowScanAbutmentBar");
      break;
    case Ue.eWF_I_O_TEETH_LIBRARY:
      t = "InlayOnlay", n = it("medic-web-engine.reconWorkflowInlayOnlay");
      break;
    case Ue.eWF_EGG_SHELL_PRE_OP:
      t = "EggShellPreOp", n = it("medic-web-engine.reconWorkflowEggShellPreOp");
      break;
    case Ue.eWF_THIMBLE_PRE_OP:
      t = "ThimblePreOp", n = it("medic-web-engine.reconWorkflowThimblePreOp");
      break;
    case Ue.eWF_C_B_BELLAK_ABUTMENT:
      t = "BellatekAbutment", n = it("medic-web-engine.reconWorkflowBellatekAbutment");
      break;
    case Ue.eWF_DENTURE_FROM_TEETH_LIBRARY:
      t = "Denture", n = it("medic-web-engine.reconWorkflowDentureFromTeethLibrary");
      break;
    case Ue.eWF_DENTURE_FROM_COPY:
      t = "Denture", n = it("medic-web-engine.reconWorkflowDentureFromCopy");
      break;
  }
  return { retValue: t, comment: n };
};
function Yn(e) {
  const t = [];
  for (let n = 0; n < e.size(); n++)
    t.push({ name: e.get(n) });
  return t;
}
function vL(e, t) {
  const n = Wn(e.getContextCAD().GetXAddReconstructionObject());
  t[
    0
    /* eDI_MODEL_ANTAGONIST */
  ].items = Yn(n.GetObjectsList(et.eANTAGONIST)), t[
    0
    /* eDI_MODEL_ANTAGONIST */
  ].selectedItem = { name: n.GetSelectedObject(et.eANTAGONIST) }, t[
    1
    /* eDI_GINGIVA_ANTAGONIST */
  ].items = Yn(n.GetObjectsList(et.eGINGIVA_ANTAGONIST)), t[
    1
    /* eDI_GINGIVA_ANTAGONIST */
  ].selectedItem = { name: n.GetSelectedObject(et.eGINGIVA_ANTAGONIST) }, t[
    2
    /* eDI_WAXUP_ANTAGONIST */
  ].items = Yn(n.GetObjectsList(et.eWAXUP_ANTAGONIST)), t[
    2
    /* eDI_WAXUP_ANTAGONIST */
  ].selectedItem = { name: n.GetSelectedObject(et.eWAXUP_ANTAGONIST) }, t[
    3
    /* eDI_MARKER_ANTAGONIST */
  ].items = Yn(n.GetObjectsList(et.eMARKER_ANTAGONIST)), t[
    3
    /* eDI_MARKER_ANTAGONIST */
  ].selectedItem = { name: n.GetSelectedObject(et.eMARKER_ANTAGONIST) }, t[
    4
    /* eDI_DENTURE_ANTAGONIST */
  ].items = Yn(n.GetObjectsList(et.eDENTURE_ANTAGONIST)), t[
    4
    /* eDI_DENTURE_ANTAGONIST */
  ].selectedItem = { name: n.GetSelectedObject(et.eDENTURE_ANTAGONIST) }, t[
    5
    /* eDI_FACE_SCAN */
  ].items = Yn(n.GetObjectsList(et.eFACE_SCAN)), t[
    5
    /* eDI_FACE_SCAN */
  ].selectedItem = { name: n.GetSelectedObject(et.eFACE_SCAN) }, t[
    6
    /* eDI_MODEL */
  ].items = Yn(n.GetObjectsList(et.eMODEL)), t[
    6
    /* eDI_MODEL */
  ].selectedItem = { name: n.GetSelectedObject(et.eMODEL) }, t[
    7
    /* eDI_GINGIVA */
  ].items = Yn(n.GetObjectsList(et.eGINGIVA)), t[
    7
    /* eDI_GINGIVA */
  ].selectedItem = { name: n.GetSelectedObject(et.eGINGIVA) }, t[
    8
    /* eDI_WAXUP */
  ].items = Yn(n.GetObjectsList(et.eWAXUP)), t[
    8
    /* eDI_WAXUP */
  ].selectedItem = { name: n.GetSelectedObject(et.eWAXUP) }, t[
    9
    /* eDI_MARKER */
  ].items = Yn(n.GetObjectsList(et.eMARKER)), t[
    9
    /* eDI_MARKER */
  ].selectedItem = { name: n.GetSelectedObject(et.eMARKER) }, t[
    10
    /* eDI_DENTURE */
  ].items = Yn(n.GetObjectsList(et.eDENTURE)), t[
    10
    /* eDI_DENTURE */
  ].selectedItem = { name: n.GetSelectedObject(et.eDENTURE) }, t[
    11
    /* eDI_MOVEMENT_MARKER */
  ].items = Yn(n.GetObjectsList(et.eMOVEMENT_MARKER)), t[
    11
    /* eDI_MOVEMENT_MARKER */
  ].selectedItem = { name: n.GetSelectedObject(et.eMOVEMENT_MARKER) };
}
async function df(e, t, n, a, o = ma.eNONE, l = nh.eNONE, s) {
  const i = t;
  let u = !0;
  function c(k) {
    return k === Xt.MANDIBLE ? rs(e.settings.general.useUSStyleToothChart) : us(e.settings.general.useUSStyleToothChart);
  }
  const p = c(Xt.MAXILLA).map((k, M) => ({
    id: M + 1,
    editMode: Ea.NO_EDIT,
    status: pt.EMPTY,
    hoverIcon: Mn.ADD,
    toothName: k
  })), h = c(Xt.MANDIBLE).map((k, M) => ({
    id: M + 1,
    editMode: Ea.NO_EDIT,
    status: pt.EMPTY,
    hoverIcon: Mn.ADD,
    toothName: k
  })), g = (k) => {
    console.log("fillTeethOption", k, k.size());
    for (let M = 0; M < k.size(); M++) {
      const z = k.get(M);
      console.log("tooth name:", z);
      const j = p.find((x) => x.toothName == z);
      j && (j.status = pt.OK, j.hoverIcon = Mn.REMOVE);
      const K = h.find((x) => x.toothName == z);
      K && (K.status = pt.OK, K.hoverIcon = Mn.REMOVE);
    }
  };
  let b = rf.value.get(t) + " " + a, E = it("implant-planner.selectOperativeTeethInstructions"), m = b;
  o == ma.eCREATE_WAXUP && (b = it("implant-planner.createWaxup"), E = it("implant-planner.addWaxupInstructions"), m = "Waxup"), m = e.module.xAddReconstructionWasm.GetValidReconstructionName(m);
  const I = Wn(e.getContextCAD().GetXAddReconstructionObject());
  console.log("xAddRecon", I), I.PrepareDialog(o, l);
  const S = e.getContextCAD().mPrevReconstructionType;
  i == ge.eRD_MODEL_BUILDER ? (I.FillReconstruction(), I.FillAntagonistReconstruction()) : ([ge.eRD_ORTHODONTIC_MODEL_BUILDER, ge.eRD_BITE_SPLINT, ge.eRD_MODEL_PRO].includes(i) || S && [
    ge.eRD_MODEL_BUILDER,
    ge.eRD_ORTHODONTIC_MODEL_BUILDER,
    ge.eRD_BITE_SPLINT,
    ge.eRD_MODEL_PRO
  ].includes(S)) && (I.FillModel(null), I.FillAntagonist(null));
  const f = {
    0: {
      visible: !0,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    1: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    2: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    3: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    4: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    5: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    6: { visible: !0, showImportBtn: !0, selectedItem: null, items: [{ name: "" }] },
    7: { visible: !1, showImportBtn: !0, selectedItem: null, items: [{ name: "" }] },
    8: { visible: !1, showImportBtn: !0, selectedItem: null, items: [{ name: "" }] },
    9: { visible: !1, showImportBtn: !0, selectedItem: null, items: [{ name: "" }] },
    10: { visible: !1, showImportBtn: !0, selectedItem: null, items: [{ name: "" }] },
    11: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    12: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    },
    13: {
      visible: !1,
      showImportBtn: !0,
      selectedItem: null,
      items: [{ name: "" }]
    }
  };
  f[
    2
    /* eDI_WAXUP_ANTAGONIST */
  ].visible = !1, f[
    1
    /* eDI_GINGIVA_ANTAGONIST */
  ].visible = !1, f[
    3
    /* eDI_MARKER_ANTAGONIST */
  ].visible = !1, f[
    10
    /* eDI_DENTURE */
  ].visible = !1, f[
    4
    /* eDI_DENTURE_ANTAGONIST */
  ].visible = !1, f[
    13
    /* eDI_LOWER_GENERIC */
  ].visible = i == ge.eRD_TMJ_DIAGNOSIS, f[
    12
    /* eDI_UPPER_GENERIC */
  ].visible = i == ge.eRD_TMJ_DIAGNOSIS, f[
    6
    /* eDI_MODEL */
  ].showImportBtn = i != ge.eRD_MODEL_BUILDER, f[
    0
    /* eDI_MODEL_ANTAGONIST */
  ].showImportBtn = i != ge.eRD_MODEL_BUILDER;
  let v = !1;
  switch (i) {
    case ge.eRD_CROWN_BRIDGE:
    case ge.eRD_BAR:
    case ge.eRD_PRE_OP:
      v = !0, f[
        8
        /* eDI_WAXUP */
      ].visible = !0, f[
        9
        /* eDI_MARKER */
      ].visible = !0, f[
        11
        /* eDI_MOVEMENT_MARKER */
      ].visible = !0, f[
        5
        /* eDI_FACE_SCAN */
      ].visible = !0, f[
        7
        /* eDI_GINGIVA */
      ].visible = !0;
      break;
    case ge.eRD_IL_PROVISIONAL: {
      f[
        9
        /* eDI_MARKER */
      ].visible = !1, f[
        11
        /* eDI_MOVEMENT_MARKER */
      ].visible = !1, f[
        5
        /* eDI_FACE_SCAN */
      ].visible = !1, v = !0, I.FillTeeth(), g(I.GetTeethList());
      break;
    }
    case ge.eRD_DENTURE:
    case ge.eRD_MODEL_BUILDER:
    case ge.eRD_ORTHODONTIC_MODEL_BUILDER:
    case ge.eRD_BITE_SPLINT:
    case ge.eRD_DIGITAL_SMILE_DESIGN:
    case ge.eRD_TMJ_DIAGNOSIS: {
      f[
        8
        /* eDI_WAXUP */
      ].visible = [ge.eRD_TMJ_DIAGNOSIS].includes(i), f[
        2
        /* eDI_WAXUP_ANTAGONIST */
      ].visible = [ge.eRD_TMJ_DIAGNOSIS].includes(i), f[
        9
        /* eDI_MARKER */
      ].visible = [ge.eRD_TMJ_DIAGNOSIS].includes(i), f[
        3
        /* eDI_MARKER_ANTAGONIST */
      ].visible = [ge.eRD_TMJ_DIAGNOSIS].includes(i), f[
        11
        /* eDI_MOVEMENT_MARKER */
      ].visible = [
        ge.eRD_DIGITAL_SMILE_DESIGN,
        ge.eRD_BITE_SPLINT,
        ge.eRD_TMJ_DIAGNOSIS,
        ge.eRD_DENTURE
      ].includes(i), f[
        5
        /* eDI_FACE_SCAN */
      ].visible = [
        ge.eRD_DIGITAL_SMILE_DESIGN,
        ge.eRD_TMJ_DIAGNOSIS,
        ge.eRD_DENTURE
      ].includes(i), f[
        7
        /* eDI_GINGIVA */
      ].visible = [ge.eRD_TMJ_DIAGNOSIS].includes(i), f[
        1
        /* eDI_GINGIVA_ANTAGONIST */
      ].visible = [ge.eRD_TMJ_DIAGNOSIS].includes(i), v = [
        ge.eRD_DENTURE,
        ge.eRD_BITE_SPLINT,
        ge.eRD_DIGITAL_SMILE_DESIGN,
        ge.eRD_TMJ_DIAGNOSIS
      ].includes(i), u = [
        ge.eRD_DENTURE,
        ge.eRD_BITE_SPLINT,
        ge.eRD_DIGITAL_SMILE_DESIGN,
        ge.eRD_TMJ_DIAGNOSIS
      ].includes(i);
      break;
    }
    case ge.eRD_MODEL_PRO: {
      f[
        8
        /* eDI_WAXUP */
      ].visible = !1, f[
        9
        /* eDI_MARKER */
      ].visible = !0, f[
        3
        /* eDI_MARKER_ANTAGONIST */
      ].visible = !0, f[
        11
        /* eDI_MOVEMENT_MARKER */
      ].visible = !1, f[
        5
        /* eDI_FACE_SCAN */
      ].visible = !1, f[
        7
        /* eDI_GINGIVA */
      ].visible = !1, v = !0;
      break;
    }
  }
  if (n != Ue.eWF_NONE)
    switch (f[
      2
      /* eDI_WAXUP_ANTAGONIST */
    ].visible = !1, f[
      1
      /* eDI_GINGIVA_ANTAGONIST */
    ].visible = !1, f[
      3
      /* eDI_MARKER_ANTAGONIST */
    ].visible = !1, f[
      10
      /* eDI_DENTURE */
    ].visible = !1, f[
      4
      /* eDI_DENTURE_ANTAGONIST */
    ].visible = !1, n) {
      case Ue.eWF_I_L_EGG_SHELL:
      case Ue.eWF_C_B_TEETH_LIBRARY:
      case Ue.eWF_C_B_MANUAL_IMPLANT:
      case Ue.eWF_C_B_MOCKUP:
      case Ue.eWF_C_B_DIGITAL_WAXUP:
      case Ue.eWF_EGG_SHELL_PRE_OP:
      case Ue.eWF_THIMBLE_PRE_OP: {
        f[
          8
          /* eDI_WAXUP */
        ].visible = !1, f[
          9
          /* eDI_MARKER */
        ].visible = !1, f[
          7
          /* eDI_GINGIVA */
        ].visible = n != Ue.eWF_C_B_DIGITAL_WAXUP, f[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = n == Ue.eWF_EGG_SHELL_PRE_OP || n == Ue.eWF_THIMBLE_PRE_OP || n == Ue.eWF_I_L_EGG_SHELL;
        break;
      }
      case Ue.eWF_BAR_MANUAL_IMPLANT: {
        f[
          8
          /* eDI_WAXUP */
        ].visible = !0, f[
          2
          /* eDI_WAXUP_ANTAGONIST */
        ].visible = !0, f[
          9
          /* eDI_MARKER */
        ].visible = !1, f[
          7
          /* eDI_GINGIVA */
        ].visible = !1, f[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case Ue.eWF_BAR_IMPLANT_LIBRARY: {
        f[
          8
          /* eDI_WAXUP */
        ].visible = !0, f[
          2
          /* eDI_WAXUP_ANTAGONIST */
        ].visible = !0, f[
          9
          /* eDI_MARKER */
        ].visible = !0, f[
          3
          /* eDI_MARKER_ANTAGONIST */
        ].visible = !0, f[
          7
          /* eDI_GINGIVA */
        ].visible = !0, f[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case Ue.eWF_I_O_TEETH_LIBRARY: {
        f[
          8
          /* eDI_WAXUP */
        ].visible = !1, f[
          9
          /* eDI_MARKER */
        ].visible = !1, f[
          7
          /* eDI_GINGIVA */
        ].visible = !0, f[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case Ue.eWF_C_B_HYBRID: {
        f[
          8
          /* eDI_WAXUP */
        ].visible = !1, f[
          9
          /* eDI_MARKER */
        ].visible = !0, f[
          3
          /* eDI_MARKER_ANTAGONIST */
        ].visible = !0, f[
          7
          /* eDI_GINGIVA */
        ].visible = !0, f[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case Ue.eWF_C_B_BELLAK_ABUTMENT: {
        f[
          8
          /* eDI_WAXUP */
        ].visible = !1, f[
          9
          /* eDI_MARKER */
        ].visible = !0, f[
          3
          /* eDI_MARKER_ANTAGONIST */
        ].visible = !0, f[
          7
          /* eDI_GINGIVA */
        ].visible = !0, f[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case Ue.eWF_C_B_HYBRID_WAXUP: {
        f[
          8
          /* eDI_WAXUP */
        ].visible = !0, f[
          2
          /* eDI_WAXUP_ANTAGONIST */
        ].visible = !0, f[
          9
          /* eDI_MARKER */
        ].visible = !0, f[
          3
          /* eDI_MARKER_ANTAGONIST */
        ].visible = !0, f[
          7
          /* eDI_GINGIVA */
        ].visible = !0, f[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case Ue.eWF_C_B_IMPLANT_LIBRARY: {
        f[
          8
          /* eDI_WAXUP */
        ].visible = !1, f[
          9
          /* eDI_MARKER */
        ].visible = !0;
        break;
      }
      case Ue.eWF_C_B_IMPLANT_LIBRARY_WAXUP:
      case Ue.eWF_C_B_IMPLANT_LIBRARY_LOCATOR_WAXUP:
      case Ue.eWF_C_B_IMPLANT_LIBRARY_IMPLANT_WAXUP:
      case Ue.eWF_SCANNED_STRUCTURE: {
        f[
          8
          /* eDI_WAXUP */
        ].visible = !0, f[
          2
          /* eDI_WAXUP_ANTAGONIST */
        ].visible = !0, f[
          9
          /* eDI_MARKER */
        ].visible = n != Ue.eWF_SCANNED_STRUCTURE, f[
          3
          /* eDI_MARKER_ANTAGONIST */
        ].visible = n != Ue.eWF_SCANNED_STRUCTURE, f[
          7
          /* eDI_GINGIVA */
        ].visible = !0, f[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = !0;
        break;
      }
      case Ue.eWF_I_L_WAXUP:
        I.FillTeeth(), g(I.GetTeethList());
      case Ue.eWF_I_L_EGG_SHELL_WAXUP:
        f[
          7
          /* eDI_GINGIVA */
        ].visible = n != Ue.eWF_I_L_WAXUP, f[
          1
          /* eDI_GINGIVA_ANTAGONIST */
        ].visible = n != Ue.eWF_I_L_WAXUP, f[
          2
          /* eDI_WAXUP_ANTAGONIST */
        ].visible = !0, u = n != Ue.eWF_I_L_WAXUP;
      case Ue.eWF_C_B_WAXUP:
      case Ue.eWF_C_B_MANUAL_IMPLANT_WAXUP: {
        f[
          8
          /* eDI_WAXUP */
        ].visible = !0, f[
          9
          /* eDI_MARKER */
        ].visible = !1;
        break;
      }
      case Ue.eWF_DENTURE_FROM_COPY: {
        f[
          10
          /* eDI_DENTURE */
        ].visible = !0, f[
          4
          /* eDI_DENTURE_ANTAGONIST */
        ].visible = !0;
        break;
      }
    }
  e.getContextCAD().mPrevReconstructionType = i, I.UpdateVisibility(), vL(e, f);
  const w = await up(s);
  let A = "", T = "", O = "";
  return w.length && (A = w[0].label, T = w[0].modelName, O = w[0].guid), {
    setupParams: {
      headerText: b,
      instructionsText: E,
      reconstructionName: m,
      selectTeethLibrary: !0,
      selectedTeethLibrary: A,
      selectedTeethLibraryModelName: T,
      selectedTeethLibraryGUID: O,
      dropdownItems: f,
      teethMapEnabled: u,
      maxillaTeeth: p,
      mandibleTeeth: h
    },
    smileParams: i == ge.eRD_DIGITAL_SMILE_DESIGN,
    productionParams: v && o != ma.eCREATE_WAXUP && o != ma.eTMJ_DIAGNOSIS
  };
}
async function yL(e) {
  let t = {
    0: { label: kl(qa[
      0
      /* eP_LEFT */
    ].label, "Left"), iconSrc: qa[
      0
      /* eP_LEFT */
    ].iconSrc, items: [] },
    1: { label: kl(qa[
      1
      /* eP_FRONT */
    ].label, "Front"), iconSrc: qa[
      1
      /* eP_FRONT */
    ].iconSrc, items: [] },
    2: { label: kl(qa[
      2
      /* eP_RIGHT */
    ].label, "Right"), iconSrc: qa[
      2
      /* eP_RIGHT */
    ].iconSrc, items: [] },
    3: { label: kl(qa[
      3
      /* eP_TOP */
    ].label, "Top"), iconSrc: qa[
      3
      /* eP_TOP */
    ].iconSrc, items: [] }
  };
  for (const [a, o] of e.getObjects().images2D) {
    const l = e.viewConfiguration.colorScheme.get(), s = await Bi(o, !0, l);
    switch (o.cadType) {
      case St.eOT_TEXTURED_LEFT_IMAGE:
        t[
          0
          /* eP_LEFT */
        ].items.push({ id: a, preview: s, selected: !0 });
        break;
      case St.eOT_TEXTURED_FRONT_IMAGE:
        t[
          1
          /* eP_FRONT */
        ].items.push({ id: a, preview: s, selected: !0 });
        break;
      case St.eOT_TEXTURED_RIGHT_IMAGE:
        t[
          2
          /* eP_RIGHT */
        ].items.push({ id: a, preview: s, selected: !0 });
        break;
      case St.eOT_TEXTURED_TOP_IMAGE:
        t[
          3
          /* eP_TOP */
        ].items.push({ id: a, preview: s, selected: !0 });
        break;
    }
  }
  const n = Wn(e.getContextCAD().GetXAddReconstructionObject());
  for (let a of [
    St.eOT_TEXTURED_LEFT_IMAGE,
    St.eOT_TEXTURED_RIGHT_IMAGE,
    St.eOT_TEXTURED_TOP_IMAGE,
    St.eOT_TEXTURED_FRONT_IMAGE
  ]) {
    const o = n.GetImages(a);
    let l = 1;
    switch (a) {
      case St.eOT_TEXTURED_LEFT_IMAGE:
        l = 0;
        break;
      case St.eOT_TEXTURED_RIGHT_IMAGE:
        l = 2;
        break;
      case St.eOT_TEXTURED_TOP_IMAGE:
        l = 3;
        break;
      case St.eOT_TEXTURED_FRONT_IMAGE:
        l = 1;
        break;
      default:
        continue;
    }
    for (let s = 0; s < o.size(); s++) {
      const i = o.get(s);
      t[l].items.push({ id: i.id, preview: "data:image/png;base64," + i.preview, selected: !0 });
    }
  }
  return t;
}
async function pf(e) {
  return await yL(e);
}
function mf(e, t, n) {
  const a = [], o = (l) => {
    const s = (i) => l.includes(i);
    switch (e) {
      case ge.eRD_CROWN_BRIDGE:
      case ge.eRD_BAR:
      case ge.eRD_PRE_OP:
      case ge.eRD_IL_PROVISIONAL:
        switch (t) {
          case Ue.eWF_C_B_HYBRID:
            return s(20);
          case Ue.eWF_C_B_HYBRID_WAXUP:
            return s(21);
          case Ue.eWF_I_O_TEETH_LIBRARY:
            return s(22);
          case Ue.eWF_C_B_DIGITAL_WAXUP:
            return s(23);
          case Ue.eWF_C_B_BELLAK_ABUTMENT:
            return s(24);
          case Ue.eWF_BAR_MANUAL_IMPLANT:
            return s(25);
          case Ue.eWF_BAR_IMPLANT_LIBRARY:
            return s(26);
          case Ue.eWF_C_B_IMPLANT_LIBRARY_LOCATOR_WAXUP:
            return s(27);
          case Ue.eWF_C_B_IMPLANT_LIBRARY_IMPLANT_WAXUP:
            return s(28);
          case Ue.eWF_EGG_SHELL_PRE_OP:
            return s(29);
          case Ue.eWF_THIMBLE_PRE_OP:
            return s(30);
          case Ue.eWF_I_L_WAXUP:
            return s(31);
          case Ue.eWF_I_L_EGG_SHELL:
            return s(32);
          case Ue.eWF_I_L_EGG_SHELL_WAXUP:
            return s(33);
          case Ue.eWF_SCANNED_STRUCTURE:
            return s(34);
          default:
            return !1;
        }
      case ge.eRD_DIGITAL_SMILE_DESIGN:
      case ge.eRD_DENTURE:
      case ge.eRD_TMJ_DIAGNOSIS:
      case ge.eRD_MODEL_BUILDER:
      case ge.eRD_ORTHODONTIC_MODEL_BUILDER:
      case ge.eRD_BITE_SPLINT:
      case ge.eRD_MODEL_PRO:
        return s(e);
      default:
        return !1;
    }
  };
  for (const l of n)
    for (const s of l.materials)
      o(s.reconstructionDesigns) && a.push({
        name: s.name,
        productionCenterId: l.id,
        materialId: s.id || -1
      });
  return a;
}
function _L(e, t, n) {
  const a = [], o = n.find((l) => l.id == e);
  if (o) {
    const l = o.materials.find((s) => s.id == t);
    if (l && l.colors)
      for (let s = 0; s < l.colors.length; s++)
        a.push({ name: l.colors[s] });
  }
  return a;
}
function wL(e, t, n) {
  return [];
}
const IL = {
  class: "p-dialog-header text-4xl",
  style: { "justify-content": "center !important" }
}, SL = { class: "flex flex-row-wrap grow gap-4 justify-center mt-4" }, EL = {
  class: "wrapper-element",
  style: { "z-index": "1000" }
}, TL = { class: "ml-2 font-bold text-xl" }, CL = ["onMouseover", "onClick"], NL = { class: "flex flex-row-wrap grow justify-center mt-4" }, LL = /* @__PURE__ */ Je({
  __name: "ReconstructionTypeSelection",
  props: {
    context: {},
    preselectedType: {}
  },
  emits: ["typeSelected", "modifyType"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = uf(), l = B(null), s = sa(), i = document.createElement("div");
    Dt(() => {
      n.context;
      const E = document.getElementById("commentContainer");
      if (E ? E.appendChild(i) : console.log("commentContainer does not exist"), n.preselectedType == ma.eCREATE_WAXUP) {
        const m = o.find((I) => I.reconstructionDesign == ge.eRD_DIGITAL_SMILE_DESIGN);
        m && b(m);
      }
    });
    const u = Ce(() => n.preselectedType == ma.eCREATE_WAXUP ? "Create Waxup" : l.value != null ? l.value.name : "Select Reconstruction Type");
    Ce(() => l.value != null ? "text-2xl" : "text-4xl");
    const c = Ce(() => l.value == null ? "col-span-12" : "col-span-3"), p = (E) => {
      i.innerHTML = E;
    }, h = () => {
      l.value || (i.innerHTML = "");
    }, g = () => {
      l.value = null, a("modifyType");
    }, b = (E) => {
      l.value = E, p(E.comment), a("typeSelected", E.reconstructionDesign);
    };
    return (E, m) => {
      const I = Au;
      return L(), be(r(we), {
        class: Ge([c.value, "flex-col"]),
        style: { overflow: "auto" }
      }, {
        default: _(() => [
          y("div", IL, U(u.value), 1),
          r(l) ? (L(), be(r(we), { key: 1 }, {
            default: _(() => [
              y("div", NL, [
                d(I, {
                  alt: r(l).name,
                  src: r(s).getAssetUrl(r(l).imageSrc),
                  "image-class": "large-image",
                  pt: {
                    image: {
                      style: {
                        background: "transparent !important",
                        maxHeight: "17rem",
                        borderRadius: "8px"
                      }
                    },
                    previewMask: {
                      style: {
                        borderRadius: "8px"
                      }
                    }
                  }
                }, null, 8, ["alt", "src"])
              ])
            ]),
            _: 1
          })) : (L(), be(r(we), {
            key: 0,
            class: "overflow-auto"
          }, {
            default: _(() => [
              y("div", SL, [
                (L(!0), H(He, null, jt(r(o), (S, f) => (L(), H("div", {
                  class: "item-element",
                  key: f
                }, [
                  y("div", EL, [
                    y("span", TL, U(S.name), 1)
                  ]),
                  d(I, {
                    alt: S.name,
                    src: r(s).getAssetUrl(S.imageSrc),
                    "image-class": "small-image",
                    style: { width: "100%", height: "auto" },
                    preview: "",
                    pt: {
                      image: {
                        style: {
                          background: "transparent !important",
                          maxHeight: "17rem",
                          borderRadius: "8px"
                        }
                      },
                      previewMask: {
                        style: {
                          borderRadius: "8px"
                        }
                      }
                    }
                  }, {
                    indicatoricon: _(() => [
                      y("div", {
                        class: "w-full h-full flex flex-col justify-start",
                        onMouseover: (v) => p(S.comment),
                        onMouseleave: h,
                        onClick: (v) => b(S)
                      }, null, 40, CL)
                    ]),
                    _: 2
                  }, 1032, ["alt", "src"])
                ]))), 128))
              ])
            ]),
            _: 1
          })),
          m[1] || (m[1] = y("div", {
            id: "commentContainer",
            class: "flex justify-center mt-2",
            style: { "min-height": "20vh", "white-space": "pre-wrap", top: "auto" }
          }, null, -1)),
          d(r(we), {
            class: "justify-center",
            style: { "margin-top": "auto" }
          }, {
            default: _(() => [
              r(l) ? (L(), be(r(Ne), {
                key: 0,
                disabled: e.preselectedType != null,
                class: "btn-wizard-lg",
                label: "Modify Reconstruction Type",
                onClick: m[0] || (m[0] = (S) => g())
              }, null, 8, ["disabled"])) : ue("", !0)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]);
    };
  }
}), ff = /* @__PURE__ */ Vt(LL, [["__scopeId", "data-v-401810ef"]]), OL = {
  class: "p-dialog-header text-4xl",
  style: { "justify-content": "center !important" }
}, DL = { class: "flex flex-row-wrap grow gap-4 justify-center mt-4" }, AL = { class: "grow" }, RL = {
  class: "wrapper-element",
  style: { "z-index": "1000" }
}, ML = { class: "ml-2 font-bold text-sm" }, PL = ["onMouseover", "onClick"], xL = { class: "flex flex-row-wrap grow col-span-12 justify-center mt-4" }, jL = /* @__PURE__ */ Je({
  __name: "WorkflowSelection",
  props: {
    reconstructionType: {}
  },
  emits: ["workflowSelected", "modifyWorkflow"],
  setup(e, { emit: t }) {
    const n = e, a = B([]), o = B(null), l = document.createElement("div"), s = Ce(() => o.value != null ? o.value.name : "Select Workflow");
    Ce(() => (o.value != null, "text-2xl justify-center")), Dt(() => {
      const g = document.getElementById("commentContainerWorkflow");
      g ? g.appendChild(l) : console.log("commentContainer does not exist"), console.log("reconstructionType", n.reconstructionType), a.value = hL(n.reconstructionType), a.value.length || i("workflowSelected", Ue.eWF_NONE, "");
    });
    const i = t, u = (g) => {
      l.innerHTML = g;
    }, c = () => {
      o.value || (l.innerHTML = "");
    }, p = () => {
      o.value = null, i("modifyWorkflow");
    }, h = (g) => {
      o.value = g, u(g.comment), i("workflowSelected", g.workflow, g.name);
    };
    return (g, b) => {
      const E = Au;
      return Pt((L(), be(r(we), {
        class: "flex-col col-span-3",
        style: { overflow: "auto" }
      }, {
        default: _(() => [
          y("div", OL, U(s.value), 1),
          r(o) ? (L(), be(r(we), { key: 1 }, {
            default: _(() => [
              y("div", xL, [
                d(E, {
                  alt: r(o).name,
                  src: r(o).imageSrc,
                  "image-class": "large-image",
                  pt: {
                    image: {
                      style: {
                        background: "transparent !important",
                        maxHeight: "17rem",
                        borderRadius: "8px"
                      }
                    },
                    previewMask: {
                      style: {
                        borderRadius: "8px"
                      }
                    }
                  }
                }, null, 8, ["alt", "src"])
              ])
            ]),
            _: 1
          })) : (L(), be(r(we), {
            key: 0,
            class: "overflow-auto"
          }, {
            default: _(() => [
              y("div", DL, [
                (L(!0), H(He, null, jt(r(a), (m, I) => (L(), H("div", {
                  class: "item-element",
                  key: I
                }, [
                  y("div", AL, [
                    y("div", RL, [
                      y("span", ML, U(m.name), 1)
                    ]),
                    d(E, {
                      alt: m.name,
                      src: m.imageSrc,
                      preview: "",
                      "image-class": "small-image",
                      style: { width: "100%", height: "auto" },
                      pt: {
                        image: {
                          style: {
                            background: "transparent !important",
                            maxHeight: "17rem",
                            borderRadius: "8px"
                          }
                        },
                        previewMask: {
                          style: {
                            borderRadius: "8px"
                          }
                        }
                      }
                    }, {
                      indicatoricon: _(() => [
                        y("div", {
                          class: "w-full h-full flex flex-col justify-start",
                          onMouseover: (S) => u(m.comment),
                          onMouseleave: c,
                          onClick: (S) => h(m)
                        }, null, 40, PL)
                      ]),
                      _: 2
                    }, 1032, ["alt", "src"])
                  ])
                ]))), 128))
              ])
            ]),
            _: 1
          })),
          b[1] || (b[1] = y("div", {
            id: "commentContainerWorkflow",
            class: "flex justify-center mt-2",
            style: { "min-height": "20vh", "white-space": "pre-wrap", top: "auto" }
          }, null, -1)),
          d(r(we), {
            class: "justify-center",
            style: { "margin-top": "auto" }
          }, {
            default: _(() => [
              d(r(Ne), {
                class: "btn-wizard-lg",
                disabled: !r(o),
                label: "Modify Workflow",
                onClick: b[0] || (b[0] = (m) => p())
              }, null, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)), [
        [ln, r(a).length]
      ]);
    };
  }
}), gf = /* @__PURE__ */ Vt(jL, [["__scopeId", "data-v-a87293d3"]]), $L = /* @__PURE__ */ Je({
  __name: "ReconstructionSetupDialog",
  emits: ["confirm", "reject"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data;
    let o, l;
    const s = ia();
    Dt(async () => {
      o = a.context;
      const { data: v } = await s.getProductionCentersFullInfo();
      l = v;
    });
    const i = t, u = B(null), c = B(null), p = (v) => {
      console.log("Selected type", v), u.value = v;
    }, h = () => {
      u.value = null, c.value = null;
    }, g = B({
      headerText: "",
      instructionsText: "",
      reconstructionName: "",
      selectTeethLibrary: !0,
      selectedTeethLibrary: "",
      selectedTeethLibraryModelName: "",
      selectedTeethLibraryGUID: "",
      dropdownItems: {
        [$e.eDI_MODEL_ANTAGONIST]: { visible: !0, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_GINGIVA_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_WAXUP_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_MARKER_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_DENTURE_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_FACE_SCAN]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_MODEL]: { visible: !0, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_GINGIVA]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_WAXUP]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_MARKER]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_DENTURE]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_MOVEMENT_MARKER]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_UPPER_GENERIC]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_LOWER_GENERIC]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] }
      },
      teethMapEnabled: !0,
      maxillaTeeth: [],
      mandibleTeeth: []
    }), b = B(null), E = B(null), m = async (v, w) => {
      if (console.log("Workflow Selected type", v), c.value = v, u.value != null && c.value != null) {
        const A = await df(o, u.value, c.value, w, a.preselectedMode, a.preselectedWorkFlow, s);
        if (g.value = A.setupParams, A.smileParams && um() ? b.value = await pf(o) : b.value = null, A.productionParams) {
          const T = mf(u.value, c.value, l);
          console.log("LibItems", T), E.value = {
            materialLibrary: {
              selectedItem: null,
              items: T
            },
            color: {
              selectedItem: null,
              items: []
            },
            presetLibrary: {
              selectedItem: null,
              items: []
            }
          };
        } else
          E.value = null;
      }
    }, I = () => {
      c.value = null;
    };
    lt(g.value.dropdownItems[$e.eDI_MODEL], () => {
      console.log("setupParams.value.dropdownItems[TDropdownItem.eDI_MODEL] changed", g.value.dropdownItems[$e.eDI_MODEL]);
    });
    const S = async () => {
      console.log("ReconstructionDialog proceed 0");
      const v = Wn(o.getContextCAD().GetXAddReconstructionObject());
      v.SetModeWorkflowName(u.value, c.value, g.value.reconstructionName);
      let w = g.value.dropdownItems[$e.eDI_MODEL_ANTAGONIST].selectedItem, A = g.value.dropdownItems[$e.eDI_MODEL_ANTAGONIST].visible;
      v.SelectedSelectionChanged(w ? w.name : "", A, et.eANTAGONIST), w = g.value.dropdownItems[$e.eDI_GINGIVA_ANTAGONIST].selectedItem, A = g.value.dropdownItems[$e.eDI_GINGIVA_ANTAGONIST].visible, v.SelectedSelectionChanged(w ? w.name : "", A, et.eGINGIVA_ANTAGONIST), w = g.value.dropdownItems[$e.eDI_WAXUP_ANTAGONIST].selectedItem, A = g.value.dropdownItems[$e.eDI_WAXUP_ANTAGONIST].visible, v.SelectedSelectionChanged(w ? w.name : "", A, et.eWAXUP_ANTAGONIST), w = g.value.dropdownItems[$e.eDI_MARKER_ANTAGONIST].selectedItem, A = g.value.dropdownItems[$e.eDI_MARKER_ANTAGONIST].visible, v.SelectedSelectionChanged(w ? w.name : "", A, et.eMARKER_ANTAGONIST), w = g.value.dropdownItems[$e.eDI_DENTURE_ANTAGONIST].selectedItem, A = g.value.dropdownItems[$e.eDI_DENTURE_ANTAGONIST].visible, v.SelectedSelectionChanged(w ? w.name : "", A, et.eDENTURE_ANTAGONIST), w = g.value.dropdownItems[$e.eDI_FACE_SCAN].selectedItem, A = g.value.dropdownItems[$e.eDI_FACE_SCAN].visible, v.SelectedSelectionChanged(w ? w.name : "", A, et.eFACE_SCAN), w = g.value.dropdownItems[$e.eDI_MODEL].selectedItem, A = g.value.dropdownItems[$e.eDI_MODEL].visible, v.SelectedSelectionChanged(w ? w.name : "", A, et.eMODEL), w = g.value.dropdownItems[$e.eDI_GINGIVA].selectedItem, A = g.value.dropdownItems[$e.eDI_GINGIVA].visible, v.SelectedSelectionChanged(w ? w.name : "", A, et.eGINGIVA), w = g.value.dropdownItems[$e.eDI_WAXUP].selectedItem, A = g.value.dropdownItems[$e.eDI_WAXUP].visible, v.SelectedSelectionChanged(w ? w.name : "", A, et.eWAXUP), w = g.value.dropdownItems[$e.eDI_MARKER].selectedItem, A = g.value.dropdownItems[$e.eDI_MARKER].visible, v.SelectedSelectionChanged(w ? w.name : "", A, et.eMARKER), w = g.value.dropdownItems[$e.eDI_DENTURE].selectedItem, A = g.value.dropdownItems[$e.eDI_DENTURE].visible, v.SelectedSelectionChanged(w ? w.name : "", A, et.eDENTURE), w = g.value.dropdownItems[$e.eDI_MOVEMENT_MARKER].selectedItem, A = g.value.dropdownItems[$e.eDI_MOVEMENT_MARKER].visible, console.log("Movement maker selected name: ", w), v.SelectedSelectionChanged(w ? w.name : "", A, et.eMOVEMENT_MARKER);
      const T = new o.module.VectorString(), O = g.value.dropdownItems[$e.eDI_UPPER_GENERIC].selectedItem;
      if (A = g.value.dropdownItems[$e.eDI_UPPER_GENERIC].visible, O)
        if (Array.isArray(O))
          for (const j of O)
            T.push_back(j.name);
        else
          T.push_back(O.name);
      v.SelectedGenericSelectionChanged(T, A, et.eGENERIC_UPPER), T.delete();
      const C = new o.module.VectorString(), k = g.value.dropdownItems[$e.eDI_LOWER_GENERIC].selectedItem;
      if (A = g.value.dropdownItems[$e.eDI_LOWER_GENERIC].visible, k)
        if (Array.isArray(k))
          for (const j of k)
            C.push_back(j.name);
        else
          C.push_back(k.name);
      v.SelectedGenericSelectionChanged(C, A, et.eGENERIC_LOWER), C.delete(), console.log("ReconstructionDialog proceed 1");
      const M = new o.module.VectorString();
      for (const j of g.value.mandibleTeeth)
        j.status != ItemStatus.EMPTY && M.push_back(j.toothName);
      for (const j of g.value.maxillaTeeth)
        j.status != ItemStatus.EMPTY && M.push_back(j.toothName);
      v.SetTeethList(M), M.delete(), console.log("ReconstructionDialog proceed 2"), await Kr(s, o, g.value.selectedTeethLibraryModelName, g.value.selectedTeethLibraryGUID), v.SetSelectedLibrary(g.value.selectedTeethLibraryModelName, g.value.selectedTeethLibraryGUID), console.log("ReconstructionDialog proceed 3");
      const z = v.ValidateAndAddReconstruction();
      console.log("ReconstructionDialog proceed 4", z), z && (console.log("ReconstructionDialog proceed 5"), o.getContextCAD().DeleteAddReconstructionObject(), console.log("ReconstructionDialog proceed 6", z), i("confirm"), n.value.close());
    }, f = () => {
      o.getContextCAD().DeleteAddReconstructionObject(), i("reject"), n.value.close();
    };
    return (v, w) => {
      const A = Tn("ReconstructionSetupComponent");
      return L(), be(r(we), {
        class: "flex-col",
        style: { width: "90vw", height: "90vh" }
      }, {
        default: _(() => [
          d(r(we), { class: "flex-row h-full mb-2" }, {
            default: _(() => [
              d(ff, {
                class: "horizontal-padding",
                context: r(o),
                "preselected-type": r(a).preselectedMode,
                onTypeSelected: p,
                onModifyType: h,
                style: { flex: "1 1 0" }
              }, null, 8, ["context", "preselected-type"]),
              r(u) != null ? (L(), H(He, { key: 0 }, [
                w[4] || (w[4] = y("div", { style: { "{\n                        width": "0.1rem", height: "90%", "background-color": "var(--p-rg-border-color)", margin: "5rem 1rem" } }, null, -1)),
                d(gf, {
                  class: "horizontal-padding",
                  context: r(o),
                  reconstructionType: r(u),
                  onWorkflowSelected: m,
                  onModifyWorkflow: I,
                  style: { flex: "1 1 0" }
                }, null, 8, ["context", "reconstructionType"]),
                w[5] || (w[5] = y("div", { style: { "{\n                        width": "0.1rem", height: "90%", "background-color": "var(--p-rg-border-color)", margin: "5rem 1rem" } }, null, -1)),
                r(c) != null || r(a).preselectedMode != null ? (L(), be(A, {
                  key: 0,
                  class: "horizontal-padding",
                  context: r(o),
                  "production-center-list": r(l),
                  "setup-params": r(g),
                  "onUpdate:setupParams": w[0] || (w[0] = (T) => Wa(g) ? g.value = T : null),
                  "smile-setup-params": r(b),
                  "onUpdate:smileSetupParams": w[1] || (w[1] = (T) => Wa(b) ? b.value = T : null),
                  "production-setup-params": r(E),
                  "onUpdate:productionSetupParams": w[2] || (w[2] = (T) => Wa(E) ? E.value = T : null),
                  style: { flex: "2 1 0" }
                }, null, 8, ["context", "production-center-list", "setup-params", "smile-setup-params", "production-setup-params"])) : ue("", !0)
              ], 64)) : ue("", !0)
            ]),
            _: 1
          }),
          d(r(we), { class: "p-dialog-footer justify-center" }, {
            default: _(() => [
              d(r(la), {
                disabled: r(u) == null || r(c) == null,
                class: "mt-6",
                label: v.$t("shared.ok"),
                onClick: S
              }, null, 8, ["disabled", "label"]),
              d(r(ya), {
                class: "mt-6",
                label: v.$t("shared.cancel"),
                onClick: w[3] || (w[3] = (T) => f())
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), FL = { class: "flex flex-col" }, kL = /* @__PURE__ */ Je({
  __name: "IPTeethViewComponent",
  props: {
    projectContext: {},
    showLines: { type: Boolean, default: !1 },
    singleJawboneType: { default: null }
  },
  setup(e) {
    const { t } = Ht(), { cleanupAll: n, onEvent: a } = Ra(), o = e, l = B(o.projectContext.settings.general.useUSStyleToothChart);
    a(o.projectContext.settings.onSettingsModified, () => {
      l.value = o.projectContext.settings.general.useUSStyleToothChart;
    });
    const s = B({
      teeth: [],
      selectedObject: void 0,
      objectsModel: null,
      objectsPreview: null,
      implants: [],
      warnString: "warn",
      showLines: o.showLines,
      singleJawboneType: void 0,
      useUSStyleToothChart: l.value
    }), i = B(!1);
    function u(v, w, A) {
      const T = c(v, A);
      T && (T.tooth.editMode === Ea.ADD || o.projectContext.objects.selectImplant(T.name));
    }
    function c(v, w) {
      if (!v) return null;
      const A = h(w)[v - 1], T = Object.keys(Xt).indexOf(w.toString());
      let O = s.value.teeth[T].find((C) => C.id === v);
      if (s.value.singleJawboneType === null && (O = s.value.teeth[w].find((C) => C.id === v)), !O) throw new Error(`Tooth with id ${v} not found!`);
      return { name: A, tooth: O };
    }
    function p(v) {
      s.value.warnString = "";
      const w = i.value ? Ea.NO_EDIT : Ea.ADD, A = h(v).map((O, C) => {
        var x, N;
        const k = o.projectContext.objects.implantExists(O), M = o.projectContext.objects.getImplantByTooth(parseInt(O)), z = k ? Ea.SELECT_ONLY : w, j = k || i.value ? Mn.NONE : Mn.ADD;
        let K = k ? pt.OK : pt.EMPTY;
        return ((x = s.value.selectedObject) == null ? void 0 : x.getName()) === O && (K = pt.OK_SELECTED), (M != null && M.getColorOverride() || (N = M == null ? void 0 : M.getSleeve()) != null && N.getColorOverride()) && (K == pt.OK_SELECTED ? (M != null && M.isSleeveChanged() && !(M != null && M.isInCollision()) ? K = pt.WARNING_SELECTED : M != null && M.isInCollision() && (K = pt.COLLISION_SELECTED), M && M.collisions && (M.collisions.nerveCollision && (s.value.warnString += `${t("implant-planner.nerveCollision")} 
`), M.collisions.sleeveCollision && (s.value.warnString += `${t("implant-planner.sleeveCollision")} 
`), M.collisions.anatomyCollision && (s.value.warnString += `${t("implant-planner.anatomyCollision")} 
`), M.collisions.implantCollision ? s.value.warnString += `${t("implant-planner.implantCollision")} 
` : M.collisions.securityZoneCollision && (s.value.warnString += `${t("implant-planner.securityZoneCollision")} 
`), M.collisions.sleeveChanged != null && (s.value.warnString += `${M.collisions.sleeveChanged} 
`))) : M != null && M.isSleeveChanged() && !(M != null && M.isInCollision()) ? K = pt.WARNING : M != null && M.isInCollision() && (K = pt.COLLISION)), {
          id: C + 1,
          editMode: z,
          status: K,
          hoverIcon: j,
          toothName: O
        };
      }), T = Object.keys(Xt).indexOf(v.toString());
      s.value.singleJawboneType !== void 0 ? s.value.teeth.length < 1 ? s.value.teeth.push(A) : s.value.teeth[0] = A : s.value.teeth.length < 2 ? s.value.teeth.push(A) : s.value.teeth[T] = A;
    }
    function h(v) {
      return v === Xt.MANDIBLE ? rs(o.projectContext.settings.general.useUSStyleToothChart) : us(o.projectContext.settings.general.useUSStyleToothChart);
    }
    function g(v, w, A) {
      var M;
      const T = c(v, A);
      if (!T || i.value && T.tooth.status === pt.EMPTY)
        return;
      const C = o.projectContext.objects.getImplantByTooth(parseInt(T.name)), k = (C == null ? void 0 : C.getColorOverride()) || ((M = C == null ? void 0 : C.getSleeve()) == null ? void 0 : M.getColorOverride());
      C && k ? C != null && C.isSleeveChanged() && !(C != null && C.isInCollision()) ? T.tooth.status = pt.WARNING_SELECTED : C.isInCollision() && (T.tooth.status = pt.COLLISION_SELECTED) : T.tooth.status = pt.OK_SELECTED;
    }
    function b() {
      for (const v in Xt)
        if (Xt.hasOwnProperty(v)) {
          const w = Xt[v];
          (Number(w) || w === 0) && p(w);
        }
    }
    b(), Dt(async () => {
      const v = o.projectContext.objects.selectedObject.get();
      v && await m(v);
    });
    function E(v) {
      return (v == null ? void 0 : v.type) === Oe._IMPLANT;
    }
    async function m(v) {
      v !== null && !E(v) || (s.value.selectedObject = v ?? void 0, S(v), await I(v), b());
    }
    async function I(v) {
      if (!v) {
        s.value.objectsPreview = null;
        return;
      }
      const w = o.projectContext.viewConfiguration.colorScheme.get();
      s.value.objectsPreview = {
        implantPreview: await ea(v, w)
      };
      const A = v.getAbutment();
      A ? s.value.objectsPreview.abutmentPreview = await ea(A, w) : s.value.objectsPreview.abutmentPreview = void 0;
      const T = v.getSleeve();
      T ? s.value.objectsPreview.sleevePreview = await ea(T, w) : s.value.objectsPreview.sleevePreview = void 0;
    }
    function S(v) {
      if (v && v.type !== Oe._IMPLANT)
        return;
      const w = v;
      if (w) {
        const A = w.getImplantInfo().implantInfo, T = {
          objectId: w.getName(),
          implant: {
            name: `${A.manufacturerName} / ${A.modelName}`,
            diameter: A.diameter,
            length: A.length,
            visibility: w.getVisibility(),
            locked: w.getLocked()
          }
        }, O = w.getAbutment();
        if (O) {
          const k = O.getAbutmentInfo();
          T.abutment = {
            name: `${k.manufacturerName} / ${k.modelName} / ${k.name}`,
            visibility: O.getVisibility(),
            rotationZ: w.GetRotation(),
            rotationZProsthetic: w.GetRotation(!0)
          };
        } else
          T.abutment = void 0;
        const C = w.getSleeve();
        C ? (T.sleeve = {
          name: C.getSleeveName(),
          visibility: C.getVisibility()
        }, T.overallLength = C.getOverallLength(), T.sleeveDistance = C.getDistanceFromImplant(), T.drillLengths = C.getDrillLengths(), T.drillLength = C.getDrillLength()) : (T.sleeve = void 0, T.overallLength = void 0, T.sleeveDistance = void 0, T.drillLengths = void 0, T.drillLength = void 0), s.value.objectsModel = T;
      } else
        s.value.objectsModel = null;
    }
    const f = (v, w, A) => {
      p(A);
    };
    return (v, w) => (L(), H("div", FL, [
      d(r(cc), {
        modelValue: s.value,
        "onUpdate:modelValue": w[0] || (w[0] = (A) => s.value = A),
        jawboneType: r(Xt).MAXILLA,
        indexTeeth: 0,
        warningString: s.value.warnString,
        showLines: s.value.showLines,
        onToothClick: u,
        onToothMouseOut: f,
        onToothMouseOver: g
      }, null, 8, ["modelValue", "jawboneType", "warningString", "showLines"]),
      d(r(cc), {
        modelValue: s.value,
        "onUpdate:modelValue": w[1] || (w[1] = (A) => s.value = A),
        jawboneType: r(Xt).MANDIBLE,
        indexTeeth: 1,
        warningString: s.value.warnString,
        showLines: s.value.showLines,
        onToothClick: u,
        onToothMouseOut: f,
        onToothMouseOver: g
      }, null, 8, ["modelValue", "jawboneType", "warningString", "showLines"])
    ]));
  }
}), VL = { class: "flex flex-row-wrap gap-20" }, BL = /* @__PURE__ */ Je({
  __name: "IPTeethViewDialog",
  setup(e) {
    const n = Xn("dialogRef").value.data;
    return (a, o) => {
      const l = kL;
      return L(), H("div", VL, [
        d(l, {
          projectContext: r(n).projectContext,
          showLines: !0
        }, null, 8, ["projectContext"]),
        d(r(ah))
      ]);
    };
  }
}), UL = { class: "text-lg" }, hf = /* @__PURE__ */ Je({
  __name: "IPFromPlannerFromFileDialog",
  emits: ["importFromFile", "importFromPlanner"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = t, o = () => {
      a("importFromFile"), n.value.close();
    }, l = () => {
      a("importFromPlanner"), n.value.close();
    };
    return (s, i) => (L(), H(He, null, [
      d(r(we), null, {
        default: _(() => [
          y("span", UL, U(s.$t("implant-planner.selectAnImportOption")), 1)
        ]),
        _: 1
      }),
      d(r(we), {
        class: "flex-row mt-6",
        style: { "justify-content": "space-around" }
      }, {
        default: _(() => [
          d(r(Ne), {
            class: "btn-wizard-lg",
            label: s.$t("implant-planner.importFromFile"),
            onClick: o
          }, null, 8, ["label"]),
          d(r(Ne), {
            class: "btn-wizard-lg ml-2",
            label: s.$t("implant-planner.importFromPlanner"),
            onClick: l
          }, null, 8, ["label"])
        ]),
        _: 1
      })
    ], 64));
  }
});
function Vd(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = GL(e)) || t) {
      n && (e = n);
      var a = 0, o = function() {
      };
      return { s: o, n: function() {
        return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
      }, e: function(c) {
        throw c;
      }, f: o };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var l, s = !0, i = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var c = n.next();
    return s = c.done, c;
  }, e: function(c) {
    i = !0, l = c;
  }, f: function() {
    try {
      s || n.return == null || n.return();
    } finally {
      if (i) throw l;
    }
  } };
}
function GL(e, t) {
  if (e) {
    if (typeof e == "string") return Bd(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Bd(e, t) : void 0;
  }
}
function Bd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = Array(t); n < t; n++) a[n] = e[n];
  return a;
}
var Ud = {
  filter: function(t, n, a, o, l) {
    var s = [];
    if (!t)
      return s;
    var i = Vd(t), u;
    try {
      for (i.s(); !(u = i.n()).done; ) {
        var c = u.value;
        if (typeof c == "string") {
          if (this.filters[o](c, a, l)) {
            s.push(c);
            continue;
          }
        } else {
          var p = Vd(n), h;
          try {
            for (p.s(); !(h = p.n()).done; ) {
              var g = h.value, b = $a(c, g);
              if (this.filters[o](b, a, l)) {
                s.push(c);
                break;
              }
            }
          } catch (E) {
            p.e(E);
          } finally {
            p.f();
          }
        }
      }
    } catch (E) {
      i.e(E);
    } finally {
      i.f();
    }
    return s;
  },
  filters: {
    startsWith: function(t, n, a) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var o = Jn(n.toString()).toLocaleLowerCase(a), l = Jn(t.toString()).toLocaleLowerCase(a);
      return l.slice(0, o.length) === o;
    },
    contains: function(t, n, a) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var o = Jn(n.toString()).toLocaleLowerCase(a), l = Jn(t.toString()).toLocaleLowerCase(a);
      return l.indexOf(o) !== -1;
    },
    notContains: function(t, n, a) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var o = Jn(n.toString()).toLocaleLowerCase(a), l = Jn(t.toString()).toLocaleLowerCase(a);
      return l.indexOf(o) === -1;
    },
    endsWith: function(t, n, a) {
      if (n == null || n === "")
        return !0;
      if (t == null)
        return !1;
      var o = Jn(n.toString()).toLocaleLowerCase(a), l = Jn(t.toString()).toLocaleLowerCase(a);
      return l.indexOf(o, l.length - o.length) !== -1;
    },
    equals: function(t, n, a) {
      return n == null || n === "" ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() === n.getTime() : Jn(t.toString()).toLocaleLowerCase(a) == Jn(n.toString()).toLocaleLowerCase(a);
    },
    notEquals: function(t, n, a) {
      return n == null || n === "" ? !1 : t == null ? !0 : t.getTime && n.getTime ? t.getTime() !== n.getTime() : Jn(t.toString()).toLocaleLowerCase(a) != Jn(n.toString()).toLocaleLowerCase(a);
    },
    in: function(t, n) {
      if (n == null || n.length === 0)
        return !0;
      for (var a = 0; a < n.length; a++)
        if (Zi(t, n[a]))
          return !0;
      return !1;
    },
    between: function(t, n) {
      return n == null || n[0] == null || n[1] == null ? !0 : t == null ? !1 : t.getTime ? n[0].getTime() <= t.getTime() && t.getTime() <= n[1].getTime() : n[0] <= t && t <= n[1];
    },
    lt: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() < n.getTime() : t < n;
    },
    lte: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() <= n.getTime() : t <= n;
    },
    gt: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() > n.getTime() : t > n;
    },
    gte: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime && n.getTime ? t.getTime() >= n.getTime() : t >= n;
    },
    dateIs: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.toDateString() === n.toDateString();
    },
    dateIsNot: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.toDateString() !== n.toDateString();
    },
    dateBefore: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime() < n.getTime();
    },
    dateAfter: function(t, n) {
      return n == null ? !0 : t == null ? !1 : t.getTime() > n.getTime();
    }
  },
  register: function(t, n) {
    this.filters[t] = n;
  }
};
function Gd() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "pv_id_";
  return Xp(e);
}
var bf = {
  name: "BlankIcon",
  extends: ra
};
function WL(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("rect", {
    width: "1",
    height: "1",
    fill: "currentColor",
    "fill-opacity": "0"
  }, null, -1)]), 16);
}
bf.render = WL;
var vf = {
  name: "CheckIcon",
  extends: ra
};
function zL(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    d: "M4.86199 11.5948C4.78717 11.5923 4.71366 11.5745 4.64596 11.5426C4.57826 11.5107 4.51779 11.4652 4.46827 11.4091L0.753985 7.69483C0.683167 7.64891 0.623706 7.58751 0.580092 7.51525C0.536478 7.44299 0.509851 7.36177 0.502221 7.27771C0.49459 7.19366 0.506156 7.10897 0.536046 7.03004C0.565935 6.95111 0.613367 6.88 0.674759 6.82208C0.736151 6.76416 0.8099 6.72095 0.890436 6.69571C0.970973 6.67046 1.05619 6.66385 1.13966 6.67635C1.22313 6.68886 1.30266 6.72017 1.37226 6.76792C1.44186 6.81567 1.4997 6.8786 1.54141 6.95197L4.86199 10.2503L12.6397 2.49483C12.7444 2.42694 12.8689 2.39617 12.9932 2.40745C13.1174 2.41873 13.2343 2.47141 13.3251 2.55705C13.4159 2.64268 13.4753 2.75632 13.4938 2.87973C13.5123 3.00315 13.4888 3.1292 13.4271 3.23768L5.2557 11.4091C5.20618 11.4652 5.14571 11.5107 5.07801 11.5426C5.01031 11.5745 4.9368 11.5923 4.86199 11.5948Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
vf.render = zL;
var yf = {
  name: "SearchIcon",
  extends: ra
};
function HL(e, t, n, a, o, l) {
  return L(), H("svg", je({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), t[0] || (t[0] = [y("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.67602 11.0265C3.6661 11.688 4.83011 12.0411 6.02086 12.0411C6.81149 12.0411 7.59438 11.8854 8.32483 11.5828C8.87005 11.357 9.37808 11.0526 9.83317 10.6803L12.9769 13.8241C13.0323 13.8801 13.0983 13.9245 13.171 13.9548C13.2438 13.985 13.3219 14.0003 13.4007 14C13.4795 14.0003 13.5575 13.985 13.6303 13.9548C13.7031 13.9245 13.7691 13.8801 13.8244 13.8241C13.9367 13.7116 13.9998 13.5592 13.9998 13.4003C13.9998 13.2414 13.9367 13.089 13.8244 12.9765L10.6807 9.8328C11.053 9.37773 11.3573 8.86972 11.5831 8.32452C11.8857 7.59408 12.0414 6.81119 12.0414 6.02056C12.0414 4.8298 11.6883 3.66579 11.0268 2.67572C10.3652 1.68564 9.42494 0.913972 8.32483 0.45829C7.22472 0.00260857 6.01418 -0.116618 4.84631 0.115686C3.67844 0.34799 2.60568 0.921393 1.76369 1.76338C0.921698 2.60537 0.348296 3.67813 0.115991 4.84601C-0.116313 6.01388 0.00291375 7.22441 0.458595 8.32452C0.914277 9.42464 1.68595 10.3649 2.67602 11.0265ZM3.35565 2.0158C4.14456 1.48867 5.07206 1.20731 6.02086 1.20731C7.29317 1.20731 8.51338 1.71274 9.41304 2.6124C10.3127 3.51206 10.8181 4.73226 10.8181 6.00457C10.8181 6.95337 10.5368 7.88088 10.0096 8.66978C9.48251 9.45868 8.73328 10.0736 7.85669 10.4367C6.98011 10.7997 6.01554 10.8947 5.08496 10.7096C4.15439 10.5245 3.2996 10.0676 2.62869 9.39674C1.95778 8.72583 1.50089 7.87104 1.31579 6.94046C1.13068 6.00989 1.22568 5.04532 1.58878 4.16874C1.95187 3.29215 2.56675 2.54292 3.35565 2.0158Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
yf.render = HL;
const YL = {
  name: "BaseListbox",
  extends: uu,
  props: {
    options: Array,
    optionLabel: null,
    optionValue: null,
    optionDisabled: null,
    optionGroupLabel: null,
    optionGroupChildren: null,
    listStyle: null,
    scrollHeight: {
      type: String,
      default: "14rem"
    },
    dataKey: null,
    multiple: {
      type: Boolean,
      default: !1
    },
    metaKeySelection: {
      type: Boolean,
      default: !1
    },
    filter: Boolean,
    filterPlaceholder: String,
    filterLocale: String,
    filterMatchMode: {
      type: String,
      default: "contains"
    },
    filterFields: {
      type: Array,
      default: null
    },
    virtualScrollerOptions: {
      type: Object,
      default: null
    },
    autoOptionFocus: {
      type: Boolean,
      default: !0
    },
    selectOnFocus: {
      type: Boolean,
      default: !1
    },
    focusOnHover: {
      type: Boolean,
      default: !0
    },
    highlightOnSelect: {
      type: Boolean,
      default: !0
    },
    checkmark: {
      type: Boolean,
      default: !1
    },
    filterMessage: {
      type: String,
      default: null
    },
    selectionMessage: {
      type: String,
      default: null
    },
    emptySelectionMessage: {
      type: String,
      default: null
    },
    emptyFilterMessage: {
      type: String,
      default: null
    },
    emptyMessage: {
      type: String,
      default: null
    },
    filterIcon: {
      type: String,
      default: void 0
    },
    striped: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: 0
    },
    ariaLabel: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  style: Rh,
  provide() {
    return {
      $pcListbox: this,
      $parentInstance: this
    };
  }
}, KL = {
  name: "Listbox",
  extends: YL,
  inheritAttrs: !1,
  emits: ["change", "focus", "blur", "filter", "item-dblclick", "option-dblclick"],
  list: null,
  virtualScroller: null,
  optionTouched: !1,
  startRangeIndex: -1,
  searchTimeout: null,
  searchValue: "",
  data() {
    return {
      id: this.$attrs.id,
      filterValue: null,
      focused: !1,
      focusedOptionIndex: -1
    };
  },
  watch: {
    "$attrs.id": function(e) {
      this.id = e || Gd();
    },
    options() {
      this.autoUpdateModel();
    }
  },
  mounted() {
    this.id = this.id || Gd(), this.autoUpdateModel();
  },
  methods: {
    getOptionIndex(e, t) {
      return this.virtualScrollerDisabled ? e : t && t(e).index;
    },
    getOptionLabel(e) {
      return this.optionLabel ? $a(e, this.optionLabel) : typeof e == "string" ? e : null;
    },
    getOptionValue(e) {
      return this.optionValue ? $a(e, this.optionValue) : e;
    },
    getOptionRenderKey(e, t) {
      return (this.dataKey ? $a(e, this.dataKey) : this.getOptionLabel(e)) + "_" + t;
    },
    getPTOptions(e, t, n, a) {
      return this.ptm(a, {
        context: {
          selected: this.isSelected(e),
          focused: this.focusedOptionIndex === this.getOptionIndex(n, t),
          disabled: this.isOptionDisabled(e)
        }
      });
    },
    isOptionDisabled(e) {
      return this.optionDisabled ? $a(e, this.optionDisabled) : !1;
    },
    isOptionGroup(e) {
      return this.optionGroupLabel && e.optionGroup && e.group;
    },
    getOptionGroupLabel(e) {
      return $a(e, this.optionGroupLabel);
    },
    getOptionGroupChildren(e) {
      return $a(e, this.optionGroupChildren);
    },
    getAriaPosInset(e) {
      return (this.optionGroupLabel ? e - this.visibleOptions.slice(0, e).filter((t) => this.isOptionGroup(t)).length : e) + 1;
    },
    onFirstHiddenFocus() {
      Pi(this.list);
      const e = Uc(this.$el, ':not([data-p-hidden-focusable="true"])');
      this.$refs.lastHiddenFocusableElement.tabIndex = Ro(e) ? void 0 : -1, this.$refs.firstHiddenFocusableElement.tabIndex = -1;
    },
    onLastHiddenFocus(e) {
      if (e.relatedTarget === this.list) {
        const n = Uc(this.$el, ':not([data-p-hidden-focusable="true"])');
        Pi(n), this.$refs.firstHiddenFocusableElement.tabIndex = void 0;
      } else
        Pi(this.$refs.firstHiddenFocusableElement);
      this.$refs.lastHiddenFocusableElement.tabIndex = -1;
    },
    onFocusout(e) {
      !this.$el.contains(e.relatedTarget) && this.$refs.lastHiddenFocusableElement && this.$refs.firstHiddenFocusableElement && (this.$refs.lastHiddenFocusableElement.tabIndex = this.$refs.firstHiddenFocusableElement.tabIndex = void 0);
    },
    onListFocus(e) {
      this.focused = !0, this.focusedOptionIndex = this.focusedOptionIndex !== -1 ? this.focusedOptionIndex : this.autoOptionFocus ? this.findFirstFocusedOptionIndex() : this.findSelectedOptionIndex(), this.autoUpdateModel(), this.$emit("focus", e);
    },
    onListBlur(e) {
      this.focused = !1, this.focusedOptionIndex = this.startRangeIndex = -1, this.searchValue = "", this.$emit("blur", e);
    },
    onListKeyDown(e) {
      const t = e.metaKey || e.ctrlKey;
      switch (e.code) {
        case "ArrowDown":
          this.onArrowDownKey(e);
          break;
        case "ArrowUp":
          this.onArrowUpKey(e);
          break;
        case "Home":
          this.onHomeKey(e);
          break;
        case "End":
          this.onEndKey(e);
          break;
        case "PageDown":
          this.onPageDownKey(e);
          break;
        case "PageUp":
          this.onPageUpKey(e);
          break;
        case "Enter":
        case "NumpadEnter":
        case "Space":
          this.onSpaceKey(e);
          break;
        case "Tab":
          break;
        case "ShiftLeft":
        case "ShiftRight":
          this.onShiftKey(e);
          break;
        default:
          if (this.multiple && e.code === "KeyA" && t) {
            const n = this.visibleOptions.filter((a) => this.isValidOption(a)).map((a) => this.getOptionValue(a));
            this.updateModel(e, n), e.preventDefault();
            break;
          }
          !t && dy(e.key) && (this.searchOptions(e, e.key), e.preventDefault());
          break;
      }
    },
    onOptionSelect(e, t, n = -1) {
      this.disabled || this.isOptionDisabled(t) || (this.multiple ? this.onOptionSelectMultiple(e, t) : this.onOptionSelectSingle(e, t), this.optionTouched = !1, n !== -1 && (this.focusedOptionIndex = n));
    },
    onOptionMouseDown(e, t) {
      this.changeFocusedOptionIndex(e, t);
    },
    onOptionMouseMove(e, t) {
      this.focusOnHover && this.focused && this.changeFocusedOptionIndex(e, t);
    },
    onOptionTouchEnd() {
      this.disabled || (this.optionTouched = !0);
    },
    onOptionDblClick(e, t) {
      this.$emit("item-dblclick", {
        originalEvent: e,
        value: t
      }), this.$emit("option-dblclick", {
        originalEvent: e,
        value: t
      });
    },
    onOptionSelectSingle(e, t) {
      let n = this.isSelected(t), a = !1, o = null;
      if (this.optionTouched ? !1 : this.metaKeySelection) {
        let s = e && (e.metaKey || e.ctrlKey);
        n ? s && (o = null, a = !0) : (o = this.getOptionValue(t), a = !0);
      } else
        o = n ? null : this.getOptionValue(t), a = !0;
      a && this.updateModel(e, o);
    },
    onOptionSelectMultiple(e, t) {
      let n = this.isSelected(t), a = null;
      if (this.optionTouched ? !1 : this.metaKeySelection) {
        let l = e.metaKey || e.ctrlKey;
        n ? a = l ? this.removeOption(t) : [this.getOptionValue(t)] : (a = l ? this.d_value || [] : [], a = [...a, this.getOptionValue(t)]);
      } else
        a = n ? this.removeOption(t) : [...this.d_value || [], this.getOptionValue(t)];
      this.updateModel(e, a);
    },
    onOptionSelectRange(e, t = -1, n = -1) {
      if (t === -1 && (t = this.findNearestSelectedOptionIndex(n, !0)), n === -1 && (n = this.findNearestSelectedOptionIndex(t)), t !== -1 && n !== -1) {
        const a = Math.min(t, n), o = Math.max(t, n), l = this.visibleOptions.slice(a, o + 1).filter((s) => this.isValidOption(s)).map((s) => this.getOptionValue(s));
        this.updateModel(e, l);
      }
    },
    onFilterChange(e) {
      this.$emit("filter", { originalEvent: e, value: e.target.value, filterValue: this.visibleOptions }), this.focusedOptionIndex = this.startRangeIndex = -1;
    },
    onFilterBlur() {
      this.focusedOptionIndex = this.startRangeIndex = -1;
    },
    onFilterKeyDown(e) {
      switch (e.code) {
        case "ArrowDown":
          this.onArrowDownKey(e);
          break;
        case "ArrowUp":
          this.onArrowUpKey(e);
          break;
        case "ArrowLeft":
        case "ArrowRight":
          this.onArrowLeftKey(e, !0);
          break;
        case "Home":
          this.onHomeKey(e, !0);
          break;
        case "End":
          this.onEndKey(e, !0);
          break;
        case "Enter":
        case "NumpadEnter":
          this.onEnterKey(e);
          break;
        case "ShiftLeft":
        case "ShiftRight":
          this.onShiftKey(e);
          break;
      }
    },
    onArrowDownKey(e) {
      const t = this.focusedOptionIndex !== -1 ? this.findNextOptionIndex(this.focusedOptionIndex) : this.findFirstFocusedOptionIndex();
      this.multiple && e.shiftKey && this.onOptionSelectRange(e, this.startRangeIndex, t), this.changeFocusedOptionIndex(e, t), e.preventDefault();
    },
    onArrowUpKey(e) {
      const t = this.focusedOptionIndex !== -1 ? this.findPrevOptionIndex(this.focusedOptionIndex) : this.findLastFocusedOptionIndex();
      this.multiple && e.shiftKey && this.onOptionSelectRange(e, t, this.startRangeIndex), this.changeFocusedOptionIndex(e, t), e.preventDefault();
    },
    onArrowLeftKey(e, t = !1) {
      t && (this.focusedOptionIndex = -1);
    },
    onHomeKey(e, t = !1) {
      if (t) {
        const n = e.currentTarget;
        e.shiftKey ? n.setSelectionRange(0, e.target.selectionStart) : (n.setSelectionRange(0, 0), this.focusedOptionIndex = -1);
      } else {
        let n = e.metaKey || e.ctrlKey, a = this.findFirstOptionIndex();
        this.multiple && e.shiftKey && n && this.onOptionSelectRange(e, a, this.startRangeIndex), this.changeFocusedOptionIndex(e, a);
      }
      e.preventDefault();
    },
    onEndKey(e, t = !1) {
      if (t) {
        const n = e.currentTarget;
        if (e.shiftKey)
          n.setSelectionRange(e.target.selectionStart, n.value.length);
        else {
          const a = n.value.length;
          n.setSelectionRange(a, a), this.focusedOptionIndex = -1;
        }
      } else {
        let n = e.metaKey || e.ctrlKey, a = this.findLastOptionIndex();
        this.multiple && e.shiftKey && n && this.onOptionSelectRange(e, this.startRangeIndex, a), this.changeFocusedOptionIndex(e, a);
      }
      e.preventDefault();
    },
    onPageUpKey(e) {
      this.scrollInView(0), e.preventDefault();
    },
    onPageDownKey(e) {
      this.scrollInView(this.visibleOptions.length - 1), e.preventDefault();
    },
    onEnterKey(e) {
      this.focusedOptionIndex !== -1 && (this.multiple && e.shiftKey ? this.onOptionSelectRange(e, this.focusedOptionIndex) : this.onOptionSelect(e, this.visibleOptions[this.focusedOptionIndex]));
    },
    onSpaceKey(e) {
      e.preventDefault(), this.onEnterKey(e);
    },
    onShiftKey() {
      this.startRangeIndex = this.focusedOptionIndex;
    },
    isOptionMatched(e) {
      var t;
      return this.isValidOption(e) && typeof this.getOptionLabel(e) == "string" && ((t = this.getOptionLabel(e)) == null ? void 0 : t.toLocaleLowerCase(this.filterLocale).startsWith(this.searchValue.toLocaleLowerCase(this.filterLocale)));
    },
    isValidOption(e) {
      return At(e) && !(this.isOptionDisabled(e) || this.isOptionGroup(e));
    },
    isValidSelectedOption(e) {
      return this.isValidOption(e) && this.isSelected(e);
    },
    isEquals(e, t) {
      return Zi(e, t, this.equalityKey);
    },
    isSelected(e) {
      const t = this.getOptionValue(e);
      return this.multiple ? (this.d_value || []).some((n) => this.isEquals(n, t)) : this.isEquals(this.d_value, t);
    },
    findFirstOptionIndex() {
      return this.visibleOptions.findIndex((e) => this.isValidOption(e));
    },
    findLastOptionIndex() {
      return Ci(this.visibleOptions, (e) => this.isValidOption(e));
    },
    findNextOptionIndex(e) {
      const t = e < this.visibleOptions.length - 1 ? this.visibleOptions.slice(e + 1).findIndex((n) => this.isValidOption(n)) : -1;
      return t > -1 ? t + e + 1 : e;
    },
    findPrevOptionIndex(e) {
      const t = e > 0 ? Ci(this.visibleOptions.slice(0, e), (n) => this.isValidOption(n)) : -1;
      return t > -1 ? t : e;
    },
    findSelectedOptionIndex() {
      if (this.$filled)
        if (this.multiple)
          for (let e = this.d_value.length - 1; e >= 0; e--) {
            const t = this.d_value[e], n = this.visibleOptions.findIndex((a) => this.isValidSelectedOption(a) && this.isEquals(t, this.getOptionValue(a)));
            if (n > -1) return n;
          }
        else
          return this.visibleOptions.findIndex((e) => this.isValidSelectedOption(e));
      return -1;
    },
    findFirstSelectedOptionIndex() {
      return this.$filled ? this.visibleOptions.findIndex((e) => this.isValidSelectedOption(e)) : -1;
    },
    findLastSelectedOptionIndex() {
      return this.$filled ? Ci(this.visibleOptions, (e) => this.isValidSelectedOption(e)) : -1;
    },
    findNextSelectedOptionIndex(e) {
      const t = this.$filled && e < this.visibleOptions.length - 1 ? this.visibleOptions.slice(e + 1).findIndex((n) => this.isValidSelectedOption(n)) : -1;
      return t > -1 ? t + e + 1 : -1;
    },
    findPrevSelectedOptionIndex(e) {
      const t = this.$filled && e > 0 ? Ci(this.visibleOptions.slice(0, e), (n) => this.isValidSelectedOption(n)) : -1;
      return t > -1 ? t : -1;
    },
    findNearestSelectedOptionIndex(e, t = !1) {
      let n = -1;
      return this.$filled && (t ? (n = this.findPrevSelectedOptionIndex(e), n = n === -1 ? this.findNextSelectedOptionIndex(e) : n) : (n = this.findNextSelectedOptionIndex(e), n = n === -1 ? this.findPrevSelectedOptionIndex(e) : n)), n > -1 ? n : e;
    },
    findFirstFocusedOptionIndex() {
      const e = this.findFirstSelectedOptionIndex();
      return e < 0 ? this.findFirstOptionIndex() : e;
    },
    findLastFocusedOptionIndex() {
      const e = this.findLastSelectedOptionIndex();
      return e < 0 ? this.findLastOptionIndex() : e;
    },
    searchOptions(e, t) {
      this.searchValue = (this.searchValue || "") + t;
      let n = -1;
      At(this.searchValue) && (this.focusedOptionIndex !== -1 ? (n = this.visibleOptions.slice(this.focusedOptionIndex).findIndex((a) => this.isOptionMatched(a)), n = n === -1 ? this.visibleOptions.slice(0, this.focusedOptionIndex).findIndex((a) => this.isOptionMatched(a)) : n + this.focusedOptionIndex) : n = this.visibleOptions.findIndex((a) => this.isOptionMatched(a)), n === -1 && this.focusedOptionIndex === -1 && (n = this.findFirstFocusedOptionIndex()), n !== -1 && this.changeFocusedOptionIndex(e, n)), this.searchTimeout && clearTimeout(this.searchTimeout), this.searchTimeout = setTimeout(() => {
        this.searchValue = "", this.searchTimeout = null;
      }, 500);
    },
    removeOption(e) {
      return this.d_value.filter((t) => !Zi(t, this.getOptionValue(e), this.equalityKey));
    },
    changeFocusedOptionIndex(e, t) {
      this.focusedOptionIndex !== t && (this.focusedOptionIndex = t, this.scrollInView(), this.selectOnFocus && !this.multiple && this.onOptionSelect(e, this.visibleOptions[t]));
    },
    scrollInView(e = -1) {
      this.$nextTick(() => {
        const t = e !== -1 ? `${this.id}_${e}` : this.focusedOptionId, n = iu(this.list, `li[id="${t}"]`);
        n ? n.scrollIntoView && n.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" }) : this.virtualScrollerDisabled || this.virtualScroller && this.virtualScroller.scrollToIndex(e !== -1 ? e : this.focusedOptionIndex);
      });
    },
    autoUpdateModel() {
      this.selectOnFocus && this.autoOptionFocus && !this.$filled && !this.multiple && this.focused && (this.focusedOptionIndex = this.findFirstFocusedOptionIndex(), this.onOptionSelect(null, this.visibleOptions[this.focusedOptionIndex]));
    },
    updateModel(e, t) {
      this.writeValue(t, e), this.$emit("change", { originalEvent: e, value: t });
    },
    listRef(e, t) {
      this.list = e, t && t(e);
    },
    virtualScrollerRef(e) {
      this.virtualScroller = e;
    }
  },
  computed: {
    optionsListFlat() {
      return this.filterValue ? Ud.filter(this.options, this.searchFields, this.filterValue, this.filterMatchMode, this.filterLocale) : this.options;
    },
    optionsListGroup() {
      const e = [];
      return (this.options || []).forEach((t) => {
        const n = this.getOptionGroupChildren(t) || [], a = this.filterValue ? Ud.filter(n, this.searchFields, this.filterValue, this.filterMatchMode, this.filterLocale) : n;
        a != null && a.length && e.push({ optionGroup: t, group: !0 }, ...a);
      }), e;
    },
    visibleOptions() {
      return this.optionGroupLabel ? this.optionsListGroup : this.optionsListFlat;
    },
    // @deprecated use $filled instead
    hasSelectedOption() {
      return At(this.d_value);
    },
    equalityKey() {
      return this.optionValue ? null : this.dataKey;
    },
    searchFields() {
      return this.filterFields || [this.optionLabel];
    },
    filterResultMessageText() {
      return At(this.visibleOptions) ? this.filterMessageText.replaceAll("{0}", this.visibleOptions.length) : this.emptyFilterMessageText;
    },
    filterMessageText() {
      return this.filterMessage || this.$primevue.config.locale.searchMessage || "";
    },
    emptyFilterMessageText() {
      return this.emptyFilterMessage || this.$primevue.config.locale.emptySearchMessage || this.$primevue.config.locale.emptyFilterMessage || "";
    },
    emptyMessageText() {
      return this.emptyMessage || this.$primevue.config.locale.emptyMessage || "";
    },
    selectionMessageText() {
      return this.selectionMessage || this.$primevue.config.locale.selectionMessage || "";
    },
    emptySelectionMessageText() {
      return this.emptySelectionMessage || this.$primevue.config.locale.emptySelectionMessage || "";
    },
    selectedMessageText() {
      return this.$filled ? this.selectionMessageText.replaceAll("{0}", this.multiple ? this.d_value.length : "1") : this.emptySelectionMessageText;
    },
    focusedOptionId() {
      return this.focusedOptionIndex !== -1 ? `${this.id}_${this.focusedOptionIndex}` : null;
    },
    ariaSetSize() {
      return this.visibleOptions.filter((e) => !this.isOptionGroup(e)).length;
    },
    virtualScrollerDisabled() {
      return !this.virtualScrollerOptions;
    }
  },
  directives: {
    ripple: fp
  },
  components: {
    InputText: da,
    VirtualScroller: Ah,
    InputIcon: Dh,
    IconField: Oh,
    SearchIcon: yf,
    CheckIcon: vf,
    BlankIcon: bf
  }
}, ZL = ["id"], XL = ["tabindex"], JL = ["id", "aria-multiselectable", "aria-label", "aria-labelledby", "aria-activedescendant", "aria-disabled"], qL = ["id"], QL = ["id", "aria-label", "aria-selected", "aria-disabled", "aria-setsize", "aria-posinset", "onClick", "onMousedown", "onMousemove", "onDblclick", "data-p-selected", "data-p-focused", "data-p-disabled"], eO = ["tabindex"];
function tO(e, t, n, a, o, l) {
  const s = Tn("InputText"), i = Tn("SearchIcon"), u = Tn("InputIcon"), c = Tn("IconField"), p = Tn("CheckIcon"), h = Tn("BlankIcon"), g = Tn("VirtualScroller"), b = Gr("ripple");
  return L(), H("div", je({
    id: o.id,
    class: e.cx("root"),
    onFocusout: t[7] || (t[7] = (...E) => l.onFocusout && l.onFocusout(...E))
  }, e.ptmi("root")), [
    y("span", je({
      ref: "firstHiddenFocusableElement",
      role: "presentation",
      "aria-hidden": "true",
      class: "p-hidden-accessible p-hidden-focusable",
      tabindex: e.disabled ? -1 : e.tabindex,
      onFocus: t[0] || (t[0] = (...E) => l.onFirstHiddenFocus && l.onFirstHiddenFocus(...E))
    }, e.ptm("hiddenFirstFocusableEl"), {
      "data-p-hidden-accessible": !0,
      "data-p-hidden-focusable": !0
    }), null, 16, XL),
    e.$slots.header ? (L(), H("div", {
      key: 0,
      class: Ge(e.cx("header"))
    }, [
      It(e.$slots, "header", {
        value: e.d_value,
        options: l.visibleOptions
      })
    ], 2)) : ue("", !0),
    e.filter ? (L(), H("div", je({
      key: 1,
      class: e.cx("header")
    }, e.ptm("header")), [
      d(c, {
        unstyled: e.unstyled,
        pt: e.ptm("pcFilterContainer")
      }, {
        default: _(() => [
          d(s, {
            modelValue: o.filterValue,
            "onUpdate:modelValue": t[1] || (t[1] = (E) => o.filterValue = E),
            type: "text",
            class: Ge(e.cx("pcFilter")),
            placeholder: e.filterPlaceholder,
            role: "searchbox",
            autocomplete: "off",
            disabled: e.disabled,
            unstyled: e.unstyled,
            "aria-owns": o.id + "_list",
            "aria-activedescendant": l.focusedOptionId,
            tabindex: !e.disabled && !o.focused ? e.tabindex : -1,
            onInput: l.onFilterChange,
            onBlur: l.onFilterBlur,
            onKeydown: l.onFilterKeyDown,
            pt: e.ptm("pcFilter")
          }, null, 8, ["modelValue", "class", "placeholder", "disabled", "unstyled", "aria-owns", "aria-activedescendant", "tabindex", "onInput", "onBlur", "onKeydown", "pt"]),
          d(u, {
            unstyled: e.unstyled,
            pt: e.ptm("pcFilterIconContainer")
          }, {
            default: _(() => [
              It(e.$slots, "filtericon", {}, () => [
                e.filterIcon ? (L(), H("span", je({
                  key: 0,
                  class: e.filterIcon
                }, e.ptm("filterIcon")), null, 16)) : (L(), be(i, po(je({ key: 1 }, e.ptm("filterIcon"))), null, 16))
              ])
            ]),
            _: 3
          }, 8, ["unstyled", "pt"])
        ]),
        _: 3
      }, 8, ["unstyled", "pt"]),
      y("span", je({
        role: "status",
        "aria-live": "polite",
        class: "p-hidden-accessible"
      }, e.ptm("hiddenFilterResult"), { "data-p-hidden-accessible": !0 }), U(l.filterResultMessageText), 17)
    ], 16)) : ue("", !0),
    y("div", je({
      class: e.cx("listContainer"),
      style: [{ "max-height": l.virtualScrollerDisabled ? e.scrollHeight : "" }, e.listStyle]
    }, e.ptm("listContainer")), [
      d(g, je({ ref: l.virtualScrollerRef }, e.virtualScrollerOptions, {
        items: l.visibleOptions,
        style: [{ height: e.scrollHeight }, e.listStyle],
        tabindex: -1,
        disabled: l.virtualScrollerDisabled,
        pt: e.ptm("virtualScroller")
      }), Sg({
        content: _(({ styleClass: E, contentRef: m, items: I, getItemOptions: S, contentStyle: f, itemSize: v }) => [
          y("ul", je({
            ref: (w) => l.listRef(w, m),
            id: o.id + "_list",
            class: [e.cx("list"), E],
            style: f,
            tabindex: -1,
            role: "listbox",
            "aria-multiselectable": e.multiple,
            "aria-label": e.ariaLabel,
            "aria-labelledby": e.ariaLabelledby,
            "aria-activedescendant": o.focused ? l.focusedOptionId : void 0,
            "aria-disabled": e.disabled,
            onFocus: t[3] || (t[3] = (...w) => l.onListFocus && l.onListFocus(...w)),
            onBlur: t[4] || (t[4] = (...w) => l.onListBlur && l.onListBlur(...w)),
            onKeydown: t[5] || (t[5] = (...w) => l.onListKeyDown && l.onListKeyDown(...w))
          }, e.ptm("list")), [
            (L(!0), H(He, null, jt(I, (w, A) => (L(), H(He, {
              key: l.getOptionRenderKey(w, l.getOptionIndex(A, S))
            }, [
              l.isOptionGroup(w) ? (L(), H("li", je({
                key: 0,
                id: o.id + "_" + l.getOptionIndex(A, S),
                style: { height: v ? v + "px" : void 0 },
                class: e.cx("optionGroup"),
                role: "option"
              }, { ref_for: !0 }, e.ptm("optionGroup")), [
                It(e.$slots, "optiongroup", {
                  option: w.optionGroup,
                  index: l.getOptionIndex(A, S)
                }, () => [
                  vt(U(l.getOptionGroupLabel(w.optionGroup)), 1)
                ])
              ], 16, qL)) : Pt((L(), H("li", je({
                key: 1,
                id: o.id + "_" + l.getOptionIndex(A, S),
                style: { height: v ? v + "px" : void 0 },
                class: e.cx("option", { option: w, index: A, getItemOptions: S }),
                role: "option",
                "aria-label": l.getOptionLabel(w),
                "aria-selected": l.isSelected(w),
                "aria-disabled": l.isOptionDisabled(w),
                "aria-setsize": l.ariaSetSize,
                "aria-posinset": l.getAriaPosInset(l.getOptionIndex(A, S)),
                onClick: (T) => l.onOptionSelect(T, w, l.getOptionIndex(A, S)),
                onMousedown: (T) => l.onOptionMouseDown(T, l.getOptionIndex(A, S)),
                onMousemove: (T) => l.onOptionMouseMove(T, l.getOptionIndex(A, S)),
                onTouchend: t[2] || (t[2] = (T) => l.onOptionTouchEnd()),
                onDblclick: (T) => l.onOptionDblClick(T, w)
              }, { ref_for: !0 }, l.getPTOptions(w, S, A, "option"), {
                "data-p-selected": l.isSelected(w),
                "data-p-focused": o.focusedOptionIndex === l.getOptionIndex(A, S),
                "data-p-disabled": l.isOptionDisabled(w)
              }), [
                e.checkmark ? (L(), H(He, { key: 0 }, [
                  l.isSelected(w) ? (L(), be(p, je({
                    key: 0,
                    class: e.cx("optionCheckIcon")
                  }, { ref_for: !0 }, e.ptm("optionCheckIcon")), null, 16, ["class"])) : (L(), be(h, je({
                    key: 1,
                    class: e.cx("optionBlankIcon")
                  }, { ref_for: !0 }, e.ptm("optionBlankIcon")), null, 16, ["class"]))
                ], 64)) : ue("", !0),
                It(e.$slots, "option", {
                  option: w,
                  selected: l.isSelected(w),
                  index: l.getOptionIndex(A, S)
                }, () => [
                  vt(U(l.getOptionLabel(w)), 1)
                ])
              ], 16, QL)), [
                [b]
              ])
            ], 64))), 128)),
            o.filterValue && (!I || I && I.length === 0) ? (L(), H("li", je({
              key: 0,
              class: e.cx("emptyMessage"),
              role: "option"
            }, e.ptm("emptyMessage")), [
              It(e.$slots, "emptyfilter", {}, () => [
                vt(U(l.emptyFilterMessageText), 1)
              ])
            ], 16)) : !e.options || e.options && e.options.length === 0 ? (L(), H("li", je({
              key: 1,
              class: e.cx("emptyMessage"),
              role: "option"
            }, e.ptm("emptyMessage")), [
              It(e.$slots, "empty", {}, () => [
                vt(U(l.emptyMessageText), 1)
              ])
            ], 16)) : ue("", !0)
          ], 16, JL)
        ]),
        _: 2
      }, [
        e.$slots.loader ? {
          name: "loader",
          fn: _(({ options: E }) => [
            It(e.$slots, "loader", { options: E })
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["items", "style", "disabled", "pt"])
    ], 16),
    It(e.$slots, "footer", {
      value: e.d_value,
      options: l.visibleOptions
    }),
    !e.options || e.options && e.options.length === 0 ? (L(), H("span", je({
      key: 2,
      role: "status",
      "aria-live": "polite",
      class: "p-hidden-accessible"
    }, e.ptm("hiddenEmptyMessage"), { "data-p-hidden-accessible": !0 }), U(l.emptyMessageText), 17)) : ue("", !0),
    y("span", je({
      role: "status",
      "aria-live": "polite",
      class: "p-hidden-accessible"
    }, e.ptm("hiddenSelectedMessage"), { "data-p-hidden-accessible": !0 }), U(l.selectedMessageText), 17),
    y("span", je({
      ref: "lastHiddenFocusableElement",
      role: "presentation",
      "aria-hidden": "true",
      class: "p-hidden-accessible p-hidden-focusable",
      tabindex: e.disabled ? -1 : e.tabindex,
      onFocus: t[6] || (t[6] = (...E) => l.onLastHiddenFocus && l.onLastHiddenFocus(...E))
    }, e.ptm("hiddenLastFocusableEl"), {
      "data-p-hidden-accessible": !0,
      "data-p-hidden-focusable": !0
    }), null, 16, eO)
  ], 16, ZL);
}
const nO = /* @__PURE__ */ Vt(KL, [["render", tO]]), aO = {
  class: /* @__PURE__ */ Ge("flex mt-2 text-lg bold")
}, oO = { class: "col-4-no-padding" }, lO = { class: "col-span-8 no-padding" }, iO = { class: "col-4-no-padding" }, sO = { class: "col no-padding" }, rO = { class: "col-4-no-padding" }, uO = { class: "col-span-8 no-padding" }, cO = /* @__PURE__ */ Je({
  __name: "ProductionOptionsComponent",
  props: /* @__PURE__ */ Rn({
    productionCenterList: {}
  }, {
    setupParams: { required: !0 },
    setupParamsModifiers: {}
  }),
  emits: ["update:setupParams"],
  setup(e) {
    const t = Nn(e, "setupParams"), n = e, a = () => {
      if (t.value != null) {
        const o = t.value.materialLibrary.selectedItem;
        o != null && (t.value.color.items = _L(o.productionCenterId, o.materialId, n.productionCenterList), t.value.color.selectedItem = t.value.color.items[0], t.value.presetLibrary.items = wL(o.productionCenterId, o.materialId, n.productionCenterList), t.value.presetLibrary.selectedItem = t.value.presetLibrary.items[0]);
      }
    };
    return (o, l) => (L(), be(r(we), { class: "flex-col w-full" }, {
      default: _(() => [
        y("div", aO, U(o.$t("implant-planner.productionOptions")), 1),
        d(r(we), { class: "flex-row" }, {
          default: _(() => [
            d(r(we), { class: "flex-col col-span-6" }, {
              default: _(() => [
                d(r(we), {
                  class: "mt-6",
                  style: { "align-items": "baseline" }
                }, {
                  default: _(() => [
                    y("div", oO, [
                      y("span", null, U(o.$t("shared.materialLibrary")), 1)
                    ]),
                    y("div", lO, [
                      d(r($n), {
                        modelValue: t.value.materialLibrary.selectedItem,
                        "onUpdate:modelValue": [
                          l[0] || (l[0] = (s) => t.value.materialLibrary.selectedItem = s),
                          a
                        ],
                        options: t.value.materialLibrary.items,
                        class: "w-full",
                        optionLabel: "name",
                        placeholder: o.$t("implant-planner.none"),
                        showClear: !0
                      }, null, 8, ["modelValue", "options", "placeholder"])
                    ])
                  ]),
                  _: 1
                }),
                d(r(we), {
                  class: "mt-6",
                  style: { "align-items": "baseline" }
                }, {
                  default: _(() => [
                    y("div", iO, [
                      y("span", null, U(o.$t("shared.color")), 1)
                    ]),
                    y("div", sO, [
                      d(r($n), {
                        modelValue: t.value.color.selectedItem,
                        "onUpdate:modelValue": l[1] || (l[1] = (s) => t.value.color.selectedItem = s),
                        options: t.value.color.items,
                        class: "w-full",
                        optionLabel: "name",
                        placeholder: o.$t("implant-planner.none"),
                        showClear: !0
                      }, null, 8, ["modelValue", "options", "placeholder"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(we), { class: "flex-col col-span-6 ml-2" }, {
              default: _(() => [
                d(r(we), {
                  class: "mt-6",
                  style: { "align-items": "baseline" }
                }, {
                  default: _(() => [
                    y("div", rO, [
                      y("span", null, U(o.$t("implant-planner.presetLibrary")), 1)
                    ]),
                    y("div", uO, [
                      d(r($n), {
                        modelValue: t.value.presetLibrary.selectedItem,
                        "onUpdate:modelValue": l[2] || (l[2] = (s) => t.value.presetLibrary.selectedItem = s),
                        options: t.value.presetLibrary.items,
                        class: "w-full",
                        optionLabel: "name",
                        placeholder: o.$t("implant-planner.none"),
                        showClear: !0
                      }, null, 8, ["modelValue", "options", "placeholder"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), dO = {
  class: /* @__PURE__ */ Ge("flex mt-2 text-lg bold")
}, pO = {
  class: /* @__PURE__ */ Ge("flex mt-2")
}, mO = {
  class: "flex flex-col",
  style: { "text-align": "center" }
}, fO = { key: 0 }, gO = /* @__PURE__ */ Je({
  __name: "SmileSetupComponent",
  props: /* @__PURE__ */ Rn({
    context: {}
  }, {
    setupParams: { required: !0 },
    setupParamsModifiers: {}
  }),
  emits: ["update:setupParams"],
  setup(e) {
    const { t } = Ht(), n = e, a = Nn(e, "setupParams"), o = Aa(), l = (s) => {
      o.open(Zl, {
        props: {
          closable: !0,
          modal: !0,
          header: t("implant-planner.uploadImage"),
          contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
        },
        data: {
          dropArea: !0,
          selectFilesBtn: !0,
          selectFolderBtn: !0,
          accept: ep,
          writeToWasmFS: !1,
          filterAssociatedFiles: !1,
          singleSelection: !0,
          showTypeColumn: !1,
          hideTreeWhenNoFolders: !0,
          showAccept: !0
        },
        emits: {
          onUploadFiles: async (i) => {
            let u = null;
            s == Ua.eP_LEFT ? u = St.eOT_TEXTURED_LEFT_IMAGE : s == Ua.eP_RIGHT ? u = St.eOT_TEXTURED_RIGHT_IMAGE : s == Ua.eP_FRONT ? u = St.eOT_TEXTURED_FRONT_IMAGE : s == Ua.eP_TOP && (u = St.eOT_TEXTURED_TOP_IMAGE), console.log("onUploadFiles called from emit - image files: ", i, "cadType", u);
            const c = await ss(i, n.context, "Image 2D", !0, u ?? St.eOT_TEXTURED_FRONT_IMAGE);
            if (c) {
              const p = Wn(n.context.getContextCAD().GetMainForm());
              if (!p) return;
              if (p.AddSTLObject(c.id), a.value) {
                const h = n.context.viewConfiguration.colorScheme.get(), g = await Bi(c, !0, h);
                a.value[s].items.push({ id: c.id, preview: g, selected: !0 });
              }
            }
          }
        }
      });
    };
    return (s, i) => a.value ? (L(), be(r(we), {
      key: 0,
      class: "flex-col w-full"
    }, {
      default: _(() => [
        y("div", dO, U(s.$t("implant-planner.smileSetup")), 1),
        y("div", pO, U(s.$t("implant-planner.clickOnEachIconToUploadTheCorrespondentDPicture")), 1),
        d(r(we), {
          class: "flex-row gap-2 mt-2",
          style: { "justify-content": "space-around" }
        }, {
          default: _(() => [
            (L(!0), H(He, null, jt(a.value, (u, c) => (L(), be(r(we), {
              key: c,
              class: "flex-col"
            }, {
              default: _(() => [
                y("div", mO, U(u.label), 1),
                d(r(we), { class: "flex-row justify-center" }, {
                  default: _(() => [
                    d(r(Ne), {
                      class: "mt-2",
                      dropdown: !!u.items.length,
                      disabled: !u.items.length,
                      "dropdown-location-top": !0,
                      togglable: !0,
                      toggled: u.items.findIndex((p) => p.selected) != -1,
                      "icon-src": `/cad/head/${u.iconSrc}.png`,
                      "icon-src-height": "50px",
                      "icon-src-width": "50px",
                      ignoreSvgFilter: !0,
                      style: { width: "66px", overflow: "visible" }
                    }, {
                      default: _(() => [
                        u.items.length ? (L(), H("div", fO, [
                          (L(!0), H(He, null, jt(u.items, (p, h) => (L(), be(r(Ne), {
                            key: h,
                            "preview-src": p.preview,
                            togglable: !0,
                            toggled: p.selected,
                            "onUpdate:toggled": (g) => p.selected = g,
                            ignoreSvgFilter: !0,
                            iconSrcObjectFit: "contain",
                            iconSrcPadding: "5px",
                            style: { width: "66px", height: "66px", padding: "0" }
                          }, null, 8, ["preview-src", "toggled", "onUpdate:toggled"]))), 128))
                        ])) : ue("", !0)
                      ]),
                      _: 2
                    }, 1032, ["dropdown", "disabled", "toggled", "icon-src"])
                  ]),
                  _: 2
                }, 1024),
                d(r(we), { class: "flex-row justify-center" }, {
                  default: _(() => [
                    d(r(Ne), {
                      class: "mt-2 no-padding",
                      "icon-src": "/icons/new_icons/ik_loadFromLibrary.svg",
                      "icon-src-height": "28px",
                      "icon-src-width": "28px",
                      iconSrcPadding: "5px",
                      style: { width: "28px" },
                      onClick: (p) => l(c)
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : ue("", !0);
  }
}), hO = {
  class: "p-dialog-header text-4xl flex-col",
  style: { "justify-content": "center !important" }
}, bO = {
  class: /* @__PURE__ */ Ge("text-4xl bold flex mt-2")
}, vO = { class: "flex-col" }, yO = {
  class: /* @__PURE__ */ Ge("text-2xl bold flex mt-2")
}, _O = {
  class: /* @__PURE__ */ Ge("flex mt-2 text-lg")
}, wO = {
  class: "flex",
  style: { flex: "1 1 0" }
}, IO = {
  class: "flex mt-2",
  style: { flex: "2 1 0" }
}, SO = {
  class: "flex",
  style: { flex: "1 1 0" }
}, EO = {
  key: 0,
  class: /* @__PURE__ */ Ge("mt-2 flex"),
  style: { "align-items": "baseline" }
}, TO = { class: "col-4 no-padding" }, CO = {
  class: "col-2 no-padding flex justify-end",
  style: { "align-self": "center" }
}, NO = {
  class: "no-padding ml-2 grow",
  style: { overflow: "hidden" }
}, LO = {
  key: 0,
  class: /* @__PURE__ */ Ge("mt-2 flex"),
  style: { "align-items": "baseline" }
}, OO = { class: "col-4 no-padding" }, DO = {
  class: "col-2 no-padding flex justify-end",
  style: { "align-self": "center" }
}, AO = {
  class: "no-padding ml-2 grow",
  style: { overflow: "hidden" }
}, RO = /* @__PURE__ */ Je({
  __name: "ReconstructionSetupComponentRedesign",
  props: /* @__PURE__ */ Rn({
    context: {},
    productionCenterList: {},
    isCADReconstruction: { type: Boolean }
  }, {
    setupParams: { required: !0 },
    setupParamsModifiers: {},
    smileSetupParams: { required: !0 },
    smileSetupParamsModifiers: {},
    productionSetupParams: { required: !0 },
    productionSetupParamsModifiers: {}
  }),
  emits: /* @__PURE__ */ Rn(["confirm"], ["update:setupParams", "update:smileSetupParams", "update:productionSetupParams"]),
  setup(e, { emit: t }) {
    const { t: n } = Ht(), a = `${ki},${Qd}`, o = Aa(), l = e, s = Nn(e, "setupParams"), i = Nn(e, "smileSetupParams"), u = Nn(e, "productionSetupParams"), c = () => {
      o.open(qm, {
        props: {
          modal: !0,
          showHeader: !1,
          contentStyle: { borderRadius: "16px" }
        },
        data: {
          context: l.context
        },
        emits: {
          onConfirm: (S, f, v) => {
            s.value.selectedTeethLibrary = S, s.value.selectedTeethLibraryModelName = f, s.value.selectedTeethLibraryGUID = v;
          }
        }
      });
    }, p = l.context.settings.general.useUSStyleToothChart;
    function h(S) {
      return S === Xt.MANDIBLE ? rs(l.context.settings.general.useUSStyleToothChart) : us(l.context.settings.general.useUSStyleToothChart);
    }
    function g(S, f) {
      if (!S) return null;
      const v = h(f)[S - 1];
      let w;
      if (f == Xt.MAXILLA ? w = s.value.maxillaTeeth.find((A) => A.id === S) : f == Xt.MANDIBLE && (w = s.value.mandibleTeeth.find((A) => A.id === S)), !w) throw new Error(`Tooth with id ${S} not found!`);
      return { name: v, tooth: w };
    }
    let b = -1, E = -1;
    function m(S, f, v) {
      const w = g(S, v);
      if (w)
        if (f.shiftKey) {
          let A = -1, T = -1;
          v == Xt.MAXILLA ? (s.value.maxillaTeeth.forEach((O) => {
            O.status = pt.EMPTY, O.hoverIcon = Mn.ADD;
          }), A = Math.min(S, b), T = Math.max(S, b)) : v == Xt.MANDIBLE && (s.value.mandibleTeeth.forEach((O) => {
            O.status = pt.EMPTY, O.hoverIcon = Mn.ADD;
          }), A = Math.min(S, E), T = Math.max(S, E));
          for (let O = A; O <= T; O++) {
            const C = g(O, v);
            if (!C)
              return;
            C.tooth.status = pt.OK, C.tooth.hoverIcon = Mn.REMOVE;
          }
        } else
          w.tooth.hoverIcon === Mn.ADD ? (console.log("Add clicked", w), w.tooth.status = pt.OK, w.tooth.hoverIcon = Mn.REMOVE, v == Xt.MAXILLA ? b = S : v == Xt.MANDIBLE && (E = S)) : w.tooth.hoverIcon === Mn.REMOVE && (console.log("Remove clicked", w), w.tooth.status = pt.EMPTY, w.tooth.hoverIcon = Mn.ADD);
    }
    const I = (S) => {
      const f = () => {
        o.open(Zl, {
          props: {
            closable: !0,
            modal: !0,
            header: n("shared.uploadFile"),
            contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" },
            style: { minWidth: "40vw" }
          },
          data: {
            dropArea: !0,
            selectFilesBtn: !0,
            selectFolderBtn: !0,
            accept: a,
            context: l.context,
            objectName: Dl.value[S],
            singleSelection: !0,
            showTypeColumn: !1,
            hideTreeWhenNoFolders: !0,
            showAccept: !0
          },
          emits: {
            onUploadFiles: async (v) => {
              console.log("onImportFromFile -> onUploadFiles: ", v);
              const w = await ss(v, l.context, Dl.value[S], !1, gL[S]);
              if (w) {
                const A = Wn(l.context.getContextCAD().GetMainForm());
                if (!A) return;
                A.AddSTLObject(w.id);
                const T = Wn(l.context.getContextCAD().GetXAddReconstructionObject());
                T.FillType(kd[S]), s.value.dropdownItems[S].items = Yn(T.GetObjectsList(kd[S])), s.value.dropdownItems[S].selectedItem = { name: w.getGUIName() };
              }
            }
          }
        });
      };
      l.isCADReconstruction ? o.open(hf, {
        props: {
          closable: !0,
          modal: !0,
          header: n("shared.import"),
          style: { width: "20vw" },
          contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
        },
        emits: {
          onImportFromFile: () => {
            console.log("onImportFromFile"), f();
          },
          onImportFromPlanner: async () => {
            console.log("onImportFromPlanner");
            const v = await l.context.getObjects().getObjectImportPreviewList();
            o.open(cp, {
              props: {
                closable: !0,
                modal: !0,
                header: n("shared.uploadFile"),
                style: { width: "23rem" },
                contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
              },
              data: {
                importObjects: v
              },
              emits: {
                onProceedToImport: (w) => {
                  console.log("onImportFromPlanner -> onProceedToImport: ", w), console.log("Upload objet as type", S);
                }
              }
            });
          }
        }
      }) : f();
    };
    return (S, f) => {
      const v = vu, w = gO, A = cO, T = nO;
      return L(), be(r(we), {
        class: "flex-col w-full h-full",
        style: { overflow: "hidden" }
      }, {
        default: _(() => [
          y("div", hO, [
            y("div", bO, U(S.$t("implant-planner.addNewReconstruction")), 1)
          ]),
          d(r(we), {
            class: "flex-row grow gap-2 mt-2",
            style: { "align-items": "center" }
          }, {
            default: _(() => [
              d(r(we), {
                class: "flex-col",
                style: { flex: "1 1 0" }
              }, {
                default: _(() => [
                  y("div", vO, [
                    y("div", yO, U(s.value.headerText), 1),
                    y("div", _O, U(s.value.instructionsText), 1)
                  ]),
                  d(r(we), { class: "flex-col mt-8" }, {
                    default: _(() => [
                      y("div", wO, [
                        y("span", null, U(S.$t("implant-planner.editreplaceTheName")), 1)
                      ]),
                      y("div", IO, [
                        d(v, {
                          class: "flex justify-end w-full",
                          modelValue: s.value.reconstructionName,
                          "onUpdate:modelValue": f[0] || (f[0] = (O) => s.value.reconstructionName = O)
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  s.value.selectTeethLibrary ? (L(), be(r(we), {
                    key: 0,
                    class: "flex-col mt-2"
                  }, {
                    default: _(() => [
                      y("div", SO, [
                        y("span", null, U(S.$t("implant-planner.selectTeethLibrary")), 1)
                      ]),
                      d(r(Ne), {
                        class: "flex mt-2",
                        label: s.value.selectedTeethLibrary,
                        onClick: c
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  })) : ue("", !0),
                  i.value ? (L(), be(r(we), {
                    key: 1,
                    class: "flex-row mt-2",
                    style: { "border-top": "3px solid rgba(255, 255, 255, 0.02)" }
                  }, {
                    default: _(() => [
                      d(w, {
                        "setup-params": i.value,
                        "onUpdate:setupParams": f[1] || (f[1] = (O) => i.value = O),
                        context: e.context
                      }, null, 8, ["setup-params", "context"])
                    ]),
                    _: 1
                  })) : ue("", !0),
                  u.value ? (L(), be(r(we), {
                    key: 2,
                    class: "flex-row mt-6",
                    style: { "border-top": "3px solid rgba(255, 255, 255, 0.02)" }
                  }, {
                    default: _(() => [
                      d(A, {
                        "setup-params": u.value,
                        "onUpdate:setupParams": f[2] || (f[2] = (O) => u.value = O),
                        "production-center-list": e.productionCenterList
                      }, null, 8, ["setup-params", "production-center-list"])
                    ]),
                    _: 1
                  })) : ue("", !0)
                ]),
                _: 1
              }),
              d(r(we), {
                class: "",
                style: { flex: "1 1 0", "align-items": "center", "justify-content": "center", background: "rgba(255, 255, 255, 0.02)", "border-radius": "24px", padding: "32px 32px 32px 32px !important" }
              }, {
                default: _(() => [
                  d(r(we), { class: "flex-col" }, {
                    default: _(() => [
                      d(r(sr), {
                        class: "justify-center",
                        jawboneType: r(Xt).MAXILLA,
                        teeth: s.value.maxillaTeeth,
                        useUSStyleToothChart: r(p),
                        warningString: "",
                        "show-lines": !0,
                        onToothClick: m
                      }, null, 8, ["jawboneType", "teeth", "useUSStyleToothChart"]),
                      d(r(sr), {
                        class: "justify-center",
                        jawboneType: r(Xt).MANDIBLE,
                        teeth: s.value.mandibleTeeth,
                        useUSStyleToothChart: r(p),
                        warningString: "",
                        "show-lines": !0,
                        onToothClick: m
                      }, null, 8, ["jawboneType", "teeth", "useUSStyleToothChart"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              d(r(we), {
                class: "flex-row grow",
                style: { flex: "1 1 0" }
              }, {
                default: _(() => [
                  d(r(we), {
                    class: "flex-col ml-2 h-full w-full",
                    style: { flex: "2 1 0" }
                  }, {
                    default: _(() => [
                      d(r(we), {
                        class: "flex-col justify-end",
                        style: { flex: "1 1 0", padding: "16px 0 16px 0" }
                      }, {
                        default: _(() => [
                          (L(!0), H(He, null, jt(s.value.dropdownItems, (O, C) => (L(), H(He, { key: C }, [
                            O.visible && C < r($e).eDI_MODEL ? (L(), H("div", EO, [
                              y("div", TO, [
                                y("span", null, U(r(Dl)[C]), 1)
                              ]),
                              y("div", CO, [
                                O.showImportBtn ? (L(), be(r(Ne), {
                                  key: 0,
                                  class: Ge("no-padding"),
                                  "icon-src": "/icons/new_icons/ik_loadFromLibrary.svg",
                                  iconSrcPadding: "5px",
                                  onClick: (k) => I(C)
                                }, null, 8, ["onClick"])) : ue("", !0)
                              ]),
                              y("div", NO, [
                                d(r($n), {
                                  modelValue: O.selectedItem,
                                  "onUpdate:modelValue": (k) => O.selectedItem = k,
                                  options: O.items,
                                  class: "w-full",
                                  optionLabel: "name",
                                  placeholder: S.$t("implant-planner.none"),
                                  showClear: !0
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
                              ])
                            ])) : ue("", !0)
                          ], 64))), 128))
                        ]),
                        _: 1
                      }),
                      d(r(we), {
                        class: "flex-col",
                        style: { flex: "1 1 0", padding: "16px 0 16px 0" }
                      }, {
                        default: _(() => [
                          (L(!0), H(He, null, jt(s.value.dropdownItems, (O, C) => (L(), H(He, { key: C }, [
                            O.visible && C >= r($e).eDI_MODEL && C < r($e).eDI_UPPER_GENERIC ? (L(), H("div", LO, [
                              y("div", OO, [
                                y("span", null, U(r(Dl)[C]), 1)
                              ]),
                              y("div", DO, [
                                O.showImportBtn ? (L(), be(r(Ne), {
                                  key: 0,
                                  class: Ge("no-padding"),
                                  "icon-src": "/icons/new_icons/ik_loadFromLibrary.svg",
                                  iconSrcPadding: "5px",
                                  onClick: (k) => I(C)
                                }, null, 8, ["onClick"])) : ue("", !0)
                              ]),
                              y("div", AO, [
                                d(r($n), {
                                  modelValue: O.selectedItem,
                                  "onUpdate:modelValue": (k) => O.selectedItem = k,
                                  options: O.items,
                                  class: "w-full",
                                  optionLabel: "name",
                                  placeholder: S.$t("implant-planner.none"),
                                  showClear: !0
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"])
                              ])
                            ])) : ue("", !0)
                          ], 64))), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  s.value.dropdownItems[r($e).eDI_LOWER_GENERIC].visible || s.value.dropdownItems[r($e).eDI_UPPER_GENERIC].visible ? (L(), be(r(we), {
                    key: 0,
                    class: "grow flex-col justify-center ml-4 w-full",
                    style: { flex: "1 1 0" }
                  }, {
                    default: _(() => [
                      (L(!0), H(He, null, jt([r($e).eDI_UPPER_GENERIC, r($e).eDI_LOWER_GENERIC], (O, C) => (L(), H(He, { key: C }, [
                        d(r(we), {
                          class: Ge([O == r($e).eDI_UPPER_GENERIC ? "justify-end" : "", "flex-col mt-12"]),
                          style: { "flex-grow": "2" }
                        }, {
                          default: _(() => [
                            s.value.dropdownItems[O].visible ? (L(), H(He, { key: 0 }, [
                              d(r(we), { class: "flex-row" }, {
                                default: _(() => [
                                  d(r(we), {
                                    class: "no-padding grow",
                                    style: { "align-self": "center" }
                                  }, {
                                    default: _(() => [
                                      y("span", null, U(r(Dl)[O]), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  d(r(we), {
                                    class: "no-padding grow-0 justify-end",
                                    style: { "align-self": "center" }
                                  }, {
                                    default: _(() => [
                                      s.value.dropdownItems[O].showImportBtn ? (L(), be(r(Ne), {
                                        key: 0,
                                        class: Ge("no-padding"),
                                        "icon-src": "/icons/new_icons/ik_loadFromLibrary.svg",
                                        iconSrcPadding: "5px",
                                        onClick: (k) => I(C)
                                      }, null, 8, ["onClick"])) : ue("", !0)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              d(T, {
                                class: "mt-2",
                                style: { "min-height": "80px" },
                                modelValue: s.value.dropdownItems[O].selectedItem,
                                "onUpdate:modelValue": (k) => s.value.dropdownItems[O].selectedItem = k,
                                options: s.value.dropdownItems[O].items,
                                multiple: "",
                                optionLabel: "name"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                            ], 64)) : ue("", !0)
                          ]),
                          _: 2
                        }, 1032, ["class"]),
                        O == r($e).eDI_UPPER_GENERIC ? (L(), be(r(we), {
                          key: 0,
                          class: "grow"
                        })) : ue("", !0)
                      ], 64))), 128))
                    ]),
                    _: 1
                  })) : ue("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), _f = /* @__PURE__ */ Je({
  __name: "ReconstructionSetupDialogRedesign",
  emits: ["confirm", "reject"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data;
    let o, l;
    const s = ia(), i = Aa();
    let u = B(!1);
    Dt(async () => {
      o = a.context, l = [], a.preselectedMode != null && (a.preselectedMode == ma.eCREATE_WAXUP && (b(ge.eRD_DIGITAL_SMILE_DESIGN), await A(Ue.eWF_NONE, "")), a.preselectedMode == ma.eTMJ_DIAGNOSIS && (b(ge.eRD_TMJ_DIAGNOSIS), await A(Ue.eWF_NONE, ""))), u.value = !0;
    });
    const { t: c } = Ht(), p = t, h = B(null), g = B(null), b = (k) => {
      console.log("Selected type", k), h.value = k;
    }, E = () => {
      h.value = null, g.value = null;
    }, m = Ce(() => u.value ? g.value != null ? 2 : h.value != null ? 1 : 0 : -1), I = Ce(() => {
      if (m.value == 0 || a.preselectedMode != null)
        return c("shared.cancel");
      if (m.value == 1)
        return c("implant-planner.selectReconstructionType");
      if (m.value == 2)
        return c("implant-planner.selectWorkflow");
    }), S = Ce(() => m.value == 2 ? c("shared.ok") : c("shared.next")), f = B({
      headerText: "",
      instructionsText: "",
      reconstructionName: "",
      selectTeethLibrary: !0,
      selectedTeethLibrary: "",
      selectedTeethLibraryModelName: "",
      selectedTeethLibraryGUID: "",
      dropdownItems: {
        [$e.eDI_MODEL_ANTAGONIST]: { visible: !0, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_GINGIVA_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_WAXUP_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_MARKER_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_DENTURE_ANTAGONIST]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_FACE_SCAN]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_MODEL]: { visible: !0, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_GINGIVA]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_WAXUP]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_MARKER]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_DENTURE]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_MOVEMENT_MARKER]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_UPPER_GENERIC]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] },
        [$e.eDI_LOWER_GENERIC]: { visible: !1, showImportBtn: !0, selectedItem: null, items: [] }
      },
      teethMapEnabled: !0,
      maxillaTeeth: [],
      mandibleTeeth: []
    }), v = B(null), w = B(null), A = async (k, M) => {
      if (console.log("Workflow Selected type", k), g.value = k, h.value != null && g.value != null) {
        const z = await df(o, h.value, g.value, M, a.preselectedMode, a.preselectedWorkFlow, s);
        if (f.value = z.setupParams, z.smileParams && um() ? (console.log("SmileParams", z.smileParams), v.value = await pf(o)) : v.value = null, z.productionParams) {
          const j = mf(h.value, g.value, l);
          console.log("productionParams", j), w.value = {
            materialLibrary: {
              selectedItem: null,
              items: j
            },
            color: {
              selectedItem: null,
              items: []
            },
            presetLibrary: {
              selectedItem: null,
              items: []
            }
          };
        } else
          w.value = null;
      }
    }, T = () => {
      g.value = null;
    };
    lt(f.value.dropdownItems[$e.eDI_MODEL], () => {
      console.log("setupParams.value.dropdownItems[TDropdownItem.eDI_MODEL] changed", f.value.dropdownItems[$e.eDI_MODEL]);
    }), lt(
      f,
      () => {
        console.log("SetupParams changed", f);
      },
      { deep: !0 }
    ), lt(
      v,
      () => {
        console.log("smileParams changed", v);
      },
      { deep: !0 }
    ), lt(
      w,
      () => {
        console.log("productionParams changed", w);
      },
      { deep: !0 }
    );
    const O = async () => {
      o.freezeWizardPanel(!0), console.log("ReconstructionDialog proceed 0");
      const k = Wn(o.getContextCAD().GetXAddReconstructionObject());
      k.SetModeWorkflowName(h.value, g.value, f.value.reconstructionName);
      let M = f.value.dropdownItems[$e.eDI_MODEL_ANTAGONIST].selectedItem, z = f.value.dropdownItems[$e.eDI_MODEL_ANTAGONIST].visible;
      k.SelectedSelectionChanged(M ? M.name : "", z, et.eANTAGONIST), M = f.value.dropdownItems[$e.eDI_GINGIVA_ANTAGONIST].selectedItem, z = f.value.dropdownItems[$e.eDI_GINGIVA_ANTAGONIST].visible, k.SelectedSelectionChanged(M ? M.name : "", z, et.eGINGIVA_ANTAGONIST), M = f.value.dropdownItems[$e.eDI_WAXUP_ANTAGONIST].selectedItem, z = f.value.dropdownItems[$e.eDI_WAXUP_ANTAGONIST].visible, k.SelectedSelectionChanged(M ? M.name : "", z, et.eWAXUP_ANTAGONIST), M = f.value.dropdownItems[$e.eDI_MARKER_ANTAGONIST].selectedItem, z = f.value.dropdownItems[$e.eDI_MARKER_ANTAGONIST].visible, k.SelectedSelectionChanged(M ? M.name : "", z, et.eMARKER_ANTAGONIST), M = f.value.dropdownItems[$e.eDI_DENTURE_ANTAGONIST].selectedItem, z = f.value.dropdownItems[$e.eDI_DENTURE_ANTAGONIST].visible, k.SelectedSelectionChanged(M ? M.name : "", z, et.eDENTURE_ANTAGONIST), M = f.value.dropdownItems[$e.eDI_FACE_SCAN].selectedItem, z = f.value.dropdownItems[$e.eDI_FACE_SCAN].visible, k.SelectedSelectionChanged(M ? M.name : "", z, et.eFACE_SCAN), M = f.value.dropdownItems[$e.eDI_MODEL].selectedItem, z = f.value.dropdownItems[$e.eDI_MODEL].visible, k.SelectedSelectionChanged(M ? M.name : "", z, et.eMODEL), M = f.value.dropdownItems[$e.eDI_GINGIVA].selectedItem, z = f.value.dropdownItems[$e.eDI_GINGIVA].visible, k.SelectedSelectionChanged(M ? M.name : "", z, et.eGINGIVA), M = f.value.dropdownItems[$e.eDI_WAXUP].selectedItem, z = f.value.dropdownItems[$e.eDI_WAXUP].visible, k.SelectedSelectionChanged(M ? M.name : "", z, et.eWAXUP), M = f.value.dropdownItems[$e.eDI_MARKER].selectedItem, z = f.value.dropdownItems[$e.eDI_MARKER].visible, k.SelectedSelectionChanged(M ? M.name : "", z, et.eMARKER), M = f.value.dropdownItems[$e.eDI_DENTURE].selectedItem, z = f.value.dropdownItems[$e.eDI_DENTURE].visible, k.SelectedSelectionChanged(M ? M.name : "", z, et.eDENTURE), M = f.value.dropdownItems[$e.eDI_MOVEMENT_MARKER].selectedItem, z = f.value.dropdownItems[$e.eDI_MOVEMENT_MARKER].visible, console.log("Movement maker selected name: ", M), k.SelectedSelectionChanged(M ? M.name : "", z, et.eMOVEMENT_MARKER);
      const j = new o.module.VectorString(), K = f.value.dropdownItems[$e.eDI_UPPER_GENERIC].selectedItem;
      if (z = f.value.dropdownItems[$e.eDI_UPPER_GENERIC].visible, K)
        if (Array.isArray(K))
          for (const se of K)
            j.push_back(se.name);
        else
          j.push_back(K.name);
      k.SelectedGenericSelectionChanged(j, z, et.eGENERIC_UPPER), j.delete();
      const x = new o.module.VectorString(), N = f.value.dropdownItems[$e.eDI_LOWER_GENERIC].selectedItem;
      if (z = f.value.dropdownItems[$e.eDI_LOWER_GENERIC].visible, N)
        if (Array.isArray(N))
          for (const se of N)
            x.push_back(se.name);
        else
          x.push_back(N.name);
      if (k.SelectedGenericSelectionChanged(x, z, et.eGENERIC_LOWER), x.delete(), v.value) {
        let se = new o.module.VectorString();
        for (let Le of v.value[Ua.eP_FRONT].items)
          Le.selected && se.push_back(Le.id.toString());
        k.SetSelected2DImage(St.eOT_TEXTURED_FRONT_IMAGE, se), se.delete(), se = new o.module.VectorString();
        for (let Le of v.value[Ua.eP_RIGHT].items)
          Le.selected && se.push_back(Le.id.toString());
        k.SetSelected2DImage(St.eOT_TEXTURED_RIGHT_IMAGE, se), se.delete(), se = new o.module.VectorString();
        for (let Le of v.value[Ua.eP_LEFT].items)
          Le.selected && se.push_back(Le.id.toString());
        k.SetSelected2DImage(St.eOT_TEXTURED_LEFT_IMAGE, se), se.delete(), se = new o.module.VectorString();
        for (let Le of v.value[Ua.eP_TOP].items)
          Le.selected && se.push_back(Le.id.toString());
        k.SetSelected2DImage(St.eOT_TEXTURED_TOP_IMAGE, se), se.delete();
      }
      const G = new o.module.VectorString();
      for (const se of f.value.mandibleTeeth)
        se.status != pt.EMPTY && G.push_back(se.toothName);
      for (const se of f.value.maxillaTeeth)
        se.status != pt.EMPTY && G.push_back(se.toothName);
      k.SetTeethList(G), G.delete(), await Kr(s, o, f.value.selectedTeethLibraryModelName, f.value.selectedTeethLibraryGUID), k.SetSelectedLibrary(f.value.selectedTeethLibraryModelName, f.value.selectedTeethLibraryGUID);
      const ce = (se) => {
        o.freezeWizardPanel(!1);
        let Le = !0;
        return i.open(tp, {
          props: {
            closable: !1,
            draggable: !1,
            modal: !0,
            header: se.GetLabel(),
            style: { width: "25vw" }
          },
          data: {
            message: se.GetMessage(),
            showCancel: se.GetShowCancel(),
            showYesNo: se.GetYesNo()
          },
          emits: {
            onConfirm: () => {
              console.log("confirmed"), Le = !0;
            },
            onReject: () => {
              console.log("rejected"), Le = !1;
            }
          }
        }), Le;
      };
      console.log("ReconstructionDialog proceed 3");
      const re = k.ValidateAndAddReconstruction(), Se = () => {
        const se = k.ValidateAndAddReconstruction2();
        se.GetInitialized() && ce(se);
      };
      if (console.log("ReconstructionDialog proceed 4", re.GetInitialized()), re.GetInitialized()) {
        const se = ce(re);
        re.GetYesNo() && se && Se();
        return;
      }
      o.getContextCAD().DeleteAddReconstructionObject(), o.freezeWizardPanel(!1), p("confirm"), n.value.close();
    }, C = () => {
      if (a.preselectedMode == null) {
        if (m.value == 2) {
          T();
          return;
        } else if (m.value == 1) {
          E();
          return;
        }
      }
      o.getContextCAD().DeleteAddReconstructionObject(), p("reject"), n.value.close();
    };
    return (k, M) => r(u) ? (L(), be(r(we), {
      key: 0,
      class: "flex-col",
      style: { overflow: "auto", "max-width": "70vw", "min-width": "60vw" }
    }, {
      default: _(() => [
        d(r(we), { class: "flex-row h-full mb-2" }, {
          default: _(() => [
            r(m) == 0 ? (L(), be(ff, {
              key: 0,
              class: "horizontal-padding",
              context: r(o),
              "preselected-type": r(a).preselectedMode,
              onTypeSelected: b,
              onModifyType: E,
              style: { flex: "1 1 0" }
            }, null, 8, ["context", "preselected-type"])) : ue("", !0),
            r(m) == 1 ? (L(), H(He, { key: 1 }, [
              r(h) != null ? (L(), be(gf, {
                key: 0,
                class: "horizontal-padding",
                context: r(o),
                reconstructionType: r(h),
                onWorkflowSelected: A,
                onModifyWorkflow: T,
                style: { flex: "1 1 0" }
              }, null, 8, ["context", "reconstructionType"])) : ue("", !0)
            ], 64)) : ue("", !0),
            r(m) == 2 ? (L(), H(He, { key: 2 }, [
              r(g) != null || r(a).preselectedMode != null ? (L(), be(RO, {
                key: 0,
                class: "horizontal-padding",
                context: r(o),
                "production-center-list": r(l),
                isCADReconstruction: r(a).preselectedMode == null,
                "setup-params": r(f),
                "onUpdate:setupParams": M[0] || (M[0] = (z) => Wa(f) ? f.value = z : null),
                "smile-setup-params": r(v),
                "onUpdate:smileSetupParams": M[1] || (M[1] = (z) => Wa(v) ? v.value = z : null),
                "production-setup-params": r(w),
                "onUpdate:productionSetupParams": M[2] || (M[2] = (z) => Wa(w) ? w.value = z : null),
                style: { flex: "2 1 0" }
              }, null, 8, ["context", "production-center-list", "isCADReconstruction", "setup-params", "smile-setup-params", "production-setup-params"])) : ue("", !0)
            ], 64)) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(we), { class: "p-dialog-footer justify-center" }, {
          default: _(() => [
            d(r(ya), {
              class: "mt-6",
              label: r(I),
              onClick: M[3] || (M[3] = (z) => C())
            }, null, 8, ["label"]),
            d(r(la), {
              disabled: r(h) == null || r(g) == null,
              class: "mt-6",
              label: r(S),
              onClick: O
            }, null, 8, ["disabled", "label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })) : ue("", !0);
  }
}), MO = {
  class: "text-xl mb-6",
  style: { "border-bottom": "1px solid" }
}, PO = { for: "patientName" }, xO = { for: "dateOfBirth" }, jO = { for: "clinician" }, $O = { for: "drugTherapies" }, FO = { for: "generalHealthStatus" }, kO = {
  class: "text-xl mb-6",
  style: { "border-bottom": "1px solid" }
}, VO = { for: "examDate" }, BO = { for: "images" }, UO = { for: "sliceThickness" }, GO = { for: "description" }, WO = { for: "projectName" }, zO = { for: "lastModified" }, HO = {
  class: "text-xl mt-2 mb-2",
  style: { "border-bottom": "1px solid" }
}, YO = { style: { flex: "1 1 100px" } }, KO = { style: { flex: "1 1 100px" } }, ZO = { style: { flex: "1 1 100px" } }, XO = { style: { flex: "1 1 100px" } }, JO = { class: "flex" }, qO = /* @__PURE__ */ Je({
  __name: "ReportSettingsGeneralTab",
  props: {
    dataObject: { required: !0 },
    dataObjectModifiers: {}
  },
  emits: ["update:dataObject"],
  setup(e) {
    const { t } = Ht(), n = Nn(e, "dataObject");
    return (a, o) => (L(), be(r(we), { style: { "flex-direction": "column" } }, {
      default: _(() => [
        d(r(we), {
          class: "gap-4",
          style: { "flex-direction": "row" }
        }, {
          default: _(() => [
            d(r(we), {
              class: "gap-2",
              style: { "flex-direction": "column", flex: "1 1 0" }
            }, {
              default: _(() => [
                y("span", MO, U(a.$t("medic-web-engine.patientInformation")), 1),
                d(r(ot), { class: "gap-8" }, {
                  default: _(() => [
                    d(r(qn), { class: "w-full" }, {
                      default: _(() => [
                        d(r(da), {
                          id: "patientName",
                          class: "w-full",
                          modelValue: n.value.name,
                          "onUpdate:modelValue": o[0] || (o[0] = (l) => n.value.name = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", PO, U(a.$t("medic-web-engine.name")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(qn), { class: "w-full" }, {
                      default: _(() => [
                        d(r(js), {
                          id: "dateOfBirth",
                          dateFormat: "yy-mm-dd",
                          class: "w-full",
                          modelValue: n.value.dateOfBirth,
                          "onUpdate:modelValue": o[1] || (o[1] = (l) => n.value.dateOfBirth = l)
                        }, null, 8, ["modelValue"]),
                        y("label", xO, U(a.$t("medic-web-engine.dateOfBirth")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(qn), { class: "w-full" }, {
                      default: _(() => [
                        d(r(da), {
                          id: "clinician",
                          class: "w-full",
                          modelValue: n.value.clinician,
                          "onUpdate:modelValue": o[2] || (o[2] = (l) => n.value.clinician = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", jO, U(a.$t("medic-web-engine.clinician")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(qn), { class: "w-full" }, {
                      default: _(() => [
                        d(r(da), {
                          id: "drugTherapies",
                          class: "w-full",
                          modelValue: n.value.drugTherapies,
                          "onUpdate:modelValue": o[3] || (o[3] = (l) => n.value.drugTherapies = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", $O, U(a.$t("medic-web-engine.drugTherapies")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(qn), { class: "w-full" }, {
                      default: _(() => [
                        d(r(da), {
                          id: "generalHealthStatus",
                          class: "w-full",
                          modelValue: n.value.generalHealthStatus,
                          "onUpdate:modelValue": o[4] || (o[4] = (l) => n.value.generalHealthStatus = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", FO, U(a.$t("medic-web-engine.generalHealthStatus")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(we), { style: { "flex-direction": "column", flex: "1 1 0" } }, {
              default: _(() => [
                y("span", kO, U(a.$t("medic-web-engine.examInformation")), 1),
                d(r(ot), { class: "gap-8" }, {
                  default: _(() => [
                    d(r(qn), { class: "w-full" }, {
                      default: _(() => [
                        d(r(js), {
                          id: "examDate",
                          dateFormat: "yy-mm-dd",
                          class: "w-full",
                          modelValue: n.value.examDate,
                          "onUpdate:modelValue": o[5] || (o[5] = (l) => n.value.examDate = l)
                        }, null, 8, ["modelValue"]),
                        y("label", VO, U(a.$t("medic-web-engine.examDate")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(qn), { class: "w-full" }, {
                      default: _(() => [
                        d(r(da), {
                          id: "images",
                          class: "w-full",
                          modelValue: n.value.images,
                          "onUpdate:modelValue": o[6] || (o[6] = (l) => n.value.images = l),
                          type: "number"
                        }, null, 8, ["modelValue"]),
                        y("label", BO, U(a.$t("medic-web-engine.images")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(qn), { class: "w-full" }, {
                      default: _(() => [
                        d(r(da), {
                          id: "sliceThickness",
                          class: "w-full",
                          modelValue: n.value.sliceThickness,
                          "onUpdate:modelValue": o[7] || (o[7] = (l) => n.value.sliceThickness = l),
                          type: "number",
                          step: "0.1"
                        }, null, 8, ["modelValue"]),
                        y("label", UO, U(a.$t("medic-web-engine.sliceThickness")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(qn), { class: "w-full" }, {
                      default: _(() => [
                        d(r(da), {
                          id: "description",
                          class: "w-full",
                          modelValue: n.value.description,
                          "onUpdate:modelValue": o[8] || (o[8] = (l) => n.value.description = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", GO, U(a.$t("medic-web-engine.description")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(qn), { class: "w-full" }, {
                      default: _(() => [
                        d(r(da), {
                          id: "projectName",
                          class: "w-full",
                          modelValue: n.value.projectName,
                          "onUpdate:modelValue": o[9] || (o[9] = (l) => n.value.projectName = l),
                          type: "text"
                        }, null, 8, ["modelValue"]),
                        y("label", WO, U(a.$t("medic-web-engine.projectName")), 1)
                      ]),
                      _: 1
                    }),
                    d(r(qn), { class: "w-full" }, {
                      default: _(() => [
                        d(r(js), {
                          id: "lastModified",
                          dateFormat: "yy-mm-dd",
                          class: "w-full",
                          modelValue: n.value.lastModified,
                          "onUpdate:modelValue": o[10] || (o[10] = (l) => n.value.lastModified = l)
                        }, null, 8, ["modelValue"]),
                        y("label", zO, U(a.$t("medic-web-engine.lastModified")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        d(r(ot), null, {
          default: _(() => [
            y("span", HO, U(a.$t("medic-web-engine.styleSettings")), 1),
            d(r(we), {
              class: "gap-2 mt-2",
              style: { "flex-direction": "column" }
            }, {
              default: _(() => [
                d(r(we), {
                  class: "gap-2",
                  style: { "flex-direction": "row", flex: "1 1 0", "align-items": "baseline" }
                }, {
                  default: _(() => [
                    d(r(we), {
                      class: "gap-2",
                      style: { "flex-direction": "row", "justify-content": "start", "align-items": "baseline", flex: "1 1 0" }
                    }, {
                      default: _(() => [
                        y("span", YO, U(a.$t("medic-web-engine.backgroundColor3d")), 1),
                        d(r(dc), {
                          modelValue: n.value.bgColor3d,
                          "onUpdate:modelValue": o[11] || (o[11] = (l) => n.value.bgColor3d = l),
                          style: { flex: "6 1 0" }
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    d(r(we), {
                      class: "gap-2",
                      style: { "flex-direction": "row", "justify-content": "start", "align-items": "baseline", flex: "1 1 0" }
                    }, {
                      default: _(() => [
                        y("span", KO, U(a.$t("medic-web-engine.template3d")), 1),
                        d(r($n), {
                          style: { flex: "6 1 0" },
                          modelValue: n.value.template3d,
                          "onUpdate:modelValue": o[12] || (o[12] = (l) => n.value.template3d = l),
                          options: ["X-Ray", "Bones", "Soft Tissues", "Teeth"]
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(we), {
                  class: "gap-2",
                  style: { "flex-direction": "row", flex: "1 1 0", "align-items": "baseline" }
                }, {
                  default: _(() => [
                    d(r(we), {
                      class: "gap-2",
                      style: { "flex-direction": "row", "justify-content": "start", "align-items": "baseline", flex: "1 1 0" }
                    }, {
                      default: _(() => [
                        y("span", ZO, U(a.$t("medic-web-engine.fontColor")), 1),
                        d(r(dc), {
                          style: { flex: "6 1 0" },
                          modelValue: n.value.fontColor,
                          "onUpdate:modelValue": o[13] || (o[13] = (l) => n.value.fontColor = l),
                          class: "grow"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    d(r(we), {
                      class: "gap-2",
                      style: { "flex-direction": "row", "justify-content": "start", "align-items": "baseline", flex: "1 1 0" }
                    }, {
                      default: _(() => [
                        y("label", XO, U(a.$t("medic-web-engine.fontSize")), 1),
                        d(r(mp), {
                          style: { flex: "6 1 0" },
                          modelValue: n.value.fontSize,
                          "onUpdate:modelValue": o[14] || (o[14] = (l) => n.value.fontSize = l),
                          class: "grow",
                          min: 1,
                          max: 25,
                          useGrouping: !1
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            d(r(we), {
              style: { "flex-direction": "column" },
              class: "gap-2 mt-2"
            }, {
              default: _(() => [
                d(r(we), {
                  class: "gap-2 mt-1 mb-1",
                  style: { "flex-direction": "row", "justify-content": "start", "align-items": "baseline" }
                }, {
                  default: _(() => [
                    y("span", JO, U(a.$t("medic-web-engine.showCollisionWarnings")), 1),
                    d(r(Mh), {
                      class: "flex ml-2 mt-1 mb-1",
                      modelValue: n.value.showCollisionWarnings,
                      "onUpdate:modelValue": o[15] || (o[15] = (l) => n.value.showCollisionWarnings = l),
                      binary: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), QO = {
  name: "BaseFloatLabel",
  extends: Ka,
  props: {
    variant: {
      type: String,
      default: "over"
    }
  },
  style: Ph,
  provide() {
    return {
      $pcFloatLabel: this,
      $parentInstance: this
    };
  }
}, eD = {
  name: "FloatLabel",
  extends: QO,
  inheritAttrs: !1
};
function tD(e, t, n, a, o, l) {
  return L(), H("span", je({
    class: e.cx("root")
  }, e.ptmi("root")), [
    It(e.$slots, "default")
  ], 16);
}
const nD = /* @__PURE__ */ Vt(eD, [["render", tD]]), aD = { for: "implantsType" }, oD = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, lD = { style: { display: "flex", "flex-direction": "row", "flex-wrap": "wrap", gap: "8px", flex: "1" } }, iD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, sD = {
  for: "immediateLoadingYes",
  style: { margin: "0" }
}, rD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, uD = {
  for: "immediateLoadingNo",
  style: { margin: "0" }
}, cD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, dD = {
  for: "immediateLoadingEval",
  style: { margin: "0" }
}, pD = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, mD = { style: { display: "flex", "flex-direction": "row", "flex-wrap": "wrap", gap: "8px", flex: "1" } }, fD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, gD = {
  for: "guideTeeth",
  style: { margin: "0" }
}, hD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, bD = {
  for: "guideSoft",
  style: { margin: "0" }
}, vD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, yD = {
  for: "guideBone",
  style: { margin: "0" }
}, _D = { style: { display: "flex", "align-items": "center", gap: "8px" } }, wD = {
  for: "guideCustom",
  style: { margin: "0" }
}, ID = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, SD = { style: { display: "flex", "flex-direction": "row", "flex-wrap": "wrap", gap: "8px", flex: "1" } }, ED = { style: { display: "flex", "align-items": "center", gap: "8px" } }, TD = {
  for: "fixPins",
  style: { margin: "0" }
}, CD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, ND = {
  for: "fixScrews",
  style: { margin: "0" }
}, LD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, OD = {
  for: "fixOther",
  style: { margin: "0" }
}, DD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, AD = {
  for: "fixNone",
  style: { margin: "0" }
}, RD = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, MD = { style: { display: "flex", "flex-direction": "row", "flex-wrap": "wrap", gap: "8px", flex: "1" } }, PD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, xD = {
  for: "densityMapYes",
  style: { margin: "0" }
}, jD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, $D = {
  for: "densityMapNo",
  style: { margin: "0" }
}, FD = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, kD = { style: { display: "flex", "flex-direction": "row", "flex-wrap": "wrap", gap: "8px", flex: "1" } }, VD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, BD = {
  for: "boneRegenYes",
  style: { margin: "0" }
}, UD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, GD = {
  for: "boneRegenNo",
  style: { margin: "0" }
}, WD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, zD = {
  for: "boneRegenEval",
  style: { margin: "0" }
}, HD = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, YD = { style: { display: "flex", "flex-direction": "row", gap: "8px", flex: "1" } }, KD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, ZD = {
  for: "flaplessYes",
  style: { margin: "0" }
}, XD = { style: { display: "flex", "align-items": "center", gap: "8px" } }, JD = {
  for: "flaplessNo",
  style: { margin: "0" }
}, qD = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, QD = { style: { display: "flex", "flex-direction": "row", gap: "8px", flex: "1" } }, eA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, tA = {
  for: "sinusYes",
  style: { margin: "0" }
}, nA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, aA = {
  for: "sinusNo",
  style: { margin: "0" }
}, oA = { style: { "margin-right": "16px", "font-weight": "500", "min-width": "120px" } }, lA = { style: { display: "flex", "flex-direction": "row", gap: "8px", flex: "1" } }, iA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, sA = {
  for: "nasalYes",
  style: { margin: "0" }
}, rA = { style: { display: "flex", "align-items": "center", gap: "8px" } }, uA = {
  for: "nasalNo",
  style: { margin: "0" }
}, cA = { for: "generalNotes" }, dA = /* @__PURE__ */ Je({
  __name: "ReportSettingsPlanningTab",
  props: {
    dataObject: { required: !0 },
    dataObjectModifiers: {}
  },
  emits: ["update:dataObject"],
  setup(e) {
    const { t } = Ht(), n = Nn(e, "dataObject");
    return (a, o) => {
      const l = nD;
      return L(), be(r(we), { style: { "flex-direction": "column", flex: "1 1 0" } }, {
        default: _(() => [
          d(l, { style: { width: "100%", "margin-bottom": "16px", "margin-top": "24px" } }, {
            default: _(() => [
              d(r(da), {
                id: "implantsType",
                style: { width: "100%" },
                modelValue: n.value.implantsType,
                "onUpdate:modelValue": o[0] || (o[0] = (s) => n.value.implantsType = s),
                type: "text"
              }, null, 8, ["modelValue"]),
              y("label", aD, U(r(t)("medic-web-engine.implantsType")), 1)
            ]),
            _: 1
          }),
          d(r(we), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: _(() => {
              var s;
              return [
                y("span", null, U(r(t)("medic-web-engine.numberOfImplants", { count: ((s = n.value) == null ? void 0 : s.numberOfImplants) || 0 })), 1)
              ];
            }),
            _: 1
          }),
          d(r(we), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: _(() => [
              y("label", oD, U(r(t)("medic-web-engine.immediateLoading")), 1),
              y("div", lD, [
                y("div", iD, [
                  d(r(en), {
                    modelValue: n.value.immediateLoading,
                    "onUpdate:modelValue": o[1] || (o[1] = (s) => n.value.immediateLoading = s),
                    inputId: "immediateLoadingYes",
                    value: "yes"
                  }, null, 8, ["modelValue"]),
                  y("label", sD, U(r(t)("medic-web-framework.yes")), 1)
                ]),
                y("div", rD, [
                  d(r(en), {
                    modelValue: n.value.immediateLoading,
                    "onUpdate:modelValue": o[2] || (o[2] = (s) => n.value.immediateLoading = s),
                    inputId: "immediateLoadingNo",
                    value: "no"
                  }, null, 8, ["modelValue"]),
                  y("label", uD, U(r(t)("medic-web-framework.no")), 1)
                ]),
                y("div", cD, [
                  d(r(en), {
                    modelValue: n.value.immediateLoading,
                    "onUpdate:modelValue": o[3] || (o[3] = (s) => n.value.immediateLoading = s),
                    inputId: "immediateLoadingEval",
                    value: "evaluate"
                  }, null, 8, ["modelValue"]),
                  y("label", dD, U(r(t)("medic-web-engine.toBeEvaluatedDuringSurgery")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(we), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: _(() => [
              y("label", pD, U(r(t)("medic-web-engine.typeOfGuide")), 1),
              y("div", mD, [
                y("div", fD, [
                  d(r(en), {
                    modelValue: n.value.guideType,
                    "onUpdate:modelValue": o[4] || (o[4] = (s) => n.value.guideType = s),
                    inputId: "guideTeeth",
                    value: r(t)("medic-web-engine.teethSupported")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", gD, U(r(t)("medic-web-engine.teethSupported")), 1)
                ]),
                y("div", hD, [
                  d(r(en), {
                    modelValue: n.value.guideType,
                    "onUpdate:modelValue": o[5] || (o[5] = (s) => n.value.guideType = s),
                    inputId: "guideSoft",
                    value: r(t)("medic-web-engine.softTissuesSupported")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", bD, U(r(t)("medic-web-engine.softTissuesSupported")), 1)
                ]),
                y("div", vD, [
                  d(r(en), {
                    modelValue: n.value.guideType,
                    "onUpdate:modelValue": o[6] || (o[6] = (s) => n.value.guideType = s),
                    inputId: "guideBone",
                    value: r(t)("medic-web-engine.boneSupported")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", yD, U(r(t)("medic-web-engine.boneSupported")), 1)
                ]),
                y("div", _D, [
                  d(r(en), {
                    modelValue: n.value.guideType,
                    "onUpdate:modelValue": o[7] || (o[7] = (s) => n.value.guideType = s),
                    inputId: "guideCustom",
                    value: r(t)("medic-web-engine.custom")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", wD, U(r(t)("medic-web-engine.custom")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(we), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: _(() => [
              y("label", ID, U(r(t)("medic-web-engine.typeOfFixation")), 1),
              y("div", SD, [
                y("div", ED, [
                  d(r(en), {
                    modelValue: n.value.fixationType,
                    "onUpdate:modelValue": o[8] || (o[8] = (s) => n.value.fixationType = s),
                    inputId: "fixPins",
                    value: r(t)("medic-web-engine.fixationPins")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", TD, U(r(t)("medic-web-engine.fixationPins")), 1)
                ]),
                y("div", CD, [
                  d(r(en), {
                    modelValue: n.value.fixationType,
                    "onUpdate:modelValue": o[9] || (o[9] = (s) => n.value.fixationType = s),
                    inputId: "fixScrews",
                    value: r(t)("medic-web-engine.fixationScrews")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", ND, U(r(t)("medic-web-engine.fixationScrews")), 1)
                ]),
                y("div", LD, [
                  d(r(en), {
                    modelValue: n.value.fixationType,
                    "onUpdate:modelValue": o[10] || (o[10] = (s) => n.value.fixationType = s),
                    inputId: "fixOther",
                    value: r(t)("medic-web-engine.other")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", OD, U(r(t)("medic-web-engine.other")), 1)
                ]),
                y("div", DD, [
                  d(r(en), {
                    modelValue: n.value.fixationType,
                    "onUpdate:modelValue": o[11] || (o[11] = (s) => n.value.fixationType = s),
                    inputId: "fixNone",
                    value: r(t)("medic-web-engine.none")
                  }, null, 8, ["modelValue", "value"]),
                  y("label", AD, U(r(t)("medic-web-engine.none")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(we), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: _(() => [
              y("label", RD, U(r(t)("medic-web-engine.showDensityBoneMap")), 1),
              y("div", MD, [
                y("div", PD, [
                  d(r(en), {
                    modelValue: n.value.showDensityBoneMap,
                    "onUpdate:modelValue": o[12] || (o[12] = (s) => n.value.showDensityBoneMap = s),
                    inputId: "densityMapYes",
                    value: "inside"
                  }, null, 8, ["modelValue"]),
                  y("label", xD, U(r(t)("medic-web-engine.showDensityBoneMap")), 1)
                ]),
                y("div", jD, [
                  d(r(en), {
                    modelValue: n.value.showDensityBoneMap,
                    "onUpdate:modelValue": o[13] || (o[13] = (s) => n.value.showDensityBoneMap = s),
                    inputId: "densityMapNo",
                    value: "outside"
                  }, null, 8, ["modelValue"]),
                  y("label", $D, U(r(t)("medic-web-engine.boneDensityOutsideVolume")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(we), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: _(() => [
              y("label", FD, U(r(t)("medic-web-engine.boneRegeneration")), 1),
              y("div", kD, [
                y("div", VD, [
                  d(r(en), {
                    modelValue: n.value.boneRegeneration,
                    "onUpdate:modelValue": o[14] || (o[14] = (s) => n.value.boneRegeneration = s),
                    inputId: "boneRegenYes",
                    value: "yes"
                  }, null, 8, ["modelValue"]),
                  y("label", BD, U(r(t)("medic-web-framework.yes")), 1)
                ]),
                y("div", UD, [
                  d(r(en), {
                    modelValue: n.value.boneRegeneration,
                    "onUpdate:modelValue": o[15] || (o[15] = (s) => n.value.boneRegeneration = s),
                    inputId: "boneRegenNo",
                    value: "no"
                  }, null, 8, ["modelValue"]),
                  y("label", GD, U(r(t)("medic-web-framework.no")), 1)
                ]),
                y("div", WD, [
                  d(r(en), {
                    modelValue: n.value.boneRegeneration,
                    "onUpdate:modelValue": o[16] || (o[16] = (s) => n.value.boneRegeneration = s),
                    inputId: "boneRegenEval",
                    value: "evaluate"
                  }, null, 8, ["modelValue"]),
                  y("label", zD, U(r(t)("medic-web-engine.toBeEvaluatedDuringSurgery")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(we), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: _(() => [
              y("label", HD, U(r(t)("medic-web-engine.flaplessSurgery")), 1),
              y("div", YD, [
                y("div", KD, [
                  d(r(en), {
                    modelValue: n.value.flaplessSurgery,
                    "onUpdate:modelValue": o[17] || (o[17] = (s) => n.value.flaplessSurgery = s),
                    inputId: "flaplessYes",
                    value: "Yes"
                  }, null, 8, ["modelValue"]),
                  y("label", ZD, U(r(t)("medic-web-framework.yes")), 1)
                ]),
                y("div", XD, [
                  d(r(en), {
                    modelValue: n.value.flaplessSurgery,
                    "onUpdate:modelValue": o[18] || (o[18] = (s) => n.value.flaplessSurgery = s),
                    inputId: "flaplessNo",
                    value: "No"
                  }, null, 8, ["modelValue"]),
                  y("label", JD, U(r(t)("medic-web-framework.no")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(we), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: _(() => [
              y("label", qD, U(r(t)("medic-web-engine.addSinusGraftLift")), 1),
              y("div", QD, [
                y("div", eA, [
                  d(r(en), {
                    modelValue: n.value.addSinusGraftLift,
                    "onUpdate:modelValue": o[19] || (o[19] = (s) => n.value.addSinusGraftLift = s),
                    inputId: "sinusYes",
                    value: "Yes"
                  }, null, 8, ["modelValue"]),
                  y("label", tA, U(r(t)("medic-web-framework.yes")), 1)
                ]),
                y("div", nA, [
                  d(r(en), {
                    modelValue: n.value.addSinusGraftLift,
                    "onUpdate:modelValue": o[20] || (o[20] = (s) => n.value.addSinusGraftLift = s),
                    inputId: "sinusNo",
                    value: "No"
                  }, null, 8, ["modelValue"]),
                  y("label", aA, U(r(t)("medic-web-framework.no")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(r(we), { style: { "flex-direction": "row", "margin-bottom": "16px" } }, {
            default: _(() => [
              y("label", oA, U(r(t)("medic-web-engine.addNasalGraftLift")), 1),
              y("div", lA, [
                y("div", iA, [
                  d(r(en), {
                    modelValue: n.value.addNasalGraftLift,
                    "onUpdate:modelValue": o[21] || (o[21] = (s) => n.value.addNasalGraftLift = s),
                    inputId: "nasalYes",
                    value: "Yes"
                  }, null, 8, ["modelValue"]),
                  y("label", sA, U(r(t)("medic-web-framework.yes")), 1)
                ]),
                y("div", rA, [
                  d(r(en), {
                    modelValue: n.value.addNasalGraftLift,
                    "onUpdate:modelValue": o[22] || (o[22] = (s) => n.value.addNasalGraftLift = s),
                    inputId: "nasalNo",
                    value: "No"
                  }, null, 8, ["modelValue"]),
                  y("label", uA, U(r(t)("medic-web-framework.no")), 1)
                ])
              ])
            ]),
            _: 1
          }),
          d(l, { style: { width: "100%", "margin-top": "24px", "margin-bottom": "16px" } }, {
            default: _(() => [
              d(r(xh), {
                id: "generalNotes",
                style: { width: "100%" },
                modelValue: n.value.generalNotes,
                "onUpdate:modelValue": o[23] || (o[23] = (s) => n.value.generalNotes = s),
                type: "text",
                rows: "4"
              }, null, 8, ["modelValue"]),
              y("label", cA, U(r(t)("medic-web-engine.generalNotes")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), pA = ["src"], mA = /* @__PURE__ */ Je({
  __name: "ReportSettingsLogoTab",
  props: {
    dataObject: { required: !0 },
    dataObjectModifiers: {}
  },
  emits: ["update:dataObject"],
  setup(e) {
    const t = Nn(e, "dataObject"), n = sa(), a = B(null), o = (i) => new Promise((u, c) => {
      const p = new FileReader();
      p.onload = () => {
        u(typeof p.result == "string" ? p.result : "");
      }, p.onerror = () => {
        c(p.error);
      }, p.readAsDataURL(i);
    });
    Dt(async () => {
      if (!(t.value.logoBase64.trim().length > 0))
        try {
          const i = await fetch(n.getAssetUrl("/img/implantReportLogo.png"));
          if (!i.ok)
            return;
          const u = await i.blob();
          t.value.logoBase64 = await o(u);
        } catch (i) {
          console.warn("Failed to load default report logo.", i);
        }
    });
    const l = () => {
      var i;
      (i = a.value) == null || i.click();
    }, s = (i) => {
      var h;
      const c = (h = i.target.files) == null ? void 0 : h[0];
      if (!c || !c.type.startsWith("image/"))
        return;
      const p = new FileReader();
      p.onload = () => {
        const g = typeof p.result == "string" ? p.result : "";
        t.value.logoBase64 = g;
      }, p.readAsDataURL(c);
    };
    return (i, u) => (L(), be(r(we), { class: "flex-col" }, {
      default: _(() => [
        d(r(we), { class: "mb-4" }, {
          default: _(() => [
            d(r(Ne), {
              class: "",
              label: "Change Logo Image",
              onClick: l
            }),
            y("input", {
              ref_key: "fileInput",
              ref: a,
              type: "file",
              accept: "image/png",
              class: "hidden",
              onChange: s
            }, null, 544)
          ]),
          _: 1
        }),
        d(r(we), { class: "mt-4" }, {
          default: _(() => [
            t.value.logoBase64.length ? (L(), H("img", {
              key: 0,
              src: t.value.logoBase64,
              alt: "Logo",
              width: "256",
              height: "256"
            }, null, 8, pA)) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), wf = /* @__PURE__ */ Je({
  __name: "ReportSettings",
  emits: ["ok", "close"],
  setup(e, { emit: t }) {
    var A, T, O, C;
    const n = Xn("dialogRef"), a = n.value.data, o = t, l = ["General", "Planning", "Logo"], s = B(l[0]), i = (k) => {
      if (!k)
        return null;
      const M = k instanceof Date ? k : new Date(k);
      return Number.isNaN(M.getTime()) ? null : M;
    }, u = (k) => {
      if (!/^\d{8}$/.test(k))
        return null;
      const M = Number(k.slice(0, 4)), z = Number(k.slice(4, 6)), j = Number(k.slice(6, 8));
      if (!Number.isFinite(M) || !Number.isFinite(z) || !Number.isFinite(j))
        return null;
      const K = new Date(M, z - 1, j);
      return K.getFullYear() !== M || K.getMonth() !== z - 1 || K.getDate() !== j ? null : K;
    }, c = (k) => {
      const M = k.trim(), z = [/^(\d{4})\/(\d{1,2})\/(\d{1,2})$/, /^(\d{4})-(\d{1,2})-(\d{1,2})$/, /^(\d{4})(\d{2})(\d{2})$/];
      for (const j of z) {
        const K = M.match(j);
        if (!K)
          continue;
        const x = Number(K[1]), N = Number(K[2]), G = Number(K[3]);
        if (!Number.isFinite(x) || !Number.isFinite(N) || !Number.isFinite(G))
          continue;
        const ce = new Date(x, N - 1, G);
        if (ce.getFullYear() === x && ce.getMonth() === N - 1 && ce.getDate() === G)
          return ce;
      }
      return null;
    }, p = (k, M) => ((k || "").replace(/\r/g, "").split(`
`)[M] || "").trim(), h = (k) => {
      var z;
      const M = (((z = a.context.projectGeneralData) == null ? void 0 : z.dicomData) || "").replace(/\r/g, "").split(`
`);
      for (const j of M)
        if (j.startsWith(`${k}=`))
          return j.slice(k.length + 1).trim();
      return "";
    }, g = () => {
      for (const k of a.context.objects.implants.values())
        if (typeof k.getProjectImplantInfo == "function") {
          const M = k.getProjectImplantInfo();
          if (M != null && M.manufacturerName)
            return M.manufacturerName;
        }
      return "";
    }, b = () => {
      var z, j;
      const k = p((z = a.context.projectGeneralData) == null ? void 0 : z.patientData, 0);
      if (k)
        return k;
      const M = a.context.patientInfo;
      return M != null && M.patientName ? M.patientName : (j = M == null ? void 0 : M.extra) != null && j.patientName ? M.extra.patientName : M != null && M.firstName ? M.firstName : "";
    }, E = () => {
      var M;
      const k = p((M = a.context.projectGeneralData) == null ? void 0 : M.seriesData, 1);
      return k ? c(k) : null;
    }, m = () => {
      const k = a.context.getImageData().getDimensions(), M = Number(k == null ? void 0 : k[2]);
      return !Number.isFinite(M) || M <= 0 ? "" : String(Math.trunc(M));
    }, I = () => {
      const k = a.context.getImageData().getSpacing(), M = Number(k == null ? void 0 : k[2]);
      return !Number.isFinite(M) || M <= 0 ? "" : String(Ri(M));
    }, S = () => {
      var M;
      const k = (((M = a.context.projectInfo) == null ? void 0 : M.projectFilename) || "").trim();
      return k ? k.replace(/\.zip$/i, "") : (a.context.projectName || "").trim().replace(/\.zip$/i, "");
    }, f = B({
      name: b(),
      dateOfBirth: u(p((A = a.context.projectGeneralData) == null ? void 0 : A.patientData, 2)) || i((T = a.context.patientInfo) == null ? void 0 : T.dateOfBirth),
      clinician: h("PATIENT_REF"),
      drugTherapies: "",
      generalHealthStatus: "",
      examDate: E(),
      images: m(),
      sliceThickness: I(),
      description: p((O = a.context.projectGeneralData) == null ? void 0 : O.seriesData, 0),
      projectName: S(),
      lastModified: i((C = a.context.projectInfo) == null ? void 0 : C.lastModified) || /* @__PURE__ */ new Date(),
      bgColor3d: "#000000",
      template3d: "Bones",
      fontColor: "#000000",
      fontSize: 10,
      zoom3d: !0,
      showCollisionWarnings: !0,
      implantsType: g(),
      numberOfImplants: a.context.objects.implants.size,
      immediateLoading: "yes",
      guideType: "Soft tissues supported",
      fixationType: "Fixation Pins",
      showDensityBoneMap: "inside",
      boneRegeneration: "no",
      flaplessSurgery: "Yes",
      addSinusGraftLift: "No",
      addNasalGraftLift: "No",
      generalNotes: "",
      notes: "",
      logoBase64: "",
      ww: 4e3,
      wl: 1e3
    }), v = () => {
      o("ok", f.value), n.value.close();
    }, w = () => {
      o("close"), n.value.close();
    };
    return (k, M) => (L(), be(r(we), {
      class: "flex-col",
      style: { overflow: "auto" }
    }, {
      default: _(() => [
        d(r(ke), { class: "mb-4 gap-2" }, {
          default: _(() => [
            (L(), H(He, null, jt(l, (z) => d(r(Ne), {
              style: { flex: "1 1 0" },
              key: z,
              label: z,
              toggled: z === s.value,
              onClick: (j) => s.value = z
            }, null, 8, ["label", "toggled", "onClick"])), 64))
          ]),
          _: 1
        }),
        d(r(we), { style: { "flex-grow": "1" } }, {
          default: _(() => [
            s.value === "General" ? (L(), be(qO, {
              key: 0,
              dataObject: f.value,
              "onUpdate:dataObject": M[0] || (M[0] = (z) => f.value = z),
              style: { flex: "1 1 0" }
            }, null, 8, ["dataObject"])) : ue("", !0),
            s.value === "Planning" ? (L(), be(dA, {
              key: 1,
              dataObject: f.value,
              "onUpdate:dataObject": M[1] || (M[1] = (z) => f.value = z),
              style: { flex: "1 1 0" }
            }, null, 8, ["dataObject"])) : ue("", !0),
            s.value === "Logo" ? (L(), be(mA, {
              key: 2,
              dataObject: f.value,
              "onUpdate:dataObject": M[2] || (M[2] = (z) => f.value = z),
              style: { flex: "1 1 0" }
            }, null, 8, ["dataObject"])) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(we), { class: "p-dialog-footer justify-center mt-8" }, {
          default: _(() => [
            d(r(la), {
              label: "OK",
              onClick: M[3] || (M[3] = (z) => v()),
              class: "mr-4"
            }),
            d(r(ya), {
              label: "Cancel",
              onClick: M[4] || (M[4] = (z) => w())
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), fA = /* @__PURE__ */ Je({
  __name: "IPCadPlaygroundComponent",
  setup(e) {
    const t = dn();
    console.log("projectContext: ", t);
    const { t: n } = Ht(), a = Aa(), o = B(!0), l = B(!0), s = B(!0);
    let i;
    Dt(() => {
      i = dn();
    });
    const u = B(!0), c = () => {
      a.open(Zl, {
        props: {
          closable: !0,
          modal: !0,
          header: n("implant-planner.universalUpload"),
          contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
        },
        data: {
          dropArea: !0,
          selectFilesBtn: !0,
          selectFolderBtn: !0,
          accept: Mg + ep + ki,
          context: i
        },
        emits: {
          onUploadFiles: (f) => {
            console.log("onUploadFiles called from emit: ", f);
          }
        }
      });
    };
    let p = B([]);
    const h = async () => {
      p.value = await i.objects.getObjectImportPreviewList(), a.open(PN, {
        props: {
          modal: !0,
          header: n("implant-planner.importDObjects")
        },
        data: {
          importObjects: p.value
        },
        emits: {
          onProceedToImport: async (f) => {
            console.log("Proceed to import:", f), new oh(i, lh.DEFAULT_RECONSTRUCTION).importObjects(f, i), i.sceneRepaint();
          }
        }
      });
    }, g = async () => {
      a.open(qm, {
        props: {
          modal: !0,
          showHeader: !1,
          contentStyle: { borderRadius: "16px" }
        },
        data: {
          context: i
        },
        emits: {
          onConfirm: (f, v, w) => {
            console.log("Proceed: ", f, v, w);
          }
        }
      });
    }, b = async () => {
      a.open($L, {
        props: {
          modal: !0,
          showHeader: !1,
          contentStyle: {
            borderRadius: "16px",
            padding: "0 1.5rem",
            overflow: "hidden"
          }
        },
        data: {
          context: i
        },
        emits: {
          onConfirm: () => {
            console.log("Proceed");
          }
        }
      });
    }, E = async () => {
      a.open(_f, {
        props: {
          modal: !0,
          showHeader: !1,
          contentStyle: {
            borderRadius: "16px",
            padding: "0 1.5rem",
            overflow: "hidden"
          }
        },
        data: {
          context: i
        },
        emits: {
          onConfirm: () => {
            console.log("Proceed");
          }
        }
      });
    }, m = () => {
      console.log("IPTeethViewDialog project context: ", t), a.open(BL, {
        props: {
          closable: !0,
          modal: !0,
          header: n("implant-planner.teethView"),
          style: { width: "80vw" }
        },
        data: {
          projectContext: t
        }
      });
    }, I = () => {
      a.open(hf, {
        props: {
          closable: !0,
          modal: !0,
          header: n("shared.import"),
          style: { width: "20vw" },
          contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
        },
        emits: {
          onImportFromFile: () => {
            console.log("onImportFromFile"), a.open(Zl, {
              props: {
                closable: !0,
                modal: !0,
                header: n("shared.uploadFile"),
                contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
              },
              data: {
                dropArea: !0,
                selectFilesBtn: !0,
                selectFolderBtn: !0,
                accept: ki
              },
              emits: {
                onUploadFiles: (f) => {
                  console.log("onImportFromFile -> onUploadFiles: ", f);
                }
              }
            });
          },
          onImportFromPlanner: async () => {
            console.log("onImportFromPlanner");
            const f = await i.getObjects().getObjectImportPreviewList();
            a.open(cp, {
              props: {
                closable: !0,
                modal: !0,
                header: n("shared.uploadFile"),
                style: { width: "23rem" },
                contentStyle: { borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }
              },
              data: {
                importObjects: f
              },
              emits: {
                onProceedToImport: (v) => {
                  console.log("onImportFromPlanner -> onProceedToImport: ", v);
                }
              }
            });
          }
        }
      });
    }, S = () => {
      a.open(wf, {
        props: {
          closable: !0,
          modal: !0,
          header: n("implant-planner.reportSettings"),
          style: { width: "900px", minHeight: "650px" },
          contentStyle: { borderRadius: "8px", background: "#0a7cc1" }
        },
        emits: {
          close: () => {
          }
        }
      });
    };
    return (f, v) => {
      const w = RN;
      return L(), H(He, null, [
        y("span", null, U(f.$t("implant-planner.includeDemoComponents")), 1),
        o.value ? (L(), be(r(Ne), {
          key: 0,
          label: f.$t("implant-planner.universalFilePicker"),
          onClick: c,
          class: "mt-2"
        }, null, 8, ["label"])) : ue("", !0),
        l.value ? (L(), be(w, {
          key: 1,
          label: f.$t("implant-planner.setactivereconstruction"),
          onClick: h,
          class: "mt-2"
        }, null, 8, ["label"])) : ue("", !0),
        s.value ? (L(), be(w, {
          key: 2,
          label: f.$t("implant-planner.openTeethLibraryPreview"),
          onClick: g,
          class: "mt-2"
        }, null, 8, ["label"])) : ue("", !0),
        u.value ? (L(), be(r(Ne), {
          key: 3,
          class: "mt-2",
          label: f.$t("implant-planner.showTeethViewDialog"),
          onClick: m
        }, null, 8, ["label"])) : ue("", !0),
        b ? (L(), be(w, {
          key: 4,
          label: f.$t("implant-planner.showReconstructionSetup"),
          onClick: b,
          class: "mt-2"
        }, null, 8, ["label"])) : ue("", !0),
        E ? (L(), be(w, {
          key: 5,
          label: f.$t("implant-planner.showReconstructionSetupRedesign"),
          onClick: E,
          class: "mt-2"
        }, null, 8, ["label"])) : ue("", !0),
        d(w, {
          label: f.$t("implant-planner.showImportFromDialog"),
          onClick: I,
          class: "mt-2"
        }, null, 8, ["label"]),
        d(r(Ne), {
          label: "Show Report Settings Dialog",
          onClick: S,
          class: "mt-2"
        })
      ], 64);
    };
  }
}), gA = {}, hA = { class: "card-wiz" }, bA = { class: "grid grid-cols-12 gap-4 grid-cols-12 gap-6" }, vA = { class: "text-2xl font-medium" }, yA = { class: "card-wiz" }, _A = { class: "grid grid-cols-12 gap-4 grid-cols-12 gap-6" }, wA = { class: "text-1xl font-medium" };
function IA(e, t) {
  const n = fA;
  return L(), H(He, null, [
    y("div", hA, [
      y("div", bA, [
        y("span", vA, U(e.$t("implant-planner.cad")), 1)
      ])
    ]),
    y("div", yA, [
      y("div", _A, [
        y("span", wA, U(e.$t("implant-planner.demoComponents")), 1)
      ])
    ]),
    d(n)
  ], 64);
}
const Ru = /* @__PURE__ */ Vt(gA, [["render", IA]]), SA = {
  name: "BaseToolbar",
  extends: Ka,
  props: {
    ariaLabelledby: {
      type: String,
      default: null
    }
  },
  style: jh,
  provide() {
    return {
      $pcToolbar: this,
      $parentInstance: this
    };
  }
}, EA = {
  name: "Toolbar",
  extends: SA,
  inheritAttrs: !1
}, TA = ["aria-labelledby"];
function CA(e, t, n, a, o, l) {
  return L(), H("div", je({
    class: e.cx("root"),
    role: "toolbar",
    "aria-labelledby": e.ariaLabelledby
  }, e.ptmi("root")), [
    y("div", je({
      class: e.cx("start")
    }, e.ptm("start")), [
      It(e.$slots, "start")
    ], 16),
    y("div", je({
      class: e.cx("center")
    }, e.ptm("center")), [
      It(e.$slots, "center")
    ], 16),
    y("div", je({
      class: e.cx("end")
    }, e.ptm("end")), [
      It(e.$slots, "end")
    ], 16)
  ], 16, TA);
}
const NA = /* @__PURE__ */ Vt(EA, [["render", CA]]), Mu = /* @__PURE__ */ Je({
  __name: "IPAppMenuHorizontalContainer",
  setup(e) {
    return (t, n) => {
      const a = NA;
      return L(), be(a, {
        class: "bg-horizontalbar mb-2 ml-4 mr-3",
        style: { height: "4rem !important" }
      }, {
        start: _(() => [
          d(r(we), { class: "gap-8 align-center" }, {
            default: _(() => [
              It(t.$slots, "start")
            ]),
            _: 3
          })
        ]),
        _: 3
      });
    };
  }
}), LA = { class: "layout-menuitem-icon" }, OA = /* @__PURE__ */ Je({
  __name: "IPAppMenuHorizontalItem",
  props: {
    modelValue: {},
    index: {},
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = B("selected-main-menu-horizontal"), l = B("selected-main-menu-text"), s = B("p-menuitem-icon"), i = Ce(() => n.modelValue === n.index);
    Ga(() => {
      const p = n.modelValue === n.index;
      o.value = p ? "selected-main-menu-horizontal color-primary-var" : "", l.value = p ? "selected-main-menu-text" : "p-menuitem-text", s.value = p ? "selected-main-menu-icon" : "p-menuitem-icon", n.disabled && (o.value += " wizard-menu-item-disabled");
    });
    const u = () => {
      a("update:modelValue", n.index);
    }, c = Ce(() => i.value ? "svg-icon-selected" : "svg-icon-color");
    return (p, h) => (L(), H("div", null, [
      y("li", {
        class: Ge([[o.value, n.index !== 0 ? "ml-5" : "", (i.value, "")], "layout-root-menuitem bg-horizontalbar-item-wiz"]),
        role: "menuitem"
      }, [
        y("a", {
          class: "p-ripple pointer flex align-center gap-2",
          href: "javascript:void(0)",
          role: "menuitem",
          onClick: u
        }, [
          y("i", LA, [
            d(r(Hr), {
              cIcon: n.index.toString(),
              isMenuIcon: !0,
              colorClass: c.value
            }, null, 8, ["cIcon", "colorClass"])
          ]),
          y("span", {
            class: Ge([i.value ? "color-primary-var " : ""])
          }, [
            It(p.$slots, "default", {}, void 0, !0)
          ], 2)
        ])
      ], 2),
      i.value ? (L(), H("div", {
        key: 0,
        class: Ge([n.index !== 0 ? "ml-5" : "", i.value ? "mt-2" : "", "border-bottom-5 -mb-1"]),
        style: { height: "100%" }
      }, null, 2)) : ue("", !0)
    ]));
  }
}), Pu = /* @__PURE__ */ Vt(OA, [["__scopeId", "data-v-462286fe"]]), DA = {
  name: "BaseSteps",
  extends: Ka,
  props: {
    id: {
      type: String
    },
    model: {
      type: Array,
      default: null
    },
    readonly: {
      type: Boolean,
      default: !0
    },
    activeStep: {
      type: Number,
      default: 0
    }
  },
  style: $h,
  provide() {
    return {
      $pcSteps: this,
      $parentInstance: this
    };
  }
}, AA = {
  name: "Steps",
  extends: DA,
  inheritAttrs: !1,
  emits: ["update:activeStep", "step-change"],
  data() {
    return {
      d_activeStep: this.activeStep
    };
  },
  watch: {
    activeStep(e) {
      this.d_activeStep = e;
    }
  },
  mounted() {
    const e = this.findFirstItem();
    e && (e.tabIndex = "0");
  },
  methods: {
    getPTOptions(e, t, n) {
      return this.ptm(e, {
        context: {
          item: t,
          index: n,
          active: this.isActive(n),
          disabled: this.isItemDisabled(t, n)
        }
      });
    },
    onItemClick(e, t, n) {
      if (this.disabled(t) || this.readonly) {
        e.preventDefault();
        return;
      }
      t.command && t.command({
        originalEvent: e,
        item: t
      }), n !== this.d_activeStep && (this.d_activeStep = n, this.$emit("update:activeStep", this.d_activeStep)), this.$emit("step-change", {
        originalEvent: e,
        index: n
      });
    },
    onItemKeydown(e, t) {
      switch (e.code) {
        case "ArrowRight": {
          this.navigateToNextItem(e.target), e.preventDefault();
          break;
        }
        case "ArrowLeft": {
          this.navigateToPrevItem(e.target), e.preventDefault();
          break;
        }
        case "Home": {
          this.navigateToFirstItem(e.target), e.preventDefault();
          break;
        }
        case "End": {
          this.navigateToLastItem(e.target), e.preventDefault();
          break;
        }
        case "Tab":
          break;
        case "Enter":
        case "NumpadEnter":
        case "Space": {
          this.onItemClick(e, t), e.preventDefault();
          break;
        }
      }
    },
    navigateToNextItem(e) {
      const t = this.findNextItem(e);
      t && this.setFocusToMenuitem(e, t);
    },
    navigateToPrevItem(e) {
      const t = this.findPrevItem(e);
      t && this.setFocusToMenuitem(e, t);
    },
    navigateToFirstItem(e) {
      const t = this.findFirstItem(e);
      t && this.setFocusToMenuitem(e, t);
    },
    navigateToLastItem(e) {
      const t = this.findLastItem(e);
      t && this.setFocusToMenuitem(e, t);
    },
    findNextItem(e) {
      const t = e.parentElement.nextElementSibling;
      return t ? t.children[0] : null;
    },
    findPrevItem(e) {
      const t = e.parentElement.previousElementSibling;
      return t ? t.children[0] : null;
    },
    findFirstItem() {
      const e = iu(this.$refs.list, '[data-pc-section="item"]');
      return e ? e.children[0] : null;
    },
    findLastItem() {
      const e = zp(this.$refs.list, '[data-pc-section="item"]');
      return e ? e[e.length - 1].children[0] : null;
    },
    setFocusToMenuitem(e, t) {
      e.tabIndex = "-1", t.tabIndex = "0", t.focus();
    },
    isActive(e) {
      return e === this.d_activeStep;
    },
    isItemDisabled(e, t) {
      return this.disabled(e) || this.readonly && !this.isActive(t);
    },
    visible(e) {
      return typeof e.visible == "function" ? e.visible() : e.visible !== !1;
    },
    disabled(e) {
      return typeof e.disabled == "function" ? e.disabled() : e.disabled;
    },
    label(e) {
      return typeof e.label == "function" ? e.label() : e.label;
    },
    getMenuItemProps(e, t) {
      return {
        action: je(
          {
            class: this.cx("itemLink"),
            onClick: (n) => this.onItemClick(n, e),
            onKeyDown: (n) => this.onItemKeydown(n, e)
          },
          this.getPTOptions("itemLink", e, t)
        ),
        step: je(
          {
            class: this.cx("itemNumber")
          },
          this.getPTOptions("itemNumber", e, t)
        ),
        label: je(
          {
            class: this.cx("itemLabel")
          },
          this.getPTOptions("itemLabel", e, t)
        )
      };
    }
  }
}, RA = ["id"], MA = ["aria-current", "onClick", "onKeydown", "data-p-active", "data-p-disabled"];
function PA(e, t, n, a, o, l) {
  return L(), H("nav", je({
    id: e.id,
    class: e.cx("root")
  }, e.ptmi("root")), [
    y("ol", je({
      ref: "list",
      class: e.cx("list")
    }, e.ptm("list")), [
      (L(!0), H(He, null, jt(e.model, (s, i) => (L(), H(He, {
        key: l.label(s) + "_" + i.toString()
      }, [
        l.visible(s) ? (L(), H("li", je({
          key: 0,
          class: [e.cx("item", { item: s, index: i }), s.class],
          style: s.style,
          "aria-current": l.isActive(i) ? "step" : void 0,
          onClick: (u) => l.onItemClick(u, s, i),
          onKeydown: (u) => l.onItemKeydown(u, s, i)
        }, { ref_for: !0 }, l.getPTOptions("item", s, i), {
          "data-p-active": l.isActive(i),
          "data-p-disabled": l.isItemDisabled(s, i)
        }), [
          e.$slots.item ? (L(), be(Sa(e.$slots.item), {
            key: 1,
            item: s,
            index: i,
            active: i === o.d_activeStep,
            label: l.label(s),
            props: l.getMenuItemProps(s, i)
          }, null, 8, ["item", "index", "active", "label", "props"])) : (L(), H("span", je({
            key: 0,
            class: e.cx("itemLink")
          }, { ref_for: !0 }, l.getPTOptions("itemLink", s, i)), [
            y("span", je({
              class: e.cx("itemNumber")
            }, { ref_for: !0 }, l.getPTOptions("itemNumber", s, i)), U(i + 1), 17),
            y("span", je({
              class: e.cx("itemLabel")
            }, { ref_for: !0 }, l.getPTOptions("itemLabel", s, i)), U(l.label(s)), 17)
          ], 16))
        ], 16, MA)) : ue("", !0)
      ], 64))), 128))
    ], 16)
  ], 16, RA);
}
const xA = /* @__PURE__ */ Vt(AA, [["render", PA]]);
var Al = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, jA = { exports: {} };
(function(e, t) {
  (function(n, a) {
    a();
  })(Al, function() {
    function n(c, p) {
      return typeof p > "u" ? p = { autoBom: !1 } : typeof p != "object" && (console.warn("Deprecated: Expected third argument to be a object"), p = { autoBom: !p }), p.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(c.type) ? new Blob(["\uFEFF", c], { type: c.type }) : c;
    }
    function a(c, p, h) {
      var g = new XMLHttpRequest();
      g.open("GET", c), g.responseType = "blob", g.onload = function() {
        u(g.response, p, h);
      }, g.onerror = function() {
        console.error("could not download file");
      }, g.send();
    }
    function o(c) {
      var p = new XMLHttpRequest();
      p.open("HEAD", c, !1);
      try {
        p.send();
      } catch {
      }
      return 200 <= p.status && 299 >= p.status;
    }
    function l(c) {
      try {
        c.dispatchEvent(new MouseEvent("click"));
      } catch {
        var p = document.createEvent("MouseEvents");
        p.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), c.dispatchEvent(p);
      }
    }
    var s = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof Al == "object" && Al.global === Al ? Al : void 0, i = s.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), u = s.saveAs || (typeof window != "object" || window !== s ? function() {
    } : "download" in HTMLAnchorElement.prototype && !i ? function(c, p, h) {
      var g = s.URL || s.webkitURL, b = document.createElement("a");
      p = p || c.name || "download", b.download = p, b.rel = "noopener", typeof c == "string" ? (b.href = c, b.origin === location.origin ? l(b) : o(b.href) ? a(c, p, h) : l(b, b.target = "_blank")) : (b.href = g.createObjectURL(c), setTimeout(function() {
        g.revokeObjectURL(b.href);
      }, 4e4), setTimeout(function() {
        l(b);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(c, p, h) {
      if (p = p || c.name || "download", typeof c != "string") navigator.msSaveOrOpenBlob(n(c, h), p);
      else if (o(c)) a(c, p, h);
      else {
        var g = document.createElement("a");
        g.href = c, g.target = "_blank", setTimeout(function() {
          l(g);
        });
      }
    } : function(c, p, h, g) {
      if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), typeof c == "string") return a(c, p, h);
      var b = c.type === "application/octet-stream", E = /constructor/i.test(s.HTMLElement) || s.safari, m = /CriOS\/[\d]+/.test(navigator.userAgent);
      if ((m || b && E || i) && typeof FileReader < "u") {
        var I = new FileReader();
        I.onloadend = function() {
          var v = I.result;
          v = m ? v : v.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = v : location = v, g = null;
        }, I.readAsDataURL(c);
      } else {
        var S = s.URL || s.webkitURL, f = S.createObjectURL(c);
        g ? g.location = f : location.href = f, g = null, setTimeout(function() {
          S.revokeObjectURL(f);
        }, 4e4);
      }
    });
    s.saveAs = u.saveAs = u, e.exports = u;
  });
})(jA);
const Kt = (e, t) => {
  const n = {
    data: {},
    objectType: "object"
  }, a = (o, l, s) => {
    for (const i in l) {
      const u = l[i];
      if ("write" in u)
        u.write(o, s[i]);
      else {
        const [c, p] = u;
        let h;
        if (c in o.data)
          if (o.data[c].objectType === "object")
            h = o.data[c];
          else
            throw "non-object value already exists at key " + c;
        else
          h = {
            data: {},
            objectType: "object"
          };
        o.data[c] = h, a(h, p, s[i]);
      }
    }
  };
  return a(n, e, t), n;
}, Zt = (e, t) => {
  const n = {}, a = [], o = (l, s, i) => {
    for (const u in s) {
      a.push(u);
      const c = s[u];
      if ("read" in c)
        i[u] = c.read(l);
      else {
        const [p, h] = c, g = {};
        if (i[u] = g, !l)
          throw "object is undefined?: " + [...a];
        const b = l.data[p];
        if (!b)
          throw "missing object: " + [...a, p];
        if (b.objectType !== "object")
          throw "not an object: " + [...a, p];
        o(b, h, g);
      }
      a.pop();
    }
  };
  return o(t, e, n), n;
};
class $A {
  constructor(t) {
    an(this, "defaultValue");
    this.defaultValue = t;
  }
  read(t) {
    const n = Mt(t, "CLRED"), a = Mt(t, "CLGREEN"), o = Mt(t, "CLBLUE");
    if (n !== void 0 && a !== void 0 && o !== void 0)
      return [n, a, o];
    if (this.defaultValue !== void 0)
      return this.defaultValue;
    throw "missing color info";
  }
  write(t, n) {
    t.data.CLRED = bt(n[0]), t.data.CLGREEN = bt(n[1]), t.data.CLBLUE = bt(n[2]);
  }
}
class yl {
  constructor(t, n, a, o) {
    an(this, "key");
    an(this, "defaultValue");
    an(this, "reader");
    an(this, "writer");
    this.key = t, this.defaultValue = o, this.reader = n, this.writer = a;
  }
  read(t) {
    const n = this.reader(t, this.key);
    if (n !== void 0)
      return n;
    if (this.defaultValue !== void 0)
      return this.defaultValue;
    console.error("key and default missing: " + this.key);
  }
  write(t, n) {
    t.data[this.key] = this.writer(n);
  }
}
const ft = (e, t) => new yl(e, va, Zn, t), Ve = (e, t) => new yl(e, Mt, bt, t), xu = (e, t) => new yl(e, Pr, go, t), Wd = (e, t) => new yl(e, ji, _o, t), jn = (e, t) => new yl(e, qI, _o, t), FA = (e, t) => new yl(e, QI, _o, t), or = (e, t) => ({
  read(n) {
    const a = [Mt(n, e[0]), Mt(n, e[1]), Mt(n, e[2])];
    if (a.includes(void 0))
      throw "missing keys: " + e;
    return a;
  },
  write(n, a) {
    n.data[e[0]] = bt(a[0]), n.data[e[1]] = bt(a[1]), n.data[e[2]] = bt(a[2]);
  }
}), Qi = (e, t, n) => {
  const a = If(e, t, n);
  return {
    read: (s) => {
      const i = a.read(s), u = [];
      if (i.forEach((c, p) => {
        c === void 0 && u.push(p);
      }), u.length)
        throw "array missing values: " + u.join(", ");
      return i;
    },
    write: (s, i) => {
      a.write(s, i);
    }
  };
}, If = (e, t, n) => ({
  read: (l) => {
    const s = Pn(l, n), i = [];
    for (let u = 0; u < s; u++) {
      const c = `${t}_${u}`, p = Qt(l, c);
      if (p !== void 0) {
        let h;
        "model" in e ? h = e.model : h = e.mapper(p);
        const g = Zt(h, p);
        i.push(g);
      } else
        i.push(void 0);
    }
    return i;
  },
  write: (l, s) => {
    for (let i = 0; i < s.length; i++) {
      const u = `${t}_${i}`, c = s[i];
      if (c !== void 0) {
        let p;
        "model" in e ? p = e.model : p = e.reverseMapper(c), l.data[u] = Kt(p, c);
      }
    }
    l.data[`${n}`] = bt(s.length);
  }
});
function No(e, t) {
  const n = ws(e, [t, "FileName"]), a = eS(e, [t, "FileStream"]).data, o = Mm(e, [t, "FileSize"]);
  return { fileName: n, data: new Int8Array(a.buffer), fileSize: o };
}
function Lo(e, t, n) {
  n && (Es(e, [t, "FileName"], n.fileName), nS(e, [t, "FileStream"], n.data), Jo(e, [t, "FileSize"], n.fileSize));
}
function Rl(e, t) {
  const n = Fl(e, [t, "RED"]), a = Fl(e, [t, "GREEN"]), o = Fl(e, [t, "BLUE"]), l = Fl(e, [t, "ALPHA"]);
  return n !== void 0 && a !== void 0 && o !== void 0 && l !== void 0 ? [n, a, o, l] : [255, 255, 255, 255];
}
function Ml(e, t, n) {
  Jo(e, [t, "RED"], n[0]), Jo(e, [t, "GREEN"], n[1]), Jo(e, [t, "BLUE"], n[2]), Jo(e, [t, "ALPHA"], n[3]);
}
const kA = {
  name: ft("NAME"),
  manufacturerName: ft("MANUFACTURER_NAME"),
  implantFileName: ft("FILE_NAME"),
  implantOriginalName: ft("IMPLANT_ORIGINAL_NAME"),
  modelName: ft("MODEL_NAME"),
  sameManufacturerImplants: ft("SAME_MANUFACTURER_IMPLANTS"),
  guid: ft("GUID"),
  sellingCode: ft("IMPLANT_SELLING_CODE"),
  implantConnectorHeight: Ve("IMPLANT_CONECTOR_HEIGHT"),
  diameter: Ve("DIAMETER"),
  length: Ve("LENGTH"),
  color: Ve("COLOR")
}, bi = {
  shapePoints: Ve("SHAPE_POINTS", 0),
  objectType: Ve("OBJECT_TYPE", Oe._NONE),
  objectSubType: Ve("OBJECT_SUB_TYPE", Oe._NONE),
  name: ft("OBJECT_NAME"),
  displayText: ft("OBJECT_DISPLAY_TEXT"),
  objectNote: ft("OBJECT_NOTE", ""),
  visible: xu("VISIBLE", !0),
  enabled: Ve("ENABLED", 1),
  deleted: Ve("DELETED", 0),
  color: new $A(),
  opacity: Ve("CLALPHA", 0),
  ownerCount: Ve("OWNER_COUNT", 0),
  owners: {
    read: (e) => {
      const t = yo(e, "OWNER_COUNT"), n = [];
      if (t != null)
        for (let a = 0; a < t; a++) {
          const o = ws(e, [`OWNER_${a}`, ""]);
          n.push(o);
        }
      return n;
    },
    write: (e, t) => {
      const n = "OWNER_COUNT";
      e.data[n] = bt(t.length), t.forEach((a, o) => {
        const l = `OWNER_${o}`;
        Es(e, [l, ""], a);
      });
    }
  }
}, Sf = {
  origin: jn("ORIGIN"),
  normal: jn("NORMAL"),
  tangent: jn("TANGENT"),
  viewUp: jn("VIEWUP")
}, VA = {
  objectName: ft("OBJECT_NAME"),
  displayText: ft("OBJECT_DISPLAY_TEXT"),
  objectType: Ve("OBJECT_TYPE", Oe._NONE),
  objectSubType: Ve("OBJECT_SUB_TYPE", Oe._NONE),
  name: ft("NAME"),
  manufacturerName: ft("MANUFACTURER_NAME"),
  implantFileName: ft("FILE_NAME"),
  implantOriginalName: ft("IMPLANT_ORIGINAL_NAME"),
  modelName: ft("MODEL_NAME"),
  sameManufacturerImplants: ft("SAME_MANUFACTURER_IMPLANTS"),
  guid: ft("GUID"),
  sellingCode: ft("IMPLANT_SELLING_CODE"),
  orientation: Ve("ORIENTATION"),
  implantConnectorHeight: Ve("IMPLANT_CONECTOR_HEIGHT"),
  diameter: Ve("DIAMETER"),
  length: Ve("LENGTH"),
  color: Ve("COLOR"),
  nonSymmetric: Ve("NON_SYMMETRIC"),
  fileSha: ft("FILE_SHA"),
  connectionSides: {
    read: (e) => Mt(e, "CONNECTION_SIDES"),
    write: (e, t) => {
      t !== void 0 && (e.data.CONNECTION_SIDES = bt(t));
    }
  },
  stlFile: {
    read: (e) => No(e, "STLFile"),
    write: (e, t) => {
      Lo(e, "STLFile", t);
    }
  },
  plyFilename: ft("PLYFilename"),
  stlSuffix: ft("STLSuffix"),
  textureCount: {
    read: (e) => Mt(e, "TextureCount"),
    write: (e, t) => {
      t !== void 0 && (e.data.TextureCount = bt(t));
    }
  },
  textureFiles: {
    read: (e) => {
      const t = yo(e, "TextureCount");
      if (t === void 0) return;
      const n = [];
      for (let a = 0; a < t; a++) {
        const o = No(e, `TextureFile[${a}]`);
        o && n.push(o);
      }
      return n;
    },
    write: (e, t) => {
      t && t.forEach((n, a) => {
        Lo(e, `TextureFile[${a}]`, n);
      });
    }
  },
  textureFileNames: {
    read: (e) => {
      const t = yo(e, "TextureCount");
      if (t === void 0) return;
      const n = [];
      for (let a = 0; a < t; a++) {
        const o = ws(e, [`Texture[${a}]`]);
        n.push(o || "");
      }
      return n;
    },
    write: (e, t) => {
      if (!t) return;
      const n = "TextureCount";
      e.data[n] = bt(t.length), t.forEach((a, o) => {
        const l = `Texture[${o}]`;
        Es(e, [l], a);
      });
    }
  }
}, Ef = {
  name: ft("OBJECT_NAME"),
  displayText: ft("OBJECT_DISPLAY_TEXT"),
  objectType: Ve("OBJECT_TYPE"),
  objectSubType: Ve("OBJECT_SUB_TYPE"),
  implantInfo: ["IMPLANT", kA]
}, Qn = {
  manufacturerName: ft("MANUFACTURER_NAME"),
  modelName: ft("MODEL_NAME"),
  fileName: ft("FILE_NAME"),
  name: ft("NAME"),
  guid: ft("GUID"),
  color: Ve("COLOR"),
  angle: Ve("ANGLE"),
  connectorHeight: Ve("CONNECTION_HEIGHT"),
  abutmentSellingCode: ft("ABUTMENT_SELLING_CODE"),
  rotationZ: Ve("ROTATION_Z"),
  stlFile: {
    read: (e) => {
      if (Qt(e, "STLFile"))
        return No(e, "STLFile");
    },
    write: (e, t) => {
      t && Lo(e, "STLFile", t);
    }
  }
}, Oo = {
  originalName: ft("SLEEVE_ORIGINAL_NAME"),
  manufacturerName: ft("SLEEVE_MANUFACTURER"),
  modelName: ft("SLEEVE_MODEL"),
  sellingCode: ft("SLEEVE_SELLING_CODE"),
  drillLengthSizes: ft("SLEEVE_DRILL_SIZES"),
  dExternal: Ve("SLEEVE_DEXTERNAL"),
  dInternal: Ve("SLEEVE_DINTERNAL"),
  dHexagon: Ve("SLEEVE_DHEXAGON"),
  lSleeve: Ve("SLEEVE_LSLEEVE"),
  lLip: Ve("SLEEVE_LLIP"),
  lCut: Ve("SLEEVE_LCUT"),
  distanceFromImplant: Ve("SLEEVE_DISTANCE_FROM_IMPLANT"),
  originalDistanceFromImplant: Ve("SLEEVE_ORIGINAL_DISTANCE_FROM_IMPLANT"),
  referencedSleeve: {
    read: (e) => Mt(e, "SLEEVE_REFERENCED_SLEEVE"),
    write: (e, t) => {
      t !== void 0 && (e.data.SLEEVE_REFERENCED_SLEEVE = bt(t));
    }
  },
  reductionSystemSize: Ve("SLEEVE_REDUCTION_SYSTEM_SIZE"),
  cylinderShape: xu("SLEEVE_CYLINDER_SHAPE"),
  lockDistance: {
    read: (e) => Mt(e, "SLEEVE_LOCK_DISTANCE"),
    write: (e, t) => {
      t !== void 0 && (e.data.SLEEVE_LOCK_DISTANCE = bt(t));
    }
  },
  distanceFromImplantOffset: {
    read: (e) => Mt(e, "SLEEVE_DISTANCE_FROM_IMPLANT_OFFSET"),
    write: (e, t) => {
      t !== void 0 && (e.data.SLEEVE_DISTANCE_FROM_IMPLANT_OFFSET = bt(t));
    }
  },
  rotationAll: {
    read: (e) => Mt(e, "ROTATION_ALL"),
    write: (e, t) => {
      t !== void 0 && (e.data.ROTATION_ALL = bt(t));
    }
  },
  rotationCut: {
    read: (e) => Mt(e, "ROTATION_CUT"),
    write: (e, t) => {
      t !== void 0 && (e.data.ROTATION_CUT = bt(t));
    }
  },
  connectionIndex: {
    read: (e) => Mt(e, "CONNECTION_INDEX"),
    write: (e, t) => {
      t !== void 0 && (e.data.CONNECTION_INDEX = bt(t));
    }
  },
  stlFileGuid: {
    read: (e) => va(e, "SLEEVE_STL_FILEGUID"),
    write: (e, t) => {
      t !== void 0 && (e.data.SLEEVE_STL_FILEGUID = Zn(t));
    }
  },
  stlFileNegativeGuid: {
    read: (e) => va(e, "SLEEVE_STL_NEGATIVE_FILEGUID") ?? va(e, "SLEEVE_STL_NEGATIVE_FILE_GUID"),
    write: (e, t) => {
      t !== void 0 && (e.data.SLEEVE_STL_NEGATIVE_FILEGUID = Zn(t));
    }
  },
  stlData: {
    read: (e) => {
      if (Qt(e, "SLEEVE_STL_FILE"))
        return No(e, "SLEEVE_STL_FILE");
    },
    write: (e, t) => {
      t && Lo(e, "SLEEVE_STL_FILE", t);
    }
  },
  stlNegativeData: {
    read: (e) => {
      if (Qt(e, "SLEEVE_STL_NEGATIVE_FILE"))
        return No(e, "SLEEVE_STL_NEGATIVE_FILE");
    },
    write: (e, t) => {
      t && Lo(e, "SLEEVE_STL_NEGATIVE_FILE", t);
    }
  }
}, zd = {
  name: ft("name"),
  guide_radius_hexagon: Ve("guide_radius_hexagon"),
  guide_lip_length: Ve("guide_lip_length"),
  guide_cut_size: Ve("guide_cut_size"),
  guide_rotation_all: Ve("guide_rotation_all"),
  guide_rotation_cut: Ve("guide_rotation_cut")
}, es = {
  name: ft("name"),
  d1Model: Ve("d1Model"),
  d2Model: Ve("d2Model"),
  l1Model: Ve("l1Model"),
  l2Model: Ve("l2Model"),
  cutSizeModel: Ve("cutSizeModel"),
  bottomExtrusionRModel: Ve("bottomExtrusionRModel"),
  support_lenght: Ve("support_lenght"),
  supportRModel: Ve("supportRModel"),
  base_lenght: Ve("base_lenght"),
  rotation_cutModel: Ve("rotation_cutModel"),
  stlFileGuid: {
    read: (e) => va(e, "STL_FILEGUID"),
    write: (e, t) => {
      t !== void 0 && (e.data.STL_FILEGUID = Zn(t));
    }
  },
  stlData: {
    read: (e) => {
      if (Qt(e, "STL_FILE"))
        return No(e, "STL_FILE");
    },
    write: (e, t) => {
      t && Lo(e, "STL_FILE", t);
    }
  }
}, Tf = {
  ...bi,
  origin: jn("ORIGIN", [0, 0, 0]),
  CadToothInfoOrderNumber: Ve("CadToothInfoOrderNumber", -1),
  CadToothInfoType: Ve("CadToothInfoType", -1)
}, BA = {
  ...bi,
  ...Sf
}, ts = {
  ...BA,
  isTextureConverted: Ve("TEXTURE_CONVERTED", 0),
  storedOrigin: jn("STORED_ORIGIN"),
  storedNormal: jn("STORED_NORMAL"),
  storedViewUp: jn("STORED_VIEWUP"),
  registrationMatrix: Wd("REGISTRATION_MATRIX"),
  registrationMatrixInverse: Wd("REGISTRATION_MATRIX_INVERSE"),
  diameter: Ve("DIAMETER", 0),
  diameter2: Ve("DIAMETER2", 0),
  height: Ve("HEIGHT", 0),
  implantInfo: ["IMPLANT", VA],
  rotation: Ve("ROTATION", 0),
  implantType: Ve("IMPLANT_TYPE", 0),
  cadType: Ve("CAD_TYPE", -1),
  cadToothInfoOrderNumber: Ve("CAD_TOOTH_INFO_ORDER_NUMBER", -1),
  cadToothInfoType: Ve("CAD_TOOTH_INFO_TYPE", -1),
  cadCorrespondenceId: Ve("CAD_CORRESPONDENCE_ID", -1),
  cadReconstructionTypeId: Ve("CAD_RECONSTRUCTION_TYPE_ID", -1),
  stlFileCam5Attachment: {
    read: (e) => va(e, "STL_FILE_CAM5_ATTACHMENT"),
    write: (e, t) => {
      t !== void 0 && (e.data.STL_FILE_CAM5_ATTACHMENT = Zn(t));
    }
  },
  stlFileCam5RegistrationMatrix: {
    read: (e) => ji(e, "STL_FILE_CAM5_REGISTRATION_MATRIX"),
    write: (e, t) => {
      t !== void 0 && (e.data.STL_FILE_CAM5_REGISTRATION_MATRIX = _o(t));
    }
  },
  toothPosition: ft("TOOTH_POSITION"),
  trackingType: Ve("trackingType", -1),
  // This abutment stay only if type == _IMPLANT
  abutment: {
    read: (e) => {
      const t = Qt(e, "ABUTMENT");
      if (t)
        return Zt(Qn, t);
    },
    write: (e, t) => {
      t && (e.data.ABUTMENT = Kt(Qn, t));
    }
  },
  secondaryAbutment: {
    read: (e) => {
      const t = Qt(e, "SECONDARY_ABUTMENT");
      if (t)
        return Zt(Qn, t);
    },
    write: (e, t) => {
      t && (e.data.SECONDARY_ABUTMENT = Kt(Qn, t));
    }
  },
  secondaryScanAbutment: {
    read: (e) => {
      const t = Qt(e, "SECONDARY_SCAN_ABUTMENT");
      if (t)
        return Zt(Qn, t);
    },
    write(e, t) {
      t && (e.data.SECONDARY_SCAN_ABUTMENT = Kt(Qn, t));
    }
  },
  modelAnalog: {
    read: (e) => {
      const t = Qt(e, "MODELANALOG");
      if (t)
        return Zt(Qn, t);
    },
    write(e, t) {
      t && (e.data.MODELANALOG = Kt(Qn, t));
    }
  },
  scanAbutment: {
    read: (e) => {
      const t = Qt(e, "SCAN_ABUTMENT");
      if (t)
        return Zt(Qn, t);
    },
    write(e, t) {
      t && (e.data.SCAN_ABUTMENT = Kt(Qn, t));
    }
  },
  abutmentColor: {
    read: (e) => Rl(e, "ABUTMENT_CL"),
    write(e, t) {
      Ml(e, "ABUTMENT_CL", t);
    }
  },
  secScanAbutmentColor: {
    read: (e) => Rl(e, "SEC_SCAN_ABUTMENT_CL"),
    write(e, t) {
      Ml(e, "SEC_SCAN_ABUTMENT_CL", t);
    }
  },
  modelAnaColor: {
    read: (e) => Rl(e, "MODEL_ANA_CL"),
    write(e, t) {
      Ml(e, "MODEL_ANA_CL", t);
    }
  },
  scanAbutmentColor: {
    read: (e) => Rl(e, "SCAN_ABUTMENT_CL"),
    write(e, t) {
      Ml(e, "SCAN_ABUTMENT_CL", t);
    }
  },
  secAbutmentColor: {
    read: (e) => Rl(e, "SEC_ABUTMENT_CL"),
    write(e, t) {
      Ml(e, "SEC_ABUTMENT_CL", t);
    }
  },
  sleeveInfo: {
    read: (e) => {
      const t = Qt(e, "SLEEVE_INFO");
      if (t)
        return Zt(Oo, t);
    },
    write: (e, t) => {
      t && (e.data.SLEEVE_INFO = Kt(Oo, t));
    }
  },
  implantModel: {
    read: (e) => {
      const t = Qt(e, "IMPLANT_MODEL");
      if (t)
        return Zt(es, t);
    },
    write: (e, t) => {
      t && (e.data.IMPLANT_MODEL = Kt(es, t));
    }
  },
  drillLength: {
    read: (e) => Mt(e, "DRILL_LENGTH"),
    write: (e, t) => {
      t !== void 0 && (e.data.DRILL_LENGTH = bt(t));
    }
  },
  drillLengthMm: {
    read: (e) => Mt(e, "DRILL_LENGTH_MM"),
    write: (e, t) => {
      t !== void 0 && (e.data.DRILL_LENGTH_MM = bt(t));
    }
  },
  sleeveManuallyChanged: {
    read: (e) => Mt(e, "sleeveManuallyChanged"),
    write: (e, t) => {
      t !== void 0 && (e.data.sleeveManuallyChanged = bt(t));
    }
  },
  sameManufacturerImplantsCount: {
    read: (e) => Mt(e, "SAME_MANUFACTURER_IMPLANTS_COUNT"),
    write: (e, t) => {
      t !== void 0 && (e.data.SAME_MANUFACTURER_IMPLANTS_COUNT = bt(t));
    }
  },
  sameManufacturerImplants: {
    read: (e) => {
      const t = yo(e, "SAME_MANUFACTURER_IMPLANTS_COUNT");
      if (t === void 0) return;
      const n = [];
      for (let a = 0; a < t; a++) {
        const o = ws(e, [`SAME_MANUFACTURER_IMPLANTS_${a}`, ""]);
        n.push(o);
      }
      return n;
    },
    write: (e, t) => {
      if (!t) return;
      const n = "SAME_MANUFACTURER_IMPLANTS_COUNT";
      e.data[n] = bt(t.length), t.forEach((a, o) => {
        const l = `SAME_MANUFACTURER_IMPLANTS_${o}`;
        Es(e, [l, ""], a);
      });
    }
  },
  scaleX: {
    read: (e) => Mt(e, "SCALE_X"),
    write: (e, t) => {
      t !== void 0 && (e.data.SCALE_X = bt(t));
    }
  },
  scaleY: {
    read: (e) => Mt(e, "SCALE_Y"),
    write: (e, t) => {
      t !== void 0 && (e.data.SCALE_Y = bt(t));
    }
  },
  scaleZ: {
    read: (e) => Mt(e, "SCALE_Z"),
    write: (e, t) => {
      t !== void 0 && (e.data.SCALE_Z = bt(t));
    }
  },
  // VOLUME fields
  // TODO missing dataArrays !!!! --> should all be parsed to sgpr + sgbd so these fields shold be redundant
  volume_data: {
    read: (e) => Mt(e, "volume_data"),
    write: (e, t) => {
      t !== void 0 && (e.data.volume_data = bt(t));
    }
  },
  volume_data_curve: {
    read: (e) => Mt(e, "volume_data_curve"),
    write: (e, t) => {
      t !== void 0 && (e.data.volume_data_curve = bt(t));
    }
  },
  volume_data_scalars: {
    read: (e) => Mt(e, "volume_data_scalars"),
    write: (e, t) => {
      t !== void 0 && (e.data.volume_data_scalars = bt(t));
    }
  },
  offset_protection_mask_data: {
    read: (e) => Mt(e, "offset_protection_mask_data"),
    write: (e, t) => {
      t !== void 0 && (e.data.offset_protection_mask_data = bt(t));
    }
  },
  offset1: {
    read: (e) => Mt(e, "offset1"),
    write: (e, t) => {
      t !== void 0 && (e.data.offset1 = bt(t));
    }
  },
  offset2: {
    read: (e) => Mt(e, "offset2"),
    write: (e, t) => {
      t !== void 0 && (e.data.offset2 = bt(t));
    }
  },
  capvalue: {
    read: (e) => Mt(e, "capvalue"),
    write: (e, t) => {
      t !== void 0 && (e.data.capvalue = bt(t));
    }
  },
  smoothing_distance: {
    read: (e) => Mt(e, "smoothing_distance"),
    write: (e, t) => {
      t !== void 0 && (e.data.smoothing_distance = bt(t));
    }
  },
  smoothing_on: {
    read: (e) => Mt(e, "smoothing_on"),
    write: (e, t) => {
      t !== void 0 && (e.data.smoothing_on = bt(t));
    }
  },
  inverted_volume: {
    read: (e) => Mt(e, "inverted_volume"),
    write: (e, t) => {
      t !== void 0 && (e.data.inverted_volume = bt(t));
    }
  },
  volume_transform: {
    read: (e) => ji(e, "volume_transform"),
    write: (e, t) => {
      t !== void 0 && (e.data.volume_transform = _o(t));
    }
  },
  volume_transform_to_3D: {
    read: (e) => ji(e, "volume_transform_to_3D"),
    write: (e, t) => {
      t !== void 0 && (e.data.volume_transform_to_3D = _o(t));
    }
  }
}, Cf = {
  ...bi,
  points: {
    read: (e) => {
      const t = Pn(e, "SHAPE_POINTS"), n = [];
      for (let a = 0; a < t; a++) {
        const o = Xo(Zo(e, `POINT_${a}`), "");
        n.push(o);
      }
      return n;
    },
    write: (e, t) => {
      const n = "SHAPE_POINTS";
      e.data[n] = bt(t.length), t.forEach((a, o) => {
        const l = `POINT_${o}`;
        qo(e, [l, ""], a);
      });
    }
  }
}, Nf = {
  ...Cf,
  maxilla0Mandible: {
    read: (e) => {
      const t = Mm(e, ["Maxiilla_0_Mandibla", ""]);
      if (![-1, 0, 1].includes(t))
        throw "failed to parse cpr maxilla/mandible value";
      return t;
    },
    write: (e, t) => {
      if (![-1, 0, 1].includes(t))
        throw "";
      Jo(e, ["Maxiilla_0_Mandibla", ""], t);
    }
  },
  owner: {
    read: (e) => {
      if (Pn(e, "OBJECT_SUB_TYPE") === Oe._CPR_DENTAL) {
        const n = Xo(Zo(e, "OWNER_O"), ""), a = Xo(Zo(e, "OWNER_N"), ""), o = Xo(Zo(e, "OWNER_S"), ""), l = Xo(Zo(e, "OWNER_T"), "");
        return {
          o: n,
          n: a,
          s: o,
          t: l
        };
      } else
        return;
    },
    write: (e, t) => {
      t && (qo(e, ["OWNER_O", ""], t.o), qo(e, ["OWNER_N", ""], t.n), qo(e, ["OWNER_S", ""], t.s), qo(e, ["OWNER_T", ""], t.t));
    }
  }
}, Lf = {
  ...Cf,
  radius: Ve("RADIUS")
}, UA = {
  name: ft("NAME"),
  filename: ft("FILENAME"),
  manufacturerName: ft("MANUFACTURER_NAME"),
  modelName: ft("MODEL_NAME"),
  color: ft("COLOR"),
  guid: ft("GUID"),
  stlFile: {
    read: (e) => No(e, "STLFile"),
    write: (e, t) => {
      Lo(e, "STLFile", t);
    }
  }
}, Of = {
  ...bi,
  sleeveInfo: {
    read: (e) => {
      const t = Qt(e, "SLEEVE_INFO");
      if (t)
        return Zt(Oo, t);
    },
    write: (e, t) => {
      t && (e.data.SLEEVE_INFO = Kt(Oo, t));
    }
  },
  pinInfo: ["INFO", UA],
  implantGuide: {
    read: (e) => {
      const t = Qt(e, "IMPLANT_GUIDE");
      if (t)
        return Zt(zd, t);
    },
    write: (e, t) => {
      t && (e.data.IMPLANT_GUIDE = Kt(zd, t));
    }
  },
  implantModel: {
    read: (e) => {
      const t = Qt(e, "IMPLANT_MODEL");
      if (t)
        return Zt(es, t);
    },
    write: (e, t) => {
      t && (e.data.IMPLANT_MODEL = Kt(es, t));
    }
  },
  ...Sf
}, vi = {
  ...bi,
  points: {
    read: (e) => {
      const t = Pn(e, "SHAPE_POINTS"), n = [];
      for (let a = 0; a < t; a++) {
        const o = Xo(Zo(e, `POINT_${a}`), "");
        n.push(o);
      }
      return n;
    },
    write: (e, t) => {
      const n = "SHAPE_POINTS";
      e.data[n] = bt(t.length), t.forEach((a, o) => {
        const l = `POINT_${o}`;
        qo(e, [l, ""], a);
      });
    }
  },
  owner: ft("OWNER")
}, Df = {
  ...vi
}, Af = {
  ...vi,
  annotationText: ft("ANNOTATION_TEXT")
}, Rf = {
  ...vi
}, Mf = {
  ...vi
}, Pf = {
  ...vi,
  statistics: [
    "STATISTICS",
    {
      area: Ve("Area"),
      length: Ve("Length"),
      avg: Ve("Avg"),
      min: Ve("Min"),
      max: Ve("Max"),
      stdDev: Ve("StdDev")
    }
  ]
}, GA = (e) => {
  const t = Pn(e, "OBJECT_TYPE");
  if (t === Oe._CPR_SHAPE_INDICATOR)
    return Df;
  if (t === Oe._ANNOTATION)
    return Af;
  if (t === Oe._DISTANCE)
    return Rf;
  if (t === Oe._ANGLE)
    return Mf;
  if (t === Oe._POLYGON)
    return Pf;
  throw "unknown collection2d object type: " + t;
}, WA = (e) => {
  const t = e.objectType;
  if (t === Oe._CPR_SHAPE_INDICATOR)
    return Df;
  if (t === Oe._ANNOTATION)
    return Af;
  if (t === Oe._DISTANCE)
    return Rf;
  if (t === Oe._ANGLE)
    return Mf;
  if (t === Oe._POLYGON)
    return Pf;
  throw "unknown collection2d object type: " + t;
}, xf = {
  objects: Qi(
    {
      mapper: GA,
      reverseMapper: WA
    },
    "OBJECT",
    "OBJECTS_COUNT"
  ),
  iAnnotAdded: Ve("iAnnotAdded"),
  iDistanceAdded: Ve("iDistanceAdded"),
  iAngleAdded: Ve("iAngleAdded"),
  iPolyAdded: Ve("iPolyAdded")
}, jf = {
  dim: or(["DIM_0", "DIM_1", "DIM_2"]),
  offset: or(["OFFSET_0", "OFFSET_1", "OFFSET_2"]),
  spacing: or(["MM_0", "MM_1", "MM_2"]),
  windowLevel: Ve("WL"),
  windowWidth: Ve("WW")
}, Br = {
  croppedPointMin: jn("CROPPED_POINT_MIN"),
  croppedPointMax: jn("CROPPED_POINT_MAX"),
  generalNotes: ft("GENERAL_NOTES"),
  patientData: {
    read: (e) => va(e, "PATIENT_DATA"),
    write: (e, t) => {
      t !== void 0 && (e.data.PATIENT_DATA = Zn(t));
    }
  },
  seriesData: {
    read: (e) => va(e, "SERIES_DATA"),
    write: (e, t) => {
      t !== void 0 && (e.data.SERIES_DATA = Zn(t));
    }
  },
  dicomData: {
    read: (e) => va(e, "DICOM_DATA"),
    write: (e, t) => {
      t !== void 0 && (e.data.DICOM_DATA = Zn(t));
    }
  },
  modified: {
    read: (e) => ({
      year: Pn(e, "PROJECT_MODIFIED_YEAR"),
      month: Pn(e, "PROJECT_MODIFIED_MONTH"),
      day: Pn(e, "PROJECT_MODIFIED_DAY"),
      hour: Pn(e, "PROJECT_MODIFIED_HOUR"),
      minutes: Pn(e, "PROJECT_MODIFIED_MINUTES"),
      seconds: Pn(e, "PROJECT_MODIFIED_SECONDS")
    }),
    write: (e, t) => {
      e.data.PROJECT_MODIFIED_YEAR = bt(t.year), e.data.PROJECT_MODIFIED_MONTH = bt(t.month), e.data.PROJECT_MODIFIED_DAY = bt(t.day), e.data.PROJECT_MODIFIED_HOUR = bt(t.hour), e.data.PROJECT_MODIFIED_MINUTES = bt(t.minutes), e.data.PROJECT_MODIFIED_SECONDS = bt(t.seconds);
    }
  },
  projectCropped: Ve("PROJECT_CROPPED"),
  projectVersion: Ve("PROJECT_VERSION"),
  useUSToothMap: xu("PROJECT_USE_US_TOOTH_MAP")
}, zA = {
  indexId: Ve("INDEXID"),
  stateId: ft("STATEID"),
  layoutType: Ve("LAYOUT_TYPE"),
  desktopType: Ve("DESKTOP_TYPE"),
  bookType: Ve("BOOK_TYPE"),
  origin: jn("ORIGIN"),
  cprAngle: Ve("CPR_ANGLE")
}, HA = {
  stateId: Ve("STATEID"),
  origin: jn("ORIGIN"),
  xAxis: jn("X_AXIS"),
  yAxis: jn("Y_AXIS"),
  zAxis: jn("Z_AXIS"),
  windowLevelWidth: FA("WINDOW_LEVEL_WIDTH"),
  filterType: Ve("FILTER_TYPE"),
  mipThickness: Ve("MIP_THICKENSS")
}, YA = {
  stateId: Ve("STATEID"),
  columns: Ve("COLUMNS"),
  rows: Ve("ROWS")
}, KA = {
  presenterWindow: [
    "PRESENTER_WINDOW",
    {
      bookmarks: Qi({ model: YA }, "BOOKMARK", "BOOKMARKS_COUNT"),
      viewWidget: [
        "VIEW_WIDGET",
        {
          bookmarks: Qi({ model: HA }, "BOOKMARK", "BOOKMARKS_COUNT")
        }
      ]
    }
  ]
}, $f = {
  layout: [
    "LAYOUT",
    {
      bookmarks: Qi({ model: zA }, "BOOKMARK", "BOOKMARKS_COUNT")
    }
  ],
  windows: [
    "WINDOWS",
    {
      windows: If({ model: KA }, "WINDOW", "WINDOWS_COUNT")
    }
  ]
};
new TextEncoder().encode("Salted__");
function Ai(e) {
  return new TextEncoder().encode(e);
}
async function to(e) {
  const t = await crypto.subtle.digest("SHA-256", e);
  return Array.from(new Uint8Array(t)).map((a) => a.toString(16).padStart(2, "0")).join("");
}
const ZA = (e) => Zt(Nf, e), XA = (e) => Zt(Lf, e), JA = (e) => {
  const t = Zt(Of, e);
  return t.name == "Pin 1" && (t.name = "Pin A"), t.name == "Pin 2" && (t.name = "Pin B"), t.name == "Pin 3" && (t.name = "Pin C"), t.name == "Pin 4" && (t.name = "Pin D"), t.name == "Pin 5" && (t.name = "Pin E"), t.name == "Pin 6" && (t.name = "Pin F"), t.name == "Pin 7" && (t.name = "Pin G"), t.name == "Pin 8" && (t.name = "Pin H"), t.name == "Pin 9" && (t.name = "Pin I"), t;
}, qA = (e) => Zt(ts, e), QA = (e) => Zt(Tf, e), e2 = (e) => Zt(ts, e), t2 = (e) => {
  const t = Zt(Ef, e);
  let n;
  const a = Qt(e, "ABUTMENT");
  a && (n = Zt(Qn, a));
  let o;
  const l = Qt(e, "SLEEVE_INFO");
  return l && _s(l, "SLEEVE_ORIGINAL_NAME") && (o = Zt(Oo, l)), {
    implant: t,
    abutment: n,
    sleeve: o
  };
}, n2 = (e) => {
  const t = {
    data: {},
    objectType: "object"
  }, n = Kt(Ef, e.implant);
  if (t.data = n.data, e.abutment) {
    const a = Kt(Qn, e.abutment);
    t.data.ABUTMENT = a;
  }
  if (e.sleeve) {
    const a = Kt(Oo, e.sleeve);
    t.data.SLEEVE_INFO = a;
  }
  return t;
};
function a2(e) {
  const t = [], n = [], a = [], o = [], l = [], s = [], i = [], u = Pn(e, "OBJECTS_COUNT");
  if (isNaN(u))
    throw "OBJECT_COUNT NaN";
  for (let c = 0; c < u; c++) {
    const p = `OBJECT_${c}`, h = Qt(e, p);
    if (!h)
      throw `${p} object data missing`;
    const g = Pn(h, "OBJECT_TYPE");
    g === Oe._NERVE ? o.push(XA(h)) : g === Oe._IMPLANT ? t.push(e2(h)) : g === Oe._CPR_CURVE ? a.push(ZA(h)) : g === Oe._PIN ? n.push(JA(h)) : g === Oe._STL_OBJECT || g === Oe._STL_TOOTH || g === Oe._STL_PROSTHESIS || g === Oe._STL_TEETH_MODEL ? l.push(qA(h)) : g === Oe._TOOTH_MARKER ? s.push(QA(h)) : (console.warn("loader not implemented for object type", g), i.push(h));
  }
  return {
    implants: t,
    pins: n,
    cprCurves: a,
    nerves: o,
    stlObjects: l,
    toothMarkers: s,
    unsupportedObjects: i
  };
}
async function o2(e, t, n, a, o) {
  const { pr: l, stlInfo: s, imageData: i, mobile: u, segmentationResult: c } = n, p = (o == null ? void 0 : o.volumeQuality) ?? "full", h = (o == null ? void 0 : o.includeImplants) ?? !0, g = (o == null ? void 0 : o.includePins) ?? !0, b = (o == null ? void 0 : o.includeProjectStlObjects) ?? !0, E = o != null && o.includedProjectStlObjectNames && o.includedProjectStlObjectNames.length > 0 ? new Set(o.includedProjectStlObjectNames) : void 0, I = {
    loaded: 0,
    total: 1 + (s ? 1 : 0) + (u ? 1 : 0) + 1 + 4 + 2 + 1
  }, S = () => {
    I.loaded++, a && a(I);
  };
  l.then(S), s && s.then(S), c.then(S);
  const f = (s == null ? void 0 : s.then((x) => {
    const N = Qt(x, "COLLECTION_3D");
    return N ? a2(N) : null;
  })) ?? null, v = l.then((x) => Zt(jf, x)), w = l.then((x) => Zt(Br, x)), A = l.then((x) => {
    const N = Qt(x, "BOOKMARKS");
    return N ? Zt($f, N) : null;
  }), T = l.then((x) => {
    const N = Qt(x, "COLLECTION_2D");
    return N ? Zt(xf, N) : null;
  }), O = Promise.all([i, v]).then(([x, N]) => {
    const G = {
      imageData: x,
      projectImageData: N
    };
    return uh(G.projectImageData, G.imageData);
  });
  await Promise.all([
    O.then((x) => {
      e.setImageData(x, p === "decimated");
    }).then(S),
    w.then((x) => {
      e.projectGeneralData = x;
    }).then(S),
    A.then((x) => {
      x && (e.projectBookmarks = x, e.objects.remapBookmarksFromProject());
    }).then(S),
    T.then((x) => {
      x && (e.objects.projectCollection2D = x);
    }).then(S)
  ]), e.replaceVolumeObject(), e.setVolumeInterpolationType(ch.LINEAR);
  const C = (x) => {
    const N = [];
    return x && x.length && x.forEach((G) => {
      N.push([G.x, G.y, G.z]);
    }), N;
  };
  let k = !1, M = !1;
  const z = await f;
  if (S(), z) {
    const { implants: x, pins: N, cprCurves: G, nerves: ce, stlObjects: re, toothMarkers: Se } = z;
    if (h)
      for (const se of x)
        e.objects.addProjectImplant(se);
    if (g)
      for (const se of N)
        e.objects.addPin(se, void 0);
    for (const se of G)
      e.objects.addCPRCurve(se);
    for (const se of ce)
      e.objects.addNerve(se), se.objectSubType == Oe._NERVE_LEFT && (k = !0), se.objectSubType == Oe._NERVE_RIGHT && (M = !0);
    for (const se of re) {
      if (!b || E && !E.has(se.name))
        continue;
      let Le = !1;
      for (let [Y, pe] of e.objects.stls)
        pe.getName() == se.name && pe.IsVolume() && (Le = !0, pe.SetImplantPlanerProjectStl(se));
      Le || e.objects.addSTL(se, {
        ply: se.implantInfo.stlSuffix === ".ply"
      });
    }
    for (const se of Se) {
      const Le = dh.fromProjectToothMarker(e, se, {});
      e.objects.toothMarkers.set(Le.id, Le);
    }
    e.objects.unsupportedProjectStlObjects = z.unsupportedObjects;
  }
  S();
  const j = await c;
  e.segmentationResult = j;
  let K = !1;
  if (j) {
    if (!e.objects.hasCPR()) {
      const G = {
        maxilla0Mandible: nn.MAXILLA,
        owner: {
          o: [0, 0, 0],
          n: [0, 0, 1],
          s: [0, 1, 0],
          t: [1, 0, 0]
        },
        points: [],
        name: "Maxilla_CPR",
        displayText: "",
        objectType: Oe._CPR_CURVE,
        objectSubType: Oe._CPR_DENTAL,
        visible: !0,
        color: e.settings.defaultColors.cprColor,
        opacity: 1,
        objectNote: "",
        enabled: 1,
        deleted: 0,
        owners: ["AXIAL"],
        ownerCount: 1,
        shapePoints: 0
      };
      let ce = j.cpr.maxilla;
      e.CPRType == nn.MANDIBLE || !ce ? (e.CPRType = nn.MANDIBLE, ce = j.cpr.mandible, G.maxilla0Mandible = nn.MANDIBLE, G.name = "Mandible_CPR") : e.CPRType = nn.MAXILLA, G.points = C(ce), G.points.length && (G.owner = ph(G.points), e.objects.addCPRCurve(G, !0));
    }
    const x = e.settings.defaultColors.nerves, N = {
      radius: 3,
      points: [],
      opacity: 1,
      name: "",
      objectType: Oe._NERVE,
      objectSubType: Oe._NONE,
      color: x,
      visible: !0,
      displayText: "",
      objectNote: "",
      enabled: 1,
      deleted: 0,
      owners: [],
      ownerCount: 0,
      shapePoints: 0
    };
    k || (N.points = C(j.nerve.left), N.points.length && (N.name = "Left Nerve", N.objectSubType = Oe._NERVE_LEFT, e.objects.addNerve(N, void 0, !0))), M || (N.points = C(j.nerve.right), N.points.length && (N.name = "Right Nerve", N.objectSubType = Oe._NERVE_RIGHT, e.objects.addNerve(N, void 0, !0))), (!k || !M) && (K = !0);
  }
  if (e.objects.projectCollection2D && e.projectBookmarks) {
    for (const x of e.projectBookmarks.windows.windows)
      if (x)
        for (const N of x.presenterWindow.viewWidget.bookmarks) {
          const G = e.objects.scaleVectorFromImplantPlanner(mo.fromValues(N.origin[0], N.origin[1], N.origin[2]));
          N.origin = G;
        }
    for (const x of e.projectBookmarks.layout.bookmarks) {
      const N = e.objects.scaleVectorFromImplantPlanner(mo.fromValues(x.origin[0], x.origin[1], x.origin[2]));
      x.origin = N;
    }
    for (const x of e.objects.projectCollection2D.objects) {
      console.log("Scaling point");
      for (const N in x.points)
        x.points[N] = e.objects.scaleVectorFromImplantPlanner(x.points[N]);
    }
    e.objects.projectCollection2D.objects.forEach((x) => {
      e.toolManager.measurementsTool.measurementTool.addMeasurementFromProject(x);
    });
  }
  S(), await t(e, !1), K && (await e.toolManager.setTool(_n.NERVE, rn.PRIMARY), await e.toolManager.setTool(_n.NONE, rn.PRIMARY)), e.settings.onProjectLoaded();
}
function l2(e) {
  const t = [], n = [], a = [], o = [], l = [], s = yo(e, "DIM_0") || 0, i = yo(e, "DIM_1") || 0, u = yo(e, "DIM_2") || 0, c = Qt(e, "COLLECTION_3D");
  if (c) {
    const E = Pn(c, "OBJECTS_COUNT");
    if (isNaN(E))
      throw "OBJECT_COUNT NaN";
    for (let m = 0; m < E; m++) {
      const I = `OBJECT_${m}`, S = Qt(c, I);
      if (!S)
        throw `${I} object data missing`;
      Pn(S, "OBJECT_TYPE") === Oe._IMPLANT && t.push(t2(S));
    }
  }
  const p = _s(e, "PROJECT_SCREENSHOT").data, h = va(e, "PLANNER_PROJECT_STEP") || "", g = Pr(e, "LOAD_OBJECTS_FROM_PATIENT") || !1, b = Pr(e, "SEGMENTATION_INVOKED_BY_USER") || !1;
  return {
    imgDims: [s, i, u],
    implants: t,
    pins: n,
    cprCurves: a,
    nerves: o,
    stlObjects: l,
    screenshot: p,
    plannerStep: h,
    loadObjectsFromPatient: g,
    segmentationInvokedByUser: b
  };
}
async function i2(e, t, n, a) {
  const o = {
    data: t ? { ...t.data } : {},
    objectType: "object"
  }, l = e.objects.getImplantObjectData();
  if (l.length) {
    const i = {
      data: {},
      objectType: "object"
    };
    i.data.OBJECTS_COUNT = bt(l.length);
    for (let u = 0; u < l.length; u++) {
      const c = `OBJECT_${u}`, h = {
        implant: {
          name: l[u].name,
          displayText: l[u].displayText,
          objectType: l[u].objectType,
          objectSubType: l[u].objectSubType,
          implantInfo: l[u].implantInfo
        },
        abutment: l[u].abutment,
        sleeve: l[u].sleeveInfo
      }, g = n2(h);
      i.data[c] = g;
    }
    o.data.COLLECTION_3D = i;
  }
  let s = "";
  if (n) {
    o.data.LOAD_OBJECTS_FROM_PATIENT = go(!0), o.data.SEGMENTATION_INVOKED_BY_USER = go(!1);
    const i = e.getVolume().volumeActor;
    i && (s = await mh({
      actor: i,
      orientation: "front",
      focalPoint: i.getOrigin(),
      distance: 1,
      width: 800,
      height: 800,
      background: [0.2, 0.2, 0.2, 0]
    }) || "");
  } else {
    let i = e.getViewWidget(Cn._3D);
    if (i || (e.layoutManager.construct3DWindow(), i = e.getViewWidget(Cn._3D), console.warn("View3D not found and constructed for screenshot")), i) {
      const u = i.isVisible(), c = i.getViewport();
      u || (i.setViewport(rp.topLeft), i.show(), i.sceneRefresh()), i.orientationWidget.hide(), s = await zo({ context: e, view: i, gradientBackground: a, noOverlay: !0 }) || "", i.orientationWidget.show(), u || (i.setViewport(c), i.hide(), i.sceneRefresh()), e.sceneRefresh();
    }
  }
  if (s) {
    const i = s.indexOf(","), u = s.slice(i), p = {
      objectType: "value",
      type: "string",
      data: Mr(u)
    };
    o.data.PROJECT_SCREENSHOT = p;
  }
  return o.data.PLANNER_PROJECT_STEP = Zn(kf(e)), n || (o.data.SEGMENTATION_INVOKED_BY_USER = go(!1), o.data.LOAD_OBJECTS_FROM_PATIENT = go(!1)), o;
}
async function s2(e, t, n = []) {
  console.log("Uploading project by files (batch)...");
  const a = `${t.fileName.replaceAll(".zip", "")}`, o = [], l = [...n], s = 40, i = 50, u = (f) => {
    t && t.progressCallback && t.progressCallback(s + f * i);
  }, c = new ba();
  c.data = e.pr;
  const p = `${a}.pr.json`, h = await c.write({
    dataWriteFunction: async (f, v) => {
      o.push([f.slice(2, f.length), v]);
    },
    filenameWithoutJson: p.slice(0, p.length - 5)
  }), g = Ai(h), b = await to(g);
  if (l.push({ part_name: a, file_type: "pr.json", file: new Blob([h]), hash: b }), e.erpFile) {
    const f = JSON.stringify(e.erpFile), v = Ai(f), w = await to(v);
    l.push({ part_name: a, file_type: "erp", file: new Blob([f]), hash: w });
  }
  if (e.stlInfo) {
    const f = new ba();
    f.data = e.stlInfo;
    const v = `${a}.stlinfo.json`, w = await f.write({
      dataWriteFunction: async (O, C) => {
        o.push([O.slice(2, O.length), C]);
      },
      filenameWithoutJson: v.slice(0, v.length - 5)
    }), A = Ai(w), T = await to(A);
    l.push({ part_name: a, file_type: "stlinfo.json", file: new Blob([w]), hash: T });
  }
  if (e.imageData) {
    const f = await to(e.imageData);
    l.push({ part_name: a, file_type: "prinfo", file: new Blob([e.imageData]), hash: f });
  }
  if (e.mobile) {
    const f = new ba();
    f.data = e.mobile;
    const v = `${a}.mobile.json`, w = await f.write(
      {
        dataWriteFunction: async (O, C) => {
          o.push([O.slice(2, O.length), C]);
        },
        filenameWithoutJson: v.slice(0, v.length - 5)
      },
      !0
    ), A = Ai(w), T = await to(A);
    l.push({ part_name: a, file_type: "mobile.json", file: new Blob([w]), hash: T });
  }
  t && t.progressCallback && t.progressCallback(s);
  const { data: E } = await t.serverApi.getZippedFilesList(t.project.patientName, a + ".zip"), m = [];
  for (let f of E) {
    if (f.fileType != "bin") continue;
    let v = !1;
    o.forEach(([w, A]) => {
      if (w.toString().replaceAll(".bin", "") == f.name) {
        v = !0;
        return;
      }
    }), v || m.push(f.id);
  }
  if (m.length)
    try {
      await t.serverApi.deleteProjectPartsBatch(t.project.patientName, a, m);
    } catch (f) {
      console.warn("Batch delete failed, proceeding without blocking upload", f);
    }
  for (let [f, v] of o) {
    const w = await to(v);
    l.push({ part_name: f.toString().replaceAll(".bin", ""), file_type: "bin", file: new Blob([v]), hash: w });
  }
  const I = [], S = {};
  for (let f of E)
    S[f.name + "." + f.fileType] = f.sha256;
  for (let f of l) {
    const v = S[f.part_name + "." + f.file_type];
    if (!v) {
      I.push(f);
      continue;
    }
    if (f.hash != v) {
      I.push(f);
      continue;
    }
  }
  if (I.length == 0)
    return console.log("No parts changed, skipping upload"), t && t.progressCallback && t.progressCallback(s + i), !0;
  console.log("Uploading changed parts", I);
  try {
    const f = await t.serverApi.uploadProjectPartsBatch(
      t.project.patientName,
      a,
      I,
      u,
      t == null ? void 0 : t.createDate
    );
    console.log("Batch upload response", f);
  } catch (f) {
    return console.log("Failed to upload project", f), !1;
  }
  return console.log("Project uploaded successfully"), !0;
}
async function BP(e, t, n) {
  const a = [], o = [], l = new ba();
  l.data = t.pr;
  const s = `${e}.pr.json`, i = await l.write({
    dataWriteFunction: async (c, p) => {
      o.push([c.slice(2, c.length), p]);
    },
    filenameWithoutJson: s.slice(0, s.length - 5)
  });
  if (a.push([s, i]), t.stlInfo) {
    const c = new ba();
    c.data = t.stlInfo;
    const p = `${e}.stlinfo.json`, h = await c.write({
      dataWriteFunction: async (g, b) => {
        o.push([g.slice(2, g.length), b]);
      },
      filenameWithoutJson: p.slice(0, p.length - 5)
    });
    a.push([p, h]);
  }
  if (t.imageData && o.push([`${e}.prinfo`, t.imageData]), t.mobile) {
    const c = new ba();
    c.data = t.mobile;
    const p = `${e}.mobile.json`, h = await c.write(
      {
        dataWriteFunction: async (g, b) => {
          o.push([g.slice(2, g.length), b]);
        },
        filenameWithoutJson: p.slice(0, p.length - 5)
      },
      !0
    );
    a.push([p, h]);
  }
  const u = new ci();
  return a.forEach(([c, p]) => u.file(c, p)), o.forEach(([c, p]) => u.file(c, p)), await u.generateAsync(
    {
      type: "blob",
      compression: "DEFLATE",
      // Enable compression
      compressionOptions: { level: 6 }
      // Optional: 1 (fastest) to 9 (best compression)
    },
    n
  );
}
async function r2(e, t) {
  const n = [], a = [];
  if (t.mobile) {
    const l = new ba();
    l.data = t.mobile;
    const s = `${e}.mobile.json`, i = await l.write(
      {
        dataWriteFunction: async (u, c) => {
          a.push([u.slice(2, u.length), c]);
        },
        filenameWithoutJson: s.slice(0, s.length - 5)
      },
      !0
    );
    n.push([s, i]);
  }
  const o = n[0][1];
  return new Blob([o], { type: "text/plain" });
}
function u2(e, t) {
  const n = Kt(jf, e.getImageInfo()), a = Zt(Br, t);
  let o = {};
  if (e.projectBookmarks) {
    let c = Vr(e.projectBookmarks);
    for (const p of c.windows.windows)
      if (p)
        for (const h of p.presenterWindow.viewWidget.bookmarks)
          h.origin = e.objects.scaleVectorToImplantPlanner(mo.fromValues(h.origin[0], h.origin[1], h.origin[2]));
    for (const p of c.layout.bookmarks)
      p.origin = e.objects.scaleVectorToImplantPlanner(p.origin);
    c = e.objects.remapBookmarksToProject(c), o = { BOOKMARKS: Kt($f, c) };
  }
  let l = {};
  if (e.objects.projectCollection2D) {
    const c = Vr(e.objects.projectCollection2D.objects);
    for (const h of c)
      for (const g in h.points)
        h.points[g] = e.objects.scaleVectorToImplantPlanner(h.points[g]);
    const p = {
      objects: c,
      iAngleAdded: e.objects.projectCollection2D.iAngleAdded,
      iAnnotAdded: e.objects.projectCollection2D.iAnnotAdded,
      iDistanceAdded: e.objects.projectCollection2D.iDistanceAdded,
      iPolyAdded: e.objects.projectCollection2D.iPolyAdded
    };
    l = { COLLECTION_2D: Kt(xf, p) };
  }
  const i = (() => {
    const c = /* @__PURE__ */ new Date();
    return new Date(c.getTime() - c.getTimezoneOffset() / 60);
  })();
  a.modified = {
    year: i.getFullYear(),
    month: i.getMonth(),
    day: i.getDate(),
    hour: i.getHours(),
    minutes: i.getMinutes(),
    seconds: i.getSeconds()
  };
  const u = Kt(Br, a);
  return {
    objectType: "object",
    data: {
      ...t.data,
      ...l,
      ...o,
      ...n.data,
      ...u.data
    }
  };
}
function c2(e, t, n) {
  const a = e.objects.getImplantObjectData(), o = e.objects.getPinObjectData(), l = e.objects.getCprCurveObjectData(), s = e.objects.getNerveObjectData(), i = e.objects.getStlObjectData(), u = e.objects.getToothMarkerObjectData();
  a.length + o.length + (l ? 1 : 0) + s.length + i.length + u.length;
  const c = { data: {}, objectType: "object" }, p = [];
  for (const g of a) {
    const b = Kt(ts, g);
    p.push(b);
  }
  for (const g of o) {
    const { pin: b, sleeve: E } = g, m = Kt(Of, b);
    E && (m.data.SLEEVE_INFO = Kt(Oo, E)), p.push(m);
  }
  l && p.push(Kt(Nf, l));
  for (const g of s)
    p.push(Kt(Lf, g));
  for (const g of i)
    p.push(Kt(ts, g));
  for (const g of u)
    p.push(Kt(Tf, g));
  for (const g of e.objects.unsupportedProjectStlObjects)
    p.push(g);
  const h = {
    data: {},
    objectType: "object"
  };
  return p.forEach((g, b) => {
    h.data[`OBJECT_${b}`] = g;
  }), h.data.OBJECTS_COUNT = bt(p.length), c.data.COLLECTION_3D = h, c;
}
async function ju(e, t, n, a) {
  const o = e.getFS(), l = Ui(e, t, "pr"), s = Ui(e, t, "bd"), i = Gi(o.FS, l), u = Gi(o.FS, s);
  if (i && i.size && u && u.size) {
    console.log("Saving ", t, "pr and bd file from WasmFS to project");
    const c = o.FS.readFile(e.projectName + "." + t + "pr"), p = o.FS.readFile(e.projectName + "." + t + "bd");
    if (c.length > 0 && p.length > 0) {
      const h = await to(c), g = new Blob([c]), b = await to(p), E = new Blob([p]), m = n.fileName.replaceAll(".zip", "");
      return console.log("upload: ", n.project.patientName, " proj name:", n.fileName, ", suffix:", t), a(m, t + "pr", g, h), a(m, t + "bd", E, b), !0;
    }
  }
  return !1;
}
async function lr(e, t, n, a, o) {
  if (!await ju(t, e, n, a)) {
    const s = n.fileName.replaceAll(".zip", ""), { data: i } = await n.serverApi.getZippedFilesList(n.project.patientName, s + ".zip"), u = i.find((p) => p.name == s && p.fileType == e + "pr"), c = i.find((p) => p.name == s && p.fileType == e + "bd");
    (u || c) && (console.log("Deleting ", e, "pr and bd file from saved project"), u && o(u.id), c && o(c.id));
  }
}
async function d2(e, t, n, a) {
  const o = e.getEngine(), l = e.getFS(), s = new l.VectorString();
  for (let [i, u] of e.objects.stls)
    u.IsVolume() && u.cadType == St.eOT_SEGMENTED_BONE && s.push_back(u.id);
  if (s.size() > 0) {
    const i = new o.xProjectLoaderUtil();
    try {
      i.InitializeCADProjectSaving("", e.projectName, rr.eM_BONE_SEGMENTATION), i.AddBoneSegmentationVisualObjectsForSave(s), i.FinalizeCADProjectSaving();
    } finally {
      s.delete(), i.delete();
    }
    await ju(e, "bs", t, n) || console.error("Failed to save bone segmentation project");
  } else {
    s.delete();
    const i = t.fileName.replaceAll(".zip", ""), { data: u } = await t.serverApi.getZippedFilesList(t.project.patientName, i + ".zip"), c = u.find((h) => h.name == i && h.fileType == "bspr"), p = u.find((h) => h.name == i && h.fileType == "bsbd");
    (c || p) && (console.log("Deleting bspr and bsbd file from saved project"), c && a(c.id), p && a(p.id));
  }
}
async function p2(e, t, n, a) {
  await ju(e, "ts", t, n) || console.error("Failed to save teeth segmentation project");
}
async function Ff(e, t, n, a) {
  const { pr: o, stlInfo: l, mobile: s } = t, i = u2(e, o), u = c2(e), c = await i2(e, s, n, a == null ? void 0 : a.gradientBackground);
  a && a.progressCallback && a.progressCallback(10, !0);
  const p = [], h = [];
  if (!n && a) {
    const m = (S, f, v, w) => {
      p.push({ part_name: S, file_type: f, file: v, hash: w });
    }, I = (S) => h.push(S);
    await lr("ipts", e, a, m, I), a && a.progressCallback && a.progressCallback(20), await d2(e, a, m, I), a && a.progressCallback && a.progressCallback(30), e.contextCAD.tsprFileFromSegmentation && await p2(e, a, m), await lr("m", e, a, m, I), await lr("sg", e, a, m, I);
  }
  const g = e.getImageDataBuffer(), b = m2(e), E = {
    pr: i,
    stlInfo: u,
    imageData: g,
    mobile: c,
    erpFile: b
  };
  if (a) {
    const m = a.fileName.replaceAll(".zip", "");
    if (console.log("Delete Ids: ", h), h.length > 0)
      try {
        await a.serverApi.deleteProjectPartsBatch(a.project.patientName, m, h);
      } catch (v) {
        console.warn("Batch delete failed, proceeding without blocking upload", v);
      }
    if (!await s2(E, a, p))
      return console.error("Upload failed -> deleting copyied projec"), null;
    const S = await r2(a.fileName.replaceAll(".zip", ""), E), f = {
      erp: {},
      extra: {
        erp: {
          project: E.erpFile.project
        },
        latestProjectStepShort: kf(e)
      },
      format: "json"
    };
    await a.serverApi.uploadMetadataToProject(a.project.patientName, a.fileName.replaceAll(".zip", "") + ".zip", f), await a.serverApi.uploadFile(
      a.project.patientName,
      a.fileName.replaceAll(".zip", "") + ".zip.mobile.json",
      a.isWeblinkOperator ? "project_attachment_preview" : "mobile",
      S,
      (v) => {
        a && a.progressCallback && a.progressCallback(90 + v * 5);
      },
      a.createDate
    );
  }
  return E;
}
function m2(e) {
  const t = Wn(e.erpFile) || ih();
  t.project.name = e.projectName, t.project.weblinkId && t.project.weblinkId.length == 0, t.project.orderId && t.project.orderId.length == 0;
  const n = e.patientInfo;
  n && (t.project.patient.id = n.patientId || "0", t.project.patient.name = n.patientName, t.project.patient.birthDate = n.dateOfBirth ? Pm(new Date(n.dateOfBirth)) : ""), e.user && (t.project.user.customerName = e.user.name, t.project.user.email = e.user.username, t.project.user.id = e.user.id), t.project.implants = [], e.objects.implants.forEach((a) => {
    const o = sh(), l = a.getProjectImplantInfo();
    o.position = l.name, o.producer = l.manufacturerName, o.model = l.modelName, o.name = l.implantOriginalName, o.diameter = l.diameter.toString(), o.length = l.length.toString(), o.notes = a.getNotes(), o.selling_code = l.sellingCode;
    const s = a.getAbutment();
    if (s) {
      const u = s.getAbutmentInfo();
      o.abutment.model = u.modelName, o.abutment.name = u.name, o.abutment.selling_code = u.abutmentSellingCode;
    }
    const i = a.getSleeve();
    if (i) {
      const u = i.getSleeveInfo();
      t.project.sleeve_list[u.sellingCode] = t.project.sleeve_list[u.sellingCode] + 1, o.sleeve.name = u.originalName, o.sleeve.model = u.modelName, o.sleeve.drill_length = i.getDrillLength(), o.sleeve.selling_code = u.sellingCode, o.sleeve.offset = i.getDistanceFromImplant(), o.sleeve.d_internal = u.dInternal, o.sleeve.d_external = u.dExternal;
    }
    t.project.implants.push(o);
  }), t.project.pins = [], e.objects.pins.forEach((a) => {
    const o = rh(), l = a.getProjectPinInfo();
    o.position = a.getName(), o.producer = l.manufacturerName, o.model = l.modelName;
    const s = a.getSleeve();
    if (s) {
      const i = s.getSleeveInfo();
      o.sleeve.name = i.originalName, o.sleeve.model = i.modelName, o.sleeve.selling_code = i.sellingCode, o.sleeve.d_internal = i.dInternal, o.sleeve.d_external = i.dExternal;
    }
    t.project.pins.push(o);
  }), t.project.sleeve_list = {}, t.project.sleeve_list["3DM00986"] = 1;
  for (const [a, o] of Object.entries(t.project.sleeve_list))
    t.project.sleeve_list[a] = o;
  return t;
}
function kf(e) {
  switch (e.layoutManager.wizardTabIndex.get()) {
    case ye.VOI_SETTINGS:
      return it("implant-planner.voiSettings");
    case ye.THREED_SETTINGS:
      return it("implant-planner.threedSettings");
    case ye.DATA_IMPORT:
      return it("implant-planner.dataImport");
    case ye.CPR_SETTINGS:
      return it("implant-planner.cprSettings");
    case ye.NERVE_DRAWING:
      return it("implant-planner.nerveSettings");
    case ye.TEETH_SETUP:
      return it("implant-planner.teethSetup");
    case ye.IMPLANT_PLANNING:
      return it("implant-planner.implantPlanning");
    default:
      return it("implant-planner.newProject");
  }
}
const f2 = ["src"], g2 = { for: "filename" }, h2 = {
  key: 0,
  class: "p-error"
}, b2 = {
  key: 1,
  class: "flex flex-col content-center justify-center"
}, v2 = { class: "mt-4 text-2xl mb-2 flex justify-center" }, y2 = { class: "mt-4 text-2xl mb-2 flex justify-center" }, _2 = { class: "mt-4 text-2xl mb-2 flex justify-center" }, w2 = { class: "mt-4 text-2xl mb-2 flex justify-center" }, $u = /* @__PURE__ */ Je({
  __name: "SaveProjectComponent",
  setup(e) {
    const { t } = Ht(), n = Fh(), a = Xn("dialogRef"), o = ms(), l = a.value.data, s = B(
      l.isSaveAs ? 4 : 0
      /* SAVING */
    );
    lt(s, (M) => {
      M === 2 && l.context.setModified(!1);
    });
    const i = B([
      {
        label: t("implant-planner.savingProject"),
        state: 0
        /* SAVING */
      },
      {
        label: t("implant-planner.uploadingToCloud"),
        state: 1
        /* UPLOADING */
      },
      {
        label: t("shared.done"),
        state: 2
        /* DONE */
      }
    ]), u = as(), c = B(u.getUser()), p = B(Pg(r(c))), h = ui(), g = B(0), b = pl(), E = ia(), m = B("");
    let I = !1, S = null;
    const f = () => {
      var M;
      (M = l.onComplete) == null || M.call(l), a.value.close();
    };
    function v() {
      s.value++;
      for (let [M, z] of i.value.entries())
        z.class = M === s.value ? "p-highlight p-steps-current" : "";
    }
    async function w() {
      var N;
      const M = S == null ? void 0 : S.project, z = (M == null ? void 0 : M.projectFileList.length) == 0;
      let j = b.params.fileHash, K = b.params.projectHash;
      if (!M) {
        s.value = 3;
        return;
      }
      const x = async () => {
        var G, ce;
        try {
          s.value = 0;
          const re = (Le, Y) => {
            Y && v(), g.value = Le;
          };
          if (!await Ff(l.context, l.projectData, !1, {
            fileName: m.value.replaceAll(".zip", ""),
            project: M,
            serverApi: E,
            progressCallback: re,
            gradientBackground: !0,
            createDate: (/* @__PURE__ */ new Date()).toISOString(),
            isWeblinkLoader: z,
            isWeblinkOperator: p.value
          })) {
            I && await E.deleteProjectFile(M.patientName, m.value.replaceAll(".zip", "") + ".zip"), s.value = 3;
            return;
          }
          g.value = 100;
          let se = await l.projectLoader.getProjectInfo(b.params);
          if (se != null && se.project) {
            const Le = se.project.projectFileList.find((Y) => Y.name == m.value.replaceAll(".zip", "") + ".zip");
            if (Le) {
              const Y = se.projectFullName.replace(se.project.projectFilename, m.value + ".zip");
              l.context.projectName = Y.replaceAll(".zip", ""), l.context.projectFullName.set(Y), l.context.fileHash = Le.uuid, await o.push({
                name: "ImplantPlannerProjectLoaderView",
                params: {
                  fileHash: Le.uuid,
                  projectHash: K
                }
              });
            } else {
              let Y = "";
              const { firstName: pe, lastName: fe } = ((G = se.patientInfo) == null ? void 0 : G.extra) || {}, le = se.projectFullName.replace(se.project.projectFilename, `${m.value}.zip`);
              Y = pe && fe ? `${pe} ${fe} // ${le}` : le, l.context.projectName = le.replaceAll(".zip", ""), l.context.projectFullName.set(Y), l.context.fileHash = Array.isArray(j) ? j[0] : j, await o.push({
                name: "ImplantPlannerProjectLoaderView",
                params: {
                  fileHash: j,
                  projectHash: b.params.projectHash
                }
              });
            }
          }
          await ((ce = l.onSuccess) == null ? void 0 : ce.call(l)), v();
        } catch (re) {
          console.error(re), s.value = 3;
        }
      };
      if (z) {
        const G = M.projectFilename.replaceAll(".zip", "") === m.value, ce = t(G ? "shared.projectAlreadyExistsDoYouWantToReplaceIt" : "shared.doYouWantToSaveTheProject");
        h.require({
          message: ce,
          header: t("implant-planner.saveProject"),
          accept: async () => {
            if (I = !1, !G)
              try {
                const re = await E.copyProject(
                  M.patientName,
                  M.projectFilename,
                  m.value.replaceAll(".zip", "") + ".zip",
                  Ta.ProjectAttachmentPreview
                );
                console.log("copyProject response 1: ", re), re.status === 500 && n.add({ severity: "error", summary: t("shared.errorWhileCopyingProjectFile"), detail: "Internal error", life: 3e3 }), I = !0, j = re.data.uuid;
              } catch (re) {
                console.log("copyProject response 1 err: "), n.add({
                  severity: "error",
                  summary: t("shared.errorWhileCopyingProjectFile"),
                  detail: re,
                  life: 3e3
                });
              }
            v(), await x(), h.close();
          },
          reject: () => {
            h.close(), l.onComplete && l.onComplete(), a.value.close();
          }
        });
        return;
      } else {
        const G = !!((N = M == null ? void 0 : M.projectFileList) != null && N.some((re) => (re == null ? void 0 : re.name.replaceAll(".zip", "")) === (m == null ? void 0 : m.value.replaceAll(".zip", ""))));
        console.log("RG LOADER Project: ", M.projectFileList), console.log("RG LOADER Project: ", G), console.log("RG LOADER Project: ", m.value.replaceAll(".zip", ""));
        const ce = t(G ? "shared.projectAlreadyExistsDoYouWantToReplaceIt" : "doYouWantToSaveTheProject");
        if (I = !1, G)
          h.require({
            message: ce,
            header: t("implant-planner.warning"),
            icon: "pi pi-exclamation-triangle",
            accept: async () => {
              v(), await x(), h.close();
            },
            reject: () => {
              s.value--, h.close();
            }
          });
        else {
          s.value = 0;
          try {
            const re = await E.copyProject(M.patientName, M.projectFilename, m.value.replaceAll(".zip", "") + ".zip");
            console.log("copyProject response 2: ", re), re.status === 500 && n.add({ severity: "error", summary: t("shared.errorWhileCopyingProjectFile"), detail: "Internal error", life: 3e3 });
          } catch (re) {
            console.log("copyProject response 2 err: "), n.add({ severity: "error", summary: t("shared.errorWhileCopyingProjectFile"), detail: re, life: 3e3 });
          }
          I = !0, await x();
        }
      }
    }
    const A = () => {
      s.value++, w();
    }, T = (M) => {
      if (M.key === "Enter") {
        if (s.value === 2 || s.value === 3) {
          M.preventDefault(), f();
          return;
        }
        s.value === 4 && C.value && (M.preventDefault(), A());
      }
    };
    Dt(async () => {
      window.addEventListener("keydown", T), S = await l.projectLoader.getProjectInfo(b.params), m.value = (S == null ? void 0 : S.project.projectFilename.replaceAll(".zip", "")) ?? "", s.value == 0 && await w();
    }), Ln(() => {
      window.removeEventListener("keydown", T);
    });
    const O = /^[\p{L}\p{M}0-9._@+()\- ]{1,128}$/u, C = Ce(() => O.test(m.value)), k = Ce(() => c.value.username !== l.projectOwner && !p.value);
    return (M, z) => {
      const j = vu, K = xA, x = fm;
      return L(), H(He, null, [
        s.value === 4 ? (L(), be(r(ke), {
          key: 0,
          class: "items-center justify-center gap-4"
        }, {
          default: _(() => [
            r(k) ? (L(), be(r(ke), {
              key: 0,
              class: "gap-2 pb-6 items-center"
            }, {
              default: _(() => [
                y("img", {
                  class: "svg-icon",
                  src: r(xg)("icon_top_nav_info")
                }, null, 8, f2),
                y("span", null, U(M.$t("implant-planner.noticeSavedProjectVisibleToOwner", { owner: r(l).projectOwner })), 1)
              ]),
              _: 1
            })) : ue("", !0),
            d(r(ke), { class: "gap-4 pt-4" }, {
              default: _(() => [
                d(r(qn), { class: "flex grow" }, {
                  default: _(() => [
                    d(j, {
                      id: "filename",
                      class: "w-full flex h-56px",
                      modelValue: m.value,
                      "onUpdate:modelValue": z[0] || (z[0] = (N) => m.value = N),
                      onKeydown: z[1] || (z[1] = Eg(ka((N) => r(C) && A(), ["prevent"]), ["enter"]))
                    }, null, 8, ["modelValue"]),
                    y("label", g2, U(M.$t("implant-planner.filename")), 1),
                    !r(C) && m.value ? (L(), H("small", h2, U(M.$t("implant-planner.filenameValidationHint")), 1)) : ue("", !0)
                  ]),
                  _: 1
                }),
                d(r(Ne), {
                  class: "h-56px flex grow",
                  label: M.$t("shared.save"),
                  addEnterListener: !0,
                  disabled: !r(C),
                  onClick: A
                }, null, 8, ["label", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })) : ue("", !0),
        s.value !== 4 ? (L(), H("div", b2, [
          d(K, {
            class: "mt-4",
            model: i.value,
            "active-step": s.value,
            "aria-label": "Form Steps"
          }, null, 8, ["model", "active-step"]),
          s.value === 0 ? (L(), H(He, { key: 0 }, [
            y("p", v2, U(M.$t("implant-planner.savingProject")), 1),
            d(x, { animationDuration: "0.6s" })
          ], 64)) : ue("", !0),
          s.value === 1 ? (L(), H(He, { key: 1 }, [
            y("p", y2, U(M.$t("shared.uploadingProject")), 1),
            d(r(di), {
              value: g.value,
              showValue: !1,
              style: { height: "2rem" },
              pt: { value: { style: { transition: "none" } } }
            }, {
              default: _(() => [
                vt(U(g.value.toFixed(0)) + " % ", 1)
              ]),
              _: 1
            }, 8, ["value"])
          ], 64)) : ue("", !0),
          s.value === 2 ? (L(), H(He, { key: 2 }, [
            y("p", _2, U(M.$t("implant-planner.projectSaved")), 1),
            d(r(Ne), {
              label: M.$t("shared.close"),
              addEnterListener: !0,
              onClick: f
            }, null, 8, ["label"])
          ], 64)) : ue("", !0),
          s.value === 3 ? (L(), H(He, { key: 3 }, [
            y("p", w2, U(M.$t("implant-planner.errorWhileUploading")), 1),
            d(r(Ne), {
              class: "h-56px",
              label: M.$t("shared.close"),
              addEnterListener: !0,
              onClick: f
            }, null, 8, ["label"])
          ], 64)) : ue("", !0)
        ])) : ue("", !0)
      ], 64);
    };
  }
});
function Fu() {
  return {
    [ye.VOI_SETTINGS]: Fe._FULLSCREEN_3D,
    [ye.THREED_SETTINGS]: Fe._FULLSCREEN_3D,
    [ye.DATA_IMPORT]: Fe._FULLSCREEN_3D,
    [ye.CPR_SETTINGS]: Fe._CPR_SETTINGS_WIZARD,
    [ye.NERVE_DRAWING]: Fe._NERVE_DRAWING_WIZARD,
    [ye.TEETH_SETUP]: Fe._LARGE_3D_MPR,
    [ye.IMPLANT_PLANNING]: Fe._3D_CPR_CROSS_TANGENT_AXIAL,
    [ye.GUIDE_DESIGN]: Fe._FULLSCREEN_3D,
    [ye.REPORTS_EXPORT]: Fe._3D_CROSS_CPR
  };
}
const I2 = { class: "layout-dialog-grid mt-6" }, S2 = ["onClick"], E2 = ["src"], T2 = { class: "flex items-center justify-center layout-dialog-grid-item-label" }, C2 = /* @__PURE__ */ Je({
  __name: "IPLayoutDialogStlLibrary",
  props: {
    modelValue: {}
  },
  emits: ["updateLayout"],
  setup(e, { emit: t }) {
    const n = e, a = tt({
      wizardIndex: -1,
      oldLayout: Fe._STL_PICKER_PREVIEW,
      newLayout: void 0,
      availableLayouts: T_(),
      wizardPanelVisible: !1
    }), o = t, l = B(Number(n.modelValue.oldLayout));
    Ga(() => {
      n.modelValue && Object.assign(a, n.modelValue);
    }), Dt(() => {
      n.modelValue && Object.assign(a, n.modelValue);
    });
    const s = (c) => {
      l.value = c, o("updateLayout", Object.keys(Fe).indexOf(c.toString()));
    }, i = sa(), u = (c, p) => {
      console.log(c, p);
      const h = c === p ? "/img/" + c + "_selected.png" : "/img/" + c + "_not_selected.png";
      return i.getAssetUrl(h);
    };
    return (c, p) => (L(), H("div", I2, [
      (L(!0), H(He, null, jt(a.availableLayouts, (h) => (L(), H("div", {
        key: h.name,
        class: "pointer flex flex-col items-center",
        onClick: (g) => s(h.code)
      }, [
        y("div", null, [
          y("img", {
            src: u(h.code, l.value),
            alt: "",
            draggable: "false"
          }, null, 8, E2),
          y("span", T2, U(h.name), 1)
        ])
      ], 8, S2))), 128))
    ]));
  }
}), ku = /* @__PURE__ */ Vt(C2, [["__scopeId", "data-v-94c2bd17"]]), Vu = /* @__PURE__ */ Je({
  __name: "IPTeethSetupContainerCAD",
  emits: ["nextStepNested", "previousStepNested"],
  setup(e, { emit: t }) {
    let n = B([]), a, o = B("");
    const l = B(Math.random());
    let s = B();
    const i = Ra(), u = Aa(), c = Ao();
    let p;
    const h = t;
    Ln(() => {
      g == null || g.cleanup(), c.disableNavbarButtons([_e.UNDO, _e.REDO]);
    });
    let g = null;
    return Dt(async () => {
      c.enableNavbarButtons([_e.UNDO, _e.REDO]);
      const b = document.getElementById("wizard-container");
      g = b ? Zr(b) : null;
      const E = new ao([0, 0]), m = B(document.getElementById("wizard-container")), I = m.value ? m.value.getBoundingClientRect() : { width: 0, height: 0 };
      E.set([(I == null ? void 0 : I.width) * 2 / 3, I == null ? void 0 : I.height]);
      const S = () => {
        var M, z;
        const C = (M = m.value) == null ? void 0 : M.getBoundingClientRect();
        if (!C) return;
        const k = (z = m.value) == null ? void 0 : z.children[2];
        if (k) {
          const K = Array.from(k.children).find((x) => x instanceof HTMLDivElement && x.style.display !== "none");
          if (K instanceof HTMLDivElement) {
            const x = K.getBoundingClientRect();
            E.set([x.width, x.height]);
            return;
          }
        }
        E.set([C.width * 2 / 3, C.height]);
      };
      Yr(m, () => {
        S();
      }), p = dn(), p.showLoading(it("implant-planner.loadingTeethSetup"), !1, void 0, !0), p.setCADMode(!0), p.contextCAD.GetMainForm().SetJSLambda((C) => {
        C ? (n.value = C.GetWidgetOrder().slice(), a = C.GetWidgets(), o.value = C.GetToolTitle(), console.log("xDynamicGUIParser JS Retrieving GUI FROM LAMBDA - order title", C.GetToolTitle())) : (console.log("toolWidget == nullptr"), n.value = [], a = void 0, o.value = ""), l.value = Math.random();
      }, qt.eJSLT_RETIEVE_GUI), p.contextCAD.GetMainForm().SetJSLambda((C) => {
        C ? S() : w();
      }, qt.eJSLT_UPDATE_OBJECT_TREE_LIST);
      let f;
      const v = new ao({ items: [] }), w = () => {
        v.set(f());
      };
      f = () => {
        try {
          const C = p.contextCAD.GetMainForm().GetWasmObjectListItems(), k = [];
          for (let j = 0; j < C.size(); j++) {
            const K = C.get(j), x = K.GetGroup(), N = K.GetColor();
            k.includes(x) || k.push(x);
          }
          const M = [];
          for (let j = 0; j < k.length; j++) {
            const K = [];
            for (let x = 0; x < C.size(); x++) {
              const N = C.get(x);
              if (k[j] === N.GetGroup()) {
                const G = N.GetColor();
                K.push({
                  key: N.GetId(),
                  label: N.GetLabel(),
                  visible: N.GetState(),
                  color: [G.get(0), G.get(1), G.get(2)],
                  onClick: (ce) => {
                    p.contextCAD.GetMainForm().WasmObjectListItemClicked(ce, !0);
                  },
                  onSelect: (ce) => {
                    p.contextCAD.GetMainForm().WasmObjectListItemClicked(ce, !0);
                  },
                  onUnselect: (ce) => {
                    p.contextCAD.GetMainForm().WasmObjectListItemClicked(ce, !1);
                  }
                });
              }
            }
            M.push({
              key: k[j],
              label: k[j],
              children: K
            });
          }
          return {
            items: M
          };
        } catch (C) {
          return console.error("Error in getObjectListItems", C), { items: [] };
        }
      };
      const A = (C) => {
        const k = p.contextCAD.GetMainForm().WasmObjectListContextMenuClicked(C);
        return Jr(k);
      };
      await p.setTabIndex(30), s.value = p.contextCAD.tabWidgetHandler, console.log("tabWidgetHandler", s), g == null || g.createVueOverlayComponent(
        Xr,
        {
          objectTree: v,
          viewSize: E,
          initialPosition: Xl.topRight,
          getContextMenuItems: A
          // parent: context.getOverlayContainer(),
          // dockEvent: () => {
          //     context.dockOverlays();
          // },
        },
        {
          noContainerResize: !0
        }
      );
      const T = g == null ? void 0 : g.createVueOverlayComponent(
        dp,
        {
          viewSize: E,
          barSize: new ao([220, 100]),
          initialPosition: Xl.bottomRight,
          // initialPosition: AnchorPosition.topRight,
          onWheelCallback: () => {
            p.contextCAD.GetMainForm().WasmScalarBarSetScalarBarScale(tn.getActiveScalarBarScale());
          },
          headerButtonClicked: (C) => {
            p.contextCAD.GetMainForm().WasmScalarBarHeaderButtonClicked(C);
          },
          contactsButtonClicked: () => {
            p.contextCAD.GetMainForm().WasmScalarBarContactsButtonClicked(!0);
          },
          modelContactsButtonClicked: () => {
            p.contextCAD.GetMainForm().WasmScalarBarContactsButtonClicked(!1);
          }
          // parent: context.getOverlayContainer(),
          // dockEvent: () => {
          //     context.dockOverlays();
          // },
        },
        {
          noContainerResize: !0
        }
      );
      T == null || T.setEnabled(!1);
      const O = (C, k, M, z, j, K, x, N, G, ce, re) => {
        console.log(
          "Update Contacts Widget",
          C,
          k,
          M,
          z,
          j,
          K,
          x,
          N,
          G,
          ce,
          re
        ), tn.updateTitle(k), T == null || T.setEnabled(z), tn.sReverseGradient.set(re), tn.sHint.set(M), tn.setActiveScalarBarMode(C), tn.contactsButtonVisible.set(j), tn.contactsButtonChecked.set(K), tn.modelContactsButtonVisible.set(x), tn.modelContactsButtonChecked.set(N), tn.headerButtonVisible.set(G), tn.headerButtonChecked.set(ce);
      };
      p.contextCAD.GetMainForm().SetJSLambda(
        (C, k, M, z, j, K, x, N, G, ce, re, Se) => {
          Se || (console.log("Update Contacts Widget"), O(
            C,
            k,
            M,
            z,
            j,
            K,
            x,
            N,
            G,
            ce,
            re
          ));
        },
        qt.eJSLT_UPDATE_CONTACTS_WIDGET
      ), i.onEvent(p.onShowAddReconstructionDialog, (C) => {
        console.log("Show Dialog", C.preSelectMode, C.preSelectWorkflow), u.open(_f, {
          props: {
            modal: !0,
            showHeader: !1,
            contentStyle: {
              borderRadius: "16px",
              padding: "0 1.5rem",
              overflow: "hidden"
            }
          },
          data: {
            context: p,
            preselectedMode: C.preSelectMode
          },
          emits: {
            onConfirm: () => {
              console.log("Confirmed 0"), C.lambda(), console.log("Confirmed 1");
            },
            onReject: () => {
              console.log("Rejected 0"), C.lambda(), console.log("Rejected 1");
            }
          }
        });
      }), p.hideLoading();
    }), Ln(() => {
      try {
        p.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_RETIEVE_GUI), p.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_UPDATE_OBJECT_TREE_LIST), p.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_UPDATE_CONTACTS_WIDGET), p.setCADMode(!1), p.setTabIndex(1), g == null || g.cleanup();
      } catch (b) {
        console.error("Error during unmount: ", b);
      }
    }), (b, E) => (L(), be(r(ot), {
      class: "flex h-full horizontal-padding",
      style: { "margin-bottom": "1rem", "margin-top": "1rem", "min-height": "0" }
    }, {
      default: _(() => [
        d(r(ot), {
          class: "grow overflow-x-hidden overflow-y-auto",
          style: { "min-height": "0" }
        }, {
          default: _(() => [
            r(n).length ? (L(), be(r(ls), {
              key: l.value,
              "widget-params": r(a),
              "widget-order": r(n),
              "tool-title": r(o)
            }, null, 8, ["widget-params", "widget-order", "tool-title"])) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(ot), { style: { flex: "0 0 auto" } }, {
          default: _(() => [
            r(s) ? (L(), be(r(is), {
              key: 0,
              "tab-handler": r(s),
              context: r(p),
              onNextStepNested: E[0] || (E[0] = (m) => h("nextStepNested")),
              onPreviousStepNested: E[1] || (E[1] = (m) => h("previousStepNested"))
            }, null, 8, ["tab-handler", "context"])) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), N2 = /* @__PURE__ */ Je({
  __name: "IPAppMenuContainer",
  setup(e) {
    const t = pl(), n = np();
    n.menuMode = hn.SIDEBAR, lt(t, () => {
      n.menuActive = !1;
    });
    function a() {
      console.log("onSidebarMouseOver "), n.menuMode === "sidebar" && !n.sidebarStatic && (n.sidebarActive = n.isDesktop(), console.log("model.sidebarActive: ", n.sidebarActive), setTimeout(() => {
        n.pinActive = n.isDesktop(), console.log("odel.pinActive: ", n.pinActive);
      }, 200));
    }
    function o() {
      n.menuMode === "sidebar" && !n.sidebarStatic && setTimeout(() => {
        n.sidebarActive = !1, n.pinActive = !1;
      }, 250);
    }
    function l() {
      n.menuClick = !0;
    }
    return Ce(() => (n.sidebarActive, "")), (s, i) => (L(), H("div", null, [
      y("div", {
        class: Ge([{ "layout-sidebar-active": r(n).sidebarActive }, "layout-menu-wrapper margin-t-80px"]),
        style: { "margin-bottom": "0.5rem", background: "transparent", border: "1px solid rgba(255, 255, 255, 0)", width: "3.5rem", overflow: "hidden" },
        onClick: l,
        onMouseleave: o,
        onMouseover: a
      }, [
        d(r(ot), null, {
          default: _(() => [
            It(s.$slots, "mainMenuTabs")
          ]),
          _: 3
        })
      ], 34)
    ]));
  }
}), L2 = { class: "layout-menuitem-icon ml-1 flex justify-center" }, O2 = { class: "ml-4 mt-1 layout-menuitem-text text-sm menu-item-color" }, D2 = /* @__PURE__ */ Je({
  __name: "IPAppMenuItem",
  props: {
    modelValue: {},
    index: {},
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = B(n.index === 0 ? "bg-purple-500" : "bg-purple-500 "), l = B(n.index);
    Ga(() => {
      o.value = n.modelValue == n.index ? "active-menuitem" : "", n.disabled && (o.value += " wizard-menu-item-disabled");
    });
    const s = () => {
      a("update:modelValue", n.index);
    }, i = Ce(() => n.index === 0 ? "rounded-t" : n.index == 11 ? "rounded-b" : "rounded-none");
    return (u, c) => (L(), H("li", {
      class: Ge([[i.value, o.value], "bg-siderbar-item-wiz flex align-center"]),
      role: "menuitem"
    }, [
      y("a", {
        class: "p-ripple flex align-center cursor-pointer",
        role: "menuitem",
        onClick: s,
        style: { background: "transparent !important" }
      }, [
        y("i", L2, [
          d(r(Hr), {
            cIcon: l.value.toString(),
            isMenuIcon: !0
          }, null, 8, ["cIcon"])
        ]),
        y("span", O2, [
          It(u.$slots, "default", {}, void 0, !0)
        ])
      ])
    ], 2));
  }
}), A2 = /* @__PURE__ */ Vt(D2, [["__scopeId", "data-v-e6174a60"]]), R2 = { style: { "text-align": "center", color: "white", "text-shadow": "0 1px 1px black" } }, M2 = {
  key: 0,
  class: "mt-20",
  style: { width: "20vw" }
}, P2 = { style: { display: "flex", "justify-content": "center" } }, x2 = { style: { display: "flex", "justify-content": "center" } }, j2 = { class: "ml-1 flex justify-center" }, $2 = { class: "col-span-12" }, F2 = {
  class: "ml-1 flex justify-start",
  style: { "white-space": "pre-wrap" }
}, k2 = { class: "col-span-12" }, V2 = {
  key: 0,
  id: "sidebarContainer",
  class: "flex flex-row-wrap",
  style: { "margin-top": "0.5rem", "margin-bottom": "0.5rem" }
}, B2 = { class: "mainMenuTabs" }, U2 = {
  class: "grow",
  style: { margin: "0 0.5rem" }
}, G2 = /* @__PURE__ */ Je({
  __name: "IPProjectLoaderView",
  props: {
    loader: {},
    source: { default: tl.IMPLANT_PLANNER }
  },
  setup(e) {
    const { t } = Ht(), n = Ao(), a = e, o = a.loader(ia()), l = Aa(), s = sa();
    let i = new cs(s.getAssetUrl(""));
    const u = B(), c = B(), p = B(!1), h = B(!0), g = B(!1), b = B(0), E = B(!1), m = B(Math.random()), I = B(!0), S = B(!1), f = B(0), v = B(), w = B("Loading project"), A = pl(), T = Do(), O = oa(), { wizardLayouts: C } = So(oa()), k = ms(), M = qr.actions, z = Ra();
    B(xn.REALGUIDE), B(!0);
    const j = B(a.source == tl.IMPLANT_PLANNER ? wt.ImplantPlannerBase : wt.WeblinkViewer);
    ds(i);
    const K = Ce(() => p.value && !E.value ? "rgba(91, 91, 91, 0.5)" : "var(--webcad-main-bg)"), x = () => {
      const Te = i.undoManager.getUndoDescription(), J = i.undoManager.getRedoDescription(), Pe = Te ? `Undo ${Te}` : void 0, Ze = J ? `Redo ${J}` : void 0;
      let st = [], ae = [];
      i.undoManager.canUndo() ? st.push(_e.UNDO) : ae.push(_e.UNDO), i.undoManager.canRedo() ? st.push(_e.REDO) : ae.push(_e.REDO), n.disableNavbarButtons(ae), n.enableNavbarButtons(st);
      const ve = [
        { button: _e.UNDO, tooltip: Pe },
        { button: _e.REDO, tooltip: Ze }
      ];
      n.addTooltips(ve);
    }, N = B(!1), G = () => {
      N.value = !1;
    }, ce = B(!1), re = B(!1), Se = Ls(), se = () => {
      Se.stlLibraryWindowVisible ? re.value = !0 : ce.value = !0;
    }, Le = B(!1), Y = B(!1), pe = B(!1), fe = B("");
    O.prepareDefaults(Fu());
    const le = B(i.layoutManager.wizardTabIndex.get()), { menuMode: Re } = So(oa()), q = Ce(() => (Re.value = Re.value == hn.OVERLAY ? hn.SIDEBAR : Re.value, Re.value === hn.HORIZONTAL && p.value)), he = Ce(() => ({
      "bg-top-nav-bar-wiz dynamic-margin-left bg-body-wiz": !0,
      "mt-1 dynamic-margin-left": j.value === wt.WeblinkViewer || !q.value
    })), ne = Ce(() => ({
      "card-no-bottom-padding no-radius bg-body-wiz h-full flex flex-col": !0,
      "wizard-vertical-menu-margin": j.value !== wt.WeblinkViewer && !q.value
    })), te = [
      {
        type: ye.VOI_SETTINGS,
        tabLabel: "VOI Settings",
        component: fu,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.THREED_SETTINGS,
        tabLabel: "3D Settings",
        component: gu,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.DATA_IMPORT,
        tabLabel: "Data Import",
        component: hu,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.CPR_SETTINGS,
        tabLabel: "CPR Settings",
        component: bu,
        defaultLayout: Fe._CPR_SETTINGS_WIZARD
      },
      {
        type: ye.NERVE_DRAWING,
        tabLabel: "Nerve Drawing",
        component: yu,
        defaultLayout: Fe._NERVE_DRAWING_WIZARD
      },
      /*
      {
          type: WizardType.TEETH_SETUP,
          tabLabel: "Teeth Setup",
      },
      */
      {
        type: ye.IMPLANT_PLANNING,
        tabLabel: "Implant Planning",
        component: Du,
        defaultLayout: Fe._3D_CPR_CROSS_TANGENT_AXIAL
      }
      /*
      {
          type: WizardType.REPORTS_EXPORT,
          tabLabel: "Reports / Export",
      },
      {
          type: WizardType.ADVANCED_TOOLS,
          tabLabel: "Advanced Tools",
      },
      {
          type: WizardType.OBJECT_LIST,
          tabLabel: "Object List",
      },
      */
      // {
      //     type: WizardType.GUIDE_DESIGN,
      //     tabLabel: "Guide Design",
      //     component: IPGuideDesignPrimaryComponentView,
      //     defaultLayout: LayoutTemplate._FULLSCREEN_3D,
      //     disabled: false,
      //     wizardsList: [
      //         {
      //             component: IPVolumeUndercutWizardView,
      //             stepName: "Volume Undercut",
      //         },
      //         {
      //             component: IPGuideDesignWizardView,
      //             stepName: "Guide Design",
      //         },
      //     ],
      // },
      /*
      {
          type: WizardType.SEGMENTATION,
          tabLabel: "Segmentation",
      },
      {
          type: WizardType.SANDBOX,
          tabLabel: "Sandbox",
      },
      {
          type: WizardType.PROJECT_SETUP,
          tabLabel: "Project Setup",
      },
      {
          type: WizardType.RECONSTRUCTION_SETUP,
          tabLabel: "Reconstruction Setup",
      },
      {
          type: WizardType.ACTIVE_RECONSTRUCTION,
          tabLabel: "Active Reconstruction",
      },
      */
    ];
    bo.SHOW_CAD_WIZARD && (te.push({
      type: ye.CAD,
      tabLabel: "Cad",
      component: Ru,
      defaultLayout: Fe._3D_CPR_CROSS_TANGENT_AXIAL
    }), te.push({
      type: ye.TEETH_SETUP,
      tabLabel: "Teeth Setup",
      component: Vu,
      defaultLayout: Fe._FULLSCREEN_3D
    }));
    const Ie = B(te.find((Te) => Te.type === le.value));
    i.setModalsInstance(T), i.setResourceUrl("/resources/");
    const Ee = i.getEngineInstance();
    async function xe(Te, J) {
      var st, ae, ve;
      Te.setRootElement(u.value), Te.setCADRootElement(c.value), Te.createRendererWindow({ background: [0.16, 0.43, 0.7] }), (st = Te.getInteractorStyle()) == null || st.setCameraInteractorEnabled(!0), (ae = Te.getInteractorStyle()) == null || ae.setMouseMode(Te.settings.general.useLeftButtonForRotationOn3d ? xn.REALGUIDE : xn.IMPLANTPLANNER), (ve = Te.getInteractorStyle()) == null || ve.setMouseMode2D(xn.REALGUIDE), C.value[ye.VOI_SETTINGS] !== void 0 && O.setWizardLayout(ye.VOI_SETTINGS, Fe._FULLSCREEN_3D);
      for (const ut of Object.keys(C.value))
        Te.layoutManager.storeLayout(ut.toString(), C.value[Number(ut)]);
      Te.layoutManager.constructAllWindows();
      const Ze = Te.layoutManager.getLayout(le.value.toString()) ?? Te.layoutManager.getDefaultLayout();
      Te.layoutManager.setLayout(Ze), V(Ze);
    }
    const Qe = (Te) => {
      Se.stlLibraryWindowVisible ? (i.layoutManager.storeLayout("StlLibrary", Te), i.layoutManager.setLayout(Te)) : (i.layoutManager.storeLayout(le.value.toString(), Te), i.layoutManager.setLayout(Te), V(Te), O.setWizardLayout(le.value, Te));
    }, Ke = () => {
      n.enableNavbarButtons([_e.LAYOUT]);
    }, qe = () => {
      n.disableNavbarButtons([_e.LAYOUT]);
    }, rt = () => {
      const Te = te.findIndex((Ze) => Ze.type === le.value);
      if (Te === -1) {
        console.warn("current wizard not found");
        return;
      }
      if (Te === te.length - 1) {
        console.warn("nextStep called on last wizard");
        return;
      }
      let J = 0;
      Te == ye.CPR_SETTINGS && i.CPRType !== nn.MANDIBLE && (J = 1);
      const Pe = te[Te + 1 + J].type;
      i.layoutManager.wizardTabIndex.set(Pe), le.value = Pe, Z();
    }, P = () => {
      const Te = te.findIndex((Ze) => Ze.type === le.value);
      if (Te === -1) {
        console.warn("current wizard not found");
        return;
      }
      if (Te === 0) {
        console.warn("previousStep called on first wizard");
        return;
      }
      let J = 0;
      Te == 5 && i.CPRType !== nn.MANDIBLE && (J = 1);
      const Pe = te[Te - 1 - J].type;
      i.layoutManager.wizardTabIndex.set(Pe), le.value = Pe, Z();
    };
    z.onEvent(i.warningDialogEvent, (Te) => {
      fe.value = Te, pe.value = !0;
    }), z.onEvent(i.screenshotUploadEvent, async ({ filename: Te, image: J }) => {
      var Ze, st, ae;
      const Pe = (ae = (st = (Ze = i.patientInfo) == null ? void 0 : Ze.extra) == null ? void 0 : st.extra) == null ? void 0 : ae.study_instance_UID;
      if (Pe)
        try {
          await o.uploadScreenshot(Pe, Te, Ta.Image, J), lo(t("weblink.successfullyUploadedScreenshot"));
        } catch (ve) {
          Vn(ve, t("web-rg.uploadFailed"));
        }
    }), z.watch(i.layoutBtnVisible, (Te) => {
      Te ? Ke() : qe();
    }), z.watch(i.loadingFlag, (Te) => {
      h.value = Te, w.value = i.loadingText, g.value = i.progressBarFlag, b.value = i.progressBarValue.get(), E.value = i.nonTransparentLoading.get();
    }), z.watch(i.nextPrevVisible, (Te) => {
      I.value = Te, console.log("Setting nextprevFlag to:", Te);
    }), z.watch(i.cadMode, (Te) => {
      S.value = Te, f.value = Te ? 1 : 0, console.log("Setting cadMode to:", Te);
    }), z.watch(i.progressBarValue, (Te) => {
      b.value = Te;
    }), z.watch(i.layoutManager.wizardTabIndex, () => {
      le.value = i.layoutManager.wizardTabIndex.get(), Z();
    });
    const F = B(!0);
    z.watch(i.tabButtonsEnabled, (Te) => {
      F.value = Te, console.log("TabButtonsEnabled", F.value);
    }), lt(le, (Te) => {
      i.toolManager.activeTool.WindowLevel.set(!1), wu(), i.layoutManager.wizardTabIndex.set(Te);
      let J = i.layoutManager.getLayout(Te.toString()) ?? i.layoutManager.getDefaultLayout();
      if (Ke(), Q(), le.value === ye.DATA_IMPORT && (i.layoutManager.storeLayout(ye.DATA_IMPORT.toString(), Fe._FULLSCREEN_3D), J = i.layoutManager.getLayout(Te.toString()) ?? i.layoutManager.getDefaultLayout(), qe()), le.value == ye.CPR_SETTINGS && (i.layoutManager.storeLayout(ye.CPR_SETTINGS.toString(), Fe._CPR_SETTINGS_WIZARD), J = i.layoutManager.getLayout(Te.toString()) ?? i.layoutManager.getDefaultLayout(), qe()), le.value == ye.NERVE_DRAWING && (i.objects.hasCPR() || (Y.value = !0), i.layoutManager.storeLayout(ye.NERVE_DRAWING.toString(), Fe._NERVE_DRAWING_WIZARD), J = i.layoutManager.getLayout(Te.toString()) ?? i.layoutManager.getDefaultLayout(), qe()), le.value == ye.GUIDE_DESIGN && (i.layoutManager.storeLayout(ye.GUIDE_DESIGN.toString(), Fe._FULLSCREEN_3D), J = i.layoutManager.getLayout(Te.toString()) ?? i.layoutManager.getDefaultLayout(), qe()), ((Ze) => {
        switch (console.log("setActiveTool wizard : ", Ze), Ze) {
          case ye.CPR_SETTINGS:
            i.toolManager.setTool(_n.CPR, rn.PRIMARY);
            break;
          case ye.NERVE_DRAWING:
            i.toolManager.setTool(_n.NERVE, rn.PRIMARY);
            break;
          case ye.DATA_IMPORT:
            i.toolManager.setTool(_n.MATCHING_TOOL, rn.PRIMARY);
            break;
          default:
            i.toolManager.setTool(_n.NONE, rn.PRIMARY);
        }
      })(le.value), le.value === ye.DATA_IMPORT && qe(), !(le.value === ye.CPR_SETTINGS || le.value === ye.NERVE_DRAWING)) {
        const Ze = i.layoutManager.layoutTemplateContainsCpr(J);
        Le.value = i.objects.hasCPR(), Ze && !Le.value && (J = Fe._3D_MPR);
      }
      i.layoutManager.setLayout(J), i.resize(), i.resetOrientation(), V(J), O.updateSelectedWizardIndex(le.value), Q();
    });
    const me = () => {
      var J, Pe;
      i.layoutManager.storeLayout(((J = Ie.value) == null ? void 0 : J.type.toString()) ?? "", ((Pe = Ie.value) == null ? void 0 : Pe.defaultLayout) ?? Fe._FULLSCREEN_3D);
      const Te = i.layoutManager.getLayout(le.value.toString()) ?? i.layoutManager.getDefaultLayout();
      i.layoutManager.setLayout(Te), ce.value = !1, V(Te);
    }, de = () => {
      const Te = i.layoutManager.getLayout("StlLibrary");
      Te !== void 0 && i.layoutManager.setLayout(Te), re.value = !1;
    }, We = B(), Q = () => {
      v.value && n.showProjectOnNavbar(v.value);
    };
    lt(p, () => {
      p.value && n.showNavbar({
        buttons: Cu(j.value),
        showZimvieLogo: !1,
        showNavbarPosition: !0,
        isWizard: !0
      });
    }), Dt(async () => {
      var st, ae;
      console.log("legacy wizard"), n.showOnlyLogo(), (st = document.getElementById("top-navbar-container")) == null || st.classList.add("bg-body-wiz"), i.undoManager.onUndoChange.subscribe(x), x(), i.toolManager.onUndoManagerChange.subscribe(x), i.toolManager.onUndoManagerPop.subscribe(x), j.value === wt.WeblinkViewer && (ze(), ct()), console.log("Engine JS - navigator.hardwareConcurrency", navigator.hardwareConcurrency);
      const Te = performance.now(), J = await Ee;
      ps(J), console.log("engine await: ", performance.now() - Te), await ie(A.params), await ((ae = i.contextCAD) == null ? void 0 : ae.LoadCADResources()), j.value === wt.WeblinkViewer && (i.layoutManager.wizardTabIndex.set(ye.IMPLANT_PLANNING), le.value = ye.IMPLANT_PLANNING, Z()), i.objects.hasCPR() && i.objects.initializeCPRCurve(), i.objects.hasCPR() && (i.layoutManager.wizardTabIndex.set(ye.IMPLANT_PLANNING), le.value = ye.IMPLANT_PLANNING, Z()), D(), Q(), Nt(mt), j.value === wt.WeblinkViewer && (i.readOnly = !0, i.objects.lockUnlockAllImplantPins(!0)), i.objects.checkCollisions(), p.value = !0, h.value = !1;
      const Pe = i.getOverlayContainer(), Ze = document.createElement("div");
      Ze.id = "stlLibraryContainer", Ze.style.position = "absolute", Ze.style.pointerEvents = "none", Ze.style.userSelect = "none", Ze.style.inset = "0px", Pe.appendChild(Ze), i.sceneRepaint();
    }), Ln(() => {
      i && p.value && i.cleanup();
    });
    async function ie(Te) {
      g.value = !0, b.value = 0, m.value = Math.random();
      const J = await o.getProjectInfo(Te);
      if (!J) {
        console.error("Project not found");
        return;
      }
      const Pe = J.project;
      i.patientInfo = J.patientInfo, v.value = J.projectFullName, Q(), We.value = Pe.patientName, g.value = !0, b.value = 5, m.value = Math.random();
      const Ze = (st) => {
        b.value = st.loaded / st.total * 100, m.value = Math.random();
      };
      await o.loadProject(Pe, i, xe, Ze);
    }
    const W = (Te) => {
      i.objects.unSelectObject();
      const J = o.getLoadedProjectData();
      i && J && l.open($u, {
        props: {
          closable: !1,
          modal: !0,
          header: t("implant-planner.saveProject"),
          style: { width: "50vw" }
        },
        data: {
          context: i,
          projectData: J,
          isSaveAs: Te,
          projectLoader: o
        }
      });
    }, ee = tt(il()), $ = tt(il()), R = r(Re);
    function D() {
      j.value === wt.WeblinkViewer ? _u() : Re.value === hn.HORIZONTAL ? rl() : sl();
    }
    Ha(() => {
      Tt(mt), R === hn.HORIZONTAL && j.value === wt.WeblinkViewer ? rl() : R === hn.SIDEBAR && j.value === wt.WeblinkViewer && sl();
    });
    const V = (Te) => {
      ee.oldLayout = Te, ee.newLayout = Te;
    };
    function Z() {
      const Te = te.find((J) => J.type === le.value);
      Te && (Ie.value = Te);
    }
    function X() {
      var Te;
      if (le.value === ye.DATA_IMPORT)
        return {
          patientName: We.value
        };
      if (le.value === ye.GUIDE_DESIGN)
        return {
          wizardsList: (Te = Ie == null ? void 0 : Ie.value) == null ? void 0 : Te.wizardsList
        };
      if (le.value === ye.IMPLANT_PLANNING && j.value === wt.WeblinkViewer)
        return {
          isReadOnly: !0
        };
    }
    const Ae = Ce(() => le.value === 0), De = Ce(() => le.value === te[te.length - 1].type), at = () => {
      Z();
    }, Be = () => {
      console.log("IPProjectLoaderView.vue: doneFromSteps clicked -");
    }, ze = () => {
      n.disableNavbarButtons([_e.UNDO, _e.REDO, _e.SAVE, _e.SAVE_AS, _e.RESET, _e.RULER, _e.SETTINGS]);
    };
    async function ct() {
      await dl().loadSTLLibrary();
    }
    lt(
      () => O.colorScheme,
      () => {
        i.setColorScheme(O.colorScheme);
      },
      {
        immediate: !0
      }
    );
    async function ht() {
      await i.toolManager.destructAllTools(), j.value === wt.WeblinkViewer ? await k.push({ name: "Home", params: { name: A.params.name, id: We.value } }) : await k.push({ name: "Patients", params: { id: We.value } });
    }
    const mt = async (Te) => {
      if (Te === _e.SAVE)
        W();
      else if (Te === _e.SAVE_AS)
        W(!0);
      else if (Te === _e.SETTINGS)
        N.value = !0;
      else if (Te === _e.RESET)
        i && (i.resetOrientation(), i.sceneRepaint());
      else if (Te === _e.LAYOUT)
        se();
      else if (Te === _e.SCREENSHOT) {
        const J = await i.takeWindowScreenshotWebcad();
        if (J) {
          const Pe = /* @__PURE__ */ new Date(), Ze = (ut) => String(ut).padStart(2, "0"), st = `${i.projectInfo.projectFilename.replace(".zip", "")} ${Pe.getFullYear()}-${Ze(Pe.getMonth() + 1)}-${Ze(Pe.getDate())} at ${Ze(Pe.getHours())}.${Ze(Pe.getMinutes())}.${Ze(Pe.getSeconds())}.png`, ae = J.toDataURL();
          if (ae) {
            const ut = document.createElement("a");
            document.body.appendChild(ut), ut.href = ae, ut.download = st, ut.click(), window.URL.revokeObjectURL(ae);
          }
          const ve = await new Promise((ut) => J.toBlob(ut, "image/png"));
          if (ve)
            try {
              await o.uploadScreenshot(i.patientInfo.extra.extra.study_instance_UID, st, Ta.Image, ve), lo(t("weblink.successfullyUploadedScreenshot"));
            } catch (ut) {
              Vn(ut, t("web-rg.uploadFailed"));
            }
        }
      } else if (Te === _e.W_L) {
        if (i) {
          const J = i.toolManager.activeTool.WindowLevel.get();
          i.toolManager.activeTool.WindowLevel.set(!J);
        }
      } else Te === _e.HELP ? await T.showViewerHelpModal() : Te === _e.INFO ? i.setInfoFlag(!i.getInfoFlag().get()) : Te === _e.UNDO ? await i.undoManager.undo() : Te === _e.REDO ? await i.undoManager.redo() : Te === _e.RULER_DISTANCE ? M.addNewDistanceMeasurement.notify() : Te === _e.RULER_ANGLE ? M.addNewAngleMeasurement.notify() : Te === _e.RULER_ANNOTATION ? M.addNewAnnotation.notify() : Te === _e.RULER_ROI ? M.addNewROIMeasurement.notify() : Te === _e.RULER_CLEAR ? M.clearAllMeasurements.notify() : Te === _e.ZIMVIE_LOGO ? await ht() : Te === _e.RG_LOGO ? await ht() : Te === _e.EXIT && await ht();
    };
    function Bt() {
      le.value = ye.CPR_SETTINGS, Z();
    }
    function Nt(Te) {
      nl.on(al.NAVBAR_BUTTON_CLICKED, Te);
    }
    function Tt(Te) {
      nl.off(al.NAVBAR_BUTTON_CLICKED, Te);
    }
    const Rt = Ce(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      height: `calc(-${q.value ? 160 : 95}px + 100vh) !important`
    })), bn = Ce(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      height: `calc(-${q.value ? 155 : 90}px + 100vh) !important`
    }));
    return (Te, J) => {
      const Pe = mu, Ze = pu, st = du;
      return L(), H(He, null, [
        h.value ? (L(), H("div", {
          key: 0,
          id: "loadingDiv",
          class: "flex flex-col gap-6 items-center justify-center",
          style: Et({
            position: "absolute",
            inset: "0px",
            background: K.value,
            zIndex: "1000000",
            pointerEvents: "all",
            cursor: "wait"
          })
        }, [
          d(r(os), { strokeWidth: 5 }, {
            default: _(() => [
              y("div", R2, U(w.value), 1),
              g.value ? (L(), H("div", M2, [
                (L(), be(r(di), {
                  value: b.value,
                  key: m.value,
                  style: { height: "2rem" }
                }, {
                  default: _(() => [
                    vt(U(b.value.toFixed(0)) + " %", 1)
                  ]),
                  _: 1
                }, 8, ["value"]))
              ])) : ue("", !0)
            ]),
            _: 1
          })
        ], 4)) : ue("", !0),
        d(r(Un), {
          visible: ce.value,
          "onUpdate:visible": J[1] || (J[1] = (ae) => ce.value = ae),
          breakpoints: { "960px": "75vw", "640px": "100vw" },
          modal: !0,
          style: { width: "50vw" },
          header: Te.$t("implant-planner.changeLayout")
        }, {
          footer: _(() => [
            y("div", P2, [
              d(r(Ne), {
                class: "btn-wizard-md",
                autofocus: "",
                icon: "pi pi-check",
                label: Te.$t("shared.ok"),
                onClick: J[0] || (J[0] = (ae) => ce.value = !1)
              }, null, 8, ["label"]),
              d(r(Ne), {
                class: "btn-wizard-md",
                background: !1,
                outlined: !0,
                icon: "pi pi-times",
                label: Te.$t("shared.cancel"),
                onClick: me
              }, null, 8, ["label"])
            ])
          ]),
          default: _(() => [
            d(Pe, {
              "model-value": ee,
              onUpdateLayout: Qe
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Un), {
          visible: re.value,
          "onUpdate:visible": J[3] || (J[3] = (ae) => re.value = ae),
          breakpoints: { "960px": "45vw", "640px": "60vw" },
          modal: !0,
          style: { width: "30vw" },
          header: Te.$t("implant-planner.changeLayout")
        }, {
          footer: _(() => [
            y("div", x2, [
              d(r(Ne), {
                class: "btn-wizard-md",
                autofocus: "",
                icon: "pi pi-check",
                label: Te.$t("shared.ok"),
                onClick: J[2] || (J[2] = (ae) => re.value = !1)
              }, null, 8, ["label"]),
              d(r(Ne), {
                class: "btn-wizard-md",
                background: !1,
                outlined: !0,
                icon: "pi pi-times",
                label: Te.$t("shared.cancel"),
                onClick: de
              }, null, 8, ["label"])
            ])
          ]),
          default: _(() => [
            d(ku, {
              "model-value": $,
              onUpdateLayout: Qe
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Un), {
          visible: Y.value,
          "onUpdate:visible": J[5] || (J[5] = (ae) => Y.value = ae),
          closable: !1,
          draggable: !1,
          modal: "",
          header: Te.$t("implant-planner.warning"),
          style: { width: "25vw" }
        }, {
          default: _(() => [
            y("p", j2, U(Te.$t("implant-planner.cprDoesNotExist")), 1),
            y("div", $2, [
              d(r(Ne), {
                class: "w-full",
                label: Te.$t("implant-planner.goToCprSettings"),
                onClick: J[4] || (J[4] = (ae) => [Bt(), Y.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Un), {
          visible: pe.value,
          "onUpdate:visible": J[7] || (J[7] = (ae) => pe.value = ae),
          closable: !1,
          draggable: !1,
          modal: "",
          header: fe.value,
          style: { width: "25vw" }
        }, {
          default: _(() => [
            y("p", F2, U(r(i).warningString.get()), 1),
            y("div", k2, [
              d(r(Ne), {
                autofocus: "",
                class: "w-full",
                label: Te.$t("shared.ok"),
                onClick: J[6] || (J[6] = (ae) => [pe.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        Pt(d(Mu, { class: "show-horizontal-bar horizontal-wizard-menu" }, {
          start: _(() => [
            (L(!0), H(He, null, jt(te, (ae) => (L(), be(Pu, {
              key: ae.type,
              modelValue: le.value,
              "onUpdate:modelValue": J[8] || (J[8] = (ve) => le.value = ve),
              index: ae.type,
              disabled: ae.disabled || !F.value,
              onClick: at
            }, {
              default: _(() => [
                vt(U(ae.tabLabel), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "index", "disabled"]))), 128))
          ]),
          _: 1
        }, 512), [
          [ln, q.value && j.value === r(wt).ImplantPlannerBase]
        ]),
        d(r(we), {
          id: "mainContainer",
          ref: "root",
          class: Ge(he.value),
          style: { "margin-bottom": "0.5rem", "margin-left": "0.5rem", "margin-right": "0.5rem", "margin-top": "0 !important", border: "1px solid rgba(255, 255, 255, 0)", "border-radius": "8px" }
        }, {
          default: _(() => [
            p.value ? (L(), H("div", V2, [
              Pt(y("div", null, [
                y("div", B2, [
                  d(N2, null, {
                    mainMenuTabs: _(() => [
                      (L(!0), H(He, null, jt(te, (ae) => (L(), be(A2, {
                        key: ae.type,
                        modelValue: le.value,
                        "onUpdate:modelValue": J[9] || (J[9] = (ve) => le.value = ve),
                        index: ae.type,
                        disabled: ae.disabled || !F.value,
                        onClick: at
                      }, {
                        default: _(() => [
                          vt(U(ae.tabLabel), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "index", "disabled"]))), 128))
                    ]),
                    _: 1
                  })
                ])
              ], 512), [
                [ln, !q.value && j.value === r(wt).ImplantPlannerBase]
              ]),
              d(r(we), {
                class: Ge(ne.value),
                style: Et(Rt.value)
              }, {
                default: _(() => [
                  y("div", U2, [
                    d(Ze, {
                      isFirstItem: Ae.value,
                      isVisible: !S.value && I.value && j.value === r(wt).ImplantPlannerBase,
                      isLastItem: De.value,
                      onNextStep: rt,
                      onPreviousStep: P
                    }, {
                      default: _(() => {
                        var ae;
                        return [
                          (L(), be(Sa(((ae = Ie.value) == null ? void 0 : ae.component) ?? {}), je(X(), { onDone: Be }), null, 16))
                        ];
                      }),
                      _: 1
                    }, 8, ["isFirstItem", "isVisible", "isLastItem"])
                  ])
                ]),
                _: 1
              }, 8, ["class", "style"])
            ])) : ue("", !0),
            d(r(we), {
              id: "wizard-container",
              style: Et(bn.value)
            }, {
              default: _(() => [
                ue("", !0),
                J[12] || (J[12] = y("div", { id: "aboveRenderWindowContainer" }, null, -1)),
                Pt(y("div", {
                  ref_key: "vtkContainer",
                  ref: u,
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden" }
                }, null, 512), [
                  [ln, !S.value]
                ]),
                Pt(y("div", {
                  ref_key: "vtkContainerCAD",
                  ref: c,
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden", position: "relative" }
                }, null, 512), [
                  [ln, S.value]
                ]),
                J[13] || (J[13] = y("div", { id: "belowRenderWindowContainer" }, null, -1))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["class"]),
        N.value ? (L(), be(st, {
          key: 1,
          visible: !0,
          settings: r(i).settings,
          onConfirm: G,
          onCancel: G
        }, null, 8, ["settings"])) : ue("", !0)
      ], 64);
    };
  }
}), UP = /* @__PURE__ */ Vt(G2, [["__scopeId", "data-v-d3990aff"]]), W2 = /* @__PURE__ */ Je({
  __name: "IPModelDesignCAD",
  emits: ["nextStepNested", "previousStepNested"],
  setup(e, { emit: t }) {
    let n = B([]), a, o = B("");
    const l = B(Math.random());
    let s = B();
    const i = Ao();
    let u;
    const c = t;
    let p = null;
    return Dt(async () => {
      i.enableNavbarButtons([_e.UNDO, _e.REDO]);
      const h = document.getElementById("wizard-container");
      p = h ? Zr(h) : null;
      const g = new ao([0, 0]), b = B(document.getElementById("wizard-container")), E = b.value ? b.value.getBoundingClientRect() : { width: 100, height: 100 };
      g.set([Math.min(100, (E == null ? void 0 : E.width) * 2 / 3), Math.min(100, E == null ? void 0 : E.height)]);
      const m = () => {
        var C, k;
        const T = (C = b.value) == null ? void 0 : C.getBoundingClientRect();
        if (!T) return;
        const O = (k = b.value) == null ? void 0 : k.children[2];
        if (O) {
          const z = Array.from(O.children).find((j) => j instanceof HTMLDivElement && j.style.display !== "none");
          if (z instanceof HTMLDivElement) {
            const j = z.getBoundingClientRect();
            g.set([j.width, j.height]);
            return;
          }
        }
        g.set([T.width * 2 / 3, T.height]);
      };
      Yr(b, () => {
        m();
      }), u = dn(), u.showLoading(it("implant-planner.loadingCreateModel"), !1, void 0, !0), u.setCADMode(!0), u.contextCAD.GetMainForm().SetJSLambda((T) => {
        console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI start toolwidget exists", !!T), T ? (n.value = T.GetWidgetOrder().slice(), a = T.GetWidgets(), o.value = T.GetToolTitle(), console.log(
          "000000 DynamicGUIComponent RETRIEVESTATICGUI widgets, order title",
          T.GetWidgetOrder().slice(),
          T.GetToolTitle(),
          T.GetWidgets()
        )) : (n.value = [], a = void 0, o.value = ""), l.value = Math.random(), console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI end");
      }, qt.eJSLT_RETIEVE_GUI);
      const I = (T) => {
        console.log("DEBUGG: finalizeCADWizard"), u.setCADMode(!1), u.layoutManager.wizardTabIndex.set(ye.IMPLANT_PLANNING);
      };
      u.contextCAD.GetMainForm().SetJSLambda(I, qt.eJSLT_FINALIZE_CAD_WIZARD);
      let S;
      const f = new ao({ items: [] }), v = () => {
        f.set(S());
      };
      S = () => {
        try {
          const T = u.contextCAD.GetMainForm().GetWasmObjectListItems(), O = [];
          for (let M = 0; M < T.size(); M++) {
            const z = T.get(M), j = z.GetGroup(), K = z.GetColor();
            console.log(z.GetLabel(), j, z.GetState(), K.get(0), K.get(1), K.get(2)), O.includes(j) || O.push(j);
          }
          const C = [];
          for (let M = 0; M < O.length; M++) {
            const z = [];
            for (let j = 0; j < T.size(); j++) {
              const K = T.get(j);
              if (O[M] === K.GetGroup()) {
                const x = K.GetColor();
                z.push({
                  key: K.GetId(),
                  label: K.GetLabel(),
                  visible: K.GetState(),
                  color: [x.get(0), x.get(1), x.get(2)],
                  onClick: (N) => {
                    u.contextCAD.GetMainForm().WasmObjectListItemClicked(N, !0);
                  },
                  onSelect: (N) => {
                    u.contextCAD.GetMainForm().WasmObjectListItemClicked(N, !0);
                  },
                  onUnselect: (N) => {
                    u.contextCAD.GetMainForm().WasmObjectListItemClicked(N, !1);
                  }
                });
              }
            }
            C.push({
              key: O[M],
              label: O[M],
              children: z
            });
          }
          return {
            items: C
          };
        } catch (T) {
          return console.error("Error in getObjectListItems", T), { items: [] };
        }
      };
      const w = (T) => {
        const O = u.contextCAD.GetMainForm().WasmObjectListContextMenuClicked(T);
        return Jr(O);
      };
      for (let T of u.objects.implants.values())
        await T.loadExtrusionParts();
      await u.setTabIndex(19) && (s.value = u.contextCAD.tabWidgetHandler, console.log("tabWidgetHandler", s), console.log("Creating Object List", p, g), p == null || p.createVueOverlayComponent(
        Xr,
        {
          objectTree: f,
          viewSize: g,
          initialPosition: Xl.topRight,
          getContextMenuItems: w
        },
        {
          noContainerResize: !0
        }
      ), u.contextCAD.GetMainForm().SetJSLambda((T) => {
        T ? m() : v();
      }, qt.eJSLT_UPDATE_OBJECT_TREE_LIST), m(), v(), u.hideLoading());
    }), Ln(() => {
      u.objects.implants.forEach((h) => {
        h.deleteExtrusionParts();
      }), p == null || p.cleanup(), i.disableNavbarButtons([_e.UNDO, _e.REDO]);
      try {
        u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_RETIEVE_GUI), u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_UPDATE_OBJECT_TREE_LIST), u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_FINALIZE_CAD_WIZARD), u.setCADMode(!1), u.setTabIndex(1);
      } catch (h) {
        console.error("Error during unmount: ", h);
      }
    }), (h, g) => (L(), be(r(ot), {
      class: "flex h-full horizontal-padding",
      style: { "margin-bottom": "1rem", "margin-top": "1rem", "min-height": "0" }
    }, {
      default: _(() => [
        d(r(ot), {
          class: "grow overflow-x-hidden overflow-y-auto",
          style: { "min-height": "0" }
        }, {
          default: _(() => [
            r(n).length ? (L(), be(r(ls), {
              key: l.value,
              "widget-params": r(a),
              "widget-order": r(n),
              "tool-title": r(o),
              class: "mb-2"
            }, null, 8, ["widget-params", "widget-order", "tool-title"])) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(ot), { style: { flex: "0 0 auto" } }, {
          default: _(() => [
            r(s) ? (L(), be(r(is), {
              key: 0,
              "tab-handler": r(s),
              context: r(u),
              onNextStepNested: g[0] || (g[0] = (b) => c("nextStepNested")),
              onPreviousStepNested: g[1] || (g[1] = (b) => c("previousStepNested"))
            }, null, 8, ["tab-handler", "context"])) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), z2 = /* @__PURE__ */ Je({
  __name: "IPGuideDesignCAD",
  emits: ["nextStepNested", "previousStepNested"],
  setup(e, { emit: t }) {
    let n = B([]), a, o = B("");
    const l = B(Math.random());
    let s = B();
    const i = Ao();
    let u;
    const c = t;
    let p = null;
    return Dt(async () => {
      i.enableNavbarButtons([_e.UNDO, _e.REDO]);
      const h = document.getElementById("wizard-container");
      p = h ? Zr(h) : null;
      const g = new ao([0, 0]), b = B(document.getElementById("wizard-container")), E = b.value ? b.value.getBoundingClientRect() : { width: 100, height: 100 };
      g.set([Math.min(100, (E == null ? void 0 : E.width) * 2 / 3), Math.min(100, E == null ? void 0 : E.height)]);
      const m = () => {
        var M, z;
        const C = (M = b.value) == null ? void 0 : M.getBoundingClientRect();
        if (!C) return;
        const k = (z = b.value) == null ? void 0 : z.children[2];
        if (k) {
          const K = Array.from(k.children).find((x) => x instanceof HTMLDivElement && x.style.display !== "none");
          if (K instanceof HTMLDivElement) {
            const x = K.getBoundingClientRect();
            g.set([x.width, x.height]);
            return;
          }
        }
        g.set([C.width * 2 / 3, C.height]);
      };
      Yr(b, () => {
        m();
      }), u = dn(), u.showLoading(it("implant-planner.loadingGuideDesign"), !1, void 0, !0), u.setCADMode(!0), u.contextCAD.GetMainForm().SetJSLambda((C) => {
        console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI start toolwidget exists", !!C), C ? (n.value = C.GetWidgetOrder().slice(), a = C.GetWidgets(), o.value = C.GetToolTitle(), console.log(
          "000000 DynamicGUIComponent RETRIEVESTATICGUI widgets, order title",
          C.GetWidgetOrder().slice(),
          C.GetToolTitle(),
          C.GetWidgets()
        )) : (n.value = [], a = void 0, o.value = ""), l.value = Math.random(), console.log("000000 DynamicGUIComponent RETRIEVESTATICGUI end");
      }, qt.eJSLT_RETIEVE_GUI);
      const I = () => {
        console.log("DEBUGG: finalizeCADWizard"), u.setCADMode(!1), u.layoutManager.wizardTabIndex.set(ye.IMPLANT_PLANNING);
      };
      u.contextCAD.GetMainForm().SetJSLambda(I, qt.eJSLT_FINALIZE_CAD_WIZARD);
      let S;
      const f = new ao({ items: [] }), v = () => {
        f.set(S());
      };
      S = () => {
        try {
          const C = u.contextCAD.GetMainForm().GetWasmObjectListItems(), k = [];
          for (let j = 0; j < C.size(); j++) {
            const K = C.get(j), x = K.GetGroup(), N = K.GetColor();
            console.log(K.GetLabel(), x, K.GetState(), N.get(0), N.get(1), N.get(2)), k.includes(x) || k.push(x);
          }
          const M = [];
          for (let j = 0; j < k.length; j++) {
            const K = [];
            for (let x = 0; x < C.size(); x++) {
              const N = C.get(x);
              if (k[j] === N.GetGroup()) {
                const G = N.GetColor();
                K.push({
                  key: N.GetId(),
                  label: N.GetLabel(),
                  visible: N.GetState(),
                  color: [G.get(0), G.get(1), G.get(2)],
                  onClick: (ce) => {
                    u.contextCAD.GetMainForm().WasmObjectListItemClicked(ce, !0);
                  },
                  onSelect: (ce) => {
                    u.contextCAD.GetMainForm().WasmObjectListItemClicked(ce, !0);
                  },
                  onUnselect: (ce) => {
                    u.contextCAD.GetMainForm().WasmObjectListItemClicked(ce, !1);
                  }
                });
              }
            }
            M.push({
              key: k[j],
              label: k[j],
              children: K
            });
          }
          return {
            items: M
          };
        } catch (C) {
          return console.error("Error in getObjectListItems", C), { items: [] };
        }
      };
      const w = (C) => {
        const k = u.contextCAD.GetMainForm().WasmObjectListContextMenuClicked(C);
        return Jr(k);
      }, A = p == null ? void 0 : p.createVueOverlayComponent(
        dp,
        {
          viewSize: g,
          barSize: new ao([220, 100]),
          initialPosition: Xl.bottomRight,
          // initialPosition: AnchorPosition.topRight,
          onWheelCallback: () => {
            u.contextCAD.GetMainForm().WasmScalarBarSetScalarBarScale(tn.getActiveScalarBarScale());
          },
          headerButtonClicked: (C) => {
            u.contextCAD.GetMainForm().WasmScalarBarHeaderButtonClicked(C);
          },
          contactsButtonClicked: () => {
            u.contextCAD.GetMainForm().WasmScalarBarContactsButtonClicked(!0);
          },
          modelContactsButtonClicked: () => {
            u.contextCAD.GetMainForm().WasmScalarBarContactsButtonClicked(!1);
          }
          // parent: context.getOverlayContainer(),
          // dockEvent: () => {
          //     context.dockOverlays();
          // },
        },
        {
          noContainerResize: !0
        }
      );
      A == null || A.setEnabled(!1);
      const T = (C, k, M, z, j, K, x, N, G, ce, re) => {
        console.log(
          "Update Contacts Widget",
          C,
          k,
          M,
          z,
          j,
          K,
          x,
          N,
          G,
          ce,
          re
        ), tn.updateTitle(k), A == null || A.setEnabled(z), tn.sReverseGradient.set(re), tn.sHint.set(M), tn.setActiveScalarBarMode(C), tn.contactsButtonVisible.set(j), tn.contactsButtonChecked.set(K), tn.modelContactsButtonVisible.set(x), tn.modelContactsButtonChecked.set(N), tn.headerButtonVisible.set(G), tn.headerButtonChecked.set(ce);
      };
      u.contextCAD.GetMainForm().SetJSLambda(
        (C, k, M, z, j, K, x, N, G, ce, re, Se) => {
          Se || T(
            C,
            k,
            M,
            z,
            j,
            K,
            x,
            N,
            G,
            ce,
            re
          );
        },
        qt.eJSLT_UPDATE_CONTACTS_WIDGET
      ), u.objects.loadGuideObjectsParts(10, 5, 0.12), await u.setTabIndex(12) && (s.value = u.contextCAD.tabWidgetHandler, p == null || p.createVueOverlayComponent(
        Xr,
        {
          objectTree: f,
          viewSize: g,
          initialPosition: Xl.topRight,
          getContextMenuItems: w
        },
        {
          noContainerResize: !0
        }
      ), u.contextCAD.GetMainForm().SetJSLambda((C) => {
        C ? m() : v();
      }, qt.eJSLT_UPDATE_OBJECT_TREE_LIST), m(), v(), u.hideLoading());
    }), Ln(() => {
      if (p == null || p.cleanup(), i.disableNavbarButtons([_e.UNDO, _e.REDO]), !(!u || u.isDestructed())) {
        u.objects.clearGuideObjectParts(!0, !0);
        try {
          u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_RETIEVE_GUI), u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_UPDATE_OBJECT_TREE_LIST), u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_FINALIZE_CAD_WIZARD), u.contextCAD.GetMainForm().ClearJSLambda(qt.eJSLT_UPDATE_CONTACTS_WIDGET), u.setCADMode(!1), u.setTabIndex(1);
        } catch (h) {
          console.error("Error during unmount: ", h);
        }
      }
    }), (h, g) => (L(), be(r(ot), {
      class: "flex h-full horizontal-padding",
      style: { "margin-bottom": "1rem", "margin-top": "1rem", "min-height": "0" }
    }, {
      default: _(() => [
        d(r(ot), {
          class: "grow overflow-x-hidden overflow-y-auto",
          style: { "min-height": "0" }
        }, {
          default: _(() => [
            r(n).length ? (L(), be(r(ls), {
              key: l.value,
              "widget-params": r(a),
              "widget-order": r(n),
              "tool-title": r(o),
              class: "mb-2"
            }, null, 8, ["widget-params", "widget-order", "tool-title"])) : ue("", !0)
          ]),
          _: 1
        }),
        d(r(ot), { style: { flex: "0 0 auto" } }, {
          default: _(() => [
            r(s) ? (L(), be(r(is), {
              key: 0,
              "tab-handler": r(s),
              context: r(u),
              onNextStepNested: g[0] || (g[0] = (b) => c("nextStepNested")),
              onPreviousStepNested: g[1] || (g[1] = (b) => c("previousStepNested"))
            }, null, 8, ["tab-handler", "context"])) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), Vf = /* @__PURE__ */ Je({
  __name: "IPAppMenuContainerRedesign",
  setup(e) {
    const t = pl(), n = np();
    n.menuMode = hn.SIDEBAR, lt(t, () => {
      n.menuActive = !1;
    });
    function a() {
      n.menuClick = !0;
    }
    return Ce(() => (n.sidebarActive, "")), (o, l) => (L(), H("div", null, [
      y("div", {
        class: Ge([{ "layout-sidebar-active": r(n).sidebarActive }, "layout-menu-wrapper margin-t-80px"]),
        style: { "margin-bottom": "0.5rem", background: "transparent", border: "1px solid rgba(255, 255, 255, 0)", width: "108px", overflow: "hidden" },
        onClick: a
      }, [
        d(r(ot), null, {
          default: _(() => [
            It(o.$slots, "mainMenuTabs")
          ]),
          _: 3
        })
      ], 2)
    ]));
  }
}), H2 = { class: "layout-menuitem-icon ml-1 flex justify-center" }, Y2 = { class: "text-center layout-menuitem-text text-sm menu-item-color" }, K2 = /* @__PURE__ */ Je({
  __name: "IPAppMenuItemRedesign",
  props: {
    modelValue: {},
    index: {},
    disabled: { type: Boolean, default: !1 },
    isLast: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = B(n.index === 0 ? "bg-purple-500" : "bg-purple-500 "), l = B(n.index);
    Ga(() => {
      o.value = n.modelValue == n.index ? "bg-primary-color" : "app-menu-btn", n.disabled && (o.value += " wizard-menu-item-disabled");
    });
    const s = () => {
      a("update:modelValue", n.index);
    }, i = Ce(() => n.index === 0 ? "rounded-t" : [ye.CAD_DESIGN, ye.GUIDE_DESIGN, ye.CREATE_MODEL].includes(n.index) || n.isLast ? "rounded-b" : "rounded-none");
    return (u, c) => (L(), be(r(ot), {
      id: `btnTabMenuIndex_${n.index}`,
      class: Ge([i.value, o.value, "cursor-pointer align-center gap-2"]),
      style: Et({ padding: "1.5rem 0.5rem", pointerEvents: n.disabled ? "none" : "auto", opacity: n.disabled ? "0.6" : "1" }),
      onClick: s
    }, {
      default: _(() => [
        d(r(we), null, {
          default: _(() => [
            y("i", H2, [
              d(r(Hr), {
                cIcon: l.value.toString(),
                isMenuIcon: !0
              }, null, 8, ["cIcon"])
            ])
          ]),
          _: 1
        }),
        d(r(we), null, {
          default: _(() => [
            y("span", Y2, [
              It(u.$slots, "default", {}, void 0, !0)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["id", "class", "style"]));
  }
}), Bf = /* @__PURE__ */ Vt(K2, [["__scopeId", "data-v-a7423a41"]]), Z2 = { class: "p-dialog-title" }, X2 = { class: "p-dialog-header-actions" }, J2 = { class: "flex flex-row-wrap grow gap-4 justify-center mt-4" }, q2 = ["data-cy"], Q2 = {
  class: "wrapper-element",
  style: { "z-index": "1000" }
}, eR = { class: "ml-2 font-bold text-xl" }, tR = ["onMouseover", "onClick"], nR = /* @__PURE__ */ Je({
  __name: "IPSelectDesignComponent",
  emits: ["selected", "close"],
  setup(e, { emit: t }) {
    const n = Xn("dialogRef"), a = n.value.data, o = sa(), l = t, s = uf(a.preselectedMode), i = document.createElement("div");
    Dt(() => {
      const b = document.getElementById("commentContainer");
      b ? b.appendChild(i) : console.log("commentContainer does not exist");
    });
    const u = Ce(() => "col-span-12"), c = (b) => {
      i.innerHTML = b;
    }, p = () => {
      i.innerHTML = "";
    }, h = (b) => {
      let E = ye.UNKNOWN;
      switch (b.reconstructionDesign) {
        case ge.eRD_GUIDE:
          E = ye.GUIDE_DESIGN;
          break;
        case ge.eRD_ANALOGS_MODEL:
          E = ye.CREATE_MODEL;
          break;
      }
      l("selected", E), n.value.close();
    }, g = () => {
      l("close"), n.value.close();
    };
    return (b, E) => {
      const m = Au;
      return L(), be(r(we), {
        class: Ge([u.value, "flex-col"]),
        style: { overflow: "auto" }
      }, {
        default: _(() => [
          d(r(ke), {
            class: "p-dialog-header",
            style: { "user-select": "none" }
          }, {
            default: _(() => [
              y("div", Z2, U(r(a).headerText), 1),
              y("div", X2, [
                d(r(Ne), {
                  icon: "pi pi-times",
                  background: !1,
                  onClick: g
                })
              ])
            ]),
            _: 1
          }),
          d(r(we), { class: "overflow-auto" }, {
            default: _(() => [
              y("div", J2, [
                (L(!0), H(He, null, jt(r(s), (I, S) => (L(), H("div", {
                  class: "item-element",
                  "data-cy": `design-${I.name}`,
                  key: S
                }, [
                  y("div", Q2, [
                    y("span", eR, U(I.name), 1)
                  ]),
                  d(m, {
                    alt: I.name,
                    src: r(o).getAssetUrl(I.imageSrc),
                    "image-class": "small-image",
                    preview: "",
                    style: { width: "100%", height: "auto" },
                    pt: {
                      image: {
                        style: {
                          background: "transparent !important",
                          maxHeight: "17rem",
                          borderRadius: "8px"
                        }
                      },
                      previewMask: {
                        style: {
                          borderRadius: "8px"
                        }
                      }
                    }
                  }, {
                    indicatoricon: _(() => [
                      y("div", {
                        class: "w-full h-full flex flex-col justify-start",
                        onMouseover: (f) => c(I.comment),
                        onMouseleave: p,
                        onClick: (f) => h(I)
                      }, null, 40, tR)
                    ]),
                    _: 2
                  }, 1032, ["alt", "src"])
                ], 8, q2))), 128))
              ])
            ]),
            _: 1
          }),
          E[0] || (E[0] = y("div", {
            id: "commentContainer",
            class: "flex justify-center mt-2",
            style: { "min-height": "20vh", "white-space": "pre-wrap", top: "auto" }
          }, null, -1))
        ]),
        _: 1
      }, 8, ["class"]);
    };
  }
}), aR = /* @__PURE__ */ Vt(nR, [["__scopeId", "data-v-4e2210a7"]]), oR = { class: "hidden" }, lR = { style: { width: "100%", border: "1px solid var(--surface-border, #d6d6d6)", "border-radius": "8px", overflow: "hidden" } }, iR = { style: { display: "grid", "grid-template-columns": "minmax(0, 3fr) minmax(0, 2fr) 32px", gap: "6px", "align-items": "center", padding: "8px 12px", "border-bottom": "1px solid var(--surface-border, #d6d6d6)", "font-weight": "600", "font-size": "0.85rem" } }, sR = { style: { "max-height": "140px", "overflow-y": "auto" } }, rR = {
  key: 0,
  style: { padding: "12px", "font-size": "0.9rem" }
}, uR = {
  key: 1,
  style: { padding: "12px", "font-size": "0.9rem" }
}, cR = ["title"], dR = { class: "text-xs" }, pR = { style: { width: "100%", border: "1px solid var(--surface-border, #d6d6d6)", "border-radius": "8px", overflow: "hidden" } }, mR = { style: { display: "grid", "grid-template-columns": "minmax(0, 3fr) minmax(0, 2fr) 32px", gap: "6px", "align-items": "center", padding: "8px 12px", "border-bottom": "1px solid var(--surface-border, #d6d6d6)", "font-weight": "600", "font-size": "0.85rem" } }, fR = { style: { "max-height": "140px", "overflow-y": "auto" } }, gR = {
  key: 0,
  style: { padding: "12px", "font-size": "0.9rem" }
}, hR = {
  key: 1,
  style: { padding: "12px", "font-size": "0.9rem" }
}, bR = ["title"], vR = { class: "text-xs" }, yR = /* @__PURE__ */ Je({
  __name: "IPReportsWizard",
  emits: ["hideWizard"],
  setup(e, { emit: t }) {
    const { t: n } = Ht(), a = Aa(), o = ui(), l = ia(), s = as(), i = B(0), u = B(!1), c = B([]), p = B([]), h = B(null);
    Dt(async () => {
      i.value = await s.getNumberOfExportsTokens(), await N();
    });
    const g = t;
    let b = dn(), E = ia();
    const m = Ce(() => !!(b.license.versionType & ho.NORMAL)), I = Ce(() => !!(b.license.versionType & ho.PRO)), S = Ce(() => !0), f = Ce(() => I.value || m.value), v = Ce(() => m.value && S.value), w = Ce(() => (I.value || m.value) && S.value), A = Ce(() => m.value ? i.value != 0 : !0), T = Ce(() => {
      let ne = n("shared.export");
      if (m.value) {
        const te = i.value;
        te === 1 ? ne += ` (${te} ${n("shared.token")})` : te >= 0 && (ne += ` (${te} ${n("shared.tokens")})`);
      }
      return ne;
    }), O = (ne) => {
      if (!ne)
        return null;
      try {
        const te = JSON.parse(ne);
        if (typeof te == "object" && te !== null)
          return te;
      } catch (te) {
        console.warn("Invalid processing file metadata.", te);
      }
      return null;
    }, C = (ne) => {
      if (!ne)
        return "-";
      const te = ne instanceof Date ? ne : new Date(ne);
      return Number.isNaN(te.getTime()) ? typeof ne == "string" ? ne : "-" : te.toLocaleString();
    }, k = (ne) => {
      const te = ne.trim();
      return te.toLowerCase().endsWith(".zip") ? te : `${te}.zip`;
    }, M = (ne, te, Ie = "application/octet-stream") => {
      const Ee = new Blob([ne], { type: Ie }), xe = window.URL.createObjectURL(Ee), Qe = document.createElement("a");
      Qe.href = xe, Qe.download = te, document.body.appendChild(Qe), Qe.click(), Qe.remove(), window.URL.revokeObjectURL(xe);
    }, z = async (ne) => {
      const te = await ci.loadAsync(ne), Ie = Object.values(te.files).filter((Ee) => !Ee.dir);
      if (Ie.length)
        for (let Ee of Ie) {
          const xe = await Ee.async("arraybuffer");
          M(xe, Ee.name);
        }
    }, j = (ne, te) => {
      M(ne, k(te), "application/zip");
    }, K = (ne) => {
      var P;
      const te = ne.type === "processing-data" || ne.type === "report-data";
      if (!b.fileHash || !te || !ne.metadata)
        return null;
      const Ie = O(ne.metadata);
      if (!Ie)
        return null;
      const Ee = Ie["job-type"], xe = Ie["origin-file-uuid"];
      if (Ee !== "REPORT" && Ee !== "EXPORT")
        return null;
      const Ke = (() => {
        const F = Ie.exportFileName;
        if (typeof F == "string" && F.trim().length > 0)
          return F.trim();
        const me = Ie["job-input-params"];
        if (typeof me == "string") {
          const de = O(me), We = de == null ? void 0 : de.exportFileName;
          if (typeof We == "string" && We.trim().length > 0)
            return We.trim();
        } else if (typeof me == "object" && me !== null) {
          const de = me.exportFileName;
          if (typeof de == "string" && de.trim().length > 0)
            return de.trim();
        }
        return ne.name.replace(/\.zip$/i, "").trim();
      })();
      if (Ke.length === 0)
        return null;
      const qe = ((P = ne.file) == null ? void 0 : P.createDate) ?? ne.localCreateDate, rt = new Date(qe).getTime();
      return {
        fileUuid: ne.uuid,
        fileName: Ke.trim(),
        createdDateLabel: C(qe),
        createdDateTimestamp: Number.isNaN(rt) ? 0 : rt,
        jobType: Ee,
        originFileUuid: typeof xe == "string" ? xe : void 0
      };
    }, x = async () => {
      if (!b.projectHash)
        return [];
      const { data: ne } = await l.GetProjectByUUID(b.projectHash);
      if (!ne)
        return [];
      const { data: te } = await l.getPatientFullById(ne.id);
      return (te == null ? void 0 : te.files) ?? [];
    }, N = async () => {
      if (!b.fileHash || !b.projectHash) {
        c.value = [], p.value = [];
        return;
      }
      u.value = !0;
      try {
        const te = (await x()).map((Ee) => K(Ee)).filter((Ee) => Ee !== null).sort((Ee, xe) => xe.createdDateTimestamp - Ee.createdDateTimestamp), Ie = b.fileHash ? te.filter((Ee) => Ee.originFileUuid === b.fileHash) : [];
        c.value = Ie.filter((Ee) => Ee.jobType === "REPORT"), p.value = Ie.filter((Ee) => Ee.jobType === "EXPORT");
      } catch (ne) {
        Vn(ne instanceof Error ? ne.message : n("implant-planner.errorLoadingReportExportList"), n("implant-planner.errorLoadingReportExportList"));
      } finally {
        u.value = !1;
      }
    }, G = async (ne) => {
      if (!h.value) {
        h.value = ne.fileUuid;
        try {
          const te = await l.GetFileByUUID(ne.fileUuid);
          if (te.status !== Ja.OK) {
            Vn(te.data, n("implant-planner.errorFindingExportData"));
            return;
          }
          ne.jobType === "EXPORT" ? j(te.data, ne.fileName) : await z(te.data);
        } catch (te) {
          Vn(te instanceof Error ? te.message : n("implant-planner.errorFindingExportData"), n("implant-planner.errorFindingExportData"));
        } finally {
          h.value = null;
        }
      }
    }, ce = (ne) => ne.replace(/[\\/:*?"<>|]/g, "_").trim(), re = () => {
      var Ee, xe;
      const ne = b.patientInfo, te = (ne == null ? void 0 : ne.patientName) || ((Ee = ne == null ? void 0 : ne.extra) == null ? void 0 : Ee.patientName) || [ne == null ? void 0 : ne.firstName, ne == null ? void 0 : ne.lastName].filter((Qe) => Qe && Qe.length > 0).join("_") || ((xe = b.projectInfo) == null ? void 0 : xe.patientName) || b.projectName || "Report";
      return `${ce(te).replace(/\s+/g, "_") || "Report"}_Report`;
    }, Se = () => {
      a.open(wf, {
        props: {
          closable: !0,
          modal: !0,
          header: n("implant-planner.implantReportSettings"),
          style: { width: "70vw", minHeight: "60vh" },
          contentStyle: { borderRadius: "8px" }
        },
        data: {
          context: b
        },
        emits: {
          onOk: async (ne) => {
            await Le(ne);
          },
          close: () => {
          }
        }
      });
    }, se = async () => {
      var Ee;
      const ne = b.objects.getReportXML(), te = new File([ne], "drillReport.xml", { type: "application/xml" }), Ie = await E.triggerDrillReport(((Ee = b.patientInfo) == null ? void 0 : Ee.firstName) || "drill-report", te);
      Ie.status == 200 && Ie.data.success && Ie.data.reportUrl && window.open(Ie.data.reportUrl, "_blank");
    }, Le = async (ne) => {
      let te = !1;
      const Ie = async () => {
        var W, ee;
        const xe = ne.logoBase64;
        if (!xe)
          return;
        if (!xe.startsWith("data:")) {
          console.warn("Report logo is not a data URL, skipping upload.");
          return;
        }
        const [Qe, Ke] = xe.split(",");
        if (!Ke)
          return;
        const qe = Qe.match(/data:(.*?);base64/), rt = (qe == null ? void 0 : qe[1]) || "image/png", P = atob(Ke), F = new Uint8Array(P.length);
        for (let $ = 0; $ < P.length; $++)
          F[$] = P.charCodeAt($);
        const me = new Blob([F], { type: rt }), We = `report-logo.${rt.includes("jpeg") ? "jpg" : rt.split("/")[1] || "png"}`, Q = ((W = b.projectInfo) == null ? void 0 : W.patientName) || b.projectName || ((ee = b.patientInfo) == null ? void 0 : ee.patientName);
        if (!Q)
          throw new Error("Project name is required to upload the report logo.");
        (await l.uploadFile(Q, We, "report_logo", me)).status == Ja.OK && (ne.logoBase64 = "");
      }, Ee = async () => {
        var Ke, qe, rt;
        const xe = await b.getModalsInstance().showTextInputModal(n("shared.export"), re(), n("implant-planner.enterReportFileName"));
        if (!xe)
          return;
        const Qe = () => {
          te = !0, b.hideLoading();
        };
        b.showLoading(n("implant-planner.generatingReport"), !1, void 0, void 0, !0, Qe);
        try {
          if (b.fileHash) {
            await Ie();
            const P = [4e3, 1e3];
            ne.ww = P[0], ne.wl = P[1], ne.dateOfBirth = ne.dateOfBirth instanceof Date ? (Ke = ne.dateOfBirth) == null ? void 0 : Ke.toLocaleDateString() : ne.dateOfBirth, ne.examDate = ne.examDate instanceof Date ? (qe = ne.examDate) == null ? void 0 : qe.toLocaleDateString() : ne.examDate, ne.lastModified = ne.lastModified instanceof Date ? (rt = ne.lastModified) == null ? void 0 : rt.toLocaleDateString() : ne.lastModified, ne.fontColor && !ne.fontColor.startsWith("#") && (ne.fontColor = `#${ne.fontColor}`), ne.bgColor3d && !ne.bgColor3d.startsWith("#") && (ne.bgColor3d = `#${ne.bgColor3d}`);
            const F = JSON.stringify(ne, (Q, ie) => ie instanceof Date ? ie.toISOString() : ie), me = await l.triggerReportJob(b.fileHash, xe, F);
            if (te)
              return;
            if (me.status !== Ja.OK) {
              Vn(me.data, n("implant-planner.errorGeneratingReport"));
              return;
            }
            const de = me.data.data;
            let We = !1;
            for (; !We && !te; ) {
              const Q = await l.getJobStatusUuid(de);
              if (console.log("Job status", Q), te)
                break;
              if (Q.status === Ja.OK && Q.data.some((ie) => ie.status === "COMPLETED")) {
                We = !0, lo(n("implant-planner.reportCompletedMessage"), n("implant-planner.reportCompletedTitle"));
                break;
              }
              await new Promise((ie) => setTimeout(ie, 3e3));
            }
            if (te) {
              console.warn("Report canceled by user.");
              return;
            }
            if (We && b.projectInfo && b.projectHash) {
              const { data: Q } = await l.GetProjectByUUID(b.projectHash);
              if (Q) {
                const { data: ie } = await l.getPatientFullById(Q.id), ee = ((ie == null ? void 0 : ie.files) ?? []).find(($) => $.name == `${de}.zip`);
                if (ee) {
                  const $ = await l.GetFileByUUID(ee.uuid);
                  $.status == Ja.OK && await z($.data);
                }
              } else
                Vn(me.data, "Error finding report data for download.");
            }
            await N();
          }
        } catch (P) {
          jg(n("implant-planner.errorGeneratingReport"), P);
        } finally {
          te || b.hideLoading();
        }
      };
      b.shouldProjectBeSaved() ? o.require({
        message: n("implant-planner.saveBeforeReportPrompt"),
        header: n("implant-planner.saveProject"),
        icon: "pi pi-exclamation-triangle",
        acceptLabel: n("medic-web-framework.yes"),
        rejectLabel: n("medic-web-framework.no"),
        accept: async () => {
          await b.saveProject(), await Ee();
        },
        reject: () => {
          console.log("User chose not to save the project before report generation.");
        }
      }) : await Ee();
    }, Y = async (ne) => {
      let te = !1;
      const Ie = async () => {
        const Ee = await b.getModalsInstance().showTextInputModal(n("shared.export"), "Exports", "Enter export file name:");
        let xe = !0;
        if (Ee) {
          const Qe = () => {
            te = !0, b.hideLoading();
          };
          b.showLoading(n("shared.exporting"), !1, void 0, void 0, !0, Qe);
          try {
            if (b.fileHash) {
              const Ke = await l.triggerExportJob(b.fileHash, ne, xe, Ee);
              if (te) {
                i.value = await s.getNumberOfExportsTokens();
                return;
              }
              if (Ke.status !== Ja.OK) {
                Vn(Ke.data, "Error exporting data");
                return;
              }
              const qe = Ke.data.data;
              let rt = !1;
              for (; !rt && !te; ) {
                const P = await l.getJobStatusUuid(qe);
                if (te)
                  break;
                if (P.status === Ja.OK && P.data.some((F) => F.status === "COMPLETED")) {
                  rt = !0, lo(n("implant-planner.exportCompletedMessage"), n("implant-planner.exportCompletedTitle"));
                  break;
                }
                await new Promise((F) => setTimeout(F, 3e3));
              }
              if (te) {
                console.warn("Export canceled by user."), i.value = await s.getNumberOfExportsTokens();
                return;
              }
              if (rt && b.projectInfo && b.projectHash) {
                if (te) {
                  i.value = await s.getNumberOfExportsTokens();
                  return;
                }
                const { data: P } = await l.GetProjectByUUID(b.projectHash);
                if (P) {
                  const { data: F } = await l.getPatientFullById(P.id), de = ((F == null ? void 0 : F.files) ?? []).find((We) => We.name == `${qe}.zip`);
                  if (de) {
                    if (te) {
                      i.value = await s.getNumberOfExportsTokens();
                      return;
                    }
                    const We = await l.GetFileByUUID(de.uuid);
                    if (te) {
                      i.value = await s.getNumberOfExportsTokens();
                      return;
                    }
                    We.status == Ja.OK && j(We.data, Ee);
                  } else
                    Vn(Ke.data, n("implant-planner.errorFindingExportData"));
                }
              }
            }
          } catch (Ke) {
            Vn(Ke instanceof Error ? Ke.message : n("implant-planner.unknownExportError"), n("implant-planner.errorExportingData"));
          } finally {
            te || b.hideLoading();
          }
        }
        i.value = await s.getNumberOfExportsTokens(), await N();
      };
      b.shouldProjectBeSaved() ? o.require({
        message: n("implant-planner.saveBeforeExportPrompt"),
        header: n("implant-planner.saveProject"),
        icon: "pi pi-exclamation-triangle",
        acceptLabel: n("medic-web-framework.yes"),
        rejectLabel: n("medic-web-framework.no"),
        accept: async () => {
          await b.saveProject(), await Ie();
        },
        reject: () => {
          console.log("User chose not to save the project before export.");
        }
      }) : await Ie();
    }, pe = () => {
      Y(0);
    }, fe = () => {
      Y(1);
    }, le = () => {
      Y(2);
    }, Re = () => {
      Y(3);
    }, q = () => {
    }, he = () => {
      Y(4);
    };
    return (ne, te) => {
      const Ie = io;
      return L(), H(He, null, [
        d(Mo, {
          onHideWizard: te[0] || (te[0] = (Ee) => g("hideWizard"))
        }, {
          default: _(() => [
            vt(U(ne.$t("implant-planner.reportsExportData")), 1)
          ]),
          _: 1
        }),
        d(fl, null, {
          default: _(() => [
            r(f) ? (L(), be(r(ot), {
              key: 0,
              class: "gap-2"
            }, {
              default: _(() => [
                d(r(ke), null, {
                  default: _(() => [
                    d(Ie, null, {
                      default: _(() => [
                        vt(U(ne.$t("implant-planner.report")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ne), {
                      label: ne.$t("implant-planner.implantReport"),
                      class: Ge("w-full web-rg-icon-btn"),
                      onClick: Se
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ne), {
                      label: ne.$t("implant-planner.drillReport"),
                      class: Ge("w-full web-rg-icon-btn"),
                      onClick: se
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : ue("", !0),
            d(r(ot), { class: "gap-2" }, {
              default: _(() => [
                d(r(ke), null, {
                  default: _(() => [
                    d(Ie, null, {
                      default: _(() => [
                        vt(U(r(T)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(r(Ne), {
                      label: ne.$t("implant-planner.exportAnatomy"),
                      class: Ge("w-full web-rg-icon-btn"),
                      onClick: pe
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }),
                r(v) ? (L(), be(r(ke), { key: 0 }, {
                  default: _(() => [
                    d(r(Ne), {
                      label: ne.$t("implant-planner.exportGuideAndModel"),
                      class: Ge("w-full web-rg-icon-btn"),
                      disabled: !r(A),
                      onClick: fe
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                })) : ue("", !0),
                r(v) ? (L(), be(r(ke), { key: 1 }, {
                  default: _(() => [
                    d(r(Ne), {
                      label: ne.$t("implant-planner.exportGuideForMilling"),
                      class: Ge("w-full web-rg-icon-btn"),
                      disabled: !r(A),
                      onClick: le
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                })) : ue("", !0),
                r(w) ? (L(), be(r(ke), { key: 2 }, {
                  default: _(() => [
                    d(r(Ne), {
                      label: ne.$t("implant-planner.exportForCadcam"),
                      class: Ge("w-full web-rg-icon-btn"),
                      onClick: Re
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })) : ue("", !0),
                y("template", oR, [
                  d(r(ke), null, {
                    default: _(() => [
                      d(r(Ne), {
                        label: ne.$t("implant-planner.exportToMininavident"),
                        class: Ge("w-full web-rg-icon-btn"),
                        onClick: q
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  })
                ]),
                r(v) ? (L(), be(r(ke), { key: 3 }, {
                  default: _(() => [
                    d(r(Ne), {
                      label: ne.$t("implant-planner.exportAll"),
                      class: Ge("w-full web-rg-icon-btn"),
                      disabled: !r(A),
                      onClick: he
                    }, null, 8, ["label", "disabled"])
                  ]),
                  _: 1
                })) : ue("", !0)
              ]),
              _: 1
            }),
            d(r(ot), { class: "gap-2" }, {
              default: _(() => [
                d(r(ke), null, {
                  default: _(() => [
                    d(Ie, null, {
                      default: _(() => [
                        vt(U(ne.$t("implant-planner.existingReports")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    y("div", lR, [
                      y("div", iR, [
                        y("span", null, U(ne.$t("implant-planner.fileNameColumn")), 1),
                        y("span", null, U(ne.$t("implant-planner.createdDateColumn")), 1),
                        te[1] || (te[1] = y("span", null, null, -1))
                      ]),
                      y("div", sR, [
                        r(u) ? (L(), H("div", rR, U(ne.$t("shared.loading")), 1)) : r(c).length ? (L(!0), H(He, { key: 2 }, jt(r(c), (Ee) => (L(), H("div", {
                          key: Ee.fileUuid,
                          style: { display: "grid", "grid-template-columns": "minmax(0, 3fr) minmax(0, 2fr) 32px", gap: "6px", "align-items": "center", padding: "8px 12px", "border-bottom": "1px solid var(--surface-border, #ededed)" }
                        }, [
                          y("span", {
                            class: "text-xs",
                            title: Ee.fileName,
                            style: { overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
                          }, U(Ee.fileName), 9, cR),
                          y("span", dR, U(Ee.createdDateLabel), 1),
                          d(r(Ne), {
                            "aria-label": ne.$t("shared.download"),
                            icon: r(h) === Ee.fileUuid ? "pi pi-spinner pi-spin" : "pi pi-download",
                            disabled: r(h) === Ee.fileUuid,
                            style: { width: "32px", "min-width": "32px", height: "32px", padding: "0" },
                            onClick: (xe) => G(Ee)
                          }, null, 8, ["aria-label", "icon", "disabled", "onClick"])
                        ]))), 128)) : (L(), H("div", uR, U(ne.$t("implant-planner.noExistingReports")), 1))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    d(Ie, null, {
                      default: _(() => [
                        vt(U(ne.$t("implant-planner.existingExports")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                d(r(ke), null, {
                  default: _(() => [
                    y("div", pR, [
                      y("div", mR, [
                        y("span", null, U(ne.$t("implant-planner.fileNameColumn")), 1),
                        y("span", null, U(ne.$t("implant-planner.createdDateColumn")), 1),
                        te[2] || (te[2] = y("span", null, null, -1))
                      ]),
                      y("div", fR, [
                        r(u) ? (L(), H("div", gR, U(ne.$t("shared.loading")), 1)) : r(p).length ? (L(!0), H(He, { key: 2 }, jt(r(p), (Ee) => (L(), H("div", {
                          key: Ee.fileUuid,
                          style: { display: "grid", "grid-template-columns": "minmax(0, 3fr) minmax(0, 2fr) 32px", gap: "6px", "align-items": "center", padding: "8px 12px", "border-bottom": "1px solid var(--surface-border, #ededed)" }
                        }, [
                          y("span", {
                            class: "text-xs",
                            title: Ee.fileName,
                            style: { overflow: "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
                          }, U(Ee.fileName), 9, bR),
                          y("span", vR, U(Ee.createdDateLabel), 1),
                          d(r(Ne), {
                            "aria-label": ne.$t("shared.download"),
                            icon: r(h) === Ee.fileUuid ? "pi pi-spinner pi-spin" : "pi pi-download",
                            disabled: r(h) === Ee.fileUuid,
                            style: { width: "32px", "min-width": "32px", height: "32px", padding: "0" },
                            onClick: (xe) => G(Ee)
                          }, null, 8, ["aria-label", "icon", "disabled", "onClick"])
                        ]))), 128)) : (L(), H("div", hR, U(ne.$t("implant-planner.noExistingExports")), 1))
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), _R = "webcad-ip-autosave", Hd = 1, Oa = "snapshots", Da = "latest", wR = 1440 * 60 * 1e3;
function Os(e) {
  const t = Object.entries(e).filter(([, o]) => !!o), n = t.map(([o]) => o), a = t.reduce((o, [, l]) => o + ((l == null ? void 0 : l.byteLength) ?? 0), 0);
  return {
    count: t.length,
    names: n,
    bytes: a
  };
}
function IR() {
  return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
function yi() {
  return typeof indexedDB < "u";
}
function Ds() {
  return new Promise((e, t) => {
    if (!yi()) {
      Ye.debug("[Autosave] IndexedDB not available"), t(new Error("IndexedDB is not available"));
      return;
    }
    const n = indexedDB.open(_R, Hd);
    n.onupgradeneeded = () => {
      const a = n.result;
      if (Ye.debug("[Autosave] Upgrading DB schema", { version: Hd }), !a.objectStoreNames.contains(Oa)) {
        const o = a.createObjectStore(Oa, { keyPath: "id" });
        o.createIndex("projectKey", "projectKey", { unique: !1 }), o.createIndex("expiresAt", "expiresAt", { unique: !1 });
      }
      a.objectStoreNames.contains(Da) || a.createObjectStore(Da, { keyPath: "projectKey" });
    }, n.onsuccess = () => {
      Ye.debug("[Autosave] DB opened"), e(n.result);
    }, n.onerror = () => t(n.error ?? new Error("Failed to open IndexedDB"));
  });
}
function Bu(e) {
  return new Promise((t, n) => {
    e.oncomplete = () => t(), e.onabort = () => n(e.error ?? new Error("IndexedDB transaction aborted")), e.onerror = () => n(e.error ?? new Error("IndexedDB transaction failed"));
  });
}
function ri(e) {
  return new Promise((t, n) => {
    e.onsuccess = () => t(e.result), e.onerror = () => n(e.error ?? new Error("IndexedDB request failed"));
  });
}
function Uu(e, t) {
  const a = e.index("projectKey").getAll(t);
  return ri(a);
}
function Yd(e) {
  return e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength);
}
function SR(e) {
  const t = {}, n = e.getFS(), a = ["ipts", "bs", "ts", "m", "sg"];
  for (const l of a) {
    const s = Ui(e, l, "pr"), i = Ui(e, l, "bd"), u = Gi(n.FS, s), c = Gi(n.FS, i);
    if (!u || !c || !u.size || !c.size)
      continue;
    const p = n.FS.readFile(`${e.projectName}.${l}pr`), h = n.FS.readFile(`${e.projectName}.${l}bd`);
    t[`${l}pr`] = Yd(p), t[`${l}bd`] = Yd(h);
  }
  const o = Os(t);
  return Ye.debug("[Autosave] Collected CAD parts", {
    projectName: e.projectName,
    partCount: o.count,
    partNames: o.names,
    totalBytes: o.bytes
  }), t;
}
function Kd(e, t) {
  const n = t || e.projectFileUuid || "", a = `${e.patientName}::${e.projectFilename}::${n}`;
  return Ye.debug("[Autosave] Computed project key", {
    patientName: e.patientName,
    projectFilename: e.projectFilename,
    fileHash: n,
    key: a
  }), a;
}
async function ER(e, t) {
  Ye.debug("[Autosave] Building payload", {
    projectName: e.projectName,
    hasLoadedPr: !!t.pr,
    hasLoadedStlInfo: !!t.stlInfo,
    hasLoadedMobile: !!t.mobile
  });
  const n = await Ff(e, t, !1);
  if (!n)
    return Ye.debug("[Autosave] Payload build returned null"), null;
  const a = {
    pr: structuredClone(n.pr),
    stlInfo: n.stlInfo ? structuredClone(n.stlInfo) : void 0,
    mobile: n.mobile ? structuredClone(n.mobile) : void 0,
    erpFile: n.erpFile ? structuredClone(n.erpFile) : void 0,
    cadParts: SR(e)
  }, o = Os(a.cadParts);
  return Ye.debug("[Autosave] Payload built", {
    projectName: e.projectName,
    hasPr: !!a.pr,
    hasStlInfo: !!a.stlInfo,
    hasMobile: !!a.mobile,
    hasErp: !!a.erpFile,
    cadPartCount: o.count,
    cadPartNames: o.names,
    cadTotalBytes: o.bytes
  }), a;
}
async function Gu(e = Date.now()) {
  if (!yi()) {
    Ye.debug("[Autosave] Skipping purge - IndexedDB unavailable");
    return;
  }
  Ye.debug("[Autosave] Purge expired snapshots start", { nowTs: e });
  const t = await Ds();
  try {
    const n = t.transaction([Oa, Da], "readwrite"), a = n.objectStore(Oa), o = n.objectStore(Da), l = await ri(a.getAll());
    let s = 0;
    for (const i of l)
      if (i.expiresAt <= e) {
        a.delete(i.id), s += 1;
        const u = await ri(o.get(i.projectKey));
        (u == null ? void 0 : u.snapshotId) === i.id && o.delete(i.projectKey);
      }
    await Bu(n), Ye.debug("[Autosave] Purge expired snapshots done", {
      scanned: l.length,
      removed: s
    });
  } finally {
    t.close();
  }
}
async function TR(e, t, n) {
  if (!yi()) {
    Ye.debug("[Autosave] Skipping save - IndexedDB unavailable", { projectKey: e });
    return;
  }
  const a = Os(t.cadParts);
  Ye.debug("[Autosave] Save snapshot start", {
    projectKey: e,
    fileHash: n,
    hasPr: !!t.pr,
    hasStlInfo: !!t.stlInfo,
    hasMobile: !!t.mobile,
    hasErp: !!t.erpFile,
    cadPartCount: a.count,
    cadPartNames: a.names,
    cadTotalBytes: a.bytes
  }), await Gu();
  const o = await Ds();
  try {
    const l = Date.now(), s = {
      id: IR(),
      projectKey: e,
      fileHash: n,
      createdAt: new Date(l).toISOString(),
      expiresAt: l + wR,
      status: "ready",
      payload: t
    }, i = o.transaction([Oa, Da], "readwrite"), u = i.objectStore(Oa), c = i.objectStore(Da), p = await Uu(u, e);
    for (const h of p)
      u.delete(h.id);
    Ye.debug("[Autosave] Replacing previous snapshots", {
      projectKey: e,
      removed: p.length
    }), u.put(s), c.put({
      projectKey: e,
      snapshotId: s.id,
      createdAt: s.createdAt
    }), await Bu(i), Ye.debug("[Autosave] Save snapshot success", {
      projectKey: e,
      snapshotId: s.id,
      createdAt: s.createdAt,
      expiresAt: s.expiresAt
    });
  } finally {
    o.close();
  }
}
async function CR(e) {
  if (!yi())
    return Ye.debug("[Autosave] Skipping read - IndexedDB unavailable", { projectKey: e }), null;
  Ye.debug("[Autosave] Read latest snapshot start", { projectKey: e }), await Gu();
  const t = await Ds();
  try {
    const n = t.transaction([Oa, Da], "readonly"), a = n.objectStore(Oa), o = n.objectStore(Da), l = await ri(o.get(e));
    let s = null;
    if (l != null && l.snapshotId && (s = await ri(a.get(l.snapshotId))), !s) {
      const i = await Uu(a, e);
      i.length && (i.sort((u, c) => c.expiresAt - u.expiresAt), s = i[0]);
    }
    if (s) {
      const i = Os(s.payload.cadParts);
      Ye.debug("[Autosave] Read latest snapshot hit", {
        projectKey: e,
        snapshotId: s.id,
        createdAt: s.createdAt,
        expiresAt: s.expiresAt,
        hasPr: !!s.payload.pr,
        hasStlInfo: !!s.payload.stlInfo,
        hasMobile: !!s.payload.mobile,
        hasErp: !!s.payload.erpFile,
        cadPartCount: i.count,
        cadPartNames: i.names,
        cadTotalBytes: i.bytes
      });
    } else
      Ye.debug("[Autosave] Read latest snapshot miss", { projectKey: e });
    return s;
  } catch (n) {
    return Ye.warn("Failed to read autosave snapshot", n), null;
  } finally {
    t.close();
  }
}
async function ir(e) {
  if (!yi()) {
    Ye.debug("[Autosave] Skipping delete - IndexedDB unavailable", { projectKey: e });
    return;
  }
  Ye.debug("[Autosave] Delete snapshots start", { projectKey: e });
  const t = await Ds();
  try {
    const n = t.transaction([Oa, Da], "readwrite"), a = n.objectStore(Oa), o = n.objectStore(Da), l = await Uu(a, e);
    for (const s of l)
      a.delete(s.id);
    o.delete(e), await Bu(n), Ye.debug("[Autosave] Delete snapshots done", {
      projectKey: e,
      removed: l.length
    });
  } finally {
    t.close();
  }
}
const NR = {
  class: "flex flex-col",
  style: {
    borderRadius: "16px",
    padding: "2rem",
    background: "rgba(69,93,130,0.85)",
    width: "clamp(20rem, 30vw, 42rem)",
    maxWidth: "90vw"
  }
}, LR = { style: {
  textAlign: "center",
  color: "white",
  textShadow: "0 1px 1px black",
  overflowWrap: "anywhere",
  wordBreak: "break-word"
} }, OR = {
  class: "mt-8",
  style: { width: "100%" }
}, DR = {
  key: 0,
  class: "mt-6 flex justify-center"
}, AR = { style: { display: "flex", "justify-content": "center" } }, RR = { class: "ml-1 mb-3 mt-3 flex justify-center" }, MR = { class: "col-span-12" }, PR = {
  class: "ml-1 mb-3 mt-3 flex justify-start",
  style: { "white-space": "pre-wrap" }
}, xR = { class: "col-span-12" }, jR = {
  key: 0,
  class: "flex flex-col gap-3"
}, $R = {
  class: "m-0",
  style: { "white-space": "pre-wrap" }
}, FR = { style: { padding: "0.75rem", "border-radius": "0.5rem", background: "rgba(0, 0, 0, 0.08)" } }, kR = { style: { display: "flex", "flex-direction": "column", gap: "0.35rem" } }, VR = { style: { "font-weight": "600" } }, BR = { style: { display: "flex", gap: "0.5rem", "align-items": "center" } }, UR = { style: { display: "flex", gap: "0.5rem", "align-items": "center" } }, GR = {
  key: 0,
  style: { display: "flex", gap: "0.5rem", "align-items": "center" }
}, WR = {
  key: 1,
  style: { display: "flex", gap: "0.5rem", "align-items": "center" }
}, zR = {
  key: 2,
  style: { display: "flex", "flex-direction": "column", gap: "0.35rem" }
}, HR = { style: { display: "flex", gap: "0.5rem", "align-items": "center" } }, YR = { style: { "max-height": "9rem", "overflow-y": "auto", "padding-left": "1.25rem", "border-left": "1px solid rgba(0, 0, 0, 0.15)" } }, KR = ["disabled", "value"], ZR = {
  key: 3,
  style: { display: "flex", "flex-direction": "column", gap: "0.35rem" }
}, XR = { style: { display: "flex", gap: "0.5rem", "align-items": "center" } }, JR = { style: { "max-height": "9rem", "overflow-y": "auto", "padding-left": "1.25rem", "border-left": "1px solid rgba(0, 0, 0, 0.15)" } }, qR = ["disabled", "value"], QR = {
  key: 0,
  id: "sidebarContainer",
  class: "flex flex-row"
}, eM = { class: "mainMenuTabs" }, tM = {
  class: "h-full web-rg-wizard",
  style: { margin: "0 0.5rem" }
}, nM = /* @__PURE__ */ Je({
  __name: "IPProjectLoaderViewRedesign",
  props: {
    loader: {},
    source: { default: tl.IMPLANT_PLANNER },
    readOnly: { type: Boolean, default: !1 }
  },
  setup(e) {
    const { t } = Ht(), n = Ao(), a = window, o = e, l = ia(), s = o.loader(l), i = Aa(), u = sa(), c = as(), p = B(c.getUser().username), h = B(c.getUser().license), g = c.getSessionLicence(), b = c.getUser(), E = ui();
    Ye.log("License", g);
    let m = new cs(u.getAssetUrl(""), g);
    m.user = b;
    const I = () => {
      v.value = !1;
    }, S = B(), f = B(), v = B(!0), w = B(!1), A = B(!0), T = B(!1), O = B(0), C = B(!1), k = B(!1), M = B(Math.random()), z = B(!0), j = B(!1), K = B(!1), x = B(0), N = B(), G = B(t("shared.loadingProject")), ce = pl(), re = Do(), Se = oa(), { wizardLayouts: se } = So(oa()), Le = ms(), Y = qr.actions, pe = Ra();
    B(xn.REALGUIDE), B(!0);
    const fe = B(o.source == tl.IMPLANT_PLANNER ? wt.ImplantPlannerBase : wt.WeblinkViewer), le = B(o.readOnly), Re = ap(), q = Ce(() => fe.value === wt.WeblinkViewer && le.value ? 116 : Re.rgScreenType === "lg" ? 110 : 70);
    ds(m);
    const he = Ce(() => w.value && !k.value ? "rgba(91, 91, 91, 0.5)" : "linear-gradient(to top, rgb(40, 106, 173) 1%, rgb(11, 14, 26) 105%)"), ne = () => {
      const oe = m.undoManager.getUndoDescription(), Me = m.undoManager.getRedoDescription(), dt = oe ? `Undo ${oe}` : void 0, Lt = Me ? `Redo ${Me}` : void 0;
      let kt = [], Xe = [];
      m.undoManager.canUndo() ? kt.push(_e.UNDO) : Xe.push(_e.UNDO), m.undoManager.canRedo() ? kt.push(_e.REDO) : Xe.push(_e.REDO), n.disableNavbarButtons(Xe), n.enableNavbarButtons(kt);
      const Ft = [
        { button: _e.UNDO, tooltip: dt },
        { button: _e.REDO, tooltip: Lt }
      ];
      n.addTooltips(Ft);
    }, te = B(!1), Ie = () => {
      te.value = !1;
    }, Ee = B(!1), xe = B(!1), Qe = Ls(), Ke = () => {
      if (j.value) {
        const oe = m.contextCAD.getLayout();
        Fo(oe);
      }
      Qe.stlLibraryWindowVisible ? xe.value = !0 : Ee.value = !0;
    }, qe = B(!1), rt = B(!1), P = B(!1), F = B("");
    let me = null;
    const de = B("");
    let We = null, Q = !1;
    const ie = typeof a.isIOS == "function" && a.isIOS(), W = B(!1);
    let ee = null;
    const $ = B(null), R = B("decimated"), D = B(!0), V = B(!0), Z = B(!0), X = B(!1), Ae = B([]), De = B([]), at = (oe) => {
      R.value = oe.volumeQuality ?? "full", D.value = oe.includeImplants ?? !0, V.value = oe.includePins ?? !0, Z.value = oe.includeProjectStlObjects ?? !0, X.value = oe.includePatientStlObjects ?? !1, Ae.value = [...oe.includedProjectStlObjectNames ?? []], De.value = [...oe.includedPatientStlFilenames ?? []];
    }, Be = Ce(() => ({
      volumeQuality: R.value,
      includeImplants: D.value,
      includePins: V.value,
      includeProjectStlObjects: Z.value && Ae.value.length > 0,
      includePatientStlObjects: X.value && De.value.length > 0,
      includedProjectStlObjectNames: [...Ae.value],
      includedPatientStlFilenames: [...De.value]
    })), ze = Ce(() => $.value ? s.estimateProjectLoadMemory($.value, Be.value) : 0), ct = Ce(() => $.value ? $.value.budgetMemoryBytes - ze.value : 0), ht = Ce(() => ct.value >= 0), mt = (oe) => Fg(Math.max(0, Math.round(oe))), Bt = (oe) => ($.value = oe, at(s.buildDefaultProjectLoadSelection(oe)), W.value = !0, new Promise((Me) => {
      ee = Me;
    })), Nt = (oe) => {
      W.value = !1, ee && (ee(oe), ee = null);
    }, Tt = () => {
      Nt(Be.value);
    }, Rt = () => {
      Nt(null);
    }, bn = () => {
      We !== null && (Ye.debug("[Autosave] Clearing interval", { intervalId: We }), window.clearInterval(We), We = null);
    }, Te = async () => {
      if (le.value || Q || !w.value || !de.value) {
        Ye.debug("[Autosave] Skipping tick", {
          reason: "guard",
          readOnly: le.value,
          autosaveInFlight: Q,
          loaded: w.value,
          hasProjectKey: !!de.value
        });
        return;
      }
      if (!m.shouldProjectBeSaved()) {
        Ye.debug("[Autosave] Skipping tick", {
          reason: "project-not-dirty",
          projectKey: de.value
        });
        return;
      }
      const oe = s.getLoadedProjectData();
      if (!oe) {
        Ye.debug("[Autosave] Skipping tick", {
          reason: "missing-loaded-project-data",
          projectKey: de.value
        });
        return;
      }
      Q = !0;
      try {
        Ye.debug("[Autosave] Tick start", {
          projectKey: de.value,
          projectName: m.projectName,
          fileHash: m.fileHash
        });
        const Me = await ER(m, oe);
        if (!Me) {
          Ye.debug("[Autosave] Tick aborted - payload was null", {
            projectKey: de.value
          });
          return;
        }
        const dt = typeof m.fileHash == "string" ? m.fileHash : void 0;
        await TR(de.value, Me, dt), Ye.debug("[Autosave] Tick completed", {
          projectKey: de.value,
          fileHash: dt
        });
      } catch (Me) {
        Ye.warn("Autosave failed", Me);
      } finally {
        Q = !1;
      }
    }, J = () => {
      if (Ye.debug("[Autosave] Restart interval requested", {
        readOnly: le.value,
        projectKey: de.value,
        intervalMinutes: m.settings.general.autosaveIntervalMinutes
      }), bn(), le.value || !de.value) {
        Ye.debug("[Autosave] Interval not started", {
          reason: "guard",
          readOnly: le.value,
          hasProjectKey: !!de.value
        });
        return;
      }
      const oe = m.settings.general.autosaveIntervalMinutes;
      if (!Number.isFinite(oe) || oe <= 0) {
        Ye.debug("[Autosave] Interval not started", {
          reason: "invalid-minutes",
          minutes: oe
        });
        return;
      }
      We = window.setInterval(
        () => {
          Te();
        },
        oe * 60 * 1e3
      ), Ye.debug("[Autosave] Interval started", {
        intervalId: We,
        minutes: oe,
        projectKey: de.value
      });
    }, Pe = () => {
      document.visibilityState === "hidden" && (Ye.debug("[Autosave] visibilitychange -> hidden, running best-effort autosave", {
        projectKey: de.value
      }), Te());
    }, Ze = () => {
      Ye.debug("[Autosave] pagehide, running best-effort autosave", {
        projectKey: de.value
      }), Te();
    }, st = (oe) => {
      const Me = m.shouldProjectBeSaved(), dt = !le.value && w.value && Me;
      Ye.debug("[Autosave] beforeunload fired", {
        projectKey: de.value,
        readOnly: le.value,
        loaded: w.value,
        dirty: Me,
        shouldPrompt: dt
      }), dt && (oe.preventDefault(), oe.returnValue = "", Ye.debug("[Autosave] beforeunload blocked because project has unsaved changes", {
        projectKey: de.value,
        projectName: m.projectName,
        fileHash: m.fileHash
      }));
    }, ae = (oe) => new Promise((Me) => {
      me && me(), me = Me, F.value = oe, P.value = !0;
    });
    Se.prepareDefaults(Fu());
    const ve = B(m.layoutManager.wizardTabIndex.get()), { menuMode: ut } = So(oa()), yt = Ce(() => ut.value === hn.HORIZONTAL && w.value), Ut = Ce(() => !le.value || !Re.isMobileView), _t = Ce(() => ({
      "bg-top-nav-bar-wiz bg-body-wiz": !0
    })), On = Ce(() => ({
      "card-no-bottom-padding no-radius bg-body-wiz h-full flex flex-col": !0,
      "wizard-vertical-menu-margin": fe.value !== wt.WeblinkViewer && !yt.value
    })), Gt = [];
    Ye.log("Version type:", g == null ? void 0 : g.versionType);
    let _i = !1, zu = !1, Hu = !1;
    g && g.versionType & ho.NORMAL && (_i = !0), g && g.versionType & ho.PRO && (zu = !0), g && g.versionType & ho.START && (Hu = !0), Gt.push(
      {
        type: ye.VOI_SETTINGS,
        tabLabel: t("implant-planner.voiSettings"),
        component: fu,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.THREED_SETTINGS,
        tabLabel: t("implant-planner.threedSettings"),
        component: gu,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.DATA_IMPORT,
        tabLabel: t("implant-planner.dataImport"),
        component: hu,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.CPR_SETTINGS,
        tabLabel: t("implant-planner.cprSettings"),
        component: bu,
        defaultLayout: Fe._CPR_SETTINGS_WIZARD
      },
      {
        type: ye.NERVE_DRAWING,
        tabLabel: t("implant-planner.nerveSettings"),
        component: yu,
        defaultLayout: Fe._NERVE_DRAWING_WIZARD
      },
      {
        type: ye.TEETH_SETUP,
        tabLabel: t("implant-planner.teethSetup"),
        component: Vu,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.IMPLANT_PLANNING,
        tabLabel: t("implant-planner.implantPlanning"),
        component: Du,
        defaultLayout: Fe._3D_CPR_CROSS_TANGENT_AXIAL
      }
    ), (_i || zu) && Gt.push({
      type: ye.REPORTS_EXPORT,
      tabLabel: t("implant-planner.reportsExport"),
      component: yR,
      defaultLayout: Fe._FULLSCREEN_3D
    }), _i && Gt.push(
      {
        type: ye.CAD_DESIGN,
        tabLabel: t("implant-planner.design"),
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.GUIDE_DESIGN,
        tabLabel: t("implant-planner.guideDesign"),
        component: z2,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.CREATE_MODEL,
        tabLabel: t("implant-planner.createModel"),
        component: W2,
        defaultLayout: Fe._FULLSCREEN_3D
      }
    ), bo.SHOW_CAD_WIZARD && Gt.push({
      type: ye.CAD,
      tabLabel: "Cad",
      component: Ru,
      defaultLayout: Fe._3D_CPR_CROSS_TANGENT_AXIAL
    });
    const uo = B(Gt.find((oe) => oe.type === ve.value));
    ie && (le.value = !0, m.readOnly = !0);
    let Yu;
    m.setModalsInstance(re), m.setResourceUrl("/resources/"), Yu = m.getEngineInstance();
    async function Kf(oe) {
      var Lt, kt, Xe;
      oe.setRootElement(S.value), oe.setCADRootElement(f.value), oe.createRendererWindow({ background: [0.16, 0.43, 0.7] }), (Lt = oe.getInteractorStyle()) == null || Lt.setCameraInteractorEnabled(!0), (kt = oe.getInteractorStyle()) == null || kt.setMouseMode(oe.settings.general.useLeftButtonForRotationOn3d ? xn.REALGUIDE : xn.IMPLANTPLANNER), (Xe = oe.getInteractorStyle()) == null || Xe.setMouseMode2D(xn.REALGUIDE), se.value[ye.VOI_SETTINGS] !== void 0 && Se.setWizardLayout(ye.VOI_SETTINGS, Fe._FULLSCREEN_3D);
      for (const Ft of Object.keys(se.value))
        oe.layoutManager.storeLayout(Ft.toString(), se.value[Number(Ft)]);
      oe.layoutManager.constructAllWindows();
      const dt = oe.layoutManager.getLayout(ve.value.toString()) ?? oe.layoutManager.getDefaultLayout();
      oe.layoutManager.setLayout(dt), Fo(dt);
    }
    const Ku = (oe) => {
      if (j.value) {
        m.contextCAD.setLayout(oe), Fo(oe);
        return;
      }
      Qe.stlLibraryWindowVisible ? (m.layoutManager.storeLayout("StlLibrary", oe), m.layoutManager.setLayout(oe)) : (m.layoutManager.storeLayout(ve.value.toString(), oe), m.layoutManager.setLayout(oe), Fo(oe), Se.setWizardLayout(ve.value, oe));
    }, Zu = () => {
      n.enableNavbarButtons([_e.LAYOUT]);
    }, _l = () => {
      n.disableNavbarButtons([_e.LAYOUT]);
    }, Zf = () => {
      const oe = Gt.findIndex((Lt) => Lt.type === ve.value);
      if (oe === -1) {
        Ye.warn("current wizard not found");
        return;
      }
      if (oe === Gt.length - 1) {
        Ye.warn("nextStep called on last wizard");
        return;
      }
      let Me = 0;
      oe == ye.CPR_SETTINGS && m.CPRType !== nn.MANDIBLE && (Me = 1);
      const dt = Gt[oe + 1 + Me].type;
      m.layoutManager.wizardTabIndex.set(dt), ve.value = dt, Xa();
    }, Xf = () => {
      const oe = Gt.findIndex((Lt) => Lt.type === ve.value);
      if (oe === -1) {
        Ye.warn("current wizard not found");
        return;
      }
      if (oe === 0) {
        Ye.warn("previousStep called on first wizard");
        return;
      }
      let Me = 0;
      oe == 5 && m.CPRType !== nn.MANDIBLE && (Me = 1);
      const dt = Gt[oe - 1 - Me].type;
      m.layoutManager.wizardTabIndex.set(dt), ve.value = dt, Xa();
    };
    pe.onEvent(m.warningDialogEvent, (oe) => {
      ae(oe);
    }), pe.onEvent(m.screenshotUploadEvent, async ({ filename: oe, image: Me }) => {
      var Lt, kt, Xe;
      const dt = (Xe = (kt = (Lt = m.patientInfo) == null ? void 0 : Lt.extra) == null ? void 0 : kt.extra) == null ? void 0 : Xe.study_instance_UID;
      if (dt)
        try {
          await s.uploadScreenshot(dt, oe, Ta.Image, Me), lo(t("weblink.successfullyUploadedScreenshot"));
        } catch (Ft) {
          Vn(Ft, t("web-rg.uploadFailed"));
        }
    }), lt(P, (oe) => {
      if (!oe && me) {
        const Me = me;
        me = null, Me();
      }
    }), pe.watch(m.layoutBtnVisible, (oe) => {
      oe ? Zu() : _l();
    }), pe.watch(m.loadingFlag, (oe) => {
      A.value = oe, G.value = m.loadingText, T.value = m.progressBarFlag, O.value = m.progressBarValue.get(), k.value = m.nonTransparentLoading.get();
    }), pe.watch(m.loadingCancelVisible, (oe) => {
      C.value = oe;
    }), pe.watch(m.wizardPanelFreeze, (oe) => {
      K.value = oe;
    }), pe.watch(m.nextPrevVisible, (oe) => {
      z.value = oe, Ye.debug("Setting nextprevFlag to:", oe);
    }), pe.watch(m.cadMode, (oe) => {
      j.value = oe, x.value = oe ? 1 : 0, n.setCadMode(j.value), Ye.debug("Setting cadMode to:", oe);
    }), pe.watch(m.progressBarValue, (oe) => {
      O.value = oe;
    }), pe.watch(m.layoutManager.wizardTabIndex, () => {
      ve.value = m.layoutManager.wizardTabIndex.get(), Xa();
    });
    const co = B(!0);
    pe.watch(m.tabButtonsEnabled, (oe) => {
      co.value = oe, Ye.debug("TabButtonsEnabled", co.value);
    });
    const Jf = () => {
      const oe = m.loadingCancelHandler;
      oe ? (G.value = "Canceling ...", T.value = !1, oe()) : m.hideLoading();
    };
    pe.onEvent(m.saveProjectEvent, () => {
      wl(!0, () => m.completeSaveProject());
    }), pe.onEvent(m.settings.onSettingsModified, () => {
      Ye.debug("[Autosave] Settings modified", {
        autosaveIntervalMinutes: m.settings.general.autosaveIntervalMinutes
      }), J();
    });
    let Xu = 0;
    lt(ve, (oe) => {
      if (Xu = m.layoutManager.wizardTabIndex.get(), ve.value === ye.CAD_DESIGN) {
        i.open(aR, {
          props: {
            closable: !1,
            showHeader: !1,
            modal: !0,
            contentStyle: {
              borderRadius: "16px",
              padding: "0 1.5rem",
              overflow: "hidden"
            }
          },
          data: {
            headerText: t("implant-planner.selectDesign"),
            preselectedMode: ma.eDESIGN
          },
          emits: {
            onSelected: (Lt) => {
              ve.value = Lt, Xa();
            },
            onClose: () => {
              ve.value = Xu;
            }
          }
        });
        return;
      }
      m.toolManager.activeTool.WindowLevel.set(!1), wu(), m.layoutManager.wizardTabIndex.set(oe);
      let Me = m.layoutManager.getLayout(oe.toString()) ?? m.layoutManager.getDefaultLayout();
      if (Zu(), $o(), ve.value === ye.DATA_IMPORT && (m.layoutManager.storeLayout(ye.DATA_IMPORT.toString(), Fe._FULLSCREEN_3D), Me = m.layoutManager.getLayout(oe.toString()) ?? m.layoutManager.getDefaultLayout(), _l()), ve.value == ye.CPR_SETTINGS && (m.layoutManager.storeLayout(ye.CPR_SETTINGS.toString(), Fe._CPR_SETTINGS_WIZARD), Me = m.layoutManager.getLayout(oe.toString()) ?? m.layoutManager.getDefaultLayout(), _l()), ve.value == ye.NERVE_DRAWING && (m.objects.hasCPR() || (rt.value = !0), m.layoutManager.storeLayout(ye.NERVE_DRAWING.toString(), Fe._NERVE_DRAWING_WIZARD), Me = m.layoutManager.getLayout(oe.toString()) ?? m.layoutManager.getDefaultLayout(), _l()), ve.value == ye.IMPLANT_PLANNING && !m.objects.hasCPR() && !le.value && (rt.value = !0), ve.value == ye.GUIDE_DESIGN && (m.layoutManager.storeLayout(ye.GUIDE_DESIGN.toString(), Fe._FULLSCREEN_3D), Me = m.layoutManager.getLayout(oe.toString()) ?? m.layoutManager.getDefaultLayout(), _l()), ((Lt) => {
        switch (Ye.debug("setActiveTool wizard : ", Lt), Lt) {
          case ye.CPR_SETTINGS:
            m.toolManager.setTool(_n.CPR, rn.PRIMARY);
            break;
          case ye.NERVE_DRAWING:
            m.toolManager.setTool(_n.NERVE, rn.PRIMARY);
            break;
          case ye.DATA_IMPORT:
            m.toolManager.setTool(_n.MATCHING_TOOL, rn.PRIMARY);
            break;
          default:
            m.toolManager.setTool(_n.NONE, rn.PRIMARY);
        }
      })(ve.value), !(ve.value === ye.CPR_SETTINGS || ve.value === ye.NERVE_DRAWING)) {
        const Lt = m.layoutManager.layoutTemplateContainsCpr(Me);
        qe.value = m.objects.hasCPR(), Lt && !qe.value && (Me = Fe._3D_MPR);
      }
      m.layoutManager.setLayout(Me), m.resize(), m.resetOrientation(), Fo(Me), Se.updateSelectedWizardIndex(ve.value), $o();
    });
    const qf = () => {
      var Me, dt;
      if (j.value) {
        Ee.value = !1;
        return;
      }
      m.layoutManager.storeLayout(((Me = uo.value) == null ? void 0 : Me.type.toString()) ?? "", ((dt = uo.value) == null ? void 0 : dt.defaultLayout) ?? Fe._FULLSCREEN_3D);
      const oe = m.layoutManager.getLayout(ve.value.toString()) ?? m.layoutManager.getDefaultLayout();
      m.layoutManager.setLayout(oe), Ee.value = !1, Fo(oe);
    }, Qf = () => {
      const oe = m.layoutManager.getLayout("StlLibrary");
      oe !== void 0 && m.layoutManager.setLayout(oe), xe.value = !1;
    }, wi = B();
    pe.watch(m.projectFullName, () => {
      $o();
    });
    const $o = () => {
      N.value = m.projectFullName.get(), Ye.debug("showProjectName projectFullName.value: ", N.value), N.value && n.showProjectOnNavbar(N.value);
    };
    lt(w, () => {
      if (w.value) {
        const oe = ce.params.name === "default" || ce.params.name === "ids" ? "3Diemme" : void 0;
        n.showNavbar({
          buttons: Cu(le.value ? fe.value : wt.ImplantPlannerBase, le.value),
          showZimvieLogo: !1,
          showNavbarPosition: !0,
          isWizard: !0,
          username: p.value,
          showDoctors: !1,
          ...oe && { pcName: oe }
        });
      }
    }), Dt(async () => {
      var Xe;
      if (!bo.VENDOR_ID)
        try {
          const { data: Ft } = await l.getVendorInfo(), Fn = Ft == null ? void 0 : Ft.data;
          bo.VENDOR_ID = $g(Fn);
        } catch (Ft) {
          console.log("Error while getting vendor info:", Ft);
        }
      op(), n.showOnlyLogo(), $o(), m.undoManager.onUndoChange.subscribe(ne), ne(), m.toolManager.onUndoManagerChange.subscribe(ne), m.toolManager.onUndoManagerPop.subscribe(ne), fe.value === wt.WeblinkViewer && (le.value && ig(), sg()), Ye.debug("Engine JS - navigator.hardwareConcurrency", navigator.hardwareConcurrency);
      const oe = performance.now(), Me = await Yu;
      if (ps(Me), Ye.debug("engine await: ", performance.now() - oe), !await eg(ce.params)) return;
      await ((Xe = m.contextCAD) == null ? void 0 : Xe.LoadCADResources(l)), le.value ? (m.layoutManager.wizardTabIndex.set(ye.IMPLANT_PLANNING), ve.value = ye.IMPLANT_PLANNING) : ve.value = ye.VOI_SETTINGS, Xa(), m.objects.hasCPR() && m.objects.initializeCPRCurve(), m.objects.hasCPR() && (m.layoutManager.wizardTabIndex.set(ye.IMPLANT_PLANNING), ve.value = ye.IMPLANT_PLANNING, Xa()), ng(), $o(), ug(ec), le.value ? (m.readOnly = !0, m.objects.lockUnlockAllImplantPins(!0)) : Hu && m.objects.lockUnlockAllImplantPins(!0), m.objects.checkCollisions(void 0, void 0, !0), w.value = !0, A.value = !1;
      const Lt = m.getOverlayContainer(), kt = document.createElement("div");
      kt.id = "stlLibraryContainer", kt.style.position = "absolute", kt.style.pointerEvents = "none", kt.style.userSelect = "none", kt.style.inset = "0px", Lt.appendChild(kt), m.sceneRepaint(), setTimeout(() => {
        m.resetOrientation();
      }, 0), m.setModified(!1), le.value ? Ye.debug("[Autosave] Lifecycle listeners skipped for read-only project") : (J(), document.addEventListener("visibilitychange", Pe), window.addEventListener("pagehide", Ze), window.addEventListener("beforeunload", st), Ye.debug("[Autosave] Lifecycle listeners attached")), oc();
    }), Ln(() => {
      Ye.debug("[Autosave] View unmount start"), bn(), document.removeEventListener("visibilitychange", Pe), window.removeEventListener("pagehide", Ze), window.removeEventListener("beforeunload", st), Ye.debug("[Autosave] Lifecycle listeners removed"), me && (me(), me = null), ee && (ee(null), ee = null);
    });
    async function eg(oe) {
      Ye.debug("[Autosave] loadProject start", { routeParams: oe }), T.value = !0, O.value = 0, M.value = Math.random();
      const Me = await s.getProjectInfo(oe);
      if (!Me) {
        Ye.error("Project not found");
        return;
      }
      const dt = Me.project;
      dt.projectFilename && (m.projectName = dt.projectFilename.replaceAll(".zip", "")), m.patientInfo = Me.patientInfo, m.projectInfo = dt, m.projectHash = oe.projectHash;
      const Lt = oe.fileHash, kt = Array.isArray(Lt) ? Lt[0] : Lt;
      m.fileHash = kt, m.projectFullName.set(Me.projectFullName), le.value ? (de.value = "", Ye.debug("[Autosave] Disabled for read-only project", {
        projectName: dt.projectFilename,
        patientName: dt.patientName,
        fileHash: kt
      })) : (de.value = Kd(dt, kt), Ye.debug("[Autosave] Active project context set", {
        projectName: dt.projectFilename,
        patientName: dt.patientName,
        fileHash: kt,
        projectKey: de.value
      })), $o(), wi.value = dt.patientName;
      let Xe;
      if (ie) {
        const zn = async () => {
          const ua = A.value, ko = T.value;
          A.value = !1, T.value = !1, await re.showInfoModal(t("implant-planner.iOSLimitedModeTitle"), t("implant-planner.iOSLimitedModeMessage")), A.value = ua, T.value = ko, M.value = Math.random();
        };
        try {
          const ua = await s.getProjectLoadPreflight(dt);
          if (ua) {
            Xe = s.buildDefaultProjectLoadSelection(ua), A.value = !1, T.value = !1;
            const ko = await Bt(ua);
            if (!ko)
              return await Rs(), !1;
            Xe = ko, A.value = !0, T.value = !0, M.value = Math.random();
          } else
            await zn();
        } catch (ua) {
          Ye.warn("Failed to fetch iOS load preflight", ua), await zn();
        }
      }
      let Ft = null;
      if (le.value || !de.value)
        Ye.debug("[Autosave] Recovery disabled", {
          readOnly: le.value,
          hasProjectKey: !!de.value
        });
      else {
        await Gu();
        const zn = await CR(de.value);
        if (zn) {
          A.value = !1, T.value = !1, Ye.debug("[Autosave] Recovery candidate found, opening decision dialog", {
            projectKey: de.value,
            snapshotId: zn.id,
            createdAt: zn.createdAt
          });
          let ua = !1;
          Ft = await new Promise((ko) => {
            const Ps = () => {
              A.value = !0, T.value = !0, M.value = Math.random(), Ye.debug("[Autosave] Recovery selection made, restoring loading overlay", {
                projectKey: de.value
              });
            }, xs = (gg) => {
              ua || (ua = !0, ko(gg));
            };
            E.require({
              message: t("implant-planner.autosaveRecoveryPrompt"),
              header: t("implant-planner.autosaveRecoveryTitle"),
              icon: "pi pi-exclamation-triangle",
              acceptLabel: t("implant-planner.openAutosaved"),
              rejectLabel: t("implant-planner.openOriginal"),
              accept: () => {
                Ps(), Ye.debug("[Autosave] Recovery decision: open-autosaved", {
                  projectKey: de.value,
                  snapshotId: zn.id
                }), xs(zn.payload);
              },
              reject: () => {
                Ps(), Ye.debug("[Autosave] Recovery decision: open-original-and-delete-autosave", {
                  projectKey: de.value,
                  snapshotId: zn.id
                }), ir(de.value), xs(null);
              },
              onHide: () => {
                ua || (Ps(), Ye.debug("[Autosave] Recovery dialog closed without explicit action, defaulting to original and deleting autosave", {
                  projectKey: de.value,
                  snapshotId: zn.id
                }), ir(de.value), xs(null));
              }
            });
          });
        } else
          Ye.debug("[Autosave] No recovery snapshot found for project", {
            projectKey: de.value
          });
      }
      T.value = !0, O.value = 5, M.value = Math.random();
      const Fn = (zn) => {
        O.value = zn.loaded / zn.total * 100, M.value = Math.random();
      }, Ms = await s.loadProject(dt, m, Kf, Fn, Ft, Xe);
      return Ye.debug("[Autosave] loadProject finished", {
        projectKey: de.value,
        usedAutosavePayload: !!Ft,
        success: Ms.success
      }), Ms.success ? !0 : (m.warningString.set(Ms.error), m.hideLoading(), await ae("Warning"), await Rs(), !1);
    }
    const wl = (oe, Me) => {
      var Lt;
      m.objects.unSelectObject();
      const dt = s.getLoadedProjectData();
      fe.value === wt.WeblinkViewer && (oe = !0), m && dt && i.open($u, {
        props: {
          closable: !0,
          modal: !0,
          header: t("implant-planner.saveProject"),
          style: { width: "40vw" },
          contentStyle: {
            overflow: "hidden"
          }
        },
        data: {
          context: m,
          projectData: dt,
          isSaveAs: oe,
          projectLoader: s,
          implantPlannerViewMode: fe.value,
          onComplete: Me,
          onSuccess: async () => {
            var Ft;
            Ye.debug("[Autosave] Manual save success hook start", {
              previousProjectKey: de.value,
              projectName: m.projectName,
              fileHash: m.fileHash
            }), de.value && await ir(de.value);
            const kt = typeof m.fileHash == "string" ? m.fileHash : void 0, Xe = ((Ft = m.projectInfo) == null ? void 0 : Ft.patientName) ?? wi.value;
            de.value = Kd(
              {
                patientName: Xe,
                projectFilename: `${m.projectName}.zip`,
                projectFileUuid: kt
              },
              kt
            ), Ye.debug("[Autosave] Manual save success hook done", {
              newProjectKey: de.value,
              currentFileHash: kt
            }), J();
          },
          projectOwner: (Lt = m.projectInfo.owner) == null ? void 0 : Lt.username
        }
      });
    }, As = tt(il()), tg = tt(il()), Ju = r(ut);
    function ng() {
      fe.value === wt.WeblinkViewer && le.value ? _u() : ut.value === hn.HORIZONTAL ? rl() : sl();
    }
    Ha(() => {
      m && w.value && m.cleanup(), cg(ec), Ju === hn.HORIZONTAL && fe.value === wt.WeblinkViewer && le.value ? rl() : Ju === hn.SIDEBAR && fe.value === wt.WeblinkViewer && le.value && sl();
    });
    const Fo = (oe) => {
      As.oldLayout = oe, As.newLayout = oe;
    };
    function Xa() {
      const oe = Gt.find((Me) => Me.type === ve.value);
      oe && (uo.value = oe);
    }
    function ag() {
      var oe;
      if (ve.value === ye.DATA_IMPORT)
        return {
          patientName: wi.value
        };
      if (ve.value === ye.GUIDE_DESIGN)
        return {
          wizardsList: (oe = uo == null ? void 0 : uo.value) == null ? void 0 : oe.wizardsList
        };
      if (ve.value === ye.IMPLANT_PLANNING && le.value)
        return {
          isReadOnly: !0
        };
    }
    const og = Ce(() => ve.value === 0), qu = Ce(() => _i ? [ye.CAD_DESIGN, ye.GUIDE_DESIGN, ye.CREATE_MODEL].includes(ve.value) : ve.value === Gt[Gt.length - 1].type), Qu = () => {
      Xa();
    }, lg = () => {
      Ye.debug("IPProjectLoaderView.vue: doneFromSteps clicked");
    }, ig = () => {
      n.disableNavbarButtons([_e.UNDO, _e.REDO, _e.SAVE, _e.SAVE_AS, _e.RESET, _e.RULER, _e.SETTINGS]);
    };
    async function sg() {
      await dl().loadSTLLibrary();
    }
    lt(
      () => Se.colorScheme,
      () => {
        m.setColorScheme(Se.colorScheme);
      },
      {
        immediate: !0
      }
    );
    async function Rs() {
      await m.toolManager.destructAllTools(), m.cleanup(), fe.value === wt.WeblinkViewer ? window.close() : (lp(), await Le.push({ name: "Patients", params: { id: wi.value } }));
    }
    const ec = async (oe) => {
      if (oe === _e.SAVE)
        wl();
      else if (oe === _e.SAVE_AS) {
        if (!co.value) {
          m.warningString.set(t("implant-planner.exitWizardBeforeSaving")), F.value = t("implant-planner.warning"), P.value = !0;
          return;
        }
        fe.value === wt.WeblinkViewer ? wl(!1) : wl(!0);
      } else if (oe === _e.SETTINGS)
        te.value = !0;
      else if (oe === _e.RESET)
        m && (m.cadMode.get() ? m.contextCAD.GetMainForm().GetTopToolbar().resetView() : (m.resetOrientation(), m.sceneRepaint()));
      else if (oe === _e.LAYOUT)
        Ke();
      else if (oe === _e.SCREENSHOT) {
        const Me = await m.takeWindowScreenshotWebcad();
        if (Me) {
          const dt = /* @__PURE__ */ new Date(), Lt = (Fn) => String(Fn).padStart(2, "0"), kt = `${m.projectInfo.projectFilename.replace(".zip", "")}_${dt.getFullYear()}-${Lt(dt.getMonth() + 1)}-${Lt(dt.getDate())}_${Lt(dt.getHours())}.${Lt(dt.getMinutes())}.${Lt(dt.getSeconds())}.png`, Xe = Me.toDataURL();
          if (Xe) {
            const Fn = document.createElement("a");
            document.body.appendChild(Fn), Fn.href = Xe, Fn.download = kt, Fn.click(), window.URL.revokeObjectURL(Xe);
          }
          const Ft = await new Promise((Fn) => Me.toBlob(Fn, "image/png"));
          if (Ft)
            try {
              await s.uploadScreenshot(m.patientInfo.extra.extra.study_instance_UID, kt, Ta.Image, Ft), lo(t("weblink.successfullyUploadedScreenshot"));
            } catch (Fn) {
              Vn(Fn, t("web-rg.uploadFailed"));
            }
        }
      } else if (oe === _e.W_L) {
        if (m) {
          const Me = m.toolManager.activeTool.WindowLevel.get();
          m.toolManager.activeTool.WindowLevel.set(!Me), m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().toggleContrast(!Me);
        }
      } else if (oe === _e.HELP)
        await re.showViewerHelpModal();
      else if (oe === _e.INFO) {
        const Me = !m.getInfoFlag().get();
        m.setInfoFlag(Me), m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().toggleInfo(Me);
      } else if (oe === _e.UNDO)
        m.cadMode.get() ? m.contextCAD.GetMainForm().Undo() : await m.undoManager.undo();
      else if (oe === _e.REDO)
        m.cadMode.get() ? m.contextCAD.GetMainForm().Redo() : await m.undoManager.redo();
      else if (oe === _e.RULER_DISTANCE)
        m.cadMode.get() ? m.contextCAD.GetMainForm().GetTopToolbar().openRuler() : Y.addNewDistanceMeasurement.notify();
      else if (oe === _e.RULER_ANGLE)
        m.cadMode.get() ? m.contextCAD.GetMainForm().GetTopToolbar().openAngle() : Y.addNewAngleMeasurement.notify();
      else if (oe === _e.RULER_ANNOTATION)
        m.cadMode.get() ? await new Promise((Me) => {
          const dt = () => {
            Me();
          };
          m.contextCAD.GetMainForm().GetTopToolbar().openAnnotationA(dt);
        }) : Y.addNewAnnotation.notify();
      else if (oe === _e.RULER_ROI)
        m.cadMode.get() ? m.contextCAD.GetMainForm().GetTopToolbar().openPoly() : Y.addNewROIMeasurement.notify();
      else if (oe === _e.RULER_CLEAR)
        m.cadMode.get() ? m.contextCAD.GetMainForm().GetTopToolbar().clearAllMeasurements() : Y.clearAllMeasurements.notify();
      else if (oe === _e.RULER_PLANE)
        m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().openPlane();
      else if (oe === _e.RULER_SPHERE)
        m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().openSphere();
      else if (oe === _e.RULER_TETRAHEDRON)
        m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().openTetrahedron();
      else if (oe === _e.RULER_LANDMARK)
        m.cadMode.get() && await new Promise((Me) => {
          const dt = () => {
            Me();
          };
          m.contextCAD.GetMainForm().GetTopToolbar().openLandmarkA(dt);
        });
      else if (oe === _e.RULER_CLEAR_EXCEPT)
        m.cadMode.get() && m.contextCAD.GetMainForm().GetTopToolbar().clearAllExcept();
      else if (oe === _e.EXIT || oe === _e.ZIMVIE_LOGO || oe === _e.RG_LOGO)
        if (co.value) {
          const Me = async () => {
            n.hideNavbar(), await Rs();
          };
          m.shouldProjectBeSaved() && !le.value ? i.open(tp, {
            props: {
              closable: !1,
              draggable: !1,
              modal: !0,
              header: t("implant-planner.saveProject"),
              style: { width: "35vw" }
            },
            data: {
              message: t("implant-planner.saveChangesPrompt"),
              showCancel: !0,
              showYesNo: !0,
              showAll: !0
            },
            emits: {
              onConfirm: async () => {
                wl(!0, Me);
              },
              onReject: async () => {
                await Me();
              },
              onCancel: () => {
              }
            }
          }) : await Me();
        } else {
          m.warningString.set(t("implant-planner.exitWizardBeforeExitProject")), F.value = t("implant-planner.warning"), P.value = !0;
          return;
        }
    };
    function rg() {
      ve.value = ye.CPR_SETTINGS, Xa();
    }
    function ug(oe) {
      nl.on(al.NAVBAR_BUTTON_CLICKED, oe);
    }
    function cg(oe) {
      nl.off(al.NAVBAR_BUTTON_CLICKED, oe);
    }
    const tc = Ce(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    })), dg = Ce(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    })), pg = Ce(() => ({
      paddingLeft: "0.75rem",
      paddingRight: "0.75rem",
      paddingBottom: "0.5rem",
      height: `calc(-${yt.value ? 155 : q.value}px + 100vh) !important`,
      //height reduced for navbar
      pointerEvents: K.value ? "none" : "auto",
      overflow: "hidden"
    })), nc = B(), ac = B(!1), oc = () => {
      const oe = nc.value;
      oe && (ac.value = oe.scrollTop + oe.clientHeight >= oe.scrollHeight - 1);
    }, mg = Ce(() => ({
      overflow: "auto",
      background: ac.value ? "none" : "linear-gradient(#0000, #0003) bottom / 100% 36px no-repeat"
    })), fg = (oe) => oe == ye.CAD_DESIGN ? ![ye.GUIDE_DESIGN, ye.CREATE_MODEL].includes(ve.value) : oe == ye.CREATE_MODEL ? ye.CREATE_MODEL == ve.value : oe == ye.GUIDE_DESIGN ? ye.GUIDE_DESIGN == ve.value : !0;
    return (oe, Me) => {
      const dt = mu, Lt = pu, kt = du;
      return L(), H(He, null, [
        A.value ? (L(), H("div", {
          key: 0,
          id: "loadingDiv",
          class: "flex flex-col gap-6 items-center justify-center",
          style: Et({
            position: "absolute",
            inset: "0px",
            background: he.value,
            pointerEvents: "all",
            cursor: "wait",
            zIndex: "100000"
          })
        }, [
          d(r(os), {
            strokeWidth: 5,
            hideSpinner: !0
          }, {
            default: _(() => [
              y("div", NR, [
                y("div", LR, U(G.value), 1),
                y("div", OR, [
                  (L(), be(r(di), {
                    value: O.value,
                    key: M.value,
                    showValue: !1,
                    style: { height: "2rem", width: "100%" },
                    mode: T.value ? "determinate" : "indeterminate",
                    pt: { value: { style: { transition: "none" } } }
                  }, null, 8, ["value", "mode"]))
                ]),
                C.value ? (L(), H("div", DR, [
                  d(r(Ne), {
                    class: "btn-wizard-md p-confirmdialog-accept-button",
                    icon: "pi pi-times",
                    label: oe.$t("shared.cancel"),
                    onClick: Jf
                  }, null, 8, ["label"])
                ])) : ue("", !0)
              ])
            ]),
            _: 1
          })
        ], 4)) : ue("", !0),
        d(r(Un), {
          visible: Ee.value,
          "onUpdate:visible": Me[1] || (Me[1] = (Xe) => Ee.value = Xe),
          breakpoints: { "960px": "75vw", "640px": "100vw" },
          modal: !0,
          style: { width: "50vw" },
          header: oe.$t("implant-planner.changeLayout")
        }, {
          footer: _(() => [
            d(r(we), { class: "justify-center gap-2" }, {
              default: _(() => [
                d(r(la), {
                  label: oe.$t("shared.ok"),
                  onClick: Me[0] || (Me[0] = (Xe) => Ee.value = !1)
                }, null, 8, ["label"]),
                j.value ? ue("", !0) : (L(), be(r(ya), {
                  key: 0,
                  label: oe.$t("shared.cancel"),
                  onClick: qf
                }, null, 8, ["label"]))
              ]),
              _: 1
            })
          ]),
          default: _(() => [
            d(dt, {
              "model-value": As,
              cadMode: j.value,
              onUpdateLayout: Ku
            }, null, 8, ["model-value", "cadMode"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Un), {
          visible: xe.value,
          "onUpdate:visible": Me[3] || (Me[3] = (Xe) => xe.value = Xe),
          breakpoints: { "960px": "45vw", "640px": "60vw" },
          modal: !0,
          style: { width: "30vw" },
          header: oe.$t("implant-planner.changeLayout")
        }, {
          footer: _(() => [
            y("div", AR, [
              d(r(Ne), {
                class: "btn-wizard-md",
                autofocus: "",
                icon: "pi pi-check",
                label: oe.$t("shared.ok"),
                onClick: Me[2] || (Me[2] = (Xe) => xe.value = !1)
              }, null, 8, ["label"]),
              d(r(Ne), {
                class: "btn-wizard-md",
                background: !1,
                outlined: !0,
                icon: "pi pi-times",
                label: oe.$t("shared.cancel"),
                onClick: Qf
              }, null, 8, ["label"])
            ])
          ]),
          default: _(() => [
            d(ku, {
              "model-value": tg,
              onUpdateLayout: Ku
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Un), {
          visible: rt.value,
          "onUpdate:visible": Me[5] || (Me[5] = (Xe) => rt.value = Xe),
          closable: !1,
          draggable: !1,
          modal: "",
          header: oe.$t("implant-planner.warning"),
          style: { width: "25vw" }
        }, {
          default: _(() => [
            y("p", RR, U(oe.$t("implant-planner.cprDoesNotExist")), 1),
            y("div", MR, [
              d(r(Ne), {
                class: "w-full",
                label: oe.$t("implant-planner.goToCprSettings"),
                onClick: Me[4] || (Me[4] = (Xe) => [rg(), rt.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Un), {
          visible: P.value,
          "onUpdate:visible": Me[7] || (Me[7] = (Xe) => P.value = Xe),
          closable: !1,
          draggable: !1,
          modal: "",
          header: F.value,
          style: { width: "25vw" }
        }, {
          default: _(() => [
            y("p", PR, U(r(m).warningString.get()), 1),
            y("div", xR, [
              d(r(Ne), {
                autofocus: "",
                class: "w-full",
                label: oe.$t("shared.ok"),
                onClick: Me[6] || (Me[6] = (Xe) => [P.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Un), {
          visible: W.value,
          "onUpdate:visible": Me[16] || (Me[16] = (Xe) => W.value = Xe),
          closable: !1,
          draggable: !1,
          modal: "",
          header: oe.$t("implant-planner.iOSLimitedLoadTitle"),
          breakpoints: { "640px": "95vw" },
          style: { width: "40vw", maxWidth: "96vw" }
        }, {
          footer: _(() => [
            d(r(we), { class: "justify-center gap-2" }, {
              default: _(() => [
                d(r(ya), {
                  label: oe.$t("shared.cancel"),
                  onClick: Rt
                }, null, 8, ["label"]),
                d(r(la), {
                  disabled: !ht.value,
                  label: oe.$t("shared.continue"),
                  onClick: Tt
                }, null, 8, ["disabled", "label"])
              ]),
              _: 1
            })
          ]),
          default: _(() => [
            $.value ? (L(), H("div", jR, [
              y("p", $R, U(oe.$t("implant-planner.iOSLimitedLoadDescription")), 1),
              y("div", FR, [
                y("div", null, U(oe.$t("implant-planner.iOSAvailableMemory")) + ": " + U(mt($.value.budgetMemoryBytes)), 1),
                y("div", null, U(oe.$t("implant-planner.iOSEstimatedSelectionMemory")) + ": " + U(mt(ze.value)), 1),
                y("div", {
                  style: Et({ color: ct.value >= 0 ? "#16a34a" : "#dc2626", fontWeight: "bold" })
                }, U(oe.$t("implant-planner.iOSRemainingMemory")) + ": " + U(ct.value >= 0 ? mt(ct.value) : "-" + mt(Math.abs(ct.value))), 5)
              ]),
              y("div", kR, [
                y("div", VR, U(oe.$t("implant-planner.iOSVolumeQuality")), 1),
                y("label", BR, [
                  Pt(y("input", {
                    "onUpdate:modelValue": Me[8] || (Me[8] = (Xe) => R.value = Xe),
                    type: "radio",
                    value: "full"
                  }, null, 512), [
                    [lc, R.value]
                  ]),
                  y("span", null, U(oe.$t("implant-planner.iOSVolumeFull")) + " (" + U(mt($.value.volumeFullEstimateBytes)) + ")", 1)
                ]),
                y("label", UR, [
                  Pt(y("input", {
                    "onUpdate:modelValue": Me[9] || (Me[9] = (Xe) => R.value = Xe),
                    type: "radio",
                    value: "decimated"
                  }, null, 512), [
                    [lc, R.value]
                  ]),
                  y("span", null, U(oe.$t("implant-planner.iOSVolumeDecimated")) + " (" + U(mt($.value.volumeDecimatedEstimateBytes)) + ")", 1)
                ])
              ]),
              $.value.implantCount ? (L(), H("label", GR, [
                Pt(y("input", {
                  "onUpdate:modelValue": Me[10] || (Me[10] = (Xe) => D.value = Xe),
                  type: "checkbox"
                }, null, 512), [
                  [Vo, D.value]
                ]),
                y("span", null, U(oe.$t("implant-planner.iOSLoadImplants")) + " (" + U($.value.implantCount) + ", " + U(mt($.value.implantEstimateBytes)) + ")", 1)
              ])) : ue("", !0),
              $.value.pinCount ? (L(), H("label", WR, [
                Pt(y("input", {
                  "onUpdate:modelValue": Me[11] || (Me[11] = (Xe) => V.value = Xe),
                  type: "checkbox"
                }, null, 512), [
                  [Vo, V.value]
                ]),
                y("span", null, U(oe.$t("implant-planner.iOSLoadPins")) + " (" + U($.value.pinCount) + ", " + U(mt($.value.pinEstimateBytes)) + ")", 1)
              ])) : ue("", !0),
              $.value.projectStlCandidates.length > 0 ? (L(), H("div", zR, [
                y("label", HR, [
                  Pt(y("input", {
                    "onUpdate:modelValue": Me[12] || (Me[12] = (Xe) => Z.value = Xe),
                    type: "checkbox"
                  }, null, 512), [
                    [Vo, Z.value]
                  ]),
                  y("span", null, U(oe.$t("implant-planner.iOSLoadProjectStls")), 1)
                ]),
                y("div", YR, [
                  (L(!0), H(He, null, jt($.value.projectStlCandidates, (Xe) => (L(), H("label", {
                    key: Xe.id,
                    style: Et({ display: "flex", gap: "0.5rem", alignItems: "center", opacity: Z.value ? 1 : 0.5 })
                  }, [
                    Pt(y("input", {
                      "onUpdate:modelValue": Me[13] || (Me[13] = (Ft) => Ae.value = Ft),
                      disabled: !Z.value,
                      type: "checkbox",
                      value: Xe.name
                    }, null, 8, KR), [
                      [Vo, Ae.value]
                    ]),
                    y("span", null, U(Xe.name) + " (" + U(mt(Xe.estimatedBytes)) + ")", 1)
                  ], 4))), 128))
                ])
              ])) : ue("", !0),
              $.value.patientStlCandidates.length > 0 ? (L(), H("div", ZR, [
                y("label", XR, [
                  Pt(y("input", {
                    "onUpdate:modelValue": Me[14] || (Me[14] = (Xe) => X.value = Xe),
                    type: "checkbox"
                  }, null, 512), [
                    [Vo, X.value]
                  ]),
                  y("span", null, U(oe.$t("implant-planner.iOSLoadPatientStls")), 1)
                ]),
                y("div", JR, [
                  (L(!0), H(He, null, jt($.value.patientStlCandidates, (Xe) => (L(), H("label", {
                    key: Xe.id,
                    style: Et({ display: "flex", gap: "0.5rem", alignItems: "center", opacity: X.value ? 1 : 0.5 })
                  }, [
                    Pt(y("input", {
                      "onUpdate:modelValue": Me[15] || (Me[15] = (Ft) => De.value = Ft),
                      disabled: !X.value,
                      type: "checkbox",
                      value: Xe.name
                    }, null, 8, qR), [
                      [Vo, De.value]
                    ]),
                    y("span", null, U(Xe.name) + " (" + U(mt(Xe.estimatedBytes)) + ")", 1)
                  ], 4))), 128))
                ])
              ])) : ue("", !0)
            ])) : ue("", !0)
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        Pt(d(Mu, { class: "show-horizontal-bar horizontal-wizard-menu" }, {
          start: _(() => [
            (L(!0), H(He, null, jt(Gt, (Xe) => (L(), be(Pu, {
              key: Xe.type,
              modelValue: ve.value,
              "onUpdate:modelValue": Me[17] || (Me[17] = (Ft) => ve.value = Ft),
              index: Xe.type,
              disabled: Xe.disabled || !co.value,
              onClick: Qu
            }, {
              default: _(() => [
                vt(U(Xe.tabLabel), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "index", "disabled"]))), 128))
          ]),
          _: 1
        }, 512), [
          [ln, yt.value && Ut.value]
        ]),
        Pt(d(r(we), {
          id: "mainContainer",
          ref: "root",
          class: Ge(_t.value),
          style: Et(pg.value)
        }, {
          default: _(() => [
            w.value ? (L(), H("div", QR, [
              Pt(y("div", {
                ref_key: "scrollEl",
                ref: nc,
                class: "h-full",
                style: Et(mg.value),
                onScroll: oc
              }, [
                y("div", eM, [
                  d(Vf, null, {
                    mainMenuTabs: _(() => [
                      (L(!0), H(He, null, jt(Gt, (Xe) => (L(), H(He, {
                        key: Xe.type
                      }, [
                        fg(Xe.type) ? (L(), be(Bf, {
                          key: 0,
                          modelValue: ve.value,
                          "onUpdate:modelValue": Me[18] || (Me[18] = (Ft) => ve.value = Ft),
                          index: Xe.type,
                          disabled: Xe.disabled || !co.value,
                          isLast: qu.value,
                          onClick: Qu
                        }, {
                          default: _(() => [
                            vt(U(Xe.tabLabel), 1)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "index", "disabled", "isLast"])) : ue("", !0)
                      ], 64))), 128))
                    ]),
                    _: 1
                  })
                ])
              ], 36), [
                [ln, !yt.value && Ut.value]
              ]),
              Pt(d(r(we), {
                id: "wizardTabContainer",
                class: Ge(On.value),
                style: Et(tc.value)
              }, {
                default: _(() => [
                  y("div", tM, [
                    d(Lt, {
                      isFirstItem: og.value,
                      isVisible: co.value && z.value && Ut.value,
                      isLastItem: qu.value,
                      onNextStep: Zf,
                      onPreviousStep: Xf,
                      onHideWizard: I
                    }, {
                      default: _(() => {
                        var Xe;
                        return [
                          (L(), be(Sa(((Xe = uo.value) == null ? void 0 : Xe.component) ?? {}), je(ag(), {
                            onDone: lg,
                            onShowWizard: Me[19] || (Me[19] = (Ft) => v.value = !0),
                            onHideWizard: I
                          }), null, 16))
                        ];
                      }),
                      _: 1
                    }, 8, ["isFirstItem", "isVisible", "isLastItem"])
                  ])
                ]),
                _: 1
              }, 8, ["class", "style"]), [
                [ln, v.value]
              ]),
              Pt(d(r(we), {
                class: Ge(On.value),
                style: Et(tc.value)
              }, {
                default: _(() => [
                  d(r(Ot), {
                    id: "toggleWizardContainer",
                    class: "items-center",
                    style: { "border-radius": "16px", margin: "0 0.5rem", background: "transparent !important" }
                  }, {
                    default: _(() => [
                      d(r(Ne), {
                        class: "web-rg-toggle-wiz-btn",
                        iconSrc: "/icons/rg_left_panel_open.svg",
                        onClick: Me[20] || (Me[20] = (Xe) => v.value = !0)
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class", "style"]), [
                [ln, !v.value]
              ])
            ])) : ue("", !0),
            d(r(we), {
              id: "wizard-container",
              style: Et(dg.value)
            }, {
              default: _(() => [
                ue("", !0),
                Me[23] || (Me[23] = y("div", { id: "aboveRenderWindowContainer" }, null, -1)),
                Pt(y("div", {
                  ref_key: "vtkContainer",
                  ref: S,
                  id: "vtkContainer",
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden" }
                }, null, 512), [
                  [ln, !j.value]
                ]),
                Pt(y("div", {
                  ref_key: "vtkContainerCAD",
                  ref: f,
                  id: "vtkContainerCAD",
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden", position: "relative" }
                }, null, 512), [
                  [ln, j.value]
                ]),
                Me[24] || (Me[24] = y("div", { id: "belowRenderWindowContainer" }, null, -1))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["class", "style"]), [
          [ln, w.value]
        ]),
        te.value ? (L(), be(kt, {
          key: 1,
          license: h.value,
          visible: !0,
          settings: r(m).settings,
          onConfirm: Ie,
          onCancel: Ie
        }, null, 8, ["license", "settings"])) : ue("", !0)
      ], 64);
    };
  }
}), GP = /* @__PURE__ */ Vt(nM, [["__scopeId", "data-v-8ad4aa07"]]);
function aM() {
  return {
    dentistCode: "",
    dentistOfficeCode: "",
    project: {
      code: "",
      notes: "",
      panoramicImage: "",
      patient: {
        code: "",
        name: "",
        surname: "",
        birthDate: "",
        gender: "",
        fiscalCode: ""
      },
      implants: [],
      frontalImage: "",
      occlusalImage: "",
      rightImage: "",
      leftImage: ""
    }
  };
}
async function oM(e) {
  const t = it("implant-planner.exportingProject");
  if (!e.objects.hasCPR())
    return e.warningString.set(it("implant-planner.cprCurveMissingExportWarning")), e.warningDialogEvent.notify(it("shared.error")), null;
  const n = aM();
  let a = e.patientInfo;
  a || (console.error("Patient info is missing"), a = {
    patientName: "",
    extra: {
      patientName: "",
      modality: "",
      patientID: "",
      doctorID: "",
      study_instance_UID: "",
      description: ""
    }
  }), n.dentistCode = a.extra.doctorID, n.dentistOfficeCode = a.extra.doctorID, n.project.code = a.extra.study_instance_UID, n.project.notes = "";
  const o = (m, I) => {
    const S = e.settings.implants.showWarningsPopup;
    e.settings.implants.showWarningsPopup = I, e.settings.implants.securityZone = m, e.settings.onSettingsModified.notify(), e.settings.implants.showWarningsPopup = S;
  };
  e.showLoading(t, !0, 0, !0), o(!1, !0);
  const l = [1600, 800];
  e.objects.SetImplantReportDims(l, l, l, l, l, "", [255, 255, 255]);
  const s = e.layoutManager.getCurrentLayoutState().template;
  e.toolManager.coordControl.hideCrossIndicators = !0, e.objects.hasCPR() && (n.project.panoramicImage = await e.objects.SaveImplantReportCPR()), e.showLoading(t, !0, 5, !0);
  let i = a.firstName.split(" ");
  const u = a.firstName.split("^");
  u.length >= 2 && (i = u), i.length >= 1 ? n.project.patient.name = i[0] : n.project.patient.name = "", i.length >= 2 ? n.project.patient.surname = i[1] : n.project.patient.surname = "", n.project.patient.code = a.extra.patientID;
  const c = a.dateOfBirth.getFullYear(), p = String(a.dateOfBirth.getMonth() + 1).padStart(2, "0"), h = String(a.dateOfBirth.getDate()).padStart(2, "0");
  n.project.patient.birthDate = `${c}${p}${h}`, n.project.patient.gender = "", n.project.patient.fiscalCode = "";
  const g = e.objects.implants.size;
  let b = 0;
  for (const m of e.objects.implants.values()) {
    e.showLoading(t, !0, 10 + Math.floor(70 * b / g), !0), b++;
    const I = {
      images: [],
      crossSectionImage: "",
      position: "",
      producer: "",
      model: "",
      diameter: "",
      length: "",
      implant_code: "",
      abutment: "",
      abutmentDimensions: "",
      abutment_code: ""
    }, S = await m.getCrossScreenshot(Cn.CROSS, void 0, 0.75), f = await m.getCrossScreenshot(Cn.TANGENT, void 0, 0.75);
    let v = "";
    const w = e.getViewWidget(Cn._3D);
    if (e.layoutManager.setLayout(Fe._FULLSCREEN_3D), w) {
      const O = m.getPosition(), C = m.getNormal(), k = m.getBinormal(), M = w.getRenderer().getActiveCamera().getDistance(), z = mo.create(), j = mo.create();
      mo.scaleAndAdd(z, O, C, -M), mo.scale(j, k, -1), w.getRenderer().getActiveCamera().setViewUp(j[0], j[1], j[2]), w.getRenderer().getActiveCamera().setPosition(z[0], z[1], z[2]), w.getRenderer().resetCameraClippingRange();
      const K = await zo({ context: e, view: w, noOverlay: !0, compression: 0.75, background: "white" });
      K && (v = K);
    }
    I.images.push(f), I.images.push(v), I.crossSectionImage = S, I.position = m.getName();
    const A = m.getImplantInfo().implantInfo;
    I.producer = A.manufacturerName, I.model = A.modelName, I.diameter = A.diameter.toString(), I.length = A.length.toString(), I.implant_code = A.sellingCode || "NONE";
    const T = m.getAbutment();
    if (T) {
      const O = T.getAbutmentInfo();
      I.abutment = O.modelName, I.abutmentDimensions = O.name, I.abutment_code = O.abutmentSellingCode || "NONE";
    }
    n.project.implants.push(I);
  }
  e.showLoading(t, !0, 85, !0), e.layoutManager.setLayout(Fe._FULLSCREEN_3D);
  const E = e.getViewWidget(Cn._3D);
  if (E) {
    e.toolManager.coordControl.set3DViewOrientation(El.Front);
    const m = await zo({ context: e, view: E, noOverlay: !0, compression: 0.75, background: "white" });
    n.project.frontalImage = m || "";
    let I = El.Top;
    e.CPRType == nn.MAXILLA && (I = El.Bottom), e.toolManager.coordControl.set3DViewOrientation(I);
    const S = await zo({ context: e, view: E, noOverlay: !0, compression: 0.75, background: "white" });
    n.project.occlusalImage = S || "", e.toolManager.coordControl.set3DViewOrientation(El.Right);
    const f = await zo({ context: e, view: E, noOverlay: !0, compression: 0.75, background: "white" });
    n.project.rightImage = f || "", e.toolManager.coordControl.set3DViewOrientation(El.Left);
    const v = await zo({ context: e, view: E, noOverlay: !0, compression: 0.75, background: "white" });
    n.project.leftImage = v || "";
  }
  return e.showLoading(t, !0, 95, !0), e.toolManager.coordControl.hideCrossIndicators = !1, s && e.layoutManager.setLayout(s), e.showLoading(t, !0, 100, !0), o(!0, !0), e.hideLoading(), n;
}
const lM = { style: { "text-align": "center", color: "white", "text-shadow": "0 1px 1px black" } }, iM = {
  key: 0,
  class: "mt-20",
  style: { width: "20vw" }
}, sM = { style: { color: "white" } }, rM = { style: { display: "flex", "justify-content": "center" } }, uM = { class: "ml-1 flex justify-center" }, cM = { class: "col-span-12" }, dM = {
  class: "ml-1 flex justify-start",
  style: { "white-space": "pre-wrap" }
}, pM = { class: "col-span-12" }, mM = {
  key: 0,
  id: "sidebarContainer",
  class: "flex flex-row",
  style: { "margin-top": "0.5rem", "margin-bottom": "0.5rem" }
}, fM = {
  class: "mainMenuTabs",
  style: { background: "linear-gradient(to right, rgba(24, 43, 75, 0.7) 15%, rgba(22, 25, 36, 0.7) 100%)", "border-radius": "16px" }
}, gM = {
  class: "grow",
  style: { "border-radius": "16px", margin: "0 0.5rem", background: "linear-gradient(to right, #172e4d 100%, #162a46 100%)" }
}, hM = /* @__PURE__ */ Je({
  __name: "IPProjectLoaderViewRedesignAlfred",
  props: {
    loader: {},
    source: { default: tl.IMPLANT_PLANNER }
  },
  setup(e) {
    const { t } = Ht(), n = Ao(), a = e, o = a.loader(ia()), l = Aa(), s = sa();
    let i = new cs(s.getAssetUrl(""));
    const u = () => {
      console.log("hide IProjectLoaderVie"), p.value = !1;
    }, c = B(), p = B(!0), h = B(!1), g = B(!0), b = B(!1), E = B(0), m = B(Math.random()), I = B(!0), S = B(!1), f = B(0), v = B(), w = B("Loading project"), A = pl(), T = Do(), O = ia(), C = oa(), { wizardLayouts: k } = So(oa()), M = ms(), z = qr.actions, j = Ra(), K = as(), x = B(K.getUser().license);
    B(xn.REALGUIDE), B(!0);
    const N = B(a.source == tl.IMPLANT_PLANNER ? wt.ImplantPlannerBase : wt.WeblinkViewer), G = ap(), ce = Ce(() => G.rgScreenType === "lg" ? 90 : 70);
    ds(i);
    const re = Ce(() => h.value ? "rgba(91, 91, 91, 0.5)" : "var(--webcad-main-bg)"), Se = () => {
      const ae = i.undoManager.getUndoDescription(), ve = i.undoManager.getRedoDescription(), ut = ae ? `Undo ${ae}` : void 0, yt = ve ? `Redo ${ve}` : void 0;
      let Ut = [], _t = [];
      i.undoManager.canUndo() ? Ut.push(_e.UNDO) : _t.push(_e.UNDO), i.undoManager.canRedo() ? Ut.push(_e.REDO) : _t.push(_e.REDO), n.disableNavbarButtons(_t), n.enableNavbarButtons(Ut);
      const On = [
        { button: _e.UNDO, tooltip: ut },
        { button: _e.REDO, tooltip: yt }
      ];
      n.addTooltips(On);
    }, se = B(!1), Le = () => {
      se.value = !1;
    }, Y = B(!1), pe = B(!1), fe = Ls(), le = () => {
      fe.stlLibraryWindowVisible ? pe.value = !0 : Y.value = !0;
    }, Re = B(!1), q = B(!1), he = B(!1), ne = B("");
    C.prepareDefaults(Fu());
    const te = B(i.layoutManager.wizardTabIndex.get()), { menuMode: Ie } = So(oa()), Ee = Ce(() => Ie.value === hn.HORIZONTAL && h.value), xe = Ce(() => ({
      "bg-top-nav-bar-wiz dynamic-margin-left bg-body-wiz": !0,
      "mt-1 dynamic-margin-left": N.value === wt.WeblinkViewer || !Ee.value
    })), Qe = Ce(() => ({
      "card-no-bottom-padding no-radius bg-body-wiz h-full flex flex-col": !0,
      "wizard-vertical-menu-margin": N.value !== wt.WeblinkViewer && !Ee.value
    })), Ke = [
      {
        type: ye.VOI_SETTINGS,
        tabLabel: "VOI Settings",
        component: fu,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.THREED_SETTINGS,
        tabLabel: "3D Settings",
        component: gu,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.DATA_IMPORT,
        tabLabel: "Data Import",
        component: hu,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.CPR_SETTINGS,
        tabLabel: "CPR Settings",
        component: bu,
        defaultLayout: Fe._CPR_SETTINGS_WIZARD
      },
      {
        type: ye.NERVE_DRAWING,
        tabLabel: "Nerve Drawing",
        component: yu,
        defaultLayout: Fe._NERVE_DRAWING_WIZARD
      },
      {
        type: ye.TEETH_SETUP,
        tabLabel: "Teeth Setup",
        component: Vu,
        defaultLayout: Fe._FULLSCREEN_3D
      },
      {
        type: ye.IMPLANT_PLANNING,
        tabLabel: "Implant Planning",
        component: Du,
        defaultLayout: Fe._3D_CPR_CROSS_TANGENT_AXIAL
      }
      /*
      {
          type: WizardType.REPORTS_EXPORT,
          tabLabel: "Reports / Export",
      },
      {
          type: WizardType.ADVANCED_TOOLS,
          tabLabel: "Advanced Tools",
      },
      {
          type: WizardType.OBJECT_LIST,
          tabLabel: "Object List",
      },
      */
      // {
      //     type: WizardType.GUIDE_DESIGN,
      //     tabLabel: "Guide Design",
      //     component: IPGuideDesignPrimaryComponentView,
      //     defaultLayout: LayoutTemplate._FULLSCREEN_3D,
      //     disabled: false,
      //     wizardsList: [
      //         {
      //             component: IPVolumeUndercutWizardView,
      //             stepName: "Volume Undercut",
      //         },
      //         {
      //             component: IPGuideDesignWizardView,
      //             stepName: "Guide Design",
      //         },
      //     ],
      // },
      /*
      {
          type: WizardType.SEGMENTATION,
          tabLabel: "Segmentation",
      },
      {
          type: WizardType.SANDBOX,
          tabLabel: "Sandbox",
      },
      {
          type: WizardType.PROJECT_SETUP,
          tabLabel: "Project Setup",
      },
      {
          type: WizardType.RECONSTRUCTION_SETUP,
          tabLabel: "Reconstruction Setup",
      },
      {
          type: WizardType.ACTIVE_RECONSTRUCTION,
          tabLabel: "Active Reconstruction",
      },
      */
    ];
    bo.SHOW_CAD_WIZARD && Ke.push({
      type: ye.CAD,
      tabLabel: "Cad",
      component: Ru,
      defaultLayout: Fe._3D_CPR_CROSS_TANGENT_AXIAL
    });
    const qe = B(Ke.find((ae) => ae.type === te.value));
    i.setModalsInstance(T), i.setResourceUrl("/resources/");
    const rt = i.getEngineInstance();
    async function P(ae, ve) {
      var Ut, _t, On;
      ae.setRootElement(c.value), ae.createRendererWindow({ background: [0.16, 0.43, 0.7] }), (Ut = ae.getInteractorStyle()) == null || Ut.setCameraInteractorEnabled(!0), (_t = ae.getInteractorStyle()) == null || _t.setMouseMode(ae.settings.general.useLeftButtonForRotationOn3d ? xn.REALGUIDE : xn.IMPLANTPLANNER), (On = ae.getInteractorStyle()) == null || On.setMouseMode2D(xn.REALGUIDE), k.value[ye.VOI_SETTINGS] !== void 0 && C.setWizardLayout(ye.VOI_SETTINGS, Fe._FULLSCREEN_3D);
      for (const Gt of Object.keys(k.value))
        ae.layoutManager.storeLayout(Gt.toString(), k.value[Number(Gt)]);
      ae.layoutManager.constructAllWindows();
      const yt = ae.layoutManager.getLayout(te.value.toString()) ?? ae.layoutManager.getDefaultLayout();
      ae.layoutManager.setLayout(yt), at(yt);
    }
    const F = (ae) => {
      fe.stlLibraryWindowVisible ? (i.layoutManager.storeLayout("StlLibrary", ae), i.layoutManager.setLayout(ae)) : (i.layoutManager.storeLayout(te.value.toString(), ae), i.layoutManager.setLayout(ae), at(ae), C.setWizardLayout(te.value, ae));
    }, me = () => {
      n.enableNavbarButtons([_e.LAYOUT]);
    }, de = () => {
      n.disableNavbarButtons([_e.LAYOUT]);
    }, We = () => {
      const ae = Ke.findIndex((yt) => yt.type === te.value);
      if (ae === -1) {
        console.warn("current wizard not found");
        return;
      }
      if (ae === Ke.length - 1) {
        console.warn("nextStep called on last wizard");
        return;
      }
      let ve = 0;
      ae == ye.CPR_SETTINGS && i.CPRType !== nn.MANDIBLE && (ve = 1);
      const ut = Ke[ae + 1 + ve].type;
      i.layoutManager.wizardTabIndex.set(ut), te.value = ut, Be();
    }, Q = () => {
      const ae = Ke.findIndex((yt) => yt.type === te.value);
      if (ae === -1) {
        console.warn("current wizard not found");
        return;
      }
      if (ae === 0) {
        console.warn("previousStep called on first wizard");
        return;
      }
      let ve = 0;
      ae == 5 && i.CPRType !== nn.MANDIBLE && (ve = 1);
      const ut = Ke[ae - 1 - ve].type;
      i.layoutManager.wizardTabIndex.set(ut), te.value = ut, Be();
    };
    j.onEvent(i.warningDialogEvent, (ae) => {
      ne.value = ae, he.value = !0;
    }), j.onEvent(i.screenshotUploadEvent, async ({ filename: ae, image: ve }) => {
      var yt, Ut, _t;
      const ut = (_t = (Ut = (yt = i.patientInfo) == null ? void 0 : yt.extra) == null ? void 0 : Ut.extra) == null ? void 0 : _t.study_instance_UID;
      if (ut)
        try {
          await o.uploadScreenshot(ut, ae, Ta.Image, ve), lo(t("weblink.successfullyUploadedScreenshot"));
        } catch (On) {
          Vn(On, t("web-rg.uploadFailed"));
        }
    }), j.watch(i.layoutBtnVisible, (ae) => {
      ae ? me() : de();
    }), j.watch(i.loadingFlag, (ae) => {
      g.value = ae, w.value = i.loadingText, b.value = i.progressBarFlag, E.value = i.progressBarValue.get();
    }), j.watch(i.nextPrevVisible, (ae) => {
      I.value = ae, console.log("Setting nextprevFlag to:", ae);
    }), j.watch(i.cadMode, (ae) => {
      S.value = ae, f.value = ae ? 1 : 0, console.log("Setting cadMode to:", ae);
    }), j.watch(i.progressBarValue, (ae) => {
      E.value = ae;
    }), j.watch(i.layoutManager.wizardTabIndex, () => {
      te.value = i.layoutManager.wizardTabIndex.get(), Be();
    });
    const ie = B(!0);
    j.watch(i.tabButtonsEnabled, (ae) => {
      ie.value = ae, console.log("TabButtonsEnabled", ie.value);
    }), lt(te, (ae) => {
      i.toolManager.activeTool.WindowLevel.set(!1), wu(), i.layoutManager.wizardTabIndex.set(ae);
      let ve = i.layoutManager.getLayout(ae.toString()) ?? i.layoutManager.getDefaultLayout();
      if (me(), R(), te.value === ye.DATA_IMPORT && (i.layoutManager.storeLayout(ye.DATA_IMPORT.toString(), Fe._FULLSCREEN_3D), ve = i.layoutManager.getLayout(ae.toString()) ?? i.layoutManager.getDefaultLayout(), de()), te.value == ye.CPR_SETTINGS && (i.layoutManager.storeLayout(ye.CPR_SETTINGS.toString(), Fe._CPR_SETTINGS_WIZARD), ve = i.layoutManager.getLayout(ae.toString()) ?? i.layoutManager.getDefaultLayout(), de()), te.value == ye.NERVE_DRAWING && (i.objects.hasCPR() || (q.value = !0), i.layoutManager.storeLayout(ye.NERVE_DRAWING.toString(), Fe._NERVE_DRAWING_WIZARD), ve = i.layoutManager.getLayout(ae.toString()) ?? i.layoutManager.getDefaultLayout(), de()), te.value == ye.GUIDE_DESIGN && (i.layoutManager.storeLayout(ye.GUIDE_DESIGN.toString(), Fe._FULLSCREEN_3D), ve = i.layoutManager.getLayout(ae.toString()) ?? i.layoutManager.getDefaultLayout(), de()), ((yt) => {
        switch (console.log("setActiveTool wizard : ", yt), yt) {
          case ye.CPR_SETTINGS:
            i.toolManager.setTool(_n.CPR, rn.PRIMARY);
            break;
          case ye.NERVE_DRAWING:
            i.toolManager.setTool(_n.NERVE, rn.PRIMARY);
            break;
          case ye.DATA_IMPORT:
            i.toolManager.setTool(_n.MATCHING_TOOL, rn.PRIMARY);
            break;
          default:
            i.toolManager.setTool(_n.NONE, rn.PRIMARY);
        }
      })(te.value), te.value === ye.DATA_IMPORT && de(), !(te.value === ye.CPR_SETTINGS || te.value === ye.NERVE_DRAWING)) {
        const yt = i.layoutManager.layoutTemplateContainsCpr(ve);
        Re.value = i.objects.hasCPR(), yt && !Re.value && (ve = Fe._3D_MPR);
      }
      i.layoutManager.setLayout(ve), i.resize(), i.resetOrientation(), at(ve), C.updateSelectedWizardIndex(te.value), R();
    });
    const W = () => {
      var ve, ut;
      i.layoutManager.storeLayout(((ve = qe.value) == null ? void 0 : ve.type.toString()) ?? "", ((ut = qe.value) == null ? void 0 : ut.defaultLayout) ?? Fe._FULLSCREEN_3D);
      const ae = i.layoutManager.getLayout(te.value.toString()) ?? i.layoutManager.getDefaultLayout();
      i.layoutManager.setLayout(ae), Y.value = !1, at(ae);
    }, ee = () => {
      const ae = i.layoutManager.getLayout("StlLibrary");
      ae !== void 0 && i.layoutManager.setLayout(ae), pe.value = !1;
    }, $ = B(), R = () => {
      console.log("showProjectName projectFullName.value: ", v.value), v.value && n.showProjectOnNavbar(v.value);
    };
    lt(h, () => {
      h.value && (console.log("watch loaded!"), n.showNavbar({
        buttons: Cu(N.value),
        showZimvieLogo: !1,
        showNavbarPosition: !0,
        isWizard: !0,
        showDoctors: !1
      }));
    }), Dt(async () => {
      op(), n.showOnlyLogo(), R(), i.undoManager.onUndoChange.subscribe(Se), Se(), i.toolManager.onUndoManagerChange.subscribe(Se), i.toolManager.onUndoManagerPop.subscribe(Se), N.value === wt.WeblinkViewer && (Nt(), Tt()), console.log("Engine JS - navigator.hardwareConcurrency", navigator.hardwareConcurrency);
      const ae = performance.now(), ve = await rt;
      ps(ve), console.log("engine await: ", performance.now() - ae), await D(A.params), N.value === wt.WeblinkViewer && (i.layoutManager.wizardTabIndex.set(ye.IMPLANT_PLANNING), te.value = ye.IMPLANT_PLANNING, Be()), i.objects.hasCPR() && i.objects.initializeCPRCurve(), i.objects.hasCPR() && (i.layoutManager.wizardTabIndex.set(ye.IMPLANT_PLANNING), te.value = ye.IMPLANT_PLANNING, Be()), De(), R(), J(bn), N.value === wt.WeblinkViewer && (i.readOnly = !0, i.objects.lockUnlockAllImplantPins(!0)), i.objects.checkCollisions(), h.value = !0, g.value = !1;
      const ut = i.getOverlayContainer(), yt = document.createElement("div");
      yt.id = "stlLibraryContainer", yt.style.position = "absolute", yt.style.pointerEvents = "none", yt.style.userSelect = "none", yt.style.inset = "0px", ut.appendChild(yt), i.sceneRepaint(), setTimeout(() => {
        i.resetOrientation();
      }, 0), A.params.alfredId && (h.value = !0, setTimeout(async () => {
        const Ut = await oM(i);
        try {
          if (Ut) {
            const _t = i.patientInfo;
            Ut.dentistCode = "T002-004", Ut.project.patient.birthDate = Pm(_t.dateOfBirth), Ut.project.patient.ALFRED_PATIENT_ID = parseInt(A.params.alfredId), await O.exportToAlfred(Ut), await T.showInfoModal("Export to Alfred", "Export to Alfred complete, please return to Alfred to continue the import.");
          }
        } catch (_t) {
          console.error("Export to Alfred failed", _t), await T.showInfoModal("Export to Alfred", "Export to Alfred failed, please try again.");
        }
      }, 500));
    });
    async function D(ae) {
      b.value = !0, E.value = 0, m.value = Math.random();
      const ve = await o.getProjectInfo(ae);
      if (!ve) {
        console.error("Project not found");
        return;
      }
      const ut = ve.project;
      i.patientInfo = ve.patientInfo, v.value = ve.projectFullName, R(), $.value = ut.patientName, b.value = !0, E.value = 5, m.value = Math.random();
      const yt = (Ut) => {
        E.value = Ut.loaded / Ut.total * 100, m.value = Math.random();
      };
      await o.loadProject(ut, i, P, yt);
    }
    const V = (ae) => {
      i.objects.unSelectObject();
      const ve = o.getLoadedProjectData();
      i && ve && l.open($u, {
        props: {
          closable: !1,
          modal: !0,
          header: t("implant-planner.saveProject"),
          style: { width: "40vw" }
        },
        data: {
          context: i,
          projectData: ve,
          isSaveAs: ae,
          projectLoader: o
        }
      });
    }, Z = tt(il()), X = tt(il()), Ae = r(Ie);
    function De() {
      N.value === wt.WeblinkViewer ? _u() : Ie.value === hn.HORIZONTAL ? rl() : sl();
    }
    Ha(() => {
      i && h.value && i.cleanup(), Pe(bn), Ae === hn.HORIZONTAL && N.value === wt.WeblinkViewer ? rl() : Ae === hn.SIDEBAR && N.value === wt.WeblinkViewer && sl();
    });
    const at = (ae) => {
      Z.oldLayout = ae, Z.newLayout = ae;
    };
    function Be() {
      const ae = Ke.find((ve) => ve.type === te.value);
      ae && (qe.value = ae);
    }
    function ze() {
      var ae;
      if (te.value === ye.DATA_IMPORT)
        return {
          patientName: $.value
        };
      if (te.value === ye.GUIDE_DESIGN)
        return {
          wizardsList: (ae = qe == null ? void 0 : qe.value) == null ? void 0 : ae.wizardsList
        };
      if (te.value === ye.IMPLANT_PLANNING && N.value === wt.WeblinkViewer)
        return {
          isReadOnly: !0
        };
    }
    const ct = Ce(() => te.value === 0), ht = Ce(() => te.value === Ke[Ke.length - 1].type), mt = () => {
      Be();
    }, Bt = () => {
      console.log("IPProjectLoaderView.vue: doneFromSteps clicked -");
    }, Nt = () => {
      n.disableNavbarButtons([_e.UNDO, _e.REDO, _e.SAVE, _e.SAVE_AS, _e.RESET, _e.RULER, _e.SETTINGS]);
    };
    async function Tt() {
      await dl().loadSTLLibrary();
    }
    lt(
      () => C.colorScheme,
      () => {
        i.setColorScheme(C.colorScheme);
      },
      {
        immediate: !0
      }
    );
    async function Rt() {
      await i.toolManager.destructAllTools(), N.value === wt.WeblinkViewer ? await M.push({ name: "Home", params: { name: A.params.name, id: $.value } }) : (lp(), await M.push({ name: "Patients", params: { id: $.value } }));
    }
    const bn = async (ae) => {
      if (ae === _e.SAVE)
        V();
      else if (ae === _e.SAVE_AS)
        V(!0);
      else if (ae === _e.SETTINGS)
        se.value = !0;
      else if (ae === _e.RESET)
        i && (i.resetOrientation(), i.sceneRepaint());
      else if (ae === _e.LAYOUT)
        le();
      else if (ae === _e.SCREENSHOT) {
        const ve = await i.takeWindowScreenshotWebcad();
        if (ve) {
          const ut = /* @__PURE__ */ new Date(), yt = (Gt) => String(Gt).padStart(2, "0"), Ut = `${i.projectInfo.projectFilename.replace(".zip", "")} ${ut.getFullYear()}-${yt(ut.getMonth() + 1)}-${yt(ut.getDate())} at ${yt(ut.getHours())}.${yt(ut.getMinutes())}.${yt(ut.getSeconds())}.png`, _t = ve.toDataURL();
          if (_t) {
            const Gt = document.createElement("a");
            document.body.appendChild(Gt), Gt.href = _t, Gt.download = Ut, Gt.click(), window.URL.revokeObjectURL(_t);
          }
          const On = await new Promise((Gt) => ve.toBlob(Gt, "image/png"));
          if (On)
            try {
              await o.uploadScreenshot(i.patientInfo.extra.extra.study_instance_UID, Ut, Ta.Image, On), lo(t("weblink.successfullyUploadedScreenshot"));
            } catch (Gt) {
              Vn(Gt, t("web-rg.uploadFailed"));
            }
        }
      } else if (ae === _e.W_L) {
        if (i) {
          const ve = i.toolManager.activeTool.WindowLevel.get();
          i.toolManager.activeTool.WindowLevel.set(!ve);
        }
      } else ae === _e.HELP ? await T.showViewerHelpModal() : ae === _e.INFO ? i.setInfoFlag(!i.getInfoFlag().get()) : ae === _e.UNDO ? await i.undoManager.undo() : ae === _e.REDO ? await i.undoManager.redo() : ae === _e.RULER_DISTANCE ? z.addNewDistanceMeasurement.notify() : ae === _e.RULER_ANGLE ? z.addNewAngleMeasurement.notify() : ae === _e.RULER_ANNOTATION ? z.addNewAnnotation.notify() : ae === _e.RULER_ROI ? z.addNewROIMeasurement.notify() : ae === _e.RULER_CLEAR ? z.clearAllMeasurements.notify() : ae === _e.ZIMVIE_LOGO ? (n.hideNavbar(), await Rt()) : ae === _e.RG_LOGO ? (n.hideNavbar(), await Rt()) : ae === _e.EXIT && (n.hideNavbar(), await Rt());
    };
    function Te() {
      te.value = ye.CPR_SETTINGS, Be();
    }
    function J(ae) {
      nl.on(al.NAVBAR_BUTTON_CLICKED, ae);
    }
    function Pe(ae) {
      nl.off(al.NAVBAR_BUTTON_CLICKED, ae);
    }
    const Ze = Ce(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      height: `calc(-${Ee.value ? 160 : 95}px + 100vh) !important`
    })), st = Ce(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      height: `calc(-${Ee.value ? 155 : ce.value}px + 100vh) !important`
    }));
    return (ae, ve) => {
      const ut = mu, yt = pu, Ut = du;
      return L(), H(He, null, [
        g.value ? (L(), H("div", {
          key: 0,
          id: "loadingDiv",
          class: "flex flex-col gap-6 items-center justify-center",
          style: Et({
            position: "absolute",
            inset: "0px",
            background: re.value,
            zIndex: "1000000",
            pointerEvents: "all",
            cursor: "wait"
          })
        }, [
          d(r(os), {
            strokeWidth: 5,
            hideSpinner: !0
          }, {
            default: _(() => [
              y("div", lM, U(w.value), 1),
              b.value ? (L(), H("div", iM, [
                (L(), be(r(di), {
                  value: E.value,
                  key: m.value,
                  style: { height: "2rem" }
                }, {
                  default: _(() => [
                    y("span", sM, U(E.value.toFixed(0)) + " %", 1)
                  ]),
                  _: 1
                }, 8, ["value"]))
              ])) : ue("", !0)
            ]),
            _: 1
          })
        ], 4)) : ue("", !0),
        d(r(Un), {
          visible: Y.value,
          "onUpdate:visible": ve[1] || (ve[1] = (_t) => Y.value = _t),
          breakpoints: { "960px": "75vw", "640px": "100vw" },
          modal: !0,
          style: { width: "50vw" },
          header: ae.$t("implant-planner.changeLayout")
        }, {
          footer: _(() => [
            d(r(we), { class: "justify-center gap-2" }, {
              default: _(() => [
                d(r(la), {
                  label: ae.$t("shared.ok"),
                  onClick: ve[0] || (ve[0] = (_t) => Y.value = !1)
                }, null, 8, ["label"]),
                d(r(ya), {
                  label: ae.$t("shared.cancel"),
                  onClick: W
                }, null, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          default: _(() => [
            d(ut, {
              "model-value": Z,
              onUpdateLayout: F
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Un), {
          visible: pe.value,
          "onUpdate:visible": ve[3] || (ve[3] = (_t) => pe.value = _t),
          breakpoints: { "960px": "45vw", "640px": "60vw" },
          modal: !0,
          style: { width: "30vw" },
          header: ae.$t("implant-planner.changeLayout")
        }, {
          footer: _(() => [
            y("div", rM, [
              d(r(Ne), {
                class: "btn-wizard-md",
                autofocus: "",
                icon: "pi pi-check",
                label: ae.$t("shared.ok"),
                onClick: ve[2] || (ve[2] = (_t) => pe.value = !1)
              }, null, 8, ["label"]),
              d(r(Ne), {
                class: "btn-wizard-md",
                background: !1,
                outlined: !0,
                icon: "pi pi-times",
                label: ae.$t("shared.cancel"),
                onClick: ee
              }, null, 8, ["label"])
            ])
          ]),
          default: _(() => [
            d(ku, {
              "model-value": X,
              onUpdateLayout: F
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Un), {
          visible: q.value,
          "onUpdate:visible": ve[5] || (ve[5] = (_t) => q.value = _t),
          closable: !1,
          draggable: !1,
          modal: "",
          header: ae.$t("implant-planner.warning"),
          style: { width: "25vw" }
        }, {
          default: _(() => [
            y("p", uM, U(ae.$t("implant-planner.cprDoesNotExist")), 1),
            y("div", cM, [
              d(r(Ne), {
                class: "w-full",
                label: ae.$t("implant-planner.goToCprSettings"),
                onClick: ve[4] || (ve[4] = (_t) => [Te(), q.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        d(r(Un), {
          visible: he.value,
          "onUpdate:visible": ve[7] || (ve[7] = (_t) => he.value = _t),
          closable: !1,
          draggable: !1,
          modal: "",
          header: ne.value,
          style: { width: "25vw" }
        }, {
          default: _(() => [
            y("p", dM, U(r(i).warningString.get()), 1),
            y("div", pM, [
              d(r(Ne), {
                autofocus: "",
                class: "w-full",
                label: ae.$t("shared.ok"),
                onClick: ve[6] || (ve[6] = (_t) => [he.value = !1])
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "header"]),
        Pt(d(Mu, { class: "show-horizontal-bar horizontal-wizard-menu" }, {
          start: _(() => [
            (L(!0), H(He, null, jt(Ke, (_t) => (L(), be(Pu, {
              key: _t.type,
              modelValue: te.value,
              "onUpdate:modelValue": ve[8] || (ve[8] = (On) => te.value = On),
              index: _t.type,
              disabled: _t.disabled || !ie.value,
              onClick: mt
            }, {
              default: _(() => [
                vt(U(_t.tabLabel), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "index", "disabled"]))), 128))
          ]),
          _: 1
        }, 512), [
          [ln, Ee.value && N.value === r(wt).ImplantPlannerBase]
        ]),
        Pt(d(r(we), {
          id: "mainContainer",
          ref: "root",
          class: Ge(xe.value),
          style: { "margin-bottom": "0.5rem", "margin-left": "0.5rem", "margin-right": "0.5rem", "margin-top": "0 !important", border: "1px solid rgba(255, 255, 255, 0)", "border-radius": "8px" }
        }, {
          default: _(() => [
            h.value ? (L(), H("div", mM, [
              Pt(y("div", null, [
                y("div", fM, [
                  d(Vf, null, {
                    mainMenuTabs: _(() => [
                      (L(!0), H(He, null, jt(Ke, (_t) => (L(), be(Bf, {
                        key: _t.type,
                        modelValue: te.value,
                        "onUpdate:modelValue": ve[9] || (ve[9] = (On) => te.value = On),
                        index: _t.type,
                        disabled: _t.disabled || !ie.value,
                        onClick: mt
                      }, {
                        default: _(() => [
                          vt(U(_t.tabLabel), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "index", "disabled"]))), 128))
                    ]),
                    _: 1
                  })
                ])
              ], 512), [
                [ln, !Ee.value && N.value === r(wt).ImplantPlannerBase]
              ]),
              Pt(d(r(we), {
                class: Ge(Qe.value),
                style: Et(Ze.value)
              }, {
                default: _(() => [
                  y("div", gM, [
                    d(yt, {
                      isFirstItem: ct.value,
                      isVisible: ie.value && I.value && N.value === r(wt).ImplantPlannerBase,
                      isLastItem: ht.value,
                      onNextStep: We,
                      onPreviousStep: Q,
                      onHideWizard: u
                    }, {
                      default: _(() => {
                        var _t;
                        return [
                          (L(), be(Sa(((_t = qe.value) == null ? void 0 : _t.component) ?? {}), je(ze(), {
                            onDone: Bt,
                            onHideWizard: u
                          }), null, 16))
                        ];
                      }),
                      _: 1
                    }, 8, ["isFirstItem", "isVisible", "isLastItem"])
                  ])
                ]),
                _: 1
              }, 8, ["class", "style"]), [
                [ln, p.value]
              ]),
              Pt(d(r(we), {
                class: Ge(Qe.value),
                style: Et(Ze.value)
              }, {
                default: _(() => [
                  d(r(Ot), {
                    class: "items-center",
                    style: { "border-radius": "16px", margin: "0 0.5rem", background: "transparent !important" }
                  }, {
                    default: _(() => [
                      d(r(Ne), {
                        class: "web-rg-toggle-wiz-btn",
                        iconSrc: "/icons/rg_left_panel_open.svg",
                        onClick: ve[10] || (ve[10] = (_t) => p.value = !0)
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class", "style"]), [
                [ln, !p.value]
              ])
            ])) : ue("", !0),
            d(r(we), {
              id: "wizard-container",
              style: Et(st.value)
            }, {
              default: _(() => [
                ue("", !0),
                ve[13] || (ve[13] = y("div", { id: "aboveRenderWindowContainer" }, null, -1)),
                y("div", {
                  ref_key: "vtkContainer",
                  ref: c,
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden" }
                }, null, 512),
                ve[14] || (ve[14] = y("div", { id: "belowRenderWindowContainer" }, null, -1))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["class"]), [
          [ln, !g.value]
        ]),
        se.value ? (L(), be(Ut, {
          key: 1,
          license: x.value,
          visible: !0,
          settings: r(i).settings,
          onConfirm: Le,
          onCancel: Le
        }, null, 8, ["license", "settings"])) : ue("", !0)
      ], 64);
    };
  }
}), WP = /* @__PURE__ */ Vt(hM, [["__scopeId", "data-v-a7be6b5f"]]), bM = { style: { "text-align": "center", color: "white", "text-shadow": "0 1px 1px black" } }, vM = {
  class: "mt-20",
  style: { width: "20vw" }
}, yM = {
  key: 0,
  style: { color: "white" }
}, _M = {
  class: "h-full web-rg-wizard",
  style: { margin: "0 0.5rem" }
}, wM = /* @__PURE__ */ Je({
  __name: "IPFreeformingAppLoader",
  setup(e) {
    const t = B(), n = B(!0), a = B(!1), o = B(!0), l = B(!1), s = B(0), i = B(!1), u = B("Loading project"), c = B(Math.random()), p = Ce(() => i.value ? "linear-gradient(to top, rgb(40, 106, 173) 1%, rgb(11, 14, 26) 105%)" : "rgba(91, 91, 91, 0.5)"), h = Ce(() => ({
      "bg-top-nav-bar-wiz bg-body-wiz h-full": !0
    })), g = Ce(() => ({
      "card-no-bottom-padding no-radius bg-body-wiz h-full flex flex-col": !0,
      "wizard-vertical-menu-margin": !0
    })), b = Ce(() => ({
      flexGrow: 15,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    })), E = Ce(() => ({
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      minHeight: 0
    })), m = Ce(() => ({
      paddingLeft: "0.75rem",
      paddingRight: "0.75rem",
      paddingBottom: "0.5rem"
      // height: `calc(-${showHorizontal.value ? 155 : wizardHeight.value}px + 100vh) !important`, //height reduced for navbar
    })), I = Ra(), S = Do(), f = B("testObject");
    let v = new cs("");
    return ds(v), Dt(async () => {
      var k, M, z, j;
      console.log("Engine JS - navigator.hardwareConcurrency", navigator.hardwareConcurrency);
      const w = await v.getEngineInstance();
      ps(w);
      const T = await (await fetch("resources/testObject.obj")).blob(), O = new File([T], "testObject.obj", {
        type: T.type,
        lastModified: (/* @__PURE__ */ new Date()).getTime()
      }), C = await ss([O], v, "testObject");
      C && (f.value = C.id), v.setModalsInstance(S), v.setResourceUrl("/resources/"), v.setCADRootElement(t.value), v.createRendererWindow({ background: [0.16, 0.43, 0.7] }), (k = v.getInteractorStyle()) == null || k.setCameraInteractorEnabled(!0), (M = v.getInteractorStyle()) == null || M.setMouseMode(v.settings.general.useLeftButtonForRotationOn3d ? xn.REALGUIDE : xn.IMPLANTPLANNER), (z = v.getInteractorStyle()) == null || z.setMouseMode2D(xn.REALGUIDE), await ((j = v.contextCAD) == null ? void 0 : j.LoadCADResources()), o.value = !1, a.value = !0, v.sceneRepaint(), setTimeout(() => {
        v.resetOrientation();
      }, 0), I.watch(v.loadingFlag, (K) => {
        o.value = K, u.value = v.loadingText, l.value = v.progressBarFlag, s.value = v.progressBarValue.get(), i.value = v.nonTransparentLoading.get();
      });
    }), Ln(() => {
      v && a.value && v.cleanup();
    }), (w, A) => {
      const T = mm;
      return L(), H(He, null, [
        o.value ? (L(), H("div", {
          key: 0,
          id: "loadingDiv",
          class: "flex flex-col gap-6 items-center justify-center",
          style: Et({
            position: "absolute",
            inset: "0px",
            background: p.value,
            pointerEvents: "all",
            cursor: "wait",
            zIndex: "100000"
          })
        }, [
          d(r(os), {
            strokeWidth: 5,
            hideSpinner: !0
          }, {
            default: _(() => [
              y("div", bM, U(u.value), 1),
              y("div", vM, [
                (L(), be(r(di), {
                  value: s.value,
                  key: c.value,
                  style: { height: "2rem" },
                  mode: l.value ? "determinate" : "indeterminate"
                }, {
                  default: _(() => [
                    l.value ? (L(), H("span", yM, U(s.value.toFixed(0)) + " %", 1)) : ue("", !0)
                  ]),
                  _: 1
                }, 8, ["value", "mode"]))
              ])
            ]),
            _: 1
          })
        ], 4)) : ue("", !0),
        Pt(d(r(we), {
          id: "mainContainer",
          ref: "root",
          class: Ge(h.value),
          style: Et(m.value)
        }, {
          default: _(() => [
            a.value ? (L(), be(r(we), {
              key: 0,
              id: "wizardTabContainer",
              class: Ge(g.value),
              style: Et(E.value)
            }, {
              default: _(() => [
                Pt(y("div", _M, [
                  d(r(ot), {
                    class: "h-full",
                    style: { position: "relative" }
                  }, {
                    default: _(() => [
                      d(r(ot), {
                        class: "overflow-x-hidden overflow-y-auto h-full grow",
                        id: "wizardBody"
                      }, {
                        default: _(() => [
                          d(T, {
                            "selected-object-id": f.value,
                            isDemo: !0
                          }, null, 8, ["selected-object-id"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 512), [
                  [ln, n.value]
                ])
              ]),
              _: 1
            }, 8, ["class", "style"])) : ue("", !0),
            d(r(we), {
              id: "wizard-container",
              style: Et(b.value)
            }, {
              default: _(() => [
                A[0] || (A[0] = y("div", { id: "aboveRenderWindowContainer" }, null, -1)),
                y("div", {
                  ref_key: "vtkContainerCAD",
                  ref: t,
                  style: { width: "100%", height: "100%", "flex-grow": "1", overflow: "hidden", position: "relative" }
                }, null, 512),
                A[1] || (A[1] = y("div", { id: "belowRenderWindowContainer" }, null, -1))
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["class", "style"]), [
          [ln, a.value]
        ])
      ], 64);
    };
  }
}), zP = /* @__PURE__ */ Vt(wM, [["__scopeId", "data-v-5f778baa"]]), IM = { class: "flex gap-2 -mt-2" }, SM = { class: "ip-viewer-settings -mt-2" }, EM = { class: "p-tabmenu p-component" }, TM = {
  class: "p-tabmenu-nav p-reset",
  role: "tablist"
}, CM = {
  key: 0,
  class: "pt-4"
}, NM = { key: 1 }, HP = /* @__PURE__ */ Je({
  __name: "IPAboutInfoComponent",
  setup(e) {
    const t = Xn("dialogRef"), { t: n, locale: a } = Ht(), o = t.value.data, l = {
      General: 0,
      Info: 1
    }, s = B(l.General), i = B(!1), u = () => {
      var c;
      (c = t.value) != null && c.options && (t.value.options.props || (t.value.options.props = {}), t.value.options.props.header = n("shared.settings"));
    };
    return u(), lt(a, u), (c, p) => (L(), be(r(ot), null, {
      default: _(() => [
        y("div", IM, [
          y("div", SM, [
            y("div", EM, [
              y("div", TM, [
                d(r(Vl), {
                  state: s.value,
                  "onUpdate:state": p[0] || (p[0] = (h) => s.value = h),
                  index: l.General
                }, {
                  default: _(() => [
                    vt(U(c.$t("implant-planner.general")), 1)
                  ]),
                  _: 1
                }, 8, ["state", "index"]),
                d(r(Vl), {
                  state: s.value,
                  "onUpdate:state": p[1] || (p[1] = (h) => s.value = h),
                  index: l.Info,
                  style: { width: "75px !important" }
                }, {
                  default: _(() => [
                    vt(U(c.$t("shared.info")), 1)
                  ]),
                  _: 1
                }, 8, ["state", "index"])
              ])
            ])
          ])
        ]),
        s.value === l.General ? (L(), H("div", CM, [
          d(r(ot), { class: "gap-4" }, {
            default: _(() => [
              r(o).showOnlyAddreses ? ue("", !0) : (L(), be(r(kg), {
                key: 0,
                header: c.$t("medic-web-framework.language"),
                isCollapsed: i.value,
                "onUpdate:isCollapsed": p[2] || (p[2] = (h) => i.value = h)
              }, {
                default: _(() => [
                  d(r(ke), { class: "rg-panel mt-4" }, {
                    default: _(() => [
                      d(r(Vg))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["header", "isCollapsed"]))
            ]),
            _: 1
          })
        ])) : ue("", !0),
        s.value === l.Info ? (L(), H("div", NM, [
          d(r(ot), { class: "gap-1 overflow-y-auto overflow-x-hidden pt-2" }, {
            default: _(() => [
              d(sm, {
                model: r(o).model,
                "onUpdate:model": p[3] || (p[3] = (h) => r(o).model = h)
              }, null, 8, ["model"])
            ]),
            _: 1
          })
        ])) : ue("", !0),
        d(r(kh)),
        d(r(ke), { class: "items-center justify-center pt-2" }, {
          default: _(() => [
            d(r(la), {
              label: c.$t("shared.close"),
              icon: "pi pi-check",
              onClick: p[4] || (p[4] = (h) => r(t).close())
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), YP = /* @__PURE__ */ Je({
  __name: "IPDataImportPreview",
  props: {
    object: {},
    textureObject: {},
    objectName: {},
    context: {}
  },
  setup(e) {
    const t = e, n = B();
    let a, o = null;
    return Dt(async () => {
      if (t.context)
        o = t.context;
      else
        try {
          o = dn();
        } catch (l) {
          console.log("Context is null", l);
        }
      o ? a = new fh(n.value, o) : a = new gh(n.value, [0, 0, 0, 0]), t.object && await a.onFileSelected(t.object, t.objectName, t.textureObject);
    }), Ln(() => {
      a.delete();
    }), (l, s) => (L(), H("div", {
      ref_key: "vtkContainer",
      ref: n,
      style: { height: "35vh !important", width: "100% !important" }
    }, null, 512));
  }
}), jo = 1024 * 1024, Uf = 750 * jo, Gf = 180 * jo, LM = Uf - Gf, OM = 24 * jo, DM = 2.7, Wf = 8, zf = 8 * jo, AM = Math.round(zf / Wf), RM = 1.6, MM = 2 * jo, PM = Math.round(0.5 * jo), Hf = 3 * jo;
function wo(e) {
  if (typeof e == "object" && e !== null && !Array.isArray(e))
    return e;
}
function xM(e) {
  try {
    const t = atob(e), n = Uint8Array.from(t, (a) => a.charCodeAt(0));
    return new TextDecoder().decode(n);
  } catch {
    try {
      return atob(e);
    } catch {
      return "";
    }
  }
}
function Wu(e) {
  const t = e.indexOf("=");
  if (t === -1)
    return e;
  const n = e.slice(0, t), a = e.slice(t + 1);
  return n === "base64" ? xM(a) : e;
}
function Io(e) {
  if (typeof e == "number")
    return Number.isFinite(e) ? e : void 0;
  if (typeof e == "boolean")
    return e ? 1 : 0;
  if (typeof e == "string") {
    const t = Wu(e), n = Number(t);
    return Number.isFinite(n) ? n : void 0;
  }
}
function jM(e) {
  if (typeof e == "boolean")
    return e;
  const t = Io(e);
  if (t !== void 0)
    return t !== 0;
  if (typeof e == "string") {
    const n = Wu(e).toLowerCase();
    if (n === "true")
      return !0;
    if (n === "false")
      return !1;
  }
}
function Zd(e) {
  if (typeof e != "string")
    return;
  const t = Wu(e).trim();
  return t.length > 0 ? t : void 0;
}
function Fi(e, t) {
  const n = e > 0 ? e : t;
  return Math.round(n * RM);
}
function Xd(e, t) {
  if (!e)
    return 0;
  const n = t === "decimated" ? Wf : 1, o = Math.max(1, Math.floor(e[0] * e[1] * e[2] / n)) * Int16Array.BYTES_PER_ELEMENT;
  return Math.max(t === "decimated" ? AM : zf, Math.round(o * DM));
}
function Yf(e) {
  const t = wo(e);
  if (!t)
    return 0;
  let n = 0;
  for (const [a, o] of Object.entries(t)) {
    if (a.toLowerCase() === "filesize") {
      const l = Io(o);
      l && l > 0 && (n += l);
      continue;
    }
    n += Yf(o);
  }
  return n;
}
function $M(e) {
  const t = {
    implantCount: 0,
    implantFileSizeBytes: 0,
    pinCount: 0,
    pinFileSizeBytes: 0,
    projectStlCandidates: []
  }, n = wo(e), a = n ? wo(n.COLLECTION_3D) : void 0;
  if (!a)
    return t;
  const o = Math.max(0, Math.floor(Io(a.OBJECTS_COUNT) ?? 0));
  for (let l = 0; l < o; l++) {
    const s = wo(a[`OBJECT_${l}`]);
    if (!s)
      continue;
    const i = Io(s.OBJECT_TYPE), u = Yf(s);
    if (i === Oe._IMPLANT) {
      t.implantCount += 1, t.implantFileSizeBytes += u;
      continue;
    }
    if (i === Oe._PIN) {
      t.pinCount += 1, t.pinFileSizeBytes += u;
      continue;
    }
    if (!(i === Oe._STL_OBJECT || i === Oe._STL_TOOTH || i === Oe._STL_PROSTHESIS || i === Oe._STL_TEETH_MODEL))
      continue;
    const p = Zd(s.OBJECT_NAME) ?? Zd(s.NAME) ?? `STL ${t.projectStlCandidates.length + 1}`;
    t.projectStlCandidates.push({
      id: `project-stl-${l}`,
      name: p,
      fileSizeBytes: u,
      estimatedBytes: Fi(u, Hf),
      source: "project"
    });
  }
  return t;
}
function FM(e) {
  const t = (a) => {
    const o = Math.floor(Io(a.DIM_0) ?? 0), l = Math.floor(Io(a.DIM_1) ?? 0), s = Math.floor(Io(a.DIM_2) ?? 0);
    return o <= 0 || l <= 0 || s <= 0 ? null : [o, l, s];
  };
  return ((a) => {
    const o = wo(a);
    if (!o)
      return null;
    const l = [o], s = /* @__PURE__ */ new Set([o]);
    for (; l.length > 0; ) {
      const i = l.pop();
      if (!i)
        continue;
      const u = t(i);
      if (u)
        return u;
      for (const c of Object.values(i)) {
        const p = wo(c);
        !p || s.has(p) || (s.add(p), l.push(p));
      }
    }
    return null;
  })(e);
}
function kM(e, t) {
  const n = e.projectStlCandidates.map((o) => o.name), a = e.patientStlCandidates.map((o) => o.name);
  return {
    volumeQuality: (t == null ? void 0 : t.volumeQuality) ?? e.defaultSelection.volumeQuality ?? "full",
    includeImplants: (t == null ? void 0 : t.includeImplants) ?? e.defaultSelection.includeImplants ?? !0,
    includePins: (t == null ? void 0 : t.includePins) ?? e.defaultSelection.includePins ?? !0,
    includeProjectStlObjects: (t == null ? void 0 : t.includeProjectStlObjects) ?? e.defaultSelection.includeProjectStlObjects ?? !0,
    includePatientStlObjects: (t == null ? void 0 : t.includePatientStlObjects) ?? e.defaultSelection.includePatientStlObjects ?? e.loadObjectsFromPatientDefault,
    includedProjectStlObjectNames: (t == null ? void 0 : t.includedProjectStlObjectNames) ?? e.defaultSelection.includedProjectStlObjectNames ?? n,
    includedPatientStlFilenames: (t == null ? void 0 : t.includedPatientStlFilenames) ?? e.defaultSelection.includedPatientStlFilenames ?? a
  };
}
class KP {
  constructor(t) {
    an(this, "api");
    // original project data, used to merge with modified project before saving
    an(this, "loadedProjectData", null);
    this.api = t;
  }
  buildDefaultProjectLoadSelection(t) {
    return {
      ...t.defaultSelection,
      includedProjectStlObjectNames: [...t.defaultSelection.includedProjectStlObjectNames ?? []],
      includedPatientStlFilenames: [...t.defaultSelection.includedPatientStlFilenames ?? []]
    };
  }
  estimateProjectLoadMemory(t, n) {
    const a = kM(t, n);
    let o = t.baseOverheadBytes;
    if (o += a.volumeQuality === "decimated" ? t.volumeDecimatedEstimateBytes : t.volumeFullEstimateBytes, a.includeImplants && (o += t.implantEstimateBytes), a.includePins && (o += t.pinEstimateBytes), a.includeProjectStlObjects) {
      const l = a.includedProjectStlObjectNames.length > 0 ? new Set(a.includedProjectStlObjectNames) : void 0;
      for (const s of t.projectStlCandidates)
        l && !l.has(s.name) || (o += s.estimatedBytes);
    }
    if (a.includePatientStlObjects) {
      const l = a.includedPatientStlFilenames.length > 0 ? new Set(a.includedPatientStlFilenames) : void 0;
      for (const s of t.patientStlCandidates)
        l && !l.has(s.name) || (o += s.estimatedBytes);
    }
    return Math.round(o);
  }
  async getProjectLoadPreflight(t) {
    var S;
    const { data: n, status: a } = await this.api.getZippedFilesList(t.patientName, t.projectFilename);
    if (a === 202)
      return null;
    const o = (f) => n.find((v) => v.fileType === f), l = o("mobile.json"), s = o("pr.json"), i = o("stlinfo.json"), u = async (f) => {
      if (!f)
        return null;
      try {
        return (await this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, f.id, !1)).data;
      } catch (v) {
        return Ye.warn("Failed to fetch preload json file", {
          fileType: f.fileType,
          projectFilename: t.projectFilename,
          patientName: t.patientName,
          error: v
        }), null;
      }
    }, [c, p, h] = await Promise.all([u(l), u(s), u(i)]), g = $M(h), b = (t.projectFileList ?? []).filter((f) => f.type === Ta.STL).map((f, v) => {
      var A;
      const w = ((A = f.file) == null ? void 0 : A.size) ?? 0;
      return {
        id: `patient-stl-${v}`,
        name: f.name,
        fileSizeBytes: w,
        estimatedBytes: Fi(w, Hf),
        source: "patient"
      };
    }), E = FM(p), m = jM((S = wo(c)) == null ? void 0 : S.LOAD_OBJECTS_FROM_PATIENT) ?? !1, I = {
      totalMemoryBytes: Uf,
      reservedMemoryBytes: Gf,
      budgetMemoryBytes: LM,
      baseOverheadBytes: OM,
      volumeDimensions: E,
      volumeFullEstimateBytes: Xd(E, "full"),
      volumeDecimatedEstimateBytes: Xd(E, "decimated"),
      implantCount: g.implantCount,
      implantEstimateBytes: Fi(g.implantFileSizeBytes, g.implantCount * MM),
      pinCount: g.pinCount,
      pinEstimateBytes: Fi(g.pinFileSizeBytes, g.pinCount * PM),
      projectStlCandidates: g.projectStlCandidates,
      patientStlCandidates: b,
      loadObjectsFromPatientDefault: m,
      defaultSelection: {
        volumeQuality: "decimated",
        includeImplants: !0,
        includePins: !0,
        includeProjectStlObjects: !0,
        includePatientStlObjects: m,
        includedProjectStlObjectNames: g.projectStlCandidates.map((f) => f.name),
        includedPatientStlFilenames: b.map((f) => f.name)
      },
      defaultEstimateBytes: 0
    };
    return I.defaultEstimateBytes = this.estimateProjectLoadMemory(I, I.defaultSelection), I;
  }
  async getFileDataSilent(t, n) {
    try {
      const { data: a } = await this.api.getFile(t, n);
      return new Int8Array(a);
    } catch {
      return null;
    }
  }
  async loadProjectObjects(t, n, a, o) {
    var p;
    if ((o == null ? void 0 : o.includePatientStlObjects) === !1)
      return;
    const l = o != null && o.includedPatientStlFilenames && o.includedPatientStlFilenames.length > 0 ? new Set(o.includedPatientStlFilenames) : void 0, s = [];
    if ((p = n.projectFileList) == null || p.forEach((h) => {
      if (h.type === Ta.STL) {
        if (l && !l.has(h.name))
          return;
        const g = {
          id: h.id,
          uuid: "",
          lastModified: new Date(h.file.changeDate),
          patientId: n.patientName,
          //user: file.uploadedBy.name,
          filename: h.name,
          itemImageSrc: this.api.getFileUrl(n.patientName, h.name).url,
          type: h.type,
          thumbnailImageSrc: "",
          alt: "",
          title: ""
        }, b = n.projectFileList.find((m) => m.type === Ta.STL_Preview && m.name === h.name + ".thumb");
        let E = "";
        b && (E = this.api.getFileUrl(n.patientName, b.name).url), s.push({
          ...g,
          thumbnailImageSrc: E,
          previewUrl: E
        });
      }
    }), !s.length)
      return;
    const i = async (h) => {
      const g = await this.getStlFile(n.patientName, h.filename);
      if (!g)
        return;
      const b = h.filename.replace(/\.[^/.]+$/, ""), E = h.filename.toLowerCase(), m = E.endsWith(".ply"), I = `${b}.jpg`, S = m ? await this.getFileDataSilent(n.patientName, I) : null, f = ip();
      f.implantInfo.stlFile.data = g, f.implantInfo.stlFile.fileName = h.filename, f.implantInfo.stlFile.fileSize = g.length;
      const v = h.filename.match(/\[([^\]]+)]/), w = v ? v[1] : h.filename;
      v && (w === "Anatomy" ? f.objectType = Oe._STL_TEETH_MODEL : w === "Waxup-Prosthesis" && (f.objectType = Oe._STL_PROSTHESIS)), f.name = w, f.implantInfo.objectName = w;
      const A = !!(S && S.length);
      m && S && S.length && (f.implantInfo.textureCount = 1, f.implantInfo.textureFileNames = [I], f.implantInfo.textureFiles = [
        {
          fileSize: S.length,
          data: S,
          fileName: I
        }
      ]);
      const T = E.endsWith(".ply") || E.endsWith(".obj");
      t.objects.addSTL(f, { ignoreScaling: !1, ply: T, fromDataImport: !0, hasTexture: A });
    };
    a == null || a({
      loaded: 0,
      total: s.length
    });
    const u = [], c = {
      loaded: 0,
      total: s.length
    };
    for (const h of s) {
      const g = i(h);
      g.then(() => {
        c.loaded++, a == null || a(c);
      }), u.push(g);
    }
    await Promise.all(u);
  }
  async loadProject(t, n, a, o, l, s) {
    Ye.debug("[Autosave] Loader start", {
      patientName: t.patientName,
      projectFilename: t.projectFilename,
      hasAutosavePayload: !!l,
      autosaveCadPartCount: l ? Object.keys(l.cadParts ?? {}).length : 0
    }), hh(n), bh(n);
    const i = await this.api.getZippedFilesList(t.patientName, t.projectFilename);
    if (i.status, i.status == 202)
      return { success: !1, error: it("implant-planner.projectPreparing") };
    const u = i.data;
    if (!u)
      return { success: !1, error: it("implant-planner.projectFilesNotFound") };
    const c = (l == null ? void 0 : l.cadParts) ?? {}, p = (P) => {
      const F = c[P];
      return F && F.byteLength > 0 && Ye.debug("[Autosave] Loader using CAD part from autosave", {
        fileType: P,
        bytes: F.byteLength
      }), F && F.byteLength > 0 ? F : void 0;
    };
    let h = !1, g;
    const b = t.projectFileList.find((P) => P.name === t.projectFilename), E = (P) => {
      const F = l2(P);
      return F.imgDims[0] == 1 && F.imgDims[1] == 1 && F.imgDims[2] == 1 ? { success: !1, error: it("implant-planner.cadModuleUnavailable") } : (h = F.loadObjectsFromPatient, console.log("segmentationInvokedByUser", F.segmentationInvokedByUser, "mFile.loadObjectsFromPatient", F.loadObjectsFromPatient), F.segmentationInvokedByUser && (g = t.projectFileList.find((me) => {
        if (me.type === "processing-data" && me.metadata) {
          const de = JSON.parse(me.metadata);
          if (de && b && de["job-type"] == "SEGMENTATION" && de["origin-file-id"] == b.id)
            return !0;
        }
      })), { success: !0 });
    }, m = u.find((P) => P.fileType === "mobile.json");
    let I = l != null && l.mobile ? structuredClone(l.mobile) : null;
    if (I && Ye.debug("[Autosave] Loader using mobile from autosave"), !I && m) {
      const F = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, m.id, !1).then((me) => me.data);
      I = await tr(
        F,
        t.patientName,
        t.projectFilename,
        er(m, "mobile"),
        u,
        this.api,
        void 0,
        !0
      );
    }
    if (I) {
      const P = E(I);
      if (!P.success)
        return P;
    }
    (s == null ? void 0 : s.includePatientStlObjects) === !1 && (h = !1);
    const S = (s == null ? void 0 : s.volumeQuality) === "decimated", f = u.find((P) => P.fileType === "pr.json"), v = u.find((P) => P.fileType === "stlinfo.json"), w = u.find((P) => P.fileType === "prinfo"), A = u.find((P) => P.fileType === "iptspr"), T = u.find((P) => P.fileType === "iptsbd"), O = u.find((P) => P.fileType === "bspr"), C = u.find((P) => P.fileType === "bsbd"), k = u.find((P) => P.fileType === "tspr"), M = u.find((P) => P.fileType === "tsbd"), z = u.find((P) => P.fileType === "mpr"), j = u.find((P) => P.fileType === "mbd"), K = u.find((P) => P.fileType === "sgpr"), x = u.find((P) => P.fileType === "sgbd"), N = u.find((P) => P.fileType === "erp"), G = n.getFS(), ce = n.getEngine(), re = (P, F, me) => {
      G.FS.writeFile(n.projectName + "." + me + "pr", new Uint8Array(P)), G.FS.writeFile(n.projectName + "." + me + "bd", new Uint8Array(F)), console.log("File saved to Wasm FS: " + n.projectName + "." + me + "pr");
      let de = rr.eM_BONE_SEGMENTATION, We = St.eOT_SEGMENTED_BONE;
      me == "ts" && (de = rr.eM_TOOTH_SEGMENTATION, We = St.eOT_CNN_SEGMENTED_TOOTH);
      const Q = new ce.xProjectLoaderUtil();
      try {
        Q.InitializeCADProjectLoading("", n.projectName, de);
        const ie = Q.GetNumberOfCADVolumeLabels();
        for (let W = 0; W < ie; W++) {
          const ee = n.objects.addVolume("", "", !0, We);
          Q.AssignVolumeById(W, ee.id), ee.syncWasmInfo();
        }
      } finally {
        try {
          Q.FinalizeCADProjectLoading();
        } catch (ie) {
          console.warn("FinalizeCADProjectLoading failed", ie);
        }
        Q.delete();
      }
    }, Se = (P, F, me, de) => {
      const We = this.api.getProjectFileFromZipById(t.patientName, P, F), Q = this.api.getProjectFileFromZipById(t.patientName, P, me);
      return Promise.all([We, Q]).then(([ie, W]) => {
        re(ie.data, W.data, de);
      });
    }, se = [], Le = async () => {
      if (!g) return null;
      const { data: P } = await this.api.getZippedFilesList(t.patientName, g.name), F = P.find((Q) => Q.name === "result");
      if (!F)
        return console.error("Segmentation result file not found!"), null;
      const { data: me } = await this.api.getProjectFileFromZipById(
        t.patientName,
        F.name,
        F.id,
        !1
      ), de = await me, We = (Q) => {
        const ie = P.find((W) => Q === `${W.name}.${W.fileType}`);
        return ie ? ie.id : null;
      };
      if (de) {
        if (!O || !C) {
          if (!S && de.boneSegmentationProject && de.boneSegmentationProject[0]) {
            const Q = de.boneSegmentationProject[0], ie = We(Q.prFile), W = We(Q.bdFile);
            ie && W && se.push(Se(F.name, ie, W, "bs"));
          } else if (de.bone) {
            const Q = n.getFS(), ie = "/segmentations";
            n.makeDir(ie);
            for (const W of de.bone)
              try {
                const ee = We(W.file);
                if (!ee)
                  throw new Error(`Segmentation File not found: ${W.file}`);
                const { data: $ } = await this.api.getProjectFileFromZipById(t.patientName, F.name, ee);
                W.buffer = $, Q.FS.writeFile(ie + "/" + W.file, new Int8Array(W.buffer));
                let R = W.name;
                switch (W.file) {
                  case "bone_mandible_with_teeth.nii.gz":
                    R = "Mandible With Teeth";
                    break;
                  case "bone_mandible_no_teeth.nii.gz":
                    R = "Mandible Without Teeth";
                    break;
                  case "bone_maxilla_with_teeth.nii.gz":
                    R = "Maxilla With Teeth";
                    break;
                  case "bone_maxilla_no_teeth.nii.gz":
                    R = "Maxilla Without Teeth";
                    break;
                }
                n.objects.addVolume(ie + "/" + W.file, R, !0, St.eOT_SEGMENTED_BONE), Q.FS.unlink(ie + "/" + W.file), Q.FS.rmdir(ie);
              } catch (ee) {
                console.log("EXCEPTION: GetFile", ee);
              }
          }
        }
        if (!k || !M) {
          if (!S && de.toothSegmentationProject && de.toothSegmentationProject[0]) {
            const Q = de.toothSegmentationProject[0], ie = We(Q.prFile), W = We(Q.bdFile);
            ie && W && (se.push(Se(F.name, ie, W, "ts")), n.contextCAD.tsprFileFromSegmentation = !0);
          } else if (de.teeth) {
            const Q = de.teeth.mandible;
            if (Q) {
              const W = n.getFS(), ee = "/segmentations";
              n.makeDir(ee);
              for (const $ of Q)
                try {
                  const R = We($.file);
                  if (!R)
                    throw new Error(`Segmentation File not found: ${$.file}`);
                  const { data: D } = await this.api.getProjectFileFromZipById(t.patientName, F.name, R);
                  $.buffer = D, W.FS.writeFile(ee + "/" + $.file, new Int8Array($.buffer)), n.objects.addVolume(ee + "/" + $.file, $.name, !0, St.eOT_CNN_SEGMENTED_TOOTH), W.FS.unlink(ee + "/" + $.file);
                } catch (R) {
                  console.log("EXCEPTION: GetFile", R);
                }
              W.FS.rmdir(ee);
            }
            const ie = de.teeth.maxilla;
            if (ie) {
              const W = n.getFS(), ee = "/segmentations";
              n.makeDir(ee);
              for (const $ of ie)
                try {
                  const R = We($.file);
                  if (!R)
                    throw new Error(`Segmentation File not found: ${$.file}`);
                  const { data: D } = await this.api.getProjectFileFromZipById(t.patientName, F.name, R);
                  $.buffer = D, W.FS.writeFile(ee + "/" + $.file, new Int8Array($.buffer)), n.objects.addVolume(ee + "/" + $.file, $.name, !0, St.eOT_CNN_SEGMENTED_TOOTH), W.FS.unlink(ee + "/" + $.file);
                } catch (R) {
                  console.log("EXCEPTION: GetFile", R);
                }
              W.FS.rmdir(ee);
            }
          }
        }
      }
      return de;
    }, Y = !!(l != null && l.pr) || !!f, pe = !!(l != null && l.stlInfo) || !!v;
    if (Ye.debug("[Autosave] Loader source availability", {
      hasProjectObject: Y,
      hasStlInfoObject: pe,
      hasImageFile: !!w,
      hasMobile: !!I,
      usingAutosavePr: !!(l != null && l.pr),
      usingAutosaveStlInfo: !!(l != null && l.stlInfo),
      usingAutosaveMobile: !!(l != null && l.mobile)
    }), !Y || !pe || !w || I == null)
      return { success: !1, error: it("implant-planner.projectFilesNotFound") };
    const fe = Le();
    let le = {
      loaded: 0,
      total: 100
    }, Re = {
      loaded: 0,
      total: 1
    }, q = {
      loaded: 0,
      total: 0
    };
    const he = () => {
      o == null || o({
        loaded: le.loaded + Re.loaded + q.loaded,
        total: le.total + Re.total + q.total
      });
    }, ne = (P) => {
      le = P, he();
    }, te = (P) => {
      Re = P, he();
    }, Ie = (P) => {
      q = P, he();
    }, Ee = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, w.id), xe = async (P, F) => {
      n.contextCAD.iptsTeethLibraryPromise = void 0, G.FS.writeFile(n.projectName + ".iptspr", new Uint8Array(P)), G.FS.writeFile(n.projectName + ".iptsbd", new Uint8Array(F));
      const de = new TextDecoder("utf-8").decode(P), ie = new DOMParser().parseFromString(de, "application/xml").querySelector("TeethSetupReconstruction TeethLibraryGUID");
      let W = "";
      const ee = await this.api.getCadLibrariesFilteredList(void 0, "xml");
      for (let $ = 0; $ < ee.data.length; $++) {
        const R = JSON.parse(ee.data[$].metadata);
        if ($ == 0 && (W = ee.data[$].modelName), R.guid === (ie == null ? void 0 : ie.textContent)) {
          W = ee.data[$].modelName;
          break;
        }
      }
      W != "" ? n.contextCAD.iptsTeethLibraryPromise = Kr(this.api, n, W, (ie == null ? void 0 : ie.textContent) || "", !0).then(() => {
        console.log("Library loaded");
      }) : n.warningString.set(it("implant-planner.teethLibraryNotFoundOnServer"));
    };
    if (!S) {
      const P = p("iptspr"), F = p("iptsbd");
      if (P && F)
        n.contextCAD.iptsPromise = xe(P, F);
      else if (A && T) {
        const R = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, A.id), D = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, T.id);
        n.contextCAD.iptsPromise = Promise.all([R, D]).then(async ([V, Z]) => {
          await xe(V.data, Z.data);
        });
      }
      const me = p("bspr"), de = p("bsbd");
      me && de ? se.push(Promise.resolve(re(me, de, "bs"))) : O && C && se.push(Se(t.projectFilename, O.id, C.id, "bs"));
      const We = p("tspr"), Q = p("tsbd");
      We && Q ? se.push(Promise.resolve(re(We, Q, "ts"))) : k && M && se.push(Se(t.projectFilename, k.id, M.id, "ts"));
      const ie = p("mpr"), W = p("mbd");
      if (ie && W)
        n.contextCAD.mPromise = Promise.resolve().then(() => {
          G.FS.writeFile(n.projectName + ".mpr", new Uint8Array(ie)), G.FS.writeFile(n.projectName + ".mbd", new Uint8Array(W));
        });
      else if (z && j) {
        const R = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, z.id), D = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, j.id);
        n.contextCAD.mPromise = Promise.all([R, D]).then(([V, Z]) => {
          G.FS.writeFile(n.projectName + ".mpr", new Uint8Array(V.data)), G.FS.writeFile(n.projectName + ".mbd", new Uint8Array(Z.data));
        });
      }
      const ee = p("sgpr"), $ = p("sgbd");
      if (ee && $)
        se.push(
          Promise.resolve().then(() => {
            G.FS.writeFile(n.projectName + ".sgpr", new Uint8Array(ee)), G.FS.writeFile(n.projectName + ".sgbd", new Uint8Array($));
          })
        );
      else if (K && x) {
        const R = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, K.id), D = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, x.id);
        se.push(
          Promise.all([R, D]).then(([V, Z]) => {
            G.FS.writeFile(n.projectName + ".sgpr", new Uint8Array(V.data)), G.FS.writeFile(n.projectName + ".sgbd", new Uint8Array(Z.data));
          })
        );
      }
    }
    if (l != null && l.erpFile)
      Ye.debug("[Autosave] Loader using ERP from autosave"), n.erpFile = structuredClone(l.erpFile);
    else if (N) {
      const P = this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, N.id, !1);
      se.push(
        Promise.all([P]).then(([F]) => {
          n.erpFile = F.data;
        })
      );
    }
    const Qe = Ee.then((P) => P.data), Ke = l != null && l.pr ? Promise.resolve(structuredClone(l.pr)) : tr(
      this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, f.id, !1).then((P) => P.data),
      t.patientName,
      t.projectFilename,
      er(f, "pr"),
      u,
      this.api
    ), qe = l != null && l.stlInfo ? Promise.resolve(structuredClone(l.stlInfo)) : tr(
      this.api.getProjectFileFromZipById(t.patientName, t.projectFilename, v.id, !1).then((P) => P.data),
      t.patientName,
      t.projectFilename,
      er(v, "stlinfo"),
      u,
      this.api,
      ne
    );
    l != null && l.stlInfo && (le = { loaded: 100, total: 100 }, he());
    const rt = {
      pr: Ke,
      stlInfo: qe,
      mobile: I,
      imageData: Qe,
      segmentationResult: fe
    };
    return await Promise.all(se), await o2(n, a, rt, te, s), h && await this.loadProjectObjects(n, t, Ie, s), this.loadedProjectData = {
      pr: await Ke,
      stlInfo: await qe,
      mobile: await I
    }, Ye.debug("[Autosave] Loader success", {
      patientName: t.patientName,
      projectFilename: t.projectFilename,
      usedAutosavePr: !!(l != null && l.pr),
      usedAutosaveStlInfo: !!(l != null && l.stlInfo),
      usedAutosaveMobile: !!(l != null && l.mobile),
      usedAutosaveErp: !!(l != null && l.erpFile)
    }), { success: !0, error: "" };
  }
  async uploadScreenshot(t, n, a, o) {
    const { data: l } = await this.api.uploadFile(t, n, a, o);
    return l.fileId;
  }
  getLoadedProjectData() {
    return this.loadedProjectData;
  }
}
function ZP(e, t) {
  return Bg(`${e}:${t}`);
}
export {
  HP as IPAboutInfoComponent,
  YP as IPDataImportPreview,
  zP as IPFreeformingAppLoader,
  KP as IPProjectLoader,
  UP as IPProjectLoaderView,
  GP as IPProjectLoaderViewRedesign,
  WP as IPProjectLoaderViewRedesignAlfred,
  VP as LoadRGFileFromServer,
  Qs as arrayToBase64,
  r2 as createMobileForUpload,
  BP as createProjectZip,
  jP as getDefaultName,
  Z1 as getImplantPlannerEnvironment,
  FP as getMetaDataFromZip,
  Lr as getObjectNames,
  $P as getPreviewProjectFromZip,
  ZP as getProjectHash,
  xP as initI18n,
  um as isDevelopmentModulesEnabled,
  l2 as loadMobileFile,
  Ff as prepareProjectData,
  Br as projectGeneralDataModel,
  PP as setImplantIsDevelopment,
  MP as setImplantPlannerEnvironment,
  kP as uploadProjectFromZip,
  Kt as writeProjectObject
};
//# sourceMappingURL=implantplanner.js.map
